!(function (i) {
  "use strict";
  "function" == typeof define && define.amd
    ? define(["jquery"], i)
    : "undefined" != typeof exports
    ? (module.exports = i(require("jquery")))
    : i(jQuery);
})(function (i) {
  "use strict";
  var e = window.Slick || {};
  ((e = (function () {
    var e = 0;
    return function (t, o) {
      var s,
        n = this;
      (n.defaults = {
        accessibility: !0,
        adaptiveHeight: !1,
        appendArrows: i(t),
        appendDots: i(t),
        arrows: !0,
        asNavFor: null,
        prevArrow:
          '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
        nextArrow:
          '<button class="slick-next" aria-label="Next" type="button">Next</button>',
        autoplay: !1,
        autoplaySpeed: 3e3,
        centerMode: !1,
        centerPadding: "50px",
        cssEase: "ease",
        customPaging: function (e, t) {
          return i('<button type="button" />').text(t + 1);
        },
        dots: !1,
        dotsClass: "slick-dots",
        draggable: !0,
        easing: "linear",
        edgeFriction: 0.35,
        fade: !1,
        focusOnSelect: !1,
        focusOnChange: !1,
        infinite: !0,
        initialSlide: 0,
        lazyLoad: "ondemand",
        mobileFirst: !1,
        pauseOnHover: !0,
        pauseOnFocus: !0,
        pauseOnDotsHover: !1,
        respondTo: "window",
        responsive: null,
        rows: 1,
        rtl: !1,
        slide: "",
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        swipe: !0,
        swipeToSlide: !1,
        touchMove: !0,
        touchThreshold: 5,
        useCSS: !0,
        useTransform: !0,
        variableWidth: !1,
        vertical: !1,
        verticalSwiping: !1,
        waitForAnimate: !0,
        zIndex: 1e3,
      }),
        (n.initials = {
          animating: !1,
          dragging: !1,
          autoPlayTimer: null,
          currentDirection: 0,
          currentLeft: null,
          currentSlide: 0,
          direction: 1,
          $dots: null,
          listWidth: null,
          listHeight: null,
          loadIndex: 0,
          $nextArrow: null,
          $prevArrow: null,
          scrolling: !1,
          slideCount: null,
          slideWidth: null,
          $slideTrack: null,
          $slides: null,
          sliding: !1,
          slideOffset: 0,
          swipeLeft: null,
          swiping: !1,
          $list: null,
          touchObject: {},
          transformsEnabled: !1,
          unslicked: !1,
        }),
        i.extend(n, n.initials),
        (n.activeBreakpoint = null),
        (n.animType = null),
        (n.animProp = null),
        (n.breakpoints = []),
        (n.breakpointSettings = []),
        (n.cssTransitions = !1),
        (n.focussed = !1),
        (n.interrupted = !1),
        (n.hidden = "hidden"),
        (n.paused = !0),
        (n.positionProp = null),
        (n.respondTo = null),
        (n.rowCount = 1),
        (n.shouldClick = !0),
        (n.$slider = i(t)),
        (n.$slidesCache = null),
        (n.transformType = null),
        (n.transitionType = null),
        (n.visibilityChange = "visibilitychange"),
        (n.windowWidth = 0),
        (n.windowTimer = null),
        (s = i(t).data("slick") || {}),
        (n.options = i.extend({}, n.defaults, o, s)),
        (n.currentSlide = n.options.initialSlide),
        (n.originalSettings = n.options),
        void 0 !== document.mozHidden
          ? ((n.hidden = "mozHidden"),
            (n.visibilityChange = "mozvisibilitychange"))
          : void 0 !== document.webkitHidden &&
            ((n.hidden = "webkitHidden"),
            (n.visibilityChange = "webkitvisibilitychange")),
        (n.autoPlay = i.proxy(n.autoPlay, n)),
        (n.autoPlayClear = i.proxy(n.autoPlayClear, n)),
        (n.autoPlayIterator = i.proxy(n.autoPlayIterator, n)),
        (n.changeSlide = i.proxy(n.changeSlide, n)),
        (n.clickHandler = i.proxy(n.clickHandler, n)),
        (n.selectHandler = i.proxy(n.selectHandler, n)),
        (n.setPosition = i.proxy(n.setPosition, n)),
        (n.swipeHandler = i.proxy(n.swipeHandler, n)),
        (n.dragHandler = i.proxy(n.dragHandler, n)),
        (n.keyHandler = i.proxy(n.keyHandler, n)),
        (n.instanceUid = e++),
        (n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
        n.registerBreakpoints(),
        n.init(!0);
    };
  })()).prototype.activateADA = function () {
    this.$slideTrack
      .find(".slick-active")
      .attr({ "aria-hidden": "false" })
      .find("a, input, button, select")
      .attr({ tabindex: "0" });
  }),
    (e.prototype.addSlide = e.prototype.slickAdd =
      function (e, t, o) {
        var s = this;
        if ("boolean" == typeof t) (o = t), (t = null);
        else if (t < 0 || t >= s.slideCount) return !1;
        s.unload(),
          "number" == typeof t
            ? 0 === t && 0 === s.$slides.length
              ? i(e).appendTo(s.$slideTrack)
              : o
              ? i(e).insertBefore(s.$slides.eq(t))
              : i(e).insertAfter(s.$slides.eq(t))
            : !0 === o
            ? i(e).prependTo(s.$slideTrack)
            : i(e).appendTo(s.$slideTrack),
          (s.$slides = s.$slideTrack.children(this.options.slide)),
          s.$slideTrack.children(this.options.slide).detach(),
          s.$slideTrack.append(s.$slides),
          s.$slides.each(function (e, t) {
            i(t).attr("data-slick-index", e);
          }),
          (s.$slidesCache = s.$slides),
          s.reinit();
      }),
    (e.prototype.animateHeight = function () {
      var i = this;
      if (
        1 === i.options.slidesToShow &&
        !0 === i.options.adaptiveHeight &&
        !1 === i.options.vertical
      ) {
        var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
        i.$list.animate({ height: e }, i.options.speed);
      }
    }),
    (e.prototype.animateSlide = function (e, t) {
      var o = {},
        s = this;
      s.animateHeight(),
        !0 === s.options.rtl && !1 === s.options.vertical && (e = -e),
        !1 === s.transformsEnabled
          ? !1 === s.options.vertical
            ? s.$slideTrack.animate(
                { left: e },
                s.options.speed,
                s.options.easing,
                t
              )
            : s.$slideTrack.animate(
                { top: e },
                s.options.speed,
                s.options.easing,
                t
              )
          : !1 === s.cssTransitions
          ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft),
            i({ animStart: s.currentLeft }).animate(
              { animStart: e },
              {
                duration: s.options.speed,
                easing: s.options.easing,
                step: function (i) {
                  (i = Math.ceil(i)),
                    !1 === s.options.vertical
                      ? ((o[s.animType] = "translate(" + i + "px, 0px)"),
                        s.$slideTrack.css(o))
                      : ((o[s.animType] = "translate(0px," + i + "px)"),
                        s.$slideTrack.css(o));
                },
                complete: function () {
                  t && t.call();
                },
              }
            ))
          : (s.applyTransition(),
            (e = Math.ceil(e)),
            !1 === s.options.vertical
              ? (o[s.animType] = "translate3d(" + e + "px, 0px, 0px)")
              : (o[s.animType] = "translate3d(0px," + e + "px, 0px)"),
            s.$slideTrack.css(o),
            t &&
              setTimeout(function () {
                s.disableTransition(), t.call();
              }, s.options.speed));
    }),
    (e.prototype.getNavTarget = function () {
      var e = this,
        t = e.options.asNavFor;
      return t && null !== t && (t = i(t).not(e.$slider)), t;
    }),
    (e.prototype.asNavFor = function (e) {
      var t = this.getNavTarget();
      null !== t &&
        "object" == typeof t &&
        t.each(function () {
          var t = i(this).slick("getSlick");
          t.unslicked || t.slideHandler(e, !0);
        });
    }),
    (e.prototype.applyTransition = function (i) {
      var e = this,
        t = {};
      !1 === e.options.fade
        ? (t[e.transitionType] =
            e.transformType + " " + e.options.speed + "ms " + e.options.cssEase)
        : (t[e.transitionType] =
            "opacity " + e.options.speed + "ms " + e.options.cssEase),
        !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
    }),
    (e.prototype.autoPlay = function () {
      var i = this;
      i.autoPlayClear(),
        i.slideCount > i.options.slidesToShow &&
          (i.autoPlayTimer = setInterval(
            i.autoPlayIterator,
            i.options.autoplaySpeed
          ));
    }),
    (e.prototype.autoPlayClear = function () {
      var i = this;
      i.autoPlayTimer && clearInterval(i.autoPlayTimer);
    }),
    (e.prototype.autoPlayIterator = function () {
      var i = this,
        e = i.currentSlide + i.options.slidesToScroll;
      i.paused ||
        i.interrupted ||
        i.focussed ||
        (!1 === i.options.infinite &&
          (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1
            ? (i.direction = 0)
            : 0 === i.direction &&
              ((e = i.currentSlide - i.options.slidesToScroll),
              i.currentSlide - 1 == 0 && (i.direction = 1))),
        i.slideHandler(e));
    }),
    (e.prototype.buildArrows = function () {
      var e = this;
      !0 === e.options.arrows &&
        ((e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow")),
        (e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow")),
        e.slideCount > e.options.slidesToShow
          ? (e.$prevArrow
              .removeClass("slick-hidden")
              .removeAttr("aria-hidden tabindex"),
            e.$nextArrow
              .removeClass("slick-hidden")
              .removeAttr("aria-hidden tabindex"),
            e.htmlExpr.test(e.options.prevArrow) &&
              e.$prevArrow.prependTo(e.options.appendArrows),
            e.htmlExpr.test(e.options.nextArrow) &&
              e.$nextArrow.appendTo(e.options.appendArrows),
            !0 !== e.options.infinite &&
              e.$prevArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"))
          : e.$prevArrow
              .add(e.$nextArrow)
              .addClass("slick-hidden")
              .attr({ "aria-disabled": "true", tabindex: "-1" }));
    }),
    (e.prototype.buildDots = function () {
      var e,
        t,
        o = this;
      if (!0 === o.options.dots) {
        for (
          o.$slider.addClass("slick-dotted"),
            t = i("<ul />").addClass(o.options.dotsClass),
            e = 0;
          e <= o.getDotCount();
          e += 1
        )
          t.append(i("<li />").append(o.options.customPaging.call(this, o, e)));
        (o.$dots = t.appendTo(o.options.appendDots)),
          o.$dots.find("li").first().addClass("slick-active");
      }
    }),
    (e.prototype.buildOut = function () {
      var e = this;
      (e.$slides = e.$slider
        .children(e.options.slide + ":not(.slick-cloned)")
        .addClass("slick-slide")),
        (e.slideCount = e.$slides.length),
        e.$slides.each(function (e, t) {
          i(t)
            .attr("data-slick-index", e)
            .data("originalStyling", i(t).attr("style") || "");
        }),
        e.$slider.addClass("slick-slider"),
        (e.$slideTrack =
          0 === e.slideCount
            ? i('<div class="slick-track"/>').appendTo(e.$slider)
            : e.$slides.wrapAll('<div class="slick-track"/>').parent()),
        (e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent()),
        e.$slideTrack.css("opacity", 0),
        (!0 !== e.options.centerMode && !0 !== e.options.swipeToSlide) ||
          (e.options.slidesToScroll = 1),
        i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"),
        e.setupInfinite(),
        e.buildArrows(),
        e.buildDots(),
        e.updateDots(),
        e.setSlideClasses(
          "number" == typeof e.currentSlide ? e.currentSlide : 0
        ),
        !0 === e.options.draggable && e.$list.addClass("draggable");
    }),
    (e.prototype.buildRows = function () {
      var i,
        e,
        t,
        o,
        s,
        n,
        r,
        l = this;
      if (
        ((o = document.createDocumentFragment()),
        (n = l.$slider.children()),
        l.options.rows > 1)
      ) {
        for (
          r = l.options.slidesPerRow * l.options.rows,
            s = Math.ceil(n.length / r),
            i = 0;
          i < s;
          i++
        ) {
          var d = document.createElement("div");
          for (e = 0; e < l.options.rows; e++) {
            var a = document.createElement("div");
            for (t = 0; t < l.options.slidesPerRow; t++) {
              var c = i * r + (e * l.options.slidesPerRow + t);
              n.get(c) && a.appendChild(n.get(c));
            }
            d.appendChild(a);
          }
          o.appendChild(d);
        }
        l.$slider.empty().append(o),
          l.$slider
            .children()
            .children()
            .children()
            .css({
              width: 100 / l.options.slidesPerRow + "%",
              display: "inline-block",
            });
      }
    }),
    (e.prototype.checkResponsive = function (e, t) {
      var o,
        s,
        n,
        r = this,
        l = !1,
        d = r.$slider.width(),
        a = window.innerWidth || i(window).width();
      if (
        ("window" === r.respondTo
          ? (n = a)
          : "slider" === r.respondTo
          ? (n = d)
          : "min" === r.respondTo && (n = Math.min(a, d)),
        r.options.responsive &&
          r.options.responsive.length &&
          null !== r.options.responsive)
      ) {
        s = null;
        for (o in r.breakpoints)
          r.breakpoints.hasOwnProperty(o) &&
            (!1 === r.originalSettings.mobileFirst
              ? n < r.breakpoints[o] && (s = r.breakpoints[o])
              : n > r.breakpoints[o] && (s = r.breakpoints[o]));
        null !== s
          ? null !== r.activeBreakpoint
            ? (s !== r.activeBreakpoint || t) &&
              ((r.activeBreakpoint = s),
              "unslick" === r.breakpointSettings[s]
                ? r.unslick(s)
                : ((r.options = i.extend(
                    {},
                    r.originalSettings,
                    r.breakpointSettings[s]
                  )),
                  !0 === e && (r.currentSlide = r.options.initialSlide),
                  r.refresh(e)),
              (l = s))
            : ((r.activeBreakpoint = s),
              "unslick" === r.breakpointSettings[s]
                ? r.unslick(s)
                : ((r.options = i.extend(
                    {},
                    r.originalSettings,
                    r.breakpointSettings[s]
                  )),
                  !0 === e && (r.currentSlide = r.options.initialSlide),
                  r.refresh(e)),
              (l = s))
          : null !== r.activeBreakpoint &&
            ((r.activeBreakpoint = null),
            (r.options = r.originalSettings),
            !0 === e && (r.currentSlide = r.options.initialSlide),
            r.refresh(e),
            (l = s)),
          e || !1 === l || r.$slider.trigger("breakpoint", [r, l]);
      }
    }),
    (e.prototype.changeSlide = function (e, t) {
      var o,
        s,
        n,
        r = this,
        l = i(e.currentTarget);
      switch (
        (l.is("a") && e.preventDefault(),
        l.is("li") || (l = l.closest("li")),
        (n = r.slideCount % r.options.slidesToScroll != 0),
        (o = n
          ? 0
          : (r.slideCount - r.currentSlide) % r.options.slidesToScroll),
        e.data.message)
      ) {
        case "previous":
          (s = 0 === o ? r.options.slidesToScroll : r.options.slidesToShow - o),
            r.slideCount > r.options.slidesToShow &&
              r.slideHandler(r.currentSlide - s, !1, t);
          break;
        case "next":
          (s = 0 === o ? r.options.slidesToScroll : o),
            r.slideCount > r.options.slidesToShow &&
              r.slideHandler(r.currentSlide + s, !1, t);
          break;
        case "index":
          var d =
            0 === e.data.index
              ? 0
              : e.data.index || l.index() * r.options.slidesToScroll;
          r.slideHandler(r.checkNavigable(d), !1, t),
            l.children().trigger("focus");
          break;
        default:
          return;
      }
    }),
    (e.prototype.checkNavigable = function (i) {
      var e, t;
      if (((e = this.getNavigableIndexes()), (t = 0), i > e[e.length - 1]))
        i = e[e.length - 1];
      else
        for (var o in e) {
          if (i < e[o]) {
            i = t;
            break;
          }
          t = e[o];
        }
      return i;
    }),
    (e.prototype.cleanUpEvents = function () {
      var e = this;
      e.options.dots &&
        null !== e.$dots &&
        (i("li", e.$dots)
          .off("click.slick", e.changeSlide)
          .off("mouseenter.slick", i.proxy(e.interrupt, e, !0))
          .off("mouseleave.slick", i.proxy(e.interrupt, e, !1)),
        !0 === e.options.accessibility &&
          e.$dots.off("keydown.slick", e.keyHandler)),
        e.$slider.off("focus.slick blur.slick"),
        !0 === e.options.arrows &&
          e.slideCount > e.options.slidesToShow &&
          (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide),
          e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide),
          !0 === e.options.accessibility &&
            (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler),
            e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))),
        e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
        e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
        e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
        e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
        e.$list.off("click.slick", e.clickHandler),
        i(document).off(e.visibilityChange, e.visibility),
        e.cleanUpSlideEvents(),
        !0 === e.options.accessibility &&
          e.$list.off("keydown.slick", e.keyHandler),
        !0 === e.options.focusOnSelect &&
          i(e.$slideTrack).children().off("click.slick", e.selectHandler),
        i(window).off(
          "orientationchange.slick.slick-" + e.instanceUid,
          e.orientationChange
        ),
        i(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
        i("[draggable!=true]", e.$slideTrack).off(
          "dragstart",
          e.preventDefault
        ),
        i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition);
    }),
    (e.prototype.cleanUpSlideEvents = function () {
      var e = this;
      e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)),
        e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1));
    }),
    (e.prototype.cleanUpRows = function () {
      var i,
        e = this;
      e.options.rows > 1 &&
        ((i = e.$slides.children().children()).removeAttr("style"),
        e.$slider.empty().append(i));
    }),
    (e.prototype.clickHandler = function (i) {
      !1 === this.shouldClick &&
        (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault());
    }),
    (e.prototype.destroy = function (e) {
      var t = this;
      t.autoPlayClear(),
        (t.touchObject = {}),
        t.cleanUpEvents(),
        i(".slick-cloned", t.$slider).detach(),
        t.$dots && t.$dots.remove(),
        t.$prevArrow &&
          t.$prevArrow.length &&
          (t.$prevArrow
            .removeClass("slick-disabled slick-arrow slick-hidden")
            .removeAttr("aria-hidden aria-disabled tabindex")
            .css("display", ""),
          t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()),
        t.$nextArrow &&
          t.$nextArrow.length &&
          (t.$nextArrow
            .removeClass("slick-disabled slick-arrow slick-hidden")
            .removeAttr("aria-hidden aria-disabled tabindex")
            .css("display", ""),
          t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()),
        t.$slides &&
          (t.$slides
            .removeClass(
              "slick-slide slick-active slick-center slick-visible slick-current"
            )
            .removeAttr("aria-hidden")
            .removeAttr("data-slick-index")
            .each(function () {
              i(this).attr("style", i(this).data("originalStyling"));
            }),
          t.$slideTrack.children(this.options.slide).detach(),
          t.$slideTrack.detach(),
          t.$list.detach(),
          t.$slider.append(t.$slides)),
        t.cleanUpRows(),
        t.$slider.removeClass("slick-slider"),
        t.$slider.removeClass("slick-initialized"),
        t.$slider.removeClass("slick-dotted"),
        (t.unslicked = !0),
        e || t.$slider.trigger("destroy", [t]);
    }),
    (e.prototype.disableTransition = function (i) {
      var e = this,
        t = {};
      (t[e.transitionType] = ""),
        !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
    }),
    (e.prototype.fadeSlide = function (i, e) {
      var t = this;
      !1 === t.cssTransitions
        ? (t.$slides.eq(i).css({ zIndex: t.options.zIndex }),
          t.$slides
            .eq(i)
            .animate({ opacity: 1 }, t.options.speed, t.options.easing, e))
        : (t.applyTransition(i),
          t.$slides.eq(i).css({ opacity: 1, zIndex: t.options.zIndex }),
          e &&
            setTimeout(function () {
              t.disableTransition(i), e.call();
            }, t.options.speed));
    }),
    (e.prototype.fadeSlideOut = function (i) {
      var e = this;
      !1 === e.cssTransitions
        ? e.$slides
            .eq(i)
            .animate(
              { opacity: 0, zIndex: e.options.zIndex - 2 },
              e.options.speed,
              e.options.easing
            )
        : (e.applyTransition(i),
          e.$slides.eq(i).css({ opacity: 0, zIndex: e.options.zIndex - 2 }));
    }),
    (e.prototype.filterSlides = e.prototype.slickFilter =
      function (i) {
        var e = this;
        null !== i &&
          ((e.$slidesCache = e.$slides),
          e.unload(),
          e.$slideTrack.children(this.options.slide).detach(),
          e.$slidesCache.filter(i).appendTo(e.$slideTrack),
          e.reinit());
      }),
    (e.prototype.focusHandler = function () {
      var e = this;
      e.$slider
        .off("focus.slick blur.slick")
        .on("focus.slick blur.slick", "*", function (t) {
          t.stopImmediatePropagation();
          var o = i(this);
          setTimeout(function () {
            e.options.pauseOnFocus &&
              ((e.focussed = o.is(":focus")), e.autoPlay());
          }, 0);
        });
    }),
    (e.prototype.getCurrent = e.prototype.slickCurrentSlide =
      function () {
        return this.currentSlide;
      }),
    (e.prototype.getDotCount = function () {
      var i = this,
        e = 0,
        t = 0,
        o = 0;
      if (!0 === i.options.infinite)
        if (i.slideCount <= i.options.slidesToShow) ++o;
        else
          for (; e < i.slideCount; )
            ++o,
              (e = t + i.options.slidesToScroll),
              (t +=
                i.options.slidesToScroll <= i.options.slidesToShow
                  ? i.options.slidesToScroll
                  : i.options.slidesToShow);
      else if (!0 === i.options.centerMode) o = i.slideCount;
      else if (i.options.asNavFor)
        for (; e < i.slideCount; )
          ++o,
            (e = t + i.options.slidesToScroll),
            (t +=
              i.options.slidesToScroll <= i.options.slidesToShow
                ? i.options.slidesToScroll
                : i.options.slidesToShow);
      else
        o =
          1 +
          Math.ceil(
            (i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll
          );
      return o - 1;
    }),
    (e.prototype.getLeft = function (i) {
      var e,
        t,
        o,
        s,
        n = this,
        r = 0;
      return (
        (n.slideOffset = 0),
        (t = n.$slides.first().outerHeight(!0)),
        !0 === n.options.infinite
          ? (n.slideCount > n.options.slidesToShow &&
              ((n.slideOffset = n.slideWidth * n.options.slidesToShow * -1),
              (s = -1),
              !0 === n.options.vertical &&
                !0 === n.options.centerMode &&
                (2 === n.options.slidesToShow
                  ? (s = -1.5)
                  : 1 === n.options.slidesToShow && (s = -2)),
              (r = t * n.options.slidesToShow * s)),
            n.slideCount % n.options.slidesToScroll != 0 &&
              i + n.options.slidesToScroll > n.slideCount &&
              n.slideCount > n.options.slidesToShow &&
              (i > n.slideCount
                ? ((n.slideOffset =
                    (n.options.slidesToShow - (i - n.slideCount)) *
                    n.slideWidth *
                    -1),
                  (r = (n.options.slidesToShow - (i - n.slideCount)) * t * -1))
                : ((n.slideOffset =
                    (n.slideCount % n.options.slidesToScroll) *
                    n.slideWidth *
                    -1),
                  (r = (n.slideCount % n.options.slidesToScroll) * t * -1))))
          : i + n.options.slidesToShow > n.slideCount &&
            ((n.slideOffset =
              (i + n.options.slidesToShow - n.slideCount) * n.slideWidth),
            (r = (i + n.options.slidesToShow - n.slideCount) * t)),
        n.slideCount <= n.options.slidesToShow &&
          ((n.slideOffset = 0), (r = 0)),
        !0 === n.options.centerMode && n.slideCount <= n.options.slidesToShow
          ? (n.slideOffset =
              (n.slideWidth * Math.floor(n.options.slidesToShow)) / 2 -
              (n.slideWidth * n.slideCount) / 2)
          : !0 === n.options.centerMode && !0 === n.options.infinite
          ? (n.slideOffset +=
              n.slideWidth * Math.floor(n.options.slidesToShow / 2) -
              n.slideWidth)
          : !0 === n.options.centerMode &&
            ((n.slideOffset = 0),
            (n.slideOffset +=
              n.slideWidth * Math.floor(n.options.slidesToShow / 2))),
        (e =
          !1 === n.options.vertical
            ? i * n.slideWidth * -1 + n.slideOffset
            : i * t * -1 + r),
        !0 === n.options.variableWidth &&
          ((o =
            n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite
              ? n.$slideTrack.children(".slick-slide").eq(i)
              : n.$slideTrack
                  .children(".slick-slide")
                  .eq(i + n.options.slidesToShow)),
          (e =
            !0 === n.options.rtl
              ? o[0]
                ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width())
                : 0
              : o[0]
              ? -1 * o[0].offsetLeft
              : 0),
          !0 === n.options.centerMode &&
            ((o =
              n.slideCount <= n.options.slidesToShow ||
              !1 === n.options.infinite
                ? n.$slideTrack.children(".slick-slide").eq(i)
                : n.$slideTrack
                    .children(".slick-slide")
                    .eq(i + n.options.slidesToShow + 1)),
            (e =
              !0 === n.options.rtl
                ? o[0]
                  ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width())
                  : 0
                : o[0]
                ? -1 * o[0].offsetLeft
                : 0),
            (e += (n.$list.width() - o.outerWidth()) / 2))),
        e
      );
    }),
    (e.prototype.getOption = e.prototype.slickGetOption =
      function (i) {
        return this.options[i];
      }),
    (e.prototype.getNavigableIndexes = function () {
      var i,
        e = this,
        t = 0,
        o = 0,
        s = [];
      for (
        !1 === e.options.infinite
          ? (i = e.slideCount)
          : ((t = -1 * e.options.slidesToScroll),
            (o = -1 * e.options.slidesToScroll),
            (i = 2 * e.slideCount));
        t < i;

      )
        s.push(t),
          (t = o + e.options.slidesToScroll),
          (o +=
            e.options.slidesToScroll <= e.options.slidesToShow
              ? e.options.slidesToScroll
              : e.options.slidesToShow);
      return s;
    }),
    (e.prototype.getSlick = function () {
      return this;
    }),
    (e.prototype.getSlideCount = function () {
      var e,
        t,
        o = this;
      return (
        (t =
          !0 === o.options.centerMode
            ? o.slideWidth * Math.floor(o.options.slidesToShow / 2)
            : 0),
        !0 === o.options.swipeToSlide
          ? (o.$slideTrack.find(".slick-slide").each(function (s, n) {
              if (n.offsetLeft - t + i(n).outerWidth() / 2 > -1 * o.swipeLeft)
                return (e = n), !1;
            }),
            Math.abs(i(e).attr("data-slick-index") - o.currentSlide) || 1)
          : o.options.slidesToScroll
      );
    }),
    (e.prototype.goTo = e.prototype.slickGoTo =
      function (i, e) {
        this.changeSlide({ data: { message: "index", index: parseInt(i) } }, e);
      }),
    (e.prototype.init = function (e) {
      var t = this;
      i(t.$slider).hasClass("slick-initialized") ||
        (i(t.$slider).addClass("slick-initialized"),
        t.buildRows(),
        t.buildOut(),
        t.setProps(),
        t.startLoad(),
        t.loadSlider(),
        t.initializeEvents(),
        t.updateArrows(),
        t.updateDots(),
        t.checkResponsive(!0),
        t.focusHandler()),
        e && t.$slider.trigger("init", [t]),
        !0 === t.options.accessibility && t.initADA(),
        t.options.autoplay && ((t.paused = !1), t.autoPlay());
    }),
    (e.prototype.initADA = function () {
      var e = this,
        t = Math.ceil(e.slideCount / e.options.slidesToShow),
        o = e.getNavigableIndexes().filter(function (i) {
          return i >= 0 && i < e.slideCount;
        });
      e.$slides
        .add(e.$slideTrack.find(".slick-cloned"))
        .attr({ "aria-hidden": "true", tabindex: "-1" })
        .find("a, input, button, select")
        .attr({ tabindex: "-1" }),
        null !== e.$dots &&
          (e.$slides
            .not(e.$slideTrack.find(".slick-cloned"))
            .each(function (t) {
              var s = o.indexOf(t);
              i(this).attr({
                role: "tabpanel",
                id: "slick-slide" + e.instanceUid + t,
                tabindex: -1,
              }),
                -1 !== s &&
                  i(this).attr({
                    "aria-describedby":
                      "slick-slide-control" + e.instanceUid + s,
                  });
            }),
          e.$dots
            .attr("role", "tablist")
            .find("li")
            .each(function (s) {
              var n = o[s];
              i(this).attr({ role: "presentation" }),
                i(this)
                  .find("button")
                  .first()
                  .attr({
                    role: "tab",
                    id: "slick-slide-control" + e.instanceUid + s,
                    "aria-controls": "slick-slide" + e.instanceUid + n,
                    "aria-label": s + 1 + " of " + t,
                    "aria-selected": null,
                    tabindex: "-1",
                  });
            })
            .eq(e.currentSlide)
            .find("button")
            .attr({ "aria-selected": "true", tabindex: "0" })
            .end());
      for (var s = e.currentSlide, n = s + e.options.slidesToShow; s < n; s++)
        e.$slides.eq(s).attr("tabindex", 0);
      e.activateADA();
    }),
    (e.prototype.initArrowEvents = function () {
      var i = this;
      !0 === i.options.arrows &&
        i.slideCount > i.options.slidesToShow &&
        (i.$prevArrow
          .off("click.slick")
          .on("click.slick", { message: "previous" }, i.changeSlide),
        i.$nextArrow
          .off("click.slick")
          .on("click.slick", { message: "next" }, i.changeSlide),
        !0 === i.options.accessibility &&
          (i.$prevArrow.on("keydown.slick", i.keyHandler),
          i.$nextArrow.on("keydown.slick", i.keyHandler)));
    }),
    (e.prototype.initDotEvents = function () {
      var e = this;
      !0 === e.options.dots &&
        (i("li", e.$dots).on(
          "click.slick",
          { message: "index" },
          e.changeSlide
        ),
        !0 === e.options.accessibility &&
          e.$dots.on("keydown.slick", e.keyHandler)),
        !0 === e.options.dots &&
          !0 === e.options.pauseOnDotsHover &&
          i("li", e.$dots)
            .on("mouseenter.slick", i.proxy(e.interrupt, e, !0))
            .on("mouseleave.slick", i.proxy(e.interrupt, e, !1));
    }),
    (e.prototype.initSlideEvents = function () {
      var e = this;
      e.options.pauseOnHover &&
        (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)),
        e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)));
    }),
    (e.prototype.initializeEvents = function () {
      var e = this;
      e.initArrowEvents(),
        e.initDotEvents(),
        e.initSlideEvents(),
        e.$list.on(
          "touchstart.slick mousedown.slick",
          { action: "start" },
          e.swipeHandler
        ),
        e.$list.on(
          "touchmove.slick mousemove.slick",
          { action: "move" },
          e.swipeHandler
        ),
        e.$list.on(
          "touchend.slick mouseup.slick",
          { action: "end" },
          e.swipeHandler
        ),
        e.$list.on(
          "touchcancel.slick mouseleave.slick",
          { action: "end" },
          e.swipeHandler
        ),
        e.$list.on("click.slick", e.clickHandler),
        i(document).on(e.visibilityChange, i.proxy(e.visibility, e)),
        !0 === e.options.accessibility &&
          e.$list.on("keydown.slick", e.keyHandler),
        !0 === e.options.focusOnSelect &&
          i(e.$slideTrack).children().on("click.slick", e.selectHandler),
        i(window).on(
          "orientationchange.slick.slick-" + e.instanceUid,
          i.proxy(e.orientationChange, e)
        ),
        i(window).on(
          "resize.slick.slick-" + e.instanceUid,
          i.proxy(e.resize, e)
        ),
        i("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault),
        i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
        i(e.setPosition);
    }),
    (e.prototype.initUI = function () {
      var i = this;
      !0 === i.options.arrows &&
        i.slideCount > i.options.slidesToShow &&
        (i.$prevArrow.show(), i.$nextArrow.show()),
        !0 === i.options.dots &&
          i.slideCount > i.options.slidesToShow &&
          i.$dots.show();
    }),
    (e.prototype.keyHandler = function (i) {
      var e = this;
      i.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
        (37 === i.keyCode && !0 === e.options.accessibility
          ? e.changeSlide({
              data: { message: !0 === e.options.rtl ? "next" : "previous" },
            })
          : 39 === i.keyCode &&
            !0 === e.options.accessibility &&
            e.changeSlide({
              data: { message: !0 === e.options.rtl ? "previous" : "next" },
            }));
    }),
    (e.prototype.lazyLoad = function () {
      function e(e) {
        i("img[data-lazy]", e).each(function () {
          var e = i(this),
            t = i(this).attr("data-lazy"),
            o = i(this).attr("data-srcset"),
            s = i(this).attr("data-sizes") || n.$slider.attr("data-sizes"),
            r = document.createElement("img");
          (r.onload = function () {
            e.animate({ opacity: 0 }, 100, function () {
              o && (e.attr("srcset", o), s && e.attr("sizes", s)),
                e.attr("src", t).animate({ opacity: 1 }, 200, function () {
                  e.removeAttr("data-lazy data-srcset data-sizes").removeClass(
                    "slick-loading"
                  );
                }),
                n.$slider.trigger("lazyLoaded", [n, e, t]);
            });
          }),
            (r.onerror = function () {
              e
                .removeAttr("data-lazy")
                .removeClass("slick-loading")
                .addClass("slick-lazyload-error"),
                n.$slider.trigger("lazyLoadError", [n, e, t]);
            }),
            (r.src = t);
        });
      }
      var t,
        o,
        s,
        n = this;
      if (
        (!0 === n.options.centerMode
          ? !0 === n.options.infinite
            ? (s =
                (o = n.currentSlide + (n.options.slidesToShow / 2 + 1)) +
                n.options.slidesToShow +
                2)
            : ((o = Math.max(
                0,
                n.currentSlide - (n.options.slidesToShow / 2 + 1)
              )),
              (s = n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide))
          : ((o = n.options.infinite
              ? n.options.slidesToShow + n.currentSlide
              : n.currentSlide),
            (s = Math.ceil(o + n.options.slidesToShow)),
            !0 === n.options.fade && (o > 0 && o--, s <= n.slideCount && s++)),
        (t = n.$slider.find(".slick-slide").slice(o, s)),
        "anticipated" === n.options.lazyLoad)
      )
        for (
          var r = o - 1, l = s, d = n.$slider.find(".slick-slide"), a = 0;
          a < n.options.slidesToScroll;
          a++
        )
          r < 0 && (r = n.slideCount - 1),
            (t = (t = t.add(d.eq(r))).add(d.eq(l))),
            r--,
            l++;
      e(t),
        n.slideCount <= n.options.slidesToShow
          ? e(n.$slider.find(".slick-slide"))
          : n.currentSlide >= n.slideCount - n.options.slidesToShow
          ? e(n.$slider.find(".slick-cloned").slice(0, n.options.slidesToShow))
          : 0 === n.currentSlide &&
            e(
              n.$slider.find(".slick-cloned").slice(-1 * n.options.slidesToShow)
            );
    }),
    (e.prototype.loadSlider = function () {
      var i = this;
      i.setPosition(),
        i.$slideTrack.css({ opacity: 1 }),
        i.$slider.removeClass("slick-loading"),
        i.initUI(),
        "progressive" === i.options.lazyLoad && i.progressiveLazyLoad();
    }),
    (e.prototype.next = e.prototype.slickNext =
      function () {
        this.changeSlide({ data: { message: "next" } });
      }),
    (e.prototype.orientationChange = function () {
      var i = this;
      i.checkResponsive(), i.setPosition();
    }),
    (e.prototype.pause = e.prototype.slickPause =
      function () {
        var i = this;
        i.autoPlayClear(), (i.paused = !0);
      }),
    (e.prototype.play = e.prototype.slickPlay =
      function () {
        var i = this;
        i.autoPlay(),
          (i.options.autoplay = !0),
          (i.paused = !1),
          (i.focussed = !1),
          (i.interrupted = !1);
      }),
    (e.prototype.postSlide = function (e) {
      var t = this;
      t.unslicked ||
        (t.$slider.trigger("afterChange", [t, e]),
        (t.animating = !1),
        t.slideCount > t.options.slidesToShow && t.setPosition(),
        (t.swipeLeft = null),
        t.options.autoplay && t.autoPlay(),
        !0 === t.options.accessibility &&
          (t.initADA(),
          t.options.focusOnChange &&
            i(t.$slides.get(t.currentSlide)).attr("tabindex", 0).focus()));
    }),
    (e.prototype.prev = e.prototype.slickPrev =
      function () {
        this.changeSlide({ data: { message: "previous" } });
      }),
    (e.prototype.preventDefault = function (i) {
      i.preventDefault();
    }),
    (e.prototype.progressiveLazyLoad = function (e) {
      e = e || 1;
      var t,
        o,
        s,
        n,
        r,
        l = this,
        d = i("img[data-lazy]", l.$slider);
      d.length
        ? ((t = d.first()),
          (o = t.attr("data-lazy")),
          (s = t.attr("data-srcset")),
          (n = t.attr("data-sizes") || l.$slider.attr("data-sizes")),
          ((r = document.createElement("img")).onload = function () {
            s && (t.attr("srcset", s), n && t.attr("sizes", n)),
              t
                .attr("src", o)
                .removeAttr("data-lazy data-srcset data-sizes")
                .removeClass("slick-loading"),
              !0 === l.options.adaptiveHeight && l.setPosition(),
              l.$slider.trigger("lazyLoaded", [l, t, o]),
              l.progressiveLazyLoad();
          }),
          (r.onerror = function () {
            e < 3
              ? setTimeout(function () {
                  l.progressiveLazyLoad(e + 1);
                }, 500)
              : (t
                  .removeAttr("data-lazy")
                  .removeClass("slick-loading")
                  .addClass("slick-lazyload-error"),
                l.$slider.trigger("lazyLoadError", [l, t, o]),
                l.progressiveLazyLoad());
          }),
          (r.src = o))
        : l.$slider.trigger("allImagesLoaded", [l]);
    }),
    (e.prototype.refresh = function (e) {
      var t,
        o,
        s = this;
      (o = s.slideCount - s.options.slidesToShow),
        !s.options.infinite && s.currentSlide > o && (s.currentSlide = o),
        s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0),
        (t = s.currentSlide),
        s.destroy(!0),
        i.extend(s, s.initials, { currentSlide: t }),
        s.init(),
        e || s.changeSlide({ data: { message: "index", index: t } }, !1);
    }),
    (e.prototype.registerBreakpoints = function () {
      var e,
        t,
        o,
        s = this,
        n = s.options.responsive || null;
      if ("array" === i.type(n) && n.length) {
        s.respondTo = s.options.respondTo || "window";
        for (e in n)
          if (((o = s.breakpoints.length - 1), n.hasOwnProperty(e))) {
            for (t = n[e].breakpoint; o >= 0; )
              s.breakpoints[o] &&
                s.breakpoints[o] === t &&
                s.breakpoints.splice(o, 1),
                o--;
            s.breakpoints.push(t), (s.breakpointSettings[t] = n[e].settings);
          }
        s.breakpoints.sort(function (i, e) {
          return s.options.mobileFirst ? i - e : e - i;
        });
      }
    }),
    (e.prototype.reinit = function () {
      var e = this;
      (e.$slides = e.$slideTrack
        .children(e.options.slide)
        .addClass("slick-slide")),
        (e.slideCount = e.$slides.length),
        e.currentSlide >= e.slideCount &&
          0 !== e.currentSlide &&
          (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
        e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
        e.registerBreakpoints(),
        e.setProps(),
        e.setupInfinite(),
        e.buildArrows(),
        e.updateArrows(),
        e.initArrowEvents(),
        e.buildDots(),
        e.updateDots(),
        e.initDotEvents(),
        e.cleanUpSlideEvents(),
        e.initSlideEvents(),
        e.checkResponsive(!1, !0),
        !0 === e.options.focusOnSelect &&
          i(e.$slideTrack).children().on("click.slick", e.selectHandler),
        e.setSlideClasses(
          "number" == typeof e.currentSlide ? e.currentSlide : 0
        ),
        e.setPosition(),
        e.focusHandler(),
        (e.paused = !e.options.autoplay),
        e.autoPlay(),
        e.$slider.trigger("reInit", [e]);
    }),
    (e.prototype.resize = function () {
      var e = this;
      i(window).width() !== e.windowWidth &&
        (clearTimeout(e.windowDelay),
        (e.windowDelay = window.setTimeout(function () {
          (e.windowWidth = i(window).width()),
            e.checkResponsive(),
            e.unslicked || e.setPosition();
        }, 50)));
    }),
    (e.prototype.removeSlide = e.prototype.slickRemove =
      function (i, e, t) {
        var o = this;
        if (
          ((i =
            "boolean" == typeof i
              ? !0 === (e = i)
                ? 0
                : o.slideCount - 1
              : !0 === e
              ? --i
              : i),
          o.slideCount < 1 || i < 0 || i > o.slideCount - 1)
        )
          return !1;
        o.unload(),
          !0 === t
            ? o.$slideTrack.children().remove()
            : o.$slideTrack.children(this.options.slide).eq(i).remove(),
          (o.$slides = o.$slideTrack.children(this.options.slide)),
          o.$slideTrack.children(this.options.slide).detach(),
          o.$slideTrack.append(o.$slides),
          (o.$slidesCache = o.$slides),
          o.reinit();
      }),
    (e.prototype.setCSS = function (i) {
      var e,
        t,
        o = this,
        s = {};
      !0 === o.options.rtl && (i = -i),
        (e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px"),
        (t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px"),
        (s[o.positionProp] = i),
        !1 === o.transformsEnabled
          ? o.$slideTrack.css(s)
          : ((s = {}),
            !1 === o.cssTransitions
              ? ((s[o.animType] = "translate(" + e + ", " + t + ")"),
                o.$slideTrack.css(s))
              : ((s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)"),
                o.$slideTrack.css(s)));
    }),
    (e.prototype.setDimensions = function () {
      var i = this;
      !1 === i.options.vertical
        ? !0 === i.options.centerMode &&
          i.$list.css({ padding: "0px " + i.options.centerPadding })
        : (i.$list.height(
            i.$slides.first().outerHeight(!0) * i.options.slidesToShow
          ),
          !0 === i.options.centerMode &&
            i.$list.css({ padding: i.options.centerPadding + " 0px" })),
        (i.listWidth = i.$list.width()),
        (i.listHeight = i.$list.height()),
        !1 === i.options.vertical && !1 === i.options.variableWidth
          ? ((i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow)),
            i.$slideTrack.width(
              Math.ceil(
                i.slideWidth * i.$slideTrack.children(".slick-slide").length
              )
            ))
          : !0 === i.options.variableWidth
          ? i.$slideTrack.width(5e3 * i.slideCount)
          : ((i.slideWidth = Math.ceil(i.listWidth)),
            i.$slideTrack.height(
              Math.ceil(
                i.$slides.first().outerHeight(!0) *
                  i.$slideTrack.children(".slick-slide").length
              )
            ));
      var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
      !1 === i.options.variableWidth &&
        i.$slideTrack.children(".slick-slide").width(i.slideWidth - e);
    }),
    (e.prototype.setFade = function () {
      var e,
        t = this;
      t.$slides.each(function (o, s) {
        (e = t.slideWidth * o * -1),
          !0 === t.options.rtl
            ? i(s).css({
                position: "relative",
                right: e,
                top: 0,
                zIndex: t.options.zIndex - 2,
                opacity: 0,
              })
            : i(s).css({
                position: "relative",
                left: e,
                top: 0,
                zIndex: t.options.zIndex - 2,
                opacity: 0,
              });
      }),
        t.$slides
          .eq(t.currentSlide)
          .css({ zIndex: t.options.zIndex - 1, opacity: 1 });
    }),
    (e.prototype.setHeight = function () {
      var i = this;
      if (
        1 === i.options.slidesToShow &&
        !0 === i.options.adaptiveHeight &&
        !1 === i.options.vertical
      ) {
        var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
        i.$list.css("height", e);
      }
    }),
    (e.prototype.setOption = e.prototype.slickSetOption =
      function () {
        var e,
          t,
          o,
          s,
          n,
          r = this,
          l = !1;
        if (
          ("object" === i.type(arguments[0])
            ? ((o = arguments[0]), (l = arguments[1]), (n = "multiple"))
            : "string" === i.type(arguments[0]) &&
              ((o = arguments[0]),
              (s = arguments[1]),
              (l = arguments[2]),
              "responsive" === arguments[0] && "array" === i.type(arguments[1])
                ? (n = "responsive")
                : void 0 !== arguments[1] && (n = "single")),
          "single" === n)
        )
          r.options[o] = s;
        else if ("multiple" === n)
          i.each(o, function (i, e) {
            r.options[i] = e;
          });
        else if ("responsive" === n)
          for (t in s)
            if ("array" !== i.type(r.options.responsive))
              r.options.responsive = [s[t]];
            else {
              for (e = r.options.responsive.length - 1; e >= 0; )
                r.options.responsive[e].breakpoint === s[t].breakpoint &&
                  r.options.responsive.splice(e, 1),
                  e--;
              r.options.responsive.push(s[t]);
            }
        l && (r.unload(), r.reinit());
      }),
    (e.prototype.setPosition = function () {
      var i = this;
      i.setDimensions(),
        i.setHeight(),
        !1 === i.options.fade
          ? i.setCSS(i.getLeft(i.currentSlide))
          : i.setFade(),
        i.$slider.trigger("setPosition", [i]);
    }),
    (e.prototype.setProps = function () {
      var i = this,
        e = document.body.style;
      (i.positionProp = !0 === i.options.vertical ? "top" : "left"),
        "top" === i.positionProp
          ? i.$slider.addClass("slick-vertical")
          : i.$slider.removeClass("slick-vertical"),
        (void 0 === e.WebkitTransition &&
          void 0 === e.MozTransition &&
          void 0 === e.msTransition) ||
          (!0 === i.options.useCSS && (i.cssTransitions = !0)),
        i.options.fade &&
          ("number" == typeof i.options.zIndex
            ? i.options.zIndex < 3 && (i.options.zIndex = 3)
            : (i.options.zIndex = i.defaults.zIndex)),
        void 0 !== e.OTransform &&
          ((i.animType = "OTransform"),
          (i.transformType = "-o-transform"),
          (i.transitionType = "OTransition"),
          void 0 === e.perspectiveProperty &&
            void 0 === e.webkitPerspective &&
            (i.animType = !1)),
        void 0 !== e.MozTransform &&
          ((i.animType = "MozTransform"),
          (i.transformType = "-moz-transform"),
          (i.transitionType = "MozTransition"),
          void 0 === e.perspectiveProperty &&
            void 0 === e.MozPerspective &&
            (i.animType = !1)),
        void 0 !== e.webkitTransform &&
          ((i.animType = "webkitTransform"),
          (i.transformType = "-webkit-transform"),
          (i.transitionType = "webkitTransition"),
          void 0 === e.perspectiveProperty &&
            void 0 === e.webkitPerspective &&
            (i.animType = !1)),
        void 0 !== e.msTransform &&
          ((i.animType = "msTransform"),
          (i.transformType = "-ms-transform"),
          (i.transitionType = "msTransition"),
          void 0 === e.msTransform && (i.animType = !1)),
        void 0 !== e.transform &&
          !1 !== i.animType &&
          ((i.animType = "transform"),
          (i.transformType = "transform"),
          (i.transitionType = "transition")),
        (i.transformsEnabled =
          i.options.useTransform && null !== i.animType && !1 !== i.animType);
    }),
    (e.prototype.setSlideClasses = function (i) {
      var e,
        t,
        o,
        s,
        n = this;
      if (
        ((t = n.$slider
          .find(".slick-slide")
          .removeClass("slick-active slick-center slick-current")
          .attr("aria-hidden", "true")),
        n.$slides.eq(i).addClass("slick-current"),
        !0 === n.options.centerMode)
      ) {
        var r = n.options.slidesToShow % 2 == 0 ? 1 : 0;
        (e = Math.floor(n.options.slidesToShow / 2)),
          !0 === n.options.infinite &&
            (i >= e && i <= n.slideCount - 1 - e
              ? n.$slides
                  .slice(i - e + r, i + e + 1)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false")
              : ((o = n.options.slidesToShow + i),
                t
                  .slice(o - e + 1 + r, o + e + 2)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false")),
            0 === i
              ? t
                  .eq(t.length - 1 - n.options.slidesToShow)
                  .addClass("slick-center")
              : i === n.slideCount - 1 &&
                t.eq(n.options.slidesToShow).addClass("slick-center")),
          n.$slides.eq(i).addClass("slick-center");
      } else
        i >= 0 && i <= n.slideCount - n.options.slidesToShow
          ? n.$slides
              .slice(i, i + n.options.slidesToShow)
              .addClass("slick-active")
              .attr("aria-hidden", "false")
          : t.length <= n.options.slidesToShow
          ? t.addClass("slick-active").attr("aria-hidden", "false")
          : ((s = n.slideCount % n.options.slidesToShow),
            (o = !0 === n.options.infinite ? n.options.slidesToShow + i : i),
            n.options.slidesToShow == n.options.slidesToScroll &&
            n.slideCount - i < n.options.slidesToShow
              ? t
                  .slice(o - (n.options.slidesToShow - s), o + s)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false")
              : t
                  .slice(o, o + n.options.slidesToShow)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false"));
      ("ondemand" !== n.options.lazyLoad &&
        "anticipated" !== n.options.lazyLoad) ||
        n.lazyLoad();
    }),
    (e.prototype.setupInfinite = function () {
      var e,
        t,
        o,
        s = this;
      if (
        (!0 === s.options.fade && (s.options.centerMode = !1),
        !0 === s.options.infinite &&
          !1 === s.options.fade &&
          ((t = null), s.slideCount > s.options.slidesToShow))
      ) {
        for (
          o =
            !0 === s.options.centerMode
              ? s.options.slidesToShow + 1
              : s.options.slidesToShow,
            e = s.slideCount;
          e > s.slideCount - o;
          e -= 1
        )
          (t = e - 1),
            i(s.$slides[t])
              .clone(!0)
              .attr("id", "")
              .attr("data-slick-index", t - s.slideCount)
              .prependTo(s.$slideTrack)
              .addClass("slick-cloned");
        for (e = 0; e < o + s.slideCount; e += 1)
          (t = e),
            i(s.$slides[t])
              .clone(!0)
              .attr("id", "")
              .attr("data-slick-index", t + s.slideCount)
              .appendTo(s.$slideTrack)
              .addClass("slick-cloned");
        s.$slideTrack
          .find(".slick-cloned")
          .find("[id]")
          .each(function () {
            i(this).attr("id", "");
          });
      }
    }),
    (e.prototype.interrupt = function (i) {
      var e = this;
      i || e.autoPlay(), (e.interrupted = i);
    }),
    (e.prototype.selectHandler = function (e) {
      var t = this,
        o = i(e.target).is(".slick-slide")
          ? i(e.target)
          : i(e.target).parents(".slick-slide"),
        s = parseInt(o.attr("data-slick-index"));
      s || (s = 0),
        t.slideCount <= t.options.slidesToShow
          ? t.slideHandler(s, !1, !0)
          : t.slideHandler(s);
    }),
    (e.prototype.slideHandler = function (i, e, t) {
      var o,
        s,
        n,
        r,
        l,
        d = null,
        a = this;
      if (
        ((e = e || !1),
        !(
          (!0 === a.animating && !0 === a.options.waitForAnimate) ||
          (!0 === a.options.fade && a.currentSlide === i)
        ))
      )
        if (
          (!1 === e && a.asNavFor(i),
          (o = i),
          (d = a.getLeft(o)),
          (r = a.getLeft(a.currentSlide)),
          (a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft),
          !1 === a.options.infinite &&
            !1 === a.options.centerMode &&
            (i < 0 || i > a.getDotCount() * a.options.slidesToScroll))
        )
          !1 === a.options.fade &&
            ((o = a.currentSlide),
            !0 !== t
              ? a.animateSlide(r, function () {
                  a.postSlide(o);
                })
              : a.postSlide(o));
        else if (
          !1 === a.options.infinite &&
          !0 === a.options.centerMode &&
          (i < 0 || i > a.slideCount - a.options.slidesToScroll)
        )
          !1 === a.options.fade &&
            ((o = a.currentSlide),
            !0 !== t
              ? a.animateSlide(r, function () {
                  a.postSlide(o);
                })
              : a.postSlide(o));
        else {
          if (
            (a.options.autoplay && clearInterval(a.autoPlayTimer),
            (s =
              o < 0
                ? a.slideCount % a.options.slidesToScroll != 0
                  ? a.slideCount - (a.slideCount % a.options.slidesToScroll)
                  : a.slideCount + o
                : o >= a.slideCount
                ? a.slideCount % a.options.slidesToScroll != 0
                  ? 0
                  : o - a.slideCount
                : o),
            (a.animating = !0),
            a.$slider.trigger("beforeChange", [a, a.currentSlide, s]),
            (n = a.currentSlide),
            (a.currentSlide = s),
            a.setSlideClasses(a.currentSlide),
            a.options.asNavFor &&
              (l = (l = a.getNavTarget()).slick("getSlick")).slideCount <=
                l.options.slidesToShow &&
              l.setSlideClasses(a.currentSlide),
            a.updateDots(),
            a.updateArrows(),
            !0 === a.options.fade)
          )
            return (
              !0 !== t
                ? (a.fadeSlideOut(n),
                  a.fadeSlide(s, function () {
                    a.postSlide(s);
                  }))
                : a.postSlide(s),
              void a.animateHeight()
            );
          !0 !== t
            ? a.animateSlide(d, function () {
                a.postSlide(s);
              })
            : a.postSlide(s);
        }
    }),
    (e.prototype.startLoad = function () {
      var i = this;
      !0 === i.options.arrows &&
        i.slideCount > i.options.slidesToShow &&
        (i.$prevArrow.hide(), i.$nextArrow.hide()),
        !0 === i.options.dots &&
          i.slideCount > i.options.slidesToShow &&
          i.$dots.hide(),
        i.$slider.addClass("slick-loading");
    }),
    (e.prototype.swipeDirection = function () {
      var i,
        e,
        t,
        o,
        s = this;
      return (
        (i = s.touchObject.startX - s.touchObject.curX),
        (e = s.touchObject.startY - s.touchObject.curY),
        (t = Math.atan2(e, i)),
        (o = Math.round((180 * t) / Math.PI)) < 0 && (o = 360 - Math.abs(o)),
        o <= 45 && o >= 0
          ? !1 === s.options.rtl
            ? "left"
            : "right"
          : o <= 360 && o >= 315
          ? !1 === s.options.rtl
            ? "left"
            : "right"
          : o >= 135 && o <= 225
          ? !1 === s.options.rtl
            ? "right"
            : "left"
          : !0 === s.options.verticalSwiping
          ? o >= 35 && o <= 135
            ? "down"
            : "up"
          : "vertical"
      );
    }),
    (e.prototype.swipeEnd = function (i) {
      var e,
        t,
        o = this;
      if (((o.dragging = !1), (o.swiping = !1), o.scrolling))
        return (o.scrolling = !1), !1;
      if (
        ((o.interrupted = !1),
        (o.shouldClick = !(o.touchObject.swipeLength > 10)),
        void 0 === o.touchObject.curX)
      )
        return !1;
      if (
        (!0 === o.touchObject.edgeHit &&
          o.$slider.trigger("edge", [o, o.swipeDirection()]),
        o.touchObject.swipeLength >= o.touchObject.minSwipe)
      ) {
        switch ((t = o.swipeDirection())) {
          case "left":
          case "down":
            (e = o.options.swipeToSlide
              ? o.checkNavigable(o.currentSlide + o.getSlideCount())
              : o.currentSlide + o.getSlideCount()),
              (o.currentDirection = 0);
            break;
          case "right":
          case "up":
            (e = o.options.swipeToSlide
              ? o.checkNavigable(o.currentSlide - o.getSlideCount())
              : o.currentSlide - o.getSlideCount()),
              (o.currentDirection = 1);
        }
        "vertical" != t &&
          (o.slideHandler(e),
          (o.touchObject = {}),
          o.$slider.trigger("swipe", [o, t]));
      } else
        o.touchObject.startX !== o.touchObject.curX &&
          (o.slideHandler(o.currentSlide), (o.touchObject = {}));
    }),
    (e.prototype.swipeHandler = function (i) {
      var e = this;
      if (
        !(
          !1 === e.options.swipe ||
          ("ontouchend" in document && !1 === e.options.swipe) ||
          (!1 === e.options.draggable && -1 !== i.type.indexOf("mouse"))
        )
      )
        switch (
          ((e.touchObject.fingerCount =
            i.originalEvent && void 0 !== i.originalEvent.touches
              ? i.originalEvent.touches.length
              : 1),
          (e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold),
          !0 === e.options.verticalSwiping &&
            (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold),
          i.data.action)
        ) {
          case "start":
            e.swipeStart(i);
            break;
          case "move":
            e.swipeMove(i);
            break;
          case "end":
            e.swipeEnd(i);
        }
    }),
    (e.prototype.swipeMove = function (i) {
      var e,
        t,
        o,
        s,
        n,
        r,
        l = this;
      return (
        (n = void 0 !== i.originalEvent ? i.originalEvent.touches : null),
        !(!l.dragging || l.scrolling || (n && 1 !== n.length)) &&
          ((e = l.getLeft(l.currentSlide)),
          (l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX),
          (l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY),
          (l.touchObject.swipeLength = Math.round(
            Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))
          )),
          (r = Math.round(
            Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2))
          )),
          !l.options.verticalSwiping && !l.swiping && r > 4
            ? ((l.scrolling = !0), !1)
            : (!0 === l.options.verticalSwiping &&
                (l.touchObject.swipeLength = r),
              (t = l.swipeDirection()),
              void 0 !== i.originalEvent &&
                l.touchObject.swipeLength > 4 &&
                ((l.swiping = !0), i.preventDefault()),
              (s =
                (!1 === l.options.rtl ? 1 : -1) *
                (l.touchObject.curX > l.touchObject.startX ? 1 : -1)),
              !0 === l.options.verticalSwiping &&
                (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1),
              (o = l.touchObject.swipeLength),
              (l.touchObject.edgeHit = !1),
              !1 === l.options.infinite &&
                ((0 === l.currentSlide && "right" === t) ||
                  (l.currentSlide >= l.getDotCount() && "left" === t)) &&
                ((o = l.touchObject.swipeLength * l.options.edgeFriction),
                (l.touchObject.edgeHit = !0)),
              !1 === l.options.vertical
                ? (l.swipeLeft = e + o * s)
                : (l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s),
              !0 === l.options.verticalSwiping && (l.swipeLeft = e + o * s),
              !0 !== l.options.fade &&
                !1 !== l.options.touchMove &&
                (!0 === l.animating
                  ? ((l.swipeLeft = null), !1)
                  : void l.setCSS(l.swipeLeft))))
      );
    }),
    (e.prototype.swipeStart = function (i) {
      var e,
        t = this;
      if (
        ((t.interrupted = !0),
        1 !== t.touchObject.fingerCount ||
          t.slideCount <= t.options.slidesToShow)
      )
        return (t.touchObject = {}), !1;
      void 0 !== i.originalEvent &&
        void 0 !== i.originalEvent.touches &&
        (e = i.originalEvent.touches[0]),
        (t.touchObject.startX = t.touchObject.curX =
          void 0 !== e ? e.pageX : i.clientX),
        (t.touchObject.startY = t.touchObject.curY =
          void 0 !== e ? e.pageY : i.clientY),
        (t.dragging = !0);
    }),
    (e.prototype.unfilterSlides = e.prototype.slickUnfilter =
      function () {
        var i = this;
        null !== i.$slidesCache &&
          (i.unload(),
          i.$slideTrack.children(this.options.slide).detach(),
          i.$slidesCache.appendTo(i.$slideTrack),
          i.reinit());
      }),
    (e.prototype.unload = function () {
      var e = this;
      i(".slick-cloned", e.$slider).remove(),
        e.$dots && e.$dots.remove(),
        e.$prevArrow &&
          e.htmlExpr.test(e.options.prevArrow) &&
          e.$prevArrow.remove(),
        e.$nextArrow &&
          e.htmlExpr.test(e.options.nextArrow) &&
          e.$nextArrow.remove(),
        e.$slides
          .removeClass("slick-slide slick-active slick-visible slick-current")
          .attr("aria-hidden", "true")
          .css("width", "");
    }),
    (e.prototype.unslick = function (i) {
      var e = this;
      e.$slider.trigger("unslick", [e, i]), e.destroy();
    }),
    (e.prototype.updateArrows = function () {
      var i = this;
      Math.floor(i.options.slidesToShow / 2),
        !0 === i.options.arrows &&
          i.slideCount > i.options.slidesToShow &&
          !i.options.infinite &&
          (i.$prevArrow
            .removeClass("slick-disabled")
            .attr("aria-disabled", "false"),
          i.$nextArrow
            .removeClass("slick-disabled")
            .attr("aria-disabled", "false"),
          0 === i.currentSlide
            ? (i.$prevArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              i.$nextArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"))
            : i.currentSlide >= i.slideCount - i.options.slidesToShow &&
              !1 === i.options.centerMode
            ? (i.$nextArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              i.$prevArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"))
            : i.currentSlide >= i.slideCount - 1 &&
              !0 === i.options.centerMode &&
              (i.$nextArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              i.$prevArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false")));
    }),
    (e.prototype.updateDots = function () {
      var i = this;
      null !== i.$dots &&
        (i.$dots.find("li").removeClass("slick-active").end(),
        i.$dots
          .find("li")
          .eq(Math.floor(i.currentSlide / i.options.slidesToScroll))
          .addClass("slick-active"));
    }),
    (e.prototype.visibility = function () {
      var i = this;
      i.options.autoplay &&
        (document[i.hidden] ? (i.interrupted = !0) : (i.interrupted = !1));
    }),
    (i.fn.slick = function () {
      var i,
        t,
        o = this,
        s = arguments[0],
        n = Array.prototype.slice.call(arguments, 1),
        r = o.length;
      for (i = 0; i < r; i++)
        if (
          ("object" == typeof s || void 0 === s
            ? (o[i].slick = new e(o[i], s))
            : (t = o[i].slick[s].apply(o[i].slick, n)),
          void 0 !== t)
        )
          return t;
      return o;
    });
});

/******/ (function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/ var installedModules = {};
  /******/
  /******/ // The require function
  /******/ function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/ if (installedModules[moduleId]) {
      /******/ return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/ var module = (installedModules[moduleId] = {
      /******/ i: moduleId,
      /******/ l: false,
      /******/ exports: {},
      /******/
    });
    /******/
    /******/ // Execute the module function
    /******/ modules[moduleId].call(
      module.exports,
      module,
      module.exports,
      __webpack_require__
    );
    /******/
    /******/ // Flag the module as loaded
    /******/ module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/ return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/ __webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/ __webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/ __webpack_require__.d = function (exports, name, getter) {
    /******/ if (!__webpack_require__.o(exports, name)) {
      /******/ Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter,
      });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/ __webpack_require__.r = function (exports) {
    /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
      /******/ Object.defineProperty(exports, Symbol.toStringTag, {
        value: "Module",
      });
      /******/
    }
    /******/ Object.defineProperty(exports, "__esModule", { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/ __webpack_require__.t = function (value, mode) {
    /******/ if (mode & 1) value = __webpack_require__(value);
    /******/ if (mode & 8) return value;
    /******/ if (
      mode & 4 &&
      typeof value === "object" &&
      value &&
      value.__esModule
    )
      return value;
    /******/ var ns = Object.create(null);
    /******/ __webpack_require__.r(ns);
    /******/ Object.defineProperty(ns, "default", {
      enumerable: true,
      value: value,
    });
    /******/ if (mode & 2 && typeof value != "string")
      for (var key in value)
        __webpack_require__.d(
          ns,
          key,
          function (key) {
            return value[key];
          }.bind(null, key)
        );
    /******/ return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/ __webpack_require__.n = function (module) {
    /******/ var getter =
      module && module.__esModule
        ? /******/ function getDefault() {
            return module["default"];
          }
        : /******/ function getModuleExports() {
            return module;
          };
    /******/ __webpack_require__.d(getter, "a", getter);
    /******/ return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/ __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/ __webpack_require__.p = "";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/ return __webpack_require__((__webpack_require__.s = 375));
  /******/
})(
  /************************************************************************/
  /******/ [
    /* 0 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
      /*!
       * jQuery JavaScript Library v3.4.1
       * https://jquery.com/
       *
       * Includes Sizzle.js
       * https://sizzlejs.com/
       *
       * Copyright JS Foundation and other contributors
       * Released under the MIT license
       * https://jquery.org/license
       *
       * Date: 2019-05-01T21:04Z
       */
      (function (global, factory) {
        "use strict";

        if (true && typeof module.exports === "object") {
          // For CommonJS and CommonJS-like environments where a proper `window`
          // is present, execute the factory and get jQuery.
          // For environments that do not have a `window` with a `document`
          // (such as Node.js), expose a factory as module.exports.
          // This accentuates the need for the creation of a real `window`.
          // e.g. var jQuery = require("jquery")(window);
          // See ticket #14549 for more info.
          module.exports = global.document
            ? factory(global, true)
            : function (w) {
                if (!w.document) {
                  throw new Error("jQuery requires a window with a document");
                }
                return factory(w);
              };
        } else {
          factory(global);
        }

        // Pass this if window is not defined yet
      })(
        typeof window !== "undefined" ? window : this,
        function (window, noGlobal) {
          // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
          // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
          // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
          // enough that all such attempts are guarded in a try block.
          "use strict";

          var arr = [];

          var document = window.document;

          var getProto = Object.getPrototypeOf;

          var slice = arr.slice;

          var concat = arr.concat;

          var push = arr.push;

          var indexOf = arr.indexOf;

          var class2type = {};

          var toString = class2type.toString;

          var hasOwn = class2type.hasOwnProperty;

          var fnToString = hasOwn.toString;

          var ObjectFunctionString = fnToString.call(Object);

          var support = {};

          var isFunction = function isFunction(obj) {
            // Support: Chrome <=57, Firefox <=52
            // In some browsers, typeof returns "function" for HTML <object> elements
            // (i.e., `typeof document.createElement( "object" ) === "function"`).
            // We don't want to classify *any* DOM node as a function.
            return (
              typeof obj === "function" && typeof obj.nodeType !== "number"
            );
          };

          var isWindow = function isWindow(obj) {
            return obj != null && obj === obj.window;
          };

          var preservedScriptAttributes = {
            type: true,
            src: true,
            nonce: true,
            noModule: true,
          };

          function DOMEval(code, node, doc) {
            doc = doc || document;

            var i,
              val,
              script = doc.createElement("script");

            script.text = code;
            if (node) {
              for (i in preservedScriptAttributes) {
                // Support: Firefox 64+, Edge 18+
                // Some browsers don't support the "nonce" property on scripts.
                // On the other hand, just using `getAttribute` is not enough as
                // the `nonce` attribute is reset to an empty string whenever it
                // becomes browsing-context connected.
                // See https://github.com/whatwg/html/issues/2369
                // See https://html.spec.whatwg.org/#nonce-attributes
                // The `node.getAttribute` check was added for the sake of
                // `jQuery.globalEval` so that it can fake a nonce-containing node
                // via an object.
                val = node[i] || (node.getAttribute && node.getAttribute(i));
                if (val) {
                  script.setAttribute(i, val);
                }
              }
            }
            doc.head.appendChild(script).parentNode.removeChild(script);
          }

          function toType(obj) {
            if (obj == null) {
              return obj + "";
            }

            // Support: Android <=2.3 only (functionish RegExp)
            return typeof obj === "object" || typeof obj === "function"
              ? class2type[toString.call(obj)] || "object"
              : typeof obj;
          }
          /* global Symbol */
          // Defining this global in .eslintrc.json would create a danger of using the global
          // unguarded in another place, it seems safer to define global only for this module

          var version = "3.4.1",
            // Define a local copy of jQuery
            jQuery = function (selector, context) {
              // The jQuery object is actually just the init constructor 'enhanced'
              // Need init if jQuery is called (just allow error to be thrown if not included)
              return new jQuery.fn.init(selector, context);
            },
            // Support: Android <=4.0 only
            // Make sure we trim BOM and NBSP
            rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

          jQuery.fn = jQuery.prototype = {
            // The current version of jQuery being used
            jquery: version,

            constructor: jQuery,

            // The default length of a jQuery object is 0
            length: 0,

            toArray: function () {
              return slice.call(this);
            },

            // Get the Nth element in the matched element set OR
            // Get the whole matched element set as a clean array
            get: function (num) {
              // Return all the elements in a clean array
              if (num == null) {
                return slice.call(this);
              }

              // Return just the one element from the set
              return num < 0 ? this[num + this.length] : this[num];
            },

            // Take an array of elements and push it onto the stack
            // (returning the new matched element set)
            pushStack: function (elems) {
              // Build a new jQuery matched element set
              var ret = jQuery.merge(this.constructor(), elems);

              // Add the old object onto the stack (as a reference)
              ret.prevObject = this;

              // Return the newly-formed element set
              return ret;
            },

            // Execute a callback for every element in the matched set.
            each: function (callback) {
              return jQuery.each(this, callback);
            },

            map: function (callback) {
              return this.pushStack(
                jQuery.map(this, function (elem, i) {
                  return callback.call(elem, i, elem);
                })
              );
            },

            slice: function () {
              return this.pushStack(slice.apply(this, arguments));
            },

            first: function () {
              return this.eq(0);
            },

            last: function () {
              return this.eq(-1);
            },

            eq: function (i) {
              var len = this.length,
                j = +i + (i < 0 ? len : 0);
              return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
            },

            end: function () {
              return this.prevObject || this.constructor();
            },

            // For internal use only.
            // Behaves like an Array's method, not like a jQuery method.
            push: push,
            sort: arr.sort,
            splice: arr.splice,
          };

          jQuery.extend = jQuery.fn.extend = function () {
            var options,
              name,
              src,
              copy,
              copyIsArray,
              clone,
              target = arguments[0] || {},
              i = 1,
              length = arguments.length,
              deep = false;

            // Handle a deep copy situation
            if (typeof target === "boolean") {
              deep = target;

              // Skip the boolean and the target
              target = arguments[i] || {};
              i++;
            }

            // Handle case when target is a string or something (possible in deep copy)
            if (typeof target !== "object" && !isFunction(target)) {
              target = {};
            }

            // Extend jQuery itself if only one argument is passed
            if (i === length) {
              target = this;
              i--;
            }

            for (; i < length; i++) {
              // Only deal with non-null/undefined values
              if ((options = arguments[i]) != null) {
                // Extend the base object
                for (name in options) {
                  copy = options[name];

                  // Prevent Object.prototype pollution
                  // Prevent never-ending loop
                  if (name === "__proto__" || target === copy) {
                    continue;
                  }

                  // Recurse if we're merging plain objects or arrays
                  if (
                    deep &&
                    copy &&
                    (jQuery.isPlainObject(copy) ||
                      (copyIsArray = Array.isArray(copy)))
                  ) {
                    src = target[name];

                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) {
                      clone = [];
                    } else if (!copyIsArray && !jQuery.isPlainObject(src)) {
                      clone = {};
                    } else {
                      clone = src;
                    }
                    copyIsArray = false;

                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);

                    // Don't bring in undefined values
                  } else if (copy !== undefined) {
                    target[name] = copy;
                  }
                }
              }
            }

            // Return the modified object
            return target;
          };

          jQuery.extend({
            // Unique for each copy of jQuery on the page
            expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),

            // Assume jQuery is ready without the ready module
            isReady: true,

            error: function (msg) {
              throw new Error(msg);
            },

            noop: function () {},

            isPlainObject: function (obj) {
              var proto, Ctor;

              // Detect obvious negatives
              // Use toString instead of jQuery.type to catch host objects
              if (!obj || toString.call(obj) !== "[object Object]") {
                return false;
              }

              proto = getProto(obj);

              // Objects with no prototype (e.g., `Object.create( null )`) are plain
              if (!proto) {
                return true;
              }

              // Objects with prototype are plain iff they were constructed by a global Object function
              Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
              return (
                typeof Ctor === "function" &&
                fnToString.call(Ctor) === ObjectFunctionString
              );
            },

            isEmptyObject: function (obj) {
              var name;

              for (name in obj) {
                return false;
              }
              return true;
            },

            // Evaluates a script in a global context
            globalEval: function (code, options) {
              DOMEval(code, { nonce: options && options.nonce });
            },

            each: function (obj, callback) {
              var length,
                i = 0;

              if (isArrayLike(obj)) {
                length = obj.length;
                for (; i < length; i++) {
                  if (callback.call(obj[i], i, obj[i]) === false) {
                    break;
                  }
                }
              } else {
                for (i in obj) {
                  if (callback.call(obj[i], i, obj[i]) === false) {
                    break;
                  }
                }
              }

              return obj;
            },

            // Support: Android <=4.0 only
            trim: function (text) {
              return text == null ? "" : (text + "").replace(rtrim, "");
            },

            // results is for internal usage only
            makeArray: function (arr, results) {
              var ret = results || [];

              if (arr != null) {
                if (isArrayLike(Object(arr))) {
                  jQuery.merge(ret, typeof arr === "string" ? [arr] : arr);
                } else {
                  push.call(ret, arr);
                }
              }

              return ret;
            },

            inArray: function (elem, arr, i) {
              return arr == null ? -1 : indexOf.call(arr, elem, i);
            },

            // Support: Android <=4.0 only, PhantomJS 1 only
            // push.apply(_, arraylike) throws on ancient WebKit
            merge: function (first, second) {
              var len = +second.length,
                j = 0,
                i = first.length;

              for (; j < len; j++) {
                first[i++] = second[j];
              }

              first.length = i;

              return first;
            },

            grep: function (elems, callback, invert) {
              var callbackInverse,
                matches = [],
                i = 0,
                length = elems.length,
                callbackExpect = !invert;

              // Go through the array, only saving the items
              // that pass the validator function
              for (; i < length; i++) {
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) {
                  matches.push(elems[i]);
                }
              }

              return matches;
            },

            // arg is for internal usage only
            map: function (elems, callback, arg) {
              var length,
                value,
                i = 0,
                ret = [];

              // Go through the array, translating each of the items to their new values
              if (isArrayLike(elems)) {
                length = elems.length;
                for (; i < length; i++) {
                  value = callback(elems[i], i, arg);

                  if (value != null) {
                    ret.push(value);
                  }
                }

                // Go through every key on the object,
              } else {
                for (i in elems) {
                  value = callback(elems[i], i, arg);

                  if (value != null) {
                    ret.push(value);
                  }
                }
              }

              // Flatten any nested arrays
              return concat.apply([], ret);
            },

            // A global GUID counter for objects
            guid: 1,

            // jQuery.support is not used in Core but other projects attach their
            // properties to it so it needs to exist.
            support: support,
          });

          if (typeof Symbol === "function") {
            jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
          }

          // Populate the class2type map
          jQuery.each(
            "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
              " "
            ),
            function (i, name) {
              class2type["[object " + name + "]"] = name.toLowerCase();
            }
          );

          function isArrayLike(obj) {
            // Support: real iOS 8.2 only (not reproducible in simulator)
            // `in` check used to prevent JIT error (gh-2145)
            // hasOwn isn't used here due to false negatives
            // regarding Nodelist length in IE
            var length = !!obj && "length" in obj && obj.length,
              type = toType(obj);

            if (isFunction(obj) || isWindow(obj)) {
              return false;
            }

            return (
              type === "array" ||
              length === 0 ||
              (typeof length === "number" && length > 0 && length - 1 in obj)
            );
          }
          var Sizzle =
            /*!
             * Sizzle CSS Selector Engine v2.3.4
             * https://sizzlejs.com/
             *
             * Copyright JS Foundation and other contributors
             * Released under the MIT license
             * https://js.foundation/
             *
             * Date: 2019-04-08
             */
            (function (window) {
              var i,
                support,
                Expr,
                getText,
                isXML,
                tokenize,
                compile,
                select,
                outermostContext,
                sortInput,
                hasDuplicate,
                // Local document vars
                setDocument,
                document,
                docElem,
                documentIsHTML,
                rbuggyQSA,
                rbuggyMatches,
                matches,
                contains,
                // Instance-specific data
                expando = "sizzle" + 1 * new Date(),
                preferredDoc = window.document,
                dirruns = 0,
                done = 0,
                classCache = createCache(),
                tokenCache = createCache(),
                compilerCache = createCache(),
                nonnativeSelectorCache = createCache(),
                sortOrder = function (a, b) {
                  if (a === b) {
                    hasDuplicate = true;
                  }
                  return 0;
                },
                // Instance methods
                hasOwn = {}.hasOwnProperty,
                arr = [],
                pop = arr.pop,
                push_native = arr.push,
                push = arr.push,
                slice = arr.slice,
                // Use a stripped-down indexOf as it's faster than native
                // https://jsperf.com/thor-indexof-vs-for/5
                indexOf = function (list, elem) {
                  var i = 0,
                    len = list.length;
                  for (; i < len; i++) {
                    if (list[i] === elem) {
                      return i;
                    }
                  }
                  return -1;
                },
                booleans =
                  "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                // Regular expressions

                // http://www.w3.org/TR/css3-selectors/#whitespace
                whitespace = "[\\x20\\t\\r\\n\\f]",
                // http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
                identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
                // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
                attributes =
                  "\\[" +
                  whitespace +
                  "*(" +
                  identifier +
                  ")(?:" +
                  whitespace +
                  // Operator (capture 2)
                  "*([*^$|!~]?=)" +
                  whitespace +
                  // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
                  "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
                  identifier +
                  "))|)" +
                  whitespace +
                  "*\\]",
                pseudos =
                  ":(" +
                  identifier +
                  ")(?:\\((" +
                  // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
                  // 1. quoted (capture 3; capture 4 or capture 5)
                  "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
                  // 2. simple (capture 6)
                  "((?:\\\\.|[^\\\\()[\\]]|" +
                  attributes +
                  ")*)|" +
                  // 3. anything else (capture 2)
                  ".*" +
                  ")\\)|)",
                // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
                rwhitespace = new RegExp(whitespace + "+", "g"),
                rtrim = new RegExp(
                  "^" +
                    whitespace +
                    "+|((?:^|[^\\\\])(?:\\\\.)*)" +
                    whitespace +
                    "+$",
                  "g"
                ),
                rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
                rcombinators = new RegExp(
                  "^" +
                    whitespace +
                    "*([>+~]|" +
                    whitespace +
                    ")" +
                    whitespace +
                    "*"
                ),
                rdescend = new RegExp(whitespace + "|>"),
                rpseudo = new RegExp(pseudos),
                ridentifier = new RegExp("^" + identifier + "$"),
                matchExpr = {
                  ID: new RegExp("^#(" + identifier + ")"),
                  CLASS: new RegExp("^\\.(" + identifier + ")"),
                  TAG: new RegExp("^(" + identifier + "|[*])"),
                  ATTR: new RegExp("^" + attributes),
                  PSEUDO: new RegExp("^" + pseudos),
                  CHILD: new RegExp(
                    "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
                      whitespace +
                      "*(even|odd|(([+-]|)(\\d*)n|)" +
                      whitespace +
                      "*(?:([+-]|)" +
                      whitespace +
                      "*(\\d+)|))" +
                      whitespace +
                      "*\\)|)",
                    "i"
                  ),
                  bool: new RegExp("^(?:" + booleans + ")$", "i"),
                  // For use in libraries implementing .is()
                  // We use this for POS matching in `select`
                  needsContext: new RegExp(
                    "^" +
                      whitespace +
                      "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
                      whitespace +
                      "*((?:-\\d)?\\d*)" +
                      whitespace +
                      "*\\)|)(?=[^-]|$)",
                    "i"
                  ),
                },
                rhtml = /HTML$/i,
                rinputs = /^(?:input|select|textarea|button)$/i,
                rheader = /^h\d$/i,
                rnative = /^[^{]+\{\s*\[native \w/,
                // Easily-parseable/retrievable ID or TAG or CLASS selectors
                rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                rsibling = /[+~]/,
                // CSS escapes
                // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
                runescape = new RegExp(
                  "\\\\([\\da-f]{1,6}" +
                    whitespace +
                    "?|(" +
                    whitespace +
                    ")|.)",
                  "ig"
                ),
                funescape = function (_, escaped, escapedWhitespace) {
                  var high = "0x" + escaped - 0x10000;
                  // NaN means non-codepoint
                  // Support: Firefox<24
                  // Workaround erroneous numeric interpretation of +"0x"
                  return high !== high || escapedWhitespace
                    ? escaped
                    : high < 0
                    ? // BMP codepoint
                      String.fromCharCode(high + 0x10000)
                    : // Supplemental Plane codepoint (surrogate pair)
                      String.fromCharCode(
                        (high >> 10) | 0xd800,
                        (high & 0x3ff) | 0xdc00
                      );
                },
                // CSS string/identifier serialization
                // https://drafts.csswg.org/cssom/#common-serializing-idioms
                rcssescape =
                  /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                fcssescape = function (ch, asCodePoint) {
                  if (asCodePoint) {
                    // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
                    if (ch === "\0") {
                      return "\uFFFD";
                    }

                    // Control characters and (dependent upon position) numbers get escaped as code points
                    return (
                      ch.slice(0, -1) +
                      "\\" +
                      ch.charCodeAt(ch.length - 1).toString(16) +
                      " "
                    );
                  }

                  // Other potentially-special ASCII characters get backslash-escaped
                  return "\\" + ch;
                },
                // Used for iframes
                // See setDocument()
                // Removing the function wrapper causes a "Permission Denied"
                // error in IE
                unloadHandler = function () {
                  setDocument();
                },
                inDisabledFieldset = addCombinator(
                  function (elem) {
                    return (
                      elem.disabled === true &&
                      elem.nodeName.toLowerCase() === "fieldset"
                    );
                  },
                  { dir: "parentNode", next: "legend" }
                );

              // Optimize for push.apply( _, NodeList )
              try {
                push.apply(
                  (arr = slice.call(preferredDoc.childNodes)),
                  preferredDoc.childNodes
                );
                // Support: Android<4.0
                // Detect silently failing push.apply
                arr[preferredDoc.childNodes.length].nodeType;
              } catch (e) {
                push = {
                  apply: arr.length
                    ? // Leverage slice if possible
                      function (target, els) {
                        push_native.apply(target, slice.call(els));
                      }
                    : // Support: IE<9
                      // Otherwise append directly
                      function (target, els) {
                        var j = target.length,
                          i = 0;
                        // Can't trust NodeList.length
                        while ((target[j++] = els[i++])) {}
                        target.length = j - 1;
                      },
                };
              }

              function Sizzle(selector, context, results, seed) {
                var m,
                  i,
                  elem,
                  nid,
                  match,
                  groups,
                  newSelector,
                  newContext = context && context.ownerDocument,
                  // nodeType defaults to 9, since context defaults to document
                  nodeType = context ? context.nodeType : 9;

                results = results || [];

                // Return early from calls with invalid selector or context
                if (
                  typeof selector !== "string" ||
                  !selector ||
                  (nodeType !== 1 && nodeType !== 9 && nodeType !== 11)
                ) {
                  return results;
                }

                // Try to shortcut find operations (as opposed to filters) in HTML documents
                if (!seed) {
                  if (
                    (context
                      ? context.ownerDocument || context
                      : preferredDoc) !== document
                  ) {
                    setDocument(context);
                  }
                  context = context || document;

                  if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (
                      nodeType !== 11 &&
                      (match = rquickExpr.exec(selector))
                    ) {
                      // ID selector
                      if ((m = match[1])) {
                        // Document context
                        if (nodeType === 9) {
                          if ((elem = context.getElementById(m))) {
                            // Support: IE, Opera, Webkit
                            // TODO: identify versions
                            // getElementById can match elements by name instead of ID
                            if (elem.id === m) {
                              results.push(elem);
                              return results;
                            }
                          } else {
                            return results;
                          }

                          // Element context
                        } else {
                          // Support: IE, Opera, Webkit
                          // TODO: identify versions
                          // getElementById can match elements by name instead of ID
                          if (
                            newContext &&
                            (elem = newContext.getElementById(m)) &&
                            contains(context, elem) &&
                            elem.id === m
                          ) {
                            results.push(elem);
                            return results;
                          }
                        }

                        // Type selector
                      } else if (match[2]) {
                        push.apply(
                          results,
                          context.getElementsByTagName(selector)
                        );
                        return results;

                        // Class selector
                      } else if (
                        (m = match[3]) &&
                        support.getElementsByClassName &&
                        context.getElementsByClassName
                      ) {
                        push.apply(results, context.getElementsByClassName(m));
                        return results;
                      }
                    }

                    // Take advantage of querySelectorAll
                    if (
                      support.qsa &&
                      !nonnativeSelectorCache[selector + " "] &&
                      (!rbuggyQSA || !rbuggyQSA.test(selector)) &&
                      // Support: IE 8 only
                      // Exclude object elements
                      (nodeType !== 1 ||
                        context.nodeName.toLowerCase() !== "object")
                    ) {
                      newSelector = selector;
                      newContext = context;

                      // qSA considers elements outside a scoping root when evaluating child or
                      // descendant combinators, which is not what we want.
                      // In such cases, we work around the behavior by prefixing every selector in the
                      // list with an ID selector referencing the scope context.
                      // Thanks to Andrew Dupont for this technique.
                      if (nodeType === 1 && rdescend.test(selector)) {
                        // Capture the context ID, setting it first if necessary
                        if ((nid = context.getAttribute("id"))) {
                          nid = nid.replace(rcssescape, fcssescape);
                        } else {
                          context.setAttribute("id", (nid = expando));
                        }

                        // Prefix every selector in the list
                        groups = tokenize(selector);
                        i = groups.length;
                        while (i--) {
                          groups[i] = "#" + nid + " " + toSelector(groups[i]);
                        }
                        newSelector = groups.join(",");

                        // Expand context for sibling selectors
                        newContext =
                          (rsibling.test(selector) &&
                            testContext(context.parentNode)) ||
                          context;
                      }

                      try {
                        push.apply(
                          results,
                          newContext.querySelectorAll(newSelector)
                        );
                        return results;
                      } catch (qsaError) {
                        nonnativeSelectorCache(selector, true);
                      } finally {
                        if (nid === expando) {
                          context.removeAttribute("id");
                        }
                      }
                    }
                  }
                }

                // All others
                return select(
                  selector.replace(rtrim, "$1"),
                  context,
                  results,
                  seed
                );
              }

              /**
               * Create key-value caches of limited size
               * @returns {function(string, object)} Returns the Object data after storing it on itself with
               *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
               *	deleting the oldest entry
               */
              function createCache() {
                var keys = [];

                function cache(key, value) {
                  // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
                  if (keys.push(key + " ") > Expr.cacheLength) {
                    // Only keep the most recent entries
                    delete cache[keys.shift()];
                  }
                  return (cache[key + " "] = value);
                }
                return cache;
              }

              /**
               * Mark a function for special use by Sizzle
               * @param {Function} fn The function to mark
               */
              function markFunction(fn) {
                fn[expando] = true;
                return fn;
              }

              /**
               * Support testing using an element
               * @param {Function} fn Passed the created element and returns a boolean result
               */
              function assert(fn) {
                var el = document.createElement("fieldset");

                try {
                  return !!fn(el);
                } catch (e) {
                  return false;
                } finally {
                  // Remove from its parent by default
                  if (el.parentNode) {
                    el.parentNode.removeChild(el);
                  }
                  // release memory in IE
                  el = null;
                }
              }

              /**
               * Adds the same handler for all of the specified attrs
               * @param {String} attrs Pipe-separated list of attributes
               * @param {Function} handler The method that will be applied
               */
              function addHandle(attrs, handler) {
                var arr = attrs.split("|"),
                  i = arr.length;

                while (i--) {
                  Expr.attrHandle[arr[i]] = handler;
                }
              }

              /**
               * Checks document order of two siblings
               * @param {Element} a
               * @param {Element} b
               * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
               */
              function siblingCheck(a, b) {
                var cur = b && a,
                  diff =
                    cur &&
                    a.nodeType === 1 &&
                    b.nodeType === 1 &&
                    a.sourceIndex - b.sourceIndex;

                // Use IE sourceIndex if available on both nodes
                if (diff) {
                  return diff;
                }

                // Check if b follows a
                if (cur) {
                  while ((cur = cur.nextSibling)) {
                    if (cur === b) {
                      return -1;
                    }
                  }
                }

                return a ? 1 : -1;
              }

              /**
               * Returns a function to use in pseudos for input types
               * @param {String} type
               */
              function createInputPseudo(type) {
                return function (elem) {
                  var name = elem.nodeName.toLowerCase();
                  return name === "input" && elem.type === type;
                };
              }

              /**
               * Returns a function to use in pseudos for buttons
               * @param {String} type
               */
              function createButtonPseudo(type) {
                return function (elem) {
                  var name = elem.nodeName.toLowerCase();
                  return (
                    (name === "input" || name === "button") &&
                    elem.type === type
                  );
                };
              }

              /**
               * Returns a function to use in pseudos for :enabled/:disabled
               * @param {Boolean} disabled true for :disabled; false for :enabled
               */
              function createDisabledPseudo(disabled) {
                // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
                return function (elem) {
                  // Only certain elements can match :enabled or :disabled
                  // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                  // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                  if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                      // Option elements defer to a parent optgroup if present
                      if ("label" in elem) {
                        if ("label" in elem.parentNode) {
                          return elem.parentNode.disabled === disabled;
                        } else {
                          return elem.disabled === disabled;
                        }
                      }

                      // Support: IE 6 - 11
                      // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                      return (
                        elem.isDisabled === disabled ||
                        // Where there is no isDisabled, check manually
                        /* jshint -W018 */
                        (elem.isDisabled !== !disabled &&
                          inDisabledFieldset(elem) === disabled)
                      );
                    }

                    return elem.disabled === disabled;

                    // Try to winnow out elements that can't be disabled before trusting the disabled property.
                    // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                    // even exist on them, let alone have a boolean value.
                  } else if ("label" in elem) {
                    return elem.disabled === disabled;
                  }

                  // Remaining elements are neither :enabled nor :disabled
                  return false;
                };
              }

              /**
               * Returns a function to use in pseudos for positionals
               * @param {Function} fn
               */
              function createPositionalPseudo(fn) {
                return markFunction(function (argument) {
                  argument = +argument;
                  return markFunction(function (seed, matches) {
                    var j,
                      matchIndexes = fn([], seed.length, argument),
                      i = matchIndexes.length;

                    // Match elements found at the specified indexes
                    while (i--) {
                      if (seed[(j = matchIndexes[i])]) {
                        seed[j] = !(matches[j] = seed[j]);
                      }
                    }
                  });
                });
              }

              /**
               * Checks a node for validity as a Sizzle context
               * @param {Element|Object=} context
               * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
               */
              function testContext(context) {
                return (
                  context &&
                  typeof context.getElementsByTagName !== "undefined" &&
                  context
                );
              }

              // Expose support vars for convenience
              support = Sizzle.support = {};

              /**
               * Detects XML nodes
               * @param {Element|Object} elem An element or a document
               * @returns {Boolean} True iff elem is a non-HTML XML node
               */
              isXML = Sizzle.isXML = function (elem) {
                var namespace = elem.namespaceURI,
                  docElem = (elem.ownerDocument || elem).documentElement;

                // Support: IE <=8
                // Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
                // https://bugs.jquery.com/ticket/4833
                return !rhtml.test(
                  namespace || (docElem && docElem.nodeName) || "HTML"
                );
              };

              /**
               * Sets document-related variables once based on the current document
               * @param {Element|Object} [doc] An element or document object to use to set the document
               * @returns {Object} Returns the current document
               */
              setDocument = Sizzle.setDocument = function (node) {
                var hasCompare,
                  subWindow,
                  doc = node ? node.ownerDocument || node : preferredDoc;

                // Return early if doc is invalid or already selected
                if (
                  doc === document ||
                  doc.nodeType !== 9 ||
                  !doc.documentElement
                ) {
                  return document;
                }

                // Update global variables
                document = doc;
                docElem = document.documentElement;
                documentIsHTML = !isXML(document);

                // Support: IE 9-11, Edge
                // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
                if (
                  preferredDoc !== document &&
                  (subWindow = document.defaultView) &&
                  subWindow.top !== subWindow
                ) {
                  // Support: IE 11, Edge
                  if (subWindow.addEventListener) {
                    subWindow.addEventListener("unload", unloadHandler, false);

                    // Support: IE 9 - 10 only
                  } else if (subWindow.attachEvent) {
                    subWindow.attachEvent("onunload", unloadHandler);
                  }
                }

                /* Attributes
	---------------------------------------------------------------------- */

                // Support: IE<8
                // Verify that getAttribute really returns attributes and not properties
                // (excepting IE8 booleans)
                support.attributes = assert(function (el) {
                  el.className = "i";
                  return !el.getAttribute("className");
                });

                /* getElement(s)By*
	---------------------------------------------------------------------- */

                // Check if getElementsByTagName("*") returns only elements
                support.getElementsByTagName = assert(function (el) {
                  el.appendChild(document.createComment(""));
                  return !el.getElementsByTagName("*").length;
                });

                // Support: IE<9
                support.getElementsByClassName = rnative.test(
                  document.getElementsByClassName
                );

                // Support: IE<10
                // Check if getElementById returns elements by name
                // The broken getElementById methods don't pick up programmatically-set names,
                // so use a roundabout getElementsByName test
                support.getById = assert(function (el) {
                  docElem.appendChild(el).id = expando;
                  return (
                    !document.getElementsByName ||
                    !document.getElementsByName(expando).length
                  );
                });

                // ID filter and find
                if (support.getById) {
                  Expr.filter["ID"] = function (id) {
                    var attrId = id.replace(runescape, funescape);
                    return function (elem) {
                      return elem.getAttribute("id") === attrId;
                    };
                  };
                  Expr.find["ID"] = function (id, context) {
                    if (
                      typeof context.getElementById !== "undefined" &&
                      documentIsHTML
                    ) {
                      var elem = context.getElementById(id);
                      return elem ? [elem] : [];
                    }
                  };
                } else {
                  Expr.filter["ID"] = function (id) {
                    var attrId = id.replace(runescape, funescape);
                    return function (elem) {
                      var node =
                        typeof elem.getAttributeNode !== "undefined" &&
                        elem.getAttributeNode("id");
                      return node && node.value === attrId;
                    };
                  };

                  // Support: IE 6 - 7 only
                  // getElementById is not reliable as a find shortcut
                  Expr.find["ID"] = function (id, context) {
                    if (
                      typeof context.getElementById !== "undefined" &&
                      documentIsHTML
                    ) {
                      var node,
                        i,
                        elems,
                        elem = context.getElementById(id);

                      if (elem) {
                        // Verify the id attribute
                        node = elem.getAttributeNode("id");
                        if (node && node.value === id) {
                          return [elem];
                        }

                        // Fall back on getElementsByName
                        elems = context.getElementsByName(id);
                        i = 0;
                        while ((elem = elems[i++])) {
                          node = elem.getAttributeNode("id");
                          if (node && node.value === id) {
                            return [elem];
                          }
                        }
                      }

                      return [];
                    }
                  };
                }

                // Tag
                Expr.find["TAG"] = support.getElementsByTagName
                  ? function (tag, context) {
                      if (typeof context.getElementsByTagName !== "undefined") {
                        return context.getElementsByTagName(tag);

                        // DocumentFragment nodes don't have gEBTN
                      } else if (support.qsa) {
                        return context.querySelectorAll(tag);
                      }
                    }
                  : function (tag, context) {
                      var elem,
                        tmp = [],
                        i = 0,
                        // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
                        results = context.getElementsByTagName(tag);

                      // Filter out possible comments
                      if (tag === "*") {
                        while ((elem = results[i++])) {
                          if (elem.nodeType === 1) {
                            tmp.push(elem);
                          }
                        }

                        return tmp;
                      }
                      return results;
                    };

                // Class
                Expr.find["CLASS"] =
                  support.getElementsByClassName &&
                  function (className, context) {
                    if (
                      typeof context.getElementsByClassName !== "undefined" &&
                      documentIsHTML
                    ) {
                      return context.getElementsByClassName(className);
                    }
                  };

                /* QSA/matchesSelector
	---------------------------------------------------------------------- */

                // QSA and matchesSelector support

                // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
                rbuggyMatches = [];

                // qSa(:focus) reports false when true (Chrome 21)
                // We allow this because of a bug in IE8/9 that throws an error
                // whenever `document.activeElement` is accessed on an iframe
                // So, we allow :focus to pass through QSA all the time to avoid the IE error
                // See https://bugs.jquery.com/ticket/13378
                rbuggyQSA = [];

                if ((support.qsa = rnative.test(document.querySelectorAll))) {
                  // Build QSA regex
                  // Regex strategy adopted from Diego Perini
                  assert(function (el) {
                    // Select is set to empty string on purpose
                    // This is to test IE's treatment of not explicitly
                    // setting a boolean content attribute,
                    // since its presence should be enough
                    // https://bugs.jquery.com/ticket/12359
                    docElem.appendChild(el).innerHTML =
                      "<a id='" +
                      expando +
                      "'></a>" +
                      "<select id='" +
                      expando +
                      "-\r\\' msallowcapture=''>" +
                      "<option selected=''></option></select>";

                    // Support: IE8, Opera 11-12.16
                    // Nothing should be selected when empty strings follow ^= or $= or *=
                    // The test attribute must be unknown in Opera but "safe" for WinRT
                    // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
                    if (el.querySelectorAll("[msallowcapture^='']").length) {
                      rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
                    }

                    // Support: IE8
                    // Boolean attributes and "value" are not treated correctly
                    if (!el.querySelectorAll("[selected]").length) {
                      rbuggyQSA.push(
                        "\\[" + whitespace + "*(?:value|" + booleans + ")"
                      );
                    }

                    // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
                    if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
                      rbuggyQSA.push("~=");
                    }

                    // Webkit/Opera - :checked should return selected option elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    // IE8 throws error here and will not see later tests
                    if (!el.querySelectorAll(":checked").length) {
                      rbuggyQSA.push(":checked");
                    }

                    // Support: Safari 8+, iOS 8+
                    // https://bugs.webkit.org/show_bug.cgi?id=136851
                    // In-page `selector#id sibling-combinator selector` fails
                    if (!el.querySelectorAll("a#" + expando + "+*").length) {
                      rbuggyQSA.push(".#.+[+~]");
                    }
                  });

                  assert(function (el) {
                    el.innerHTML =
                      "<a href='' disabled='disabled'></a>" +
                      "<select disabled='disabled'><option/></select>";

                    // Support: Windows 8 Native Apps
                    // The type and name attributes are restricted during .innerHTML assignment
                    var input = document.createElement("input");
                    input.setAttribute("type", "hidden");
                    el.appendChild(input).setAttribute("name", "D");

                    // Support: IE8
                    // Enforce case-sensitivity of name attribute
                    if (el.querySelectorAll("[name=d]").length) {
                      rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
                    }

                    // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
                    // IE8 throws error here and will not see later tests
                    if (el.querySelectorAll(":enabled").length !== 2) {
                      rbuggyQSA.push(":enabled", ":disabled");
                    }

                    // Support: IE9-11+
                    // IE's :disabled selector does not pick up the children of disabled fieldsets
                    docElem.appendChild(el).disabled = true;
                    if (el.querySelectorAll(":disabled").length !== 2) {
                      rbuggyQSA.push(":enabled", ":disabled");
                    }

                    // Opera 10-11 does not throw on post-comma invalid pseudos
                    el.querySelectorAll("*,:x");
                    rbuggyQSA.push(",.*:");
                  });
                }

                if (
                  (support.matchesSelector = rnative.test(
                    (matches =
                      docElem.matches ||
                      docElem.webkitMatchesSelector ||
                      docElem.mozMatchesSelector ||
                      docElem.oMatchesSelector ||
                      docElem.msMatchesSelector)
                  ))
                ) {
                  assert(function (el) {
                    // Check to see if it's possible to do matchesSelector
                    // on a disconnected node (IE 9)
                    support.disconnectedMatch = matches.call(el, "*");

                    // This should fail with an exception
                    // Gecko does not error, returns false instead
                    matches.call(el, "[s!='']:x");
                    rbuggyMatches.push("!=", pseudos);
                  });
                }

                rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
                rbuggyMatches =
                  rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));

                /* Contains
	---------------------------------------------------------------------- */
                hasCompare = rnative.test(docElem.compareDocumentPosition);

                // Element contains another
                // Purposefully self-exclusive
                // As in, an element does not contain itself
                contains =
                  hasCompare || rnative.test(docElem.contains)
                    ? function (a, b) {
                        var adown = a.nodeType === 9 ? a.documentElement : a,
                          bup = b && b.parentNode;
                        return (
                          a === bup ||
                          !!(
                            bup &&
                            bup.nodeType === 1 &&
                            (adown.contains
                              ? adown.contains(bup)
                              : a.compareDocumentPosition &&
                                a.compareDocumentPosition(bup) & 16)
                          )
                        );
                      }
                    : function (a, b) {
                        if (b) {
                          while ((b = b.parentNode)) {
                            if (b === a) {
                              return true;
                            }
                          }
                        }
                        return false;
                      };

                /* Sorting
	---------------------------------------------------------------------- */

                // Document order sorting
                sortOrder = hasCompare
                  ? function (a, b) {
                      // Flag for duplicate removal
                      if (a === b) {
                        hasDuplicate = true;
                        return 0;
                      }

                      // Sort on method existence if only one input has compareDocumentPosition
                      var compare =
                        !a.compareDocumentPosition - !b.compareDocumentPosition;
                      if (compare) {
                        return compare;
                      }

                      // Calculate position if both inputs belong to the same document
                      compare =
                        (a.ownerDocument || a) === (b.ownerDocument || b)
                          ? a.compareDocumentPosition(b)
                          : // Otherwise we know they are disconnected
                            1;

                      // Disconnected nodes
                      if (
                        compare & 1 ||
                        (!support.sortDetached &&
                          b.compareDocumentPosition(a) === compare)
                      ) {
                        // Choose the first element that is related to our preferred document
                        if (
                          a === document ||
                          (a.ownerDocument === preferredDoc &&
                            contains(preferredDoc, a))
                        ) {
                          return -1;
                        }
                        if (
                          b === document ||
                          (b.ownerDocument === preferredDoc &&
                            contains(preferredDoc, b))
                        ) {
                          return 1;
                        }

                        // Maintain original order
                        return sortInput
                          ? indexOf(sortInput, a) - indexOf(sortInput, b)
                          : 0;
                      }

                      return compare & 4 ? -1 : 1;
                    }
                  : function (a, b) {
                      // Exit early if the nodes are identical
                      if (a === b) {
                        hasDuplicate = true;
                        return 0;
                      }

                      var cur,
                        i = 0,
                        aup = a.parentNode,
                        bup = b.parentNode,
                        ap = [a],
                        bp = [b];

                      // Parentless nodes are either documents or disconnected
                      if (!aup || !bup) {
                        return a === document
                          ? -1
                          : b === document
                          ? 1
                          : aup
                          ? -1
                          : bup
                          ? 1
                          : sortInput
                          ? indexOf(sortInput, a) - indexOf(sortInput, b)
                          : 0;

                        // If the nodes are siblings, we can do a quick check
                      } else if (aup === bup) {
                        return siblingCheck(a, b);
                      }

                      // Otherwise we need full lists of their ancestors for comparison
                      cur = a;
                      while ((cur = cur.parentNode)) {
                        ap.unshift(cur);
                      }
                      cur = b;
                      while ((cur = cur.parentNode)) {
                        bp.unshift(cur);
                      }

                      // Walk down the tree looking for a discrepancy
                      while (ap[i] === bp[i]) {
                        i++;
                      }

                      return i
                        ? // Do a sibling check if the nodes have a common ancestor
                          siblingCheck(ap[i], bp[i])
                        : // Otherwise nodes in our document sort first
                        ap[i] === preferredDoc
                        ? -1
                        : bp[i] === preferredDoc
                        ? 1
                        : 0;
                    };

                return document;
              };

              Sizzle.matches = function (expr, elements) {
                return Sizzle(expr, null, null, elements);
              };

              Sizzle.matchesSelector = function (elem, expr) {
                // Set document vars if needed
                if ((elem.ownerDocument || elem) !== document) {
                  setDocument(elem);
                }

                if (
                  support.matchesSelector &&
                  documentIsHTML &&
                  !nonnativeSelectorCache[expr + " "] &&
                  (!rbuggyMatches || !rbuggyMatches.test(expr)) &&
                  (!rbuggyQSA || !rbuggyQSA.test(expr))
                ) {
                  try {
                    var ret = matches.call(elem, expr);

                    // IE 9's matchesSelector returns false on disconnected nodes
                    if (
                      ret ||
                      support.disconnectedMatch ||
                      // As well, disconnected nodes are said to be in a document
                      // fragment in IE 9
                      (elem.document && elem.document.nodeType !== 11)
                    ) {
                      return ret;
                    }
                  } catch (e) {
                    nonnativeSelectorCache(expr, true);
                  }
                }

                return Sizzle(expr, document, null, [elem]).length > 0;
              };

              Sizzle.contains = function (context, elem) {
                // Set document vars if needed
                if ((context.ownerDocument || context) !== document) {
                  setDocument(context);
                }
                return contains(context, elem);
              };

              Sizzle.attr = function (elem, name) {
                // Set document vars if needed
                if ((elem.ownerDocument || elem) !== document) {
                  setDocument(elem);
                }

                var fn = Expr.attrHandle[name.toLowerCase()],
                  // Don't get fooled by Object.prototype properties (jQuery #13807)
                  val =
                    fn && hasOwn.call(Expr.attrHandle, name.toLowerCase())
                      ? fn(elem, name, !documentIsHTML)
                      : undefined;

                return val !== undefined
                  ? val
                  : support.attributes || !documentIsHTML
                  ? elem.getAttribute(name)
                  : (val = elem.getAttributeNode(name)) && val.specified
                  ? val.value
                  : null;
              };

              Sizzle.escape = function (sel) {
                return (sel + "").replace(rcssescape, fcssescape);
              };

              Sizzle.error = function (msg) {
                throw new Error(
                  "Syntax error, unrecognized expression: " + msg
                );
              };

              /**
               * Document sorting and removing duplicates
               * @param {ArrayLike} results
               */
              Sizzle.uniqueSort = function (results) {
                var elem,
                  duplicates = [],
                  j = 0,
                  i = 0;

                // Unless we *know* we can detect duplicates, assume their presence
                hasDuplicate = !support.detectDuplicates;
                sortInput = !support.sortStable && results.slice(0);
                results.sort(sortOrder);

                if (hasDuplicate) {
                  while ((elem = results[i++])) {
                    if (elem === results[i]) {
                      j = duplicates.push(i);
                    }
                  }
                  while (j--) {
                    results.splice(duplicates[j], 1);
                  }
                }

                // Clear input after sorting to release objects
                // See https://github.com/jquery/sizzle/pull/225
                sortInput = null;

                return results;
              };

              /**
               * Utility function for retrieving the text value of an array of DOM nodes
               * @param {Array|Element} elem
               */
              getText = Sizzle.getText = function (elem) {
                var node,
                  ret = "",
                  i = 0,
                  nodeType = elem.nodeType;

                if (!nodeType) {
                  // If no nodeType, this is expected to be an array
                  while ((node = elem[i++])) {
                    // Do not traverse comment nodes
                    ret += getText(node);
                  }
                } else if (
                  nodeType === 1 ||
                  nodeType === 9 ||
                  nodeType === 11
                ) {
                  // Use textContent for elements
                  // innerText usage removed for consistency of new lines (jQuery #11153)
                  if (typeof elem.textContent === "string") {
                    return elem.textContent;
                  } else {
                    // Traverse its children
                    for (
                      elem = elem.firstChild;
                      elem;
                      elem = elem.nextSibling
                    ) {
                      ret += getText(elem);
                    }
                  }
                } else if (nodeType === 3 || nodeType === 4) {
                  return elem.nodeValue;
                }
                // Do not include comment or processing instruction nodes

                return ret;
              };

              Expr = Sizzle.selectors = {
                // Can be adjusted by the user
                cacheLength: 50,

                createPseudo: markFunction,

                match: matchExpr,

                attrHandle: {},

                find: {},

                relative: {
                  ">": { dir: "parentNode", first: true },
                  " ": { dir: "parentNode" },
                  "+": { dir: "previousSibling", first: true },
                  "~": { dir: "previousSibling" },
                },

                preFilter: {
                  ATTR: function (match) {
                    match[1] = match[1].replace(runescape, funescape);

                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(
                      runescape,
                      funescape
                    );

                    if (match[2] === "~=") {
                      match[3] = " " + match[3] + " ";
                    }

                    return match.slice(0, 4);
                  },

                  CHILD: function (match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
                    match[1] = match[1].toLowerCase();

                    if (match[1].slice(0, 3) === "nth") {
                      // nth-* requires argument
                      if (!match[3]) {
                        Sizzle.error(match[0]);
                      }

                      // numeric x and y parameters for Expr.filter.CHILD
                      // remember that false/true cast respectively to 0/1
                      match[4] = +(match[4]
                        ? match[5] + (match[6] || 1)
                        : 2 * (match[3] === "even" || match[3] === "odd"));
                      match[5] = +(match[7] + match[8] || match[3] === "odd");

                      // other types prohibit arguments
                    } else if (match[3]) {
                      Sizzle.error(match[0]);
                    }

                    return match;
                  },

                  PSEUDO: function (match) {
                    var excess,
                      unquoted = !match[6] && match[2];

                    if (matchExpr["CHILD"].test(match[0])) {
                      return null;
                    }

                    // Accept quoted arguments as-is
                    if (match[3]) {
                      match[2] = match[4] || match[5] || "";

                      // Strip excess characters from unquoted arguments
                    } else if (
                      unquoted &&
                      rpseudo.test(unquoted) &&
                      // Get excess from tokenize (recursively)
                      (excess = tokenize(unquoted, true)) &&
                      // advance to the next closing parenthesis
                      (excess =
                        unquoted.indexOf(")", unquoted.length - excess) -
                        unquoted.length)
                    ) {
                      // excess is a negative index
                      match[0] = match[0].slice(0, excess);
                      match[2] = unquoted.slice(0, excess);
                    }

                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                  },
                },

                filter: {
                  TAG: function (nodeNameSelector) {
                    var nodeName = nodeNameSelector
                      .replace(runescape, funescape)
                      .toLowerCase();
                    return nodeNameSelector === "*"
                      ? function () {
                          return true;
                        }
                      : function (elem) {
                          return (
                            elem.nodeName &&
                            elem.nodeName.toLowerCase() === nodeName
                          );
                        };
                  },

                  CLASS: function (className) {
                    var pattern = classCache[className + " "];

                    return (
                      pattern ||
                      ((pattern = new RegExp(
                        "(^|" +
                          whitespace +
                          ")" +
                          className +
                          "(" +
                          whitespace +
                          "|$)"
                      )) &&
                        classCache(className, function (elem) {
                          return pattern.test(
                            (typeof elem.className === "string" &&
                              elem.className) ||
                              (typeof elem.getAttribute !== "undefined" &&
                                elem.getAttribute("class")) ||
                              ""
                          );
                        }))
                    );
                  },

                  ATTR: function (name, operator, check) {
                    return function (elem) {
                      var result = Sizzle.attr(elem, name);

                      if (result == null) {
                        return operator === "!=";
                      }
                      if (!operator) {
                        return true;
                      }

                      result += "";

                      return operator === "="
                        ? result === check
                        : operator === "!="
                        ? result !== check
                        : operator === "^="
                        ? check && result.indexOf(check) === 0
                        : operator === "*="
                        ? check && result.indexOf(check) > -1
                        : operator === "$="
                        ? check && result.slice(-check.length) === check
                        : operator === "~="
                        ? (
                            " " +
                            result.replace(rwhitespace, " ") +
                            " "
                          ).indexOf(check) > -1
                        : operator === "|="
                        ? result === check ||
                          result.slice(0, check.length + 1) === check + "-"
                        : false;
                    };
                  },

                  CHILD: function (type, what, argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth",
                      forward = type.slice(-4) !== "last",
                      ofType = what === "of-type";

                    return first === 1 && last === 0
                      ? // Shortcut for :nth-*(n)
                        function (elem) {
                          return !!elem.parentNode;
                        }
                      : function (elem, context, xml) {
                          var cache,
                            uniqueCache,
                            outerCache,
                            node,
                            nodeIndex,
                            start,
                            dir =
                              simple !== forward
                                ? "nextSibling"
                                : "previousSibling",
                            parent = elem.parentNode,
                            name = ofType && elem.nodeName.toLowerCase(),
                            useCache = !xml && !ofType,
                            diff = false;

                          if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                              while (dir) {
                                node = elem;
                                while ((node = node[dir])) {
                                  if (
                                    ofType
                                      ? node.nodeName.toLowerCase() === name
                                      : node.nodeType === 1
                                  ) {
                                    return false;
                                  }
                                }
                                // Reverse direction for :only-* (if we haven't yet done so)
                                start = dir =
                                  type === "only" && !start && "nextSibling";
                              }
                              return true;
                            }

                            start = [
                              forward ? parent.firstChild : parent.lastChild,
                            ];

                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                              // Seek `elem` from a previously-cached index

                              // ...in a gzip-friendly way
                              node = parent;
                              outerCache =
                                node[expando] || (node[expando] = {});

                              // Support: IE <9 only
                              // Defend against cloned attroperties (jQuery gh-1709)
                              uniqueCache =
                                outerCache[node.uniqueID] ||
                                (outerCache[node.uniqueID] = {});

                              cache = uniqueCache[type] || [];
                              nodeIndex = cache[0] === dirruns && cache[1];
                              diff = nodeIndex && cache[2];
                              node = nodeIndex && parent.childNodes[nodeIndex];

                              while (
                                (node =
                                  (++nodeIndex && node && node[dir]) ||
                                  // Fallback to seeking `elem` from the start
                                  (diff = nodeIndex = 0) ||
                                  start.pop())
                              ) {
                                // When found, cache indexes on `parent` and break
                                if (
                                  node.nodeType === 1 &&
                                  ++diff &&
                                  node === elem
                                ) {
                                  uniqueCache[type] = [
                                    dirruns,
                                    nodeIndex,
                                    diff,
                                  ];
                                  break;
                                }
                              }
                            } else {
                              // Use previously-cached element index if available
                              if (useCache) {
                                // ...in a gzip-friendly way
                                node = elem;
                                outerCache =
                                  node[expando] || (node[expando] = {});

                                // Support: IE <9 only
                                // Defend against cloned attroperties (jQuery gh-1709)
                                uniqueCache =
                                  outerCache[node.uniqueID] ||
                                  (outerCache[node.uniqueID] = {});

                                cache = uniqueCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex;
                              }

                              // xml :nth-child(...)
                              // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                              if (diff === false) {
                                // Use the same loop as above to seek `elem` from the start
                                while (
                                  (node =
                                    (++nodeIndex && node && node[dir]) ||
                                    (diff = nodeIndex = 0) ||
                                    start.pop())
                                ) {
                                  if (
                                    (ofType
                                      ? node.nodeName.toLowerCase() === name
                                      : node.nodeType === 1) &&
                                    ++diff
                                  ) {
                                    // Cache the index of each encountered element
                                    if (useCache) {
                                      outerCache =
                                        node[expando] || (node[expando] = {});

                                      // Support: IE <9 only
                                      // Defend against cloned attroperties (jQuery gh-1709)
                                      uniqueCache =
                                        outerCache[node.uniqueID] ||
                                        (outerCache[node.uniqueID] = {});

                                      uniqueCache[type] = [dirruns, diff];
                                    }

                                    if (node === elem) {
                                      break;
                                    }
                                  }
                                }
                              }
                            }

                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return (
                              diff === first ||
                              (diff % first === 0 && diff / first >= 0)
                            );
                          }
                        };
                  },

                  PSEUDO: function (pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // http://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args,
                      fn =
                        Expr.pseudos[pseudo] ||
                        Expr.setFilters[pseudo.toLowerCase()] ||
                        Sizzle.error("unsupported pseudo: " + pseudo);

                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as Sizzle does
                    if (fn[expando]) {
                      return fn(argument);
                    }

                    // But maintain support for old signatures
                    if (fn.length > 1) {
                      args = [pseudo, pseudo, "", argument];
                      return Expr.setFilters.hasOwnProperty(
                        pseudo.toLowerCase()
                      )
                        ? markFunction(function (seed, matches) {
                            var idx,
                              matched = fn(seed, argument),
                              i = matched.length;
                            while (i--) {
                              idx = indexOf(seed, matched[i]);
                              seed[idx] = !(matches[idx] = matched[i]);
                            }
                          })
                        : function (elem) {
                            return fn(elem, 0, args);
                          };
                    }

                    return fn;
                  },
                },

                pseudos: {
                  // Potentially complex pseudos
                  not: markFunction(function (selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [],
                      results = [],
                      matcher = compile(selector.replace(rtrim, "$1"));

                    return matcher[expando]
                      ? markFunction(function (seed, matches, context, xml) {
                          var elem,
                            unmatched = matcher(seed, null, xml, []),
                            i = seed.length;

                          // Match elements unmatched by `matcher`
                          while (i--) {
                            if ((elem = unmatched[i])) {
                              seed[i] = !(matches[i] = elem);
                            }
                          }
                        })
                      : function (elem, context, xml) {
                          input[0] = elem;
                          matcher(input, null, xml, results);
                          // Don't keep the element (issue #299)
                          input[0] = null;
                          return !results.pop();
                        };
                  }),

                  has: markFunction(function (selector) {
                    return function (elem) {
                      return Sizzle(selector, elem).length > 0;
                    };
                  }),

                  contains: markFunction(function (text) {
                    text = text.replace(runescape, funescape);
                    return function (elem) {
                      return (
                        (elem.textContent || getText(elem)).indexOf(text) > -1
                      );
                    };
                  }),

                  // "Whether an element is represented by a :lang() selector
                  // is based solely on the element's language value
                  // being equal to the identifier C,
                  // or beginning with the identifier C immediately followed by "-".
                  // The matching of C against the element's language value is performed case-insensitively.
                  // The identifier C does not have to be a valid language name."
                  // http://www.w3.org/TR/selectors/#lang-pseudo
                  lang: markFunction(function (lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) {
                      Sizzle.error("unsupported lang: " + lang);
                    }
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function (elem) {
                      var elemLang;
                      do {
                        if (
                          (elemLang = documentIsHTML
                            ? elem.lang
                            : elem.getAttribute("xml:lang") ||
                              elem.getAttribute("lang"))
                        ) {
                          elemLang = elemLang.toLowerCase();
                          return (
                            elemLang === lang ||
                            elemLang.indexOf(lang + "-") === 0
                          );
                        }
                      } while ((elem = elem.parentNode) && elem.nodeType === 1);
                      return false;
                    };
                  }),

                  // Miscellaneous
                  target: function (elem) {
                    var hash = window.location && window.location.hash;
                    return hash && hash.slice(1) === elem.id;
                  },

                  root: function (elem) {
                    return elem === docElem;
                  },

                  focus: function (elem) {
                    return (
                      elem === document.activeElement &&
                      (!document.hasFocus || document.hasFocus()) &&
                      !!(elem.type || elem.href || ~elem.tabIndex)
                    );
                  },

                  // Boolean properties
                  enabled: createDisabledPseudo(false),
                  disabled: createDisabledPseudo(true),

                  checked: function (elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    var nodeName = elem.nodeName.toLowerCase();
                    return (
                      (nodeName === "input" && !!elem.checked) ||
                      (nodeName === "option" && !!elem.selected)
                    );
                  },

                  selected: function (elem) {
                    // Accessing this property makes selected-by-default
                    // options in Safari work properly
                    if (elem.parentNode) {
                      elem.parentNode.selectedIndex;
                    }

                    return elem.selected === true;
                  },

                  // Contents
                  empty: function (elem) {
                    // http://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for (
                      elem = elem.firstChild;
                      elem;
                      elem = elem.nextSibling
                    ) {
                      if (elem.nodeType < 6) {
                        return false;
                      }
                    }
                    return true;
                  },

                  parent: function (elem) {
                    return !Expr.pseudos["empty"](elem);
                  },

                  // Element/input types
                  header: function (elem) {
                    return rheader.test(elem.nodeName);
                  },

                  input: function (elem) {
                    return rinputs.test(elem.nodeName);
                  },

                  button: function (elem) {
                    var name = elem.nodeName.toLowerCase();
                    return (
                      (name === "input" && elem.type === "button") ||
                      name === "button"
                    );
                  },

                  text: function (elem) {
                    var attr;
                    return (
                      elem.nodeName.toLowerCase() === "input" &&
                      elem.type === "text" &&
                      // Support: IE<8
                      // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                      ((attr = elem.getAttribute("type")) == null ||
                        attr.toLowerCase() === "text")
                    );
                  },

                  // Position-in-collection
                  first: createPositionalPseudo(function () {
                    return [0];
                  }),

                  last: createPositionalPseudo(function (matchIndexes, length) {
                    return [length - 1];
                  }),

                  eq: createPositionalPseudo(function (
                    matchIndexes,
                    length,
                    argument
                  ) {
                    return [argument < 0 ? argument + length : argument];
                  }),

                  even: createPositionalPseudo(function (matchIndexes, length) {
                    var i = 0;
                    for (; i < length; i += 2) {
                      matchIndexes.push(i);
                    }
                    return matchIndexes;
                  }),

                  odd: createPositionalPseudo(function (matchIndexes, length) {
                    var i = 1;
                    for (; i < length; i += 2) {
                      matchIndexes.push(i);
                    }
                    return matchIndexes;
                  }),

                  lt: createPositionalPseudo(function (
                    matchIndexes,
                    length,
                    argument
                  ) {
                    var i =
                      argument < 0
                        ? argument + length
                        : argument > length
                        ? length
                        : argument;
                    for (; --i >= 0; ) {
                      matchIndexes.push(i);
                    }
                    return matchIndexes;
                  }),

                  gt: createPositionalPseudo(function (
                    matchIndexes,
                    length,
                    argument
                  ) {
                    var i = argument < 0 ? argument + length : argument;
                    for (; ++i < length; ) {
                      matchIndexes.push(i);
                    }
                    return matchIndexes;
                  }),
                },
              };

              Expr.pseudos["nth"] = Expr.pseudos["eq"];

              // Add button/input type pseudos
              for (i in {
                radio: true,
                checkbox: true,
                file: true,
                password: true,
                image: true,
              }) {
                Expr.pseudos[i] = createInputPseudo(i);
              }
              for (i in { submit: true, reset: true }) {
                Expr.pseudos[i] = createButtonPseudo(i);
              }

              // Easy API for creating new setFilters
              function setFilters() {}
              setFilters.prototype = Expr.filters = Expr.pseudos;
              Expr.setFilters = new setFilters();

              tokenize = Sizzle.tokenize = function (selector, parseOnly) {
                var matched,
                  match,
                  tokens,
                  type,
                  soFar,
                  groups,
                  preFilters,
                  cached = tokenCache[selector + " "];

                if (cached) {
                  return parseOnly ? 0 : cached.slice(0);
                }

                soFar = selector;
                groups = [];
                preFilters = Expr.preFilter;

                while (soFar) {
                  // Comma and first run
                  if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) {
                      // Don't consume trailing commas as valid
                      soFar = soFar.slice(match[0].length) || soFar;
                    }
                    groups.push((tokens = []));
                  }

                  matched = false;

                  // Combinators
                  if ((match = rcombinators.exec(soFar))) {
                    matched = match.shift();
                    tokens.push({
                      value: matched,
                      // Cast descendant combinators to space
                      type: match[0].replace(rtrim, " "),
                    });
                    soFar = soFar.slice(matched.length);
                  }

                  // Filters
                  for (type in Expr.filter) {
                    if (
                      (match = matchExpr[type].exec(soFar)) &&
                      (!preFilters[type] || (match = preFilters[type](match)))
                    ) {
                      matched = match.shift();
                      tokens.push({
                        value: matched,
                        type: type,
                        matches: match,
                      });
                      soFar = soFar.slice(matched.length);
                    }
                  }

                  if (!matched) {
                    break;
                  }
                }

                // Return the length of the invalid excess
                // if we're just parsing
                // Otherwise, throw an error or return tokens
                return parseOnly
                  ? soFar.length
                  : soFar
                  ? Sizzle.error(selector)
                  : // Cache the tokens
                    tokenCache(selector, groups).slice(0);
              };

              function toSelector(tokens) {
                var i = 0,
                  len = tokens.length,
                  selector = "";
                for (; i < len; i++) {
                  selector += tokens[i].value;
                }
                return selector;
              }

              function addCombinator(matcher, combinator, base) {
                var dir = combinator.dir,
                  skip = combinator.next,
                  key = skip || dir,
                  checkNonElements = base && key === "parentNode",
                  doneName = done++;

                return combinator.first
                  ? // Check against closest ancestor/preceding element
                    function (elem, context, xml) {
                      while ((elem = elem[dir])) {
                        if (elem.nodeType === 1 || checkNonElements) {
                          return matcher(elem, context, xml);
                        }
                      }
                      return false;
                    }
                  : // Check against all ancestor/preceding elements
                    function (elem, context, xml) {
                      var oldCache,
                        uniqueCache,
                        outerCache,
                        newCache = [dirruns, doneName];

                      // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                      if (xml) {
                        while ((elem = elem[dir])) {
                          if (elem.nodeType === 1 || checkNonElements) {
                            if (matcher(elem, context, xml)) {
                              return true;
                            }
                          }
                        }
                      } else {
                        while ((elem = elem[dir])) {
                          if (elem.nodeType === 1 || checkNonElements) {
                            outerCache = elem[expando] || (elem[expando] = {});

                            // Support: IE <9 only
                            // Defend against cloned attroperties (jQuery gh-1709)
                            uniqueCache =
                              outerCache[elem.uniqueID] ||
                              (outerCache[elem.uniqueID] = {});

                            if (skip && skip === elem.nodeName.toLowerCase()) {
                              elem = elem[dir] || elem;
                            } else if (
                              (oldCache = uniqueCache[key]) &&
                              oldCache[0] === dirruns &&
                              oldCache[1] === doneName
                            ) {
                              // Assign to newCache so results back-propagate to previous elements
                              return (newCache[2] = oldCache[2]);
                            } else {
                              // Reuse newcache so results back-propagate to previous elements
                              uniqueCache[key] = newCache;

                              // A match means we're done; a fail means we have to keep checking
                              if ((newCache[2] = matcher(elem, context, xml))) {
                                return true;
                              }
                            }
                          }
                        }
                      }
                      return false;
                    };
              }

              function elementMatcher(matchers) {
                return matchers.length > 1
                  ? function (elem, context, xml) {
                      var i = matchers.length;
                      while (i--) {
                        if (!matchers[i](elem, context, xml)) {
                          return false;
                        }
                      }
                      return true;
                    }
                  : matchers[0];
              }

              function multipleContexts(selector, contexts, results) {
                var i = 0,
                  len = contexts.length;
                for (; i < len; i++) {
                  Sizzle(selector, contexts[i], results);
                }
                return results;
              }

              function condense(unmatched, map, filter, context, xml) {
                var elem,
                  newUnmatched = [],
                  i = 0,
                  len = unmatched.length,
                  mapped = map != null;

                for (; i < len; i++) {
                  if ((elem = unmatched[i])) {
                    if (!filter || filter(elem, context, xml)) {
                      newUnmatched.push(elem);
                      if (mapped) {
                        map.push(i);
                      }
                    }
                  }
                }

                return newUnmatched;
              }

              function setMatcher(
                preFilter,
                selector,
                matcher,
                postFilter,
                postFinder,
                postSelector
              ) {
                if (postFilter && !postFilter[expando]) {
                  postFilter = setMatcher(postFilter);
                }
                if (postFinder && !postFinder[expando]) {
                  postFinder = setMatcher(postFinder, postSelector);
                }
                return markFunction(function (seed, results, context, xml) {
                  var temp,
                    i,
                    elem,
                    preMap = [],
                    postMap = [],
                    preexisting = results.length,
                    // Get initial elements from seed or context
                    elems =
                      seed ||
                      multipleContexts(
                        selector || "*",
                        context.nodeType ? [context] : context,
                        []
                      ),
                    // Prefilter to get matcher input, preserving a map for seed-results synchronization
                    matcherIn =
                      preFilter && (seed || !selector)
                        ? condense(elems, preMap, preFilter, context, xml)
                        : elems,
                    matcherOut = matcher
                      ? // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                        postFinder ||
                        (seed ? preFilter : preexisting || postFilter)
                        ? // ...intermediate processing is necessary
                          []
                        : // ...otherwise use results directly
                          results
                      : matcherIn;

                  // Find primary matches
                  if (matcher) {
                    matcher(matcherIn, matcherOut, context, xml);
                  }

                  // Apply postFilter
                  if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);

                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while (i--) {
                      if ((elem = temp[i])) {
                        matcherOut[postMap[i]] = !(matcherIn[postMap[i]] =
                          elem);
                      }
                    }
                  }

                  if (seed) {
                    if (postFinder || preFilter) {
                      if (postFinder) {
                        // Get the final matcherOut by condensing this intermediate into postFinder contexts
                        temp = [];
                        i = matcherOut.length;
                        while (i--) {
                          if ((elem = matcherOut[i])) {
                            // Restore matcherIn since elem is not yet a final match
                            temp.push((matcherIn[i] = elem));
                          }
                        }
                        postFinder(null, (matcherOut = []), temp, xml);
                      }

                      // Move matched elements from seed to results to keep them synchronized
                      i = matcherOut.length;
                      while (i--) {
                        if (
                          (elem = matcherOut[i]) &&
                          (temp = postFinder
                            ? indexOf(seed, elem)
                            : preMap[i]) > -1
                        ) {
                          seed[temp] = !(results[temp] = elem);
                        }
                      }
                    }

                    // Add elements to results, through postFinder if defined
                  } else {
                    matcherOut = condense(
                      matcherOut === results
                        ? matcherOut.splice(preexisting, matcherOut.length)
                        : matcherOut
                    );
                    if (postFinder) {
                      postFinder(null, results, matcherOut, xml);
                    } else {
                      push.apply(results, matcherOut);
                    }
                  }
                });
              }

              function matcherFromTokens(tokens) {
                var checkContext,
                  matcher,
                  j,
                  len = tokens.length,
                  leadingRelative = Expr.relative[tokens[0].type],
                  implicitRelative = leadingRelative || Expr.relative[" "],
                  i = leadingRelative ? 1 : 0,
                  // The foundational matcher ensures that elements are reachable from top-level context(s)
                  matchContext = addCombinator(
                    function (elem) {
                      return elem === checkContext;
                    },
                    implicitRelative,
                    true
                  ),
                  matchAnyContext = addCombinator(
                    function (elem) {
                      return indexOf(checkContext, elem) > -1;
                    },
                    implicitRelative,
                    true
                  ),
                  matchers = [
                    function (elem, context, xml) {
                      var ret =
                        (!leadingRelative &&
                          (xml || context !== outermostContext)) ||
                        ((checkContext = context).nodeType
                          ? matchContext(elem, context, xml)
                          : matchAnyContext(elem, context, xml));
                      // Avoid hanging onto element (issue #299)
                      checkContext = null;
                      return ret;
                    },
                  ];

                for (; i < len; i++) {
                  if ((matcher = Expr.relative[tokens[i].type])) {
                    matchers = [
                      addCombinator(elementMatcher(matchers), matcher),
                    ];
                  } else {
                    matcher = Expr.filter[tokens[i].type].apply(
                      null,
                      tokens[i].matches
                    );

                    // Return special upon seeing a positional matcher
                    if (matcher[expando]) {
                      // Find the next relative operator (if any) for proper handling
                      j = ++i;
                      for (; j < len; j++) {
                        if (Expr.relative[tokens[j].type]) {
                          break;
                        }
                      }
                      return setMatcher(
                        i > 1 && elementMatcher(matchers),
                        i > 1 &&
                          toSelector(
                            // If the preceding token was a descendant combinator, insert an implicit any-element `*`
                            tokens
                              .slice(0, i - 1)
                              .concat({
                                value: tokens[i - 2].type === " " ? "*" : "",
                              })
                          ).replace(rtrim, "$1"),
                        matcher,
                        i < j && matcherFromTokens(tokens.slice(i, j)),
                        j < len &&
                          matcherFromTokens((tokens = tokens.slice(j))),
                        j < len && toSelector(tokens)
                      );
                    }
                    matchers.push(matcher);
                  }
                }

                return elementMatcher(matchers);
              }

              function matcherFromGroupMatchers(elementMatchers, setMatchers) {
                var bySet = setMatchers.length > 0,
                  byElement = elementMatchers.length > 0,
                  superMatcher = function (
                    seed,
                    context,
                    xml,
                    results,
                    outermost
                  ) {
                    var elem,
                      j,
                      matcher,
                      matchedCount = 0,
                      i = "0",
                      unmatched = seed && [],
                      setMatched = [],
                      contextBackup = outermostContext,
                      // We must always have either seed elements or outermost context
                      elems =
                        seed || (byElement && Expr.find["TAG"]("*", outermost)),
                      // Use integer dirruns iff this is the outermost matcher
                      dirrunsUnique = (dirruns +=
                        contextBackup == null ? 1 : Math.random() || 0.1),
                      len = elems.length;

                    if (outermost) {
                      outermostContext =
                        context === document || context || outermost;
                    }

                    // Add elements passing elementMatchers directly to results
                    // Support: IE<9, Safari
                    // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
                    for (; i !== len && (elem = elems[i]) != null; i++) {
                      if (byElement && elem) {
                        j = 0;
                        if (!context && elem.ownerDocument !== document) {
                          setDocument(elem);
                          xml = !documentIsHTML;
                        }
                        while ((matcher = elementMatchers[j++])) {
                          if (matcher(elem, context || document, xml)) {
                            results.push(elem);
                            break;
                          }
                        }
                        if (outermost) {
                          dirruns = dirrunsUnique;
                        }
                      }

                      // Track unmatched elements for set filters
                      if (bySet) {
                        // They will have gone through all possible matchers
                        if ((elem = !matcher && elem)) {
                          matchedCount--;
                        }

                        // Lengthen the array for every element, matched or not
                        if (seed) {
                          unmatched.push(elem);
                        }
                      }
                    }

                    // `i` is now the count of elements visited above, and adding it to `matchedCount`
                    // makes the latter nonnegative.
                    matchedCount += i;

                    // Apply set filters to unmatched elements
                    // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                    // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                    // no element matchers and no seed.
                    // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                    // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                    // numerically zero.
                    if (bySet && i !== matchedCount) {
                      j = 0;
                      while ((matcher = setMatchers[j++])) {
                        matcher(unmatched, setMatched, context, xml);
                      }

                      if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                          while (i--) {
                            if (!(unmatched[i] || setMatched[i])) {
                              setMatched[i] = pop.call(results);
                            }
                          }
                        }

                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                      }

                      // Add matches to results
                      push.apply(results, setMatched);

                      // Seedless set matches succeeding multiple successful matchers stipulate sorting
                      if (
                        outermost &&
                        !seed &&
                        setMatched.length > 0 &&
                        matchedCount + setMatchers.length > 1
                      ) {
                        Sizzle.uniqueSort(results);
                      }
                    }

                    // Override manipulation of globals by nested matchers
                    if (outermost) {
                      dirruns = dirrunsUnique;
                      outermostContext = contextBackup;
                    }

                    return unmatched;
                  };

                return bySet ? markFunction(superMatcher) : superMatcher;
              }

              compile = Sizzle.compile = function (
                selector,
                match /* Internal Use Only */
              ) {
                var i,
                  setMatchers = [],
                  elementMatchers = [],
                  cached = compilerCache[selector + " "];

                if (!cached) {
                  // Generate a function of recursive functions that can be used to check each element
                  if (!match) {
                    match = tokenize(selector);
                  }
                  i = match.length;
                  while (i--) {
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) {
                      setMatchers.push(cached);
                    } else {
                      elementMatchers.push(cached);
                    }
                  }

                  // Cache the compiled function
                  cached = compilerCache(
                    selector,
                    matcherFromGroupMatchers(elementMatchers, setMatchers)
                  );

                  // Save selector and tokenization
                  cached.selector = selector;
                }
                return cached;
              };

              /**
               * A low-level selection function that works with Sizzle's compiled
               *  selector functions
               * @param {String|Function} selector A selector or a pre-compiled
               *  selector function built with Sizzle.compile
               * @param {Element} context
               * @param {Array} [results]
               * @param {Array} [seed] A set of elements to match against
               */
              select = Sizzle.select = function (
                selector,
                context,
                results,
                seed
              ) {
                var i,
                  tokens,
                  token,
                  type,
                  find,
                  compiled = typeof selector === "function" && selector,
                  match =
                    !seed &&
                    tokenize((selector = compiled.selector || selector));

                results = results || [];

                // Try to minimize operations if there is only one selector in the list and no seed
                // (the latter of which guarantees us context)
                if (match.length === 1) {
                  // Reduce context if the leading compound selector is an ID
                  tokens = match[0] = match[0].slice(0);
                  if (
                    tokens.length > 2 &&
                    (token = tokens[0]).type === "ID" &&
                    context.nodeType === 9 &&
                    documentIsHTML &&
                    Expr.relative[tokens[1].type]
                  ) {
                    context = (Expr.find["ID"](
                      token.matches[0].replace(runescape, funescape),
                      context
                    ) || [])[0];
                    if (!context) {
                      return results;

                      // Precompiled matchers will still verify ancestry, so step up a level
                    } else if (compiled) {
                      context = context.parentNode;
                    }

                    selector = selector.slice(tokens.shift().value.length);
                  }

                  // Fetch a seed set for right-to-left matching
                  i = matchExpr["needsContext"].test(selector)
                    ? 0
                    : tokens.length;
                  while (i--) {
                    token = tokens[i];

                    // Abort if we hit a combinator
                    if (Expr.relative[(type = token.type)]) {
                      break;
                    }
                    if ((find = Expr.find[type])) {
                      // Search, expanding context for leading sibling combinators
                      if (
                        (seed = find(
                          token.matches[0].replace(runescape, funescape),
                          (rsibling.test(tokens[0].type) &&
                            testContext(context.parentNode)) ||
                            context
                        ))
                      ) {
                        // If seed is empty or no tokens remain, we can return early
                        tokens.splice(i, 1);
                        selector = seed.length && toSelector(tokens);
                        if (!selector) {
                          push.apply(results, seed);
                          return results;
                        }

                        break;
                      }
                    }
                  }
                }

                // Compile and execute a filtering function if one is not provided
                // Provide `match` to avoid retokenization if we modified the selector above
                (compiled || compile(selector, match))(
                  seed,
                  context,
                  !documentIsHTML,
                  results,
                  !context ||
                    (rsibling.test(selector) &&
                      testContext(context.parentNode)) ||
                    context
                );
                return results;
              };

              // One-time assignments

              // Sort stability
              support.sortStable =
                expando.split("").sort(sortOrder).join("") === expando;

              // Support: Chrome 14-35+
              // Always assume duplicates if they aren't passed to the comparison function
              support.detectDuplicates = !!hasDuplicate;

              // Initialize against the default document
              setDocument();

              // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
              // Detached nodes confoundingly follow *each other*
              support.sortDetached = assert(function (el) {
                // Should return 1, but returns 4 (following)
                return (
                  el.compareDocumentPosition(
                    document.createElement("fieldset")
                  ) & 1
                );
              });

              // Support: IE<8
              // Prevent attribute/property "interpolation"
              // https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
              if (
                !assert(function (el) {
                  el.innerHTML = "<a href='#'></a>";
                  return el.firstChild.getAttribute("href") === "#";
                })
              ) {
                addHandle(
                  "type|href|height|width",
                  function (elem, name, isXML) {
                    if (!isXML) {
                      return elem.getAttribute(
                        name,
                        name.toLowerCase() === "type" ? 1 : 2
                      );
                    }
                  }
                );
              }

              // Support: IE<9
              // Use defaultValue in place of getAttribute("value")
              if (
                !support.attributes ||
                !assert(function (el) {
                  el.innerHTML = "<input/>";
                  el.firstChild.setAttribute("value", "");
                  return el.firstChild.getAttribute("value") === "";
                })
              ) {
                addHandle("value", function (elem, name, isXML) {
                  if (!isXML && elem.nodeName.toLowerCase() === "input") {
                    return elem.defaultValue;
                  }
                });
              }

              // Support: IE<9
              // Use getAttributeNode to fetch booleans when getAttribute lies
              if (
                !assert(function (el) {
                  return el.getAttribute("disabled") == null;
                })
              ) {
                addHandle(booleans, function (elem, name, isXML) {
                  var val;
                  if (!isXML) {
                    return elem[name] === true
                      ? name.toLowerCase()
                      : (val = elem.getAttributeNode(name)) && val.specified
                      ? val.value
                      : null;
                  }
                });
              }

              return Sizzle;
            })(window);

          jQuery.find = Sizzle;
          jQuery.expr = Sizzle.selectors;

          // Deprecated
          jQuery.expr[":"] = jQuery.expr.pseudos;
          jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
          jQuery.text = Sizzle.getText;
          jQuery.isXMLDoc = Sizzle.isXML;
          jQuery.contains = Sizzle.contains;
          jQuery.escapeSelector = Sizzle.escape;

          var dir = function (elem, dir, until) {
            var matched = [],
              truncate = until !== undefined;

            while ((elem = elem[dir]) && elem.nodeType !== 9) {
              if (elem.nodeType === 1) {
                if (truncate && jQuery(elem).is(until)) {
                  break;
                }
                matched.push(elem);
              }
            }
            return matched;
          };

          var siblings = function (n, elem) {
            var matched = [];

            for (; n; n = n.nextSibling) {
              if (n.nodeType === 1 && n !== elem) {
                matched.push(n);
              }
            }

            return matched;
          };

          var rneedsContext = jQuery.expr.match.needsContext;

          function nodeName(elem, name) {
            return (
              elem.nodeName &&
              elem.nodeName.toLowerCase() === name.toLowerCase()
            );
          }
          var rsingleTag =
            /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

          // Implement the identical functionality for filter and not
          function winnow(elements, qualifier, not) {
            if (isFunction(qualifier)) {
              return jQuery.grep(elements, function (elem, i) {
                return !!qualifier.call(elem, i, elem) !== not;
              });
            }

            // Single element
            if (qualifier.nodeType) {
              return jQuery.grep(elements, function (elem) {
                return (elem === qualifier) !== not;
              });
            }

            // Arraylike of elements (jQuery, arguments, Array)
            if (typeof qualifier !== "string") {
              return jQuery.grep(elements, function (elem) {
                return indexOf.call(qualifier, elem) > -1 !== not;
              });
            }

            // Filtered directly for both simple and complex selectors
            return jQuery.filter(qualifier, elements, not);
          }

          jQuery.filter = function (expr, elems, not) {
            var elem = elems[0];

            if (not) {
              expr = ":not(" + expr + ")";
            }

            if (elems.length === 1 && elem.nodeType === 1) {
              return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
            }

            return jQuery.find.matches(
              expr,
              jQuery.grep(elems, function (elem) {
                return elem.nodeType === 1;
              })
            );
          };

          jQuery.fn.extend({
            find: function (selector) {
              var i,
                ret,
                len = this.length,
                self = this;

              if (typeof selector !== "string") {
                return this.pushStack(
                  jQuery(selector).filter(function () {
                    for (i = 0; i < len; i++) {
                      if (jQuery.contains(self[i], this)) {
                        return true;
                      }
                    }
                  })
                );
              }

              ret = this.pushStack([]);

              for (i = 0; i < len; i++) {
                jQuery.find(selector, self[i], ret);
              }

              return len > 1 ? jQuery.uniqueSort(ret) : ret;
            },
            filter: function (selector) {
              return this.pushStack(winnow(this, selector || [], false));
            },
            not: function (selector) {
              return this.pushStack(winnow(this, selector || [], true));
            },
            is: function (selector) {
              return !!winnow(
                this,

                // If this is a positional/relative selector, check membership in the returned set
                // so $("p:first").is("p:last") won't return true for a doc with two "p".
                typeof selector === "string" && rneedsContext.test(selector)
                  ? jQuery(selector)
                  : selector || [],
                false
              ).length;
            },
          });

          // Initialize a jQuery object

          // A central reference to the root jQuery(document)
          var rootjQuery,
            // A simple way to check for HTML strings
            // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
            // Strict HTML recognition (#11290: must start with <)
            // Shortcut simple #id case for speed
            rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
            init = (jQuery.fn.init = function (selector, context, root) {
              var match, elem;

              // HANDLE: $(""), $(null), $(undefined), $(false)
              if (!selector) {
                return this;
              }

              // Method init() accepts an alternate rootjQuery
              // so migrate can support jQuery.sub (gh-2101)
              root = root || rootjQuery;

              // Handle HTML strings
              if (typeof selector === "string") {
                if (
                  selector[0] === "<" &&
                  selector[selector.length - 1] === ">" &&
                  selector.length >= 3
                ) {
                  // Assume that strings that start and end with <> are HTML and skip the regex check
                  match = [null, selector, null];
                } else {
                  match = rquickExpr.exec(selector);
                }

                // Match html or make sure no context is specified for #id
                if (match && (match[1] || !context)) {
                  // HANDLE: $(html) -> $(array)
                  if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;

                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(
                      this,
                      jQuery.parseHTML(
                        match[1],
                        context && context.nodeType
                          ? context.ownerDocument || context
                          : document,
                        true
                      )
                    );

                    // HANDLE: $(html, props)
                    if (
                      rsingleTag.test(match[1]) &&
                      jQuery.isPlainObject(context)
                    ) {
                      for (match in context) {
                        // Properties of context are called as methods if possible
                        if (isFunction(this[match])) {
                          this[match](context[match]);

                          // ...and otherwise set as attributes
                        } else {
                          this.attr(match, context[match]);
                        }
                      }
                    }

                    return this;

                    // HANDLE: $(#id)
                  } else {
                    elem = document.getElementById(match[2]);

                    if (elem) {
                      // Inject the element directly into the jQuery object
                      this[0] = elem;
                      this.length = 1;
                    }
                    return this;
                  }

                  // HANDLE: $(expr, $(...))
                } else if (!context || context.jquery) {
                  return (context || root).find(selector);

                  // HANDLE: $(expr, context)
                  // (which is just equivalent to: $(context).find(expr)
                } else {
                  return this.constructor(context).find(selector);
                }

                // HANDLE: $(DOMElement)
              } else if (selector.nodeType) {
                this[0] = selector;
                this.length = 1;
                return this;

                // HANDLE: $(function)
                // Shortcut for document ready
              } else if (isFunction(selector)) {
                return root.ready !== undefined
                  ? root.ready(selector)
                  : // Execute immediately if ready is not present
                    selector(jQuery);
              }

              return jQuery.makeArray(selector, this);
            });

          // Give the init function the jQuery prototype for later instantiation
          init.prototype = jQuery.fn;

          // Initialize central reference
          rootjQuery = jQuery(document);

          var rparentsprev = /^(?:parents|prev(?:Until|All))/,
            // Methods guaranteed to produce a unique set when starting from a unique set
            guaranteedUnique = {
              children: true,
              contents: true,
              next: true,
              prev: true,
            };

          jQuery.fn.extend({
            has: function (target) {
              var targets = jQuery(target, this),
                l = targets.length;

              return this.filter(function () {
                var i = 0;
                for (; i < l; i++) {
                  if (jQuery.contains(this, targets[i])) {
                    return true;
                  }
                }
              });
            },

            closest: function (selectors, context) {
              var cur,
                i = 0,
                l = this.length,
                matched = [],
                targets = typeof selectors !== "string" && jQuery(selectors);

              // Positional selectors never match, since there's no _selection_ context
              if (!rneedsContext.test(selectors)) {
                for (; i < l; i++) {
                  for (
                    cur = this[i];
                    cur && cur !== context;
                    cur = cur.parentNode
                  ) {
                    // Always skip document fragments
                    if (
                      cur.nodeType < 11 &&
                      (targets
                        ? targets.index(cur) > -1
                        : // Don't pass non-elements to Sizzle
                          cur.nodeType === 1 &&
                          jQuery.find.matchesSelector(cur, selectors))
                    ) {
                      matched.push(cur);
                      break;
                    }
                  }
                }
              }

              return this.pushStack(
                matched.length > 1 ? jQuery.uniqueSort(matched) : matched
              );
            },

            // Determine the position of an element within the set
            index: function (elem) {
              // No argument, return index in parent
              if (!elem) {
                return this[0] && this[0].parentNode
                  ? this.first().prevAll().length
                  : -1;
              }

              // Index in selector
              if (typeof elem === "string") {
                return indexOf.call(jQuery(elem), this[0]);
              }

              // Locate the position of the desired element
              return indexOf.call(
                this,

                // If it receives a jQuery object, the first element is used
                elem.jquery ? elem[0] : elem
              );
            },

            add: function (selector, context) {
              return this.pushStack(
                jQuery.uniqueSort(
                  jQuery.merge(this.get(), jQuery(selector, context))
                )
              );
            },

            addBack: function (selector) {
              return this.add(
                selector == null
                  ? this.prevObject
                  : this.prevObject.filter(selector)
              );
            },
          });

          function sibling(cur, dir) {
            while ((cur = cur[dir]) && cur.nodeType !== 1) {}
            return cur;
          }

          jQuery.each(
            {
              parent: function (elem) {
                var parent = elem.parentNode;
                return parent && parent.nodeType !== 11 ? parent : null;
              },
              parents: function (elem) {
                return dir(elem, "parentNode");
              },
              parentsUntil: function (elem, i, until) {
                return dir(elem, "parentNode", until);
              },
              next: function (elem) {
                return sibling(elem, "nextSibling");
              },
              prev: function (elem) {
                return sibling(elem, "previousSibling");
              },
              nextAll: function (elem) {
                return dir(elem, "nextSibling");
              },
              prevAll: function (elem) {
                return dir(elem, "previousSibling");
              },
              nextUntil: function (elem, i, until) {
                return dir(elem, "nextSibling", until);
              },
              prevUntil: function (elem, i, until) {
                return dir(elem, "previousSibling", until);
              },
              siblings: function (elem) {
                return siblings((elem.parentNode || {}).firstChild, elem);
              },
              children: function (elem) {
                return siblings(elem.firstChild);
              },
              contents: function (elem) {
                if (typeof elem.contentDocument !== "undefined") {
                  return elem.contentDocument;
                }

                // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
                // Treat the template element as a regular one in browsers that
                // don't support it.
                if (nodeName(elem, "template")) {
                  elem = elem.content || elem;
                }

                return jQuery.merge([], elem.childNodes);
              },
            },
            function (name, fn) {
              jQuery.fn[name] = function (until, selector) {
                var matched = jQuery.map(this, fn, until);

                if (name.slice(-5) !== "Until") {
                  selector = until;
                }

                if (selector && typeof selector === "string") {
                  matched = jQuery.filter(selector, matched);
                }

                if (this.length > 1) {
                  // Remove duplicates
                  if (!guaranteedUnique[name]) {
                    jQuery.uniqueSort(matched);
                  }

                  // Reverse order for parents* and prev-derivatives
                  if (rparentsprev.test(name)) {
                    matched.reverse();
                  }
                }

                return this.pushStack(matched);
              };
            }
          );
          var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;

          // Convert String-formatted options into Object-formatted ones
          function createOptions(options) {
            var object = {};
            jQuery.each(options.match(rnothtmlwhite) || [], function (_, flag) {
              object[flag] = true;
            });
            return object;
          }

          /*
           * Create a callback list using the following parameters:
           *
           *	options: an optional list of space-separated options that will change how
           *			the callback list behaves or a more traditional option object
           *
           * By default a callback list will act like an event callback list and can be
           * "fired" multiple times.
           *
           * Possible options:
           *
           *	once:			will ensure the callback list can only be fired once (like a Deferred)
           *
           *	memory:			will keep track of previous values and will call any callback added
           *					after the list has been fired right away with the latest "memorized"
           *					values (like a Deferred)
           *
           *	unique:			will ensure a callback can only be added once (no duplicate in the list)
           *
           *	stopOnFalse:	interrupt callings when a callback returns false
           *
           */
          jQuery.Callbacks = function (options) {
            // Convert options from String-formatted to Object-formatted if needed
            // (we check in cache first)
            options =
              typeof options === "string"
                ? createOptions(options)
                : jQuery.extend({}, options);

            var // Flag to know if list is currently firing
              firing,
              // Last fire value for non-forgettable lists
              memory,
              // Flag to know if list was already fired
              fired,
              // Flag to prevent firing
              locked,
              // Actual callback list
              list = [],
              // Queue of execution data for repeatable lists
              queue = [],
              // Index of currently firing callback (modified by add/remove as needed)
              firingIndex = -1,
              // Fire callbacks
              fire = function () {
                // Enforce single-firing
                locked = locked || options.once;

                // Execute callbacks for all pending executions,
                // respecting firingIndex overrides and runtime changes
                fired = firing = true;
                for (; queue.length; firingIndex = -1) {
                  memory = queue.shift();
                  while (++firingIndex < list.length) {
                    // Run callback and check for early termination
                    if (
                      list[firingIndex].apply(memory[0], memory[1]) === false &&
                      options.stopOnFalse
                    ) {
                      // Jump to end and forget the data so .add doesn't re-fire
                      firingIndex = list.length;
                      memory = false;
                    }
                  }
                }

                // Forget the data if we're done with it
                if (!options.memory) {
                  memory = false;
                }

                firing = false;

                // Clean up if we're done firing for good
                if (locked) {
                  // Keep an empty list if we have data for future add calls
                  if (memory) {
                    list = [];

                    // Otherwise, this object is spent
                  } else {
                    list = "";
                  }
                }
              },
              // Actual Callbacks object
              self = {
                // Add a callback or a collection of callbacks to the list
                add: function () {
                  if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                      firingIndex = list.length - 1;
                      queue.push(memory);
                    }

                    (function add(args) {
                      jQuery.each(args, function (_, arg) {
                        if (isFunction(arg)) {
                          if (!options.unique || !self.has(arg)) {
                            list.push(arg);
                          }
                        } else if (
                          arg &&
                          arg.length &&
                          toType(arg) !== "string"
                        ) {
                          // Inspect recursively
                          add(arg);
                        }
                      });
                    })(arguments);

                    if (memory && !firing) {
                      fire();
                    }
                  }
                  return this;
                },

                // Remove a callback from the list
                remove: function () {
                  jQuery.each(arguments, function (_, arg) {
                    var index;
                    while ((index = jQuery.inArray(arg, list, index)) > -1) {
                      list.splice(index, 1);

                      // Handle firing indexes
                      if (index <= firingIndex) {
                        firingIndex--;
                      }
                    }
                  });
                  return this;
                },

                // Check if a given callback is in the list.
                // If no argument is given, return whether or not list has callbacks attached.
                has: function (fn) {
                  return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
                },

                // Remove all callbacks from the list
                empty: function () {
                  if (list) {
                    list = [];
                  }
                  return this;
                },

                // Disable .fire and .add
                // Abort any current/pending executions
                // Clear all callbacks and values
                disable: function () {
                  locked = queue = [];
                  list = memory = "";
                  return this;
                },
                disabled: function () {
                  return !list;
                },

                // Disable .fire
                // Also disable .add unless we have memory (since it would have no effect)
                // Abort any pending executions
                lock: function () {
                  locked = queue = [];
                  if (!memory && !firing) {
                    list = memory = "";
                  }
                  return this;
                },
                locked: function () {
                  return !!locked;
                },

                // Call all callbacks with the given context and arguments
                fireWith: function (context, args) {
                  if (!locked) {
                    args = args || [];
                    args = [context, args.slice ? args.slice() : args];
                    queue.push(args);
                    if (!firing) {
                      fire();
                    }
                  }
                  return this;
                },

                // Call all the callbacks with the given arguments
                fire: function () {
                  self.fireWith(this, arguments);
                  return this;
                },

                // To know if the callbacks have already been called at least once
                fired: function () {
                  return !!fired;
                },
              };

            return self;
          };

          function Identity(v) {
            return v;
          }
          function Thrower(ex) {
            throw ex;
          }

          function adoptValue(value, resolve, reject, noValue) {
            var method;

            try {
              // Check for promise aspect first to privilege synchronous behavior
              if (value && isFunction((method = value.promise))) {
                method.call(value).done(resolve).fail(reject);

                // Other thenables
              } else if (value && isFunction((method = value.then))) {
                method.call(value, resolve, reject);

                // Other non-thenables
              } else {
                // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
                // * false: [ value ].slice( 0 ) => resolve( value )
                // * true: [ value ].slice( 1 ) => resolve()
                resolve.apply(undefined, [value].slice(noValue));
              }

              // For Promises/A+, convert exceptions into rejections
              // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
              // Deferred#then to conditionally suppress rejection.
            } catch (value) {
              // Support: Android 4.0 only
              // Strict mode functions invoked without .call/.apply get global-object context
              reject.apply(undefined, [value]);
            }
          }

          jQuery.extend({
            Deferred: function (func) {
              var tuples = [
                  // action, add listener, callbacks,
                  // ... .then handlers, argument index, [final state]
                  [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2,
                  ],
                  [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved",
                  ],
                  [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected",
                  ],
                ],
                state = "pending",
                promise = {
                  state: function () {
                    return state;
                  },
                  always: function () {
                    deferred.done(arguments).fail(arguments);
                    return this;
                  },
                  catch: function (fn) {
                    return promise.then(null, fn);
                  },

                  // Keep pipe for back-compat
                  pipe: function (/* fnDone, fnFail, fnProgress */) {
                    var fns = arguments;

                    return jQuery
                      .Deferred(function (newDefer) {
                        jQuery.each(tuples, function (i, tuple) {
                          // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                          var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];

                          // deferred.progress(function() { bind to newDefer or newDefer.notify })
                          // deferred.done(function() { bind to newDefer or newDefer.resolve })
                          // deferred.fail(function() { bind to newDefer or newDefer.reject })
                          deferred[tuple[1]](function () {
                            var returned = fn && fn.apply(this, arguments);
                            if (returned && isFunction(returned.promise)) {
                              returned
                                .promise()
                                .progress(newDefer.notify)
                                .done(newDefer.resolve)
                                .fail(newDefer.reject);
                            } else {
                              newDefer[tuple[0] + "With"](
                                this,
                                fn ? [returned] : arguments
                              );
                            }
                          });
                        });
                        fns = null;
                      })
                      .promise();
                  },
                  then: function (onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                      return function () {
                        var that = this,
                          args = arguments,
                          mightThrow = function () {
                            var returned, then;

                            // Support: Promises/A+ section 2.3.3.3.3
                            // https://promisesaplus.com/#point-59
                            // Ignore double-resolution attempts
                            if (depth < maxDepth) {
                              return;
                            }

                            returned = handler.apply(that, args);

                            // Support: Promises/A+ section 2.3.1
                            // https://promisesaplus.com/#point-48
                            if (returned === deferred.promise()) {
                              throw new TypeError("Thenable self-resolution");
                            }

                            // Support: Promises/A+ sections 2.3.3.1, 3.5
                            // https://promisesaplus.com/#point-54
                            // https://promisesaplus.com/#point-75
                            // Retrieve `then` only once
                            then =
                              returned &&
                              // Support: Promises/A+ section 2.3.4
                              // https://promisesaplus.com/#point-64
                              // Only check objects and functions for thenability
                              (typeof returned === "object" ||
                                typeof returned === "function") &&
                              returned.then;

                            // Handle a returned thenable
                            if (isFunction(then)) {
                              // Special processors (notify) just wait for resolution
                              if (special) {
                                then.call(
                                  returned,
                                  resolve(
                                    maxDepth,
                                    deferred,
                                    Identity,
                                    special
                                  ),
                                  resolve(maxDepth, deferred, Thrower, special)
                                );

                                // Normal processors (resolve) also hook into progress
                              } else {
                                // ...and disregard older resolution values
                                maxDepth++;

                                then.call(
                                  returned,
                                  resolve(
                                    maxDepth,
                                    deferred,
                                    Identity,
                                    special
                                  ),
                                  resolve(maxDepth, deferred, Thrower, special),
                                  resolve(
                                    maxDepth,
                                    deferred,
                                    Identity,
                                    deferred.notifyWith
                                  )
                                );
                              }

                              // Handle all other returned values
                            } else {
                              // Only substitute handlers pass on context
                              // and multiple values (non-spec behavior)
                              if (handler !== Identity) {
                                that = undefined;
                                args = [returned];
                              }

                              // Process the value(s)
                              // Default process is resolve
                              (special || deferred.resolveWith)(that, args);
                            }
                          },
                          // Only normal processors (resolve) catch and reject exceptions
                          process = special
                            ? mightThrow
                            : function () {
                                try {
                                  mightThrow();
                                } catch (e) {
                                  if (jQuery.Deferred.exceptionHook) {
                                    jQuery.Deferred.exceptionHook(
                                      e,
                                      process.stackTrace
                                    );
                                  }

                                  // Support: Promises/A+ section 2.3.3.3.4.1
                                  // https://promisesaplus.com/#point-61
                                  // Ignore post-resolution exceptions
                                  if (depth + 1 >= maxDepth) {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Thrower) {
                                      that = undefined;
                                      args = [e];
                                    }

                                    deferred.rejectWith(that, args);
                                  }
                                }
                              };

                        // Support: Promises/A+ section 2.3.3.3.1
                        // https://promisesaplus.com/#point-57
                        // Re-resolve promises immediately to dodge false rejection from
                        // subsequent errors
                        if (depth) {
                          process();
                        } else {
                          // Call an optional hook to record the stack, in case of exception
                          // since it's otherwise lost when execution goes async
                          if (jQuery.Deferred.getStackHook) {
                            process.stackTrace = jQuery.Deferred.getStackHook();
                          }
                          window.setTimeout(process);
                        }
                      };
                    }

                    return jQuery
                      .Deferred(function (newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(
                          resolve(
                            0,
                            newDefer,
                            isFunction(onProgress) ? onProgress : Identity,
                            newDefer.notifyWith
                          )
                        );

                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(
                          resolve(
                            0,
                            newDefer,
                            isFunction(onFulfilled) ? onFulfilled : Identity
                          )
                        );

                        // rejected_handlers.add( ... )
                        tuples[2][3].add(
                          resolve(
                            0,
                            newDefer,
                            isFunction(onRejected) ? onRejected : Thrower
                          )
                        );
                      })
                      .promise();
                  },

                  // Get a promise for this deferred
                  // If obj is provided, the promise aspect is added to the object
                  promise: function (obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                  },
                },
                deferred = {};

              // Add list-specific methods
              jQuery.each(tuples, function (i, tuple) {
                var list = tuple[2],
                  stateString = tuple[5];

                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;

                // Handle state
                if (stateString) {
                  list.add(
                    function () {
                      // state = "resolved" (i.e., fulfilled)
                      // state = "rejected"
                      state = stateString;
                    },

                    // rejected_callbacks.disable
                    // fulfilled_callbacks.disable
                    tuples[3 - i][2].disable,

                    // rejected_handlers.disable
                    // fulfilled_handlers.disable
                    tuples[3 - i][3].disable,

                    // progress_callbacks.lock
                    tuples[0][2].lock,

                    // progress_handlers.lock
                    tuples[0][3].lock
                  );
                }

                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);

                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function () {
                  deferred[tuple[0] + "With"](
                    this === deferred ? undefined : this,
                    arguments
                  );
                  return this;
                };

                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
              });

              // Make the deferred a promise
              promise.promise(deferred);

              // Call given func if any
              if (func) {
                func.call(deferred, deferred);
              }

              // All done!
              return deferred;
            },

            // Deferred helper
            when: function (singleValue) {
              var // count of uncompleted subordinates
                remaining = arguments.length,
                // count of unprocessed arguments
                i = remaining,
                // subordinate fulfillment data
                resolveContexts = Array(i),
                resolveValues = slice.call(arguments),
                // the master Deferred
                master = jQuery.Deferred(),
                // subordinate callback factory
                updateFunc = function (i) {
                  return function (value) {
                    resolveContexts[i] = this;
                    resolveValues[i] =
                      arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) {
                      master.resolveWith(resolveContexts, resolveValues);
                    }
                  };
                };

              // Single- and empty arguments are adopted like Promise.resolve
              if (remaining <= 1) {
                adoptValue(
                  singleValue,
                  master.done(updateFunc(i)).resolve,
                  master.reject,
                  !remaining
                );

                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (
                  master.state() === "pending" ||
                  isFunction(resolveValues[i] && resolveValues[i].then)
                ) {
                  return master.then();
                }
              }

              // Multiple arguments are aggregated like Promise.all array elements
              while (i--) {
                adoptValue(resolveValues[i], updateFunc(i), master.reject);
              }

              return master.promise();
            },
          });

          // These usually indicate a programmer mistake during development,
          // warn about them ASAP rather than swallowing them by default.
          var rerrorNames =
            /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

          jQuery.Deferred.exceptionHook = function (error, stack) {
            // Support: IE 8 - 9 only
            // Console exists when dev tools are open, which can happen at any time
            if (
              window.console &&
              window.console.warn &&
              error &&
              rerrorNames.test(error.name)
            ) {
              window.console.warn(
                "jQuery.Deferred exception: " + error.message,
                error.stack,
                stack
              );
            }
          };

          jQuery.readyException = function (error) {
            window.setTimeout(function () {
              throw error;
            });
          };

          // The deferred used on DOM ready
          var readyList = jQuery.Deferred();

          jQuery.fn.ready = function (fn) {
            readyList
              .then(fn)

              // Wrap jQuery.readyException in a function so that the lookup
              // happens at the time of error handling instead of callback
              // registration.
              .catch(function (error) {
                jQuery.readyException(error);
              });

            return this;
          };

          jQuery.extend({
            // Is the DOM ready to be used? Set to true once it occurs.
            isReady: false,

            // A counter to track how many items to wait for before
            // the ready event fires. See #6781
            readyWait: 1,

            // Handle when the DOM is ready
            ready: function (wait) {
              // Abort if there are pending holds or we're already ready
              if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
                return;
              }

              // Remember that the DOM is ready
              jQuery.isReady = true;

              // If a normal DOM Ready event fired, decrement, and wait if need be
              if (wait !== true && --jQuery.readyWait > 0) {
                return;
              }

              // If there are functions bound, to execute
              readyList.resolveWith(document, [jQuery]);
            },
          });

          jQuery.ready.then = readyList.then;

          // The ready event handler and self cleanup method
          function completed() {
            document.removeEventListener("DOMContentLoaded", completed);
            window.removeEventListener("load", completed);
            jQuery.ready();
          }

          // Catch cases where $(document).ready() is called
          // after the browser event has already occurred.
          // Support: IE <=9 - 10 only
          // Older IE sometimes signals "interactive" too soon
          if (
            document.readyState === "complete" ||
            (document.readyState !== "loading" &&
              !document.documentElement.doScroll)
          ) {
            // Handle it asynchronously to allow scripts the opportunity to delay ready
            window.setTimeout(jQuery.ready);
          } else {
            // Use the handy event callback
            document.addEventListener("DOMContentLoaded", completed);

            // A fallback to window.onload, that will always work
            window.addEventListener("load", completed);
          }

          // Multifunctional method to get and set values of a collection
          // The value/s can optionally be executed if it's a function
          var access = function (
            elems,
            fn,
            key,
            value,
            chainable,
            emptyGet,
            raw
          ) {
            var i = 0,
              len = elems.length,
              bulk = key == null;

            // Sets many values
            if (toType(key) === "object") {
              chainable = true;
              for (i in key) {
                access(elems, fn, i, key[i], true, emptyGet, raw);
              }

              // Sets one value
            } else if (value !== undefined) {
              chainable = true;

              if (!isFunction(value)) {
                raw = true;
              }

              if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                  fn.call(elems, value);
                  fn = null;

                  // ...except when executing function values
                } else {
                  bulk = fn;
                  fn = function (elem, key, value) {
                    return bulk.call(jQuery(elem), value);
                  };
                }
              }

              if (fn) {
                for (; i < len; i++) {
                  fn(
                    elems[i],
                    key,
                    raw ? value : value.call(elems[i], i, fn(elems[i], key))
                  );
                }
              }
            }

            if (chainable) {
              return elems;
            }

            // Gets
            if (bulk) {
              return fn.call(elems);
            }

            return len ? fn(elems[0], key) : emptyGet;
          };

          // Matches dashed string for camelizing
          var rmsPrefix = /^-ms-/,
            rdashAlpha = /-([a-z])/g;

          // Used by camelCase as callback to replace()
          function fcamelCase(all, letter) {
            return letter.toUpperCase();
          }

          // Convert dashed to camelCase; used by the css and data modules
          // Support: IE <=9 - 11, Edge 12 - 15
          // Microsoft forgot to hump their vendor prefix (#9572)
          function camelCase(string) {
            return string
              .replace(rmsPrefix, "ms-")
              .replace(rdashAlpha, fcamelCase);
          }
          var acceptData = function (owner) {
            // Accepts only:
            //  - Node
            //    - Node.ELEMENT_NODE
            //    - Node.DOCUMENT_NODE
            //  - Object
            //    - Any
            return (
              owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType
            );
          };

          function Data() {
            this.expando = jQuery.expando + Data.uid++;
          }

          Data.uid = 1;

          Data.prototype = {
            cache: function (owner) {
              // Check if the owner object already has a cache
              var value = owner[this.expando];

              // If not, create one
              if (!value) {
                value = {};

                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see #8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                  // If it is a node unlikely to be stringify-ed or looped over
                  // use plain assignment
                  if (owner.nodeType) {
                    owner[this.expando] = value;

                    // Otherwise secure it in a non-enumerable property
                    // configurable must be true to allow the property to be
                    // deleted when data is removed
                  } else {
                    Object.defineProperty(owner, this.expando, {
                      value: value,
                      configurable: true,
                    });
                  }
                }
              }

              return value;
            },
            set: function (owner, data, value) {
              var prop,
                cache = this.cache(owner);

              // Handle: [ owner, key, value ] args
              // Always use camelCase key (gh-2257)
              if (typeof data === "string") {
                cache[camelCase(data)] = value;

                // Handle: [ owner, { properties } ] args
              } else {
                // Copy the properties one-by-one to the cache object
                for (prop in data) {
                  cache[camelCase(prop)] = data[prop];
                }
              }
              return cache;
            },
            get: function (owner, key) {
              return key === undefined
                ? this.cache(owner)
                : // Always use camelCase key (gh-2257)
                  owner[this.expando] && owner[this.expando][camelCase(key)];
            },
            access: function (owner, key, value) {
              // In cases where either:
              //
              //   1. No key was specified
              //   2. A string key was specified, but no value provided
              //
              // Take the "read" path and allow the get method to determine
              // which value to return, respectively either:
              //
              //   1. The entire cache object
              //   2. The data stored at the key
              //
              if (
                key === undefined ||
                (key && typeof key === "string" && value === undefined)
              ) {
                return this.get(owner, key);
              }

              // When the key is not a string, or both a key and value
              // are specified, set or extend (existing objects) with either:
              //
              //   1. An object of properties
              //   2. A key and value
              //
              this.set(owner, key, value);

              // Since the "set" path can have two possible entry points
              // return the expected data based on which path was taken[*]
              return value !== undefined ? value : key;
            },
            remove: function (owner, key) {
              var i,
                cache = owner[this.expando];

              if (cache === undefined) {
                return;
              }

              if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) {
                  // If key is an array of keys...
                  // We always set camelCase keys, so remove that.
                  key = key.map(camelCase);
                } else {
                  key = camelCase(key);

                  // If a key with the spaces exists, use it.
                  // Otherwise, create an array by matching non-whitespace
                  key = key in cache ? [key] : key.match(rnothtmlwhite) || [];
                }

                i = key.length;

                while (i--) {
                  delete cache[key[i]];
                }
              }

              // Remove the expando if there's no more data
              if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) {
                  owner[this.expando] = undefined;
                } else {
                  delete owner[this.expando];
                }
              }
            },
            hasData: function (owner) {
              var cache = owner[this.expando];
              return cache !== undefined && !jQuery.isEmptyObject(cache);
            },
          };
          var dataPriv = new Data();

          var dataUser = new Data();

          //	Implementation Summary
          //
          //	1. Enforce API surface and semantic compatibility with 1.9.x branch
          //	2. Improve the module's maintainability by reducing the storage
          //		paths to a single mechanism.
          //	3. Use the same single mechanism to support "private" and "user" data.
          //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
          //	5. Avoid exposing implementation details on user objects (eg. expando properties)
          //	6. Provide a clear path for implementation upgrade to WeakMap in 2014

          var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            rmultiDash = /[A-Z]/g;

          function getData(data) {
            if (data === "true") {
              return true;
            }

            if (data === "false") {
              return false;
            }

            if (data === "null") {
              return null;
            }

            // Only convert to a number if it doesn't change the string
            if (data === +data + "") {
              return +data;
            }

            if (rbrace.test(data)) {
              return JSON.parse(data);
            }

            return data;
          }

          function dataAttr(elem, key, data) {
            var name;

            // If nothing was found internally, try to fetch any
            // data from the HTML5 data-* attribute
            if (data === undefined && elem.nodeType === 1) {
              name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
              data = elem.getAttribute(name);

              if (typeof data === "string") {
                try {
                  data = getData(data);
                } catch (e) {}

                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
              } else {
                data = undefined;
              }
            }
            return data;
          }

          jQuery.extend({
            hasData: function (elem) {
              return dataUser.hasData(elem) || dataPriv.hasData(elem);
            },

            data: function (elem, name, data) {
              return dataUser.access(elem, name, data);
            },

            removeData: function (elem, name) {
              dataUser.remove(elem, name);
            },

            // TODO: Now that all calls to _data and _removeData have been replaced
            // with direct calls to dataPriv methods, these can be deprecated.
            _data: function (elem, name, data) {
              return dataPriv.access(elem, name, data);
            },

            _removeData: function (elem, name) {
              dataPriv.remove(elem, name);
            },
          });

          jQuery.fn.extend({
            data: function (key, value) {
              var i,
                name,
                data,
                elem = this[0],
                attrs = elem && elem.attributes;

              // Gets all values
              if (key === undefined) {
                if (this.length) {
                  data = dataUser.get(elem);

                  if (
                    elem.nodeType === 1 &&
                    !dataPriv.get(elem, "hasDataAttrs")
                  ) {
                    i = attrs.length;
                    while (i--) {
                      // Support: IE 11 only
                      // The attrs elements can be null (#14894)
                      if (attrs[i]) {
                        name = attrs[i].name;
                        if (name.indexOf("data-") === 0) {
                          name = camelCase(name.slice(5));
                          dataAttr(elem, name, data[name]);
                        }
                      }
                    }
                    dataPriv.set(elem, "hasDataAttrs", true);
                  }
                }

                return data;
              }

              // Sets multiple values
              if (typeof key === "object") {
                return this.each(function () {
                  dataUser.set(this, key);
                });
              }

              return access(
                this,
                function (value) {
                  var data;

                  // The calling jQuery object (element matches) is not empty
                  // (and therefore has an element appears at this[ 0 ]) and the
                  // `value` parameter was not undefined. An empty jQuery object
                  // will result in `undefined` for elem = this[ 0 ] which will
                  // throw an exception if an attempt to read a data cache is made.
                  if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) {
                      return data;
                    }

                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) {
                      return data;
                    }

                    // We tried really hard, but the data doesn't exist.
                    return;
                  }

                  // Set the data...
                  this.each(function () {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                  });
                },
                null,
                value,
                arguments.length > 1,
                null,
                true
              );
            },

            removeData: function (key) {
              return this.each(function () {
                dataUser.remove(this, key);
              });
            },
          });

          jQuery.extend({
            queue: function (elem, type, data) {
              var queue;

              if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);

                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                  if (!queue || Array.isArray(data)) {
                    queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                  } else {
                    queue.push(data);
                  }
                }
                return queue || [];
              }
            },

            dequeue: function (elem, type) {
              type = type || "fx";

              var queue = jQuery.queue(elem, type),
                startLength = queue.length,
                fn = queue.shift(),
                hooks = jQuery._queueHooks(elem, type),
                next = function () {
                  jQuery.dequeue(elem, type);
                };

              // If the fx queue is dequeued, always remove the progress sentinel
              if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
              }

              if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") {
                  queue.unshift("inprogress");
                }

                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
              }

              if (!startLength && hooks) {
                hooks.empty.fire();
              }
            },

            // Not public - generate a queueHooks object, or return the current one
            _queueHooks: function (elem, type) {
              var key = type + "queueHooks";
              return (
                dataPriv.get(elem, key) ||
                dataPriv.access(elem, key, {
                  empty: jQuery.Callbacks("once memory").add(function () {
                    dataPriv.remove(elem, [type + "queue", key]);
                  }),
                })
              );
            },
          });

          jQuery.fn.extend({
            queue: function (type, data) {
              var setter = 2;

              if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
              }

              if (arguments.length < setter) {
                return jQuery.queue(this[0], type);
              }

              return data === undefined
                ? this
                : this.each(function () {
                    var queue = jQuery.queue(this, type, data);

                    // Ensure a hooks for this queue
                    jQuery._queueHooks(this, type);

                    if (type === "fx" && queue[0] !== "inprogress") {
                      jQuery.dequeue(this, type);
                    }
                  });
            },
            dequeue: function (type) {
              return this.each(function () {
                jQuery.dequeue(this, type);
              });
            },
            clearQueue: function (type) {
              return this.queue(type || "fx", []);
            },

            // Get a promise resolved when queues of a certain type
            // are emptied (fx is the type by default)
            promise: function (type, obj) {
              var tmp,
                count = 1,
                defer = jQuery.Deferred(),
                elements = this,
                i = this.length,
                resolve = function () {
                  if (!--count) {
                    defer.resolveWith(elements, [elements]);
                  }
                };

              if (typeof type !== "string") {
                obj = type;
                type = undefined;
              }
              type = type || "fx";

              while (i--) {
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                  count++;
                  tmp.empty.add(resolve);
                }
              }
              resolve();
              return defer.promise(obj);
            },
          });
          var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;

          var rcssNum = new RegExp(
            "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$",
            "i"
          );

          var cssExpand = ["Top", "Right", "Bottom", "Left"];

          var documentElement = document.documentElement;

          var isAttached = function (elem) {
              return jQuery.contains(elem.ownerDocument, elem);
            },
            composed = { composed: true };

          // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
          // Check attachment across shadow DOM boundaries when possible (gh-3504)
          // Support: iOS 10.0-10.2 only
          // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
          // leading to errors. We need to check for `getRootNode`.
          if (documentElement.getRootNode) {
            isAttached = function (elem) {
              return (
                jQuery.contains(elem.ownerDocument, elem) ||
                elem.getRootNode(composed) === elem.ownerDocument
              );
            };
          }
          var isHiddenWithinTree = function (elem, el) {
            // isHiddenWithinTree might be called from jQuery#filter function;
            // in that case, element will be second argument
            elem = el || elem;

            // Inline style trumps all
            return (
              elem.style.display === "none" ||
              (elem.style.display === "" &&
                // Otherwise, check computed style
                // Support: Firefox <=43 - 45
                // Disconnected elements can have computed display: none, so first confirm that elem is
                // in the document.
                isAttached(elem) &&
                jQuery.css(elem, "display") === "none")
            );
          };

          var swap = function (elem, options, callback, args) {
            var ret,
              name,
              old = {};

            // Remember the old values, and insert the new ones
            for (name in options) {
              old[name] = elem.style[name];
              elem.style[name] = options[name];
            }

            ret = callback.apply(elem, args || []);

            // Revert the old values
            for (name in options) {
              elem.style[name] = old[name];
            }

            return ret;
          };

          function adjustCSS(elem, prop, valueParts, tween) {
            var adjusted,
              scale,
              maxIterations = 20,
              currentValue = tween
                ? function () {
                    return tween.cur();
                  }
                : function () {
                    return jQuery.css(elem, prop, "");
                  },
              initial = currentValue(),
              unit =
                (valueParts && valueParts[3]) ||
                (jQuery.cssNumber[prop] ? "" : "px"),
              // Starting value computation is required for potential unit mismatches
              initialInUnit =
                elem.nodeType &&
                (jQuery.cssNumber[prop] || (unit !== "px" && +initial)) &&
                rcssNum.exec(jQuery.css(elem, prop));

            if (initialInUnit && initialInUnit[3] !== unit) {
              // Support: Firefox <=54
              // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
              initial = initial / 2;

              // Trust units reported by jQuery.css
              unit = unit || initialInUnit[3];

              // Iteratively approximate from a nonzero starting point
              initialInUnit = +initial || 1;

              while (maxIterations--) {
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if (
                  (1 - scale) *
                    (1 - (scale = currentValue() / initial || 0.5)) <=
                  0
                ) {
                  maxIterations = 0;
                }
                initialInUnit = initialInUnit / scale;
              }

              initialInUnit = initialInUnit * 2;
              jQuery.style(elem, prop, initialInUnit + unit);

              // Make sure we update the tween properties later on
              valueParts = valueParts || [];
            }

            if (valueParts) {
              initialInUnit = +initialInUnit || +initial || 0;

              // Apply relative offset (+=/-=) if specified
              adjusted = valueParts[1]
                ? initialInUnit + (valueParts[1] + 1) * valueParts[2]
                : +valueParts[2];
              if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
              }
            }
            return adjusted;
          }

          var defaultDisplayMap = {};

          function getDefaultDisplay(elem) {
            var temp,
              doc = elem.ownerDocument,
              nodeName = elem.nodeName,
              display = defaultDisplayMap[nodeName];

            if (display) {
              return display;
            }

            temp = doc.body.appendChild(doc.createElement(nodeName));
            display = jQuery.css(temp, "display");

            temp.parentNode.removeChild(temp);

            if (display === "none") {
              display = "block";
            }
            defaultDisplayMap[nodeName] = display;

            return display;
          }

          function showHide(elements, show) {
            var display,
              elem,
              values = [],
              index = 0,
              length = elements.length;

            // Determine new display value for elements that need to change
            for (; index < length; index++) {
              elem = elements[index];
              if (!elem.style) {
                continue;
              }

              display = elem.style.display;
              if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                  values[index] = dataPriv.get(elem, "display") || null;
                  if (!values[index]) {
                    elem.style.display = "";
                  }
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) {
                  values[index] = getDefaultDisplay(elem);
                }
              } else {
                if (display !== "none") {
                  values[index] = "none";

                  // Remember what we're overwriting
                  dataPriv.set(elem, "display", display);
                }
              }
            }

            // Set the display of the elements in a second loop to avoid constant reflow
            for (index = 0; index < length; index++) {
              if (values[index] != null) {
                elements[index].style.display = values[index];
              }
            }

            return elements;
          }

          jQuery.fn.extend({
            show: function () {
              return showHide(this, true);
            },
            hide: function () {
              return showHide(this);
            },
            toggle: function (state) {
              if (typeof state === "boolean") {
                return state ? this.show() : this.hide();
              }

              return this.each(function () {
                if (isHiddenWithinTree(this)) {
                  jQuery(this).show();
                } else {
                  jQuery(this).hide();
                }
              });
            },
          });
          var rcheckableType = /^(?:checkbox|radio)$/i;

          var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;

          var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;

          // We have to close these tags to support XHTML (#13200)
          var wrapMap = {
            // Support: IE <=9 only
            option: [1, "<select multiple='multiple'>", "</select>"],

            // XHTML parsers do not magically insert elements in the
            // same way that tag soup parsers do. So we cannot shorten
            // this by omitting <tbody> or other required elements.
            thead: [1, "<table>", "</table>"],
            col: [2, "<table><colgroup>", "</colgroup></table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],

            _default: [0, "", ""],
          };

          // Support: IE <=9 only
          wrapMap.optgroup = wrapMap.option;

          wrapMap.tbody =
            wrapMap.tfoot =
            wrapMap.colgroup =
            wrapMap.caption =
              wrapMap.thead;
          wrapMap.th = wrapMap.td;

          function getAll(context, tag) {
            // Support: IE <=9 - 11 only
            // Use typeof to avoid zero-argument method invocation on host objects (#15151)
            var ret;

            if (typeof context.getElementsByTagName !== "undefined") {
              ret = context.getElementsByTagName(tag || "*");
            } else if (typeof context.querySelectorAll !== "undefined") {
              ret = context.querySelectorAll(tag || "*");
            } else {
              ret = [];
            }

            if (tag === undefined || (tag && nodeName(context, tag))) {
              return jQuery.merge([context], ret);
            }

            return ret;
          }

          // Mark scripts as having already been evaluated
          function setGlobalEval(elems, refElements) {
            var i = 0,
              l = elems.length;

            for (; i < l; i++) {
              dataPriv.set(
                elems[i],
                "globalEval",
                !refElements || dataPriv.get(refElements[i], "globalEval")
              );
            }
          }

          var rhtml = /<|&#?\w+;/;

          function buildFragment(elems, context, scripts, selection, ignored) {
            var elem,
              tmp,
              tag,
              wrap,
              attached,
              j,
              fragment = context.createDocumentFragment(),
              nodes = [],
              i = 0,
              l = elems.length;

            for (; i < l; i++) {
              elem = elems[i];

              if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") {
                  // Support: Android <=4.0 only, PhantomJS 1 only
                  // push.apply(_, arraylike) throws on ancient WebKit
                  jQuery.merge(nodes, elem.nodeType ? [elem] : elem);

                  // Convert non-html into a text node
                } else if (!rhtml.test(elem)) {
                  nodes.push(context.createTextNode(elem));

                  // Convert html into DOM nodes
                } else {
                  tmp =
                    tmp || fragment.appendChild(context.createElement("div"));

                  // Deserialize a standard representation
                  tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
                  wrap = wrapMap[tag] || wrapMap._default;
                  tmp.innerHTML =
                    wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];

                  // Descend through wrappers to the right content
                  j = wrap[0];
                  while (j--) {
                    tmp = tmp.lastChild;
                  }

                  // Support: Android <=4.0 only, PhantomJS 1 only
                  // push.apply(_, arraylike) throws on ancient WebKit
                  jQuery.merge(nodes, tmp.childNodes);

                  // Remember the top-level container
                  tmp = fragment.firstChild;

                  // Ensure the created nodes are orphaned (#12392)
                  tmp.textContent = "";
                }
              }
            }

            // Remove wrapper from fragment
            fragment.textContent = "";

            i = 0;
            while ((elem = nodes[i++])) {
              // Skip elements already in the context collection (trac-4087)
              if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) {
                  ignored.push(elem);
                }
                continue;
              }

              attached = isAttached(elem);

              // Append to fragment
              tmp = getAll(fragment.appendChild(elem), "script");

              // Preserve script evaluation history
              if (attached) {
                setGlobalEval(tmp);
              }

              // Capture executables
              if (scripts) {
                j = 0;
                while ((elem = tmp[j++])) {
                  if (rscriptType.test(elem.type || "")) {
                    scripts.push(elem);
                  }
                }
              }
            }

            return fragment;
          }

          (function () {
            var fragment = document.createDocumentFragment(),
              div = fragment.appendChild(document.createElement("div")),
              input = document.createElement("input");

            // Support: Android 4.0 - 4.3 only
            // Check state lost if the name is set (#11217)
            // Support: Windows Web Apps (WWA)
            // `name` and `type` must use .setAttribute for WWA (#14901)
            input.setAttribute("type", "radio");
            input.setAttribute("checked", "checked");
            input.setAttribute("name", "t");

            div.appendChild(input);

            // Support: Android <=4.1 only
            // Older WebKit doesn't clone checked state correctly in fragments
            support.checkClone = div
              .cloneNode(true)
              .cloneNode(true).lastChild.checked;

            // Support: IE <=11 only
            // Make sure textarea (and checkbox) defaultValue is properly cloned
            div.innerHTML = "<textarea>x</textarea>";
            support.noCloneChecked =
              !!div.cloneNode(true).lastChild.defaultValue;
          })();

          var rkeyEvent = /^key/,
            rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
            rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

          function returnTrue() {
            return true;
          }

          function returnFalse() {
            return false;
          }

          // Support: IE <=9 - 11+
          // focus() and blur() are asynchronous, except when they are no-op.
          // So expect focus to be synchronous when the element is already active,
          // and blur to be synchronous when the element is not already active.
          // (focus and blur are always synchronous in other supported browsers,
          // this just defines when we can count on it).
          function expectSync(elem, type) {
            return (elem === safeActiveElement()) === (type === "focus");
          }

          // Support: IE <=9 only
          // Accessing document.activeElement can throw unexpectedly
          // https://bugs.jquery.com/ticket/13393
          function safeActiveElement() {
            try {
              return document.activeElement;
            } catch (err) {}
          }

          function on(elem, types, selector, data, fn, one) {
            var origFn, type;

            // Types can be a map of types/handlers
            if (typeof types === "object") {
              // ( types-Object, selector, data )
              if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
              }
              for (type in types) {
                on(elem, type, selector, data, types[type], one);
              }
              return elem;
            }

            if (data == null && fn == null) {
              // ( types, fn )
              fn = selector;
              data = selector = undefined;
            } else if (fn == null) {
              if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
              } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
              }
            }
            if (fn === false) {
              fn = returnFalse;
            } else if (!fn) {
              return elem;
            }

            if (one === 1) {
              origFn = fn;
              fn = function (event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
              };

              // Use same guid so caller can remove using origFn
              fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
            }
            return elem.each(function () {
              jQuery.event.add(this, types, fn, data, selector);
            });
          }

          /*
           * Helper functions for managing events -- not part of the public interface.
           * Props to Dean Edwards' addEvent library for many of the ideas.
           */
          jQuery.event = {
            global: {},

            add: function (elem, types, handler, data, selector) {
              var handleObjIn,
                eventHandle,
                tmp,
                events,
                t,
                handleObj,
                special,
                handlers,
                type,
                namespaces,
                origType,
                elemData = dataPriv.get(elem);

              // Don't attach events to noData or text/comment nodes (but allow plain objects)
              if (!elemData) {
                return;
              }

              // Caller can pass in an object of custom data in lieu of the handler
              if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
              }

              // Ensure that invalid selectors throw exceptions at attach time
              // Evaluate against documentElement in case elem is a non-element node (e.g., document)
              if (selector) {
                jQuery.find.matchesSelector(documentElement, selector);
              }

              // Make sure that the handler has a unique ID, used to find/remove it later
              if (!handler.guid) {
                handler.guid = jQuery.guid++;
              }

              // Init the element's event structure and main handler, if this is the first
              if (!(events = elemData.events)) {
                events = elemData.events = {};
              }
              if (!(eventHandle = elemData.handle)) {
                eventHandle = elemData.handle = function (e) {
                  // Discard the second event of a jQuery.event.trigger() and
                  // when an event is called after a page has unloaded
                  return typeof jQuery !== "undefined" &&
                    jQuery.event.triggered !== e.type
                    ? jQuery.event.dispatch.apply(elem, arguments)
                    : undefined;
                };
              }

              // Handle multiple events separated by a space
              types = (types || "").match(rnothtmlwhite) || [""];
              t = types.length;
              while (t--) {
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();

                // There *must* be a type, no attaching namespace-only handlers
                if (!type) {
                  continue;
                }

                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};

                // If selector defined, determine special event api type, otherwise given type
                type =
                  (selector ? special.delegateType : special.bindType) || type;

                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};

                // handleObj is passed to all event handlers
                handleObj = jQuery.extend(
                  {
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext:
                      selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join("."),
                  },
                  handleObjIn
                );

                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                  handlers = events[type] = [];
                  handlers.delegateCount = 0;

                  // Only use addEventListener if the special events handler returns false
                  if (
                    !special.setup ||
                    special.setup.call(elem, data, namespaces, eventHandle) ===
                      false
                  ) {
                    if (elem.addEventListener) {
                      elem.addEventListener(type, eventHandle);
                    }
                  }
                }

                if (special.add) {
                  special.add.call(elem, handleObj);

                  if (!handleObj.handler.guid) {
                    handleObj.handler.guid = handler.guid;
                  }
                }

                // Add to the element's handler list, delegates in front
                if (selector) {
                  handlers.splice(handlers.delegateCount++, 0, handleObj);
                } else {
                  handlers.push(handleObj);
                }

                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
              }
            },

            // Detach an event or set of events from an element
            remove: function (elem, types, handler, selector, mappedTypes) {
              var j,
                origCount,
                tmp,
                events,
                t,
                handleObj,
                special,
                handlers,
                type,
                namespaces,
                origType,
                elemData = dataPriv.hasData(elem) && dataPriv.get(elem);

              if (!elemData || !(events = elemData.events)) {
                return;
              }

              // Once for each type.namespace in types; type may be omitted
              types = (types || "").match(rnothtmlwhite) || [""];
              t = types.length;
              while (t--) {
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();

                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                  for (type in events) {
                    jQuery.event.remove(
                      elem,
                      type + types[t],
                      handler,
                      selector,
                      true
                    );
                  }
                  continue;
                }

                special = jQuery.event.special[type] || {};
                type =
                  (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp =
                  tmp[2] &&
                  new RegExp(
                    "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)"
                  );

                // Remove matching events
                origCount = j = handlers.length;
                while (j--) {
                  handleObj = handlers[j];

                  if (
                    (mappedTypes || origType === handleObj.origType) &&
                    (!handler || handler.guid === handleObj.guid) &&
                    (!tmp || tmp.test(handleObj.namespace)) &&
                    (!selector ||
                      selector === handleObj.selector ||
                      (selector === "**" && handleObj.selector))
                  ) {
                    handlers.splice(j, 1);

                    if (handleObj.selector) {
                      handlers.delegateCount--;
                    }
                    if (special.remove) {
                      special.remove.call(elem, handleObj);
                    }
                  }
                }

                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                  if (
                    !special.teardown ||
                    special.teardown.call(elem, namespaces, elemData.handle) ===
                      false
                  ) {
                    jQuery.removeEvent(elem, type, elemData.handle);
                  }

                  delete events[type];
                }
              }

              // Remove data and the expando if it's no longer used
              if (jQuery.isEmptyObject(events)) {
                dataPriv.remove(elem, "handle events");
              }
            },

            dispatch: function (nativeEvent) {
              // Make a writable jQuery.Event from the native event object
              var event = jQuery.event.fix(nativeEvent);

              var i,
                j,
                ret,
                matched,
                handleObj,
                handlerQueue,
                args = new Array(arguments.length),
                handlers =
                  (dataPriv.get(this, "events") || {})[event.type] || [],
                special = jQuery.event.special[event.type] || {};

              // Use the fix-ed jQuery.Event rather than the (read-only) native event
              args[0] = event;

              for (i = 1; i < arguments.length; i++) {
                args[i] = arguments[i];
              }

              event.delegateTarget = this;

              // Call the preDispatch hook for the mapped type, and let it bail if desired
              if (
                special.preDispatch &&
                special.preDispatch.call(this, event) === false
              ) {
                return;
              }

              // Determine handlers
              handlerQueue = jQuery.event.handlers.call(this, event, handlers);

              // Run delegates first; they may want to stop propagation beneath us
              i = 0;
              while (
                (matched = handlerQueue[i++]) &&
                !event.isPropagationStopped()
              ) {
                event.currentTarget = matched.elem;

                j = 0;
                while (
                  (handleObj = matched.handlers[j++]) &&
                  !event.isImmediatePropagationStopped()
                ) {
                  // If the event is namespaced, then each handler is only invoked if it is
                  // specially universal or its namespaces are a superset of the event's.
                  if (
                    !event.rnamespace ||
                    handleObj.namespace === false ||
                    event.rnamespace.test(handleObj.namespace)
                  ) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;

                    ret = (
                      (jQuery.event.special[handleObj.origType] || {}).handle ||
                      handleObj.handler
                    ).apply(matched.elem, args);

                    if (ret !== undefined) {
                      if ((event.result = ret) === false) {
                        event.preventDefault();
                        event.stopPropagation();
                      }
                    }
                  }
                }
              }

              // Call the postDispatch hook for the mapped type
              if (special.postDispatch) {
                special.postDispatch.call(this, event);
              }

              return event.result;
            },

            handlers: function (event, handlers) {
              var i,
                handleObj,
                sel,
                matchedHandlers,
                matchedSelectors,
                handlerQueue = [],
                delegateCount = handlers.delegateCount,
                cur = event.target;

              // Find delegate handlers
              if (
                delegateCount &&
                // Support: IE <=9
                // Black-hole SVG <use> instance trees (trac-13180)
                cur.nodeType &&
                // Support: Firefox <=42
                // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
                // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
                // Support: IE 11 only
                // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
                !(event.type === "click" && event.button >= 1)
              ) {
                for (; cur !== this; cur = cur.parentNode || this) {
                  // Don't check non-elements (#13208)
                  // Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
                  if (
                    cur.nodeType === 1 &&
                    !(event.type === "click" && cur.disabled === true)
                  ) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for (i = 0; i < delegateCount; i++) {
                      handleObj = handlers[i];

                      // Don't conflict with Object.prototype properties (#13203)
                      sel = handleObj.selector + " ";

                      if (matchedSelectors[sel] === undefined) {
                        matchedSelectors[sel] = handleObj.needsContext
                          ? jQuery(sel, this).index(cur) > -1
                          : jQuery.find(sel, this, null, [cur]).length;
                      }
                      if (matchedSelectors[sel]) {
                        matchedHandlers.push(handleObj);
                      }
                    }
                    if (matchedHandlers.length) {
                      handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers,
                      });
                    }
                  }
                }
              }

              // Add the remaining (directly-bound) handlers
              cur = this;
              if (delegateCount < handlers.length) {
                handlerQueue.push({
                  elem: cur,
                  handlers: handlers.slice(delegateCount),
                });
              }

              return handlerQueue;
            },

            addProp: function (name, hook) {
              Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,

                get: isFunction(hook)
                  ? function () {
                      if (this.originalEvent) {
                        return hook(this.originalEvent);
                      }
                    }
                  : function () {
                      if (this.originalEvent) {
                        return this.originalEvent[name];
                      }
                    },

                set: function (value) {
                  Object.defineProperty(this, name, {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: value,
                  });
                },
              });
            },

            fix: function (originalEvent) {
              return originalEvent[jQuery.expando]
                ? originalEvent
                : new jQuery.Event(originalEvent);
            },

            special: {
              load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true,
              },
              click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function (data) {
                  // For mutual compressibility with _default, replace `this` access with a local var.
                  // `|| data` is dead code meant only to preserve the variable through minification.
                  var el = this || data;

                  // Claim the first handler
                  if (
                    rcheckableType.test(el.type) &&
                    el.click &&
                    nodeName(el, "input")
                  ) {
                    // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", returnTrue);
                  }

                  // Return false to allow normal processing in the caller
                  return false;
                },
                trigger: function (data) {
                  // For mutual compressibility with _default, replace `this` access with a local var.
                  // `|| data` is dead code meant only to preserve the variable through minification.
                  var el = this || data;

                  // Force setup before triggering a click
                  if (
                    rcheckableType.test(el.type) &&
                    el.click &&
                    nodeName(el, "input")
                  ) {
                    leverageNative(el, "click");
                  }

                  // Return non-false to allow normal event-path propagation
                  return true;
                },

                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function (event) {
                  var target = event.target;
                  return (
                    (rcheckableType.test(target.type) &&
                      target.click &&
                      nodeName(target, "input") &&
                      dataPriv.get(target, "click")) ||
                    nodeName(target, "a")
                  );
                },
              },

              beforeunload: {
                postDispatch: function (event) {
                  // Support: Firefox 20+
                  // Firefox doesn't alert if the returnValue field is not set.
                  if (event.result !== undefined && event.originalEvent) {
                    event.originalEvent.returnValue = event.result;
                  }
                },
              },
            },
          };

          // Ensure the presence of an event listener that handles manually-triggered
          // synthetic events by interrupting progress until reinvoked in response to
          // *native* events that it fires directly, ensuring that state changes have
          // already occurred before other listeners are invoked.
          function leverageNative(el, type, expectSync) {
            // Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
            if (!expectSync) {
              if (dataPriv.get(el, type) === undefined) {
                jQuery.event.add(el, type, returnTrue);
              }
              return;
            }

            // Register the controller as a special universal handler for all event namespaces
            dataPriv.set(el, type, false);
            jQuery.event.add(el, type, {
              namespace: false,
              handler: function (event) {
                var notAsync,
                  result,
                  saved = dataPriv.get(this, type);

                if (event.isTrigger & 1 && this[type]) {
                  // Interrupt processing of the outer synthetic .trigger()ed event
                  // Saved data should be false in such cases, but might be a leftover capture object
                  // from an async native handler (gh-4350)
                  if (!saved.length) {
                    // Store arguments for use when handling the inner native event
                    // There will always be at least one argument (an event object), so this array
                    // will not be confused with a leftover capture object.
                    saved = slice.call(arguments);
                    dataPriv.set(this, type, saved);

                    // Trigger the native event and capture its result
                    // Support: IE <=9 - 11+
                    // focus() and blur() are asynchronous
                    notAsync = expectSync(this, type);
                    this[type]();
                    result = dataPriv.get(this, type);
                    if (saved !== result || notAsync) {
                      dataPriv.set(this, type, false);
                    } else {
                      result = {};
                    }
                    if (saved !== result) {
                      // Cancel the outer synthetic event
                      event.stopImmediatePropagation();
                      event.preventDefault();
                      return result.value;
                    }

                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering the
                    // native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                  } else if ((jQuery.event.special[type] || {}).delegateType) {
                    event.stopPropagation();
                  }

                  // If this is a native event triggered above, everything is now in order
                  // Fire an inner synthetic event with the original arguments
                } else if (saved.length) {
                  // ...and capture the result
                  dataPriv.set(this, type, {
                    value: jQuery.event.trigger(
                      // Support: IE <=9 - 11+
                      // Extend with the prototype to reset the above stopImmediatePropagation()
                      jQuery.extend(saved[0], jQuery.Event.prototype),
                      saved.slice(1),
                      this
                    ),
                  });

                  // Abort handling of the native event
                  event.stopImmediatePropagation();
                }
              },
            });
          }

          jQuery.removeEvent = function (elem, type, handle) {
            // This "if" is needed for plain objects
            if (elem.removeEventListener) {
              elem.removeEventListener(type, handle);
            }
          };

          jQuery.Event = function (src, props) {
            // Allow instantiation without the 'new' keyword
            if (!(this instanceof jQuery.Event)) {
              return new jQuery.Event(src, props);
            }

            // Event object
            if (src && src.type) {
              this.originalEvent = src;
              this.type = src.type;

              // Events bubbling up the document may have been marked as prevented
              // by a handler lower down the tree; reflect the correct value.
              this.isDefaultPrevented =
                src.defaultPrevented ||
                (src.defaultPrevented === undefined &&
                  // Support: Android <=2.3 only
                  src.returnValue === false)
                  ? returnTrue
                  : returnFalse;

              // Create target properties
              // Support: Safari <=6 - 7 only
              // Target should not be a text node (#504, #13143)
              this.target =
                src.target && src.target.nodeType === 3
                  ? src.target.parentNode
                  : src.target;

              this.currentTarget = src.currentTarget;
              this.relatedTarget = src.relatedTarget;

              // Event type
            } else {
              this.type = src;
            }

            // Put explicitly provided properties onto the event object
            if (props) {
              jQuery.extend(this, props);
            }

            // Create a timestamp if incoming event doesn't have one
            this.timeStamp = (src && src.timeStamp) || Date.now();

            // Mark it as fixed
            this[jQuery.expando] = true;
          };

          // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
          // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
          jQuery.Event.prototype = {
            constructor: jQuery.Event,
            isDefaultPrevented: returnFalse,
            isPropagationStopped: returnFalse,
            isImmediatePropagationStopped: returnFalse,
            isSimulated: false,

            preventDefault: function () {
              var e = this.originalEvent;

              this.isDefaultPrevented = returnTrue;

              if (e && !this.isSimulated) {
                e.preventDefault();
              }
            },
            stopPropagation: function () {
              var e = this.originalEvent;

              this.isPropagationStopped = returnTrue;

              if (e && !this.isSimulated) {
                e.stopPropagation();
              }
            },
            stopImmediatePropagation: function () {
              var e = this.originalEvent;

              this.isImmediatePropagationStopped = returnTrue;

              if (e && !this.isSimulated) {
                e.stopImmediatePropagation();
              }

              this.stopPropagation();
            },
          };

          // Includes all common event props including KeyEvent and MouseEvent specific props
          jQuery.each(
            {
              altKey: true,
              bubbles: true,
              cancelable: true,
              changedTouches: true,
              ctrlKey: true,
              detail: true,
              eventPhase: true,
              metaKey: true,
              pageX: true,
              pageY: true,
              shiftKey: true,
              view: true,
              char: true,
              code: true,
              charCode: true,
              key: true,
              keyCode: true,
              button: true,
              buttons: true,
              clientX: true,
              clientY: true,
              offsetX: true,
              offsetY: true,
              pointerId: true,
              pointerType: true,
              screenX: true,
              screenY: true,
              targetTouches: true,
              toElement: true,
              touches: true,

              which: function (event) {
                var button = event.button;

                // Add which for key events
                if (event.which == null && rkeyEvent.test(event.type)) {
                  return event.charCode != null
                    ? event.charCode
                    : event.keyCode;
                }

                // Add which for click: 1 === left; 2 === middle; 3 === right
                if (
                  !event.which &&
                  button !== undefined &&
                  rmouseEvent.test(event.type)
                ) {
                  if (button & 1) {
                    return 1;
                  }

                  if (button & 2) {
                    return 3;
                  }

                  if (button & 4) {
                    return 2;
                  }

                  return 0;
                }

                return event.which;
              },
            },
            jQuery.event.addProp
          );

          jQuery.each(
            { focus: "focusin", blur: "focusout" },
            function (type, delegateType) {
              jQuery.event.special[type] = {
                // Utilize native event if possible so blur/focus sequence is correct
                setup: function () {
                  // Claim the first handler
                  // dataPriv.set( this, "focus", ... )
                  // dataPriv.set( this, "blur", ... )
                  leverageNative(this, type, expectSync);

                  // Return false to allow normal processing in the caller
                  return false;
                },
                trigger: function () {
                  // Force setup before trigger
                  leverageNative(this, type);

                  // Return non-false to allow normal event-path propagation
                  return true;
                },

                delegateType: delegateType,
              };
            }
          );

          // Create mouseenter/leave events using mouseover/out and event-time checks
          // so that event delegation works in jQuery.
          // Do the same for pointerenter/pointerleave and pointerover/pointerout
          //
          // Support: Safari 7 only
          // Safari sends mouseenter too often; see:
          // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
          // for the description of the bug (it existed in older Chrome versions as well).
          jQuery.each(
            {
              mouseenter: "mouseover",
              mouseleave: "mouseout",
              pointerenter: "pointerover",
              pointerleave: "pointerout",
            },
            function (orig, fix) {
              jQuery.event.special[orig] = {
                delegateType: fix,
                bindType: fix,

                handle: function (event) {
                  var ret,
                    target = this,
                    related = event.relatedTarget,
                    handleObj = event.handleObj;

                  // For mouseenter/leave call the handler if related is outside the target.
                  // NB: No relatedTarget if the mouse left/entered the browser window
                  if (
                    !related ||
                    (related !== target && !jQuery.contains(target, related))
                  ) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                  }
                  return ret;
                },
              };
            }
          );

          jQuery.fn.extend({
            on: function (types, selector, data, fn) {
              return on(this, types, selector, data, fn);
            },
            one: function (types, selector, data, fn) {
              return on(this, types, selector, data, fn, 1);
            },
            off: function (types, selector, fn) {
              var handleObj, type;
              if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(
                  handleObj.namespace
                    ? handleObj.origType + "." + handleObj.namespace
                    : handleObj.origType,
                  handleObj.selector,
                  handleObj.handler
                );
                return this;
              }
              if (typeof types === "object") {
                // ( types-object [, selector] )
                for (type in types) {
                  this.off(type, selector, types[type]);
                }
                return this;
              }
              if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
              }
              if (fn === false) {
                fn = returnFalse;
              }
              return this.each(function () {
                jQuery.event.remove(this, types, fn, selector);
              });
            },
          });

          var /* eslint-disable max-len */

            // See https://github.com/eslint/eslint/issues/3229
            rxhtmlTag =
              /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
            /* eslint-enable */

            // Support: IE <=10 - 11, Edge 12 - 13 only
            // In IE/Edge using regex groups here causes severe slowdowns.
            // See https://connect.microsoft.com/IE/feedback/details/1736512/
            rnoInnerhtml = /<script|<style|<link/i,
            // checked="checked" or checked
            rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
            rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

          // Prefer a tbody over its parent table for containing new rows
          function manipulationTarget(elem, content) {
            if (
              nodeName(elem, "table") &&
              nodeName(
                content.nodeType !== 11 ? content : content.firstChild,
                "tr"
              )
            ) {
              return jQuery(elem).children("tbody")[0] || elem;
            }

            return elem;
          }

          // Replace/restore the type attribute of script elements for safe DOM manipulation
          function disableScript(elem) {
            elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
            return elem;
          }
          function restoreScript(elem) {
            if ((elem.type || "").slice(0, 5) === "true/") {
              elem.type = elem.type.slice(5);
            } else {
              elem.removeAttribute("type");
            }

            return elem;
          }

          function cloneCopyEvent(src, dest) {
            var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

            if (dest.nodeType !== 1) {
              return;
            }

            // 1. Copy private data: events, handlers, etc.
            if (dataPriv.hasData(src)) {
              pdataOld = dataPriv.access(src);
              pdataCur = dataPriv.set(dest, pdataOld);
              events = pdataOld.events;

              if (events) {
                delete pdataCur.handle;
                pdataCur.events = {};

                for (type in events) {
                  for (i = 0, l = events[type].length; i < l; i++) {
                    jQuery.event.add(dest, type, events[type][i]);
                  }
                }
              }
            }

            // 2. Copy user data
            if (dataUser.hasData(src)) {
              udataOld = dataUser.access(src);
              udataCur = jQuery.extend({}, udataOld);

              dataUser.set(dest, udataCur);
            }
          }

          // Fix IE bugs, see support tests
          function fixInput(src, dest) {
            var nodeName = dest.nodeName.toLowerCase();

            // Fails to persist the checked state of a cloned checkbox or radio button.
            if (nodeName === "input" && rcheckableType.test(src.type)) {
              dest.checked = src.checked;

              // Fails to return the selected option to the default selected state when cloning options
            } else if (nodeName === "input" || nodeName === "textarea") {
              dest.defaultValue = src.defaultValue;
            }
          }

          function domManip(collection, args, callback, ignored) {
            // Flatten any nested arrays
            args = concat.apply([], args);

            var fragment,
              first,
              scripts,
              hasScripts,
              node,
              doc,
              i = 0,
              l = collection.length,
              iNoClone = l - 1,
              value = args[0],
              valueIsFunction = isFunction(value);

            // We can't cloneNode fragments that contain checked, in WebKit
            if (
              valueIsFunction ||
              (l > 1 &&
                typeof value === "string" &&
                !support.checkClone &&
                rchecked.test(value))
            ) {
              return collection.each(function (index) {
                var self = collection.eq(index);
                if (valueIsFunction) {
                  args[0] = value.call(this, index, self.html());
                }
                domManip(self, args, callback, ignored);
              });
            }

            if (l) {
              fragment = buildFragment(
                args,
                collection[0].ownerDocument,
                false,
                collection,
                ignored
              );
              first = fragment.firstChild;

              if (fragment.childNodes.length === 1) {
                fragment = first;
              }

              // Require either new content or an interest in ignored elements to invoke the callback
              if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;

                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (#8070).
                for (; i < l; i++) {
                  node = fragment;

                  if (i !== iNoClone) {
                    node = jQuery.clone(node, true, true);

                    // Keep references to cloned scripts for later restoration
                    if (hasScripts) {
                      // Support: Android <=4.0 only, PhantomJS 1 only
                      // push.apply(_, arraylike) throws on ancient WebKit
                      jQuery.merge(scripts, getAll(node, "script"));
                    }
                  }

                  callback.call(collection[i], node, i);
                }

                if (hasScripts) {
                  doc = scripts[scripts.length - 1].ownerDocument;

                  // Reenable scripts
                  jQuery.map(scripts, restoreScript);

                  // Evaluate executable scripts on first document insertion
                  for (i = 0; i < hasScripts; i++) {
                    node = scripts[i];
                    if (
                      rscriptType.test(node.type || "") &&
                      !dataPriv.access(node, "globalEval") &&
                      jQuery.contains(doc, node)
                    ) {
                      if (
                        node.src &&
                        (node.type || "").toLowerCase() !== "module"
                      ) {
                        // Optional AJAX dependency, but won't run scripts if not present
                        if (jQuery._evalUrl && !node.noModule) {
                          jQuery._evalUrl(node.src, {
                            nonce: node.nonce || node.getAttribute("nonce"),
                          });
                        }
                      } else {
                        DOMEval(
                          node.textContent.replace(rcleanScript, ""),
                          node,
                          doc
                        );
                      }
                    }
                  }
                }
              }
            }

            return collection;
          }

          function remove(elem, selector, keepData) {
            var node,
              nodes = selector ? jQuery.filter(selector, elem) : elem,
              i = 0;

            for (; (node = nodes[i]) != null; i++) {
              if (!keepData && node.nodeType === 1) {
                jQuery.cleanData(getAll(node));
              }

              if (node.parentNode) {
                if (keepData && isAttached(node)) {
                  setGlobalEval(getAll(node, "script"));
                }
                node.parentNode.removeChild(node);
              }
            }

            return elem;
          }

          jQuery.extend({
            htmlPrefilter: function (html) {
              return html.replace(rxhtmlTag, "<$1></$2>");
            },

            clone: function (elem, dataAndEvents, deepDataAndEvents) {
              var i,
                l,
                srcElements,
                destElements,
                clone = elem.cloneNode(true),
                inPage = isAttached(elem);

              // Fix IE cloning issues
              if (
                !support.noCloneChecked &&
                (elem.nodeType === 1 || elem.nodeType === 11) &&
                !jQuery.isXMLDoc(elem)
              ) {
                // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);

                for (i = 0, l = srcElements.length; i < l; i++) {
                  fixInput(srcElements[i], destElements[i]);
                }
              }

              // Copy the events from the original to the clone
              if (dataAndEvents) {
                if (deepDataAndEvents) {
                  srcElements = srcElements || getAll(elem);
                  destElements = destElements || getAll(clone);

                  for (i = 0, l = srcElements.length; i < l; i++) {
                    cloneCopyEvent(srcElements[i], destElements[i]);
                  }
                } else {
                  cloneCopyEvent(elem, clone);
                }
              }

              // Preserve script evaluation history
              destElements = getAll(clone, "script");
              if (destElements.length > 0) {
                setGlobalEval(destElements, !inPage && getAll(elem, "script"));
              }

              // Return the cloned set
              return clone;
            },

            cleanData: function (elems) {
              var data,
                elem,
                type,
                special = jQuery.event.special,
                i = 0;

              for (; (elem = elems[i]) !== undefined; i++) {
                if (acceptData(elem)) {
                  if ((data = elem[dataPriv.expando])) {
                    if (data.events) {
                      for (type in data.events) {
                        if (special[type]) {
                          jQuery.event.remove(elem, type);

                          // This is a shortcut to avoid jQuery.event.remove's overhead
                        } else {
                          jQuery.removeEvent(elem, type, data.handle);
                        }
                      }
                    }

                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                  }
                  if (elem[dataUser.expando]) {
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataUser.expando] = undefined;
                  }
                }
              }
            },
          });

          jQuery.fn.extend({
            detach: function (selector) {
              return remove(this, selector, true);
            },

            remove: function (selector) {
              return remove(this, selector);
            },

            text: function (value) {
              return access(
                this,
                function (value) {
                  return value === undefined
                    ? jQuery.text(this)
                    : this.empty().each(function () {
                        if (
                          this.nodeType === 1 ||
                          this.nodeType === 11 ||
                          this.nodeType === 9
                        ) {
                          this.textContent = value;
                        }
                      });
                },
                null,
                value,
                arguments.length
              );
            },

            append: function () {
              return domManip(this, arguments, function (elem) {
                if (
                  this.nodeType === 1 ||
                  this.nodeType === 11 ||
                  this.nodeType === 9
                ) {
                  var target = manipulationTarget(this, elem);
                  target.appendChild(elem);
                }
              });
            },

            prepend: function () {
              return domManip(this, arguments, function (elem) {
                if (
                  this.nodeType === 1 ||
                  this.nodeType === 11 ||
                  this.nodeType === 9
                ) {
                  var target = manipulationTarget(this, elem);
                  target.insertBefore(elem, target.firstChild);
                }
              });
            },

            before: function () {
              return domManip(this, arguments, function (elem) {
                if (this.parentNode) {
                  this.parentNode.insertBefore(elem, this);
                }
              });
            },

            after: function () {
              return domManip(this, arguments, function (elem) {
                if (this.parentNode) {
                  this.parentNode.insertBefore(elem, this.nextSibling);
                }
              });
            },

            empty: function () {
              var elem,
                i = 0;

              for (; (elem = this[i]) != null; i++) {
                if (elem.nodeType === 1) {
                  // Prevent memory leaks
                  jQuery.cleanData(getAll(elem, false));

                  // Remove any remaining nodes
                  elem.textContent = "";
                }
              }

              return this;
            },

            clone: function (dataAndEvents, deepDataAndEvents) {
              dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
              deepDataAndEvents =
                deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

              return this.map(function () {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
              });
            },

            html: function (value) {
              return access(
                this,
                function (value) {
                  var elem = this[0] || {},
                    i = 0,
                    l = this.length;

                  if (value === undefined && elem.nodeType === 1) {
                    return elem.innerHTML;
                  }

                  // See if we can take a shortcut and just use innerHTML
                  if (
                    typeof value === "string" &&
                    !rnoInnerhtml.test(value) &&
                    !wrapMap[
                      (rtagName.exec(value) || ["", ""])[1].toLowerCase()
                    ]
                  ) {
                    value = jQuery.htmlPrefilter(value);

                    try {
                      for (; i < l; i++) {
                        elem = this[i] || {};

                        // Remove element nodes and prevent memory leaks
                        if (elem.nodeType === 1) {
                          jQuery.cleanData(getAll(elem, false));
                          elem.innerHTML = value;
                        }
                      }

                      elem = 0;

                      // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                  }

                  if (elem) {
                    this.empty().append(value);
                  }
                },
                null,
                value,
                arguments.length
              );
            },

            replaceWith: function () {
              var ignored = [];

              // Make the changes, replacing each non-ignored context element with the new content
              return domManip(
                this,
                arguments,
                function (elem) {
                  var parent = this.parentNode;

                  if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) {
                      parent.replaceChild(elem, this);
                    }
                  }

                  // Force callback invocation
                },
                ignored
              );
            },
          });

          jQuery.each(
            {
              appendTo: "append",
              prependTo: "prepend",
              insertBefore: "before",
              insertAfter: "after",
              replaceAll: "replaceWith",
            },
            function (name, original) {
              jQuery.fn[name] = function (selector) {
                var elems,
                  ret = [],
                  insert = jQuery(selector),
                  last = insert.length - 1,
                  i = 0;

                for (; i <= last; i++) {
                  elems = i === last ? this : this.clone(true);
                  jQuery(insert[i])[original](elems);

                  // Support: Android <=4.0 only, PhantomJS 1 only
                  // .get() because push.apply(_, arraylike) throws on ancient WebKit
                  push.apply(ret, elems.get());
                }

                return this.pushStack(ret);
              };
            }
          );
          var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");

          var getStyles = function (elem) {
            // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
            // IE throws on elements created in popups
            // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
            var view = elem.ownerDocument.defaultView;

            if (!view || !view.opener) {
              view = window;
            }

            return view.getComputedStyle(elem);
          };

          var rboxStyle = new RegExp(cssExpand.join("|"), "i");

          (function () {
            // Executing both pixelPosition & boxSizingReliable tests require only one layout
            // so they're executed at the same time to save the second computation.
            function computeStyleTests() {
              // This is a singleton, we need to execute it only once
              if (!div) {
                return;
              }

              container.style.cssText =
                "position:absolute;left:-11111px;width:60px;" +
                "margin-top:1px;padding:0;border:0";
              div.style.cssText =
                "position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
                "margin:auto;border:1px;padding:1px;" +
                "width:60%;top:1%";
              documentElement.appendChild(container).appendChild(div);

              var divStyle = window.getComputedStyle(div);
              pixelPositionVal = divStyle.top !== "1%";

              // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
              reliableMarginLeftVal =
                roundPixelMeasures(divStyle.marginLeft) === 12;

              // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
              // Some styles come back with percentage values, even though they shouldn't
              div.style.right = "60%";
              pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;

              // Support: IE 9 - 11 only
              // Detect misreporting of content dimensions for box-sizing:border-box elements
              boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;

              // Support: IE 9 only
              // Detect overflow:scroll screwiness (gh-3699)
              // Support: Chrome <=64
              // Don't get tricked when zoom affects offsetWidth (gh-4029)
              div.style.position = "absolute";
              scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;

              documentElement.removeChild(container);

              // Nullify the div so it wouldn't be stored in the memory and
              // it will also be a sign that checks already performed
              div = null;
            }

            function roundPixelMeasures(measure) {
              return Math.round(parseFloat(measure));
            }

            var pixelPositionVal,
              boxSizingReliableVal,
              scrollboxSizeVal,
              pixelBoxStylesVal,
              reliableMarginLeftVal,
              container = document.createElement("div"),
              div = document.createElement("div");

            // Finish early in limited (non-browser) environments
            if (!div.style) {
              return;
            }

            // Support: IE <=9 - 11 only
            // Style of cloned element affects source element cloned (#8908)
            div.style.backgroundClip = "content-box";
            div.cloneNode(true).style.backgroundClip = "";
            support.clearCloneStyle =
              div.style.backgroundClip === "content-box";

            jQuery.extend(support, {
              boxSizingReliable: function () {
                computeStyleTests();
                return boxSizingReliableVal;
              },
              pixelBoxStyles: function () {
                computeStyleTests();
                return pixelBoxStylesVal;
              },
              pixelPosition: function () {
                computeStyleTests();
                return pixelPositionVal;
              },
              reliableMarginLeft: function () {
                computeStyleTests();
                return reliableMarginLeftVal;
              },
              scrollboxSize: function () {
                computeStyleTests();
                return scrollboxSizeVal;
              },
            });
          })();

          function curCSS(elem, name, computed) {
            var width,
              minWidth,
              maxWidth,
              ret,
              // Support: Firefox 51+
              // Retrieving style before computed somehow
              // fixes an issue with getting wrong values
              // on detached elements
              style = elem.style;

            computed = computed || getStyles(elem);

            // getPropertyValue is needed for:
            //   .css('filter') (IE 9 only, #12537)
            //   .css('--customProperty) (#3144)
            if (computed) {
              ret = computed.getPropertyValue(name) || computed[name];

              if (ret === "" && !isAttached(elem)) {
                ret = jQuery.style(elem, name);
              }

              // A tribute to the "awesome hack by Dean Edwards"
              // Android Browser returns percentage for some values,
              // but width seems to be reliably pixels.
              // This is against the CSSOM draft spec:
              // https://drafts.csswg.org/cssom/#resolved-values
              if (
                !support.pixelBoxStyles() &&
                rnumnonpx.test(ret) &&
                rboxStyle.test(name)
              ) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;

                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;

                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
              }
            }

            return ret !== undefined
              ? // Support: IE <=9 - 11 only
                // IE returns zIndex value as an integer.
                ret + ""
              : ret;
          }

          function addGetHookIf(conditionFn, hookFn) {
            // Define the hook, we'll check on the first run if it's really needed.
            return {
              get: function () {
                if (conditionFn()) {
                  // Hook not needed (or it's not possible to use it due
                  // to missing dependency), remove it.
                  delete this.get;
                  return;
                }

                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
              },
            };
          }

          var cssPrefixes = ["Webkit", "Moz", "ms"],
            emptyStyle = document.createElement("div").style,
            vendorProps = {};

          // Return a vendor-prefixed property or undefined
          function vendorPropName(name) {
            // Check for vendor prefixed names
            var capName = name[0].toUpperCase() + name.slice(1),
              i = cssPrefixes.length;

            while (i--) {
              name = cssPrefixes[i] + capName;
              if (name in emptyStyle) {
                return name;
              }
            }
          }

          // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
          function finalPropName(name) {
            var final = jQuery.cssProps[name] || vendorProps[name];

            if (final) {
              return final;
            }
            if (name in emptyStyle) {
              return name;
            }
            return (vendorProps[name] = vendorPropName(name) || name);
          }

          var // Swappable if display is none or starts with table
            // except "table", "table-cell", or "table-caption"
            // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
            rdisplayswap = /^(none|table(?!-c[ea]).+)/,
            rcustomProp = /^--/,
            cssShow = {
              position: "absolute",
              visibility: "hidden",
              display: "block",
            },
            cssNormalTransform = {
              letterSpacing: "0",
              fontWeight: "400",
            };

          function setPositiveNumber(elem, value, subtract) {
            // Any relative (+/-) values have already been
            // normalized at this point
            var matches = rcssNum.exec(value);
            return matches
              ? // Guard against undefined "subtract", e.g., when used as in cssHooks
                Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px")
              : value;
          }

          function boxModelAdjustment(
            elem,
            dimension,
            box,
            isBorderBox,
            styles,
            computedVal
          ) {
            var i = dimension === "width" ? 1 : 0,
              extra = 0,
              delta = 0;

            // Adjustment may not be necessary
            if (box === (isBorderBox ? "border" : "content")) {
              return 0;
            }

            for (; i < 4; i += 2) {
              // Both box models exclude margin
              if (box === "margin") {
                delta += jQuery.css(elem, box + cssExpand[i], true, styles);
              }

              // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
              if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(
                  elem,
                  "padding" + cssExpand[i],
                  true,
                  styles
                );

                // For "border" or "margin", add border
                if (box !== "padding") {
                  delta += jQuery.css(
                    elem,
                    "border" + cssExpand[i] + "Width",
                    true,
                    styles
                  );

                  // But still keep track of it otherwise
                } else {
                  extra += jQuery.css(
                    elem,
                    "border" + cssExpand[i] + "Width",
                    true,
                    styles
                  );
                }

                // If we get here with a border-box (content + padding + border), we're seeking "content" or
                // "padding" or "margin"
              } else {
                // For "content", subtract padding
                if (box === "content") {
                  delta -= jQuery.css(
                    elem,
                    "padding" + cssExpand[i],
                    true,
                    styles
                  );
                }

                // For "content" or "padding", subtract border
                if (box !== "margin") {
                  delta -= jQuery.css(
                    elem,
                    "border" + cssExpand[i] + "Width",
                    true,
                    styles
                  );
                }
              }
            }

            // Account for positive content-box scroll gutter when requested by providing computedVal
            if (!isBorderBox && computedVal >= 0) {
              // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
              // Assuming integer scroll gutter, subtract the rest and round down
              delta +=
                Math.max(
                  0,
                  Math.ceil(
                    elem[
                      "offset" + dimension[0].toUpperCase() + dimension.slice(1)
                    ] -
                      computedVal -
                      delta -
                      extra -
                      0.5

                    // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
                    // Use an explicit zero to avoid NaN (gh-3964)
                  )
                ) || 0;
            }

            return delta;
          }

          function getWidthOrHeight(elem, dimension, extra) {
            // Start with computed style
            var styles = getStyles(elem),
              // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
              // Fake content-box until we know it's needed to know the true value.
              boxSizingNeeded = !support.boxSizingReliable() || extra,
              isBorderBox =
                boxSizingNeeded &&
                jQuery.css(elem, "boxSizing", false, styles) === "border-box",
              valueIsBorderBox = isBorderBox,
              val = curCSS(elem, dimension, styles),
              offsetProp =
                "offset" + dimension[0].toUpperCase() + dimension.slice(1);

            // Support: Firefox <=54
            // Return a confounding non-pixel value or feign ignorance, as appropriate.
            if (rnumnonpx.test(val)) {
              if (!extra) {
                return val;
              }
              val = "auto";
            }

            // Fall back to offsetWidth/offsetHeight when value is "auto"
            // This happens for inline elements with no explicit setting (gh-3571)
            // Support: Android <=4.1 - 4.3 only
            // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
            // Support: IE 9-11 only
            // Also use offsetWidth/offsetHeight for when box sizing is unreliable
            // We use getClientRects() to check for hidden/disconnected.
            // In those cases, the computed value can be trusted to be border-box
            if (
              ((!support.boxSizingReliable() && isBorderBox) ||
                val === "auto" ||
                (!parseFloat(val) &&
                  jQuery.css(elem, "display", false, styles) === "inline")) &&
              elem.getClientRects().length
            ) {
              isBorderBox =
                jQuery.css(elem, "boxSizing", false, styles) === "border-box";

              // Where available, offsetWidth/offsetHeight approximate border box dimensions.
              // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
              // retrieved value as a content box dimension.
              valueIsBorderBox = offsetProp in elem;
              if (valueIsBorderBox) {
                val = elem[offsetProp];
              }
            }

            // Normalize "" and auto
            val = parseFloat(val) || 0;

            // Adjust for the element's box model
            return (
              val +
              boxModelAdjustment(
                elem,
                dimension,
                extra || (isBorderBox ? "border" : "content"),
                valueIsBorderBox,
                styles,

                // Provide the current computed size to request scroll gutter calculation (gh-3589)
                val
              ) +
              "px"
            );
          }

          jQuery.extend({
            // Add in style property hooks for overriding the default
            // behavior of getting and setting a style property
            cssHooks: {
              opacity: {
                get: function (elem, computed) {
                  if (computed) {
                    // We should always get a number back from opacity
                    var ret = curCSS(elem, "opacity");
                    return ret === "" ? "1" : ret;
                  }
                },
              },
            },

            // Don't automatically add "px" to these possibly-unitless properties
            cssNumber: {
              animationIterationCount: true,
              columnCount: true,
              fillOpacity: true,
              flexGrow: true,
              flexShrink: true,
              fontWeight: true,
              gridArea: true,
              gridColumn: true,
              gridColumnEnd: true,
              gridColumnStart: true,
              gridRow: true,
              gridRowEnd: true,
              gridRowStart: true,
              lineHeight: true,
              opacity: true,
              order: true,
              orphans: true,
              widows: true,
              zIndex: true,
              zoom: true,
            },

            // Add in properties whose names you wish to fix before
            // setting or getting the value
            cssProps: {},

            // Get and set the style property on a DOM Node
            style: function (elem, name, value, extra) {
              // Don't set styles on text and comment nodes
              if (
                !elem ||
                elem.nodeType === 3 ||
                elem.nodeType === 8 ||
                !elem.style
              ) {
                return;
              }

              // Make sure that we're working with the right name
              var ret,
                type,
                hooks,
                origName = camelCase(name),
                isCustomProp = rcustomProp.test(name),
                style = elem.style;

              // Make sure that we're working with the right name. We don't
              // want to query the value if it is a CSS custom property
              // since they are user-defined.
              if (!isCustomProp) {
                name = finalPropName(origName);
              }

              // Gets hook for the prefixed version, then unprefixed version
              hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

              // Check if we're setting a value
              if (value !== undefined) {
                type = typeof value;

                // Convert "+=" or "-=" to relative numbers (#7345)
                if (
                  type === "string" &&
                  (ret = rcssNum.exec(value)) &&
                  ret[1]
                ) {
                  value = adjustCSS(elem, name, ret);

                  // Fixes bug #9237
                  type = "number";
                }

                // Make sure that null and NaN values aren't set (#7116)
                if (value == null || value !== value) {
                  return;
                }

                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) {
                  value +=
                    (ret && ret[3]) || (jQuery.cssNumber[origName] ? "" : "px");
                }

                // background-* props affect original clone's values
                if (
                  !support.clearCloneStyle &&
                  value === "" &&
                  name.indexOf("background") === 0
                ) {
                  style[name] = "inherit";
                }

                // If a hook was provided, use that value, otherwise just set the specified value
                if (
                  !hooks ||
                  !("set" in hooks) ||
                  (value = hooks.set(elem, value, extra)) !== undefined
                ) {
                  if (isCustomProp) {
                    style.setProperty(name, value);
                  } else {
                    style[name] = value;
                  }
                }
              } else {
                // If a hook was provided get the non-computed value from there
                if (
                  hooks &&
                  "get" in hooks &&
                  (ret = hooks.get(elem, false, extra)) !== undefined
                ) {
                  return ret;
                }

                // Otherwise just get the value from the style object
                return style[name];
              }
            },

            css: function (elem, name, extra, styles) {
              var val,
                num,
                hooks,
                origName = camelCase(name),
                isCustomProp = rcustomProp.test(name);

              // Make sure that we're working with the right name. We don't
              // want to modify the value if it is a CSS custom property
              // since they are user-defined.
              if (!isCustomProp) {
                name = finalPropName(origName);
              }

              // Try prefixed name followed by the unprefixed name
              hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

              // If a hook was provided get the computed value from there
              if (hooks && "get" in hooks) {
                val = hooks.get(elem, true, extra);
              }

              // Otherwise, if a way to get the computed value exists, use that
              if (val === undefined) {
                val = curCSS(elem, name, styles);
              }

              // Convert "normal" to computed value
              if (val === "normal" && name in cssNormalTransform) {
                val = cssNormalTransform[name];
              }

              // Make numeric if forced or a qualifier was provided and val looks numeric
              if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
              }

              return val;
            },
          });

          jQuery.each(["height", "width"], function (i, dimension) {
            jQuery.cssHooks[dimension] = {
              get: function (elem, computed, extra) {
                if (computed) {
                  // Certain elements can have dimension info if we invisibly show them
                  // but it must have a current display style that would benefit
                  return rdisplayswap.test(jQuery.css(elem, "display")) &&
                    // Support: Safari 8+
                    // Table columns in Safari have non-zero offsetWidth & zero
                    // getBoundingClientRect().width unless display is changed.
                    // Support: IE <=11 only
                    // Running getBoundingClientRect on a disconnected node
                    // in IE throws an error.
                    (!elem.getClientRects().length ||
                      !elem.getBoundingClientRect().width)
                    ? swap(elem, cssShow, function () {
                        return getWidthOrHeight(elem, dimension, extra);
                      })
                    : getWidthOrHeight(elem, dimension, extra);
                }
              },

              set: function (elem, value, extra) {
                var matches,
                  styles = getStyles(elem),
                  // Only read styles.position if the test has a chance to fail
                  // to avoid forcing a reflow.
                  scrollboxSizeBuggy =
                    !support.scrollboxSize() && styles.position === "absolute",
                  // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                  boxSizingNeeded = scrollboxSizeBuggy || extra,
                  isBorderBox =
                    boxSizingNeeded &&
                    jQuery.css(elem, "boxSizing", false, styles) ===
                      "border-box",
                  subtract = extra
                    ? boxModelAdjustment(
                        elem,
                        dimension,
                        extra,
                        isBorderBox,
                        styles
                      )
                    : 0;

                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) {
                  subtract -= Math.ceil(
                    elem[
                      "offset" + dimension[0].toUpperCase() + dimension.slice(1)
                    ] -
                      parseFloat(styles[dimension]) -
                      boxModelAdjustment(
                        elem,
                        dimension,
                        "border",
                        false,
                        styles
                      ) -
                      0.5
                  );
                }

                // Convert to pixels if value adjustment is needed
                if (
                  subtract &&
                  (matches = rcssNum.exec(value)) &&
                  (matches[3] || "px") !== "px"
                ) {
                  elem.style[dimension] = value;
                  value = jQuery.css(elem, dimension);
                }

                return setPositiveNumber(elem, value, subtract);
              },
            };
          });

          jQuery.cssHooks.marginLeft = addGetHookIf(
            support.reliableMarginLeft,
            function (elem, computed) {
              if (computed) {
                return (
                  (parseFloat(curCSS(elem, "marginLeft")) ||
                    elem.getBoundingClientRect().left -
                      swap(elem, { marginLeft: 0 }, function () {
                        return elem.getBoundingClientRect().left;
                      })) + "px"
                );
              }
            }
          );

          // These hooks are used by animate to expand properties
          jQuery.each(
            {
              margin: "",
              padding: "",
              border: "Width",
            },
            function (prefix, suffix) {
              jQuery.cssHooks[prefix + suffix] = {
                expand: function (value) {
                  var i = 0,
                    expanded = {},
                    // Assumes a single number if not a string
                    parts =
                      typeof value === "string" ? value.split(" ") : [value];

                  for (; i < 4; i++) {
                    expanded[prefix + cssExpand[i] + suffix] =
                      parts[i] || parts[i - 2] || parts[0];
                  }

                  return expanded;
                },
              };

              if (prefix !== "margin") {
                jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
              }
            }
          );

          jQuery.fn.extend({
            css: function (name, value) {
              return access(
                this,
                function (elem, name, value) {
                  var styles,
                    len,
                    map = {},
                    i = 0;

                  if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;

                    for (; i < len; i++) {
                      map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    }

                    return map;
                  }

                  return value !== undefined
                    ? jQuery.style(elem, name, value)
                    : jQuery.css(elem, name);
                },
                name,
                value,
                arguments.length > 1
              );
            },
          });

          function Tween(elem, options, prop, end, easing) {
            return new Tween.prototype.init(elem, options, prop, end, easing);
          }
          jQuery.Tween = Tween;

          Tween.prototype = {
            constructor: Tween,
            init: function (elem, options, prop, end, easing, unit) {
              this.elem = elem;
              this.prop = prop;
              this.easing = easing || jQuery.easing._default;
              this.options = options;
              this.start = this.now = this.cur();
              this.end = end;
              this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
            },
            cur: function () {
              var hooks = Tween.propHooks[this.prop];

              return hooks && hooks.get
                ? hooks.get(this)
                : Tween.propHooks._default.get(this);
            },
            run: function (percent) {
              var eased,
                hooks = Tween.propHooks[this.prop];

              if (this.options.duration) {
                this.pos = eased = jQuery.easing[this.easing](
                  percent,
                  this.options.duration * percent,
                  0,
                  1,
                  this.options.duration
                );
              } else {
                this.pos = eased = percent;
              }
              this.now = (this.end - this.start) * eased + this.start;

              if (this.options.step) {
                this.options.step.call(this.elem, this.now, this);
              }

              if (hooks && hooks.set) {
                hooks.set(this);
              } else {
                Tween.propHooks._default.set(this);
              }
              return this;
            },
          };

          Tween.prototype.init.prototype = Tween.prototype;

          Tween.propHooks = {
            _default: {
              get: function (tween) {
                var result;

                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (
                  tween.elem.nodeType !== 1 ||
                  (tween.elem[tween.prop] != null &&
                    tween.elem.style[tween.prop] == null)
                ) {
                  return tween.elem[tween.prop];
                }

                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");

                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
              },
              set: function (tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) {
                  jQuery.fx.step[tween.prop](tween);
                } else if (
                  tween.elem.nodeType === 1 &&
                  (jQuery.cssHooks[tween.prop] ||
                    tween.elem.style[finalPropName(tween.prop)] != null)
                ) {
                  jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                } else {
                  tween.elem[tween.prop] = tween.now;
                }
              },
            },
          };

          // Support: IE <=9 only
          // Panic based approach to setting things on disconnected nodes
          Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
            set: function (tween) {
              if (tween.elem.nodeType && tween.elem.parentNode) {
                tween.elem[tween.prop] = tween.now;
              }
            },
          };

          jQuery.easing = {
            linear: function (p) {
              return p;
            },
            swing: function (p) {
              return 0.5 - Math.cos(p * Math.PI) / 2;
            },
            _default: "swing",
          };

          jQuery.fx = Tween.prototype.init;

          // Back compat <1.8 extension point
          jQuery.fx.step = {};

          var fxNow,
            inProgress,
            rfxtypes = /^(?:toggle|show|hide)$/,
            rrun = /queueHooks$/;

          function schedule() {
            if (inProgress) {
              if (document.hidden === false && window.requestAnimationFrame) {
                window.requestAnimationFrame(schedule);
              } else {
                window.setTimeout(schedule, jQuery.fx.interval);
              }

              jQuery.fx.tick();
            }
          }

          // Animations created synchronously will run synchronously
          function createFxNow() {
            window.setTimeout(function () {
              fxNow = undefined;
            });
            return (fxNow = Date.now());
          }

          // Generate parameters to create a standard animation
          function genFx(type, includeWidth) {
            var which,
              i = 0,
              attrs = { height: type };

            // If we include width, step value is 1 to do all cssExpand values,
            // otherwise step value is 2 to skip over Left and Right
            includeWidth = includeWidth ? 1 : 0;
            for (; i < 4; i += 2 - includeWidth) {
              which = cssExpand[i];
              attrs["margin" + which] = attrs["padding" + which] = type;
            }

            if (includeWidth) {
              attrs.opacity = attrs.width = type;
            }

            return attrs;
          }

          function createTween(value, prop, animation) {
            var tween,
              collection = (Animation.tweeners[prop] || []).concat(
                Animation.tweeners["*"]
              ),
              index = 0,
              length = collection.length;
            for (; index < length; index++) {
              if ((tween = collection[index].call(animation, prop, value))) {
                // We're done with this property
                return tween;
              }
            }
          }

          function defaultPrefilter(elem, props, opts) {
            var prop,
              value,
              toggle,
              hooks,
              oldfire,
              propTween,
              restoreDisplay,
              display,
              isBox = "width" in props || "height" in props,
              anim = this,
              orig = {},
              style = elem.style,
              hidden = elem.nodeType && isHiddenWithinTree(elem),
              dataShow = dataPriv.get(elem, "fxshow");

            // Queue-skipping animations hijack the fx hooks
            if (!opts.queue) {
              hooks = jQuery._queueHooks(elem, "fx");
              if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function () {
                  if (!hooks.unqueued) {
                    oldfire();
                  }
                };
              }
              hooks.unqueued++;

              anim.always(function () {
                // Ensure the complete handler is called before this completes
                anim.always(function () {
                  hooks.unqueued--;
                  if (!jQuery.queue(elem, "fx").length) {
                    hooks.empty.fire();
                  }
                });
              });
            }

            // Detect show/hide animations
            for (prop in props) {
              value = props[prop];
              if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                  // Pretend to be hidden if this is a "show" and
                  // there is still data from a stopped show/hide
                  if (
                    value === "show" &&
                    dataShow &&
                    dataShow[prop] !== undefined
                  ) {
                    hidden = true;

                    // Ignore all other no-op show/hide data
                  } else {
                    continue;
                  }
                }
                orig[prop] =
                  (dataShow && dataShow[prop]) || jQuery.style(elem, prop);
              }
            }

            // Bail out if this is a no-op like .hide().hide()
            propTween = !jQuery.isEmptyObject(props);
            if (!propTween && jQuery.isEmptyObject(orig)) {
              return;
            }

            // Restrict "overflow" and "display" styles during box animations
            if (isBox && elem.nodeType === 1) {
              // Support: IE <=9 - 11, Edge 12 - 15
              // Record all 3 overflow attributes because IE does not infer the shorthand
              // from identically-valued overflowX and overflowY and Edge just mirrors
              // the overflowX value there.
              opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY,
              ];

              // Identify a display type, preferring old show/hide data over the CSS cascade
              restoreDisplay = dataShow && dataShow.display;
              if (restoreDisplay == null) {
                restoreDisplay = dataPriv.get(elem, "display");
              }
              display = jQuery.css(elem, "display");
              if (display === "none") {
                if (restoreDisplay) {
                  display = restoreDisplay;
                } else {
                  // Get nonempty value(s) by temporarily forcing visibility
                  showHide([elem], true);
                  restoreDisplay = elem.style.display || restoreDisplay;
                  display = jQuery.css(elem, "display");
                  showHide([elem]);
                }
              }

              // Animate inline elements as inline-block
              if (
                display === "inline" ||
                (display === "inline-block" && restoreDisplay != null)
              ) {
                if (jQuery.css(elem, "float") === "none") {
                  // Restore the original display value at the end of pure show/hide animations
                  if (!propTween) {
                    anim.done(function () {
                      style.display = restoreDisplay;
                    });
                    if (restoreDisplay == null) {
                      display = style.display;
                      restoreDisplay = display === "none" ? "" : display;
                    }
                  }
                  style.display = "inline-block";
                }
              }
            }

            if (opts.overflow) {
              style.overflow = "hidden";
              anim.always(function () {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
              });
            }

            // Implement show/hide animations
            propTween = false;
            for (prop in orig) {
              // General show/hide setup for this element animation
              if (!propTween) {
                if (dataShow) {
                  if ("hidden" in dataShow) {
                    hidden = dataShow.hidden;
                  }
                } else {
                  dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay,
                  });
                }

                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) {
                  dataShow.hidden = !hidden;
                }

                // Show elements before animating them
                if (hidden) {
                  showHide([elem], true);
                }

                /* eslint-disable no-loop-func */

                anim.done(function () {
                  /* eslint-enable no-loop-func */

                  // The final step of a "hide" animation is actually hiding the element
                  if (!hidden) {
                    showHide([elem]);
                  }
                  dataPriv.remove(elem, "fxshow");
                  for (prop in orig) {
                    jQuery.style(elem, prop, orig[prop]);
                  }
                });
              }

              // Per-property setup
              propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
              if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                  propTween.end = propTween.start;
                  propTween.start = 0;
                }
              }
            }
          }

          function propFilter(props, specialEasing) {
            var index, name, easing, value, hooks;

            // camelCase, specialEasing and expand cssHook pass
            for (index in props) {
              name = camelCase(index);
              easing = specialEasing[name];
              value = props[index];
              if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
              }

              if (index !== name) {
                props[name] = value;
                delete props[index];
              }

              hooks = jQuery.cssHooks[name];
              if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];

                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for (index in value) {
                  if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                  }
                }
              } else {
                specialEasing[name] = easing;
              }
            }
          }

          function Animation(elem, properties, options) {
            var result,
              stopped,
              index = 0,
              length = Animation.prefilters.length,
              deferred = jQuery.Deferred().always(function () {
                // Don't match elem in the :animated selector
                delete tick.elem;
              }),
              tick = function () {
                if (stopped) {
                  return false;
                }
                var currentTime = fxNow || createFxNow(),
                  remaining = Math.max(
                    0,
                    animation.startTime + animation.duration - currentTime
                  ),
                  // Support: Android 2.3 only
                  // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
                  temp = remaining / animation.duration || 0,
                  percent = 1 - temp,
                  index = 0,
                  length = animation.tweens.length;

                for (; index < length; index++) {
                  animation.tweens[index].run(percent);
                }

                deferred.notifyWith(elem, [animation, percent, remaining]);

                // If there's more to do, yield
                if (percent < 1 && length) {
                  return remaining;
                }

                // If this was an empty animation, synthesize a final progress notification
                if (!length) {
                  deferred.notifyWith(elem, [animation, 1, 0]);
                }

                // Resolve the animation and report its conclusion
                deferred.resolveWith(elem, [animation]);
                return false;
              },
              animation = deferred.promise({
                elem: elem,
                props: jQuery.extend({}, properties),
                opts: jQuery.extend(
                  true,
                  {
                    specialEasing: {},
                    easing: jQuery.easing._default,
                  },
                  options
                ),
                originalProperties: properties,
                originalOptions: options,
                startTime: fxNow || createFxNow(),
                duration: options.duration,
                tweens: [],
                createTween: function (prop, end) {
                  var tween = jQuery.Tween(
                    elem,
                    animation.opts,
                    prop,
                    end,
                    animation.opts.specialEasing[prop] || animation.opts.easing
                  );
                  animation.tweens.push(tween);
                  return tween;
                },
                stop: function (gotoEnd) {
                  var index = 0,
                    // If we are going to the end, we want to run all the tweens
                    // otherwise we skip this part
                    length = gotoEnd ? animation.tweens.length : 0;
                  if (stopped) {
                    return this;
                  }
                  stopped = true;
                  for (; index < length; index++) {
                    animation.tweens[index].run(1);
                  }

                  // Resolve when we played the last frame; otherwise, reject
                  if (gotoEnd) {
                    deferred.notifyWith(elem, [animation, 1, 0]);
                    deferred.resolveWith(elem, [animation, gotoEnd]);
                  } else {
                    deferred.rejectWith(elem, [animation, gotoEnd]);
                  }
                  return this;
                },
              }),
              props = animation.props;

            propFilter(props, animation.opts.specialEasing);

            for (; index < length; index++) {
              result = Animation.prefilters[index].call(
                animation,
                elem,
                props,
                animation.opts
              );
              if (result) {
                if (isFunction(result.stop)) {
                  jQuery._queueHooks(
                    animation.elem,
                    animation.opts.queue
                  ).stop = result.stop.bind(result);
                }
                return result;
              }
            }

            jQuery.map(props, createTween, animation);

            if (isFunction(animation.opts.start)) {
              animation.opts.start.call(elem, animation);
            }

            // Attach callbacks from options
            animation
              .progress(animation.opts.progress)
              .done(animation.opts.done, animation.opts.complete)
              .fail(animation.opts.fail)
              .always(animation.opts.always);

            jQuery.fx.timer(
              jQuery.extend(tick, {
                elem: elem,
                anim: animation,
                queue: animation.opts.queue,
              })
            );

            return animation;
          }

          jQuery.Animation = jQuery.extend(Animation, {
            tweeners: {
              "*": [
                function (prop, value) {
                  var tween = this.createTween(prop, value);
                  adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                  return tween;
                },
              ],
            },

            tweener: function (props, callback) {
              if (isFunction(props)) {
                callback = props;
                props = ["*"];
              } else {
                props = props.match(rnothtmlwhite);
              }

              var prop,
                index = 0,
                length = props.length;

              for (; index < length; index++) {
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
              }
            },

            prefilters: [defaultPrefilter],

            prefilter: function (callback, prepend) {
              if (prepend) {
                Animation.prefilters.unshift(callback);
              } else {
                Animation.prefilters.push(callback);
              }
            },
          });

          jQuery.speed = function (speed, easing, fn) {
            var opt =
              speed && typeof speed === "object"
                ? jQuery.extend({}, speed)
                : {
                    complete:
                      fn || (!fn && easing) || (isFunction(speed) && speed),
                    duration: speed,
                    easing:
                      (fn && easing) ||
                      (easing && !isFunction(easing) && easing),
                  };

            // Go to the end state if fx are off
            if (jQuery.fx.off) {
              opt.duration = 0;
            } else {
              if (typeof opt.duration !== "number") {
                if (opt.duration in jQuery.fx.speeds) {
                  opt.duration = jQuery.fx.speeds[opt.duration];
                } else {
                  opt.duration = jQuery.fx.speeds._default;
                }
              }
            }

            // Normalize opt.queue - true/undefined/null -> "fx"
            if (opt.queue == null || opt.queue === true) {
              opt.queue = "fx";
            }

            // Queueing
            opt.old = opt.complete;

            opt.complete = function () {
              if (isFunction(opt.old)) {
                opt.old.call(this);
              }

              if (opt.queue) {
                jQuery.dequeue(this, opt.queue);
              }
            };

            return opt;
          };

          jQuery.fn.extend({
            fadeTo: function (speed, to, easing, callback) {
              // Show any hidden elements after setting opacity to 0
              return (
                this.filter(isHiddenWithinTree)
                  .css("opacity", 0)
                  .show()

                  // Animate to the value specified
                  .end()
                  .animate({ opacity: to }, speed, easing, callback)
              );
            },
            animate: function (prop, speed, easing, callback) {
              var empty = jQuery.isEmptyObject(prop),
                optall = jQuery.speed(speed, easing, callback),
                doAnimation = function () {
                  // Operate on a copy of prop so per-property easing won't be lost
                  var anim = Animation(this, jQuery.extend({}, prop), optall);

                  // Empty animations, or finishing resolves immediately
                  if (empty || dataPriv.get(this, "finish")) {
                    anim.stop(true);
                  }
                };
              doAnimation.finish = doAnimation;

              return empty || optall.queue === false
                ? this.each(doAnimation)
                : this.queue(optall.queue, doAnimation);
            },
            stop: function (type, clearQueue, gotoEnd) {
              var stopQueue = function (hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
              };

              if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
              }
              if (clearQueue && type !== false) {
                this.queue(type || "fx", []);
              }

              return this.each(function () {
                var dequeue = true,
                  index = type != null && type + "queueHooks",
                  timers = jQuery.timers,
                  data = dataPriv.get(this);

                if (index) {
                  if (data[index] && data[index].stop) {
                    stopQueue(data[index]);
                  }
                } else {
                  for (index in data) {
                    if (data[index] && data[index].stop && rrun.test(index)) {
                      stopQueue(data[index]);
                    }
                  }
                }

                for (index = timers.length; index--; ) {
                  if (
                    timers[index].elem === this &&
                    (type == null || timers[index].queue === type)
                  ) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                  }
                }

                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) {
                  jQuery.dequeue(this, type);
                }
              });
            },
            finish: function (type) {
              if (type !== false) {
                type = type || "fx";
              }
              return this.each(function () {
                var index,
                  data = dataPriv.get(this),
                  queue = data[type + "queue"],
                  hooks = data[type + "queueHooks"],
                  timers = jQuery.timers,
                  length = queue ? queue.length : 0;

                // Enable finishing flag on private data
                data.finish = true;

                // Empty the queue first
                jQuery.queue(this, type, []);

                if (hooks && hooks.stop) {
                  hooks.stop.call(this, true);
                }

                // Look for any active animations, and finish them
                for (index = timers.length; index--; ) {
                  if (
                    timers[index].elem === this &&
                    timers[index].queue === type
                  ) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                  }
                }

                // Look for any animations in the old queue and finish them
                for (index = 0; index < length; index++) {
                  if (queue[index] && queue[index].finish) {
                    queue[index].finish.call(this);
                  }
                }

                // Turn off finishing flag
                delete data.finish;
              });
            },
          });

          jQuery.each(["toggle", "show", "hide"], function (i, name) {
            var cssFn = jQuery.fn[name];
            jQuery.fn[name] = function (speed, easing, callback) {
              return speed == null || typeof speed === "boolean"
                ? cssFn.apply(this, arguments)
                : this.animate(genFx(name, true), speed, easing, callback);
            };
          });

          // Generate shortcuts for custom animations
          jQuery.each(
            {
              slideDown: genFx("show"),
              slideUp: genFx("hide"),
              slideToggle: genFx("toggle"),
              fadeIn: { opacity: "show" },
              fadeOut: { opacity: "hide" },
              fadeToggle: { opacity: "toggle" },
            },
            function (name, props) {
              jQuery.fn[name] = function (speed, easing, callback) {
                return this.animate(props, speed, easing, callback);
              };
            }
          );

          jQuery.timers = [];
          jQuery.fx.tick = function () {
            var timer,
              i = 0,
              timers = jQuery.timers;

            fxNow = Date.now();

            for (; i < timers.length; i++) {
              timer = timers[i];

              // Run the timer and safely remove it when done (allowing for external removal)
              if (!timer() && timers[i] === timer) {
                timers.splice(i--, 1);
              }
            }

            if (!timers.length) {
              jQuery.fx.stop();
            }
            fxNow = undefined;
          };

          jQuery.fx.timer = function (timer) {
            jQuery.timers.push(timer);
            jQuery.fx.start();
          };

          jQuery.fx.interval = 13;
          jQuery.fx.start = function () {
            if (inProgress) {
              return;
            }

            inProgress = true;
            schedule();
          };

          jQuery.fx.stop = function () {
            inProgress = null;
          };

          jQuery.fx.speeds = {
            slow: 600,
            fast: 200,

            // Default speed
            _default: 400,
          };

          // Based off of the plugin by Clint Helfers, with permission.
          // https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
          jQuery.fn.delay = function (time, type) {
            time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
            type = type || "fx";

            return this.queue(type, function (next, hooks) {
              var timeout = window.setTimeout(next, time);
              hooks.stop = function () {
                window.clearTimeout(timeout);
              };
            });
          };

          (function () {
            var input = document.createElement("input"),
              select = document.createElement("select"),
              opt = select.appendChild(document.createElement("option"));

            input.type = "checkbox";

            // Support: Android <=4.3 only
            // Default value for a checkbox should be "on"
            support.checkOn = input.value !== "";

            // Support: IE <=11 only
            // Must access selectedIndex to make default options select
            support.optSelected = opt.selected;

            // Support: IE <=11 only
            // An input loses its value after becoming a radio
            input = document.createElement("input");
            input.value = "t";
            input.type = "radio";
            support.radioValue = input.value === "t";
          })();

          var boolHook,
            attrHandle = jQuery.expr.attrHandle;

          jQuery.fn.extend({
            attr: function (name, value) {
              return access(
                this,
                jQuery.attr,
                name,
                value,
                arguments.length > 1
              );
            },

            removeAttr: function (name) {
              return this.each(function () {
                jQuery.removeAttr(this, name);
              });
            },
          });

          jQuery.extend({
            attr: function (elem, name, value) {
              var ret,
                hooks,
                nType = elem.nodeType;

              // Don't get/set attributes on text, comment and attribute nodes
              if (nType === 3 || nType === 8 || nType === 2) {
                return;
              }

              // Fallback to prop when attributes are not supported
              if (typeof elem.getAttribute === "undefined") {
                return jQuery.prop(elem, name, value);
              }

              // Attribute hooks are determined by the lowercase version
              // Grab necessary hook if one is defined
              if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                hooks =
                  jQuery.attrHooks[name.toLowerCase()] ||
                  (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
              }

              if (value !== undefined) {
                if (value === null) {
                  jQuery.removeAttr(elem, name);
                  return;
                }

                if (
                  hooks &&
                  "set" in hooks &&
                  (ret = hooks.set(elem, value, name)) !== undefined
                ) {
                  return ret;
                }

                elem.setAttribute(name, value + "");
                return value;
              }

              if (
                hooks &&
                "get" in hooks &&
                (ret = hooks.get(elem, name)) !== null
              ) {
                return ret;
              }

              ret = jQuery.find.attr(elem, name);

              // Non-existent attributes return null, we normalize to undefined
              return ret == null ? undefined : ret;
            },

            attrHooks: {
              type: {
                set: function (elem, value) {
                  if (
                    !support.radioValue &&
                    value === "radio" &&
                    nodeName(elem, "input")
                  ) {
                    var val = elem.value;
                    elem.setAttribute("type", value);
                    if (val) {
                      elem.value = val;
                    }
                    return value;
                  }
                },
              },
            },

            removeAttr: function (elem, value) {
              var name,
                i = 0,
                // Attribute names can contain non-HTML whitespace characters
                // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
                attrNames = value && value.match(rnothtmlwhite);

              if (attrNames && elem.nodeType === 1) {
                while ((name = attrNames[i++])) {
                  elem.removeAttribute(name);
                }
              }
            },
          });

          // Hooks for boolean attributes
          boolHook = {
            set: function (elem, value, name) {
              if (value === false) {
                // Remove boolean attributes when set to false
                jQuery.removeAttr(elem, name);
              } else {
                elem.setAttribute(name, name);
              }
              return name;
            },
          };

          jQuery.each(
            jQuery.expr.match.bool.source.match(/\w+/g),
            function (i, name) {
              var getter = attrHandle[name] || jQuery.find.attr;

              attrHandle[name] = function (elem, name, isXML) {
                var ret,
                  handle,
                  lowercaseName = name.toLowerCase();

                if (!isXML) {
                  // Avoid an infinite loop by temporarily removing this function from the getter
                  handle = attrHandle[lowercaseName];
                  attrHandle[lowercaseName] = ret;
                  ret =
                    getter(elem, name, isXML) != null ? lowercaseName : null;
                  attrHandle[lowercaseName] = handle;
                }
                return ret;
              };
            }
          );

          var rfocusable = /^(?:input|select|textarea|button)$/i,
            rclickable = /^(?:a|area)$/i;

          jQuery.fn.extend({
            prop: function (name, value) {
              return access(
                this,
                jQuery.prop,
                name,
                value,
                arguments.length > 1
              );
            },

            removeProp: function (name) {
              return this.each(function () {
                delete this[jQuery.propFix[name] || name];
              });
            },
          });

          jQuery.extend({
            prop: function (elem, name, value) {
              var ret,
                hooks,
                nType = elem.nodeType;

              // Don't get/set properties on text, comment and attribute nodes
              if (nType === 3 || nType === 8 || nType === 2) {
                return;
              }

              if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
              }

              if (value !== undefined) {
                if (
                  hooks &&
                  "set" in hooks &&
                  (ret = hooks.set(elem, value, name)) !== undefined
                ) {
                  return ret;
                }

                return (elem[name] = value);
              }

              if (
                hooks &&
                "get" in hooks &&
                (ret = hooks.get(elem, name)) !== null
              ) {
                return ret;
              }

              return elem[name];
            },

            propHooks: {
              tabIndex: {
                get: function (elem) {
                  // Support: IE <=9 - 11 only
                  // elem.tabIndex doesn't always return the
                  // correct value when it hasn't been explicitly set
                  // https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
                  // Use proper attribute retrieval(#12072)
                  var tabindex = jQuery.find.attr(elem, "tabindex");

                  if (tabindex) {
                    return parseInt(tabindex, 10);
                  }

                  if (
                    rfocusable.test(elem.nodeName) ||
                    (rclickable.test(elem.nodeName) && elem.href)
                  ) {
                    return 0;
                  }

                  return -1;
                },
              },
            },

            propFix: {
              for: "htmlFor",
              class: "className",
            },
          });

          // Support: IE <=11 only
          // Accessing the selectedIndex property
          // forces the browser to respect setting selected
          // on the option
          // The getter ensures a default option is selected
          // when in an optgroup
          // eslint rule "no-unused-expressions" is disabled for this code
          // since it considers such accessions noop
          if (!support.optSelected) {
            jQuery.propHooks.selected = {
              get: function (elem) {
                /* eslint no-unused-expressions: "off" */

                var parent = elem.parentNode;
                if (parent && parent.parentNode) {
                  parent.parentNode.selectedIndex;
                }
                return null;
              },
              set: function (elem) {
                /* eslint no-unused-expressions: "off" */

                var parent = elem.parentNode;
                if (parent) {
                  parent.selectedIndex;

                  if (parent.parentNode) {
                    parent.parentNode.selectedIndex;
                  }
                }
              },
            };
          }

          jQuery.each(
            [
              "tabIndex",
              "readOnly",
              "maxLength",
              "cellSpacing",
              "cellPadding",
              "rowSpan",
              "colSpan",
              "useMap",
              "frameBorder",
              "contentEditable",
            ],
            function () {
              jQuery.propFix[this.toLowerCase()] = this;
            }
          );

          // Strip and collapse whitespace according to HTML spec
          // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
          function stripAndCollapse(value) {
            var tokens = value.match(rnothtmlwhite) || [];
            return tokens.join(" ");
          }

          function getClass(elem) {
            return (elem.getAttribute && elem.getAttribute("class")) || "";
          }

          function classesToArray(value) {
            if (Array.isArray(value)) {
              return value;
            }
            if (typeof value === "string") {
              return value.match(rnothtmlwhite) || [];
            }
            return [];
          }

          jQuery.fn.extend({
            addClass: function (value) {
              var classes,
                elem,
                cur,
                curValue,
                clazz,
                j,
                finalValue,
                i = 0;

              if (isFunction(value)) {
                return this.each(function (j) {
                  jQuery(this).addClass(value.call(this, j, getClass(this)));
                });
              }

              classes = classesToArray(value);

              if (classes.length) {
                while ((elem = this[i++])) {
                  curValue = getClass(elem);
                  cur =
                    elem.nodeType === 1 &&
                    " " + stripAndCollapse(curValue) + " ";

                  if (cur) {
                    j = 0;
                    while ((clazz = classes[j++])) {
                      if (cur.indexOf(" " + clazz + " ") < 0) {
                        cur += clazz + " ";
                      }
                    }

                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) {
                      elem.setAttribute("class", finalValue);
                    }
                  }
                }
              }

              return this;
            },

            removeClass: function (value) {
              var classes,
                elem,
                cur,
                curValue,
                clazz,
                j,
                finalValue,
                i = 0;

              if (isFunction(value)) {
                return this.each(function (j) {
                  jQuery(this).removeClass(value.call(this, j, getClass(this)));
                });
              }

              if (!arguments.length) {
                return this.attr("class", "");
              }

              classes = classesToArray(value);

              if (classes.length) {
                while ((elem = this[i++])) {
                  curValue = getClass(elem);

                  // This expression is here for better compressibility (see addClass)
                  cur =
                    elem.nodeType === 1 &&
                    " " + stripAndCollapse(curValue) + " ";

                  if (cur) {
                    j = 0;
                    while ((clazz = classes[j++])) {
                      // Remove *all* instances
                      while (cur.indexOf(" " + clazz + " ") > -1) {
                        cur = cur.replace(" " + clazz + " ", " ");
                      }
                    }

                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) {
                      elem.setAttribute("class", finalValue);
                    }
                  }
                }
              }

              return this;
            },

            toggleClass: function (value, stateVal) {
              var type = typeof value,
                isValidValue = type === "string" || Array.isArray(value);

              if (typeof stateVal === "boolean" && isValidValue) {
                return stateVal
                  ? this.addClass(value)
                  : this.removeClass(value);
              }

              if (isFunction(value)) {
                return this.each(function (i) {
                  jQuery(this).toggleClass(
                    value.call(this, i, getClass(this), stateVal),
                    stateVal
                  );
                });
              }

              return this.each(function () {
                var className, i, self, classNames;

                if (isValidValue) {
                  // Toggle individual class names
                  i = 0;
                  self = jQuery(this);
                  classNames = classesToArray(value);

                  while ((className = classNames[i++])) {
                    // Check each className given, space separated list
                    if (self.hasClass(className)) {
                      self.removeClass(className);
                    } else {
                      self.addClass(className);
                    }
                  }

                  // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                  className = getClass(this);
                  if (className) {
                    // Store className if set
                    dataPriv.set(this, "__className__", className);
                  }

                  // If the element has a class name or if we're passed `false`,
                  // then remove the whole classname (if there was one, the above saved it).
                  // Otherwise bring back whatever was previously saved (if anything),
                  // falling back to the empty string if nothing was stored.
                  if (this.setAttribute) {
                    this.setAttribute(
                      "class",
                      className || value === false
                        ? ""
                        : dataPriv.get(this, "__className__") || ""
                    );
                  }
                }
              });
            },

            hasClass: function (selector) {
              var className,
                elem,
                i = 0;

              className = " " + selector + " ";
              while ((elem = this[i++])) {
                if (
                  elem.nodeType === 1 &&
                  (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(
                    className
                  ) > -1
                ) {
                  return true;
                }
              }

              return false;
            },
          });

          var rreturn = /\r/g;

          jQuery.fn.extend({
            val: function (value) {
              var hooks,
                ret,
                valueIsFunction,
                elem = this[0];

              if (!arguments.length) {
                if (elem) {
                  hooks =
                    jQuery.valHooks[elem.type] ||
                    jQuery.valHooks[elem.nodeName.toLowerCase()];

                  if (
                    hooks &&
                    "get" in hooks &&
                    (ret = hooks.get(elem, "value")) !== undefined
                  ) {
                    return ret;
                  }

                  ret = elem.value;

                  // Handle most common string cases
                  if (typeof ret === "string") {
                    return ret.replace(rreturn, "");
                  }

                  // Handle cases where value is null/undef or number
                  return ret == null ? "" : ret;
                }

                return;
              }

              valueIsFunction = isFunction(value);

              return this.each(function (i) {
                var val;

                if (this.nodeType !== 1) {
                  return;
                }

                if (valueIsFunction) {
                  val = value.call(this, i, jQuery(this).val());
                } else {
                  val = value;
                }

                // Treat null/undefined as ""; convert numbers to string
                if (val == null) {
                  val = "";
                } else if (typeof val === "number") {
                  val += "";
                } else if (Array.isArray(val)) {
                  val = jQuery.map(val, function (value) {
                    return value == null ? "" : value + "";
                  });
                }

                hooks =
                  jQuery.valHooks[this.type] ||
                  jQuery.valHooks[this.nodeName.toLowerCase()];

                // If set returns undefined, fall back to normal setting
                if (
                  !hooks ||
                  !("set" in hooks) ||
                  hooks.set(this, val, "value") === undefined
                ) {
                  this.value = val;
                }
              });
            },
          });

          jQuery.extend({
            valHooks: {
              option: {
                get: function (elem) {
                  var val = jQuery.find.attr(elem, "value");
                  return val != null
                    ? val
                    : // Support: IE <=10 - 11 only
                      // option.text throws exceptions (#14686, #14858)
                      // Strip and collapse whitespace
                      // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                      stripAndCollapse(jQuery.text(elem));
                },
              },
              select: {
                get: function (elem) {
                  var value,
                    option,
                    i,
                    options = elem.options,
                    index = elem.selectedIndex,
                    one = elem.type === "select-one",
                    values = one ? null : [],
                    max = one ? index + 1 : options.length;

                  if (index < 0) {
                    i = max;
                  } else {
                    i = one ? index : 0;
                  }

                  // Loop through all the selected options
                  for (; i < max; i++) {
                    option = options[i];

                    // Support: IE <=9 only
                    // IE8-9 doesn't update selected after form reset (#2551)
                    if (
                      (option.selected || i === index) &&
                      // Don't return options that are disabled or in a disabled optgroup
                      !option.disabled &&
                      (!option.parentNode.disabled ||
                        !nodeName(option.parentNode, "optgroup"))
                    ) {
                      // Get the specific value for the option
                      value = jQuery(option).val();

                      // We don't need an array for one selects
                      if (one) {
                        return value;
                      }

                      // Multi-Selects return an array
                      values.push(value);
                    }
                  }

                  return values;
                },

                set: function (elem, value) {
                  var optionSet,
                    option,
                    options = elem.options,
                    values = jQuery.makeArray(value),
                    i = options.length;

                  while (i--) {
                    option = options[i];

                    /* eslint-disable no-cond-assign */

                    if (
                      (option.selected =
                        jQuery.inArray(
                          jQuery.valHooks.option.get(option),
                          values
                        ) > -1)
                    ) {
                      optionSet = true;
                    }

                    /* eslint-enable no-cond-assign */
                  }

                  // Force browsers to behave consistently when non-matching value is set
                  if (!optionSet) {
                    elem.selectedIndex = -1;
                  }
                  return values;
                },
              },
            },
          });

          // Radios and checkboxes getter/setter
          jQuery.each(["radio", "checkbox"], function () {
            jQuery.valHooks[this] = {
              set: function (elem, value) {
                if (Array.isArray(value)) {
                  return (elem.checked =
                    jQuery.inArray(jQuery(elem).val(), value) > -1);
                }
              },
            };
            if (!support.checkOn) {
              jQuery.valHooks[this].get = function (elem) {
                return elem.getAttribute("value") === null ? "on" : elem.value;
              };
            }
          });

          // Return jQuery for attributes-only inclusion

          support.focusin = "onfocusin" in window;

          var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
            stopPropagationCallback = function (e) {
              e.stopPropagation();
            };

          jQuery.extend(jQuery.event, {
            trigger: function (event, data, elem, onlyHandlers) {
              var i,
                cur,
                tmp,
                bubbleType,
                ontype,
                handle,
                special,
                lastElement,
                eventPath = [elem || document],
                type = hasOwn.call(event, "type") ? event.type : event,
                namespaces = hasOwn.call(event, "namespace")
                  ? event.namespace.split(".")
                  : [];

              cur = lastElement = tmp = elem = elem || document;

              // Don't do events on text and comment nodes
              if (elem.nodeType === 3 || elem.nodeType === 8) {
                return;
              }

              // focus/blur morphs to focusin/out; ensure we're not firing them right now
              if (rfocusMorph.test(type + jQuery.event.triggered)) {
                return;
              }

              if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
              }
              ontype = type.indexOf(":") < 0 && "on" + type;

              // Caller can pass in a jQuery.Event object, Object, or just an event type string
              event = event[jQuery.expando]
                ? event
                : new jQuery.Event(type, typeof event === "object" && event);

              // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
              event.isTrigger = onlyHandlers ? 2 : 3;
              event.namespace = namespaces.join(".");
              event.rnamespace = event.namespace
                ? new RegExp(
                    "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)"
                  )
                : null;

              // Clean up the event in case it is being reused
              event.result = undefined;
              if (!event.target) {
                event.target = elem;
              }

              // Clone any incoming data and prepend the event, creating the handler arg list
              data = data == null ? [event] : jQuery.makeArray(data, [event]);

              // Allow special events to draw outside the lines
              special = jQuery.event.special[type] || {};
              if (
                !onlyHandlers &&
                special.trigger &&
                special.trigger.apply(elem, data) === false
              ) {
                return;
              }

              // Determine event propagation path in advance, per W3C events spec (#9951)
              // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
              if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) {
                  cur = cur.parentNode;
                }
                for (; cur; cur = cur.parentNode) {
                  eventPath.push(cur);
                  tmp = cur;
                }

                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) {
                  eventPath.push(tmp.defaultView || tmp.parentWindow || window);
                }
              }

              // Fire handlers on the event path
              i = 0;
              while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;

                // jQuery handler
                handle =
                  (dataPriv.get(cur, "events") || {})[event.type] &&
                  dataPriv.get(cur, "handle");
                if (handle) {
                  handle.apply(cur, data);
                }

                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                  event.result = handle.apply(cur, data);
                  if (event.result === false) {
                    event.preventDefault();
                  }
                }
              }
              event.type = type;

              // If nobody prevented the default action, do it now
              if (!onlyHandlers && !event.isDefaultPrevented()) {
                if (
                  (!special._default ||
                    special._default.apply(eventPath.pop(), data) === false) &&
                  acceptData(elem)
                ) {
                  // Call a native DOM method on the target with the same name as the event.
                  // Don't do default actions on window, that's where global variables be (#6170)
                  if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                    // Don't re-trigger an onFOO event when we call its FOO() method
                    tmp = elem[ontype];

                    if (tmp) {
                      elem[ontype] = null;
                    }

                    // Prevent re-triggering of the same event, since we already bubbled it above
                    jQuery.event.triggered = type;

                    if (event.isPropagationStopped()) {
                      lastElement.addEventListener(
                        type,
                        stopPropagationCallback
                      );
                    }

                    elem[type]();

                    if (event.isPropagationStopped()) {
                      lastElement.removeEventListener(
                        type,
                        stopPropagationCallback
                      );
                    }

                    jQuery.event.triggered = undefined;

                    if (tmp) {
                      elem[ontype] = tmp;
                    }
                  }
                }
              }

              return event.result;
            },

            // Piggyback on a donor event to simulate a different one
            // Used only for `focus(in | out)` events
            simulate: function (type, elem, event) {
              var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true,
              });

              jQuery.event.trigger(e, null, elem);
            },
          });

          jQuery.fn.extend({
            trigger: function (type, data) {
              return this.each(function () {
                jQuery.event.trigger(type, data, this);
              });
            },
            triggerHandler: function (type, data) {
              var elem = this[0];
              if (elem) {
                return jQuery.event.trigger(type, data, elem, true);
              }
            },
          });

          // Support: Firefox <=44
          // Firefox doesn't have focus(in | out) events
          // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
          //
          // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
          // focus(in | out) events fire after focus & blur events,
          // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
          // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
          if (!support.focusin) {
            jQuery.each(
              { focus: "focusin", blur: "focusout" },
              function (orig, fix) {
                // Attach a single capturing handler on the document while someone wants focusin/focusout
                var handler = function (event) {
                  jQuery.event.simulate(
                    fix,
                    event.target,
                    jQuery.event.fix(event)
                  );
                };

                jQuery.event.special[fix] = {
                  setup: function () {
                    var doc = this.ownerDocument || this,
                      attaches = dataPriv.access(doc, fix);

                    if (!attaches) {
                      doc.addEventListener(orig, handler, true);
                    }
                    dataPriv.access(doc, fix, (attaches || 0) + 1);
                  },
                  teardown: function () {
                    var doc = this.ownerDocument || this,
                      attaches = dataPriv.access(doc, fix) - 1;

                    if (!attaches) {
                      doc.removeEventListener(orig, handler, true);
                      dataPriv.remove(doc, fix);
                    } else {
                      dataPriv.access(doc, fix, attaches);
                    }
                  },
                };
              }
            );
          }
          var location = window.location;

          var nonce = Date.now();

          var rquery = /\?/;

          // Cross-browser xml parsing
          jQuery.parseXML = function (data) {
            var xml;
            if (!data || typeof data !== "string") {
              return null;
            }

            // Support: IE 9 - 11 only
            // IE throws on parseFromString with invalid input.
            try {
              xml = new window.DOMParser().parseFromString(data, "text/xml");
            } catch (e) {
              xml = undefined;
            }

            if (!xml || xml.getElementsByTagName("parsererror").length) {
              jQuery.error("Invalid XML: " + data);
            }
            return xml;
          };

          var rbracket = /\[\]$/,
            rCRLF = /\r?\n/g,
            rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
            rsubmittable = /^(?:input|select|textarea|keygen)/i;

          function buildParams(prefix, obj, traditional, add) {
            var name;

            if (Array.isArray(obj)) {
              // Serialize array item.
              jQuery.each(obj, function (i, v) {
                if (traditional || rbracket.test(prefix)) {
                  // Treat each array item as a scalar.
                  add(prefix, v);
                } else {
                  // Item is non-scalar (array or object), encode its numeric index.
                  buildParams(
                    prefix +
                      "[" +
                      (typeof v === "object" && v != null ? i : "") +
                      "]",
                    v,
                    traditional,
                    add
                  );
                }
              });
            } else if (!traditional && toType(obj) === "object") {
              // Serialize object item.
              for (name in obj) {
                buildParams(
                  prefix + "[" + name + "]",
                  obj[name],
                  traditional,
                  add
                );
              }
            } else {
              // Serialize scalar item.
              add(prefix, obj);
            }
          }

          // Serialize an array of form elements or a set of
          // key/values into a query string
          jQuery.param = function (a, traditional) {
            var prefix,
              s = [],
              add = function (key, valueOrFunction) {
                // If value is a function, invoke it and use its return value
                var value = isFunction(valueOrFunction)
                  ? valueOrFunction()
                  : valueOrFunction;

                s[s.length] =
                  encodeURIComponent(key) +
                  "=" +
                  encodeURIComponent(value == null ? "" : value);
              };

            if (a == null) {
              return "";
            }

            // If an array was passed in, assume that it is an array of form elements.
            if (Array.isArray(a) || (a.jquery && !jQuery.isPlainObject(a))) {
              // Serialize the form elements
              jQuery.each(a, function () {
                add(this.name, this.value);
              });
            } else {
              // If traditional, encode the "old" way (the way 1.3.2 or older
              // did it), otherwise encode params recursively.
              for (prefix in a) {
                buildParams(prefix, a[prefix], traditional, add);
              }
            }

            // Return the resulting serialization
            return s.join("&");
          };

          jQuery.fn.extend({
            serialize: function () {
              return jQuery.param(this.serializeArray());
            },
            serializeArray: function () {
              return this.map(function () {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
              })
                .filter(function () {
                  var type = this.type;

                  // Use .is( ":disabled" ) so that fieldset[disabled] works
                  return (
                    this.name &&
                    !jQuery(this).is(":disabled") &&
                    rsubmittable.test(this.nodeName) &&
                    !rsubmitterTypes.test(type) &&
                    (this.checked || !rcheckableType.test(type))
                  );
                })
                .map(function (i, elem) {
                  var val = jQuery(this).val();

                  if (val == null) {
                    return null;
                  }

                  if (Array.isArray(val)) {
                    return jQuery.map(val, function (val) {
                      return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n"),
                      };
                    });
                  }

                  return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
                })
                .get();
            },
          });

          var r20 = /%20/g,
            rhash = /#.*$/,
            rantiCache = /([?&])_=[^&]*/,
            rheaders = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            // #7653, #8125, #8152: local protocol detection
            rlocalProtocol =
              /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
            rnoContent = /^(?:GET|HEAD)$/,
            rprotocol = /^\/\//,
            /* Prefilters
             * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
             * 2) These are called:
             *    - BEFORE asking for a transport
             *    - AFTER param serialization (s.data is a string if s.processData is true)
             * 3) key is the dataType
             * 4) the catchall symbol "*" can be used
             * 5) execution will start with transport dataType and THEN continue down to "*" if needed
             */
            prefilters = {},
            /* Transports bindings
             * 1) key is the dataType
             * 2) the catchall symbol "*" can be used
             * 3) selection will start with transport dataType and THEN go to "*" if needed
             */
            transports = {},
            // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
            allTypes = "*/".concat("*"),
            // Anchor tag for parsing the document origin
            originAnchor = document.createElement("a");
          originAnchor.href = location.href;

          // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
          function addToPrefiltersOrTransports(structure) {
            // dataTypeExpression is optional and defaults to "*"
            return function (dataTypeExpression, func) {
              if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
              }

              var dataType,
                i = 0,
                dataTypes =
                  dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];

              if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while ((dataType = dataTypes[i++])) {
                  // Prepend if requested
                  if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(
                      func
                    );

                    // Otherwise append
                  } else {
                    (structure[dataType] = structure[dataType] || []).push(
                      func
                    );
                  }
                }
              }
            };
          }

          // Base inspection function for prefilters and transports
          function inspectPrefiltersOrTransports(
            structure,
            options,
            originalOptions,
            jqXHR
          ) {
            var inspected = {},
              seekingTransport = structure === transports;

            function inspect(dataType) {
              var selected;
              inspected[dataType] = true;
              jQuery.each(
                structure[dataType] || [],
                function (_, prefilterOrFactory) {
                  var dataTypeOrTransport = prefilterOrFactory(
                    options,
                    originalOptions,
                    jqXHR
                  );
                  if (
                    typeof dataTypeOrTransport === "string" &&
                    !seekingTransport &&
                    !inspected[dataTypeOrTransport]
                  ) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                  } else if (seekingTransport) {
                    return !(selected = dataTypeOrTransport);
                  }
                }
              );
              return selected;
            }

            return (
              inspect(options.dataTypes[0]) || (!inspected["*"] && inspect("*"))
            );
          }

          // A special extend for ajax options
          // that takes "flat" options (not to be deep extended)
          // Fixes #9887
          function ajaxExtend(target, src) {
            var key,
              deep,
              flatOptions = jQuery.ajaxSettings.flatOptions || {};

            for (key in src) {
              if (src[key] !== undefined) {
                (flatOptions[key] ? target : deep || (deep = {}))[key] =
                  src[key];
              }
            }
            if (deep) {
              jQuery.extend(true, target, deep);
            }

            return target;
          }

          /* Handles responses to an ajax request:
           * - finds the right dataType (mediates between content-type and expected dataType)
           * - returns the corresponding response
           */
          function ajaxHandleResponses(s, jqXHR, responses) {
            var ct,
              type,
              finalDataType,
              firstDataType,
              contents = s.contents,
              dataTypes = s.dataTypes;

            // Remove auto dataType and get content-type in the process
            while (dataTypes[0] === "*") {
              dataTypes.shift();
              if (ct === undefined) {
                ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
              }
            }

            // Check if we're dealing with a known content-type
            if (ct) {
              for (type in contents) {
                if (contents[type] && contents[type].test(ct)) {
                  dataTypes.unshift(type);
                  break;
                }
              }
            }

            // Check to see if we have a response for the expected dataType
            if (dataTypes[0] in responses) {
              finalDataType = dataTypes[0];
            } else {
              // Try convertible dataTypes
              for (type in responses) {
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                  finalDataType = type;
                  break;
                }
                if (!firstDataType) {
                  firstDataType = type;
                }
              }

              // Or just use first one
              finalDataType = finalDataType || firstDataType;
            }

            // If we found a dataType
            // We add the dataType to the list if needed
            // and return the corresponding response
            if (finalDataType) {
              if (finalDataType !== dataTypes[0]) {
                dataTypes.unshift(finalDataType);
              }
              return responses[finalDataType];
            }
          }

          /* Chain conversions given the request and the original response
           * Also sets the responseXXX fields on the jqXHR instance
           */
          function ajaxConvert(s, response, jqXHR, isSuccess) {
            var conv2,
              current,
              conv,
              tmp,
              prev,
              converters = {},
              // Work with a copy of dataTypes in case we need to modify it for conversion
              dataTypes = s.dataTypes.slice();

            // Create converters map with lowercased keys
            if (dataTypes[1]) {
              for (conv in s.converters) {
                converters[conv.toLowerCase()] = s.converters[conv];
              }
            }

            current = dataTypes.shift();

            // Convert to each sequential dataType
            while (current) {
              if (s.responseFields[current]) {
                jqXHR[s.responseFields[current]] = response;
              }

              // Apply the dataFilter if provided
              if (!prev && isSuccess && s.dataFilter) {
                response = s.dataFilter(response, s.dataType);
              }

              prev = current;
              current = dataTypes.shift();

              if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") {
                  current = prev;

                  // Convert response if prev dataType is non-auto and differs from current
                } else if (prev !== "*" && prev !== current) {
                  // Seek a direct converter
                  conv =
                    converters[prev + " " + current] ||
                    converters["* " + current];

                  // If none found, seek a pair
                  if (!conv) {
                    for (conv2 in converters) {
                      // If conv2 outputs current
                      tmp = conv2.split(" ");
                      if (tmp[1] === current) {
                        // If prev can be converted to accepted input
                        conv =
                          converters[prev + " " + tmp[0]] ||
                          converters["* " + tmp[0]];
                        if (conv) {
                          // Condense equivalence converters
                          if (conv === true) {
                            conv = converters[conv2];

                            // Otherwise, insert the intermediate dataType
                          } else if (converters[conv2] !== true) {
                            current = tmp[0];
                            dataTypes.unshift(tmp[1]);
                          }
                          break;
                        }
                      }
                    }
                  }

                  // Apply converter (if not an equivalence)
                  if (conv !== true) {
                    // Unless errors are allowed to bubble, catch and return them
                    if (conv && s.throws) {
                      response = conv(response);
                    } else {
                      try {
                        response = conv(response);
                      } catch (e) {
                        return {
                          state: "parsererror",
                          error: conv
                            ? e
                            : "No conversion from " + prev + " to " + current,
                        };
                      }
                    }
                  }
                }
              }
            }

            return { state: "success", data: response };
          }

          jQuery.extend({
            // Counter for holding the number of active queries
            active: 0,

            // Last-Modified header cache for next request
            lastModified: {},
            etag: {},

            ajaxSettings: {
              url: location.href,
              type: "GET",
              isLocal: rlocalProtocol.test(location.protocol),
              global: true,
              processData: true,
              async: true,
              contentType: "application/x-www-form-urlencoded; charset=UTF-8",

              /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

              accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript",
              },

              contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/,
              },

              responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON",
              },

              // Data converters
              // Keys separate source (or catchall "*") and destination types with a single space
              converters: {
                // Convert anything to text
                "* text": String,

                // Text to html (true = no transformation)
                "text html": true,

                // Evaluate text as a json expression
                "text json": JSON.parse,

                // Parse text as xml
                "text xml": jQuery.parseXML,
              },

              // For options that shouldn't be deep extended:
              // you can add your own custom options here if
              // and when you create one that shouldn't be
              // deep extended (see ajaxExtend)
              flatOptions: {
                url: true,
                context: true,
              },
            },

            // Creates a full fledged settings object into target
            // with both ajaxSettings and settings fields.
            // If target is omitted, writes into ajaxSettings.
            ajaxSetup: function (target, settings) {
              return settings
                ? // Building a settings object
                  ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings)
                : // Extending ajaxSettings
                  ajaxExtend(jQuery.ajaxSettings, target);
            },

            ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
            ajaxTransport: addToPrefiltersOrTransports(transports),

            // Main method
            ajax: function (url, options) {
              // If url is an object, simulate pre-1.5 signature
              if (typeof url === "object") {
                options = url;
                url = undefined;
              }

              // Force options to be an object
              options = options || {};

              var transport,
                // URL without anti-cache param
                cacheURL,
                // Response headers
                responseHeadersString,
                responseHeaders,
                // timeout handle
                timeoutTimer,
                // Url cleanup var
                urlAnchor,
                // Request state (becomes false upon send and true upon completion)
                completed,
                // To know if global events are to be dispatched
                fireGlobals,
                // Loop variable
                i,
                // uncached part of the url
                uncached,
                // Create the final options object
                s = jQuery.ajaxSetup({}, options),
                // Callbacks context
                callbackContext = s.context || s,
                // Context for global events is callbackContext if it is a DOM node or jQuery collection
                globalEventContext =
                  s.context &&
                  (callbackContext.nodeType || callbackContext.jquery)
                    ? jQuery(callbackContext)
                    : jQuery.event,
                // Deferreds
                deferred = jQuery.Deferred(),
                completeDeferred = jQuery.Callbacks("once memory"),
                // Status-dependent callbacks
                statusCode = s.statusCode || {},
                // Headers (they are sent all at once)
                requestHeaders = {},
                requestHeadersNames = {},
                // Default abort message
                strAbort = "canceled",
                // Fake xhr
                jqXHR = {
                  readyState: 0,

                  // Builds headers hashtable if needed
                  getResponseHeader: function (key) {
                    var match;
                    if (completed) {
                      if (!responseHeaders) {
                        responseHeaders = {};
                        while ((match = rheaders.exec(responseHeadersString))) {
                          responseHeaders[match[1].toLowerCase() + " "] = (
                            responseHeaders[match[1].toLowerCase() + " "] || []
                          ).concat(match[2]);
                        }
                      }
                      match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                  },

                  // Raw string
                  getAllResponseHeaders: function () {
                    return completed ? responseHeadersString : null;
                  },

                  // Caches the header
                  setRequestHeader: function (name, value) {
                    if (completed == null) {
                      name = requestHeadersNames[name.toLowerCase()] =
                        requestHeadersNames[name.toLowerCase()] || name;
                      requestHeaders[name] = value;
                    }
                    return this;
                  },

                  // Overrides response content-type header
                  overrideMimeType: function (type) {
                    if (completed == null) {
                      s.mimeType = type;
                    }
                    return this;
                  },

                  // Status-dependent callbacks
                  statusCode: function (map) {
                    var code;
                    if (map) {
                      if (completed) {
                        // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                      } else {
                        // Lazy-add the new callbacks in a way that preserves old ones
                        for (code in map) {
                          statusCode[code] = [statusCode[code], map[code]];
                        }
                      }
                    }
                    return this;
                  },

                  // Cancel the request
                  abort: function (statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) {
                      transport.abort(finalText);
                    }
                    done(0, finalText);
                    return this;
                  },
                };

              // Attach deferreds
              deferred.promise(jqXHR);

              // Add protocol if not provided (prefilters might expect it)
              // Handle falsy url in the settings object (#10093: consistency with old signature)
              // We also use the url parameter if available
              s.url = ((url || s.url || location.href) + "").replace(
                rprotocol,
                location.protocol + "//"
              );

              // Alias method option to type as per ticket #12004
              s.type = options.method || options.type || s.method || s.type;

              // Extract dataTypes list
              s.dataTypes = (s.dataType || "*")
                .toLowerCase()
                .match(rnothtmlwhite) || [""];

              // A cross-domain request is in order when the origin doesn't match the current origin.
              if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");

                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                  urlAnchor.href = s.url;

                  // Support: IE <=8 - 11 only
                  // Anchor's host property isn't correctly set when s.url is relative
                  urlAnchor.href = urlAnchor.href;
                  s.crossDomain =
                    originAnchor.protocol + "//" + originAnchor.host !==
                    urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                  // If there is an error parsing the URL, assume it is crossDomain,
                  // it can be rejected by the transport if it is invalid
                  s.crossDomain = true;
                }
              }

              // Convert data if not already a string
              if (s.data && s.processData && typeof s.data !== "string") {
                s.data = jQuery.param(s.data, s.traditional);
              }

              // Apply prefilters
              inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);

              // If request was aborted inside a prefilter, stop there
              if (completed) {
                return jqXHR;
              }

              // We can fire global events as of now if asked to
              // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
              fireGlobals = jQuery.event && s.global;

              // Watch for a new set of requests
              if (fireGlobals && jQuery.active++ === 0) {
                jQuery.event.trigger("ajaxStart");
              }

              // Uppercase the type
              s.type = s.type.toUpperCase();

              // Determine if request has content
              s.hasContent = !rnoContent.test(s.type);

              // Save the URL in case we're toying with the If-Modified-Since
              // and/or If-None-Match header later on
              // Remove hash to simplify url manipulation
              cacheURL = s.url.replace(rhash, "");

              // More options handling for requests with no content
              if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);

                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                  cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;

                  // #9682: remove data so that it's not used in an eventual retry
                  delete s.data;
                }

                // Add or update anti-cache param if needed
                if (s.cache === false) {
                  cacheURL = cacheURL.replace(rantiCache, "$1");
                  uncached =
                    (rquery.test(cacheURL) ? "&" : "?") +
                    "_=" +
                    nonce++ +
                    uncached;
                }

                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;

                // Change '%20' to '+' if this is encoded form body content (gh-2658)
              } else if (
                s.data &&
                s.processData &&
                (s.contentType || "").indexOf(
                  "application/x-www-form-urlencoded"
                ) === 0
              ) {
                s.data = s.data.replace(r20, "+");
              }

              // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
              if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) {
                  jqXHR.setRequestHeader(
                    "If-Modified-Since",
                    jQuery.lastModified[cacheURL]
                  );
                }
                if (jQuery.etag[cacheURL]) {
                  jqXHR.setRequestHeader(
                    "If-None-Match",
                    jQuery.etag[cacheURL]
                  );
                }
              }

              // Set the correct header, if data is being sent
              if (
                (s.data && s.hasContent && s.contentType !== false) ||
                options.contentType
              ) {
                jqXHR.setRequestHeader("Content-Type", s.contentType);
              }

              // Set the Accepts header for the server, depending on the dataType
              jqXHR.setRequestHeader(
                "Accept",
                s.dataTypes[0] && s.accepts[s.dataTypes[0]]
                  ? s.accepts[s.dataTypes[0]] +
                      (s.dataTypes[0] !== "*"
                        ? ", " + allTypes + "; q=0.01"
                        : "")
                  : s.accepts["*"]
              );

              // Check for headers option
              for (i in s.headers) {
                jqXHR.setRequestHeader(i, s.headers[i]);
              }

              // Allow custom headers/mimetypes and early abort
              if (
                s.beforeSend &&
                (s.beforeSend.call(callbackContext, jqXHR, s) === false ||
                  completed)
              ) {
                // Abort if not done already and return
                return jqXHR.abort();
              }

              // Aborting is no longer a cancellation
              strAbort = "abort";

              // Install callbacks on deferreds
              completeDeferred.add(s.complete);
              jqXHR.done(s.success);
              jqXHR.fail(s.error);

              // Get transport
              transport = inspectPrefiltersOrTransports(
                transports,
                s,
                options,
                jqXHR
              );

              // If no transport, we auto-abort
              if (!transport) {
                done(-1, "No Transport");
              } else {
                jqXHR.readyState = 1;

                // Send global event
                if (fireGlobals) {
                  globalEventContext.trigger("ajaxSend", [jqXHR, s]);
                }

                // If request was aborted inside ajaxSend, stop there
                if (completed) {
                  return jqXHR;
                }

                // Timeout
                if (s.async && s.timeout > 0) {
                  timeoutTimer = window.setTimeout(function () {
                    jqXHR.abort("timeout");
                  }, s.timeout);
                }

                try {
                  completed = false;
                  transport.send(requestHeaders, done);
                } catch (e) {
                  // Rethrow post-completion exceptions
                  if (completed) {
                    throw e;
                  }

                  // Propagate others as results
                  done(-1, e);
                }
              }

              // Callback for when everything is done
              function done(status, nativeStatusText, responses, headers) {
                var isSuccess,
                  success,
                  error,
                  response,
                  modified,
                  statusText = nativeStatusText;

                // Ignore repeat invocations
                if (completed) {
                  return;
                }

                completed = true;

                // Clear timeout if it exists
                if (timeoutTimer) {
                  window.clearTimeout(timeoutTimer);
                }

                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;

                // Cache response headers
                responseHeadersString = headers || "";

                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;

                // Determine if successful
                isSuccess = (status >= 200 && status < 300) || status === 304;

                // Get response data
                if (responses) {
                  response = ajaxHandleResponses(s, jqXHR, responses);
                }

                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);

                // If successful, handle type chaining
                if (isSuccess) {
                  // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                  if (s.ifModified) {
                    modified = jqXHR.getResponseHeader("Last-Modified");
                    if (modified) {
                      jQuery.lastModified[cacheURL] = modified;
                    }
                    modified = jqXHR.getResponseHeader("etag");
                    if (modified) {
                      jQuery.etag[cacheURL] = modified;
                    }
                  }

                  // if no content
                  if (status === 204 || s.type === "HEAD") {
                    statusText = "nocontent";

                    // if not modified
                  } else if (status === 304) {
                    statusText = "notmodified";

                    // If we have data, let's convert it
                  } else {
                    statusText = response.state;
                    success = response.data;
                    error = response.error;
                    isSuccess = !error;
                  }
                } else {
                  // Extract error from statusText and normalize for non-aborts
                  error = statusText;
                  if (status || !statusText) {
                    statusText = "error";
                    if (status < 0) {
                      status = 0;
                    }
                  }
                }

                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";

                // Success/Error
                if (isSuccess) {
                  deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR,
                  ]);
                } else {
                  deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error,
                  ]);
                }

                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;

                if (fireGlobals) {
                  globalEventContext.trigger(
                    isSuccess ? "ajaxSuccess" : "ajaxError",
                    [jqXHR, s, isSuccess ? success : error]
                  );
                }

                // Complete
                completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);

                if (fireGlobals) {
                  globalEventContext.trigger("ajaxComplete", [jqXHR, s]);

                  // Handle the global AJAX counter
                  if (!--jQuery.active) {
                    jQuery.event.trigger("ajaxStop");
                  }
                }
              }

              return jqXHR;
            },

            getJSON: function (url, data, callback) {
              return jQuery.get(url, data, callback, "json");
            },

            getScript: function (url, callback) {
              return jQuery.get(url, undefined, callback, "script");
            },
          });

          jQuery.each(["get", "post"], function (i, method) {
            jQuery[method] = function (url, data, callback, type) {
              // Shift arguments if data argument was omitted
              if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
              }

              // The url can be an options object (which then must have .url)
              return jQuery.ajax(
                jQuery.extend(
                  {
                    url: url,
                    type: method,
                    dataType: type,
                    data: data,
                    success: callback,
                  },
                  jQuery.isPlainObject(url) && url
                )
              );
            };
          });

          jQuery._evalUrl = function (url, options) {
            return jQuery.ajax({
              url: url,

              // Make this explicit, since user can override this through ajaxSetup (#11264)
              type: "GET",
              dataType: "script",
              cache: true,
              async: false,
              global: false,

              // Only evaluate the response if it is successful (gh-4126)
              // dataFilter is not invoked for failure responses, so using it instead
              // of the default converter is kludgy but it works.
              converters: {
                "text script": function () {},
              },
              dataFilter: function (response) {
                jQuery.globalEval(response, options);
              },
            });
          };

          jQuery.fn.extend({
            wrapAll: function (html) {
              var wrap;

              if (this[0]) {
                if (isFunction(html)) {
                  html = html.call(this[0]);
                }

                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);

                if (this[0].parentNode) {
                  wrap.insertBefore(this[0]);
                }

                wrap
                  .map(function () {
                    var elem = this;

                    while (elem.firstElementChild) {
                      elem = elem.firstElementChild;
                    }

                    return elem;
                  })
                  .append(this);
              }

              return this;
            },

            wrapInner: function (html) {
              if (isFunction(html)) {
                return this.each(function (i) {
                  jQuery(this).wrapInner(html.call(this, i));
                });
              }

              return this.each(function () {
                var self = jQuery(this),
                  contents = self.contents();

                if (contents.length) {
                  contents.wrapAll(html);
                } else {
                  self.append(html);
                }
              });
            },

            wrap: function (html) {
              var htmlIsFunction = isFunction(html);

              return this.each(function (i) {
                jQuery(this).wrapAll(
                  htmlIsFunction ? html.call(this, i) : html
                );
              });
            },

            unwrap: function (selector) {
              this.parent(selector)
                .not("body")
                .each(function () {
                  jQuery(this).replaceWith(this.childNodes);
                });
              return this;
            },
          });

          jQuery.expr.pseudos.hidden = function (elem) {
            return !jQuery.expr.pseudos.visible(elem);
          };
          jQuery.expr.pseudos.visible = function (elem) {
            return !!(
              elem.offsetWidth ||
              elem.offsetHeight ||
              elem.getClientRects().length
            );
          };

          jQuery.ajaxSettings.xhr = function () {
            try {
              return new window.XMLHttpRequest();
            } catch (e) {}
          };

          var xhrSuccessStatus = {
              // File protocol always yields status code 0, assume 200
              0: 200,

              // Support: IE <=9 only
              // #1450: sometimes IE returns 1223 when it should be 204
              1223: 204,
            },
            xhrSupported = jQuery.ajaxSettings.xhr();

          support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
          support.ajax = xhrSupported = !!xhrSupported;

          jQuery.ajaxTransport(function (options) {
            var callback, errorCallback;

            // Cross domain only allowed if supported through XMLHttpRequest
            if (support.cors || (xhrSupported && !options.crossDomain)) {
              return {
                send: function (headers, complete) {
                  var i,
                    xhr = options.xhr();

                  xhr.open(
                    options.type,
                    options.url,
                    options.async,
                    options.username,
                    options.password
                  );

                  // Apply custom fields if provided
                  if (options.xhrFields) {
                    for (i in options.xhrFields) {
                      xhr[i] = options.xhrFields[i];
                    }
                  }

                  // Override mime type if needed
                  if (options.mimeType && xhr.overrideMimeType) {
                    xhr.overrideMimeType(options.mimeType);
                  }

                  // X-Requested-With header
                  // For cross-domain requests, seeing as conditions for a preflight are
                  // akin to a jigsaw puzzle, we simply never set it to be sure.
                  // (it can always be set on a per-request basis or even using ajaxSetup)
                  // For same-domain requests, won't change header if already provided.
                  if (!options.crossDomain && !headers["X-Requested-With"]) {
                    headers["X-Requested-With"] = "XMLHttpRequest";
                  }

                  // Set headers
                  for (i in headers) {
                    xhr.setRequestHeader(i, headers[i]);
                  }

                  // Callback
                  callback = function (type) {
                    return function () {
                      if (callback) {
                        callback =
                          errorCallback =
                          xhr.onload =
                          xhr.onerror =
                          xhr.onabort =
                          xhr.ontimeout =
                          xhr.onreadystatechange =
                            null;

                        if (type === "abort") {
                          xhr.abort();
                        } else if (type === "error") {
                          // Support: IE <=9 only
                          // On a manual native abort, IE9 throws
                          // errors on any property access that is not readyState
                          if (typeof xhr.status !== "number") {
                            complete(0, "error");
                          } else {
                            complete(
                              // File: protocol always yields status 0; see #8605, #14207
                              xhr.status,
                              xhr.statusText
                            );
                          }
                        } else {
                          complete(
                            xhrSuccessStatus[xhr.status] || xhr.status,
                            xhr.statusText,

                            // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" ||
                              typeof xhr.responseText !== "string"
                              ? { binary: xhr.response }
                              : { text: xhr.responseText },
                            xhr.getAllResponseHeaders()
                          );
                        }
                      }
                    };
                  };

                  // Listen to events
                  xhr.onload = callback();
                  errorCallback =
                    xhr.onerror =
                    xhr.ontimeout =
                      callback("error");

                  // Support: IE 9 only
                  // Use onreadystatechange to replace onabort
                  // to handle uncaught aborts
                  if (xhr.onabort !== undefined) {
                    xhr.onabort = errorCallback;
                  } else {
                    xhr.onreadystatechange = function () {
                      // Check readyState before timeout as it changes
                      if (xhr.readyState === 4) {
                        // Allow onerror to be called first,
                        // but that will not handle a native abort
                        // Also, save errorCallback to a variable
                        // as xhr.onerror cannot be accessed
                        window.setTimeout(function () {
                          if (callback) {
                            errorCallback();
                          }
                        });
                      }
                    };
                  }

                  // Create the abort callback
                  callback = callback("abort");

                  try {
                    // Do send the request (this may raise an exception)
                    xhr.send((options.hasContent && options.data) || null);
                  } catch (e) {
                    // #14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) {
                      throw e;
                    }
                  }
                },

                abort: function () {
                  if (callback) {
                    callback();
                  }
                },
              };
            }
          });

          // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
          jQuery.ajaxPrefilter(function (s) {
            if (s.crossDomain) {
              s.contents.script = false;
            }
          });

          // Install script dataType
          jQuery.ajaxSetup({
            accepts: {
              script:
                "text/javascript, application/javascript, " +
                "application/ecmascript, application/x-ecmascript",
            },
            contents: {
              script: /\b(?:java|ecma)script\b/,
            },
            converters: {
              "text script": function (text) {
                jQuery.globalEval(text);
                return text;
              },
            },
          });

          // Handle cache's special case and crossDomain
          jQuery.ajaxPrefilter("script", function (s) {
            if (s.cache === undefined) {
              s.cache = false;
            }
            if (s.crossDomain) {
              s.type = "GET";
            }
          });

          // Bind script tag hack transport
          jQuery.ajaxTransport("script", function (s) {
            // This transport only deals with cross domain or forced-by-attrs requests
            if (s.crossDomain || s.scriptAttrs) {
              var script, callback;
              return {
                send: function (_, complete) {
                  script = jQuery("<script>")
                    .attr(s.scriptAttrs || {})
                    .prop({ charset: s.scriptCharset, src: s.url })
                    .on(
                      "load error",
                      (callback = function (evt) {
                        script.remove();
                        callback = null;
                        if (evt) {
                          complete(evt.type === "error" ? 404 : 200, evt.type);
                        }
                      })
                    );

                  // Use native DOM manipulation to avoid our domManip AJAX trickery
                  document.head.appendChild(script[0]);
                },
                abort: function () {
                  if (callback) {
                    callback();
                  }
                },
              };
            }
          });

          var oldCallbacks = [],
            rjsonp = /(=)\?(?=&|$)|\?\?/;

          // Default jsonp settings
          jQuery.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function () {
              var callback =
                oldCallbacks.pop() || jQuery.expando + "_" + nonce++;
              this[callback] = true;
              return callback;
            },
          });

          // Detect, normalize options and install callbacks for jsonp requests
          jQuery.ajaxPrefilter(
            "json jsonp",
            function (s, originalSettings, jqXHR) {
              var callbackName,
                overwritten,
                responseContainer,
                jsonProp =
                  s.jsonp !== false &&
                  (rjsonp.test(s.url)
                    ? "url"
                    : typeof s.data === "string" &&
                      (s.contentType || "").indexOf(
                        "application/x-www-form-urlencoded"
                      ) === 0 &&
                      rjsonp.test(s.data) &&
                      "data");

              // Handle iff the expected data type is "jsonp" or we have a parameter to set
              if (jsonProp || s.dataTypes[0] === "jsonp") {
                // Get callback name, remembering preexisting value associated with it
                callbackName = s.jsonpCallback = isFunction(s.jsonpCallback)
                  ? s.jsonpCallback()
                  : s.jsonpCallback;

                // Insert callback into url or form data
                if (jsonProp) {
                  s[jsonProp] = s[jsonProp].replace(
                    rjsonp,
                    "$1" + callbackName
                  );
                } else if (s.jsonp !== false) {
                  s.url +=
                    (rquery.test(s.url) ? "&" : "?") +
                    s.jsonp +
                    "=" +
                    callbackName;
                }

                // Use data converter to retrieve json after script execution
                s.converters["script json"] = function () {
                  if (!responseContainer) {
                    jQuery.error(callbackName + " was not called");
                  }
                  return responseContainer[0];
                };

                // Force json dataType
                s.dataTypes[0] = "json";

                // Install callback
                overwritten = window[callbackName];
                window[callbackName] = function () {
                  responseContainer = arguments;
                };

                // Clean-up function (fires after converters)
                jqXHR.always(function () {
                  // If previous value didn't exist - remove it
                  if (overwritten === undefined) {
                    jQuery(window).removeProp(callbackName);

                    // Otherwise restore preexisting value
                  } else {
                    window[callbackName] = overwritten;
                  }

                  // Save back as free
                  if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;

                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                  }

                  // Call if it was a function and we have a response
                  if (responseContainer && isFunction(overwritten)) {
                    overwritten(responseContainer[0]);
                  }

                  responseContainer = overwritten = undefined;
                });

                // Delegate to script
                return "script";
              }
            }
          );

          // Support: Safari 8 only
          // In Safari 8 documents created via document.implementation.createHTMLDocument
          // collapse sibling forms: the second one becomes a child of the first one.
          // Because of that, this security measure has to be disabled in Safari 8.
          // https://bugs.webkit.org/show_bug.cgi?id=137337
          support.createHTMLDocument = (function () {
            var body = document.implementation.createHTMLDocument("").body;
            body.innerHTML = "<form></form><form></form>";
            return body.childNodes.length === 2;
          })();

          // Argument "data" should be string of html
          // context (optional): If specified, the fragment will be created in this context,
          // defaults to document
          // keepScripts (optional): If true, will include scripts passed in the html string
          jQuery.parseHTML = function (data, context, keepScripts) {
            if (typeof data !== "string") {
              return [];
            }
            if (typeof context === "boolean") {
              keepScripts = context;
              context = false;
            }

            var base, parsed, scripts;

            if (!context) {
              // Stop scripts or inline event handlers from being executed immediately
              // by using document.implementation
              if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");

                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
              } else {
                context = document;
              }
            }

            parsed = rsingleTag.exec(data);
            scripts = !keepScripts && [];

            // Single tag
            if (parsed) {
              return [context.createElement(parsed[1])];
            }

            parsed = buildFragment([data], context, scripts);

            if (scripts && scripts.length) {
              jQuery(scripts).remove();
            }

            return jQuery.merge([], parsed.childNodes);
          };

          /**
           * Load a url into a page
           */
          jQuery.fn.load = function (url, params, callback) {
            var selector,
              type,
              response,
              self = this,
              off = url.indexOf(" ");

            if (off > -1) {
              selector = stripAndCollapse(url.slice(off));
              url = url.slice(0, off);
            }

            // If it's a function
            if (isFunction(params)) {
              // We assume that it's the callback
              callback = params;
              params = undefined;

              // Otherwise, build a param string
            } else if (params && typeof params === "object") {
              type = "POST";
            }

            // If we have elements to modify, make the request
            if (self.length > 0) {
              jQuery
                .ajax({
                  url: url,

                  // If "type" variable is undefined, then "GET" method will be used.
                  // Make value of this field explicit since
                  // user can override it through ajaxSetup method
                  type: type || "GET",
                  dataType: "html",
                  data: params,
                })
                .done(function (responseText) {
                  // Save response for use in complete callback
                  response = arguments;

                  self.html(
                    selector
                      ? // If a selector was specified, locate the right elements in a dummy div
                        // Exclude scripts to avoid IE 'Permission Denied' errors
                        jQuery("<div>")
                          .append(jQuery.parseHTML(responseText))
                          .find(selector)
                      : // Otherwise use the full result
                        responseText
                  );

                  // If the request succeeds, this function gets "data", "status", "jqXHR"
                  // but they are ignored because response was set above.
                  // If it fails, this function gets "jqXHR", "status", "error"
                })
                .always(
                  callback &&
                    function (jqXHR, status) {
                      self.each(function () {
                        callback.apply(
                          this,
                          response || [jqXHR.responseText, status, jqXHR]
                        );
                      });
                    }
                );
            }

            return this;
          };

          // Attach a bunch of functions for handling common AJAX events
          jQuery.each(
            [
              "ajaxStart",
              "ajaxStop",
              "ajaxComplete",
              "ajaxError",
              "ajaxSuccess",
              "ajaxSend",
            ],
            function (i, type) {
              jQuery.fn[type] = function (fn) {
                return this.on(type, fn);
              };
            }
          );

          jQuery.expr.pseudos.animated = function (elem) {
            return jQuery.grep(jQuery.timers, function (fn) {
              return elem === fn.elem;
            }).length;
          };

          jQuery.offset = {
            setOffset: function (elem, options, i) {
              var curPosition,
                curLeft,
                curCSSTop,
                curTop,
                curOffset,
                curCSSLeft,
                calculatePosition,
                position = jQuery.css(elem, "position"),
                curElem = jQuery(elem),
                props = {};

              // Set position first, in-case top/left are set even on static elem
              if (position === "static") {
                elem.style.position = "relative";
              }

              curOffset = curElem.offset();
              curCSSTop = jQuery.css(elem, "top");
              curCSSLeft = jQuery.css(elem, "left");
              calculatePosition =
                (position === "absolute" || position === "fixed") &&
                (curCSSTop + curCSSLeft).indexOf("auto") > -1;

              // Need to be able to calculate position if either
              // top or left is auto and position is either absolute or fixed
              if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
              } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
              }

              if (isFunction(options)) {
                // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
                options = options.call(elem, i, jQuery.extend({}, curOffset));
              }

              if (options.top != null) {
                props.top = options.top - curOffset.top + curTop;
              }
              if (options.left != null) {
                props.left = options.left - curOffset.left + curLeft;
              }

              if ("using" in options) {
                options.using.call(elem, props);
              } else {
                curElem.css(props);
              }
            },
          };

          jQuery.fn.extend({
            // offset() relates an element's border box to the document origin
            offset: function (options) {
              // Preserve chaining for setter
              if (arguments.length) {
                return options === undefined
                  ? this
                  : this.each(function (i) {
                      jQuery.offset.setOffset(this, options, i);
                    });
              }

              var rect,
                win,
                elem = this[0];

              if (!elem) {
                return;
              }

              // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
              // Support: IE <=11 only
              // Running getBoundingClientRect on a
              // disconnected node in IE throws an error
              if (!elem.getClientRects().length) {
                return { top: 0, left: 0 };
              }

              // Get document-relative position by adding viewport scroll to viewport-relative gBCR
              rect = elem.getBoundingClientRect();
              win = elem.ownerDocument.defaultView;
              return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset,
              };
            },

            // position() relates an element's margin box to its offset parent's padding box
            // This corresponds to the behavior of CSS absolute positioning
            position: function () {
              if (!this[0]) {
                return;
              }

              var offsetParent,
                offset,
                doc,
                elem = this[0],
                parentOffset = { top: 0, left: 0 };

              // position:fixed elements are offset from the viewport, which itself always has zero offset
              if (jQuery.css(elem, "position") === "fixed") {
                // Assume position:fixed implies availability of getBoundingClientRect
                offset = elem.getBoundingClientRect();
              } else {
                offset = this.offset();

                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while (
                  offsetParent &&
                  (offsetParent === doc.body ||
                    offsetParent === doc.documentElement) &&
                  jQuery.css(offsetParent, "position") === "static"
                ) {
                  offsetParent = offsetParent.parentNode;
                }
                if (
                  offsetParent &&
                  offsetParent !== elem &&
                  offsetParent.nodeType === 1
                ) {
                  // Incorporate borders into its offset, since they are outside its content origin
                  parentOffset = jQuery(offsetParent).offset();
                  parentOffset.top += jQuery.css(
                    offsetParent,
                    "borderTopWidth",
                    true
                  );
                  parentOffset.left += jQuery.css(
                    offsetParent,
                    "borderLeftWidth",
                    true
                  );
                }
              }

              // Subtract parent offsets and element margins
              return {
                top:
                  offset.top -
                  parentOffset.top -
                  jQuery.css(elem, "marginTop", true),
                left:
                  offset.left -
                  parentOffset.left -
                  jQuery.css(elem, "marginLeft", true),
              };
            },

            // This method will return documentElement in the following cases:
            // 1) For the element inside the iframe without offsetParent, this method will return
            //    documentElement of the parent window
            // 2) For the hidden or detached element
            // 3) For body or html element, i.e. in case of the html node - it will return itself
            //
            // but those exceptions were never presented as a real life use-cases
            // and might be considered as more preferable results.
            //
            // This logic, however, is not guaranteed and can change at any point in the future
            offsetParent: function () {
              return this.map(function () {
                var offsetParent = this.offsetParent;

                while (
                  offsetParent &&
                  jQuery.css(offsetParent, "position") === "static"
                ) {
                  offsetParent = offsetParent.offsetParent;
                }

                return offsetParent || documentElement;
              });
            },
          });

          // Create scrollLeft and scrollTop methods
          jQuery.each(
            { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
            function (method, prop) {
              var top = "pageYOffset" === prop;

              jQuery.fn[method] = function (val) {
                return access(
                  this,
                  function (elem, method, val) {
                    // Coalesce documents and windows
                    var win;
                    if (isWindow(elem)) {
                      win = elem;
                    } else if (elem.nodeType === 9) {
                      win = elem.defaultView;
                    }

                    if (val === undefined) {
                      return win ? win[prop] : elem[method];
                    }

                    if (win) {
                      win.scrollTo(
                        !top ? val : win.pageXOffset,
                        top ? val : win.pageYOffset
                      );
                    } else {
                      elem[method] = val;
                    }
                  },
                  method,
                  val,
                  arguments.length
                );
              };
            }
          );

          // Support: Safari <=7 - 9.1, Chrome <=37 - 49
          // Add the top/left cssHooks using jQuery.fn.position
          // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
          // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
          // getComputedStyle returns percent when specified for top/left/bottom/right;
          // rather than make the css module depend on the offset module, just check for it here
          jQuery.each(["top", "left"], function (i, prop) {
            jQuery.cssHooks[prop] = addGetHookIf(
              support.pixelPosition,
              function (elem, computed) {
                if (computed) {
                  computed = curCSS(elem, prop);

                  // If curCSS returns percentage, fallback to offset
                  return rnumnonpx.test(computed)
                    ? jQuery(elem).position()[prop] + "px"
                    : computed;
                }
              }
            );
          });

          // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
          jQuery.each(
            { Height: "height", Width: "width" },
            function (name, type) {
              jQuery.each(
                { padding: "inner" + name, content: type, "": "outer" + name },
                function (defaultExtra, funcName) {
                  // Margin is only for outerHeight, outerWidth
                  jQuery.fn[funcName] = function (margin, value) {
                    var chainable =
                        arguments.length &&
                        (defaultExtra || typeof margin !== "boolean"),
                      extra =
                        defaultExtra ||
                        (margin === true || value === true
                          ? "margin"
                          : "border");

                    return access(
                      this,
                      function (elem, type, value) {
                        var doc;

                        if (isWindow(elem)) {
                          // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                          return funcName.indexOf("outer") === 0
                            ? elem["inner" + name]
                            : elem.document.documentElement["client" + name];
                        }

                        // Get document width or height
                        if (elem.nodeType === 9) {
                          doc = elem.documentElement;

                          // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                          // whichever is greatest
                          return Math.max(
                            elem.body["scroll" + name],
                            doc["scroll" + name],
                            elem.body["offset" + name],
                            doc["offset" + name],
                            doc["client" + name]
                          );
                        }

                        return value === undefined
                          ? // Get width or height on the element, requesting but not forcing parseFloat
                            jQuery.css(elem, type, extra)
                          : // Set width or height on the element
                            jQuery.style(elem, type, value, extra);
                      },
                      type,
                      chainable ? margin : undefined,
                      chainable
                    );
                  };
                }
              );
            }
          );

          jQuery.each(
            (
              "blur focus focusin focusout resize scroll click dblclick " +
              "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
              "change select submit keydown keypress keyup contextmenu"
            ).split(" "),
            function (i, name) {
              // Handle event binding
              jQuery.fn[name] = function (data, fn) {
                return arguments.length > 0
                  ? this.on(name, null, data, fn)
                  : this.trigger(name);
              };
            }
          );

          jQuery.fn.extend({
            hover: function (fnOver, fnOut) {
              return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
            },
          });

          jQuery.fn.extend({
            bind: function (types, data, fn) {
              return this.on(types, null, data, fn);
            },
            unbind: function (types, fn) {
              return this.off(types, null, fn);
            },

            delegate: function (selector, types, data, fn) {
              return this.on(types, selector, data, fn);
            },
            undelegate: function (selector, types, fn) {
              // ( namespace ) or ( selector, types [, fn] )
              return arguments.length === 1
                ? this.off(selector, "**")
                : this.off(types, selector || "**", fn);
            },
          });

          // Bind a function to a context, optionally partially applying any
          // arguments.
          // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
          // However, it is not slated for removal any time soon
          jQuery.proxy = function (fn, context) {
            var tmp, args, proxy;

            if (typeof context === "string") {
              tmp = fn[context];
              context = fn;
              fn = tmp;
            }

            // Quick check to determine if target is callable, in the spec
            // this throws a TypeError, but we will just return undefined.
            if (!isFunction(fn)) {
              return undefined;
            }

            // Simulated bind
            args = slice.call(arguments, 2);
            proxy = function () {
              return fn.apply(
                context || this,
                args.concat(slice.call(arguments))
              );
            };

            // Set the guid of unique handler to the same of original handler, so it can be removed
            proxy.guid = fn.guid = fn.guid || jQuery.guid++;

            return proxy;
          };

          jQuery.holdReady = function (hold) {
            if (hold) {
              jQuery.readyWait++;
            } else {
              jQuery.ready(true);
            }
          };
          jQuery.isArray = Array.isArray;
          jQuery.parseJSON = JSON.parse;
          jQuery.nodeName = nodeName;
          jQuery.isFunction = isFunction;
          jQuery.isWindow = isWindow;
          jQuery.camelCase = camelCase;
          jQuery.type = toType;

          jQuery.now = Date.now;

          jQuery.isNumeric = function (obj) {
            // As of jQuery 3.0, isNumeric is limited to
            // strings and numbers (primitives or objects)
            // that can be coerced to finite numbers (gh-2662)
            var type = jQuery.type(obj);
            return (
              (type === "number" || type === "string") &&
              // parseFloat NaNs numeric-cast false positives ("")
              // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
              // subtraction forces infinities to NaN
              !isNaN(obj - parseFloat(obj))
            );
          };

          // Register as a named AMD module, since jQuery can be concatenated with other
          // files that may use define, but not via a proper concatenation script that
          // understands anonymous AMD modules. A named AMD is safest and most robust
          // way to register. Lowercase jquery is used because AMD module names are
          // derived from file names, and jQuery is normally delivered in a lowercase
          // file name. Do this after creating the global so that if an AMD module wants
          // to call noConflict to hide this version of jQuery, it will work.

          // Note that for maximum portability, libraries that are not jQuery should
          // declare themselves as anonymous modules, and avoid setting a global if an
          // AMD loader is present. jQuery is a special case. For more information, see
          // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

          if (true) {
            !((__WEBPACK_AMD_DEFINE_ARRAY__ = []),
            (__WEBPACK_AMD_DEFINE_RESULT__ = function () {
              return jQuery;
            }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
            __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
              (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
          }

          var // Map over jQuery in case of overwrite
            _jQuery = window.jQuery,
            // Map over the $ in case of overwrite
            _$ = window.$;

          jQuery.noConflict = function (deep) {
            if (window.$ === jQuery) {
              window.$ = _$;
            }

            if (deep && window.jQuery === jQuery) {
              window.jQuery = _jQuery;
            }

            return jQuery;
          };

          // Expose jQuery and $ identifiers, even in AMD
          // (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
          // and CommonJS for browser emulators (#13566)
          if (!noGlobal) {
            window.jQuery = window.$ = jQuery;
          }

          return jQuery;
        }
      );

      /***/
    },
    /* 1 */
    /***/ function (module, exports, __webpack_require__) {
      var global = __webpack_require__(3);
      var core = __webpack_require__(11);
      var hide = __webpack_require__(16);
      var redefine = __webpack_require__(17);
      var ctx = __webpack_require__(21);
      var PROTOTYPE = "prototype";

      var $export = function (type, name, source) {
        var IS_FORCED = type & $export.F;
        var IS_GLOBAL = type & $export.G;
        var IS_STATIC = type & $export.S;
        var IS_PROTO = type & $export.P;
        var IS_BIND = type & $export.B;
        var target = IS_GLOBAL
          ? global
          : IS_STATIC
          ? global[name] || (global[name] = {})
          : (global[name] || {})[PROTOTYPE];
        var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
        var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
        var key, own, out, exp;
        if (IS_GLOBAL) source = name;
        for (key in source) {
          // contains in native
          own = !IS_FORCED && target && target[key] !== undefined;
          // export native or passed
          out = (own ? target : source)[key];
          // bind timers to global for call from export context
          exp =
            IS_BIND && own
              ? ctx(out, global)
              : IS_PROTO && typeof out == "function"
              ? ctx(Function.call, out)
              : out;
          // extend global
          if (target) redefine(target, key, out, type & $export.U);
          // export
          if (exports[key] != out) hide(exports, key, exp);
          if (IS_PROTO && expProto[key] != out) expProto[key] = out;
        }
      };
      global.core = core;
      // type bitmap
      $export.F = 1; // forced
      $export.G = 2; // global
      $export.S = 4; // static
      $export.P = 8; // proto
      $export.B = 16; // bind
      $export.W = 32; // wrap
      $export.U = 64; // safe
      $export.R = 128; // real proto method for `library`
      module.exports = $export;

      /***/
    },
    /* 2 */
    /***/ function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(4);
      module.exports = function (it) {
        if (!isObject(it)) throw TypeError(it + " is not an object!");
        return it;
      };

      /***/
    },
    /* 3 */
    /***/ function (module, exports) {
      // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
      var global = (module.exports =
        typeof window != "undefined" && window.Math == Math
          ? window
          : typeof self != "undefined" && self.Math == Math
          ? self
          : // eslint-disable-next-line no-new-func
            Function("return this")());
      if (typeof __g == "number") __g = global; // eslint-disable-line no-undef

      /***/
    },
    /* 4 */
    /***/ function (module, exports) {
      module.exports = function (it) {
        return typeof it === "object" ? it !== null : typeof it === "function";
      };

      /***/
    },
    /* 5 */
    /***/ function (module, exports) {
      module.exports = function (exec) {
        try {
          return !!exec();
        } catch (e) {
          return true;
        }
      };

      /***/
    },
    /* 6 */
    /***/ function (module, exports, __webpack_require__) {
      var store = __webpack_require__(60)("wks");
      var uid = __webpack_require__(42);
      var Symbol = __webpack_require__(3).Symbol;
      var USE_SYMBOL = typeof Symbol == "function";

      var $exports = (module.exports = function (name) {
        return (
          store[name] ||
          (store[name] =
            (USE_SYMBOL && Symbol[name]) ||
            (USE_SYMBOL ? Symbol : uid)("Symbol." + name))
        );
      });

      $exports.store = store;

      /***/
    },
    /* 7 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var moneyFormats = {
        USD: {
          money_format: "${{amount}}",
          money_with_currency_format: "${{amount}} USD",
        },
        EUR: {
          money_format: "&euro;{{amount}}",
          money_with_currency_format: "&euro;{{amount}} EUR",
        },
        GBP: {
          money_format: "&pound;{{amount}}",
          money_with_currency_format: "&pound;{{amount}} GBP",
        },
        CAD: {
          money_format: "${{amount}}",
          money_with_currency_format: "${{amount}} CAD",
        },
        ALL: {
          money_format: "Lek {{amount}}",
          money_with_currency_format: "Lek {{amount}} ALL",
        },
        DZD: {
          money_format: "DA {{amount}}",
          money_with_currency_format: "DA {{amount}} DZD",
        },
        AOA: {
          money_format: "Kz{{amount}}",
          money_with_currency_format: "Kz{{amount}} AOA",
        },
        ARS: {
          money_format: "${{amount_with_comma_separator}}",
          money_with_currency_format: "${{amount_with_comma_separator}} ARS",
        },
        AMD: {
          money_format: "{{amount}} AMD",
          money_with_currency_format: "{{amount}} AMD",
        },
        AWG: {
          money_format: "Afl{{amount}}",
          money_with_currency_format: "Afl{{amount}} AWG",
        },
        AUD: {
          money_format: "${{amount}}",
          money_with_currency_format: "${{amount}} AUD",
        },
        BBD: {
          money_format: "${{amount}}",
          money_with_currency_format: "${{amount}} Bds",
        },
        AZN: {
          money_format: "m.{{amount}}",
          money_with_currency_format: "m.{{amount}} AZN",
        },
        BDT: {
          money_format: "Tk {{amount}}",
          money_with_currency_format: "Tk {{amount}} BDT",
        },
        BSD: {
          money_format: "BS${{amount}}",
          money_with_currency_format: "BS${{amount}} BSD",
        },
        BHD: {
          money_format: "{{amount}}0 BD",
          money_with_currency_format: "{{amount}}0 BHD",
        },
        BYR: {
          money_format: "Br {{amount}}",
          money_with_currency_format: "Br {{amount}} BYR",
        },
        BZD: {
          money_format: "BZ${{amount}}",
          money_with_currency_format: "BZ${{amount}} BZD",
        },
        BTN: {
          money_format: "Nu {{amount}}",
          money_with_currency_format: "Nu {{amount}} BTN",
        },
        BAM: {
          money_format: "KM {{amount_with_comma_separator}}",
          money_with_currency_format: "KM {{amount_with_comma_separator}} BAM",
        },
        BRL: {
          money_format: "R$ {{amount_with_comma_separator}}",
          money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL",
        },
        BOB: {
          money_format: "Bs{{amount_with_comma_separator}}",
          money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB",
        },
        BWP: {
          money_format: "P{{amount}}",
          money_with_currency_format: "P{{amount}} BWP",
        },
        BND: {
          money_format: "${{amount}}",
          money_with_currency_format: "${{amount}} BND",
        },
        BGN: {
          money_format: "{{amount}} лв",
          money_with_currency_format: "{{amount}} лв BGN",
        },
        MMK: {
          money_format: "K{{amount}}",
          money_with_currency_format: "K{{amount}} MMK",
        },
        KHR: {
          money_format: "KHR{{amount}}",
          money_with_currency_format: "KHR{{amount}}",
        },
        KYD: {
          money_format: "${{amount}}",
          money_with_currency_format: "${{amount}} KYD",
        },
        XAF: {
          money_format: "FCFA{{amount}}",
          money_with_currency_format: "FCFA{{amount}} XAF",
        },
        CLP: {
          money_format: "${{amount_no_decimals}}",
          money_with_currency_format: "${{amount_no_decimals}} CLP",
        },
        CNY: {
          money_format: "&#165;{{amount}}",
          money_with_currency_format: "&#165;{{amount}} CNY",
        },
        COP: {
          money_format: "${{amount_with_comma_separator}}",
          money_with_currency_format: "${{amount_with_comma_separator}} COP",
        },
        CRC: {
          money_format: "&#8353; {{amount_with_comma_separator}}",
          money_with_currency_format:
            "&#8353; {{amount_with_comma_separator}} CRC",
        },
        HRK: {
          money_format: "{{amount_with_comma_separator}} kn",
          money_with_currency_format: "{{amount_with_comma_separator}} kn HRK",
        },
        CZK: {
          money_format: "{{amount_with_comma_separator}} K&#269;",
          money_with_currency_format: "{{amount_with_comma_separator}} K&#269;",
        },
        DKK: {
          money_format: "{{amount_with_comma_separator}}",
          money_with_currency_format: "kr.{{amount_with_comma_separator}}",
        },
        DOP: {
          money_format: "RD$ {{amount}}",
          money_with_currency_format: "RD$ {{amount}}",
        },
        XCD: {
          money_format: "${{amount}}",
          money_with_currency_format: "EC${{amount}}",
        },
        EGP: {
          money_format: "LE {{amount}}",
          money_with_currency_format: "LE {{amount}} EGP",
        },
        ETB: {
          money_format: "Br{{amount}}",
          money_with_currency_format: "Br{{amount}} ETB",
        },
        XPF: {
          money_format: "{{amount_no_decimals_with_comma_separator}} XPF",
          money_with_currency_format:
            "{{amount_no_decimals_with_comma_separator}} XPF",
        },
        FJD: {
          money_format: "${{amount}}",
          money_with_currency_format: "FJ${{amount}}",
        },
        GMD: {
          money_format: "D {{amount}}",
          money_with_currency_format: "D {{amount}} GMD",
        },
        GHS: {
          money_format: "GH&#8373;{{amount}}",
          money_with_currency_format: "GH&#8373;{{amount}}",
        },
        GTQ: {
          money_format: "Q{{amount}}",
          money_with_currency_format: "{{amount}} GTQ",
        },
        GYD: {
          money_format: "G${{amount}}",
          money_with_currency_format: "${{amount}} GYD",
        },
        GEL: {
          money_format: "{{amount}} GEL",
          money_with_currency_format: "{{amount}} GEL",
        },
        HNL: {
          money_format: "L {{amount}}",
          money_with_currency_format: "L {{amount}} HNL",
        },
        HKD: {
          money_format: "${{amount}}",
          money_with_currency_format: "HK${{amount}}",
        },
        HUF: {
          money_format: "{{amount_no_decimals_with_comma_separator}}",
          money_with_currency_format:
            "{{amount_no_decimals_with_comma_separator}} Ft",
        },
        ISK: {
          money_format: "{{amount_no_decimals}} kr",
          money_with_currency_format: "{{amount_no_decimals}} kr ISK",
        },
        INR: {
          money_format: "Rs. {{amount}}",
          money_with_currency_format: "Rs. {{amount}}",
        },
        IDR: {
          money_format: "{{amount_with_comma_separator}}",
          money_with_currency_format: "Rp {{amount_with_comma_separator}}",
        },
        ILS: {
          money_format: "{{amount}} NIS",
          money_with_currency_format: "{{amount}} NIS",
        },
        JMD: {
          money_format: "${{amount}}",
          money_with_currency_format: "${{amount}} JMD",
        },
        JPY: {
          money_format: "&#165;{{amount_no_decimals}}",
          money_with_currency_format: "&#165;{{amount_no_decimals}} JPY",
        },
        JEP: {
          money_format: "&pound;{{amount}}",
          money_with_currency_format: "&pound;{{amount}} JEP",
        },
        JOD: {
          money_format: "{{amount}}0 JD",
          money_with_currency_format: "{{amount}}0 JOD",
        },
        KZT: {
          money_format: "{{amount}} KZT",
          money_with_currency_format: "{{amount}} KZT",
        },
        KES: {
          money_format: "KSh{{amount}}",
          money_with_currency_format: "KSh{{amount}}",
        },
        KWD: {
          money_format: "{{amount}}0 KD",
          money_with_currency_format: "{{amount}}0 KWD",
        },
        KGS: {
          money_format: "лв{{amount}}",
          money_with_currency_format: "лв{{amount}}",
        },
        LVL: {
          money_format: "Ls {{amount}}",
          money_with_currency_format: "Ls {{amount}} LVL",
        },
        LBP: {
          money_format: "L&pound;{{amount}}",
          money_with_currency_format: "L&pound;{{amount}} LBP",
        },
        LTL: {
          money_format: "{{amount}} Lt",
          money_with_currency_format: "{{amount}} Lt",
        },
        MGA: {
          money_format: "Ar {{amount}}",
          money_with_currency_format: "Ar {{amount}} MGA",
        },
        MKD: {
          money_format: "ден {{amount}}",
          money_with_currency_format: "ден {{amount}} MKD",
        },
        MOP: {
          money_format: "MOP${{amount}}",
          money_with_currency_format: "MOP${{amount}}",
        },
        MVR: {
          money_format: "Rf{{amount}}",
          money_with_currency_format: "Rf{{amount}} MRf",
        },
        MXN: {
          money_format: "$ {{amount}}",
          money_with_currency_format: "$ {{amount}} MXN",
        },
        MYR: {
          money_format: "RM{{amount}} MYR",
          money_with_currency_format: "RM{{amount}} MYR",
        },
        MUR: {
          money_format: "Rs {{amount}}",
          money_with_currency_format: "Rs {{amount}} MUR",
        },
        MDL: {
          money_format: "{{amount}} MDL",
          money_with_currency_format: "{{amount}} MDL",
        },
        MAD: {
          money_format: "{{amount}} dh",
          money_with_currency_format: "Dh {{amount}} MAD",
        },
        MNT: {
          money_format: "{{amount_no_decimals}} &#8366",
          money_with_currency_format: "{{amount_no_decimals}} MNT",
        },
        MZN: {
          money_format: "{{amount}} Mt",
          money_with_currency_format: "Mt {{amount}} MZN",
        },
        NAD: {
          money_format: "N${{amount}}",
          money_with_currency_format: "N${{amount}} NAD",
        },
        NPR: {
          money_format: "Rs{{amount}}",
          money_with_currency_format: "Rs{{amount}} NPR",
        },
        ANG: {
          money_format: "&fnof;{{amount}}",
          money_with_currency_format: "{{amount}} NA&fnof;",
        },
        NZD: {
          money_format: "${{amount}}",
          money_with_currency_format: "${{amount}} NZD",
        },
        NIO: {
          money_format: "C${{amount}}",
          money_with_currency_format: "C${{amount}} NIO",
        },
        NGN: {
          money_format: "&#8358;{{amount}}",
          money_with_currency_format: "&#8358;{{amount}} NGN",
        },
        NOK: {
          money_format: "kr {{amount_with_comma_separator}}",
          money_with_currency_format: "kr {{amount_with_comma_separator}} NOK",
        },
        OMR: {
          money_format: "{{amount_with_comma_separator}} OMR",
          money_with_currency_format: "{{amount_with_comma_separator}} OMR",
        },
        PKR: {
          money_format: "Rs.{{amount}}",
          money_with_currency_format: "Rs.{{amount}} PKR",
        },
        PGK: {
          money_format: "K {{amount}}",
          money_with_currency_format: "K {{amount}} PGK",
        },
        PYG: {
          money_format: "Gs. {{amount_no_decimals_with_comma_separator}}",
          money_with_currency_format:
            "Gs. {{amount_no_decimals_with_comma_separator}} PYG",
        },
        PEN: {
          money_format: "S/. {{amount}}",
          money_with_currency_format: "S/. {{amount}} PEN",
        },
        PHP: {
          money_format: "&#8369;{{amount}}",
          money_with_currency_format: "&#8369;{{amount}} PHP",
        },
        PLN: {
          money_format: "{{amount_with_comma_separator}} zl",
          money_with_currency_format: "{{amount_with_comma_separator}} zl PLN",
        },
        QAR: {
          money_format: "QAR {{amount_with_comma_separator}}",
          money_with_currency_format: "QAR {{amount_with_comma_separator}}",
        },
        RON: {
          money_format: "{{amount_with_comma_separator}} lei",
          money_with_currency_format: "{{amount_with_comma_separator}} lei RON",
        },
        RUB: {
          money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
          money_with_currency_format:
            "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB",
        },
        RWF: {
          money_format: "{{amount_no_decimals}} RF",
          money_with_currency_format: "{{amount_no_decimals}} RWF",
        },
        WST: {
          money_format: "WS$ {{amount}}",
          money_with_currency_format: "WS$ {{amount}} WST",
        },
        SAR: {
          money_format: "{{amount}} SR",
          money_with_currency_format: "{{amount}} SAR",
        },
        STD: {
          money_format: "Db {{amount}}",
          money_with_currency_format: "Db {{amount}} STD",
        },
        RSD: {
          money_format: "{{amount}} RSD",
          money_with_currency_format: "{{amount}} RSD",
        },
        SCR: {
          money_format: "Rs {{amount}}",
          money_with_currency_format: "Rs {{amount}} SCR",
        },
        SGD: {
          money_format: "${{amount}}",
          money_with_currency_format: "${{amount}} SGD",
        },
        SYP: {
          money_format: "S&pound;{{amount}}",
          money_with_currency_format: "S&pound;{{amount}} SYP",
        },
        ZAR: {
          money_format: "R {{amount}}",
          money_with_currency_format: "R {{amount}} ZAR",
        },
        KRW: {
          money_format: "&#8361;{{amount_no_decimals}}",
          money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW",
        },
        LKR: {
          money_format: "Rs {{amount}}",
          money_with_currency_format: "Rs {{amount}} LKR",
        },
        SEK: {
          money_format: "{{amount_no_decimals}} kr",
          money_with_currency_format: "{{amount_no_decimals}} kr SEK",
        },
        CHF: {
          money_format: "SFr. {{amount}}",
          money_with_currency_format: "SFr. {{amount}} CHF",
        },
        TWD: {
          money_format: "${{amount}}",
          money_with_currency_format: "${{amount}} TWD",
        },
        THB: {
          money_format: "{{amount}} &#xe3f;",
          money_with_currency_format: "{{amount}} &#xe3f; THB",
        },
        TZS: {
          money_format: "{{amount}} TZS",
          money_with_currency_format: "{{amount}} TZS",
        },
        TTD: {
          money_format: "${{amount}}",
          money_with_currency_format: "${{amount}} TTD",
        },
        TND: {
          money_format: "{{amount}}",
          money_with_currency_format: "{{amount}} DT",
        },
        TRY: {
          money_format: "{{amount}}TL",
          money_with_currency_format: "{{amount}}TL",
        },
        UGX: {
          money_format: "Ush {{amount_no_decimals}}",
          money_with_currency_format: "Ush {{amount_no_decimals}} UGX",
        },
        UAH: {
          money_format: "₴{{amount}}",
          money_with_currency_format: "₴{{amount}} UAH",
        },
        AED: {
          money_format: "Dhs. {{amount}}",
          money_with_currency_format: "Dhs. {{amount}} AED",
        },
        UYU: {
          money_format: "${{amount_with_comma_separator}}",
          money_with_currency_format: "${{amount_with_comma_separator}} UYU",
        },
        VUV: {
          money_format: "${{amount}}",
          money_with_currency_format: "${{amount}}VT",
        },
        VEF: {
          money_format: "Bs. {{amount_with_comma_separator}}",
          money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF",
        },
        VND: {
          money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;",
          money_with_currency_format:
            "{{amount_no_decimals_with_comma_separator}} VND",
        },
        XBT: {
          money_format: "{{amount_no_decimals}} BTC",
          money_with_currency_format: "{{amount_no_decimals}} BTC",
        },
        XOF: {
          money_format: "CFA{{amount}}",
          money_with_currency_format: "CFA{{amount}} XOF",
        },
        ZMW: {
          money_format: "K{{amount_no_decimals_with_comma_separator}}",
          money_with_currency_format:
            "ZMW{{amount_no_decimals_with_comma_separator}}",
        },
      };

      /**
       * Format a number to a specific format
       *
       * @param {Number} number - Value to format
       * @param {Number} precision - Amount of decimal points to show
       * @param {String} thousands - Thousands delimiter
       * @param {String} decimal - Decimal delimiter
       * @returns {String|Number}
       */
      function formatWithDelimiters(number) {
        var precision =
          arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        var thousands =
          arguments.length > 2 && arguments[2] !== undefined
            ? arguments[2]
            : ",";
        var decimal =
          arguments.length > 3 && arguments[3] !== undefined
            ? arguments[3]
            : ".";

        if (isNaN(number) || !number) {
          return 0;
        }

        var preciseNumber = (number / 100.0).toFixed(precision);

        var parts = preciseNumber.split(thousands);
        var dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : "";

        return dollarsAmount + centsAmount;
      }

      /**
       * Convert a money value in cents to a formatted currency string
       *
       * @param {Number|String} cents
       * @param {String} format
       * @returns {String}
       */
      function formatMoney(cents, format) {
        if (typeof cents === "string") {
          cents = cents.replace(".", "");
        }

        var value = "";
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

        switch (format.match(placeholderRegex)[1]) {
          case "amount":
            value = formatWithDelimiters(cents, 2, ",", ".");
            break;
          case "amount_with_space_separator":
            value = formatWithDelimiters(cents, 2, " ", ".");
            break;
          case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
          case "amount_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 2, "'", ".");
            break;
          case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0, ",", ".");
            break;
          case "amount_no_decimals_with_space_separator":
            value = formatWithDelimiters(cents, 0, " ", ".");
            break;
          case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ",", ".");
            break;
        }

        return format.replace(placeholderRegex, value);
      }

      /**
       * Return the value of money in cents value
       *
       * @param {Number} moneyAmount - Money value of a price
       *                 eg: 1000
       * @param {String} format - Shop formatting of a price
       *                 eg: {{amount}}
       * @param {String} currency - Currency of a price
       *                 eg: 'CAD'
       * @returns {Number}
       * @private
       */
      function getCentsValue(moneyAmount, format, currency) {
        var cents = 0;
        // Convert prices from float values to integers if needed, then convert
        if (format.indexOf("amount_no_decimals") !== -1) {
          cents = moneyAmount * 100;
        } else if (
          currency === "JOD" ||
          currency === "KWD" ||
          currency === "BHD"
        ) {
          cents = moneyAmount / 10;
        } else {
          cents = moneyAmount;
        }

        return cents;
      }

      /**
       * Converts formatted money to a number
       *
       * @param {Element} priceEl
       * @returns {Number|String}
       */
      function getMoneyValue(priceEl) {
        var price = priceEl.textContent;
        var value = parseInt(price.replace(/[^0-9]/g, ""), 10);

        return !isNaN(value) ? value : "";
      }

      var classCallCheck = function (instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      };

      var createClass = (function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      })();

      var CurrencyConverter = (function () {
        function CurrencyConverter() {
          classCallCheck(this, CurrencyConverter);

          this.defaults = {
            switcherSelector: "[data-currency-converter]",
            priceSelector: ".money",
            shopCurrency: "",
            defaultCurrency: "",
            displayFormat: "",
            moneyFormat: "",
            moneyFormatNoCurrency: "",
            moneyFormatCurrency: "",
          };

          this.options = {};
          this.moneyFormats = moneyFormats;
          this.storage = "currency";
          this.currentCurrency = null;
          this.isInitialised = false;
        }

        /**
         * Initialize CurrencyConverter
         *
         * @param settings
         * @property {Object} settings
         *                    Configuration for CurrencyConverter
         * @property {String} settings.switcherSelector
         *                    CSS Selector for dropdown(s) which controls currency conversion
         * @property {String} settings.priceSelector
         *                    CSS Selector for elements containing prices
         * @property {String} settings.shopCurrency
         *                    Shop's currency (The currency used to process transactions)
         * @property {String} settings.defaultCurrency
         *                    Theme's currency setting, or initial currency to show on the page
         * @property {String} settings.displayFormat
         *                    `money_with_currency_format` or `money_format`
         * @property {String} settings.moneyFormat
         *                    Shop's currency formatted using the selected display format
         * @property {String} settings.moneyFormatNoCurrency
         *                    Shop's currency formatted without showing currency code
         * @property {String} settings.moneyFormatCurrency
         *                    Shop's currency formatted showing currency code
         */

        createClass(CurrencyConverter, [
          {
            key: "init",
            value: function init(settings) {
              var _this = this;

              if (!window.Currency || this.isInitialised) return;

              Object.keys(this.defaults).forEach(function (key) {
                _this.options[key] = settings[key] || _this.defaults[key];
              });

              this.currentCurrency =
                this._getStoredCurrency() || this.options.defaultCurrency;
              this.moneyFormats[
                this.options.shopCurrency
              ].money_with_currency_format = this.options.moneyFormatCurrency;
              this.moneyFormats[this.options.shopCurrency].money_format =
                this.options.moneyFormatNoCurrency;

              this.isInitialised = true;
              this._current();
            },

            /**
             * Change the currency to a new currency using an ISO currency code
             *
             * @param {String} newCurrency - New currency to convert prices to
             */
          },
          {
            key: "setCurrency",
            value: function setCurrency(newCurrency) {
              if (!this.isInitialised) return;

              this._convertAll(this.currentCurrency, newCurrency);
            },

            /**
             * Update a price on the page from shop currency to the active currency, and formatting
             *
             * @param priceEl {HTMLElement} - element containing price text, in the shop currency
             */
          },
          {
            key: "update",
            value: function update(priceEl) {
              if (!this.isInitialised) return;

              // unset any stored previous conversions and the data-currency attribute itself
              var attributes = priceEl.attributes;
              for (var attr = 0; attr < attributes.length; attr++) {
                var attribute = attributes[attr];

                if (attribute.name.indexOf("data-currency") === 0) {
                  priceEl.setAttribute(attribute.name, "");
                }
              }

              this._convertEl(
                priceEl,
                this.options.shopCurrency,
                this.currentCurrency
              );
            },

            /**
             * Return the stored currency from the client's browser
             * @returns {String}
             * @private
             */
          },
          {
            key: "_getStoredCurrency",
            value: function _getStoredCurrency() {
              try {
                return localStorage.getItem(this.storage);
              } catch (error) {
                console.warn(error);
                return this.options.defaultCurrency;
              }
            },

            /**
             * Save the client's currency in localstorage for persistence across pages
             * and sessions
             * @param {String} currency
             * @private
             */
          },
          {
            key: "_setStoredCurrency",
            value: function _setStoredCurrency(currency) {
              try {
                localStorage.setItem(this.storage, currency);
              } catch (error) {
                console.warn(error);
              }
            },

            /**
             * Update the currency switcher to the current currency
             * @private
             */
          },
          {
            key: "_current",
            value: function _current() {
              var switchers = document.querySelectorAll(
                this.options.switcherSelector
              );
              for (var i = 0; i < switchers.length; i += 1) {
                var switcher = switchers[i];
                var childrenEls = switcher.querySelectorAll("option");

                for (var j = 0; j < childrenEls.length; j += 1) {
                  var optionEl = childrenEls[j];

                  if (
                    optionEl.selected &&
                    optionEl.value !== this.currentCurrency
                  ) {
                    optionEl.selected = false;
                  }

                  if (optionEl.value === this.currentCurrency) {
                    optionEl.selected = true;
                  }
                }
              }

              this._convertAll(this.options.shopCurrency, this.currentCurrency);
            },

            /**
             * Converts an individual price to the new format
             *
             * @param {Element} priceEl - Node element containing price
             * @param {String} oldCurrency - Currency of element converting from
             * @param {String} newCurrency - Currency to convert to
             * @private
             */
          },
          {
            key: "_convertEl",
            value: function _convertEl(priceEl, oldCurrency, newCurrency) {
              // If the amount has already been converted, we leave it alone.
              if (priceEl.getAttribute("data-currency") === newCurrency) {
                return;
              }

              // If we are converting to a currency that we have saved, we will use the saved amount.
              if (priceEl.getAttribute("data-currency-" + newCurrency)) {
                priceEl.innerHTML = priceEl.getAttribute(
                  "data-currency-" + newCurrency
                );
              } else {
                var oldFormat =
                  this.moneyFormats[oldCurrency][this.options.displayFormat];
                var newFormat =
                  this.moneyFormats[newCurrency][this.options.displayFormat];

                var moneyValue = getMoneyValue(priceEl);
                var centsValue = getCentsValue(
                  moneyValue,
                  oldFormat,
                  oldCurrency
                );

                // Cents value is empty, but not 0. 0$ is a valid price, while empty is not
                if (centsValue === "") return;

                var cents = window.Currency.convert(
                  centsValue,
                  oldCurrency,
                  newCurrency
                );
                var oldPriceFormatted = formatMoney(centsValue, oldFormat);
                var priceFormatted = formatMoney(cents, newFormat);

                priceEl.setAttribute(
                  "data-currency-" + oldCurrency,
                  oldPriceFormatted
                );
                priceEl.setAttribute(
                  "data-currency-" + newCurrency,
                  priceFormatted
                );
                priceEl.innerHTML = priceFormatted;
              }

              priceEl.setAttribute("data-currency", newCurrency);
            },

            /**
             * Convert all prices on the page to the new currency
             *
             * @param {String} oldCurrency - Currency of element converting from
             * @param {String} newCurrency - Currency to convert to
             * @private
             */
          },
          {
            key: "_convertAll",
            value: function _convertAll(oldCurrency, newCurrency) {
              var priceEls = document.querySelectorAll(
                this.options.priceSelector
              );
              if (!priceEls) return;

              this.currentCurrency = newCurrency;
              this._setStoredCurrency(newCurrency);

              for (var i = 0; i < priceEls.length; i += 1) {
                this._convertEl(priceEls[i], oldCurrency, newCurrency);
              }
            },
          },
        ]);
        return CurrencyConverter;
      })();

      var CurrencyConverter$1 = new CurrencyConverter();

      module.exports = CurrencyConverter$1;

      /***/
    },
    /* 8 */
    /***/ function (module, exports, __webpack_require__) {
      var anObject = __webpack_require__(2);
      var IE8_DOM_DEFINE = __webpack_require__(108);
      var toPrimitive = __webpack_require__(24);
      var dP = Object.defineProperty;

      exports.f = __webpack_require__(9)
        ? Object.defineProperty
        : function defineProperty(O, P, Attributes) {
            anObject(O);
            P = toPrimitive(P, true);
            anObject(Attributes);
            if (IE8_DOM_DEFINE)
              try {
                return dP(O, P, Attributes);
              } catch (e) {
                /* empty */
              }
            if ("get" in Attributes || "set" in Attributes)
              throw TypeError("Accessors not supported!");
            if ("value" in Attributes) O[P] = Attributes.value;
            return O;
          };

      /***/
    },
    /* 9 */
    /***/ function (module, exports, __webpack_require__) {
      // Thank's IE8 for his funny defineProperty
      module.exports = !__webpack_require__(5)(function () {
        return (
          Object.defineProperty({}, "a", {
            get: function () {
              return 7;
            },
          }).a != 7
        );
      });

      /***/
    },
    /* 10 */
    /***/ function (module, exports, __webpack_require__) {
      // 7.1.15 ToLength
      var toInteger = __webpack_require__(26);
      var min = Math.min;
      module.exports = function (it) {
        return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
      };

      /***/
    },
    /* 11 */
    /***/ function (module, exports) {
      var core = (module.exports = { version: "2.5.7" });
      if (typeof __e == "number") __e = core; // eslint-disable-line no-undef

      /***/
    },
    /* 12 */
    /***/ function (module, exports, __webpack_require__) {
      // 7.1.13 ToObject(argument)
      var defined = __webpack_require__(25);
      module.exports = function (it) {
        return Object(defined(it));
      };

      /***/
    },
    /* 13 */
    /***/ function (module, exports) {
      module.exports = function (it) {
        if (typeof it != "function")
          throw TypeError(it + " is not a function!");
        return it;
      };

      /***/
    },
    /* 14 */
    /***/ function (module, exports, __webpack_require__) {
      // to indexed object, toObject with fallback for non-array-like ES3 strings
      var IObject = __webpack_require__(55);
      var defined = __webpack_require__(25);
      module.exports = function (it) {
        return IObject(defined(it));
      };

      /***/
    },
    /* 15 */
    /***/ function (module, exports) {
      var hasOwnProperty = {}.hasOwnProperty;
      module.exports = function (it, key) {
        return hasOwnProperty.call(it, key);
      };

      /***/
    },
    /* 16 */
    /***/ function (module, exports, __webpack_require__) {
      var dP = __webpack_require__(8);
      var createDesc = __webpack_require__(36);
      module.exports = __webpack_require__(9)
        ? function (object, key, value) {
            return dP.f(object, key, createDesc(1, value));
          }
        : function (object, key, value) {
            object[key] = value;
            return object;
          };

      /***/
    },
    /* 17 */
    /***/ function (module, exports, __webpack_require__) {
      var global = __webpack_require__(3);
      var hide = __webpack_require__(16);
      var has = __webpack_require__(15);
      var SRC = __webpack_require__(42)("src");
      var TO_STRING = "toString";
      var $toString = Function[TO_STRING];
      var TPL = ("" + $toString).split(TO_STRING);

      __webpack_require__(11).inspectSource = function (it) {
        return $toString.call(it);
      };

      (module.exports = function (O, key, val, safe) {
        var isFunction = typeof val == "function";
        if (isFunction) has(val, "name") || hide(val, "name", key);
        if (O[key] === val) return;
        if (isFunction)
          has(val, SRC) ||
            hide(val, SRC, O[key] ? "" + O[key] : TPL.join(String(key)));
        if (O === global) {
          O[key] = val;
        } else if (!safe) {
          delete O[key];
          hide(O, key, val);
        } else if (O[key]) {
          O[key] = val;
        } else {
          hide(O, key, val);
        }
        // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
      })(Function.prototype, TO_STRING, function toString() {
        return (typeof this == "function" && this[SRC]) || $toString.call(this);
      });

      /***/
    },
    /* 18 */
    /***/ function (module, exports, __webpack_require__) {
      var pIE = __webpack_require__(56);
      var createDesc = __webpack_require__(36);
      var toIObject = __webpack_require__(14);
      var toPrimitive = __webpack_require__(24);
      var has = __webpack_require__(15);
      var IE8_DOM_DEFINE = __webpack_require__(108);
      var gOPD = Object.getOwnPropertyDescriptor;

      exports.f = __webpack_require__(9)
        ? gOPD
        : function getOwnPropertyDescriptor(O, P) {
            O = toIObject(O);
            P = toPrimitive(P, true);
            if (IE8_DOM_DEFINE)
              try {
                return gOPD(O, P);
              } catch (e) {
                /* empty */
              }
            if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
          };

      /***/
    },
    /* 19 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
      var has = __webpack_require__(15);
      var toObject = __webpack_require__(12);
      var IE_PROTO = __webpack_require__(80)("IE_PROTO");
      var ObjectProto = Object.prototype;

      module.exports =
        Object.getPrototypeOf ||
        function (O) {
          O = toObject(O);
          if (has(O, IE_PROTO)) return O[IE_PROTO];
          if (
            typeof O.constructor == "function" &&
            O instanceof O.constructor
          ) {
            return O.constructor.prototype;
          }
          return O instanceof Object ? ObjectProto : null;
        };

      /***/
    },
    /* 20 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(1);
      var fails = __webpack_require__(5);
      var defined = __webpack_require__(25);
      var quot = /"/g;
      // B.2.3.2.1 CreateHTML(string, tag, attribute, value)
      var createHTML = function (string, tag, attribute, value) {
        var S = String(defined(string));
        var p1 = "<" + tag;
        if (attribute !== "")
          p1 +=
            " " +
            attribute +
            '="' +
            String(value).replace(quot, "&quot;") +
            '"';
        return p1 + ">" + S + "</" + tag + ">";
      };
      module.exports = function (NAME, exec) {
        var O = {};
        O[NAME] = exec(createHTML);
        $export(
          $export.P +
            $export.F *
              fails(function () {
                var test = ""[NAME]('"');
                return (
                  test !== test.toLowerCase() || test.split('"').length > 3
                );
              }),
          "String",
          O
        );
      };

      /***/
    },
    /* 21 */
    /***/ function (module, exports, __webpack_require__) {
      // optional / simple context binding
      var aFunction = __webpack_require__(13);
      module.exports = function (fn, that, length) {
        aFunction(fn);
        if (that === undefined) return fn;
        switch (length) {
          case 1:
            return function (a) {
              return fn.call(that, a);
            };
          case 2:
            return function (a, b) {
              return fn.call(that, a, b);
            };
          case 3:
            return function (a, b, c) {
              return fn.call(that, a, b, c);
            };
        }
        return function (/* ...args */) {
          return fn.apply(that, arguments);
        };
      };

      /***/
    },
    /* 22 */
    /***/ function (module, exports) {
      var toString = {}.toString;

      module.exports = function (it) {
        return toString.call(it).slice(8, -1);
      };

      /***/
    },
    /* 23 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var fails = __webpack_require__(5);

      module.exports = function (method, arg) {
        return (
          !!method &&
          fails(function () {
            // eslint-disable-next-line no-useless-call
            arg
              ? method.call(
                  null,
                  function () {
                    /* empty */
                  },
                  1
                )
              : method.call(null);
          })
        );
      };

      /***/
    },
    /* 24 */
    /***/ function (module, exports, __webpack_require__) {
      // 7.1.1 ToPrimitive(input [, PreferredType])
      var isObject = __webpack_require__(4);
      // instead of the ES6 spec version, we didn't implement @@toPrimitive case
      // and the second argument - flag - preferred type is a string
      module.exports = function (it, S) {
        if (!isObject(it)) return it;
        var fn, val;
        if (
          S &&
          typeof (fn = it.toString) == "function" &&
          !isObject((val = fn.call(it)))
        )
          return val;
        if (
          typeof (fn = it.valueOf) == "function" &&
          !isObject((val = fn.call(it)))
        )
          return val;
        if (
          !S &&
          typeof (fn = it.toString) == "function" &&
          !isObject((val = fn.call(it)))
        )
          return val;
        throw TypeError("Can't convert object to primitive value");
      };

      /***/
    },
    /* 25 */
    /***/ function (module, exports) {
      // 7.2.1 RequireObjectCoercible(argument)
      module.exports = function (it) {
        if (it == undefined) throw TypeError("Can't call method on  " + it);
        return it;
      };

      /***/
    },
    /* 26 */
    /***/ function (module, exports) {
      // 7.1.4 ToInteger
      var ceil = Math.ceil;
      var floor = Math.floor;
      module.exports = function (it) {
        return isNaN((it = +it)) ? 0 : (it > 0 ? floor : ceil)(it);
      };

      /***/
    },
    /* 27 */
    /***/ function (module, exports, __webpack_require__) {
      // most Object methods by ES6 should accept primitives
      var $export = __webpack_require__(1);
      var core = __webpack_require__(11);
      var fails = __webpack_require__(5);
      module.exports = function (KEY, exec) {
        var fn = (core.Object || {})[KEY] || Object[KEY];
        var exp = {};
        exp[KEY] = exec(fn);
        $export(
          $export.S +
            $export.F *
              fails(function () {
                fn(1);
              }),
          "Object",
          exp
        );
      };

      /***/
    },
    /* 28 */
    /***/ function (module, exports, __webpack_require__) {
      // 0 -> Array#forEach
      // 1 -> Array#map
      // 2 -> Array#filter
      // 3 -> Array#some
      // 4 -> Array#every
      // 5 -> Array#find
      // 6 -> Array#findIndex
      var ctx = __webpack_require__(21);
      var IObject = __webpack_require__(55);
      var toObject = __webpack_require__(12);
      var toLength = __webpack_require__(10);
      var asc = __webpack_require__(98);
      module.exports = function (TYPE, $create) {
        var IS_MAP = TYPE == 1;
        var IS_FILTER = TYPE == 2;
        var IS_SOME = TYPE == 3;
        var IS_EVERY = TYPE == 4;
        var IS_FIND_INDEX = TYPE == 6;
        var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
        var create = $create || asc;
        return function ($this, callbackfn, that) {
          var O = toObject($this);
          var self = IObject(O);
          var f = ctx(callbackfn, that, 3);
          var length = toLength(self.length);
          var index = 0;
          var result = IS_MAP
            ? create($this, length)
            : IS_FILTER
            ? create($this, 0)
            : undefined;
          var val, res;
          for (; length > index; index++)
            if (NO_HOLES || index in self) {
              val = self[index];
              res = f(val, index, O);
              if (TYPE) {
                if (IS_MAP) result[index] = res; // map
                else if (res)
                  switch (TYPE) {
                    case 3:
                      return true; // some
                    case 5:
                      return val; // find
                    case 6:
                      return index; // findIndex
                    case 2:
                      result.push(val); // filter
                  }
                else if (IS_EVERY) return false; // every
              }
            }
          return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
        };
      };

      /***/
    },
    /* 29 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;
      /*!
       * $script.js JS loader & dependency manager
       * https://github.com/ded/script.js
       * (c) Dustin Diaz 2014 | License MIT
       */

      (function (name, definition) {
        if (true && module.exports) module.exports = definition();
        else if (true)
          !((__WEBPACK_AMD_DEFINE_FACTORY__ = definition),
          (__WEBPACK_AMD_DEFINE_RESULT__ =
            typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
              ? __WEBPACK_AMD_DEFINE_FACTORY__.call(
                  exports,
                  __webpack_require__,
                  exports,
                  module
                )
              : __WEBPACK_AMD_DEFINE_FACTORY__),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
            (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        else {
        }
      })("$script", function () {
        var doc = document,
          head = doc.getElementsByTagName("head")[0],
          s = "string",
          f = false,
          push = "push",
          readyState = "readyState",
          onreadystatechange = "onreadystatechange",
          list = {},
          ids = {},
          delay = {},
          scripts = {},
          scriptpath,
          urlArgs;

        function every(ar, fn) {
          for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f;
          return 1;
        }
        function each(ar, fn) {
          every(ar, function (el) {
            fn(el);
            return 1;
          });
        }

        function $script(paths, idOrDone, optDone) {
          paths = paths[push] ? paths : [paths];
          var idOrDoneIsDone = idOrDone && idOrDone.call,
            done = idOrDoneIsDone ? idOrDone : optDone,
            id = idOrDoneIsDone ? paths.join("") : idOrDone,
            queue = paths.length;
          function loopFn(item) {
            return item.call ? item() : list[item];
          }
          function callback() {
            if (!--queue) {
              list[id] = 1;
              done && done();
              for (var dset in delay) {
                every(dset.split("|"), loopFn) &&
                  !each(delay[dset], loopFn) &&
                  (delay[dset] = []);
              }
            }
          }
          setTimeout(function () {
            each(paths, function loading(path, force) {
              if (path === null) return callback();

              if (!force && !/^https?:\/\//.test(path) && scriptpath) {
                path =
                  path.indexOf(".js") === -1
                    ? scriptpath + path + ".js"
                    : scriptpath + path;
              }

              if (scripts[path]) {
                if (id) ids[id] = 1;
                return scripts[path] == 2
                  ? callback()
                  : setTimeout(function () {
                      loading(path, true);
                    }, 0);
              }

              scripts[path] = 1;
              if (id) ids[id] = 1;
              create(path, callback);
            });
          }, 0);
          return $script;
        }

        function create(path, fn) {
          var el = doc.createElement("script"),
            loaded;
          el.onload =
            el.onerror =
            el[onreadystatechange] =
              function () {
                if (
                  (el[readyState] && !/^c|loade/.test(el[readyState])) ||
                  loaded
                )
                  return;
                el.onload = el[onreadystatechange] = null;
                loaded = 1;
                scripts[path] = 2;
                fn();
              };
          el.async = 1;
          el.src = urlArgs
            ? path + (path.indexOf("?") === -1 ? "?" : "&") + urlArgs
            : path;
          head.insertBefore(el, head.lastChild);
        }

        $script.get = create;

        $script.order = function (scripts, id, done) {
          (function callback(s) {
            s = scripts.shift();
            !scripts.length ? $script(s, id, done) : $script(s, callback);
          })();
        };

        $script.path = function (p) {
          scriptpath = p;
        };
        $script.urlArgs = function (str) {
          urlArgs = str;
        };
        $script.ready = function (deps, ready, req) {
          deps = deps[push] ? deps : [deps];
          var missing = [];
          !each(deps, function (dep) {
            list[dep] || missing[push](dep);
          }) &&
          every(deps, function (dep) {
            return list[dep];
          })
            ? ready()
            : !(function (key) {
                delay[key] = delay[key] || [];
                delay[key][push](ready);
                req && req(missing);
              })(deps.join("|"));
          return $script;
        };

        $script.done = function (idOrDone) {
          $script([null], idOrDone);
        };

        return $script;
      });

      /***/
    },
    /* 30 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.14 / 15.2.3.14 Object.keys(O)
      var $keys = __webpack_require__(110);
      var enumBugKeys = __webpack_require__(81);

      module.exports =
        Object.keys ||
        function keys(O) {
          return $keys(O, enumBugKeys);
        };

      /***/
    },
    /* 31 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
      var anObject = __webpack_require__(2);
      var dPs = __webpack_require__(111);
      var enumBugKeys = __webpack_require__(81);
      var IE_PROTO = __webpack_require__(80)("IE_PROTO");
      var Empty = function () {
        /* empty */
      };
      var PROTOTYPE = "prototype";

      // Create object with fake `null` prototype: use iframe Object with cleared prototype
      var createDict = function () {
        // Thrash, waste and sodomy: IE GC bug
        var iframe = __webpack_require__(78)("iframe");
        var i = enumBugKeys.length;
        var lt = "<";
        var gt = ">";
        var iframeDocument;
        iframe.style.display = "none";
        __webpack_require__(82).appendChild(iframe);
        iframe.src = "javascript:"; // eslint-disable-line no-script-url
        // createDict = iframe.contentWindow.Object;
        // html.removeChild(iframe);
        iframeDocument = iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(
          lt + "script" + gt + "document.F=Object" + lt + "/script" + gt
        );
        iframeDocument.close();
        createDict = iframeDocument.F;
        while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
        return createDict();
      };

      module.exports =
        Object.create ||
        function create(O, Properties) {
          var result;
          if (O !== null) {
            Empty[PROTOTYPE] = anObject(O);
            result = new Empty();
            Empty[PROTOTYPE] = null;
            // add "__proto__" for Object.getPrototypeOf polyfill
            result[IE_PROTO] = O;
          } else result = createDict();
          return Properties === undefined ? result : dPs(result, Properties);
        };

      /***/
    },
    /* 32 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
      /**
       * Fizzy UI utils v2.0.7
       * MIT license
       */

      /*jshint browser: true, undef: true, unused: true, strict: true */

      (function (window, factory) {
        // universal module definition
        /*jshint strict: false */ /*globals define, module, require */

        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(156)]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (matchesSelector) {
            return factory(window, matchesSelector);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
            (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(window, function factory(window, matchesSelector) {
        "use strict";

        var utils = {};

        // ----- extend ----- //

        // extends objects
        utils.extend = function (a, b) {
          for (var prop in b) {
            a[prop] = b[prop];
          }
          return a;
        };

        // ----- modulo ----- //

        utils.modulo = function (num, div) {
          return ((num % div) + div) % div;
        };

        // ----- makeArray ----- //

        var arraySlice = Array.prototype.slice;

        // turn element or nodeList into an array
        utils.makeArray = function (obj) {
          if (Array.isArray(obj)) {
            // use object if already an array
            return obj;
          }
          // return empty array if undefined or null. #6
          if (obj === null || obj === undefined) {
            return [];
          }

          var isArrayLike =
            typeof obj == "object" && typeof obj.length == "number";
          if (isArrayLike) {
            // convert nodeList to array
            return arraySlice.call(obj);
          }

          // array of single index
          return [obj];
        };

        // ----- removeFrom ----- //

        utils.removeFrom = function (ary, obj) {
          var index = ary.indexOf(obj);
          if (index != -1) {
            ary.splice(index, 1);
          }
        };

        // ----- getParent ----- //

        utils.getParent = function (elem, selector) {
          while (elem.parentNode && elem != document.body) {
            elem = elem.parentNode;
            if (matchesSelector(elem, selector)) {
              return elem;
            }
          }
        };

        // ----- getQueryElement ----- //

        // use element as selector string
        utils.getQueryElement = function (elem) {
          if (typeof elem == "string") {
            return document.querySelector(elem);
          }
          return elem;
        };

        // ----- handleEvent ----- //

        // enable .ontype to trigger from .addEventListener( elem, 'type' )
        utils.handleEvent = function (event) {
          var method = "on" + event.type;
          if (this[method]) {
            this[method](event);
          }
        };

        // ----- filterFindElements ----- //

        utils.filterFindElements = function (elems, selector) {
          // make array of elems
          elems = utils.makeArray(elems);
          var ffElems = [];

          elems.forEach(function (elem) {
            // check that elem is an actual element
            if (!(elem instanceof HTMLElement)) {
              return;
            }
            // add elem if no selector
            if (!selector) {
              ffElems.push(elem);
              return;
            }
            // filter & find items if we have a selector
            // filter
            if (matchesSelector(elem, selector)) {
              ffElems.push(elem);
            }
            // find children
            var childElems = elem.querySelectorAll(selector);
            // concat childElems to filterFound array
            for (var i = 0; i < childElems.length; i++) {
              ffElems.push(childElems[i]);
            }
          });

          return ffElems;
        };

        // ----- debounceMethod ----- //

        utils.debounceMethod = function (_class, methodName, threshold) {
          threshold = threshold || 100;
          // original method
          var method = _class.prototype[methodName];
          var timeoutName = methodName + "Timeout";

          _class.prototype[methodName] = function () {
            var timeout = this[timeoutName];
            clearTimeout(timeout);

            var args = arguments;
            var _this = this;
            this[timeoutName] = setTimeout(function () {
              method.apply(_this, args);
              delete _this[timeoutName];
            }, threshold);
          };
        };

        // ----- docReady ----- //

        utils.docReady = function (callback) {
          var readyState = document.readyState;
          if (readyState == "complete" || readyState == "interactive") {
            // do async to allow for other scripts to run. metafizzy/flickity#441
            setTimeout(callback);
          } else {
            document.addEventListener("DOMContentLoaded", callback);
          }
        };

        // ----- htmlInit ----- //

        // http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
        utils.toDashed = function (str) {
          return str
            .replace(/(.)([A-Z])/g, function (match, $1, $2) {
              return $1 + "-" + $2;
            })
            .toLowerCase();
        };

        var console = window.console;
        /**
         * allow user to initialize classes via [data-namespace] or .js-namespace class
         * htmlInit( Widget, 'widgetName' )
         * options are parsed from data-namespace-options
         */
        utils.htmlInit = function (WidgetClass, namespace) {
          utils.docReady(function () {
            var dashedNamespace = utils.toDashed(namespace);
            var dataAttr = "data-" + dashedNamespace;
            var dataAttrElems = document.querySelectorAll("[" + dataAttr + "]");
            var jsDashElems = document.querySelectorAll(
              ".js-" + dashedNamespace
            );
            var elems = utils
              .makeArray(dataAttrElems)
              .concat(utils.makeArray(jsDashElems));
            var dataOptionsAttr = dataAttr + "-options";
            var jQuery = window.jQuery;

            elems.forEach(function (elem) {
              var attr =
                elem.getAttribute(dataAttr) ||
                elem.getAttribute(dataOptionsAttr);
              var options;
              try {
                options = attr && JSON.parse(attr);
              } catch (error) {
                // log error, do not initialize
                if (console) {
                  console.error(
                    "Error parsing " +
                      dataAttr +
                      " on " +
                      elem.className +
                      ": " +
                      error
                  );
                }
                return;
              }
              // initialize
              var instance = new WidgetClass(elem, options);
              // make available via $().data('namespace')
              if (jQuery) {
                jQuery.data(elem, namespace, instance);
              }
            });
          });
        };

        // -----  ----- //

        return utils;
      });

      /***/
    },
    /* 33 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      if (__webpack_require__(9)) {
        var LIBRARY = __webpack_require__(38);
        var global = __webpack_require__(3);
        var fails = __webpack_require__(5);
        var $export = __webpack_require__(1);
        var $typed = __webpack_require__(74);
        var $buffer = __webpack_require__(103);
        var ctx = __webpack_require__(21);
        var anInstance = __webpack_require__(49);
        var propertyDesc = __webpack_require__(36);
        var hide = __webpack_require__(16);
        var redefineAll = __webpack_require__(50);
        var toInteger = __webpack_require__(26);
        var toLength = __webpack_require__(10);
        var toIndex = __webpack_require__(133);
        var toAbsoluteIndex = __webpack_require__(43);
        var toPrimitive = __webpack_require__(24);
        var has = __webpack_require__(15);
        var classof = __webpack_require__(45);
        var isObject = __webpack_require__(4);
        var toObject = __webpack_require__(12);
        var isArrayIter = __webpack_require__(96);
        var create = __webpack_require__(31);
        var getPrototypeOf = __webpack_require__(19);
        var gOPN = __webpack_require__(44).f;
        var getIterFn = __webpack_require__(59);
        var uid = __webpack_require__(42);
        var wks = __webpack_require__(6);
        var createArrayMethod = __webpack_require__(28);
        var createArrayIncludes = __webpack_require__(61);
        var speciesConstructor = __webpack_require__(71);
        var ArrayIterators = __webpack_require__(64);
        var Iterators = __webpack_require__(46);
        var $iterDetect = __webpack_require__(68);
        var setSpecies = __webpack_require__(48);
        var arrayFill = __webpack_require__(99);
        var arrayCopyWithin = __webpack_require__(124);
        var $DP = __webpack_require__(8);
        var $GOPD = __webpack_require__(18);
        var dP = $DP.f;
        var gOPD = $GOPD.f;
        var RangeError = global.RangeError;
        var TypeError = global.TypeError;
        var Uint8Array = global.Uint8Array;
        var ARRAY_BUFFER = "ArrayBuffer";
        var SHARED_BUFFER = "Shared" + ARRAY_BUFFER;
        var BYTES_PER_ELEMENT = "BYTES_PER_ELEMENT";
        var PROTOTYPE = "prototype";
        var ArrayProto = Array[PROTOTYPE];
        var $ArrayBuffer = $buffer.ArrayBuffer;
        var $DataView = $buffer.DataView;
        var arrayForEach = createArrayMethod(0);
        var arrayFilter = createArrayMethod(2);
        var arraySome = createArrayMethod(3);
        var arrayEvery = createArrayMethod(4);
        var arrayFind = createArrayMethod(5);
        var arrayFindIndex = createArrayMethod(6);
        var arrayIncludes = createArrayIncludes(true);
        var arrayIndexOf = createArrayIncludes(false);
        var arrayValues = ArrayIterators.values;
        var arrayKeys = ArrayIterators.keys;
        var arrayEntries = ArrayIterators.entries;
        var arrayLastIndexOf = ArrayProto.lastIndexOf;
        var arrayReduce = ArrayProto.reduce;
        var arrayReduceRight = ArrayProto.reduceRight;
        var arrayJoin = ArrayProto.join;
        var arraySort = ArrayProto.sort;
        var arraySlice = ArrayProto.slice;
        var arrayToString = ArrayProto.toString;
        var arrayToLocaleString = ArrayProto.toLocaleString;
        var ITERATOR = wks("iterator");
        var TAG = wks("toStringTag");
        var TYPED_CONSTRUCTOR = uid("typed_constructor");
        var DEF_CONSTRUCTOR = uid("def_constructor");
        var ALL_CONSTRUCTORS = $typed.CONSTR;
        var TYPED_ARRAY = $typed.TYPED;
        var VIEW = $typed.VIEW;
        var WRONG_LENGTH = "Wrong length!";

        var $map = createArrayMethod(1, function (O, length) {
          return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
        });

        var LITTLE_ENDIAN = fails(function () {
          // eslint-disable-next-line no-undef
          return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
        });

        var FORCED_SET =
          !!Uint8Array &&
          !!Uint8Array[PROTOTYPE].set &&
          fails(function () {
            new Uint8Array(1).set({});
          });

        var toOffset = function (it, BYTES) {
          var offset = toInteger(it);
          if (offset < 0 || offset % BYTES) throw RangeError("Wrong offset!");
          return offset;
        };

        var validate = function (it) {
          if (isObject(it) && TYPED_ARRAY in it) return it;
          throw TypeError(it + " is not a typed array!");
        };

        var allocate = function (C, length) {
          if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
            throw TypeError("It is not a typed array constructor!");
          }
          return new C(length);
        };

        var speciesFromList = function (O, list) {
          return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
        };

        var fromList = function (C, list) {
          var index = 0;
          var length = list.length;
          var result = allocate(C, length);
          while (length > index) result[index] = list[index++];
          return result;
        };

        var addGetter = function (it, key, internal) {
          dP(it, key, {
            get: function () {
              return this._d[internal];
            },
          });
        };

        var $from = function from(source /* , mapfn, thisArg */) {
          var O = toObject(source);
          var aLen = arguments.length;
          var mapfn = aLen > 1 ? arguments[1] : undefined;
          var mapping = mapfn !== undefined;
          var iterFn = getIterFn(O);
          var i, length, values, result, step, iterator;
          if (iterFn != undefined && !isArrayIter(iterFn)) {
            for (
              iterator = iterFn.call(O), values = [], i = 0;
              !(step = iterator.next()).done;
              i++
            ) {
              values.push(step.value);
            }
            O = values;
          }
          if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
          for (
            i = 0, length = toLength(O.length), result = allocate(this, length);
            length > i;
            i++
          ) {
            result[i] = mapping ? mapfn(O[i], i) : O[i];
          }
          return result;
        };

        var $of = function of(/* ...items */) {
          var index = 0;
          var length = arguments.length;
          var result = allocate(this, length);
          while (length > index) result[index] = arguments[index++];
          return result;
        };

        // iOS Safari 6.x fails here
        var TO_LOCALE_BUG =
          !!Uint8Array &&
          fails(function () {
            arrayToLocaleString.call(new Uint8Array(1));
          });

        var $toLocaleString = function toLocaleString() {
          return arrayToLocaleString.apply(
            TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this),
            arguments
          );
        };

        var proto = {
          copyWithin: function copyWithin(target, start /* , end */) {
            return arrayCopyWithin.call(
              validate(this),
              target,
              start,
              arguments.length > 2 ? arguments[2] : undefined
            );
          },
          every: function every(callbackfn /* , thisArg */) {
            return arrayEvery(
              validate(this),
              callbackfn,
              arguments.length > 1 ? arguments[1] : undefined
            );
          },
          fill: function fill(value /* , start, end */) {
            // eslint-disable-line no-unused-vars
            return arrayFill.apply(validate(this), arguments);
          },
          filter: function filter(callbackfn /* , thisArg */) {
            return speciesFromList(
              this,
              arrayFilter(
                validate(this),
                callbackfn,
                arguments.length > 1 ? arguments[1] : undefined
              )
            );
          },
          find: function find(predicate /* , thisArg */) {
            return arrayFind(
              validate(this),
              predicate,
              arguments.length > 1 ? arguments[1] : undefined
            );
          },
          findIndex: function findIndex(predicate /* , thisArg */) {
            return arrayFindIndex(
              validate(this),
              predicate,
              arguments.length > 1 ? arguments[1] : undefined
            );
          },
          forEach: function forEach(callbackfn /* , thisArg */) {
            arrayForEach(
              validate(this),
              callbackfn,
              arguments.length > 1 ? arguments[1] : undefined
            );
          },
          indexOf: function indexOf(searchElement /* , fromIndex */) {
            return arrayIndexOf(
              validate(this),
              searchElement,
              arguments.length > 1 ? arguments[1] : undefined
            );
          },
          includes: function includes(searchElement /* , fromIndex */) {
            return arrayIncludes(
              validate(this),
              searchElement,
              arguments.length > 1 ? arguments[1] : undefined
            );
          },
          join: function join(separator) {
            // eslint-disable-line no-unused-vars
            return arrayJoin.apply(validate(this), arguments);
          },
          lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) {
            // eslint-disable-line no-unused-vars
            return arrayLastIndexOf.apply(validate(this), arguments);
          },
          map: function map(mapfn /* , thisArg */) {
            return $map(
              validate(this),
              mapfn,
              arguments.length > 1 ? arguments[1] : undefined
            );
          },
          reduce: function reduce(callbackfn /* , initialValue */) {
            // eslint-disable-line no-unused-vars
            return arrayReduce.apply(validate(this), arguments);
          },
          reduceRight: function reduceRight(callbackfn /* , initialValue */) {
            // eslint-disable-line no-unused-vars
            return arrayReduceRight.apply(validate(this), arguments);
          },
          reverse: function reverse() {
            var that = this;
            var length = validate(that).length;
            var middle = Math.floor(length / 2);
            var index = 0;
            var value;
            while (index < middle) {
              value = that[index];
              that[index++] = that[--length];
              that[length] = value;
            }
            return that;
          },
          some: function some(callbackfn /* , thisArg */) {
            return arraySome(
              validate(this),
              callbackfn,
              arguments.length > 1 ? arguments[1] : undefined
            );
          },
          sort: function sort(comparefn) {
            return arraySort.call(validate(this), comparefn);
          },
          subarray: function subarray(begin, end) {
            var O = validate(this);
            var length = O.length;
            var $begin = toAbsoluteIndex(begin, length);
            return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
              O.buffer,
              O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
              toLength(
                (end === undefined ? length : toAbsoluteIndex(end, length)) -
                  $begin
              )
            );
          },
        };

        var $slice = function slice(start, end) {
          return speciesFromList(
            this,
            arraySlice.call(validate(this), start, end)
          );
        };

        var $set = function set(arrayLike /* , offset */) {
          validate(this);
          var offset = toOffset(arguments[1], 1);
          var length = this.length;
          var src = toObject(arrayLike);
          var len = toLength(src.length);
          var index = 0;
          if (len + offset > length) throw RangeError(WRONG_LENGTH);
          while (index < len) this[offset + index] = src[index++];
        };

        var $iterators = {
          entries: function entries() {
            return arrayEntries.call(validate(this));
          },
          keys: function keys() {
            return arrayKeys.call(validate(this));
          },
          values: function values() {
            return arrayValues.call(validate(this));
          },
        };

        var isTAIndex = function (target, key) {
          return (
            isObject(target) &&
            target[TYPED_ARRAY] &&
            typeof key != "symbol" &&
            key in target &&
            String(+key) == String(key)
          );
        };
        var $getDesc = function getOwnPropertyDescriptor(target, key) {
          return isTAIndex(target, (key = toPrimitive(key, true)))
            ? propertyDesc(2, target[key])
            : gOPD(target, key);
        };
        var $setDesc = function defineProperty(target, key, desc) {
          if (
            isTAIndex(target, (key = toPrimitive(key, true))) &&
            isObject(desc) &&
            has(desc, "value") &&
            !has(desc, "get") &&
            !has(desc, "set") &&
            // TODO: add validation descriptor w/o calling accessors
            !desc.configurable &&
            (!has(desc, "writable") || desc.writable) &&
            (!has(desc, "enumerable") || desc.enumerable)
          ) {
            target[key] = desc.value;
            return target;
          }
          return dP(target, key, desc);
        };

        if (!ALL_CONSTRUCTORS) {
          $GOPD.f = $getDesc;
          $DP.f = $setDesc;
        }

        $export($export.S + $export.F * !ALL_CONSTRUCTORS, "Object", {
          getOwnPropertyDescriptor: $getDesc,
          defineProperty: $setDesc,
        });

        if (
          fails(function () {
            arrayToString.call({});
          })
        ) {
          arrayToString = arrayToLocaleString = function toString() {
            return arrayJoin.call(this);
          };
        }

        var $TypedArrayPrototype$ = redefineAll({}, proto);
        redefineAll($TypedArrayPrototype$, $iterators);
        hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
        redefineAll($TypedArrayPrototype$, {
          slice: $slice,
          set: $set,
          constructor: function () {
            /* noop */
          },
          toString: arrayToString,
          toLocaleString: $toLocaleString,
        });
        addGetter($TypedArrayPrototype$, "buffer", "b");
        addGetter($TypedArrayPrototype$, "byteOffset", "o");
        addGetter($TypedArrayPrototype$, "byteLength", "l");
        addGetter($TypedArrayPrototype$, "length", "e");
        dP($TypedArrayPrototype$, TAG, {
          get: function () {
            return this[TYPED_ARRAY];
          },
        });

        // eslint-disable-next-line max-statements
        module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
          CLAMPED = !!CLAMPED;
          var NAME = KEY + (CLAMPED ? "Clamped" : "") + "Array";
          var GETTER = "get" + KEY;
          var SETTER = "set" + KEY;
          var TypedArray = global[NAME];
          var Base = TypedArray || {};
          var TAC = TypedArray && getPrototypeOf(TypedArray);
          var FORCED = !TypedArray || !$typed.ABV;
          var O = {};
          var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
          var getter = function (that, index) {
            var data = that._d;
            return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
          };
          var setter = function (that, index, value) {
            var data = that._d;
            if (CLAMPED)
              value =
                (value = Math.round(value)) < 0
                  ? 0
                  : value > 0xff
                  ? 0xff
                  : value & 0xff;
            data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
          };
          var addElement = function (that, index) {
            dP(that, index, {
              get: function () {
                return getter(this, index);
              },
              set: function (value) {
                return setter(this, index, value);
              },
              enumerable: true,
            });
          };
          if (FORCED) {
            TypedArray = wrapper(function (that, data, $offset, $length) {
              anInstance(that, TypedArray, NAME, "_d");
              var index = 0;
              var offset = 0;
              var buffer, byteLength, length, klass;
              if (!isObject(data)) {
                length = toIndex(data);
                byteLength = length * BYTES;
                buffer = new $ArrayBuffer(byteLength);
              } else if (
                data instanceof $ArrayBuffer ||
                (klass = classof(data)) == ARRAY_BUFFER ||
                klass == SHARED_BUFFER
              ) {
                buffer = data;
                offset = toOffset($offset, BYTES);
                var $len = data.byteLength;
                if ($length === undefined) {
                  if ($len % BYTES) throw RangeError(WRONG_LENGTH);
                  byteLength = $len - offset;
                  if (byteLength < 0) throw RangeError(WRONG_LENGTH);
                } else {
                  byteLength = toLength($length) * BYTES;
                  if (byteLength + offset > $len)
                    throw RangeError(WRONG_LENGTH);
                }
                length = byteLength / BYTES;
              } else if (TYPED_ARRAY in data) {
                return fromList(TypedArray, data);
              } else {
                return $from.call(TypedArray, data);
              }
              hide(that, "_d", {
                b: buffer,
                o: offset,
                l: byteLength,
                e: length,
                v: new $DataView(buffer),
              });
              while (index < length) addElement(that, index++);
            });
            TypedArrayPrototype = TypedArray[PROTOTYPE] = create(
              $TypedArrayPrototype$
            );
            hide(TypedArrayPrototype, "constructor", TypedArray);
          } else if (
            !fails(function () {
              TypedArray(1);
            }) ||
            !fails(function () {
              new TypedArray(-1); // eslint-disable-line no-new
            }) ||
            !$iterDetect(function (iter) {
              new TypedArray(); // eslint-disable-line no-new
              new TypedArray(null); // eslint-disable-line no-new
              new TypedArray(1.5); // eslint-disable-line no-new
              new TypedArray(iter); // eslint-disable-line no-new
            }, true)
          ) {
            TypedArray = wrapper(function (that, data, $offset, $length) {
              anInstance(that, TypedArray, NAME);
              var klass;
              // `ws` module bug, temporarily remove validation length for Uint8Array
              // https://github.com/websockets/ws/pull/645
              if (!isObject(data)) return new Base(toIndex(data));
              if (
                data instanceof $ArrayBuffer ||
                (klass = classof(data)) == ARRAY_BUFFER ||
                klass == SHARED_BUFFER
              ) {
                return $length !== undefined
                  ? new Base(data, toOffset($offset, BYTES), $length)
                  : $offset !== undefined
                  ? new Base(data, toOffset($offset, BYTES))
                  : new Base(data);
              }
              if (TYPED_ARRAY in data) return fromList(TypedArray, data);
              return $from.call(TypedArray, data);
            });
            arrayForEach(
              TAC !== Function.prototype
                ? gOPN(Base).concat(gOPN(TAC))
                : gOPN(Base),
              function (key) {
                if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
              }
            );
            TypedArray[PROTOTYPE] = TypedArrayPrototype;
            if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
          }
          var $nativeIterator = TypedArrayPrototype[ITERATOR];
          var CORRECT_ITER_NAME =
            !!$nativeIterator &&
            ($nativeIterator.name == "values" ||
              $nativeIterator.name == undefined);
          var $iterator = $iterators.values;
          hide(TypedArray, TYPED_CONSTRUCTOR, true);
          hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
          hide(TypedArrayPrototype, VIEW, true);
          hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

          if (
            CLAMPED
              ? new TypedArray(1)[TAG] != NAME
              : !(TAG in TypedArrayPrototype)
          ) {
            dP(TypedArrayPrototype, TAG, {
              get: function () {
                return NAME;
              },
            });
          }

          O[NAME] = TypedArray;

          $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

          $export($export.S, NAME, {
            BYTES_PER_ELEMENT: BYTES,
          });

          $export(
            $export.S +
              $export.F *
                fails(function () {
                  Base.of.call(TypedArray, 1);
                }),
            NAME,
            {
              from: $from,
              of: $of,
            }
          );

          if (!(BYTES_PER_ELEMENT in TypedArrayPrototype))
            hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

          $export($export.P, NAME, proto);

          setSpecies(NAME);

          $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

          $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

          if (!LIBRARY && TypedArrayPrototype.toString != arrayToString)
            TypedArrayPrototype.toString = arrayToString;

          $export(
            $export.P +
              $export.F *
                fails(function () {
                  new TypedArray(1).slice();
                }),
            NAME,
            { slice: $slice }
          );

          $export(
            $export.P +
              $export.F *
                (fails(function () {
                  return (
                    [1, 2].toLocaleString() !=
                    new TypedArray([1, 2]).toLocaleString()
                  );
                }) ||
                  !fails(function () {
                    TypedArrayPrototype.toLocaleString.call([1, 2]);
                  })),
            NAME,
            { toLocaleString: $toLocaleString }
          );

          Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
          if (!LIBRARY && !CORRECT_ITER_NAME)
            hide(TypedArrayPrototype, ITERATOR, $iterator);
        };
      } else
        module.exports = function () {
          /* empty */
        };

      /***/
    },
    /* 34 */
    /***/ function (module, exports, __webpack_require__) {
      var Map = __webpack_require__(128);
      var $export = __webpack_require__(1);
      var shared = __webpack_require__(60)("metadata");
      var store =
        shared.store || (shared.store = new (__webpack_require__(131))());

      var getOrCreateMetadataMap = function (target, targetKey, create) {
        var targetMetadata = store.get(target);
        if (!targetMetadata) {
          if (!create) return undefined;
          store.set(target, (targetMetadata = new Map()));
        }
        var keyMetadata = targetMetadata.get(targetKey);
        if (!keyMetadata) {
          if (!create) return undefined;
          targetMetadata.set(targetKey, (keyMetadata = new Map()));
        }
        return keyMetadata;
      };
      var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
        var metadataMap = getOrCreateMetadataMap(O, P, false);
        return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
      };
      var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
        var metadataMap = getOrCreateMetadataMap(O, P, false);
        return metadataMap === undefined
          ? undefined
          : metadataMap.get(MetadataKey);
      };
      var ordinaryDefineOwnMetadata = function (
        MetadataKey,
        MetadataValue,
        O,
        P
      ) {
        getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
      };
      var ordinaryOwnMetadataKeys = function (target, targetKey) {
        var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
        var keys = [];
        if (metadataMap)
          metadataMap.forEach(function (_, key) {
            keys.push(key);
          });
        return keys;
      };
      var toMetaKey = function (it) {
        return it === undefined || typeof it == "symbol" ? it : String(it);
      };
      var exp = function (O) {
        $export($export.S, "Reflect", O);
      };

      module.exports = {
        store: store,
        map: getOrCreateMetadataMap,
        has: ordinaryHasOwnMetadata,
        get: ordinaryGetOwnMetadata,
        set: ordinaryDefineOwnMetadata,
        keys: ordinaryOwnMetadataKeys,
        key: toMetaKey,
        exp: exp,
      };

      /***/
    },
    /* 35 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", { value: true });
      function all() {
        return window
          .getComputedStyle(document.documentElement, ":before")
          .getPropertyValue("content")
          .replace(/"/g, "")
          .split(",");
      }
      exports.all = all;
      function current() {
        return window
          .getComputedStyle(document.documentElement, ":after")
          .getPropertyValue("content")
          .replace(/"/g, "");
      }
      exports.current = current;
      var callbacks = [];
      var breakpoints = all();
      var breakpointData = {
        previous: current(),
        current: current(),
      };
      function min(breakpoint) {
        var current = breakpointData.current;
        var comparison =
          breakpoints.indexOf(current) - breakpoints.indexOf(breakpoint);
        return comparison >= 0;
      }
      exports.min = min;
      function max(breakpoint) {
        var current = breakpointData.current;
        var comparison =
          breakpoints.indexOf(current) - breakpoints.indexOf(breakpoint);
        return comparison <= 0;
      }
      exports.max = max;
      function range(breakpointStart, breakpointEnd) {
        var current = breakpointData.current;
        var indexCurrent = breakpoints.indexOf(current);
        var indexStart = breakpoints.indexOf(breakpointStart);
        var indexEnd = breakpoints.indexOf(breakpointEnd);
        return indexStart <= indexCurrent && indexCurrent <= indexEnd;
      }
      exports.range = range;
      function is() {
        var breakpoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          breakpoints[_i] = arguments[_i];
        }
        var current = breakpointData.current;
        return breakpoints.some(function (breakpoint) {
          return breakpoint === current;
        });
      }
      exports.is = is;
      function onChange(callback) {
        if (callbacks.indexOf(callback) === -1) {
          callbacks.push(callback);
        }
      }
      exports.onChange = onChange;
      function offChange(callback) {
        var index = callbacks.indexOf(callback);
        if (index !== -1) {
          callbacks.splice(index, 1);
        }
      }
      exports.offChange = offChange;
      var styleSheetList = document.styleSheets;
      var mediaLists = Object.keys(styleSheetList).reduce(function (
        accumulator,
        key
      ) {
        var stylesheet = styleSheetList[key];
        if (!stylesheet.href || stylesheet.href.indexOf("theme") === -1) {
          return accumulator;
        }
        try {
          var cssRules = stylesheet.cssRules;
          for (var i = 0; i < cssRules.length; i++) {
            var cssRule = stylesheet.cssRules[i];
            if (!(cssRule instanceof CSSMediaRule)) {
              continue;
            }
            for (var j = 0; j < cssRules.length; j++) {
              var cssMediaCssRule = cssRule.cssRules[j];
              if (!(cssMediaCssRule instanceof CSSStyleRule)) {
                continue;
              }
              if (
                cssMediaCssRule.selectorText &&
                cssMediaCssRule.selectorText.indexOf("html::after") !== -1
              ) {
                accumulator.push(cssRule.media);
              }
            }
          }
        } catch (_a) {
          return accumulator;
        }
        return accumulator;
      },
      []);
      if (mediaLists.length > 0) {
        mediaLists.forEach(function (mediaList) {
          var mql = window.matchMedia(mediaList.mediaText);
          mql.addListener(function () {
            var currentBreakpoint = current();
            if (breakpointData.current !== currentBreakpoint) {
              breakpointData.previous = breakpointData.current;
              breakpointData.current = currentBreakpoint;
              callbacks.forEach(function (callback) {
                return callback(breakpointData);
              });
            }
          });
        });
      } else {
        window.addEventListener("resize", function () {
          var currentBreakpoint = current();
          if (breakpointData.current !== currentBreakpoint) {
            breakpointData.previous = breakpointData.current;
            breakpointData.current = currentBreakpoint;
            callbacks.forEach(function (callback) {
              return callback(breakpointData);
            });
          }
        });
      }

      /***/
    },
    /* 36 */
    /***/ function (module, exports) {
      module.exports = function (bitmap, value) {
        return {
          enumerable: !(bitmap & 1),
          configurable: !(bitmap & 2),
          writable: !(bitmap & 4),
          value: value,
        };
      };

      /***/
    },
    /* 37 */
    /***/ function (module, exports, __webpack_require__) {
      var META = __webpack_require__(42)("meta");
      var isObject = __webpack_require__(4);
      var has = __webpack_require__(15);
      var setDesc = __webpack_require__(8).f;
      var id = 0;
      var isExtensible =
        Object.isExtensible ||
        function () {
          return true;
        };
      var FREEZE = !__webpack_require__(5)(function () {
        return isExtensible(Object.preventExtensions({}));
      });
      var setMeta = function (it) {
        setDesc(it, META, {
          value: {
            i: "O" + ++id, // object ID
            w: {}, // weak collections IDs
          },
        });
      };
      var fastKey = function (it, create) {
        // return primitive with prefix
        if (!isObject(it))
          return typeof it == "symbol"
            ? it
            : (typeof it == "string" ? "S" : "P") + it;
        if (!has(it, META)) {
          // can't set metadata to uncaught frozen object
          if (!isExtensible(it)) return "F";
          // not necessary to add metadata
          if (!create) return "E";
          // add missing metadata
          setMeta(it);
          // return object ID
        }
        return it[META].i;
      };
      var getWeak = function (it, create) {
        if (!has(it, META)) {
          // can't set metadata to uncaught frozen object
          if (!isExtensible(it)) return true;
          // not necessary to add metadata
          if (!create) return false;
          // add missing metadata
          setMeta(it);
          // return hash weak collections IDs
        }
        return it[META].w;
      };
      // add metadata on freeze-family methods calling
      var onFreeze = function (it) {
        if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META))
          setMeta(it);
        return it;
      };
      var meta = (module.exports = {
        KEY: META,
        NEED: false,
        fastKey: fastKey,
        getWeak: getWeak,
        onFreeze: onFreeze,
      });

      /***/
    },
    /* 38 */
    /***/ function (module, exports) {
      module.exports = false;

      /***/
    },
    /* 39 */
    /***/ function (module, exports, __webpack_require__) {
      // 22.1.3.31 Array.prototype[@@unscopables]
      var UNSCOPABLES = __webpack_require__(6)("unscopables");
      var ArrayProto = Array.prototype;
      if (ArrayProto[UNSCOPABLES] == undefined)
        __webpack_require__(16)(ArrayProto, UNSCOPABLES, {});
      module.exports = function (key) {
        ArrayProto[UNSCOPABLES][key] = true;
      };

      /***/
    },
    /* 40 */
    /***/ function (module, exports, __webpack_require__) {
      var ctx = __webpack_require__(21);
      var call = __webpack_require__(122);
      var isArrayIter = __webpack_require__(96);
      var anObject = __webpack_require__(2);
      var toLength = __webpack_require__(10);
      var getIterFn = __webpack_require__(59);
      var BREAK = {};
      var RETURN = {};
      var exports = (module.exports = function (
        iterable,
        entries,
        fn,
        that,
        ITERATOR
      ) {
        var iterFn = ITERATOR
          ? function () {
              return iterable;
            }
          : getIterFn(iterable);
        var f = ctx(fn, that, entries ? 2 : 1);
        var index = 0;
        var length, step, iterator, result;
        if (typeof iterFn != "function")
          throw TypeError(iterable + " is not iterable!");
        // fast case for arrays with default iterator
        if (isArrayIter(iterFn))
          for (length = toLength(iterable.length); length > index; index++) {
            result = entries
              ? f(anObject((step = iterable[index]))[0], step[1])
              : f(iterable[index]);
            if (result === BREAK || result === RETURN) return result;
          }
        else
          for (
            iterator = iterFn.call(iterable);
            !(step = iterator.next()).done;

          ) {
            result = call(iterator, f, step.value, entries);
            if (result === BREAK || result === RETURN) return result;
          }
      });
      exports.BREAK = BREAK;
      exports.RETURN = RETURN;

      /***/
    },
    /* 41 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_FACTORY__,
        __WEBPACK_AMD_DEFINE_ARRAY__,
        __WEBPACK_AMD_DEFINE_RESULT__;
      /*!
       * Flickity v2.2.1
       * Touch, responsive, flickable carousels
       *
       * Licensed GPLv3 for open source use
       * or Flickity Commercial License for commercial use
       *
       * https://flickity.metafizzy.co
       * Copyright 2015-2019 Metafizzy
       */

      (function (window, factory) {
        // universal module definition
        /* jshint strict: false */
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(47),
            __webpack_require__(161),
            __webpack_require__(163),
            __webpack_require__(164),
            __webpack_require__(165),
            __webpack_require__(166),
            __webpack_require__(167),
          ]),
          (__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
          (__WEBPACK_AMD_DEFINE_RESULT__ =
            typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
              ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(
                  exports,
                  __WEBPACK_AMD_DEFINE_ARRAY__
                )
              : __WEBPACK_AMD_DEFINE_FACTORY__),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
            (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(window, function factory(Flickity) {
        /*jshint strict: false*/
        return Flickity;
      });

      /***/
    },
    /* 42 */
    /***/ function (module, exports) {
      var id = 0;
      var px = Math.random();
      module.exports = function (key) {
        return "Symbol(".concat(
          key === undefined ? "" : key,
          ")_",
          (++id + px).toString(36)
        );
      };

      /***/
    },
    /* 43 */
    /***/ function (module, exports, __webpack_require__) {
      var toInteger = __webpack_require__(26);
      var max = Math.max;
      var min = Math.min;
      module.exports = function (index, length) {
        index = toInteger(index);
        return index < 0 ? max(index + length, 0) : min(index, length);
      };

      /***/
    },
    /* 44 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
      var $keys = __webpack_require__(110);
      var hiddenKeys = __webpack_require__(81).concat("length", "prototype");

      exports.f =
        Object.getOwnPropertyNames ||
        function getOwnPropertyNames(O) {
          return $keys(O, hiddenKeys);
        };

      /***/
    },
    /* 45 */
    /***/ function (module, exports, __webpack_require__) {
      // getting tag from 19.1.3.6 Object.prototype.toString()
      var cof = __webpack_require__(22);
      var TAG = __webpack_require__(6)("toStringTag");
      // ES3 wrong here
      var ARG =
        cof(
          (function () {
            return arguments;
          })()
        ) == "Arguments";

      // fallback for IE11 Script Access Denied error
      var tryGet = function (it, key) {
        try {
          return it[key];
        } catch (e) {
          /* empty */
        }
      };

      module.exports = function (it) {
        var O, T, B;
        return it === undefined
          ? "Undefined"
          : it === null
          ? "Null"
          : // @@toStringTag case
          typeof (T = tryGet((O = Object(it)), TAG)) == "string"
          ? T
          : // builtinTag case
          ARG
          ? cof(O)
          : // ES3 arguments fallback
          (B = cof(O)) == "Object" && typeof O.callee == "function"
          ? "Arguments"
          : B;
      };

      /***/
    },
    /* 46 */
    /***/ function (module, exports) {
      module.exports = {};

      /***/
    },
    /* 47 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // Flickity main
      (function (window, factory) {
        // universal module definition
        /* jshint strict: false */
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(57),
            __webpack_require__(58),
            __webpack_require__(32),
            __webpack_require__(158),
            __webpack_require__(159),
            __webpack_require__(160),
          ]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (
            EvEmitter,
            getSize,
            utils,
            Cell,
            Slide,
            animatePrototype
          ) {
            return factory(
              window,
              EvEmitter,
              getSize,
              utils,
              Cell,
              Slide,
              animatePrototype
            );
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
            (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
          var _Flickity;
        }
      })(
        window,
        function factory(
          window,
          EvEmitter,
          getSize,
          utils,
          Cell,
          Slide,
          animatePrototype
        ) {
          "use strict";

          // vars
          var jQuery = window.jQuery;
          var getComputedStyle = window.getComputedStyle;
          var console = window.console;

          function moveElements(elems, toElem) {
            elems = utils.makeArray(elems);
            while (elems.length) {
              toElem.appendChild(elems.shift());
            }
          }

          // -------------------------- Flickity -------------------------- //

          // globally unique identifiers
          var GUID = 0;
          // internal store of all Flickity intances
          var instances = {};

          function Flickity(element, options) {
            var queryElement = utils.getQueryElement(element);
            if (!queryElement) {
              if (console) {
                console.error(
                  "Bad element for Flickity: " + (queryElement || element)
                );
              }
              return;
            }
            this.element = queryElement;
            // do not initialize twice on same element
            if (this.element.flickityGUID) {
              var instance = instances[this.element.flickityGUID];
              instance.option(options);
              return instance;
            }

            // add jQuery
            if (jQuery) {
              this.$element = jQuery(this.element);
            }
            // options
            this.options = utils.extend({}, this.constructor.defaults);
            this.option(options);

            // kick things off
            this._create();
          }

          Flickity.defaults = {
            accessibility: true,
            // adaptiveHeight: false,
            cellAlign: "center",
            // cellSelector: undefined,
            // contain: false,
            freeScrollFriction: 0.075, // friction when free-scrolling
            friction: 0.28, // friction when selecting
            namespaceJQueryEvents: true,
            // initialIndex: 0,
            percentPosition: true,
            resize: true,
            selectedAttraction: 0.025,
            setGallerySize: true,
            // watchCSS: false,
            // wrapAround: false
          };

          // hash of methods triggered on _create()
          Flickity.createMethods = [];

          var proto = Flickity.prototype;
          // inherit EventEmitter
          utils.extend(proto, EvEmitter.prototype);

          proto._create = function () {
            // add id for Flickity.data
            var id = (this.guid = ++GUID);
            this.element.flickityGUID = id; // expando
            instances[id] = this; // associate via id
            // initial properties
            this.selectedIndex = 0;
            // how many frames slider has been in same position
            this.restingFrames = 0;
            // initial physics properties
            this.x = 0;
            this.velocity = 0;
            this.originSide = this.options.rightToLeft ? "right" : "left";
            // create viewport & slider
            this.viewport = document.createElement("div");
            this.viewport.className = "flickity-viewport";
            this._createSlider();

            if (this.options.resize || this.options.watchCSS) {
              window.addEventListener("resize", this);
            }

            // add listeners from on option
            for (var eventName in this.options.on) {
              var listener = this.options.on[eventName];
              this.on(eventName, listener);
            }

            Flickity.createMethods.forEach(function (method) {
              this[method]();
            }, this);

            if (this.options.watchCSS) {
              this.watchCSS();
            } else {
              this.activate();
            }
          };

          /**
           * set options
           * @param {Object} opts
           */
          proto.option = function (opts) {
            utils.extend(this.options, opts);
          };

          proto.activate = function () {
            if (this.isActive) {
              return;
            }
            this.isActive = true;
            this.element.classList.add("flickity-enabled");
            if (this.options.rightToLeft) {
              this.element.classList.add("flickity-rtl");
            }

            this.getSize();
            // move initial cell elements so they can be loaded as cells
            var cellElems = this._filterFindCellElements(this.element.children);
            moveElements(cellElems, this.slider);
            this.viewport.appendChild(this.slider);
            this.element.appendChild(this.viewport);
            // get cells from children
            this.reloadCells();

            if (this.options.accessibility) {
              // allow element to focusable
              this.element.tabIndex = 0;
              // listen for key presses
              this.element.addEventListener("keydown", this);
            }

            this.emitEvent("activate");
            this.selectInitialIndex();
            // flag for initial activation, for using initialIndex
            this.isInitActivated = true;
            // ready event. #493
            this.dispatchEvent("ready");
          };

          // slider positions the cells
          proto._createSlider = function () {
            // slider element does all the positioning
            var slider = document.createElement("div");
            slider.className = "flickity-slider";
            slider.style[this.originSide] = 0;
            this.slider = slider;
          };

          proto._filterFindCellElements = function (elems) {
            return utils.filterFindElements(elems, this.options.cellSelector);
          };

          // goes through all children
          proto.reloadCells = function () {
            // collection of item elements
            this.cells = this._makeCells(this.slider.children);
            this.positionCells();
            this._getWrapShiftCells();
            this.setGallerySize();
          };

          /**
           * turn elements into Flickity.Cells
           * @param {Array or NodeList or HTMLElement} elems
           * @returns {Array} items - collection of new Flickity Cells
           */
          proto._makeCells = function (elems) {
            var cellElems = this._filterFindCellElements(elems);

            // create new Flickity for collection
            var cells = cellElems.map(function (cellElem) {
              return new Cell(cellElem, this);
            }, this);

            return cells;
          };

          proto.getLastCell = function () {
            return this.cells[this.cells.length - 1];
          };

          proto.getLastSlide = function () {
            return this.slides[this.slides.length - 1];
          };

          // positions all cells
          proto.positionCells = function () {
            // size all cells
            this._sizeCells(this.cells);
            // position all cells
            this._positionCells(0);
          };

          /**
           * position certain cells
           * @param {Integer} index - which cell to start with
           */
          proto._positionCells = function (index) {
            index = index || 0;
            // also measure maxCellHeight
            // start 0 if positioning all cells
            this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
            var cellX = 0;
            // get cellX
            if (index > 0) {
              var startCell = this.cells[index - 1];
              cellX = startCell.x + startCell.size.outerWidth;
            }
            var len = this.cells.length;
            for (var i = index; i < len; i++) {
              var cell = this.cells[i];
              cell.setPosition(cellX);
              cellX += cell.size.outerWidth;
              this.maxCellHeight = Math.max(
                cell.size.outerHeight,
                this.maxCellHeight
              );
            }
            // keep track of cellX for wrap-around
            this.slideableWidth = cellX;
            // slides
            this.updateSlides();
            // contain slides target
            this._containSlides();
            // update slidesWidth
            this.slidesWidth = len
              ? this.getLastSlide().target - this.slides[0].target
              : 0;
          };

          /**
           * cell.getSize() on multiple cells
           * @param {Array} cells
           */
          proto._sizeCells = function (cells) {
            cells.forEach(function (cell) {
              cell.getSize();
            });
          };

          // --------------------------  -------------------------- //

          proto.updateSlides = function () {
            this.slides = [];
            if (!this.cells.length) {
              return;
            }

            var slide = new Slide(this);
            this.slides.push(slide);
            var isOriginLeft = this.originSide == "left";
            var nextMargin = isOriginLeft ? "marginRight" : "marginLeft";

            var canCellFit = this._getCanCellFit();

            this.cells.forEach(function (cell, i) {
              // just add cell if first cell in slide
              if (!slide.cells.length) {
                slide.addCell(cell);
                return;
              }

              var slideWidth =
                slide.outerWidth -
                slide.firstMargin +
                (cell.size.outerWidth - cell.size[nextMargin]);

              if (canCellFit.call(this, i, slideWidth)) {
                slide.addCell(cell);
              } else {
                // doesn't fit, new slide
                slide.updateTarget();

                slide = new Slide(this);
                this.slides.push(slide);
                slide.addCell(cell);
              }
            }, this);
            // last slide
            slide.updateTarget();
            // update .selectedSlide
            this.updateSelectedSlide();
          };

          proto._getCanCellFit = function () {
            var groupCells = this.options.groupCells;
            if (!groupCells) {
              return function () {
                return false;
              };
            } else if (typeof groupCells == "number") {
              // group by number. 3 -> [0,1,2], [3,4,5], ...
              var number = parseInt(groupCells, 10);
              return function (i) {
                return i % number !== 0;
              };
            }
            // default, group by width of slide
            // parse '75%
            var percentMatch =
              typeof groupCells == "string" && groupCells.match(/^(\d+)%$/);
            var percent = percentMatch
              ? parseInt(percentMatch[1], 10) / 100
              : 1;
            return function (i, slideWidth) {
              return slideWidth <= (this.size.innerWidth + 1) * percent;
            };
          };

          // alias _init for jQuery plugin .flickity()
          proto._init = proto.reposition = function () {
            this.positionCells();
            this.positionSliderAtSelected();
          };

          proto.getSize = function () {
            this.size = getSize(this.element);
            this.setCellAlign();
            this.cursorPosition = this.size.innerWidth * this.cellAlign;
          };

          var cellAlignShorthands = {
            // cell align, then based on origin side
            center: {
              left: 0.5,
              right: 0.5,
            },
            left: {
              left: 0,
              right: 1,
            },
            right: {
              right: 0,
              left: 1,
            },
          };

          proto.setCellAlign = function () {
            var shorthand = cellAlignShorthands[this.options.cellAlign];
            this.cellAlign = shorthand
              ? shorthand[this.originSide]
              : this.options.cellAlign;
          };

          proto.setGallerySize = function () {
            if (this.options.setGallerySize) {
              var height =
                this.options.adaptiveHeight && this.selectedSlide
                  ? this.selectedSlide.height
                  : this.maxCellHeight;
              this.viewport.style.height = height + "px";
            }
          };

          proto._getWrapShiftCells = function () {
            // only for wrap-around
            if (!this.options.wrapAround) {
              return;
            }
            // unshift previous cells
            this._unshiftCells(this.beforeShiftCells);
            this._unshiftCells(this.afterShiftCells);
            // get before cells
            // initial gap
            var gapX = this.cursorPosition;
            var cellIndex = this.cells.length - 1;
            this.beforeShiftCells = this._getGapCells(gapX, cellIndex, -1);
            // get after cells
            // ending gap between last cell and end of gallery viewport
            gapX = this.size.innerWidth - this.cursorPosition;
            // start cloning at first cell, working forwards
            this.afterShiftCells = this._getGapCells(gapX, 0, 1);
          };

          proto._getGapCells = function (gapX, cellIndex, increment) {
            // keep adding cells until the cover the initial gap
            var cells = [];
            while (gapX > 0) {
              var cell = this.cells[cellIndex];
              if (!cell) {
                break;
              }
              cells.push(cell);
              cellIndex += increment;
              gapX -= cell.size.outerWidth;
            }
            return cells;
          };

          // ----- contain ----- //

          // contain cell targets so no excess sliding
          proto._containSlides = function () {
            if (
              !this.options.contain ||
              this.options.wrapAround ||
              !this.cells.length
            ) {
              return;
            }
            var isRightToLeft = this.options.rightToLeft;
            var beginMargin = isRightToLeft ? "marginRight" : "marginLeft";
            var endMargin = isRightToLeft ? "marginLeft" : "marginRight";
            var contentWidth =
              this.slideableWidth - this.getLastCell().size[endMargin];
            // content is less than gallery size
            var isContentSmaller = contentWidth < this.size.innerWidth;
            // bounds
            var beginBound =
              this.cursorPosition + this.cells[0].size[beginMargin];
            var endBound =
              contentWidth - this.size.innerWidth * (1 - this.cellAlign);
            // contain each cell target
            this.slides.forEach(function (slide) {
              if (isContentSmaller) {
                // all cells fit inside gallery
                slide.target = contentWidth * this.cellAlign;
              } else {
                // contain to bounds
                slide.target = Math.max(slide.target, beginBound);
                slide.target = Math.min(slide.target, endBound);
              }
            }, this);
          };

          // -----  ----- //

          /**
           * emits events via eventEmitter and jQuery events
           * @param {String} type - name of event
           * @param {Event} event - original event
           * @param {Array} args - extra arguments
           */
          proto.dispatchEvent = function (type, event, args) {
            var emitArgs = event ? [event].concat(args) : args;
            this.emitEvent(type, emitArgs);

            if (jQuery && this.$element) {
              // default trigger with type if no event
              type += this.options.namespaceJQueryEvents ? ".flickity" : "";
              var $event = type;
              if (event) {
                // create jQuery event
                var jQEvent = jQuery.Event(event);
                jQEvent.type = type;
                $event = jQEvent;
              }
              this.$element.trigger($event, args);
            }
          };

          // -------------------------- select -------------------------- //

          /**
           * @param {Integer} index - index of the slide
           * @param {Boolean} isWrap - will wrap-around to last/first if at the end
           * @param {Boolean} isInstant - will immediately set position at selected cell
           */
          proto.select = function (index, isWrap, isInstant) {
            if (!this.isActive) {
              return;
            }
            index = parseInt(index, 10);
            this._wrapSelect(index);

            if (this.options.wrapAround || isWrap) {
              index = utils.modulo(index, this.slides.length);
            }
            // bail if invalid index
            if (!this.slides[index]) {
              return;
            }
            var prevIndex = this.selectedIndex;
            this.selectedIndex = index;
            this.updateSelectedSlide();
            if (isInstant) {
              this.positionSliderAtSelected();
            } else {
              this.startAnimation();
            }
            if (this.options.adaptiveHeight) {
              this.setGallerySize();
            }
            // events
            this.dispatchEvent("select", null, [index]);
            // change event if new index
            if (index != prevIndex) {
              this.dispatchEvent("change", null, [index]);
            }
            // old v1 event name, remove in v3
            this.dispatchEvent("cellSelect");
          };

          // wraps position for wrapAround, to move to closest slide. #113
          proto._wrapSelect = function (index) {
            var len = this.slides.length;
            var isWrapping = this.options.wrapAround && len > 1;
            if (!isWrapping) {
              return index;
            }
            var wrapIndex = utils.modulo(index, len);
            // go to shortest
            var delta = Math.abs(wrapIndex - this.selectedIndex);
            var backWrapDelta = Math.abs(wrapIndex + len - this.selectedIndex);
            var forewardWrapDelta = Math.abs(
              wrapIndex - len - this.selectedIndex
            );
            if (!this.isDragSelect && backWrapDelta < delta) {
              index += len;
            } else if (!this.isDragSelect && forewardWrapDelta < delta) {
              index -= len;
            }
            // wrap position so slider is within normal area
            if (index < 0) {
              this.x -= this.slideableWidth;
            } else if (index >= len) {
              this.x += this.slideableWidth;
            }
          };

          proto.previous = function (isWrap, isInstant) {
            this.select(this.selectedIndex - 1, isWrap, isInstant);
          };

          proto.next = function (isWrap, isInstant) {
            this.select(this.selectedIndex + 1, isWrap, isInstant);
          };

          proto.updateSelectedSlide = function () {
            var slide = this.slides[this.selectedIndex];
            // selectedIndex could be outside of slides, if triggered before resize()
            if (!slide) {
              return;
            }
            // unselect previous selected slide
            this.unselectSelectedSlide();
            // update new selected slide
            this.selectedSlide = slide;
            slide.select();
            this.selectedCells = slide.cells;
            this.selectedElements = slide.getCellElements();
            // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
            // Remove in v3?
            this.selectedCell = slide.cells[0];
            this.selectedElement = this.selectedElements[0];
          };

          proto.unselectSelectedSlide = function () {
            if (this.selectedSlide) {
              this.selectedSlide.unselect();
            }
          };

          proto.selectInitialIndex = function () {
            var initialIndex = this.options.initialIndex;
            // already activated, select previous selectedIndex
            if (this.isInitActivated) {
              this.select(this.selectedIndex, false, true);
              return;
            }
            // select with selector string
            if (initialIndex && typeof initialIndex == "string") {
              var cell = this.queryCell(initialIndex);
              if (cell) {
                this.selectCell(initialIndex, false, true);
                return;
              }
            }

            var index = 0;
            // select with number
            if (initialIndex && this.slides[initialIndex]) {
              index = initialIndex;
            }
            // select instantly
            this.select(index, false, true);
          };

          /**
           * select slide from number or cell element
           * @param {Element or Number} elem
           */
          proto.selectCell = function (value, isWrap, isInstant) {
            // get cell
            var cell = this.queryCell(value);
            if (!cell) {
              return;
            }

            var index = this.getCellSlideIndex(cell);
            this.select(index, isWrap, isInstant);
          };

          proto.getCellSlideIndex = function (cell) {
            // get index of slides that has cell
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides[i];
              var index = slide.cells.indexOf(cell);
              if (index != -1) {
                return i;
              }
            }
          };

          // -------------------------- get cells -------------------------- //

          /**
           * get Flickity.Cell, given an Element
           * @param {Element} elem
           * @returns {Flickity.Cell} item
           */
          proto.getCell = function (elem) {
            // loop through cells to get the one that matches
            for (var i = 0; i < this.cells.length; i++) {
              var cell = this.cells[i];
              if (cell.element == elem) {
                return cell;
              }
            }
          };

          /**
           * get collection of Flickity.Cells, given Elements
           * @param {Element, Array, NodeList} elems
           * @returns {Array} cells - Flickity.Cells
           */
          proto.getCells = function (elems) {
            elems = utils.makeArray(elems);
            var cells = [];
            elems.forEach(function (elem) {
              var cell = this.getCell(elem);
              if (cell) {
                cells.push(cell);
              }
            }, this);
            return cells;
          };

          /**
           * get cell elements
           * @returns {Array} cellElems
           */
          proto.getCellElements = function () {
            return this.cells.map(function (cell) {
              return cell.element;
            });
          };

          /**
           * get parent cell from an element
           * @param {Element} elem
           * @returns {Flickit.Cell} cell
           */
          proto.getParentCell = function (elem) {
            // first check if elem is cell
            var cell = this.getCell(elem);
            if (cell) {
              return cell;
            }
            // try to get parent cell elem
            elem = utils.getParent(elem, ".flickity-slider > *");
            return this.getCell(elem);
          };

          /**
           * get cells adjacent to a slide
           * @param {Integer} adjCount - number of adjacent slides
           * @param {Integer} index - index of slide to start
           * @returns {Array} cells - array of Flickity.Cells
           */
          proto.getAdjacentCellElements = function (adjCount, index) {
            if (!adjCount) {
              return this.selectedSlide.getCellElements();
            }
            index = index === undefined ? this.selectedIndex : index;

            var len = this.slides.length;
            if (1 + adjCount * 2 >= len) {
              return this.getCellElements();
            }

            var cellElems = [];
            for (var i = index - adjCount; i <= index + adjCount; i++) {
              var slideIndex = this.options.wrapAround
                ? utils.modulo(i, len)
                : i;
              var slide = this.slides[slideIndex];
              if (slide) {
                cellElems = cellElems.concat(slide.getCellElements());
              }
            }
            return cellElems;
          };

          /**
           * select slide from number or cell element
           * @param {Element, Selector String, or Number} selector
           */
          proto.queryCell = function (selector) {
            if (typeof selector == "number") {
              // use number as index
              return this.cells[selector];
            }
            if (typeof selector == "string") {
              // do not select invalid selectors from hash: #123, #/. #791
              if (selector.match(/^[#\.]?[\d\/]/)) {
                return;
              }
              // use string as selector, get element
              selector = this.element.querySelector(selector);
            }
            // get cell from element
            return this.getCell(selector);
          };

          // -------------------------- events -------------------------- //

          proto.uiChange = function () {
            this.emitEvent("uiChange");
          };

          // keep focus on element when child UI elements are clicked
          proto.childUIPointerDown = function (event) {
            // HACK iOS does not allow touch events to bubble up?!
            if (event.type != "touchstart") {
              event.preventDefault();
            }
            this.focus();
          };

          // ----- resize ----- //

          proto.onresize = function () {
            this.watchCSS();
            this.resize();
          };

          utils.debounceMethod(Flickity, "onresize", 150);

          proto.resize = function () {
            if (!this.isActive) {
              return;
            }
            this.getSize();
            // wrap values
            if (this.options.wrapAround) {
              this.x = utils.modulo(this.x, this.slideableWidth);
            }
            this.positionCells();
            this._getWrapShiftCells();
            this.setGallerySize();
            this.emitEvent("resize");
            // update selected index for group slides, instant
            // TODO: position can be lost between groups of various numbers
            var selectedElement =
              this.selectedElements && this.selectedElements[0];
            this.selectCell(selectedElement, false, true);
          };

          // watches the :after property, activates/deactivates
          proto.watchCSS = function () {
            var watchOption = this.options.watchCSS;
            if (!watchOption) {
              return;
            }

            var afterContent = getComputedStyle(this.element, ":after").content;
            // activate if :after { content: 'flickity' }
            if (afterContent.indexOf("flickity") != -1) {
              this.activate();
            } else {
              this.deactivate();
            }
          };

          // ----- keydown ----- //

          // go previous/next if left/right keys pressed
          proto.onkeydown = function (event) {
            // only work if element is in focus
            var isNotFocused =
              document.activeElement && document.activeElement != this.element;
            if (!this.options.accessibility || isNotFocused) {
              return;
            }

            var handler = Flickity.keyboardHandlers[event.keyCode];
            if (handler) {
              handler.call(this);
            }
          };

          Flickity.keyboardHandlers = {
            // left arrow
            37: function () {
              var leftMethod = this.options.rightToLeft ? "next" : "previous";
              this.uiChange();
              this[leftMethod]();
            },
            // right arrow
            39: function () {
              var rightMethod = this.options.rightToLeft ? "previous" : "next";
              this.uiChange();
              this[rightMethod]();
            },
          };

          // ----- focus ----- //

          proto.focus = function () {
            // TODO remove scrollTo once focus options gets more support
            // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#Browser_compatibility
            var prevScrollY = window.pageYOffset;
            this.element.focus({ preventScroll: true });
            // hack to fix scroll jump after focus, #76
            if (window.pageYOffset != prevScrollY) {
              window.scrollTo(window.pageXOffset, prevScrollY);
            }
          };

          // -------------------------- destroy -------------------------- //

          // deactivate all Flickity functionality, but keep stuff available
          proto.deactivate = function () {
            if (!this.isActive) {
              return;
            }
            this.element.classList.remove("flickity-enabled");
            this.element.classList.remove("flickity-rtl");
            this.unselectSelectedSlide();
            // destroy cells
            this.cells.forEach(function (cell) {
              cell.destroy();
            });
            this.element.removeChild(this.viewport);
            // move child elements back into element
            moveElements(this.slider.children, this.element);
            if (this.options.accessibility) {
              this.element.removeAttribute("tabIndex");
              this.element.removeEventListener("keydown", this);
            }
            // set flags
            this.isActive = false;
            this.emitEvent("deactivate");
          };

          proto.destroy = function () {
            this.deactivate();
            window.removeEventListener("resize", this);
            this.allOff();
            this.emitEvent("destroy");
            if (jQuery && this.$element) {
              jQuery.removeData(this.element, "flickity");
            }
            delete this.element.flickityGUID;
            delete instances[this.guid];
          };

          // -------------------------- prototype -------------------------- //

          utils.extend(proto, animatePrototype);

          // -------------------------- extras -------------------------- //

          /**
           * get Flickity instance from element
           * @param {Element} elem
           * @returns {Flickity}
           */
          Flickity.data = function (elem) {
            elem = utils.getQueryElement(elem);
            var id = elem && elem.flickityGUID;
            return id && instances[id];
          };

          utils.htmlInit(Flickity, "flickity");

          if (jQuery && jQuery.bridget) {
            jQuery.bridget("flickity", Flickity);
          }

          // set internal jQuery, for Webpack + jQuery v3, #478
          Flickity.setJQuery = function (jq) {
            jQuery = jq;
          };

          Flickity.Cell = Cell;
          Flickity.Slide = Slide;

          return Flickity;
        }
      );

      /***/
    },
    /* 48 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var global = __webpack_require__(3);
      var dP = __webpack_require__(8);
      var DESCRIPTORS = __webpack_require__(9);
      var SPECIES = __webpack_require__(6)("species");

      module.exports = function (KEY) {
        var C = global[KEY];
        if (DESCRIPTORS && C && !C[SPECIES])
          dP.f(C, SPECIES, {
            configurable: true,
            get: function () {
              return this;
            },
          });
      };

      /***/
    },
    /* 49 */
    /***/ function (module, exports) {
      module.exports = function (it, Constructor, name, forbiddenField) {
        if (
          !(it instanceof Constructor) ||
          (forbiddenField !== undefined && forbiddenField in it)
        ) {
          throw TypeError(name + ": incorrect invocation!");
        }
        return it;
      };

      /***/
    },
    /* 50 */
    /***/ function (module, exports, __webpack_require__) {
      var redefine = __webpack_require__(17);
      module.exports = function (target, src, safe) {
        for (var key in src) redefine(target, key, src[key], safe);
        return target;
      };

      /***/
    },
    /* 51 */
    /***/ function (module, exports, __webpack_require__) {
      var def = __webpack_require__(8).f;
      var has = __webpack_require__(15);
      var TAG = __webpack_require__(6)("toStringTag");

      module.exports = function (it, tag, stat) {
        if (it && !has((it = stat ? it : it.prototype), TAG))
          def(it, TAG, { configurable: true, value: tag });
      };

      /***/
    },
    /* 52 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(1);
      var defined = __webpack_require__(25);
      var fails = __webpack_require__(5);
      var spaces = __webpack_require__(88);
      var space = "[" + spaces + "]";
      var non = "\u200b\u0085";
      var ltrim = RegExp("^" + space + space + "*");
      var rtrim = RegExp(space + space + "*$");

      var exporter = function (KEY, exec, ALIAS) {
        var exp = {};
        var FORCE = fails(function () {
          return !!spaces[KEY]() || non[KEY]() != non;
        });
        var fn = (exp[KEY] = FORCE ? exec(trim) : spaces[KEY]);
        if (ALIAS) exp[ALIAS] = fn;
        $export($export.P + $export.F * FORCE, "String", exp);
      };

      // 1 -> String#trimLeft
      // 2 -> String#trimRight
      // 3 -> String#trim
      var trim = (exporter.trim = function (string, TYPE) {
        string = String(defined(string));
        if (TYPE & 1) string = string.replace(ltrim, "");
        if (TYPE & 2) string = string.replace(rtrim, "");
        return string;
      });

      module.exports = exporter;

      /***/
    },
    /* 53 */
    /***/ function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(4);
      module.exports = function (it, TYPE) {
        if (!isObject(it) || it._t !== TYPE)
          throw TypeError("Incompatible receiver, " + TYPE + " required!");
        return it;
      };

      /***/
    },
    /* 54 */
    /***/ function (module, exports) {
      module.exports = debounce;

      function debounce(fn, delay, at_start, guarantee) {
        var timeout;
        var args;
        var self;

        return function debounced() {
          self = this;
          args = Array.prototype.slice.call(arguments);

          if (timeout && (at_start || guarantee)) {
            return;
          } else if (!at_start) {
            clear();

            timeout = setTimeout(run, delay);
            return timeout;
          }

          timeout = setTimeout(clear, delay);
          fn.apply(self, args);

          function run() {
            clear();
            fn.apply(self, args);
          }

          function clear() {
            clearTimeout(timeout);
            timeout = null;
          }
        };
      }

      /***/
    },
    /* 55 */
    /***/ function (module, exports, __webpack_require__) {
      // fallback for non-array-like ES3 and non-enumerable old V8 strings
      var cof = __webpack_require__(22);
      // eslint-disable-next-line no-prototype-builtins
      module.exports = Object("z").propertyIsEnumerable(0)
        ? Object
        : function (it) {
            return cof(it) == "String" ? it.split("") : Object(it);
          };

      /***/
    },
    /* 56 */
    /***/ function (module, exports) {
      exports.f = {}.propertyIsEnumerable;

      /***/
    },
    /* 57 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;
      /**
       * EvEmitter v1.1.0
       * Lil' event emitter
       * MIT License
       */

      /* jshint unused: true, undef: true, strict: true */

      (function (global, factory) {
        // universal module definition
        /* jshint strict: false */ /* globals define, module, window */
        if (true) {
          // AMD - RequireJS
          !((__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
          (__WEBPACK_AMD_DEFINE_RESULT__ =
            typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
              ? __WEBPACK_AMD_DEFINE_FACTORY__.call(
                  exports,
                  __webpack_require__,
                  exports,
                  module
                )
              : __WEBPACK_AMD_DEFINE_FACTORY__),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
            (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(typeof window != "undefined" ? window : this, function () {
        "use strict";

        function EvEmitter() {}

        var proto = EvEmitter.prototype;

        proto.on = function (eventName, listener) {
          if (!eventName || !listener) {
            return;
          }
          // set events hash
          var events = (this._events = this._events || {});
          // set listeners array
          var listeners = (events[eventName] = events[eventName] || []);
          // only add once
          if (listeners.indexOf(listener) == -1) {
            listeners.push(listener);
          }

          return this;
        };

        proto.once = function (eventName, listener) {
          if (!eventName || !listener) {
            return;
          }
          // add event
          this.on(eventName, listener);
          // set once flag
          // set onceEvents hash
          var onceEvents = (this._onceEvents = this._onceEvents || {});
          // set onceListeners object
          var onceListeners = (onceEvents[eventName] =
            onceEvents[eventName] || {});
          // set flag
          onceListeners[listener] = true;

          return this;
        };

        proto.off = function (eventName, listener) {
          var listeners = this._events && this._events[eventName];
          if (!listeners || !listeners.length) {
            return;
          }
          var index = listeners.indexOf(listener);
          if (index != -1) {
            listeners.splice(index, 1);
          }

          return this;
        };

        proto.emitEvent = function (eventName, args) {
          var listeners = this._events && this._events[eventName];
          if (!listeners || !listeners.length) {
            return;
          }
          // copy over to avoid interference if .off() in listener
          listeners = listeners.slice(0);
          args = args || [];
          // once stuff
          var onceListeners = this._onceEvents && this._onceEvents[eventName];

          for (var i = 0; i < listeners.length; i++) {
            var listener = listeners[i];
            var isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
              // remove listener
              // remove before trigger to prevent recursion
              this.off(eventName, listener);
              // unset once flag
              delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
          }

          return this;
        };

        proto.allOff = function () {
          delete this._events;
          delete this._onceEvents;
        };

        return EvEmitter;
      });

      /***/
    },
    /* 58 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;
      /*!
       * getSize v2.0.3
       * measure size of elements
       * MIT license
       */

      /* jshint browser: true, strict: true, undef: true, unused: true */
      /* globals console: false */

      (function (window, factory) {
        /* jshint strict: false */ /* globals define, module */
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
          (__WEBPACK_AMD_DEFINE_RESULT__ =
            typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
              ? __WEBPACK_AMD_DEFINE_FACTORY__.call(
                  exports,
                  __webpack_require__,
                  exports,
                  module
                )
              : __WEBPACK_AMD_DEFINE_FACTORY__),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
            (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(window, function factory() {
        "use strict";

        // -------------------------- helpers -------------------------- //

        // get a number from a string, not a percentage
        function getStyleSize(value) {
          var num = parseFloat(value);
          // not a percent like '100%', and a number
          var isValid = value.indexOf("%") == -1 && !isNaN(num);
          return isValid && num;
        }

        function noop() {}

        var logError =
          typeof console == "undefined"
            ? noop
            : function (message) {
                console.error(message);
              };

        // -------------------------- measurements -------------------------- //

        var measurements = [
          "paddingLeft",
          "paddingRight",
          "paddingTop",
          "paddingBottom",
          "marginLeft",
          "marginRight",
          "marginTop",
          "marginBottom",
          "borderLeftWidth",
          "borderRightWidth",
          "borderTopWidth",
          "borderBottomWidth",
        ];

        var measurementsLength = measurements.length;

        function getZeroSize() {
          var size = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0,
          };
          for (var i = 0; i < measurementsLength; i++) {
            var measurement = measurements[i];
            size[measurement] = 0;
          }
          return size;
        }

        // -------------------------- getStyle -------------------------- //

        /**
         * getStyle, get style of element, check for Firefox bug
         * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
         */
        function getStyle(elem) {
          var style = getComputedStyle(elem);
          if (!style) {
            logError(
              "Style returned " +
                style +
                ". Are you running this code in a hidden iframe on Firefox? " +
                "See https://bit.ly/getsizebug1"
            );
          }
          return style;
        }

        // -------------------------- setup -------------------------- //

        var isSetup = false;

        var isBoxSizeOuter;

        /**
         * setup
         * check isBoxSizerOuter
         * do on first getSize() rather than on page load for Firefox bug
         */
        function setup() {
          // setup once
          if (isSetup) {
            return;
          }
          isSetup = true;

          // -------------------------- box sizing -------------------------- //

          /**
           * Chrome & Safari measure the outer-width on style.width on border-box elems
           * IE11 & Firefox<29 measures the inner-width
           */
          var div = document.createElement("div");
          div.style.width = "200px";
          div.style.padding = "1px 2px 3px 4px";
          div.style.borderStyle = "solid";
          div.style.borderWidth = "1px 2px 3px 4px";
          div.style.boxSizing = "border-box";

          var body = document.body || document.documentElement;
          body.appendChild(div);
          var style = getStyle(div);
          // round value for browser zoom. desandro/masonry#928
          isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
          getSize.isBoxSizeOuter = isBoxSizeOuter;

          body.removeChild(div);
        }

        // -------------------------- getSize -------------------------- //

        function getSize(elem) {
          setup();

          // use querySeletor if elem is string
          if (typeof elem == "string") {
            elem = document.querySelector(elem);
          }

          // do not proceed on non-objects
          if (!elem || typeof elem != "object" || !elem.nodeType) {
            return;
          }

          var style = getStyle(elem);

          // if hidden, everything is 0
          if (style.display == "none") {
            return getZeroSize();
          }

          var size = {};
          size.width = elem.offsetWidth;
          size.height = elem.offsetHeight;

          var isBorderBox = (size.isBorderBox =
            style.boxSizing == "border-box");

          // get all measurements
          for (var i = 0; i < measurementsLength; i++) {
            var measurement = measurements[i];
            var value = style[measurement];
            var num = parseFloat(value);
            // any 'auto', 'medium' value will be 0
            size[measurement] = !isNaN(num) ? num : 0;
          }

          var paddingWidth = size.paddingLeft + size.paddingRight;
          var paddingHeight = size.paddingTop + size.paddingBottom;
          var marginWidth = size.marginLeft + size.marginRight;
          var marginHeight = size.marginTop + size.marginBottom;
          var borderWidth = size.borderLeftWidth + size.borderRightWidth;
          var borderHeight = size.borderTopWidth + size.borderBottomWidth;

          var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

          // overwrite width and height if we can get it from style
          var styleWidth = getStyleSize(style.width);
          if (styleWidth !== false) {
            size.width =
              styleWidth +
              // add padding and border unless it's already including it
              (isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
          }

          var styleHeight = getStyleSize(style.height);
          if (styleHeight !== false) {
            size.height =
              styleHeight +
              // add padding and border unless it's already including it
              (isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
          }

          size.innerWidth = size.width - (paddingWidth + borderWidth);
          size.innerHeight = size.height - (paddingHeight + borderHeight);

          size.outerWidth = size.width + marginWidth;
          size.outerHeight = size.height + marginHeight;

          return size;
        }

        return getSize;
      });

      /***/
    },
    /* 59 */
    /***/ function (module, exports, __webpack_require__) {
      var classof = __webpack_require__(45);
      var ITERATOR = __webpack_require__(6)("iterator");
      var Iterators = __webpack_require__(46);
      module.exports = __webpack_require__(11).getIteratorMethod = function (
        it
      ) {
        if (it != undefined)
          return it[ITERATOR] || it["@@iterator"] || Iterators[classof(it)];
      };

      /***/
    },
    /* 60 */
    /***/ function (module, exports, __webpack_require__) {
      var core = __webpack_require__(11);
      var global = __webpack_require__(3);
      var SHARED = "__core-js_shared__";
      var store = global[SHARED] || (global[SHARED] = {});

      (module.exports = function (key, value) {
        return store[key] || (store[key] = value !== undefined ? value : {});
      })("versions", []).push({
        version: core.version,
        mode: __webpack_require__(38) ? "pure" : "global",
        copyright: "© 2018 Denis Pushkarev (zloirock.ru)",
      });

      /***/
    },
    /* 61 */
    /***/ function (module, exports, __webpack_require__) {
      // false -> Array#indexOf
      // true  -> Array#includes
      var toIObject = __webpack_require__(14);
      var toLength = __webpack_require__(10);
      var toAbsoluteIndex = __webpack_require__(43);
      module.exports = function (IS_INCLUDES) {
        return function ($this, el, fromIndex) {
          var O = toIObject($this);
          var length = toLength(O.length);
          var index = toAbsoluteIndex(fromIndex, length);
          var value;
          // Array#includes uses SameValueZero equality algorithm
          // eslint-disable-next-line no-self-compare
          if (IS_INCLUDES && el != el)
            while (length > index) {
              value = O[index++];
              // eslint-disable-next-line no-self-compare
              if (value != value) return true;
              // Array#indexOf ignores holes, Array#includes - not
            }
          else
            for (; length > index; index++)
              if (IS_INCLUDES || index in O) {
                if (O[index] === el) return IS_INCLUDES || index || 0;
              }
          return !IS_INCLUDES && -1;
        };
      };

      /***/
    },
    /* 62 */
    /***/ function (module, exports) {
      exports.f = Object.getOwnPropertySymbols;

      /***/
    },
    /* 63 */
    /***/ function (module, exports, __webpack_require__) {
      // 7.2.2 IsArray(argument)
      var cof = __webpack_require__(22);
      module.exports =
        Array.isArray ||
        function isArray(arg) {
          return cof(arg) == "Array";
        };

      /***/
    },
    /* 64 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var addToUnscopables = __webpack_require__(39);
      var step = __webpack_require__(84);
      var Iterators = __webpack_require__(46);
      var toIObject = __webpack_require__(14);

      // 22.1.3.4 Array.prototype.entries()
      // 22.1.3.13 Array.prototype.keys()
      // 22.1.3.29 Array.prototype.values()
      // 22.1.3.30 Array.prototype[@@iterator]()
      module.exports = __webpack_require__(65)(
        Array,
        "Array",
        function (iterated, kind) {
          this._t = toIObject(iterated); // target
          this._i = 0; // next index
          this._k = kind; // kind
          // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
        },
        function () {
          var O = this._t;
          var kind = this._k;
          var index = this._i++;
          if (!O || index >= O.length) {
            this._t = undefined;
            return step(1);
          }
          if (kind == "keys") return step(0, index);
          if (kind == "values") return step(0, O[index]);
          return step(0, [index, O[index]]);
        },
        "values"
      );

      // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
      Iterators.Arguments = Iterators.Array;

      addToUnscopables("keys");
      addToUnscopables("values");
      addToUnscopables("entries");

      /***/
    },
    /* 65 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var LIBRARY = __webpack_require__(38);
      var $export = __webpack_require__(1);
      var redefine = __webpack_require__(17);
      var hide = __webpack_require__(16);
      var Iterators = __webpack_require__(46);
      var $iterCreate = __webpack_require__(66);
      var setToStringTag = __webpack_require__(51);
      var getPrototypeOf = __webpack_require__(19);
      var ITERATOR = __webpack_require__(6)("iterator");
      var BUGGY = !([].keys && "next" in [].keys()); // Safari has buggy iterators w/o `next`
      var FF_ITERATOR = "@@iterator";
      var KEYS = "keys";
      var VALUES = "values";

      var returnThis = function () {
        return this;
      };

      module.exports = function (
        Base,
        NAME,
        Constructor,
        next,
        DEFAULT,
        IS_SET,
        FORCED
      ) {
        $iterCreate(Constructor, NAME, next);
        var getMethod = function (kind) {
          if (!BUGGY && kind in proto) return proto[kind];
          switch (kind) {
            case KEYS:
              return function keys() {
                return new Constructor(this, kind);
              };
            case VALUES:
              return function values() {
                return new Constructor(this, kind);
              };
          }
          return function entries() {
            return new Constructor(this, kind);
          };
        };
        var TAG = NAME + " Iterator";
        var DEF_VALUES = DEFAULT == VALUES;
        var VALUES_BUG = false;
        var proto = Base.prototype;
        var $native =
          proto[ITERATOR] || proto[FF_ITERATOR] || (DEFAULT && proto[DEFAULT]);
        var $default = $native || getMethod(DEFAULT);
        var $entries = DEFAULT
          ? !DEF_VALUES
            ? $default
            : getMethod("entries")
          : undefined;
        var $anyNative = NAME == "Array" ? proto.entries || $native : $native;
        var methods, key, IteratorPrototype;
        // Fix native
        if ($anyNative) {
          IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
          if (
            IteratorPrototype !== Object.prototype &&
            IteratorPrototype.next
          ) {
            // Set @@toStringTag to native iterators
            setToStringTag(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != "function")
              hide(IteratorPrototype, ITERATOR, returnThis);
          }
        }
        // fix Array#{values, @@iterator}.name in V8 / FF
        if (DEF_VALUES && $native && $native.name !== VALUES) {
          VALUES_BUG = true;
          $default = function values() {
            return $native.call(this);
          };
        }
        // Define iterator
        if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
          hide(proto, ITERATOR, $default);
        }
        // Plug for library
        Iterators[NAME] = $default;
        Iterators[TAG] = returnThis;
        if (DEFAULT) {
          methods = {
            values: DEF_VALUES ? $default : getMethod(VALUES),
            keys: IS_SET ? $default : getMethod(KEYS),
            entries: $entries,
          };
          if (FORCED)
            for (key in methods) {
              if (!(key in proto)) redefine(proto, key, methods[key]);
            }
          else
            $export(
              $export.P + $export.F * (BUGGY || VALUES_BUG),
              NAME,
              methods
            );
        }
        return methods;
      };

      /***/
    },
    /* 66 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var create = __webpack_require__(31);
      var descriptor = __webpack_require__(36);
      var setToStringTag = __webpack_require__(51);
      var IteratorPrototype = {};

      // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
      __webpack_require__(16)(
        IteratorPrototype,
        __webpack_require__(6)("iterator"),
        function () {
          return this;
        }
      );

      module.exports = function (Constructor, NAME, next) {
        Constructor.prototype = create(IteratorPrototype, {
          next: descriptor(1, next),
        });
        setToStringTag(Constructor, NAME + " Iterator");
      };

      /***/
    },
    /* 67 */
    /***/ function (module, exports, __webpack_require__) {
      // 7.2.8 IsRegExp(argument)
      var isObject = __webpack_require__(4);
      var cof = __webpack_require__(22);
      var MATCH = __webpack_require__(6)("match");
      module.exports = function (it) {
        var isRegExp;
        return (
          isObject(it) &&
          ((isRegExp = it[MATCH]) !== undefined
            ? !!isRegExp
            : cof(it) == "RegExp")
        );
      };

      /***/
    },
    /* 68 */
    /***/ function (module, exports, __webpack_require__) {
      var ITERATOR = __webpack_require__(6)("iterator");
      var SAFE_CLOSING = false;

      try {
        var riter = [7][ITERATOR]();
        riter["return"] = function () {
          SAFE_CLOSING = true;
        };
        // eslint-disable-next-line no-throw-literal
        Array.from(riter, function () {
          throw 2;
        });
      } catch (e) {
        /* empty */
      }

      module.exports = function (exec, skipClosing) {
        if (!skipClosing && !SAFE_CLOSING) return false;
        var safe = false;
        try {
          var arr = [7];
          var iter = arr[ITERATOR]();
          iter.next = function () {
            return { done: (safe = true) };
          };
          arr[ITERATOR] = function () {
            return iter;
          };
          exec(arr);
        } catch (e) {
          /* empty */
        }
        return safe;
      };

      /***/
    },
    /* 69 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // 21.2.5.3 get RegExp.prototype.flags
      var anObject = __webpack_require__(2);
      module.exports = function () {
        var that = anObject(this);
        var result = "";
        if (that.global) result += "g";
        if (that.ignoreCase) result += "i";
        if (that.multiline) result += "m";
        if (that.unicode) result += "u";
        if (that.sticky) result += "y";
        return result;
      };

      /***/
    },
    /* 70 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var hide = __webpack_require__(16);
      var redefine = __webpack_require__(17);
      var fails = __webpack_require__(5);
      var defined = __webpack_require__(25);
      var wks = __webpack_require__(6);

      module.exports = function (KEY, length, exec) {
        var SYMBOL = wks(KEY);
        var fns = exec(defined, SYMBOL, ""[KEY]);
        var strfn = fns[0];
        var rxfn = fns[1];
        if (
          fails(function () {
            var O = {};
            O[SYMBOL] = function () {
              return 7;
            };
            return ""[KEY](O) != 7;
          })
        ) {
          redefine(String.prototype, KEY, strfn);
          hide(
            RegExp.prototype,
            SYMBOL,
            length == 2
              ? // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
                // 21.2.5.11 RegExp.prototype[@@split](string, limit)
                function (string, arg) {
                  return rxfn.call(string, this, arg);
                }
              : // 21.2.5.6 RegExp.prototype[@@match](string)
                // 21.2.5.9 RegExp.prototype[@@search](string)
                function (string) {
                  return rxfn.call(string, this);
                }
          );
        }
      };

      /***/
    },
    /* 71 */
    /***/ function (module, exports, __webpack_require__) {
      // 7.3.20 SpeciesConstructor(O, defaultConstructor)
      var anObject = __webpack_require__(2);
      var aFunction = __webpack_require__(13);
      var SPECIES = __webpack_require__(6)("species");
      module.exports = function (O, D) {
        var C = anObject(O).constructor;
        var S;
        return C === undefined || (S = anObject(C)[SPECIES]) == undefined
          ? D
          : aFunction(S);
      };

      /***/
    },
    /* 72 */
    /***/ function (module, exports, __webpack_require__) {
      var global = __webpack_require__(3);
      var navigator = global.navigator;

      module.exports = (navigator && navigator.userAgent) || "";

      /***/
    },
    /* 73 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var global = __webpack_require__(3);
      var $export = __webpack_require__(1);
      var redefine = __webpack_require__(17);
      var redefineAll = __webpack_require__(50);
      var meta = __webpack_require__(37);
      var forOf = __webpack_require__(40);
      var anInstance = __webpack_require__(49);
      var isObject = __webpack_require__(4);
      var fails = __webpack_require__(5);
      var $iterDetect = __webpack_require__(68);
      var setToStringTag = __webpack_require__(51);
      var inheritIfRequired = __webpack_require__(89);

      module.exports = function (
        NAME,
        wrapper,
        methods,
        common,
        IS_MAP,
        IS_WEAK
      ) {
        var Base = global[NAME];
        var C = Base;
        var ADDER = IS_MAP ? "set" : "add";
        var proto = C && C.prototype;
        var O = {};
        var fixMethod = function (KEY) {
          var fn = proto[KEY];
          redefine(
            proto,
            KEY,
            KEY == "delete"
              ? function (a) {
                  return IS_WEAK && !isObject(a)
                    ? false
                    : fn.call(this, a === 0 ? 0 : a);
                }
              : KEY == "has"
              ? function has(a) {
                  return IS_WEAK && !isObject(a)
                    ? false
                    : fn.call(this, a === 0 ? 0 : a);
                }
              : KEY == "get"
              ? function get(a) {
                  return IS_WEAK && !isObject(a)
                    ? undefined
                    : fn.call(this, a === 0 ? 0 : a);
                }
              : KEY == "add"
              ? function add(a) {
                  fn.call(this, a === 0 ? 0 : a);
                  return this;
                }
              : function set(a, b) {
                  fn.call(this, a === 0 ? 0 : a, b);
                  return this;
                }
          );
        };
        if (
          typeof C != "function" ||
          !(
            IS_WEAK ||
            (proto.forEach &&
              !fails(function () {
                new C().entries().next();
              }))
          )
        ) {
          // create collection constructor
          C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
          redefineAll(C.prototype, methods);
          meta.NEED = true;
        } else {
          var instance = new C();
          // early implementations not supports chaining
          var HASNT_CHAINING =
            instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
          // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
          var THROWS_ON_PRIMITIVES = fails(function () {
            instance.has(1);
          });
          // most early implementations doesn't supports iterables, most modern - not close it correctly
          var ACCEPT_ITERABLES = $iterDetect(function (iter) {
            new C(iter);
          }); // eslint-disable-line no-new
          // for early implementations -0 and +0 not the same
          var BUGGY_ZERO =
            !IS_WEAK &&
            fails(function () {
              // V8 ~ Chromium 42- fails only with 5+ elements
              var $instance = new C();
              var index = 5;
              while (index--) $instance[ADDER](index, index);
              return !$instance.has(-0);
            });
          if (!ACCEPT_ITERABLES) {
            C = wrapper(function (target, iterable) {
              anInstance(target, C, NAME);
              var that = inheritIfRequired(new Base(), target, C);
              if (iterable != undefined)
                forOf(iterable, IS_MAP, that[ADDER], that);
              return that;
            });
            C.prototype = proto;
            proto.constructor = C;
          }
          if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod("delete");
            fixMethod("has");
            IS_MAP && fixMethod("get");
          }
          if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
          // weak collections should not contains .clear method
          if (IS_WEAK && proto.clear) delete proto.clear;
        }

        setToStringTag(C, NAME);

        O[NAME] = C;
        $export($export.G + $export.W + $export.F * (C != Base), O);

        if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

        return C;
      };

      /***/
    },
    /* 74 */
    /***/ function (module, exports, __webpack_require__) {
      var global = __webpack_require__(3);
      var hide = __webpack_require__(16);
      var uid = __webpack_require__(42);
      var TYPED = uid("typed_array");
      var VIEW = uid("view");
      var ABV = !!(global.ArrayBuffer && global.DataView);
      var CONSTR = ABV;
      var i = 0;
      var l = 9;
      var Typed;

      var TypedArrayConstructors =
        "Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(
          ","
        );

      while (i < l) {
        if ((Typed = global[TypedArrayConstructors[i++]])) {
          hide(Typed.prototype, TYPED, true);
          hide(Typed.prototype, VIEW, true);
        } else CONSTR = false;
      }

      module.exports = {
        ABV: ABV,
        CONSTR: CONSTR,
        TYPED: TYPED,
        VIEW: VIEW,
      };

      /***/
    },
    /* 75 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // Forced replacement prototype accessors methods
      module.exports =
        __webpack_require__(38) ||
        !__webpack_require__(5)(function () {
          var K = Math.random();
          // In FF throws only define methods
          // eslint-disable-next-line no-undef, no-useless-call
          __defineSetter__.call(null, K, function () {
            /* empty */
          });
          delete __webpack_require__(3)[K];
        });

      /***/
    },
    /* 76 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // https://tc39.github.io/proposal-setmap-offrom/
      var $export = __webpack_require__(1);

      module.exports = function (COLLECTION) {
        $export($export.S, COLLECTION, {
          of: function of() {
            var length = arguments.length;
            var A = new Array(length);
            while (length--) A[length] = arguments[length];
            return new this(A);
          },
        });
      };

      /***/
    },
    /* 77 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // https://tc39.github.io/proposal-setmap-offrom/
      var $export = __webpack_require__(1);
      var aFunction = __webpack_require__(13);
      var ctx = __webpack_require__(21);
      var forOf = __webpack_require__(40);

      module.exports = function (COLLECTION) {
        $export($export.S, COLLECTION, {
          from: function from(source /* , mapFn, thisArg */) {
            var mapFn = arguments[1];
            var mapping, A, n, cb;
            aFunction(this);
            mapping = mapFn !== undefined;
            if (mapping) aFunction(mapFn);
            if (source == undefined) return new this();
            A = [];
            if (mapping) {
              n = 0;
              cb = ctx(mapFn, arguments[2], 2);
              forOf(source, false, function (nextItem) {
                A.push(cb(nextItem, n++));
              });
            } else {
              forOf(source, false, A.push, A);
            }
            return new this(A);
          },
        });
      };

      /***/
    },
    /* 78 */
    /***/ function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(4);
      var document = __webpack_require__(3).document;
      // typeof document.createElement is 'object' in old IE
      var is = isObject(document) && isObject(document.createElement);
      module.exports = function (it) {
        return is ? document.createElement(it) : {};
      };

      /***/
    },
    /* 79 */
    /***/ function (module, exports, __webpack_require__) {
      var global = __webpack_require__(3);
      var core = __webpack_require__(11);
      var LIBRARY = __webpack_require__(38);
      var wksExt = __webpack_require__(109);
      var defineProperty = __webpack_require__(8).f;
      module.exports = function (name) {
        var $Symbol =
          core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
        if (name.charAt(0) != "_" && !(name in $Symbol))
          defineProperty($Symbol, name, { value: wksExt.f(name) });
      };

      /***/
    },
    /* 80 */
    /***/ function (module, exports, __webpack_require__) {
      var shared = __webpack_require__(60)("keys");
      var uid = __webpack_require__(42);
      module.exports = function (key) {
        return shared[key] || (shared[key] = uid(key));
      };

      /***/
    },
    /* 81 */
    /***/ function (module, exports) {
      // IE 8- don't enum bug keys
      module.exports =
        "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(
          ","
        );

      /***/
    },
    /* 82 */
    /***/ function (module, exports, __webpack_require__) {
      var document = __webpack_require__(3).document;
      module.exports = document && document.documentElement;

      /***/
    },
    /* 83 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // 19.1.2.1 Object.assign(target, source, ...)
      var getKeys = __webpack_require__(30);
      var gOPS = __webpack_require__(62);
      var pIE = __webpack_require__(56);
      var toObject = __webpack_require__(12);
      var IObject = __webpack_require__(55);
      var $assign = Object.assign;

      // should work with symbols and should have deterministic property order (V8 bug)
      module.exports =
        !$assign ||
        __webpack_require__(5)(function () {
          var A = {};
          var B = {};
          // eslint-disable-next-line no-undef
          var S = Symbol();
          var K = "abcdefghijklmnopqrst";
          A[S] = 7;
          K.split("").forEach(function (k) {
            B[k] = k;
          });
          return (
            $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join("") != K
          );
        })
          ? function assign(target, source) {
              // eslint-disable-line no-unused-vars
              var T = toObject(target);
              var aLen = arguments.length;
              var index = 1;
              var getSymbols = gOPS.f;
              var isEnum = pIE.f;
              while (aLen > index) {
                var S = IObject(arguments[index++]);
                var keys = getSymbols
                  ? getKeys(S).concat(getSymbols(S))
                  : getKeys(S);
                var length = keys.length;
                var j = 0;
                var key;
                while (length > j)
                  if (isEnum.call(S, (key = keys[j++]))) T[key] = S[key];
              }
              return T;
            }
          : $assign;

      /***/
    },
    /* 84 */
    /***/ function (module, exports) {
      module.exports = function (done, value) {
        return { value: value, done: !!done };
      };

      /***/
    },
    /* 85 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
      /*!
       * Unipointer v2.3.0
       * base class for doing one thing with pointer event
       * MIT license
       */

      /*jshint browser: true, undef: true, unused: true, strict: true */

      (function (window, factory) {
        // universal module definition
        /* jshint strict: false */ /*global define, module, require */
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(57)]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (EvEmitter) {
            return factory(window, EvEmitter);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
            (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(window, function factory(window, EvEmitter) {
        "use strict";

        function noop() {}

        function Unipointer() {}

        // inherit EvEmitter
        var proto = (Unipointer.prototype = Object.create(EvEmitter.prototype));

        proto.bindStartEvent = function (elem) {
          this._bindStartEvent(elem, true);
        };

        proto.unbindStartEvent = function (elem) {
          this._bindStartEvent(elem, false);
        };

        /**
         * Add or remove start event
         * @param {Boolean} isAdd - remove if falsey
         */
        proto._bindStartEvent = function (elem, isAdd) {
          // munge isAdd, default to true
          isAdd = isAdd === undefined ? true : isAdd;
          var bindMethod = isAdd ? "addEventListener" : "removeEventListener";

          // default to mouse events
          var startEvent = "mousedown";
          if (window.PointerEvent) {
            // Pointer Events
            startEvent = "pointerdown";
          } else if ("ontouchstart" in window) {
            // Touch Events. iOS Safari
            startEvent = "touchstart";
          }
          elem[bindMethod](startEvent, this);
        };

        // trigger handler methods for events
        proto.handleEvent = function (event) {
          var method = "on" + event.type;
          if (this[method]) {
            this[method](event);
          }
        };

        // returns the touch that we're keeping track of
        proto.getTouch = function (touches) {
          for (var i = 0; i < touches.length; i++) {
            var touch = touches[i];
            if (touch.identifier == this.pointerIdentifier) {
              return touch;
            }
          }
        };

        // ----- start event ----- //

        proto.onmousedown = function (event) {
          // dismiss clicks from right or middle buttons
          var button = event.button;
          if (button && button !== 0 && button !== 1) {
            return;
          }
          this._pointerDown(event, event);
        };

        proto.ontouchstart = function (event) {
          this._pointerDown(event, event.changedTouches[0]);
        };

        proto.onpointerdown = function (event) {
          this._pointerDown(event, event);
        };

        /**
         * pointer start
         * @param {Event} event
         * @param {Event or Touch} pointer
         */
        proto._pointerDown = function (event, pointer) {
          // dismiss right click and other pointers
          // button = 0 is okay, 1-4 not
          if (event.button || this.isPointerDown) {
            return;
          }

          this.isPointerDown = true;
          // save pointer identifier to match up touch events
          this.pointerIdentifier =
            pointer.pointerId !== undefined
              ? // pointerId for pointer events, touch.indentifier for touch events
                pointer.pointerId
              : pointer.identifier;

          this.pointerDown(event, pointer);
        };

        proto.pointerDown = function (event, pointer) {
          this._bindPostStartEvents(event);
          this.emitEvent("pointerDown", [event, pointer]);
        };

        // hash of events to be bound after start event
        var postStartEvents = {
          mousedown: ["mousemove", "mouseup"],
          touchstart: ["touchmove", "touchend", "touchcancel"],
          pointerdown: ["pointermove", "pointerup", "pointercancel"],
        };

        proto._bindPostStartEvents = function (event) {
          if (!event) {
            return;
          }
          // get proper events to match start event
          var events = postStartEvents[event.type];
          // bind events to node
          events.forEach(function (eventName) {
            window.addEventListener(eventName, this);
          }, this);
          // save these arguments
          this._boundPointerEvents = events;
        };

        proto._unbindPostStartEvents = function () {
          // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
          if (!this._boundPointerEvents) {
            return;
          }
          this._boundPointerEvents.forEach(function (eventName) {
            window.removeEventListener(eventName, this);
          }, this);

          delete this._boundPointerEvents;
        };

        // ----- move event ----- //

        proto.onmousemove = function (event) {
          this._pointerMove(event, event);
        };

        proto.onpointermove = function (event) {
          if (event.pointerId == this.pointerIdentifier) {
            this._pointerMove(event, event);
          }
        };

        proto.ontouchmove = function (event) {
          var touch = this.getTouch(event.changedTouches);
          if (touch) {
            this._pointerMove(event, touch);
          }
        };

        /**
         * pointer move
         * @param {Event} event
         * @param {Event or Touch} pointer
         * @private
         */
        proto._pointerMove = function (event, pointer) {
          this.pointerMove(event, pointer);
        };

        // public
        proto.pointerMove = function (event, pointer) {
          this.emitEvent("pointerMove", [event, pointer]);
        };

        // ----- end event ----- //

        proto.onmouseup = function (event) {
          this._pointerUp(event, event);
        };

        proto.onpointerup = function (event) {
          if (event.pointerId == this.pointerIdentifier) {
            this._pointerUp(event, event);
          }
        };

        proto.ontouchend = function (event) {
          var touch = this.getTouch(event.changedTouches);
          if (touch) {
            this._pointerUp(event, touch);
          }
        };

        /**
         * pointer up
         * @param {Event} event
         * @param {Event or Touch} pointer
         * @private
         */
        proto._pointerUp = function (event, pointer) {
          this._pointerDone();
          this.pointerUp(event, pointer);
        };

        // public
        proto.pointerUp = function (event, pointer) {
          this.emitEvent("pointerUp", [event, pointer]);
        };

        // ----- pointer done ----- //

        // triggered on pointer up & pointer cancel
        proto._pointerDone = function () {
          this._pointerReset();
          this._unbindPostStartEvents();
          this.pointerDone();
        };

        proto._pointerReset = function () {
          // reset properties
          this.isPointerDown = false;
          delete this.pointerIdentifier;
        };

        proto.pointerDone = noop;

        // ----- pointer cancel ----- //

        proto.onpointercancel = function (event) {
          if (event.pointerId == this.pointerIdentifier) {
            this._pointerCancel(event, event);
          }
        };

        proto.ontouchcancel = function (event) {
          var touch = this.getTouch(event.changedTouches);
          if (touch) {
            this._pointerCancel(event, touch);
          }
        };

        /**
         * pointer cancel
         * @param {Event} event
         * @param {Event or Touch} pointer
         * @private
         */
        proto._pointerCancel = function (event, pointer) {
          this._pointerDone();
          this.pointerCancel(event, pointer);
        };

        // public
        proto.pointerCancel = function (event, pointer) {
          this.emitEvent("pointerCancel", [event, pointer]);
        };

        // -----  ----- //

        // utility function for getting x/y coords from event
        Unipointer.getPointerPoint = function (pointer) {
          return {
            x: pointer.pageX,
            y: pointer.pageY,
          };
        };

        // -----  ----- //

        return Unipointer;
      });

      /***/
    },
    /* 86 */
    /***/ function (module, exports, __webpack_require__) {
      // Works with __proto__ only. Old v8 can't work with null proto objects.
      /* eslint-disable no-proto */
      var isObject = __webpack_require__(4);
      var anObject = __webpack_require__(2);
      var check = function (O, proto) {
        anObject(O);
        if (!isObject(proto) && proto !== null)
          throw TypeError(proto + ": can't set as prototype!");
      };
      module.exports = {
        set:
          Object.setPrototypeOf ||
          ("__proto__" in {} // eslint-disable-line
            ? (function (test, buggy, set) {
                try {
                  set = __webpack_require__(21)(
                    Function.call,
                    __webpack_require__(18).f(Object.prototype, "__proto__")
                      .set,
                    2
                  );
                  set(test, []);
                  buggy = !(test instanceof Array);
                } catch (e) {
                  buggy = true;
                }
                return function setPrototypeOf(O, proto) {
                  check(O, proto);
                  if (buggy) O.__proto__ = proto;
                  else set(O, proto);
                  return O;
                };
              })({}, false)
            : undefined),
        check: check,
      };

      /***/
    },
    /* 87 */
    /***/ function (module, exports) {
      // fast apply, http://jsperf.lnkit.com/fast-apply/5
      module.exports = function (fn, args, that) {
        var un = that === undefined;
        switch (args.length) {
          case 0:
            return un ? fn() : fn.call(that);
          case 1:
            return un ? fn(args[0]) : fn.call(that, args[0]);
          case 2:
            return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
          case 3:
            return un
              ? fn(args[0], args[1], args[2])
              : fn.call(that, args[0], args[1], args[2]);
          case 4:
            return un
              ? fn(args[0], args[1], args[2], args[3])
              : fn.call(that, args[0], args[1], args[2], args[3]);
        }
        return fn.apply(that, args);
      };

      /***/
    },
    /* 88 */
    /***/ function (module, exports) {
      module.exports =
        "\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003" +
        "\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";

      /***/
    },
    /* 89 */
    /***/ function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(4);
      var setPrototypeOf = __webpack_require__(86).set;
      module.exports = function (that, target, C) {
        var S = target.constructor;
        var P;
        if (
          S !== C &&
          typeof S == "function" &&
          (P = S.prototype) !== C.prototype &&
          isObject(P) &&
          setPrototypeOf
        ) {
          setPrototypeOf(that, P);
        }
        return that;
      };

      /***/
    },
    /* 90 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var toInteger = __webpack_require__(26);
      var defined = __webpack_require__(25);

      module.exports = function repeat(count) {
        var str = String(defined(this));
        var res = "";
        var n = toInteger(count);
        if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
        for (; n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
        return res;
      };

      /***/
    },
    /* 91 */
    /***/ function (module, exports) {
      // 20.2.2.28 Math.sign(x)
      module.exports =
        Math.sign ||
        function sign(x) {
          // eslint-disable-next-line no-self-compare
          return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
        };

      /***/
    },
    /* 92 */
    /***/ function (module, exports) {
      // 20.2.2.14 Math.expm1(x)
      var $expm1 = Math.expm1;
      module.exports =
        !$expm1 ||
        // Old FF bug
        $expm1(10) > 22025.465794806719 ||
        $expm1(10) < 22025.4657948067165168 ||
        // Tor Browser bug
        $expm1(-2e-17) != -2e-17
          ? function expm1(x) {
              return (x = +x) == 0
                ? x
                : x > -1e-6 && x < 1e-6
                ? x + (x * x) / 2
                : Math.exp(x) - 1;
            }
          : $expm1;

      /***/
    },
    /* 93 */
    /***/ function (module, exports, __webpack_require__) {
      var toInteger = __webpack_require__(26);
      var defined = __webpack_require__(25);
      // true  -> String#at
      // false -> String#codePointAt
      module.exports = function (TO_STRING) {
        return function (that, pos) {
          var s = String(defined(that));
          var i = toInteger(pos);
          var l = s.length;
          var a, b;
          if (i < 0 || i >= l) return TO_STRING ? "" : undefined;
          a = s.charCodeAt(i);
          return a < 0xd800 ||
            a > 0xdbff ||
            i + 1 === l ||
            (b = s.charCodeAt(i + 1)) < 0xdc00 ||
            b > 0xdfff
            ? TO_STRING
              ? s.charAt(i)
              : a
            : TO_STRING
            ? s.slice(i, i + 2)
            : ((a - 0xd800) << 10) + (b - 0xdc00) + 0x10000;
        };
      };

      /***/
    },
    /* 94 */
    /***/ function (module, exports, __webpack_require__) {
      // helper for String#{startsWith, endsWith, includes}
      var isRegExp = __webpack_require__(67);
      var defined = __webpack_require__(25);

      module.exports = function (that, searchString, NAME) {
        if (isRegExp(searchString))
          throw TypeError("String#" + NAME + " doesn't accept regex!");
        return String(defined(that));
      };

      /***/
    },
    /* 95 */
    /***/ function (module, exports, __webpack_require__) {
      var MATCH = __webpack_require__(6)("match");
      module.exports = function (KEY) {
        var re = /./;
        try {
          "/./"[KEY](re);
        } catch (e) {
          try {
            re[MATCH] = false;
            return !"/./"[KEY](re);
          } catch (f) {
            /* empty */
          }
        }
        return true;
      };

      /***/
    },
    /* 96 */
    /***/ function (module, exports, __webpack_require__) {
      // check on default Array iterator
      var Iterators = __webpack_require__(46);
      var ITERATOR = __webpack_require__(6)("iterator");
      var ArrayProto = Array.prototype;

      module.exports = function (it) {
        return (
          it !== undefined &&
          (Iterators.Array === it || ArrayProto[ITERATOR] === it)
        );
      };

      /***/
    },
    /* 97 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $defineProperty = __webpack_require__(8);
      var createDesc = __webpack_require__(36);

      module.exports = function (object, index, value) {
        if (index in object)
          $defineProperty.f(object, index, createDesc(0, value));
        else object[index] = value;
      };

      /***/
    },
    /* 98 */
    /***/ function (module, exports, __webpack_require__) {
      // 9.4.2.3 ArraySpeciesCreate(originalArray, length)
      var speciesConstructor = __webpack_require__(256);

      module.exports = function (original, length) {
        return new (speciesConstructor(original))(length);
      };

      /***/
    },
    /* 99 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";
      // 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

      var toObject = __webpack_require__(12);
      var toAbsoluteIndex = __webpack_require__(43);
      var toLength = __webpack_require__(10);
      module.exports = function fill(value /* , start = 0, end = @length */) {
        var O = toObject(this);
        var length = toLength(O.length);
        var aLen = arguments.length;
        var index = toAbsoluteIndex(
          aLen > 1 ? arguments[1] : undefined,
          length
        );
        var end = aLen > 2 ? arguments[2] : undefined;
        var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
        while (endPos > index) O[index++] = value;
        return O;
      };

      /***/
    },
    /* 100 */
    /***/ function (module, exports, __webpack_require__) {
      var ctx = __webpack_require__(21);
      var invoke = __webpack_require__(87);
      var html = __webpack_require__(82);
      var cel = __webpack_require__(78);
      var global = __webpack_require__(3);
      var process = global.process;
      var setTask = global.setImmediate;
      var clearTask = global.clearImmediate;
      var MessageChannel = global.MessageChannel;
      var Dispatch = global.Dispatch;
      var counter = 0;
      var queue = {};
      var ONREADYSTATECHANGE = "onreadystatechange";
      var defer, channel, port;
      var run = function () {
        var id = +this;
        // eslint-disable-next-line no-prototype-builtins
        if (queue.hasOwnProperty(id)) {
          var fn = queue[id];
          delete queue[id];
          fn();
        }
      };
      var listener = function (event) {
        run.call(event.data);
      };
      // Node.js 0.9+ & IE10+ has setImmediate, otherwise:
      if (!setTask || !clearTask) {
        setTask = function setImmediate(fn) {
          var args = [];
          var i = 1;
          while (arguments.length > i) args.push(arguments[i++]);
          queue[++counter] = function () {
            // eslint-disable-next-line no-new-func
            invoke(typeof fn == "function" ? fn : Function(fn), args);
          };
          defer(counter);
          return counter;
        };
        clearTask = function clearImmediate(id) {
          delete queue[id];
        };
        // Node.js 0.8-
        if (__webpack_require__(22)(process) == "process") {
          defer = function (id) {
            process.nextTick(ctx(run, id, 1));
          };
          // Sphere (JS game engine) Dispatch API
        } else if (Dispatch && Dispatch.now) {
          defer = function (id) {
            Dispatch.now(ctx(run, id, 1));
          };
          // Browsers with MessageChannel, includes WebWorkers
        } else if (MessageChannel) {
          channel = new MessageChannel();
          port = channel.port2;
          channel.port1.onmessage = listener;
          defer = ctx(port.postMessage, port, 1);
          // Browsers with postMessage, skip WebWorkers
          // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
        } else if (
          global.addEventListener &&
          typeof postMessage == "function" &&
          !global.importScripts
        ) {
          defer = function (id) {
            global.postMessage(id + "", "*");
          };
          global.addEventListener("message", listener, false);
          // IE8-
        } else if (ONREADYSTATECHANGE in cel("script")) {
          defer = function (id) {
            html.appendChild(cel("script"))[ONREADYSTATECHANGE] = function () {
              html.removeChild(this);
              run.call(id);
            };
          };
          // Rest old browsers
        } else {
          defer = function (id) {
            setTimeout(ctx(run, id, 1), 0);
          };
        }
      }
      module.exports = {
        set: setTask,
        clear: clearTask,
      };

      /***/
    },
    /* 101 */
    /***/ function (module, exports, __webpack_require__) {
      var global = __webpack_require__(3);
      var macrotask = __webpack_require__(100).set;
      var Observer = global.MutationObserver || global.WebKitMutationObserver;
      var process = global.process;
      var Promise = global.Promise;
      var isNode = __webpack_require__(22)(process) == "process";

      module.exports = function () {
        var head, last, notify;

        var flush = function () {
          var parent, fn;
          if (isNode && (parent = process.domain)) parent.exit();
          while (head) {
            fn = head.fn;
            head = head.next;
            try {
              fn();
            } catch (e) {
              if (head) notify();
              else last = undefined;
              throw e;
            }
          }
          last = undefined;
          if (parent) parent.enter();
        };

        // Node.js
        if (isNode) {
          notify = function () {
            process.nextTick(flush);
          };
          // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
        } else if (
          Observer &&
          !(global.navigator && global.navigator.standalone)
        ) {
          var toggle = true;
          var node = document.createTextNode("");
          new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
          notify = function () {
            node.data = toggle = !toggle;
          };
          // environments with maybe non-completely correct, but existent Promise
        } else if (Promise && Promise.resolve) {
          // Promise.resolve without an argument throws an error in LG WebOS 2
          var promise = Promise.resolve(undefined);
          notify = function () {
            promise.then(flush);
          };
          // for other environments - macrotask based on:
          // - setImmediate
          // - MessageChannel
          // - window.postMessag
          // - onreadystatechange
          // - setTimeout
        } else {
          notify = function () {
            // strange IE + webpack dev server bug - use .call(global)
            macrotask.call(global, flush);
          };
        }

        return function (fn) {
          var task = { fn: fn, next: undefined };
          if (last) last.next = task;
          if (!head) {
            head = task;
            notify();
          }
          last = task;
        };
      };

      /***/
    },
    /* 102 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // 25.4.1.5 NewPromiseCapability(C)
      var aFunction = __webpack_require__(13);

      function PromiseCapability(C) {
        var resolve, reject;
        this.promise = new C(function ($$resolve, $$reject) {
          if (resolve !== undefined || reject !== undefined)
            throw TypeError("Bad Promise constructor");
          resolve = $$resolve;
          reject = $$reject;
        });
        this.resolve = aFunction(resolve);
        this.reject = aFunction(reject);
      }

      module.exports.f = function (C) {
        return new PromiseCapability(C);
      };

      /***/
    },
    /* 103 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var global = __webpack_require__(3);
      var DESCRIPTORS = __webpack_require__(9);
      var LIBRARY = __webpack_require__(38);
      var $typed = __webpack_require__(74);
      var hide = __webpack_require__(16);
      var redefineAll = __webpack_require__(50);
      var fails = __webpack_require__(5);
      var anInstance = __webpack_require__(49);
      var toInteger = __webpack_require__(26);
      var toLength = __webpack_require__(10);
      var toIndex = __webpack_require__(133);
      var gOPN = __webpack_require__(44).f;
      var dP = __webpack_require__(8).f;
      var arrayFill = __webpack_require__(99);
      var setToStringTag = __webpack_require__(51);
      var ARRAY_BUFFER = "ArrayBuffer";
      var DATA_VIEW = "DataView";
      var PROTOTYPE = "prototype";
      var WRONG_LENGTH = "Wrong length!";
      var WRONG_INDEX = "Wrong index!";
      var $ArrayBuffer = global[ARRAY_BUFFER];
      var $DataView = global[DATA_VIEW];
      var Math = global.Math;
      var RangeError = global.RangeError;
      // eslint-disable-next-line no-shadow-restricted-names
      var Infinity = global.Infinity;
      var BaseBuffer = $ArrayBuffer;
      var abs = Math.abs;
      var pow = Math.pow;
      var floor = Math.floor;
      var log = Math.log;
      var LN2 = Math.LN2;
      var BUFFER = "buffer";
      var BYTE_LENGTH = "byteLength";
      var BYTE_OFFSET = "byteOffset";
      var $BUFFER = DESCRIPTORS ? "_b" : BUFFER;
      var $LENGTH = DESCRIPTORS ? "_l" : BYTE_LENGTH;
      var $OFFSET = DESCRIPTORS ? "_o" : BYTE_OFFSET;

      // IEEE754 conversions based on https://github.com/feross/ieee754
      function packIEEE754(value, mLen, nBytes) {
        var buffer = new Array(nBytes);
        var eLen = nBytes * 8 - mLen - 1;
        var eMax = (1 << eLen) - 1;
        var eBias = eMax >> 1;
        var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
        var i = 0;
        var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;
        var e, m, c;
        value = abs(value);
        // eslint-disable-next-line no-self-compare
        if (value != value || value === Infinity) {
          // eslint-disable-next-line no-self-compare
          m = value != value ? 1 : 0;
          e = eMax;
        } else {
          e = floor(log(value) / LN2);
          if (value * (c = pow(2, -e)) < 1) {
            e--;
            c *= 2;
          }
          if (e + eBias >= 1) {
            value += rt / c;
          } else {
            value += rt * pow(2, 1 - eBias);
          }
          if (value * c >= 2) {
            e++;
            c /= 2;
          }
          if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
          } else if (e + eBias >= 1) {
            m = (value * c - 1) * pow(2, mLen);
            e = e + eBias;
          } else {
            m = value * pow(2, eBias - 1) * pow(2, mLen);
            e = 0;
          }
        }
        for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
        e = (e << mLen) | m;
        eLen += mLen;
        for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
        buffer[--i] |= s * 128;
        return buffer;
      }
      function unpackIEEE754(buffer, mLen, nBytes) {
        var eLen = nBytes * 8 - mLen - 1;
        var eMax = (1 << eLen) - 1;
        var eBias = eMax >> 1;
        var nBits = eLen - 7;
        var i = nBytes - 1;
        var s = buffer[i--];
        var e = s & 127;
        var m;
        s >>= 7;
        for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
        m = e & ((1 << -nBits) - 1);
        e >>= -nBits;
        nBits += mLen;
        for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
        if (e === 0) {
          e = 1 - eBias;
        } else if (e === eMax) {
          return m ? NaN : s ? -Infinity : Infinity;
        } else {
          m = m + pow(2, mLen);
          e = e - eBias;
        }
        return (s ? -1 : 1) * m * pow(2, e - mLen);
      }

      function unpackI32(bytes) {
        return (bytes[3] << 24) | (bytes[2] << 16) | (bytes[1] << 8) | bytes[0];
      }
      function packI8(it) {
        return [it & 0xff];
      }
      function packI16(it) {
        return [it & 0xff, (it >> 8) & 0xff];
      }
      function packI32(it) {
        return [
          it & 0xff,
          (it >> 8) & 0xff,
          (it >> 16) & 0xff,
          (it >> 24) & 0xff,
        ];
      }
      function packF64(it) {
        return packIEEE754(it, 52, 8);
      }
      function packF32(it) {
        return packIEEE754(it, 23, 4);
      }

      function addGetter(C, key, internal) {
        dP(C[PROTOTYPE], key, {
          get: function () {
            return this[internal];
          },
        });
      }

      function get(view, bytes, index, isLittleEndian) {
        var numIndex = +index;
        var intIndex = toIndex(numIndex);
        if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
        var store = view[$BUFFER]._b;
        var start = intIndex + view[$OFFSET];
        var pack = store.slice(start, start + bytes);
        return isLittleEndian ? pack : pack.reverse();
      }
      function set(view, bytes, index, conversion, value, isLittleEndian) {
        var numIndex = +index;
        var intIndex = toIndex(numIndex);
        if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
        var store = view[$BUFFER]._b;
        var start = intIndex + view[$OFFSET];
        var pack = conversion(+value);
        for (var i = 0; i < bytes; i++)
          store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
      }

      if (!$typed.ABV) {
        $ArrayBuffer = function ArrayBuffer(length) {
          anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
          var byteLength = toIndex(length);
          this._b = arrayFill.call(new Array(byteLength), 0);
          this[$LENGTH] = byteLength;
        };

        $DataView = function DataView(buffer, byteOffset, byteLength) {
          anInstance(this, $DataView, DATA_VIEW);
          anInstance(buffer, $ArrayBuffer, DATA_VIEW);
          var bufferLength = buffer[$LENGTH];
          var offset = toInteger(byteOffset);
          if (offset < 0 || offset > bufferLength)
            throw RangeError("Wrong offset!");
          byteLength =
            byteLength === undefined
              ? bufferLength - offset
              : toLength(byteLength);
          if (offset + byteLength > bufferLength)
            throw RangeError(WRONG_LENGTH);
          this[$BUFFER] = buffer;
          this[$OFFSET] = offset;
          this[$LENGTH] = byteLength;
        };

        if (DESCRIPTORS) {
          addGetter($ArrayBuffer, BYTE_LENGTH, "_l");
          addGetter($DataView, BUFFER, "_b");
          addGetter($DataView, BYTE_LENGTH, "_l");
          addGetter($DataView, BYTE_OFFSET, "_o");
        }

        redefineAll($DataView[PROTOTYPE], {
          getInt8: function getInt8(byteOffset) {
            return (get(this, 1, byteOffset)[0] << 24) >> 24;
          },
          getUint8: function getUint8(byteOffset) {
            return get(this, 1, byteOffset)[0];
          },
          getInt16: function getInt16(byteOffset /* , littleEndian */) {
            var bytes = get(this, 2, byteOffset, arguments[1]);
            return (((bytes[1] << 8) | bytes[0]) << 16) >> 16;
          },
          getUint16: function getUint16(byteOffset /* , littleEndian */) {
            var bytes = get(this, 2, byteOffset, arguments[1]);
            return (bytes[1] << 8) | bytes[0];
          },
          getInt32: function getInt32(byteOffset /* , littleEndian */) {
            return unpackI32(get(this, 4, byteOffset, arguments[1]));
          },
          getUint32: function getUint32(byteOffset /* , littleEndian */) {
            return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
          },
          getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
            return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
          },
          getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
            return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
          },
          setInt8: function setInt8(byteOffset, value) {
            set(this, 1, byteOffset, packI8, value);
          },
          setUint8: function setUint8(byteOffset, value) {
            set(this, 1, byteOffset, packI8, value);
          },
          setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
            set(this, 2, byteOffset, packI16, value, arguments[2]);
          },
          setUint16: function setUint16(
            byteOffset,
            value /* , littleEndian */
          ) {
            set(this, 2, byteOffset, packI16, value, arguments[2]);
          },
          setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
            set(this, 4, byteOffset, packI32, value, arguments[2]);
          },
          setUint32: function setUint32(
            byteOffset,
            value /* , littleEndian */
          ) {
            set(this, 4, byteOffset, packI32, value, arguments[2]);
          },
          setFloat32: function setFloat32(
            byteOffset,
            value /* , littleEndian */
          ) {
            set(this, 4, byteOffset, packF32, value, arguments[2]);
          },
          setFloat64: function setFloat64(
            byteOffset,
            value /* , littleEndian */
          ) {
            set(this, 8, byteOffset, packF64, value, arguments[2]);
          },
        });
      } else {
        if (
          !fails(function () {
            $ArrayBuffer(1);
          }) ||
          !fails(function () {
            new $ArrayBuffer(-1); // eslint-disable-line no-new
          }) ||
          fails(function () {
            new $ArrayBuffer(); // eslint-disable-line no-new
            new $ArrayBuffer(1.5); // eslint-disable-line no-new
            new $ArrayBuffer(NaN); // eslint-disable-line no-new
            return $ArrayBuffer.name != ARRAY_BUFFER;
          })
        ) {
          $ArrayBuffer = function ArrayBuffer(length) {
            anInstance(this, $ArrayBuffer);
            return new BaseBuffer(toIndex(length));
          };
          var ArrayBufferProto = ($ArrayBuffer[PROTOTYPE] =
            BaseBuffer[PROTOTYPE]);
          for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ) {
            if (!((key = keys[j++]) in $ArrayBuffer))
              hide($ArrayBuffer, key, BaseBuffer[key]);
          }
          if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
        }
        // iOS Safari 7.x bug
        var view = new $DataView(new $ArrayBuffer(2));
        var $setInt8 = $DataView[PROTOTYPE].setInt8;
        view.setInt8(0, 2147483648);
        view.setInt8(1, 2147483649);
        if (view.getInt8(0) || !view.getInt8(1))
          redefineAll(
            $DataView[PROTOTYPE],
            {
              setInt8: function setInt8(byteOffset, value) {
                $setInt8.call(this, byteOffset, (value << 24) >> 24);
              },
              setUint8: function setUint8(byteOffset, value) {
                $setInt8.call(this, byteOffset, (value << 24) >> 24);
              },
            },
            true
          );
      }
      setToStringTag($ArrayBuffer, ARRAY_BUFFER);
      setToStringTag($DataView, DATA_VIEW);
      hide($DataView[PROTOTYPE], $typed.VIEW, true);
      exports[ARRAY_BUFFER] = $ArrayBuffer;
      exports[DATA_VIEW] = $DataView;

      /***/
    },
    /* 104 */
    /***/ function (module, exports, __webpack_require__) {
      // all object keys, includes non-enumerable and symbols
      var gOPN = __webpack_require__(44);
      var gOPS = __webpack_require__(62);
      var anObject = __webpack_require__(2);
      var Reflect = __webpack_require__(3).Reflect;
      module.exports =
        (Reflect && Reflect.ownKeys) ||
        function ownKeys(it) {
          var keys = gOPN.f(anObject(it));
          var getSymbols = gOPS.f;
          return getSymbols ? keys.concat(getSymbols(it)) : keys;
        };

      /***/
    },
    /* 105 */
    /***/ function (module, exports) {
      module.exports = function (regExp, replace) {
        var replacer =
          replace === Object(replace)
            ? function (part) {
                return replace[part];
              }
            : replace;
        return function (it) {
          return String(it).replace(regExp, replacer);
        };
      };

      /***/
    },
    /* 106 */
    /***/ function (module, exports) {
      /**
       * Copyright 2016 Google Inc. All Rights Reserved.
       *
       * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
       *
       *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
       *
       */

      (function (window, document) {
        "use strict";

        // Exits early if all IntersectionObserver and IntersectionObserverEntry
        // features are natively supported.
        if (
          "IntersectionObserver" in window &&
          "IntersectionObserverEntry" in window &&
          "intersectionRatio" in window.IntersectionObserverEntry.prototype
        ) {
          // Minimal polyfill for Edge 15's lack of `isIntersecting`
          // See: https://github.com/w3c/IntersectionObserver/issues/211
          if (
            !("isIntersecting" in window.IntersectionObserverEntry.prototype)
          ) {
            Object.defineProperty(
              window.IntersectionObserverEntry.prototype,
              "isIntersecting",
              {
                get: function () {
                  return this.intersectionRatio > 0;
                },
              }
            );
          }
          return;
        }

        /**
         * An IntersectionObserver registry. This registry exists to hold a strong
         * reference to IntersectionObserver instances currently observing a target
         * element. Without this registry, instances without another reference may be
         * garbage collected.
         */
        var registry = [];

        /**
         * Creates the global IntersectionObserverEntry constructor.
         * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
         * @param {Object} entry A dictionary of instance properties.
         * @constructor
         */
        function IntersectionObserverEntry(entry) {
          this.time = entry.time;
          this.target = entry.target;
          this.rootBounds = entry.rootBounds;
          this.boundingClientRect = entry.boundingClientRect;
          this.intersectionRect = entry.intersectionRect || getEmptyRect();
          this.isIntersecting = !!entry.intersectionRect;

          // Calculates the intersection ratio.
          var targetRect = this.boundingClientRect;
          var targetArea = targetRect.width * targetRect.height;
          var intersectionRect = this.intersectionRect;
          var intersectionArea =
            intersectionRect.width * intersectionRect.height;

          // Sets intersection ratio.
          if (targetArea) {
            // Round the intersection ratio to avoid floating point math issues:
            // https://github.com/w3c/IntersectionObserver/issues/324
            this.intersectionRatio = Number(
              (intersectionArea / targetArea).toFixed(4)
            );
          } else {
            // If area is zero and is intersecting, sets to 1, otherwise to 0
            this.intersectionRatio = this.isIntersecting ? 1 : 0;
          }
        }

        /**
         * Creates the global IntersectionObserver constructor.
         * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
         * @param {Function} callback The function to be invoked after intersection
         *     changes have queued. The function is not invoked if the queue has
         *     been emptied by calling the `takeRecords` method.
         * @param {Object=} opt_options Optional configuration options.
         * @constructor
         */
        function IntersectionObserver(callback, opt_options) {
          var options = opt_options || {};

          if (typeof callback != "function") {
            throw new Error("callback must be a function");
          }

          if (options.root && options.root.nodeType != 1) {
            throw new Error("root must be an Element");
          }

          // Binds and throttles `this._checkForIntersections`.
          this._checkForIntersections = throttle(
            this._checkForIntersections.bind(this),
            this.THROTTLE_TIMEOUT
          );

          // Private properties.
          this._callback = callback;
          this._observationTargets = [];
          this._queuedEntries = [];
          this._rootMarginValues = this._parseRootMargin(options.rootMargin);

          // Public properties.
          this.thresholds = this._initThresholds(options.threshold);
          this.root = options.root || null;
          this.rootMargin = this._rootMarginValues
            .map(function (margin) {
              return margin.value + margin.unit;
            })
            .join(" ");
        }

        /**
         * The minimum interval within which the document will be checked for
         * intersection changes.
         */
        IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;

        /**
         * The frequency in which the polyfill polls for intersection changes.
         * this can be updated on a per instance basis and must be set prior to
         * calling `observe` on the first target.
         */
        IntersectionObserver.prototype.POLL_INTERVAL = null;

        /**
         * Use a mutation observer on the root element
         * to detect intersection changes.
         */
        IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;

        /**
         * Starts observing a target element for intersection changes based on
         * the thresholds values.
         * @param {Element} target The DOM element to observe.
         */
        IntersectionObserver.prototype.observe = function (target) {
          var isTargetAlreadyObserved = this._observationTargets.some(function (
            item
          ) {
            return item.element == target;
          });

          if (isTargetAlreadyObserved) {
            return;
          }

          if (!(target && target.nodeType == 1)) {
            throw new Error("target must be an Element");
          }

          this._registerInstance();
          this._observationTargets.push({ element: target, entry: null });
          this._monitorIntersections();
          this._checkForIntersections();
        };

        /**
         * Stops observing a target element for intersection changes.
         * @param {Element} target The DOM element to observe.
         */
        IntersectionObserver.prototype.unobserve = function (target) {
          this._observationTargets = this._observationTargets.filter(function (
            item
          ) {
            return item.element != target;
          });
          if (!this._observationTargets.length) {
            this._unmonitorIntersections();
            this._unregisterInstance();
          }
        };

        /**
         * Stops observing all target elements for intersection changes.
         */
        IntersectionObserver.prototype.disconnect = function () {
          this._observationTargets = [];
          this._unmonitorIntersections();
          this._unregisterInstance();
        };

        /**
         * Returns any queue entries that have not yet been reported to the
         * callback and clears the queue. This can be used in conjunction with the
         * callback to obtain the absolute most up-to-date intersection information.
         * @return {Array} The currently queued entries.
         */
        IntersectionObserver.prototype.takeRecords = function () {
          var records = this._queuedEntries.slice();
          this._queuedEntries = [];
          return records;
        };

        /**
         * Accepts the threshold value from the user configuration object and
         * returns a sorted array of unique threshold values. If a value is not
         * between 0 and 1 and error is thrown.
         * @private
         * @param {Array|number=} opt_threshold An optional threshold value or
         *     a list of threshold values, defaulting to [0].
         * @return {Array} A sorted list of unique and valid threshold values.
         */
        IntersectionObserver.prototype._initThresholds = function (
          opt_threshold
        ) {
          var threshold = opt_threshold || [0];
          if (!Array.isArray(threshold)) threshold = [threshold];

          return threshold.sort().filter(function (t, i, a) {
            if (typeof t != "number" || isNaN(t) || t < 0 || t > 1) {
              throw new Error(
                "threshold must be a number between 0 and 1 inclusively"
              );
            }
            return t !== a[i - 1];
          });
        };

        /**
         * Accepts the rootMargin value from the user configuration object
         * and returns an array of the four margin values as an object containing
         * the value and unit properties. If any of the values are not properly
         * formatted or use a unit other than px or %, and error is thrown.
         * @private
         * @param {string=} opt_rootMargin An optional rootMargin value,
         *     defaulting to '0px'.
         * @return {Array<Object>} An array of margin objects with the keys
         *     value and unit.
         */
        IntersectionObserver.prototype._parseRootMargin = function (
          opt_rootMargin
        ) {
          var marginString = opt_rootMargin || "0px";
          var margins = marginString.split(/\s+/).map(function (margin) {
            var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
            if (!parts) {
              throw new Error(
                "rootMargin must be specified in pixels or percent"
              );
            }
            return { value: parseFloat(parts[1]), unit: parts[2] };
          });

          // Handles shorthand.
          margins[1] = margins[1] || margins[0];
          margins[2] = margins[2] || margins[0];
          margins[3] = margins[3] || margins[1];

          return margins;
        };

        /**
         * Starts polling for intersection changes if the polling is not already
         * happening, and if the page's visibility state is visible.
         * @private
         */
        IntersectionObserver.prototype._monitorIntersections = function () {
          if (!this._monitoringIntersections) {
            this._monitoringIntersections = true;

            // If a poll interval is set, use polling instead of listening to
            // resize and scroll events or DOM mutations.
            if (this.POLL_INTERVAL) {
              this._monitoringInterval = setInterval(
                this._checkForIntersections,
                this.POLL_INTERVAL
              );
            } else {
              addEvent(window, "resize", this._checkForIntersections, true);
              addEvent(document, "scroll", this._checkForIntersections, true);

              if (this.USE_MUTATION_OBSERVER && "MutationObserver" in window) {
                this._domObserver = new MutationObserver(
                  this._checkForIntersections
                );
                this._domObserver.observe(document, {
                  attributes: true,
                  childList: true,
                  characterData: true,
                  subtree: true,
                });
              }
            }
          }
        };

        /**
         * Stops polling for intersection changes.
         * @private
         */
        IntersectionObserver.prototype._unmonitorIntersections = function () {
          if (this._monitoringIntersections) {
            this._monitoringIntersections = false;

            clearInterval(this._monitoringInterval);
            this._monitoringInterval = null;

            removeEvent(window, "resize", this._checkForIntersections, true);
            removeEvent(document, "scroll", this._checkForIntersections, true);

            if (this._domObserver) {
              this._domObserver.disconnect();
              this._domObserver = null;
            }
          }
        };

        /**
         * Scans each observation target for intersection changes and adds them
         * to the internal entries queue. If new entries are found, it
         * schedules the callback to be invoked.
         * @private
         */
        IntersectionObserver.prototype._checkForIntersections = function () {
          var rootIsInDom = this._rootIsInDom();
          var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

          this._observationTargets.forEach(function (item) {
            var target = item.element;
            var targetRect = getBoundingClientRect(target);
            var rootContainsTarget = this._rootContainsTarget(target);
            var oldEntry = item.entry;
            var intersectionRect =
              rootIsInDom &&
              rootContainsTarget &&
              this._computeTargetAndRootIntersection(target, rootRect);

            var newEntry = (item.entry = new IntersectionObserverEntry({
              time: now(),
              target: target,
              boundingClientRect: targetRect,
              rootBounds: rootRect,
              intersectionRect: intersectionRect,
            }));

            if (!oldEntry) {
              this._queuedEntries.push(newEntry);
            } else if (rootIsInDom && rootContainsTarget) {
              // If the new entry intersection ratio has crossed any of the
              // thresholds, add a new entry.
              if (this._hasCrossedThreshold(oldEntry, newEntry)) {
                this._queuedEntries.push(newEntry);
              }
            } else {
              // If the root is not in the DOM or target is not contained within
              // root but the previous entry for this target had an intersection,
              // add a new record indicating removal.
              if (oldEntry && oldEntry.isIntersecting) {
                this._queuedEntries.push(newEntry);
              }
            }
          }, this);

          if (this._queuedEntries.length) {
            this._callback(this.takeRecords(), this);
          }
        };

        /**
         * Accepts a target and root rect computes the intersection between then
         * following the algorithm in the spec.
         * TODO(philipwalton): at this time clip-path is not considered.
         * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
         * @param {Element} target The target DOM element
         * @param {Object} rootRect The bounding rect of the root after being
         *     expanded by the rootMargin value.
         * @return {?Object} The final intersection rect object or undefined if no
         *     intersection is found.
         * @private
         */
        IntersectionObserver.prototype._computeTargetAndRootIntersection =
          function (target, rootRect) {
            // If the element isn't displayed, an intersection can't happen.
            if (window.getComputedStyle(target).display == "none") return;

            var targetRect = getBoundingClientRect(target);
            var intersectionRect = targetRect;
            var parent = getParentNode(target);
            var atRoot = false;

            while (!atRoot) {
              var parentRect = null;
              var parentComputedStyle =
                parent.nodeType == 1 ? window.getComputedStyle(parent) : {};

              // If the parent isn't displayed, an intersection can't happen.
              if (parentComputedStyle.display == "none") return;

              if (parent == this.root || parent == document) {
                atRoot = true;
                parentRect = rootRect;
              } else {
                // If the element has a non-visible overflow, and it's not the <body>
                // or <html> element, update the intersection rect.
                // Note: <body> and <html> cannot be clipped to a rect that's not also
                // the document rect, so no need to compute a new intersection.
                if (
                  parent != document.body &&
                  parent != document.documentElement &&
                  parentComputedStyle.overflow != "visible"
                ) {
                  parentRect = getBoundingClientRect(parent);
                }
              }

              // If either of the above conditionals set a new parentRect,
              // calculate new intersection data.
              if (parentRect) {
                intersectionRect = computeRectIntersection(
                  parentRect,
                  intersectionRect
                );

                if (!intersectionRect) break;
              }
              parent = getParentNode(parent);
            }
            return intersectionRect;
          };

        /**
         * Returns the root rect after being expanded by the rootMargin value.
         * @return {Object} The expanded root rect.
         * @private
         */
        IntersectionObserver.prototype._getRootRect = function () {
          var rootRect;
          if (this.root) {
            rootRect = getBoundingClientRect(this.root);
          } else {
            // Use <html>/<body> instead of window since scroll bars affect size.
            var html = document.documentElement;
            var body = document.body;
            rootRect = {
              top: 0,
              left: 0,
              right: html.clientWidth || body.clientWidth,
              width: html.clientWidth || body.clientWidth,
              bottom: html.clientHeight || body.clientHeight,
              height: html.clientHeight || body.clientHeight,
            };
          }
          return this._expandRectByRootMargin(rootRect);
        };

        /**
         * Accepts a rect and expands it by the rootMargin value.
         * @param {Object} rect The rect object to expand.
         * @return {Object} The expanded rect.
         * @private
         */
        IntersectionObserver.prototype._expandRectByRootMargin = function (
          rect
        ) {
          var margins = this._rootMarginValues.map(function (margin, i) {
            return margin.unit == "px"
              ? margin.value
              : (margin.value * (i % 2 ? rect.width : rect.height)) / 100;
          });
          var newRect = {
            top: rect.top - margins[0],
            right: rect.right + margins[1],
            bottom: rect.bottom + margins[2],
            left: rect.left - margins[3],
          };
          newRect.width = newRect.right - newRect.left;
          newRect.height = newRect.bottom - newRect.top;

          return newRect;
        };

        /**
         * Accepts an old and new entry and returns true if at least one of the
         * threshold values has been crossed.
         * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
         *    particular target element or null if no previous entry exists.
         * @param {IntersectionObserverEntry} newEntry The current entry for a
         *    particular target element.
         * @return {boolean} Returns true if a any threshold has been crossed.
         * @private
         */
        IntersectionObserver.prototype._hasCrossedThreshold = function (
          oldEntry,
          newEntry
        ) {
          // To make comparing easier, an entry that has a ratio of 0
          // but does not actually intersect is given a value of -1
          var oldRatio =
            oldEntry && oldEntry.isIntersecting
              ? oldEntry.intersectionRatio || 0
              : -1;
          var newRatio = newEntry.isIntersecting
            ? newEntry.intersectionRatio || 0
            : -1;

          // Ignore unchanged ratios
          if (oldRatio === newRatio) return;

          for (var i = 0; i < this.thresholds.length; i++) {
            var threshold = this.thresholds[i];

            // Return true if an entry matches a threshold or if the new ratio
            // and the old ratio are on the opposite sides of a threshold.
            if (
              threshold == oldRatio ||
              threshold == newRatio ||
              threshold < oldRatio !== threshold < newRatio
            ) {
              return true;
            }
          }
        };

        /**
         * Returns whether or not the root element is an element and is in the DOM.
         * @return {boolean} True if the root element is an element and is in the DOM.
         * @private
         */
        IntersectionObserver.prototype._rootIsInDom = function () {
          return !this.root || containsDeep(document, this.root);
        };

        /**
         * Returns whether or not the target element is a child of root.
         * @param {Element} target The target element to check.
         * @return {boolean} True if the target element is a child of root.
         * @private
         */
        IntersectionObserver.prototype._rootContainsTarget = function (target) {
          return containsDeep(this.root || document, target);
        };

        /**
         * Adds the instance to the global IntersectionObserver registry if it isn't
         * already present.
         * @private
         */
        IntersectionObserver.prototype._registerInstance = function () {
          if (registry.indexOf(this) < 0) {
            registry.push(this);
          }
        };

        /**
         * Removes the instance from the global IntersectionObserver registry.
         * @private
         */
        IntersectionObserver.prototype._unregisterInstance = function () {
          var index = registry.indexOf(this);
          if (index != -1) registry.splice(index, 1);
        };

        /**
         * Returns the result of the performance.now() method or null in browsers
         * that don't support the API.
         * @return {number} The elapsed time since the page was requested.
         */
        function now() {
          return window.performance && performance.now && performance.now();
        }

        /**
         * Throttles a function and delays its execution, so it's only called at most
         * once within a given time period.
         * @param {Function} fn The function to throttle.
         * @param {number} timeout The amount of time that must pass before the
         *     function can be called again.
         * @return {Function} The throttled function.
         */
        function throttle(fn, timeout) {
          var timer = null;
          return function () {
            if (!timer) {
              timer = setTimeout(function () {
                fn();
                timer = null;
              }, timeout);
            }
          };
        }

        /**
         * Adds an event handler to a DOM node ensuring cross-browser compatibility.
         * @param {Node} node The DOM node to add the event handler to.
         * @param {string} event The event name.
         * @param {Function} fn The event handler to add.
         * @param {boolean} opt_useCapture Optionally adds the even to the capture
         *     phase. Note: this only works in modern browsers.
         */
        function addEvent(node, event, fn, opt_useCapture) {
          if (typeof node.addEventListener == "function") {
            node.addEventListener(event, fn, opt_useCapture || false);
          } else if (typeof node.attachEvent == "function") {
            node.attachEvent("on" + event, fn);
          }
        }

        /**
         * Removes a previously added event handler from a DOM node.
         * @param {Node} node The DOM node to remove the event handler from.
         * @param {string} event The event name.
         * @param {Function} fn The event handler to remove.
         * @param {boolean} opt_useCapture If the event handler was added with this
         *     flag set to true, it should be set to true here in order to remove it.
         */
        function removeEvent(node, event, fn, opt_useCapture) {
          if (typeof node.removeEventListener == "function") {
            node.removeEventListener(event, fn, opt_useCapture || false);
          } else if (typeof node.detatchEvent == "function") {
            node.detatchEvent("on" + event, fn);
          }
        }

        /**
         * Returns the intersection between two rect objects.
         * @param {Object} rect1 The first rect.
         * @param {Object} rect2 The second rect.
         * @return {?Object} The intersection rect or undefined if no intersection
         *     is found.
         */
        function computeRectIntersection(rect1, rect2) {
          var top = Math.max(rect1.top, rect2.top);
          var bottom = Math.min(rect1.bottom, rect2.bottom);
          var left = Math.max(rect1.left, rect2.left);
          var right = Math.min(rect1.right, rect2.right);
          var width = right - left;
          var height = bottom - top;

          return (
            width >= 0 &&
            height >= 0 && {
              top: top,
              bottom: bottom,
              left: left,
              right: right,
              width: width,
              height: height,
            }
          );
        }

        /**
         * Shims the native getBoundingClientRect for compatibility with older IE.
         * @param {Element} el The element whose bounding rect to get.
         * @return {Object} The (possibly shimmed) rect of the element.
         */
        function getBoundingClientRect(el) {
          var rect;

          try {
            rect = el.getBoundingClientRect();
          } catch (err) {
            // Ignore Windows 7 IE11 "Unspecified error"
            // https://github.com/w3c/IntersectionObserver/pull/205
          }

          if (!rect) return getEmptyRect();

          // Older IE
          if (!(rect.width && rect.height)) {
            rect = {
              top: rect.top,
              right: rect.right,
              bottom: rect.bottom,
              left: rect.left,
              width: rect.right - rect.left,
              height: rect.bottom - rect.top,
            };
          }
          return rect;
        }

        /**
         * Returns an empty rect object. An empty rect is returned when an element
         * is not in the DOM.
         * @return {Object} The empty rect.
         */
        function getEmptyRect() {
          return {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            width: 0,
            height: 0,
          };
        }

        /**
         * Checks to see if a parent element contains a child element (including inside
         * shadow DOM).
         * @param {Node} parent The parent element.
         * @param {Node} child The child element.
         * @return {boolean} True if the parent node contains the child node.
         */
        function containsDeep(parent, child) {
          var node = child;
          while (node) {
            if (node == parent) return true;

            node = getParentNode(node);
          }
          return false;
        }

        /**
         * Gets the parent node of an element or its host element if the parent node
         * is a shadow root.
         * @param {Node} node The node whose parent to get.
         * @return {Node|null} The parent node or null if no parent exists.
         */
        function getParentNode(node) {
          var parent = node.parentNode;

          if (parent && parent.nodeType == 11 && parent.host) {
            // If the parent is a shadow root, return the host element.
            return parent.host;
          }
          return parent;
        }

        // Exposes the constructors globally.
        window.IntersectionObserver = IntersectionObserver;
        window.IntersectionObserverEntry = IntersectionObserverEntry;
      })(window, document);

      /***/
    },
    /* 107 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // ECMAScript 6 symbols shim
      var global = __webpack_require__(3);
      var has = __webpack_require__(15);
      var DESCRIPTORS = __webpack_require__(9);
      var $export = __webpack_require__(1);
      var redefine = __webpack_require__(17);
      var META = __webpack_require__(37).KEY;
      var $fails = __webpack_require__(5);
      var shared = __webpack_require__(60);
      var setToStringTag = __webpack_require__(51);
      var uid = __webpack_require__(42);
      var wks = __webpack_require__(6);
      var wksExt = __webpack_require__(109);
      var wksDefine = __webpack_require__(79);
      var enumKeys = __webpack_require__(149);
      var isArray = __webpack_require__(63);
      var anObject = __webpack_require__(2);
      var isObject = __webpack_require__(4);
      var toIObject = __webpack_require__(14);
      var toPrimitive = __webpack_require__(24);
      var createDesc = __webpack_require__(36);
      var _create = __webpack_require__(31);
      var gOPNExt = __webpack_require__(112);
      var $GOPD = __webpack_require__(18);
      var $DP = __webpack_require__(8);
      var $keys = __webpack_require__(30);
      var gOPD = $GOPD.f;
      var dP = $DP.f;
      var gOPN = gOPNExt.f;
      var $Symbol = global.Symbol;
      var $JSON = global.JSON;
      var _stringify = $JSON && $JSON.stringify;
      var PROTOTYPE = "prototype";
      var HIDDEN = wks("_hidden");
      var TO_PRIMITIVE = wks("toPrimitive");
      var isEnum = {}.propertyIsEnumerable;
      var SymbolRegistry = shared("symbol-registry");
      var AllSymbols = shared("symbols");
      var OPSymbols = shared("op-symbols");
      var ObjectProto = Object[PROTOTYPE];
      var USE_NATIVE = typeof $Symbol == "function";
      var QObject = global.QObject;
      // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
      var setter =
        !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

      // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
      var setSymbolDesc =
        DESCRIPTORS &&
        $fails(function () {
          return (
            _create(
              dP({}, "a", {
                get: function () {
                  return dP(this, "a", { value: 7 }).a;
                },
              })
            ).a != 7
          );
        })
          ? function (it, key, D) {
              var protoDesc = gOPD(ObjectProto, key);
              if (protoDesc) delete ObjectProto[key];
              dP(it, key, D);
              if (protoDesc && it !== ObjectProto)
                dP(ObjectProto, key, protoDesc);
            }
          : dP;

      var wrap = function (tag) {
        var sym = (AllSymbols[tag] = _create($Symbol[PROTOTYPE]));
        sym._k = tag;
        return sym;
      };

      var isSymbol =
        USE_NATIVE && typeof $Symbol.iterator == "symbol"
          ? function (it) {
              return typeof it == "symbol";
            }
          : function (it) {
              return it instanceof $Symbol;
            };

      var $defineProperty = function defineProperty(it, key, D) {
        if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
        anObject(it);
        key = toPrimitive(key, true);
        anObject(D);
        if (has(AllSymbols, key)) {
          if (!D.enumerable) {
            if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
            it[HIDDEN][key] = true;
          } else {
            if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
            D = _create(D, { enumerable: createDesc(0, false) });
          }
          return setSymbolDesc(it, key, D);
        }
        return dP(it, key, D);
      };
      var $defineProperties = function defineProperties(it, P) {
        anObject(it);
        var keys = enumKeys((P = toIObject(P)));
        var i = 0;
        var l = keys.length;
        var key;
        while (l > i) $defineProperty(it, (key = keys[i++]), P[key]);
        return it;
      };
      var $create = function create(it, P) {
        return P === undefined
          ? _create(it)
          : $defineProperties(_create(it), P);
      };
      var $propertyIsEnumerable = function propertyIsEnumerable(key) {
        var E = isEnum.call(this, (key = toPrimitive(key, true)));
        if (
          this === ObjectProto &&
          has(AllSymbols, key) &&
          !has(OPSymbols, key)
        )
          return false;
        return E ||
          !has(this, key) ||
          !has(AllSymbols, key) ||
          (has(this, HIDDEN) && this[HIDDEN][key])
          ? E
          : true;
      };
      var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(
        it,
        key
      ) {
        it = toIObject(it);
        key = toPrimitive(key, true);
        if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))
          return;
        var D = gOPD(it, key);
        if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))
          D.enumerable = true;
        return D;
      };
      var $getOwnPropertyNames = function getOwnPropertyNames(it) {
        var names = gOPN(toIObject(it));
        var result = [];
        var i = 0;
        var key;
        while (names.length > i) {
          if (
            !has(AllSymbols, (key = names[i++])) &&
            key != HIDDEN &&
            key != META
          )
            result.push(key);
        }
        return result;
      };
      var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
        var IS_OP = it === ObjectProto;
        var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
        var result = [];
        var i = 0;
        var key;
        while (names.length > i) {
          if (
            has(AllSymbols, (key = names[i++])) &&
            (IS_OP ? has(ObjectProto, key) : true)
          )
            result.push(AllSymbols[key]);
        }
        return result;
      };

      // 19.4.1.1 Symbol([description])
      if (!USE_NATIVE) {
        $Symbol = function Symbol() {
          if (this instanceof $Symbol)
            throw TypeError("Symbol is not a constructor!");
          var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
          var $set = function (value) {
            if (this === ObjectProto) $set.call(OPSymbols, value);
            if (has(this, HIDDEN) && has(this[HIDDEN], tag))
              this[HIDDEN][tag] = false;
            setSymbolDesc(this, tag, createDesc(1, value));
          };
          if (DESCRIPTORS && setter)
            setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
          return wrap(tag);
        };
        redefine($Symbol[PROTOTYPE], "toString", function toString() {
          return this._k;
        });

        $GOPD.f = $getOwnPropertyDescriptor;
        $DP.f = $defineProperty;
        __webpack_require__(44).f = gOPNExt.f = $getOwnPropertyNames;
        __webpack_require__(56).f = $propertyIsEnumerable;
        __webpack_require__(62).f = $getOwnPropertySymbols;

        if (DESCRIPTORS && !__webpack_require__(38)) {
          redefine(
            ObjectProto,
            "propertyIsEnumerable",
            $propertyIsEnumerable,
            true
          );
        }

        wksExt.f = function (name) {
          return wrap(wks(name));
        };
      }

      $export($export.G + $export.W + $export.F * !USE_NATIVE, {
        Symbol: $Symbol,
      });

      for (
        var es6Symbols =
            // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
            "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(
              ","
            ),
          j = 0;
        es6Symbols.length > j;

      )
        wks(es6Symbols[j++]);

      for (
        var wellKnownSymbols = $keys(wks.store), k = 0;
        wellKnownSymbols.length > k;

      )
        wksDefine(wellKnownSymbols[k++]);

      $export($export.S + $export.F * !USE_NATIVE, "Symbol", {
        // 19.4.2.1 Symbol.for(key)
        for: function (key) {
          return has(SymbolRegistry, (key += ""))
            ? SymbolRegistry[key]
            : (SymbolRegistry[key] = $Symbol(key));
        },
        // 19.4.2.5 Symbol.keyFor(sym)
        keyFor: function keyFor(sym) {
          if (!isSymbol(sym)) throw TypeError(sym + " is not a symbol!");
          for (var key in SymbolRegistry)
            if (SymbolRegistry[key] === sym) return key;
        },
        useSetter: function () {
          setter = true;
        },
        useSimple: function () {
          setter = false;
        },
      });

      $export($export.S + $export.F * !USE_NATIVE, "Object", {
        // 19.1.2.2 Object.create(O [, Properties])
        create: $create,
        // 19.1.2.4 Object.defineProperty(O, P, Attributes)
        defineProperty: $defineProperty,
        // 19.1.2.3 Object.defineProperties(O, Properties)
        defineProperties: $defineProperties,
        // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
        getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
        // 19.1.2.7 Object.getOwnPropertyNames(O)
        getOwnPropertyNames: $getOwnPropertyNames,
        // 19.1.2.8 Object.getOwnPropertySymbols(O)
        getOwnPropertySymbols: $getOwnPropertySymbols,
      });

      // 24.3.2 JSON.stringify(value [, replacer [, space]])
      $JSON &&
        $export(
          $export.S +
            $export.F *
              (!USE_NATIVE ||
                $fails(function () {
                  var S = $Symbol();
                  // MS Edge converts symbol values to JSON as {}
                  // WebKit converts symbol values to JSON as null
                  // V8 throws on boxed symbols
                  return (
                    _stringify([S]) != "[null]" ||
                    _stringify({ a: S }) != "{}" ||
                    _stringify(Object(S)) != "{}"
                  );
                })),
          "JSON",
          {
            stringify: function stringify(it) {
              var args = [it];
              var i = 1;
              var replacer, $replacer;
              while (arguments.length > i) args.push(arguments[i++]);
              $replacer = replacer = args[1];
              if ((!isObject(replacer) && it === undefined) || isSymbol(it))
                return; // IE8 returns string on undefined
              if (!isArray(replacer))
                replacer = function (key, value) {
                  if (typeof $replacer == "function")
                    value = $replacer.call(this, key, value);
                  if (!isSymbol(value)) return value;
                };
              args[1] = replacer;
              return _stringify.apply($JSON, args);
            },
          }
        );

      // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
      $Symbol[PROTOTYPE][TO_PRIMITIVE] ||
        __webpack_require__(16)(
          $Symbol[PROTOTYPE],
          TO_PRIMITIVE,
          $Symbol[PROTOTYPE].valueOf
        );
      // 19.4.3.5 Symbol.prototype[@@toStringTag]
      setToStringTag($Symbol, "Symbol");
      // 20.2.1.9 Math[@@toStringTag]
      setToStringTag(Math, "Math", true);
      // 24.3.3 JSON[@@toStringTag]
      setToStringTag(global.JSON, "JSON", true);

      /***/
    },
    /* 108 */
    /***/ function (module, exports, __webpack_require__) {
      module.exports =
        !__webpack_require__(9) &&
        !__webpack_require__(5)(function () {
          return (
            Object.defineProperty(__webpack_require__(78)("div"), "a", {
              get: function () {
                return 7;
              },
            }).a != 7
          );
        });

      /***/
    },
    /* 109 */
    /***/ function (module, exports, __webpack_require__) {
      exports.f = __webpack_require__(6);

      /***/
    },
    /* 110 */
    /***/ function (module, exports, __webpack_require__) {
      var has = __webpack_require__(15);
      var toIObject = __webpack_require__(14);
      var arrayIndexOf = __webpack_require__(61)(false);
      var IE_PROTO = __webpack_require__(80)("IE_PROTO");

      module.exports = function (object, names) {
        var O = toIObject(object);
        var i = 0;
        var result = [];
        var key;
        for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
        // Don't enum bug & hidden keys
        while (names.length > i)
          if (has(O, (key = names[i++]))) {
            ~arrayIndexOf(result, key) || result.push(key);
          }
        return result;
      };

      /***/
    },
    /* 111 */
    /***/ function (module, exports, __webpack_require__) {
      var dP = __webpack_require__(8);
      var anObject = __webpack_require__(2);
      var getKeys = __webpack_require__(30);

      module.exports = __webpack_require__(9)
        ? Object.defineProperties
        : function defineProperties(O, Properties) {
            anObject(O);
            var keys = getKeys(Properties);
            var length = keys.length;
            var i = 0;
            var P;
            while (length > i) dP.f(O, (P = keys[i++]), Properties[P]);
            return O;
          };

      /***/
    },
    /* 112 */
    /***/ function (module, exports, __webpack_require__) {
      // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
      var toIObject = __webpack_require__(14);
      var gOPN = __webpack_require__(44).f;
      var toString = {}.toString;

      var windowNames =
        typeof window == "object" && window && Object.getOwnPropertyNames
          ? Object.getOwnPropertyNames(window)
          : [];

      var getWindowNames = function (it) {
        try {
          return gOPN(it);
        } catch (e) {
          return windowNames.slice();
        }
      };

      module.exports.f = function getOwnPropertyNames(it) {
        return windowNames && toString.call(it) == "[object Window]"
          ? getWindowNames(it)
          : gOPN(toIObject(it));
      };

      /***/
    },
    /* 113 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // 19.1.3.6 Object.prototype.toString()
      var classof = __webpack_require__(45);
      var test = {};
      test[__webpack_require__(6)("toStringTag")] = "z";
      if (test + "" != "[object z]") {
        __webpack_require__(17)(
          Object.prototype,
          "toString",
          function toString() {
            return "[object " + classof(this) + "]";
          },
          true
        );
      }

      /***/
    },
    /* 114 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.3.1 Object.assign(target, source)
      var $export = __webpack_require__(1);

      $export($export.S + $export.F, "Object", {
        assign: __webpack_require__(83),
      });

      /***/
    },
    /* 115 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var aFunction = __webpack_require__(13);
      var isObject = __webpack_require__(4);
      var invoke = __webpack_require__(87);
      var arraySlice = [].slice;
      var factories = {};

      var construct = function (F, len, args) {
        if (!(len in factories)) {
          for (var n = [], i = 0; i < len; i++) n[i] = "a[" + i + "]";
          // eslint-disable-next-line no-new-func
          factories[len] = Function("F,a", "return new F(" + n.join(",") + ")");
        }
        return factories[len](F, args);
      };

      module.exports =
        Function.bind ||
        function bind(that /* , ...args */) {
          var fn = aFunction(this);
          var partArgs = arraySlice.call(arguments, 1);
          var bound = function (/* args... */) {
            var args = partArgs.concat(arraySlice.call(arguments));
            return this instanceof bound
              ? construct(fn, args.length, args)
              : invoke(fn, args, that);
          };
          if (isObject(fn.prototype)) bound.prototype = fn.prototype;
          return bound;
        };

      /***/
    },
    /* 116 */
    /***/ function (module, exports, __webpack_require__) {
      var $parseInt = __webpack_require__(3).parseInt;
      var $trim = __webpack_require__(52).trim;
      var ws = __webpack_require__(88);
      var hex = /^[-+]?0[xX]/;

      module.exports =
        $parseInt(ws + "08") !== 8 || $parseInt(ws + "0x16") !== 22
          ? function parseInt(str, radix) {
              var string = $trim(String(str), 3);
              return $parseInt(
                string,
                radix >>> 0 || (hex.test(string) ? 16 : 10)
              );
            }
          : $parseInt;

      /***/
    },
    /* 117 */
    /***/ function (module, exports, __webpack_require__) {
      var $parseFloat = __webpack_require__(3).parseFloat;
      var $trim = __webpack_require__(52).trim;

      module.exports =
        1 / $parseFloat(__webpack_require__(88) + "-0") !== -Infinity
          ? function parseFloat(str) {
              var string = $trim(String(str), 3);
              var result = $parseFloat(string);
              return result === 0 && string.charAt(0) == "-" ? -0 : result;
            }
          : $parseFloat;

      /***/
    },
    /* 118 */
    /***/ function (module, exports, __webpack_require__) {
      var cof = __webpack_require__(22);
      module.exports = function (it, msg) {
        if (typeof it != "number" && cof(it) != "Number") throw TypeError(msg);
        return +it;
      };

      /***/
    },
    /* 119 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.1.2.3 Number.isInteger(number)
      var isObject = __webpack_require__(4);
      var floor = Math.floor;
      module.exports = function isInteger(it) {
        return !isObject(it) && isFinite(it) && floor(it) === it;
      };

      /***/
    },
    /* 120 */
    /***/ function (module, exports) {
      // 20.2.2.20 Math.log1p(x)
      module.exports =
        Math.log1p ||
        function log1p(x) {
          return (x = +x) > -1e-8 && x < 1e-8
            ? x - (x * x) / 2
            : Math.log(1 + x);
        };

      /***/
    },
    /* 121 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.16 Math.fround(x)
      var sign = __webpack_require__(91);
      var pow = Math.pow;
      var EPSILON = pow(2, -52);
      var EPSILON32 = pow(2, -23);
      var MAX32 = pow(2, 127) * (2 - EPSILON32);
      var MIN32 = pow(2, -126);

      var roundTiesToEven = function (n) {
        return n + 1 / EPSILON - 1 / EPSILON;
      };

      module.exports =
        Math.fround ||
        function fround(x) {
          var $abs = Math.abs(x);
          var $sign = sign(x);
          var a, result;
          if ($abs < MIN32)
            return (
              $sign *
              roundTiesToEven($abs / MIN32 / EPSILON32) *
              MIN32 *
              EPSILON32
            );
          a = (1 + EPSILON32 / EPSILON) * $abs;
          result = a - (a - $abs);
          // eslint-disable-next-line no-self-compare
          if (result > MAX32 || result != result) return $sign * Infinity;
          return $sign * result;
        };

      /***/
    },
    /* 122 */
    /***/ function (module, exports, __webpack_require__) {
      // call something on iterator step with safe closing on error
      var anObject = __webpack_require__(2);
      module.exports = function (iterator, fn, value, entries) {
        try {
          return entries ? fn(anObject(value)[0], value[1]) : fn(value);
          // 7.4.6 IteratorClose(iterator, completion)
        } catch (e) {
          var ret = iterator["return"];
          if (ret !== undefined) anObject(ret.call(iterator));
          throw e;
        }
      };

      /***/
    },
    /* 123 */
    /***/ function (module, exports, __webpack_require__) {
      var aFunction = __webpack_require__(13);
      var toObject = __webpack_require__(12);
      var IObject = __webpack_require__(55);
      var toLength = __webpack_require__(10);

      module.exports = function (that, callbackfn, aLen, memo, isRight) {
        aFunction(callbackfn);
        var O = toObject(that);
        var self = IObject(O);
        var length = toLength(O.length);
        var index = isRight ? length - 1 : 0;
        var i = isRight ? -1 : 1;
        if (aLen < 2)
          for (;;) {
            if (index in self) {
              memo = self[index];
              index += i;
              break;
            }
            index += i;
            if (isRight ? index < 0 : length <= index) {
              throw TypeError("Reduce of empty array with no initial value");
            }
          }
        for (; isRight ? index >= 0 : length > index; index += i)
          if (index in self) {
            memo = callbackfn(memo, self[index], index, O);
          }
        return memo;
      };

      /***/
    },
    /* 124 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";
      // 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

      var toObject = __webpack_require__(12);
      var toAbsoluteIndex = __webpack_require__(43);
      var toLength = __webpack_require__(10);

      module.exports =
        [].copyWithin ||
        function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
          var O = toObject(this);
          var len = toLength(O.length);
          var to = toAbsoluteIndex(target, len);
          var from = toAbsoluteIndex(start, len);
          var end = arguments.length > 2 ? arguments[2] : undefined;
          var count = Math.min(
            (end === undefined ? len : toAbsoluteIndex(end, len)) - from,
            len - to
          );
          var inc = 1;
          if (from < to && to < from + count) {
            inc = -1;
            from += count - 1;
            to += count - 1;
          }
          while (count-- > 0) {
            if (from in O) O[to] = O[from];
            else delete O[to];
            to += inc;
            from += inc;
          }
          return O;
        };

      /***/
    },
    /* 125 */
    /***/ function (module, exports, __webpack_require__) {
      // 21.2.5.3 get RegExp.prototype.flags()
      if (__webpack_require__(9) && /./g.flags != "g")
        __webpack_require__(8).f(RegExp.prototype, "flags", {
          configurable: true,
          get: __webpack_require__(69),
        });

      /***/
    },
    /* 126 */
    /***/ function (module, exports) {
      module.exports = function (exec) {
        try {
          return { e: false, v: exec() };
        } catch (e) {
          return { e: true, v: e };
        }
      };

      /***/
    },
    /* 127 */
    /***/ function (module, exports, __webpack_require__) {
      var anObject = __webpack_require__(2);
      var isObject = __webpack_require__(4);
      var newPromiseCapability = __webpack_require__(102);

      module.exports = function (C, x) {
        anObject(C);
        if (isObject(x) && x.constructor === C) return x;
        var promiseCapability = newPromiseCapability.f(C);
        var resolve = promiseCapability.resolve;
        resolve(x);
        return promiseCapability.promise;
      };

      /***/
    },
    /* 128 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var strong = __webpack_require__(129);
      var validate = __webpack_require__(53);
      var MAP = "Map";

      // 23.1 Map Objects
      module.exports = __webpack_require__(73)(
        MAP,
        function (get) {
          return function Map() {
            return get(this, arguments.length > 0 ? arguments[0] : undefined);
          };
        },
        {
          // 23.1.3.6 Map.prototype.get(key)
          get: function get(key) {
            var entry = strong.getEntry(validate(this, MAP), key);
            return entry && entry.v;
          },
          // 23.1.3.9 Map.prototype.set(key, value)
          set: function set(key, value) {
            return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
          },
        },
        strong,
        true
      );

      /***/
    },
    /* 129 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var dP = __webpack_require__(8).f;
      var create = __webpack_require__(31);
      var redefineAll = __webpack_require__(50);
      var ctx = __webpack_require__(21);
      var anInstance = __webpack_require__(49);
      var forOf = __webpack_require__(40);
      var $iterDefine = __webpack_require__(65);
      var step = __webpack_require__(84);
      var setSpecies = __webpack_require__(48);
      var DESCRIPTORS = __webpack_require__(9);
      var fastKey = __webpack_require__(37).fastKey;
      var validate = __webpack_require__(53);
      var SIZE = DESCRIPTORS ? "_s" : "size";

      var getEntry = function (that, key) {
        // fast case
        var index = fastKey(key);
        var entry;
        if (index !== "F") return that._i[index];
        // frozen object case
        for (entry = that._f; entry; entry = entry.n) {
          if (entry.k == key) return entry;
        }
      };

      module.exports = {
        getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
          var C = wrapper(function (that, iterable) {
            anInstance(that, C, NAME, "_i");
            that._t = NAME; // collection type
            that._i = create(null); // index
            that._f = undefined; // first entry
            that._l = undefined; // last entry
            that[SIZE] = 0; // size
            if (iterable != undefined)
              forOf(iterable, IS_MAP, that[ADDER], that);
          });
          redefineAll(C.prototype, {
            // 23.1.3.1 Map.prototype.clear()
            // 23.2.3.2 Set.prototype.clear()
            clear: function clear() {
              for (
                var that = validate(this, NAME),
                  data = that._i,
                  entry = that._f;
                entry;
                entry = entry.n
              ) {
                entry.r = true;
                if (entry.p) entry.p = entry.p.n = undefined;
                delete data[entry.i];
              }
              that._f = that._l = undefined;
              that[SIZE] = 0;
            },
            // 23.1.3.3 Map.prototype.delete(key)
            // 23.2.3.4 Set.prototype.delete(value)
            delete: function (key) {
              var that = validate(this, NAME);
              var entry = getEntry(that, key);
              if (entry) {
                var next = entry.n;
                var prev = entry.p;
                delete that._i[entry.i];
                entry.r = true;
                if (prev) prev.n = next;
                if (next) next.p = prev;
                if (that._f == entry) that._f = next;
                if (that._l == entry) that._l = prev;
                that[SIZE]--;
              }
              return !!entry;
            },
            // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
            // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
            forEach: function forEach(callbackfn /* , that = undefined */) {
              validate(this, NAME);
              var f = ctx(
                callbackfn,
                arguments.length > 1 ? arguments[1] : undefined,
                3
              );
              var entry;
              while ((entry = entry ? entry.n : this._f)) {
                f(entry.v, entry.k, this);
                // revert to the last existing entry
                while (entry && entry.r) entry = entry.p;
              }
            },
            // 23.1.3.7 Map.prototype.has(key)
            // 23.2.3.7 Set.prototype.has(value)
            has: function has(key) {
              return !!getEntry(validate(this, NAME), key);
            },
          });
          if (DESCRIPTORS)
            dP(C.prototype, "size", {
              get: function () {
                return validate(this, NAME)[SIZE];
              },
            });
          return C;
        },
        def: function (that, key, value) {
          var entry = getEntry(that, key);
          var prev, index;
          // change existing entry
          if (entry) {
            entry.v = value;
            // create new entry
          } else {
            that._l = entry = {
              i: (index = fastKey(key, true)), // <- index
              k: key, // <- key
              v: value, // <- value
              p: (prev = that._l), // <- previous entry
              n: undefined, // <- next entry
              r: false, // <- removed
            };
            if (!that._f) that._f = entry;
            if (prev) prev.n = entry;
            that[SIZE]++;
            // add to index
            if (index !== "F") that._i[index] = entry;
          }
          return that;
        },
        getEntry: getEntry,
        setStrong: function (C, NAME, IS_MAP) {
          // add .keys, .values, .entries, [@@iterator]
          // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
          $iterDefine(
            C,
            NAME,
            function (iterated, kind) {
              this._t = validate(iterated, NAME); // target
              this._k = kind; // kind
              this._l = undefined; // previous
            },
            function () {
              var that = this;
              var kind = that._k;
              var entry = that._l;
              // revert to the last existing entry
              while (entry && entry.r) entry = entry.p;
              // get next entry
              if (
                !that._t ||
                !(that._l = entry = entry ? entry.n : that._t._f)
              ) {
                // or finish the iteration
                that._t = undefined;
                return step(1);
              }
              // return step by kind
              if (kind == "keys") return step(0, entry.k);
              if (kind == "values") return step(0, entry.v);
              return step(0, [entry.k, entry.v]);
            },
            IS_MAP ? "entries" : "values",
            !IS_MAP,
            true
          );

          // add [@@species], 23.1.2.2, 23.2.2.2
          setSpecies(NAME);
        },
      };

      /***/
    },
    /* 130 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var strong = __webpack_require__(129);
      var validate = __webpack_require__(53);
      var SET = "Set";

      // 23.2 Set Objects
      module.exports = __webpack_require__(73)(
        SET,
        function (get) {
          return function Set() {
            return get(this, arguments.length > 0 ? arguments[0] : undefined);
          };
        },
        {
          // 23.2.3.1 Set.prototype.add(value)
          add: function add(value) {
            return strong.def(
              validate(this, SET),
              (value = value === 0 ? 0 : value),
              value
            );
          },
        },
        strong
      );

      /***/
    },
    /* 131 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var each = __webpack_require__(28)(0);
      var redefine = __webpack_require__(17);
      var meta = __webpack_require__(37);
      var assign = __webpack_require__(83);
      var weak = __webpack_require__(132);
      var isObject = __webpack_require__(4);
      var fails = __webpack_require__(5);
      var validate = __webpack_require__(53);
      var WEAK_MAP = "WeakMap";
      var getWeak = meta.getWeak;
      var isExtensible = Object.isExtensible;
      var uncaughtFrozenStore = weak.ufstore;
      var tmp = {};
      var InternalMap;

      var wrapper = function (get) {
        return function WeakMap() {
          return get(this, arguments.length > 0 ? arguments[0] : undefined);
        };
      };

      var methods = {
        // 23.3.3.3 WeakMap.prototype.get(key)
        get: function get(key) {
          if (isObject(key)) {
            var data = getWeak(key);
            if (data === true)
              return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
            return data ? data[this._i] : undefined;
          }
        },
        // 23.3.3.5 WeakMap.prototype.set(key, value)
        set: function set(key, value) {
          return weak.def(validate(this, WEAK_MAP), key, value);
        },
      };

      // 23.3 WeakMap Objects
      var $WeakMap = (module.exports = __webpack_require__(73)(
        WEAK_MAP,
        wrapper,
        methods,
        weak,
        true,
        true
      ));

      // IE11 WeakMap frozen keys fix
      if (
        fails(function () {
          return (
            new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7
          );
        })
      ) {
        InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
        assign(InternalMap.prototype, methods);
        meta.NEED = true;
        each(["delete", "has", "get", "set"], function (key) {
          var proto = $WeakMap.prototype;
          var method = proto[key];
          redefine(proto, key, function (a, b) {
            // store frozen objects on internal weakmap shim
            if (isObject(a) && !isExtensible(a)) {
              if (!this._f) this._f = new InternalMap();
              var result = this._f[key](a, b);
              return key == "set" ? this : result;
              // store all the rest on native weakmap
            }
            return method.call(this, a, b);
          });
        });
      }

      /***/
    },
    /* 132 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var redefineAll = __webpack_require__(50);
      var getWeak = __webpack_require__(37).getWeak;
      var anObject = __webpack_require__(2);
      var isObject = __webpack_require__(4);
      var anInstance = __webpack_require__(49);
      var forOf = __webpack_require__(40);
      var createArrayMethod = __webpack_require__(28);
      var $has = __webpack_require__(15);
      var validate = __webpack_require__(53);
      var arrayFind = createArrayMethod(5);
      var arrayFindIndex = createArrayMethod(6);
      var id = 0;

      // fallback for uncaught frozen keys
      var uncaughtFrozenStore = function (that) {
        return that._l || (that._l = new UncaughtFrozenStore());
      };
      var UncaughtFrozenStore = function () {
        this.a = [];
      };
      var findUncaughtFrozen = function (store, key) {
        return arrayFind(store.a, function (it) {
          return it[0] === key;
        });
      };
      UncaughtFrozenStore.prototype = {
        get: function (key) {
          var entry = findUncaughtFrozen(this, key);
          if (entry) return entry[1];
        },
        has: function (key) {
          return !!findUncaughtFrozen(this, key);
        },
        set: function (key, value) {
          var entry = findUncaughtFrozen(this, key);
          if (entry) entry[1] = value;
          else this.a.push([key, value]);
        },
        delete: function (key) {
          var index = arrayFindIndex(this.a, function (it) {
            return it[0] === key;
          });
          if (~index) this.a.splice(index, 1);
          return !!~index;
        },
      };

      module.exports = {
        getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
          var C = wrapper(function (that, iterable) {
            anInstance(that, C, NAME, "_i");
            that._t = NAME; // collection type
            that._i = id++; // collection id
            that._l = undefined; // leak store for uncaught frozen objects
            if (iterable != undefined)
              forOf(iterable, IS_MAP, that[ADDER], that);
          });
          redefineAll(C.prototype, {
            // 23.3.3.2 WeakMap.prototype.delete(key)
            // 23.4.3.3 WeakSet.prototype.delete(value)
            delete: function (key) {
              if (!isObject(key)) return false;
              var data = getWeak(key);
              if (data === true)
                return uncaughtFrozenStore(validate(this, NAME))["delete"](key);
              return data && $has(data, this._i) && delete data[this._i];
            },
            // 23.3.3.4 WeakMap.prototype.has(key)
            // 23.4.3.4 WeakSet.prototype.has(value)
            has: function has(key) {
              if (!isObject(key)) return false;
              var data = getWeak(key);
              if (data === true)
                return uncaughtFrozenStore(validate(this, NAME)).has(key);
              return data && $has(data, this._i);
            },
          });
          return C;
        },
        def: function (that, key, value) {
          var data = getWeak(anObject(key), true);
          if (data === true) uncaughtFrozenStore(that).set(key, value);
          else data[that._i] = value;
          return that;
        },
        ufstore: uncaughtFrozenStore,
      };

      /***/
    },
    /* 133 */
    /***/ function (module, exports, __webpack_require__) {
      // https://tc39.github.io/ecma262/#sec-toindex
      var toInteger = __webpack_require__(26);
      var toLength = __webpack_require__(10);
      module.exports = function (it) {
        if (it === undefined) return 0;
        var number = toInteger(it);
        var length = toLength(number);
        if (number !== length) throw RangeError("Wrong length!");
        return length;
      };

      /***/
    },
    /* 134 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
      var isArray = __webpack_require__(63);
      var isObject = __webpack_require__(4);
      var toLength = __webpack_require__(10);
      var ctx = __webpack_require__(21);
      var IS_CONCAT_SPREADABLE = __webpack_require__(6)("isConcatSpreadable");

      function flattenIntoArray(
        target,
        original,
        source,
        sourceLen,
        start,
        depth,
        mapper,
        thisArg
      ) {
        var targetIndex = start;
        var sourceIndex = 0;
        var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
        var element, spreadable;

        while (sourceIndex < sourceLen) {
          if (sourceIndex in source) {
            element = mapFn
              ? mapFn(source[sourceIndex], sourceIndex, original)
              : source[sourceIndex];

            spreadable = false;
            if (isObject(element)) {
              spreadable = element[IS_CONCAT_SPREADABLE];
              spreadable =
                spreadable !== undefined ? !!spreadable : isArray(element);
            }

            if (spreadable && depth > 0) {
              targetIndex =
                flattenIntoArray(
                  target,
                  original,
                  element,
                  toLength(element.length),
                  targetIndex,
                  depth - 1
                ) - 1;
            } else {
              if (targetIndex >= 0x1fffffffffffff) throw TypeError();
              target[targetIndex] = element;
            }

            targetIndex++;
          }
          sourceIndex++;
        }
        return targetIndex;
      }

      module.exports = flattenIntoArray;

      /***/
    },
    /* 135 */
    /***/ function (module, exports, __webpack_require__) {
      // https://github.com/tc39/proposal-string-pad-start-end
      var toLength = __webpack_require__(10);
      var repeat = __webpack_require__(90);
      var defined = __webpack_require__(25);

      module.exports = function (that, maxLength, fillString, left) {
        var S = String(defined(that));
        var stringLength = S.length;
        var fillStr = fillString === undefined ? " " : String(fillString);
        var intMaxLength = toLength(maxLength);
        if (intMaxLength <= stringLength || fillStr == "") return S;
        var fillLen = intMaxLength - stringLength;
        var stringFiller = repeat.call(
          fillStr,
          Math.ceil(fillLen / fillStr.length)
        );
        if (stringFiller.length > fillLen)
          stringFiller = stringFiller.slice(0, fillLen);
        return left ? stringFiller + S : S + stringFiller;
      };

      /***/
    },
    /* 136 */
    /***/ function (module, exports, __webpack_require__) {
      var getKeys = __webpack_require__(30);
      var toIObject = __webpack_require__(14);
      var isEnum = __webpack_require__(56).f;
      module.exports = function (isEntries) {
        return function (it) {
          var O = toIObject(it);
          var keys = getKeys(O);
          var length = keys.length;
          var i = 0;
          var result = [];
          var key;
          while (length > i)
            if (isEnum.call(O, (key = keys[i++]))) {
              result.push(isEntries ? [key, O[key]] : O[key]);
            }
          return result;
        };
      };

      /***/
    },
    /* 137 */
    /***/ function (module, exports, __webpack_require__) {
      // https://github.com/DavidBruant/Map-Set.prototype.toJSON
      var classof = __webpack_require__(45);
      var from = __webpack_require__(138);
      module.exports = function (NAME) {
        return function toJSON() {
          if (classof(this) != NAME)
            throw TypeError(NAME + "#toJSON isn't generic");
          return from(this);
        };
      };

      /***/
    },
    /* 138 */
    /***/ function (module, exports, __webpack_require__) {
      var forOf = __webpack_require__(40);

      module.exports = function (iter, ITERATOR) {
        var result = [];
        forOf(iter, false, result.push, result, ITERATOR);
        return result;
      };

      /***/
    },
    /* 139 */
    /***/ function (module, exports) {
      // https://rwaldron.github.io/proposal-math-extensions/
      module.exports =
        Math.scale ||
        function scale(x, inLow, inHigh, outLow, outHigh) {
          if (
            arguments.length === 0 ||
            // eslint-disable-next-line no-self-compare
            x != x ||
            // eslint-disable-next-line no-self-compare
            inLow != inLow ||
            // eslint-disable-next-line no-self-compare
            inHigh != inHigh ||
            // eslint-disable-next-line no-self-compare
            outLow != outLow ||
            // eslint-disable-next-line no-self-compare
            outHigh != outHigh
          )
            return NaN;
          if (x === Infinity || x === -Infinity) return x;
          return ((x - inLow) * (outHigh - outLow)) / (inHigh - inLow) + outLow;
        };

      /***/
    },
    /* 140 */
    /***/ function (module, exports, __webpack_require__) {
      var classof = __webpack_require__(45);
      var ITERATOR = __webpack_require__(6)("iterator");
      var Iterators = __webpack_require__(46);
      module.exports = __webpack_require__(11).isIterable = function (it) {
        var O = Object(it);
        return (
          O[ITERATOR] !== undefined ||
          "@@iterator" in O ||
          // eslint-disable-next-line no-prototype-builtins
          Iterators.hasOwnProperty(classof(O))
        );
      };

      /***/
    },
    /* 141 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var path = __webpack_require__(142);
      var invoke = __webpack_require__(87);
      var aFunction = __webpack_require__(13);
      module.exports = function (/* ...pargs */) {
        var fn = aFunction(this);
        var length = arguments.length;
        var pargs = new Array(length);
        var i = 0;
        var _ = path._;
        var holder = false;
        while (length > i) if ((pargs[i] = arguments[i++]) === _) holder = true;
        return function (/* ...args */) {
          var that = this;
          var aLen = arguments.length;
          var j = 0;
          var k = 0;
          var args;
          if (!holder && !aLen) return invoke(fn, pargs, that);
          args = pargs.slice();
          if (holder)
            for (; length > j; j++) if (args[j] === _) args[j] = arguments[k++];
          while (aLen > k) args.push(arguments[k++]);
          return invoke(fn, args, that);
        };
      };

      /***/
    },
    /* 142 */
    /***/ function (module, exports, __webpack_require__) {
      module.exports = __webpack_require__(3);

      /***/
    },
    /* 143 */
    /***/ function (module, exports, __webpack_require__) {
      var dP = __webpack_require__(8);
      var gOPD = __webpack_require__(18);
      var ownKeys = __webpack_require__(104);
      var toIObject = __webpack_require__(14);

      module.exports = function define(target, mixin) {
        var keys = ownKeys(toIObject(mixin));
        var length = keys.length;
        var i = 0;
        var key;
        while (length > i) dP.f(target, (key = keys[i++]), gOPD.f(mixin, key));
        return target;
      };

      /***/
    },
    /* 144 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // forEach method, could be shipped as part of an Object Literal/Module
      function forEach(array, callback, scope) {
        var index = 0;

        for (index = 0; index < array.length; index += 1) {
          callback.call(scope, array[index], index); // passes back stuff we need
        }
      }

      function hasClass(el, className) {
        var regex = new RegExp("^" + className + "| +" + className, "g");

        return el.className.match(regex);
      }

      function addClass(el, className) {
        // Return if it already has the className
        if (hasClass(el, className)) return;

        el.className += " " + className;
      }

      function removeClass(el, className) {
        // Return if it doesn't already have the className
        if (!hasClass(el, className)) return;

        var regex = new RegExp("^" + className + "| +" + className, "g");

        el.className = el.className.replace(regex, "");
      }

      function toggleClass(el, className) {
        if (hasClass(el, className)) {
          removeClass(el, className);
        } else {
          addClass(el, className);
        }
      }

      function findPairingFromPairingTrigger(pairings, pairingTrigger) {
        var foundPairing = null;

        forEach(pairings, function (pairing) {
          if (pairing.trigger === pairingTrigger) {
            foundPairing = pairing;
          }
        });

        return foundPairing;
      }

      /**
       * See {@link https://stackoverflow.com/revisions/2117523/11 Stack Overflow}
       * An RFC4122 v4 compliant uuid solution
       */
      function uuidv4() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
          /[xy]/g,
          function (c) {
            var r = (Math.random() * 16) | 0;
            var v = c === "x" ? r : (r & 0x3) | 0x8;

            return v.toString(16);
          }
        );
      }

      function init(groupedContent) {
        var triggers = groupedContent.triggers;
        var pairings = groupedContent.pairings;

        triggers.setAttribute("role", "tablist");

        forEach(pairings, function (pairing, index) {
          pairing.trigger.setAttribute("role", "tab");
          pairing.trigger.setAttribute(
            "aria-controls",
            groupedContent.namespace +
              "-" +
              groupedContent.id +
              "-" +
              index +
              "-content"
          );

          if (pairing.trigger.children.length > 0) {
            forEach(pairing.trigger.children, function (child) {
              child.setAttribute("tabIndex", "-1");
            });
          }

          if (hasClass(pairing.trigger, "active")) {
            pairing.trigger.setAttribute("aria-selected", "true");
            pairing.trigger.setAttribute("tabIndex", "0");
          } else {
            pairing.trigger.setAttribute("tabIndex", "-1");
          }

          pairing.content.id =
            groupedContent.namespace +
            "-" +
            groupedContent.id +
            "-" +
            index +
            "-content";
          pairing.content.setAttribute("role", "tabpanel");

          if (!hasClass(pairing.content, "active")) {
            pairing.content.setAttribute("aria-hidden", "true");
          }
        });
      }

      function update(groupedContent) {
        var pairings = groupedContent.pairings;

        forEach(pairings, function (pairing) {
          pairing.trigger.removeAttribute("aria-selected");
          pairing.content.removeAttribute("aria-hidden");

          if (hasClass(pairing.trigger, "active")) {
            pairing.trigger.setAttribute("aria-selected", "true");
            pairing.trigger.setAttribute("tabIndex", "0");
          } else {
            pairing.trigger.setAttribute("tabIndex", "-1");
          }

          if (!hasClass(pairing.content, "active")) {
            pairing.content.setAttribute("aria-hidden", "true");
          }
        });
      }

      var a11y = {
        init: init,
        update: update,
      };

      var asyncGenerator = (function () {
        function AwaitValue(value) {
          this.value = value;
        }

        function AsyncGenerator(gen) {
          var front, back;

          function send(key, arg) {
            return new Promise(function (resolve, reject) {
              var request = {
                key: key,
                arg: arg,
                resolve: resolve,
                reject: reject,
                next: null,
              };

              if (back) {
                back = back.next = request;
              } else {
                front = back = request;
                resume(key, arg);
              }
            });
          }

          function resume(key, arg) {
            try {
              var result = gen[key](arg);
              var value = result.value;

              if (value instanceof AwaitValue) {
                Promise.resolve(value.value).then(
                  function (arg) {
                    resume("next", arg);
                  },
                  function (arg) {
                    resume("throw", arg);
                  }
                );
              } else {
                settle(result.done ? "return" : "normal", result.value);
              }
            } catch (err) {
              settle("throw", err);
            }
          }

          function settle(type, value) {
            switch (type) {
              case "return":
                front.resolve({
                  value: value,
                  done: true,
                });
                break;

              case "throw":
                front.reject(value);
                break;

              default:
                front.resolve({
                  value: value,
                  done: false,
                });
                break;
            }

            front = front.next;

            if (front) {
              resume(front.key, front.arg);
            } else {
              back = null;
            }
          }

          this._invoke = send;

          if (typeof gen.return !== "function") {
            this.return = undefined;
          }
        }

        if (typeof Symbol === "function" && Symbol.asyncIterator) {
          AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
            return this;
          };
        }

        AsyncGenerator.prototype.next = function (arg) {
          return this._invoke("next", arg);
        };

        AsyncGenerator.prototype.throw = function (arg) {
          return this._invoke("throw", arg);
        };

        AsyncGenerator.prototype.return = function (arg) {
          return this._invoke("return", arg);
        };

        return {
          wrap: function (fn) {
            return function () {
              return new AsyncGenerator(fn.apply(this, arguments));
            };
          },
          await: function (value) {
            return new AwaitValue(value);
          },
        };
      })();

      var classCallCheck = function (instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      };

      var createClass = (function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      })();

      /** A class for creating, managing, and destroying groupable content as tabs. */

      var TabsLayout = (function () {
        function TabsLayout(groupedContent) {
          classCallCheck(this, TabsLayout);

          this.groupedContent = groupedContent;
          this.pairings = groupedContent.pairings;
          this.events = [];

          this._handleKeydown = this._handleKeydown.bind(this);
          this._handleClick = this._handleClick.bind(this);

          this._init();
          a11y.init(this.groupedContent);
        }

        createClass(TabsLayout, [
          {
            key: "unload",
            value: function unload() {
              forEach(this.events, function (event) {
                event.trigger.removeEventListener(event.type, event.fn);
              });
            },
          },
          {
            key: "_init",
            value: function _init() {
              var _this = this;

              var existingActive = false;

              forEach(this.pairings, function (pairing) {
                var trigger = pairing.trigger;

                if (hasClass(trigger, "active")) {
                  existingActive = true;
                }

                trigger.addEventListener("keydown", _this._handleKeydown);
                trigger.addEventListener("click", _this._handleClick);

                _this.events.push({
                  trigger: trigger,
                  type: "keydown",
                  fn: _this._handleKeydown,
                });

                _this.events.push({
                  trigger: trigger,
                  type: "click",
                  fn: _this._handleClick,
                });
              });

              if (!existingActive) {
                addClass(this.pairings[0].trigger, "active");
                addClass(this.pairings[0].content, "active");
              }
            },
          },
          {
            key: "_handleKeydown",
            value: function _handleKeydown(event) {
              var trigger = event.currentTarget;
              var pairing = findPairingFromPairingTrigger(
                this.pairings,
                trigger
              );
              var pairingIndex = this.pairings.indexOf(pairing);
              var prevIndex =
                pairingIndex - 1 < 0
                  ? this.pairings.length - 1
                  : pairingIndex - 1;
              var nextIndex =
                pairingIndex + 1 >= this.pairings.length ? 0 : pairingIndex + 1;

              var nextPairing = null;

              switch (event.key) {
                case "ArrowLeft":
                  nextPairing = this.pairings[prevIndex];
                  break;
                case "ArrowRight":
                  nextPairing = this.pairings[nextIndex];
                  break;
                default:
                  nextPairing = null;
                  break;
              }

              // Fast exit if we can't find the tab or tabs
              if (nextPairing === null) return;

              event.preventDefault();

              forEach(this.pairings, function (inactivePairing) {
                removeClass(inactivePairing.trigger, "active");
                removeClass(inactivePairing.content, "active");
              });

              addClass(nextPairing.trigger, "active");
              addClass(nextPairing.content, "active");

              nextPairing.trigger.focus();

              a11y.update(this.groupedContent);
            },
          },
          {
            key: "_handleClick",
            value: function _handleClick(event) {
              var trigger = event.currentTarget;
              var pairing = findPairingFromPairingTrigger(
                this.pairings,
                trigger
              );

              // Fast exit if we can't find the tab or tabs
              if (pairing === null) return;

              event.preventDefault();

              forEach(this.pairings, function (inactivePairing) {
                removeClass(inactivePairing.trigger, "active");
                removeClass(inactivePairing.content, "active");
              });

              addClass(pairing.trigger, "active");
              addClass(pairing.content, "active");

              a11y.update(this.groupedContent);
            },
          },
        ]);
        return TabsLayout;
      })();

      function init$1(groupedContent) {
        var pairings = groupedContent.pairings;

        forEach(pairings, function (pairing, index) {
          pairing.trigger.setAttribute("role", "button");
          pairing.trigger.setAttribute(
            "aria-controls",
            groupedContent.namespace +
              "-" +
              groupedContent.id +
              "-" +
              index +
              "-content"
          );
          pairing.trigger.setAttribute("tabIndex", "0");

          if (pairing.trigger.children.length > 0) {
            forEach(pairing.trigger.children, function (child) {
              child.setAttribute("tabIndex", "-1");
            });
          }

          if (hasClass(pairing.trigger, "active")) {
            pairing.trigger.setAttribute("aria-expanded", "true");
          } else {
            pairing.trigger.setAttribute("aria-expanded", "false");
          }

          pairing.content.id =
            groupedContent.namespace +
            "-" +
            groupedContent.id +
            "-" +
            index +
            "-content";

          if (!hasClass(pairing.content, "active")) {
            pairing.content.setAttribute("aria-hidden", "true");
          }
        });
      }

      function update$1(groupedContent) {
        var pairings = groupedContent.pairings;

        forEach(pairings, function (pairing) {
          pairing.content.removeAttribute("aria-hidden");

          if (hasClass(pairing.trigger, "active")) {
            pairing.trigger.setAttribute("aria-expanded", "true");
          } else {
            pairing.trigger.setAttribute("aria-expanded", "false");
          }

          if (!hasClass(pairing.content, "active")) {
            pairing.content.setAttribute("aria-hidden", "true");
          }
        });
      }

      var a11y$1 = {
        init: init$1,
        update: update$1,
      };

      /** A class for creating, managing, and destroying groupable content as an accordion. */

      var AccordionLayout = (function () {
        function AccordionLayout(groupedContent) {
          classCallCheck(this, AccordionLayout);

          this.groupedContent = groupedContent;
          this.pairings = groupedContent.pairings;
          this.events = [];

          this._handleKeydown = this._handleKeydown.bind(this);
          this._handleClick = this._handleClick.bind(this);

          this._init(this.pairings);
          a11y$1.init(this.groupedContent);
        }

        createClass(AccordionLayout, [
          {
            key: "unload",
            value: function unload() {
              forEach(this.events, function (event) {
                event.trigger.removeEventListener(event.type, event.fn);
              });
            },
          },
          {
            key: "_init",
            value: function _init() {
              var _this = this;

              forEach(this.pairings, function (pairing) {
                var trigger = pairing.trigger;
                var content = pairing.content;

                trigger.parentNode.insertBefore(content, trigger.nextSibling);

                trigger.addEventListener("keydown", _this._handleKeydown);
                trigger.addEventListener("click", _this._handleClick);

                _this.events.push({
                  trigger: trigger,
                  type: "keydown",
                  fn: _this._handleKeydown,
                });

                _this.events.push({
                  trigger: trigger,
                  type: "click",
                  fn: _this._handleClick,
                });
              });

              this.groupedContent.contents.remove();
            },
          },
          {
            key: "_handleKeydown",
            value: function _handleKeydown(event) {
              var trigger = event.currentTarget;
              var pairing = findPairingFromPairingTrigger(
                this.pairings,
                trigger
              );

              // Fast exit if enter isn't pressed or we can't find the group
              if (event.key !== "Enter" || pairing === null) return;

              event.preventDefault();

              toggleClass(pairing.trigger, "active");
              toggleClass(pairing.content, "active");
              a11y$1.update(this.groupedContent);
            },
          },
          {
            key: "_handleClick",
            value: function _handleClick(event) {
              var trigger = event.currentTarget;
              var pairing = findPairingFromPairingTrigger(
                this.pairings,
                trigger
              );

              // Fast exit if we can't find the group
              if (pairing === null) return;

              event.preventDefault();

              toggleClass(pairing.trigger, "active");
              toggleClass(pairing.content, "active");
              a11y$1.update(this.groupedContent);
            },
          },
        ]);
        return AccordionLayout;
      })();

      /**
       * Returns an array of nodes related to the heading node.
       * @param {node} heading - The heading node to search for content from.
       * @returns {node[]}
       */
      function getHeadingContent(heading) {
        var headingTagNames = ["H1", "H2", "H3", "H4", "H5", "H6"];
        var tagNameIndex = headingTagNames.indexOf(heading.tagName);
        var content = [];

        var sibling = heading.nextElementSibling;

        while (
          sibling !== null &&
          (headingTagNames.indexOf(sibling.tagName) === -1 ||
            headingTagNames.indexOf(sibling.tagName) > tagNameIndex)
        ) {
          content.push(sibling);

          sibling = sibling.nextElementSibling;
        }

        return content;
      }

      /**
       * Returns an object array representing the heading tree from a given node.
       * Root nodes are evaluated differently, and requires the evaluatingRoot flag
       * to be true.
       * @param {node} el - The node being evaluated.
       * @param {node[]} children - The children of the evaluated node.
       * @param {boolean} [evaluatingRoot] - Whether to evaluate as root node.
       * @returns {Object[]}
       */
      function getHeadingTree(el, children) {
        var evaluatingRoot =
          arguments.length > 2 && arguments[2] !== undefined
            ? arguments[2]
            : false;

        var headingTagNames = ["H1", "H2", "H3", "H4", "H5", "H6"];
        var tagNameIndex = headingTagNames.indexOf(el.tagName);
        var headings = [];

        var currentLowestTagNameIndex = 5;

        for (var i = 0; i < children.length; i += 1) {
          var child = children[i];
          var childTagNameIndex = headingTagNames.indexOf(child.tagName);

          if (
            childTagNameIndex !== -1 &&
            childTagNameIndex < currentLowestTagNameIndex
          ) {
            currentLowestTagNameIndex = childTagNameIndex;
          }

          if (
            (evaluatingRoot &&
              childTagNameIndex !== -1 &&
              childTagNameIndex <= currentLowestTagNameIndex) ||
            (!evaluatingRoot &&
              childTagNameIndex !== -1 &&
              childTagNameIndex === tagNameIndex + 1)
          ) {
            var siblings = getHeadingContent(child);

            var childNode = {
              el: child,
              content: siblings,
              children: getHeadingTree(child, siblings),
            };

            headings.push(childNode);
          }
        }

        return headings;
      }

      /**
       * Returns groupings of headings that meet the minimum sequence value
       * and don't contain any invalid headings.
       * @param {Object[]} headings - An array of heading objects.
       * @param {int[]} invalidHeadings - An array of invalid heading integers,
       *                                  representing indexes of headings.
       * @param {*} minInSequence - Minimum headings in sequence before being considered
       *                            as a grouping.
       * @returns {Object[][]}
       */
      function getHeadingGroupsInSequence(
        headings,
        invalidHeadings,
        minInSequence
      ) {
        var headingGroupsInSequence = [];
        var currentHeadingGroupInSequence = [];
        var currentSequence = 0;

        for (var i = 0; i < headings.length; i += 1) {
          if (invalidHeadings.indexOf(i) === -1) {
            currentHeadingGroupInSequence.push(headings[i]);
            currentSequence += 1;

            if (
              i !== headings.length - 1 &&
              headings[i].el.tagName !== headings[i + 1].el.tagName &&
              invalidHeadings.indexOf(i + 1)
            ) {
              currentHeadingGroupInSequence = [];
              currentSequence = 0;
            } else if (
              i !== 0 &&
              headings[i].el.tagName !== headings[i - 1].el.tagName
            ) {
              currentHeadingGroupInSequence.pop();
              currentSequence -= 1;

              if (currentSequence >= minInSequence) {
                headingGroupsInSequence.push(currentHeadingGroupInSequence);
              }

              currentHeadingGroupInSequence = [headings[i]];
              currentSequence = 1;
            }
          }
        }

        if (currentSequence >= minInSequence) {
          headingGroupsInSequence.push(currentHeadingGroupInSequence);
        }

        return headingGroupsInSequence;
      }

      /**
       * Generates necessary DOM elements to group related content.
       * Returns a object array representing the grouped content.
       * @param {Object[]} children - An array of objects.
       * @returns {Object[]}
       */
      function createGroupedContent(children) {
        var pairings = [];

        var firstChild = children[0].el;
        var triggers = document.createElement("div");
        var contents = document.createElement("div");

        contents = firstChild.parentNode.insertBefore(
          contents,
          firstChild.nextSibling
        );
        triggers = firstChild.parentNode.insertBefore(
          triggers,
          firstChild.nextSibling
        );

        for (var i = 0; i < children.length; i += 1) {
          var child = children[i];
          var trigger = child.el;
          var content = document.createElement("div");

          trigger = triggers.appendChild(trigger);
          content = contents.appendChild(content);

          for (var j = 0; j < child.content.length; j += 1) {
            content.appendChild(child.content[j]);
          }

          pairings.push({
            trigger: trigger,
            content: content,
          });
        }

        return {
          triggers: triggers,
          contents: contents,
          pairings: pairings,
        };
      }

      /**
       * Returns all groupable content within the supplied node.
       * @param {node} node - A node to traverse for groupable content.
       * @returns {Object[][]}
       */
      /*
       * Recursive function:
       *  Returns all groups of headings that
       *  are elegible to become grouped content.
       */
      function getGroupedContentSet(node) {
        var children = node.children;
        var childrenWithGroupableContent = [];
        var groupedContentSet = [];

        if (children.length === 0) {
          return [];
        }

        for (var i = 0; i < children.length; i += 1) {
          var childGroupableContent = getGroupedContentSet(children[i]);

          if (childGroupableContent.length > 0) {
            childrenWithGroupableContent.push(i);
            groupedContentSet = groupedContentSet.concat(childGroupableContent);
          }
        }

        var headingGroupsInSequence = getHeadingGroupsInSequence(
          children,
          childrenWithGroupableContent,
          3
        );

        for (var _i = 0; _i < headingGroupsInSequence.length; _i += 1) {
          groupedContentSet.push(
            createGroupedContent(headingGroupsInSequence[_i])
          );
        }

        return groupedContentSet;
      }

      /**
       * When static parsing isn't enough, there's intelliparse™!
       * Searches through dom content to find heading groupings that
       * are elegible to become tab groups.
       * Assumes that content is in a flattened hierarchy in the dom
       * and interprets increasing heading values as a deeper level of nesting.
       * Returns all groupable content as an array of object arrays.
       * @param {node} el - The node who's content will be searched for groupable content.
       * @returns {Object[][]}
       */
      function intelliParse(el) {
        var children = el.children;
        var heading = el.querySelector("h1, h2, h3, h4, h5, h6");

        // Fast return if there's no headings
        if (children.length === 0) return [];

        var rootNode = {
          el: el,
          content: null,
          children: getHeadingTree(heading, children, true),
        };

        return getGroupedContentSet(rootNode);
      }

      /**
       * Parses content from a given node based on a static structure.
       * The structure is as follows:
       * <ul class="tabs">
       *   <li class="active">Tab 1</li>
       *   <li>Tab 2</li>
       *   <li>Tab 3</li>
       * </ul>
       *
       * <ul class="tabs-content">
       *   <li class="active">
       *     <p>Tab 1 content goes here.</p>
       *   </li>
       *   <li>
       *     <p>Tab 2 content goes here.</p>
       *   </li>
       *   <li>
       *     <p>Tab 3 content goes here.</p>
       *   </li>
       * </ul>
       * Returns all groupable content as an array of object arrays.
       * @param {node} el - The node who's content will be searched for groupable content.
       * @returns {Object[][]}
       */
      function staticParse(el) {
        var groupedContentSet = [];

        var tabs = el.querySelectorAll(".tabs");

        for (var i = 0; i < tabs.length; i += 1) {
          var triggers = tabs[i].children;
          var contents = tabs[i].nextElementSibling.children;

          // Only add a tab group if equal triggers to contents
          if (triggers.length === contents.length) {
            var length = groupedContentSet.push({
              triggers: tabs[i],
              contents: tabs[i].nextElementSibling,
              pairings: [],
            });
            var index = length - 1;

            for (var j = 0; j < triggers.length; j += 1) {
              var trigger = triggers[j];
              var content = contents[j];

              var pairing = {
                trigger: trigger,
                content: content,
              };

              groupedContentSet[index].pairings.push(pairing);
            }
          }
        }

        return groupedContentSet;
      }

      /**
       * Returns all groupable content as an array of object arrays.
       * @param {node} content - The node to parse for groupable content.
       * @param {boolean} intelliparse - Whether to use intelligent parsing.
       * @returns {Object[][]}
       */
      function parse(content) {
        var intelliparse =
          arguments.length > 1 && arguments[1] !== undefined
            ? arguments[1]
            : false;

        var groupedContentSet = intelliparse
          ? intelliParse(content)
          : staticParse(content);

        return groupedContentSet;
      }

      /** A class for creating, managing, and destroying groupable content. */

      var GroupedContent = (function () {
        /**
         * Create grouped content
         * @param {node} el - The element to search for groupable content in.
         * @param {Object}  [options] - Additional options
         * @param {string}  [options.layout] - The layout to display groupable content in.
         * @param {boolean} [options.intelliparse] - The parsing algorithm used to find content with.
         */
        function GroupedContent(el) {
          var _this = this;

          var options =
            arguments.length > 1 && arguments[1] !== undefined
              ? arguments[1]
              : {};
          classCallCheck(this, GroupedContent);

          this.namespace = "grouped-content";
          this.el = el;
          this.groupedContentInstances = [];

          var layout = options.layout || "tabs";
          var intelliparse = !!options.intelliparse;

          forEach(parse(el, intelliparse), function (groupedContent) {
            var id = uuidv4();
            var instance = null;
            var groupedContentWrapper = document.createElement("div");

            groupedContentWrapper =
              groupedContent.triggers.parentNode.insertBefore(
                groupedContentWrapper,
                groupedContent.triggers.nextSibling
              );

            addClass(groupedContentWrapper, _this.namespace);
            addClass(
              groupedContentWrapper,
              _this.namespace + "-layout-" + layout
            );

            groupedContentWrapper.appendChild(groupedContent.triggers);
            groupedContentWrapper.appendChild(groupedContent.contents);

            groupedContent.namespace = _this.namespace;
            groupedContent.id = id;
            groupedContent.triggers.id =
              _this.namespace + "-" + id + "-triggers";
            groupedContent.contents.id =
              _this.namespace + "-" + id + "-contents";

            addClass(groupedContent.triggers, _this.namespace + "-triggers");
            addClass(groupedContent.contents, _this.namespace + "-contents");

            forEach(groupedContent.pairings, function (pairing) {
              addClass(pairing.trigger, _this.namespace + "-trigger");
              addClass(pairing.content, _this.namespace + "-content");
            });

            switch (layout) {
              case "accordion":
                instance = new AccordionLayout(groupedContent);
                break;
              case "tabs":
              default:
                instance = new TabsLayout(groupedContent);
                break;
            }

            _this.groupedContentInstances.push({
              groupedContent: groupedContent,
              instance: instance,
            });
          });
        }

        /** Unload all grouped content instances */

        createClass(GroupedContent, [
          {
            key: "unload",
            value: function unload() {
              forEach(
                this.groupedContentInstances,
                function (groupedContentInstance) {
                  groupedContentInstance.instance.unload();
                }
              );
            },
          },
        ]);
        return GroupedContent;
      })();

      module.exports = GroupedContent;

      /***/
    },
    /* 145 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_FACTORY__,
        __WEBPACK_AMD_DEFINE_ARRAY__,
        __WEBPACK_AMD_DEFINE_RESULT__;
      /*!
       * Masonry v4.2.2
       * Cascading grid layout library
       * https://masonry.desandro.com
       * MIT License
       * by David DeSandro
       */

      (function (window, factory) {
        // universal module definition
        /* jshint strict: false */ /*globals define, module, require */
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(155),
            __webpack_require__(58),
          ]),
          (__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
          (__WEBPACK_AMD_DEFINE_RESULT__ =
            typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
              ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(
                  exports,
                  __WEBPACK_AMD_DEFINE_ARRAY__
                )
              : __WEBPACK_AMD_DEFINE_FACTORY__),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
            (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(window, function factory(Outlayer, getSize) {
        "use strict";

        // -------------------------- masonryDefinition -------------------------- //

        // create an Outlayer layout class
        var Masonry = Outlayer.create("masonry");
        // isFitWidth -> fitWidth
        Masonry.compatOptions.fitWidth = "isFitWidth";

        var proto = Masonry.prototype;

        proto._resetLayout = function () {
          this.getSize();
          this._getMeasurement("columnWidth", "outerWidth");
          this._getMeasurement("gutter", "outerWidth");
          this.measureColumns();

          // reset column Y
          this.colYs = [];
          for (var i = 0; i < this.cols; i++) {
            this.colYs.push(0);
          }

          this.maxY = 0;
          this.horizontalColIndex = 0;
        };

        proto.measureColumns = function () {
          this.getContainerWidth();
          // if columnWidth is 0, default to outerWidth of first item
          if (!this.columnWidth) {
            var firstItem = this.items[0];
            var firstItemElem = firstItem && firstItem.element;
            // columnWidth fall back to item of first element
            this.columnWidth =
              (firstItemElem && getSize(firstItemElem).outerWidth) ||
              // if first elem has no width, default to size of container
              this.containerWidth;
          }

          var columnWidth = (this.columnWidth += this.gutter);

          // calculate columns
          var containerWidth = this.containerWidth + this.gutter;
          var cols = containerWidth / columnWidth;
          // fix rounding errors, typically with gutters
          var excess = columnWidth - (containerWidth % columnWidth);
          // if overshoot is less than a pixel, round up, otherwise floor it
          var mathMethod = excess && excess < 1 ? "round" : "floor";
          cols = Math[mathMethod](cols);
          this.cols = Math.max(cols, 1);
        };

        proto.getContainerWidth = function () {
          // container is parent if fit width
          var isFitWidth = this._getOption("fitWidth");
          var container = isFitWidth ? this.element.parentNode : this.element;
          // check that this.size and size are there
          // IE8 triggers resize on body size change, so they might not be
          var size = getSize(container);
          this.containerWidth = size && size.innerWidth;
        };

        proto._getItemLayoutPosition = function (item) {
          item.getSize();
          // how many columns does this brick span
          var remainder = item.size.outerWidth % this.columnWidth;
          var mathMethod = remainder && remainder < 1 ? "round" : "ceil";
          // round if off by 1 pixel, otherwise use ceil
          var colSpan = Math[mathMethod](
            item.size.outerWidth / this.columnWidth
          );
          colSpan = Math.min(colSpan, this.cols);
          // use horizontal or top column position
          var colPosMethod = this.options.horizontalOrder
            ? "_getHorizontalColPosition"
            : "_getTopColPosition";
          var colPosition = this[colPosMethod](colSpan, item);
          // position the brick
          var position = {
            x: this.columnWidth * colPosition.col,
            y: colPosition.y,
          };
          // apply setHeight to necessary columns
          var setHeight = colPosition.y + item.size.outerHeight;
          var setMax = colSpan + colPosition.col;
          for (var i = colPosition.col; i < setMax; i++) {
            this.colYs[i] = setHeight;
          }

          return position;
        };

        proto._getTopColPosition = function (colSpan) {
          var colGroup = this._getTopColGroup(colSpan);
          // get the minimum Y value from the columns
          var minimumY = Math.min.apply(Math, colGroup);

          return {
            col: colGroup.indexOf(minimumY),
            y: minimumY,
          };
        };

        /**
         * @param {Number} colSpan - number of columns the element spans
         * @returns {Array} colGroup
         */
        proto._getTopColGroup = function (colSpan) {
          if (colSpan < 2) {
            // if brick spans only one column, use all the column Ys
            return this.colYs;
          }

          var colGroup = [];
          // how many different places could this brick fit horizontally
          var groupCount = this.cols + 1 - colSpan;
          // for each group potential horizontal position
          for (var i = 0; i < groupCount; i++) {
            colGroup[i] = this._getColGroupY(i, colSpan);
          }
          return colGroup;
        };

        proto._getColGroupY = function (col, colSpan) {
          if (colSpan < 2) {
            return this.colYs[col];
          }
          // make an array of colY values for that one group
          var groupColYs = this.colYs.slice(col, col + colSpan);
          // and get the max value of the array
          return Math.max.apply(Math, groupColYs);
        };

        // get column position based on horizontal index. #873
        proto._getHorizontalColPosition = function (colSpan, item) {
          var col = this.horizontalColIndex % this.cols;
          var isOver = colSpan > 1 && col + colSpan > this.cols;
          // shift to next row if item can't fit on current row
          col = isOver ? 0 : col;
          // don't let zero-size items take up space
          var hasSize = item.size.outerWidth && item.size.outerHeight;
          this.horizontalColIndex = hasSize
            ? col + colSpan
            : this.horizontalColIndex;

          return {
            col: col,
            y: this._getColGroupY(col, colSpan),
          };
        };

        proto._manageStamp = function (stamp) {
          var stampSize = getSize(stamp);
          var offset = this._getElementOffset(stamp);
          // get the columns that this stamp affects
          var isOriginLeft = this._getOption("originLeft");
          var firstX = isOriginLeft ? offset.left : offset.right;
          var lastX = firstX + stampSize.outerWidth;
          var firstCol = Math.floor(firstX / this.columnWidth);
          firstCol = Math.max(0, firstCol);
          var lastCol = Math.floor(lastX / this.columnWidth);
          // lastCol should not go over if multiple of columnWidth #425
          lastCol -= lastX % this.columnWidth ? 0 : 1;
          lastCol = Math.min(this.cols - 1, lastCol);
          // set colYs to bottom of the stamp

          var isOriginTop = this._getOption("originTop");
          var stampMaxY =
            (isOriginTop ? offset.top : offset.bottom) + stampSize.outerHeight;
          for (var i = firstCol; i <= lastCol; i++) {
            this.colYs[i] = Math.max(stampMaxY, this.colYs[i]);
          }
        };

        proto._getContainerSize = function () {
          this.maxY = Math.max.apply(Math, this.colYs);
          var size = {
            height: this.maxY,
          };

          if (this._getOption("fitWidth")) {
            size.width = this._getContainerFitWidth();
          }

          return size;
        };

        proto._getContainerFitWidth = function () {
          var unusedCols = 0;
          // count unused columns
          var i = this.cols;
          while (--i) {
            if (this.colYs[i] !== 0) {
              break;
            }
            unusedCols++;
          }
          // fit container to columns that have been used
          return (this.cols - unusedCols) * this.columnWidth - this.gutter;
        };

        proto.needsResizeLayout = function () {
          var previousWidth = this.containerWidth;
          this.getContainerWidth();
          return previousWidth != this.containerWidth;
        };

        return Masonry;
      });

      /***/
    },
    /* 146 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;
      var EventHandler = /** @class */ (function () {
        function EventHandler() {
          this.events = [];
        }
        EventHandler.prototype.register = function (el, event, listener) {
          if (!el || !event || !listener) return null;
          this.events.push({ el: el, event: event, listener: listener });
          el.addEventListener(event, listener);
          return { el: el, event: event, listener: listener };
        };
        EventHandler.prototype.unregister = function (_a) {
          var el = _a.el,
            event = _a.event,
            listener = _a.listener;
          if (!el || !event || !listener) return null;
          this.events = this.events.filter(function (e) {
            return el !== e.el || event !== e.event || listener !== e.listener;
          });
          el.removeEventListener(event, listener);
          return { el: el, event: event, listener: listener };
        };
        EventHandler.prototype.unregisterAll = function () {
          this.events.forEach(function (_a) {
            var el = _a.el,
              event = _a.event,
              listener = _a.listener;
            return el.removeEventListener(event, listener);
          });
          this.events = [];
        };
        return EventHandler;
      })();
      exports["default"] = EventHandler;

      /***/
    },
    /* 147 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_FACTORY__,
        __WEBPACK_AMD_DEFINE_ARRAY__,
        __WEBPACK_AMD_DEFINE_RESULT__;
      /*********************************************************************
       * @license
       *  #### Twitter Post Fetcher v17.1.0 ####
       *  Coded by Jason Mayes 2015. A present to all the developers out there.
       *  www.jasonmayes.com
       *  Please keep this disclaimer with my code if you use it. Thanks. :-)
       *  Got feedback or questions, ask here:
       *  http://www.jasonmayes.com/projects/twitterApi/
       *  Github: https://github.com/jasonmayes/Twitter-Post-Fetcher
       *  Updates will be posted to this site.
       *********************************************************************/
      !(function (e, t) {
        true
          ? !((__WEBPACK_AMD_DEFINE_ARRAY__ = []),
            (__WEBPACK_AMD_DEFINE_FACTORY__ = t),
            (__WEBPACK_AMD_DEFINE_RESULT__ =
              typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
                ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(
                    exports,
                    __WEBPACK_AMD_DEFINE_ARRAY__
                  )
                : __WEBPACK_AMD_DEFINE_FACTORY__),
            __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
              (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
          : undefined;
      })(0, function () {
        var _ = "",
          y = 20,
          T = !0,
          k = [],
          C = !1,
          x = !0,
          E = !0,
          N = null,
          A = !0,
          I = !0,
          B = null,
          L = !0,
          M = !1,
          i = !1,
          R = !1,
          H = !0,
          a = "en",
          j = !0,
          q = !1,
          n = null;
        function P(e) {
          return e
            .replace(/<b[^>]*>(.*?)<\/b>/gi, function (e, t) {
              return t;
            })
            .replace(
              /class="(?!(tco-hidden|tco-display|tco-ellipsis))+.*?"|data-query-source=".*?"|dir=".*?"|rel=".*?"/gi,
              ""
            );
        }
        function S(e) {
          for (
            var t = e.getElementsByTagName("a"), i = t.length - 1;
            0 <= i;
            i--
          )
            t[i].setAttribute("target", "_blank");
        }
        function U(e, t) {
          for (
            var i = [],
              a = new RegExp("(^| )" + t + "( |$)"),
              n = e.getElementsByTagName("*"),
              s = 0,
              l = n.length;
            s < l;
            s++
          )
            a.test(n[s].className) && i.push(n[s]);
          return i;
        }
        function F(e) {
          if (void 0 !== e && 0 <= e.innerHTML.indexOf("data-image")) {
            var t = e.innerHTML.split('data-image="')[1].split('"')[0];
            return decodeURIComponent(t) + ".jpg";
          }
        }
        var O = {
          fetch: function (e) {
            if (
              (void 0 === e.maxTweets && (e.maxTweets = 20),
              void 0 === e.enableLinks && (e.enableLinks = !0),
              void 0 === e.showUser && (e.showUser = !0),
              void 0 === e.showTime && (e.showTime = !0),
              void 0 === e.dateFunction && (e.dateFunction = "default"),
              void 0 === e.showRetweet && (e.showRetweet = !0),
              void 0 === e.customCallback && (e.customCallback = null),
              void 0 === e.showInteraction && (e.showInteraction = !0),
              void 0 === e.showImages && (e.showImages = !1),
              void 0 === e.showReplies && (e.showReplies = !1),
              void 0 === e.useEmoji && (e.useEmoji = !1),
              void 0 === e.linksInNewWindow && (e.linksInNewWindow = !0),
              void 0 === e.showPermalinks && (e.showPermalinks = !0),
              void 0 === e.dataOnly && (e.dataOnly = !1),
              C)
            )
              k.push(e);
            else {
              (C = !0),
                (_ = e.domId),
                (y = e.maxTweets),
                (T = e.enableLinks),
                (E = e.showUser),
                (x = e.showTime),
                (I = e.showRetweet),
                (N = e.dateFunction),
                (B = e.customCallback),
                (L = e.showInteraction),
                (M = e.showImages),
                (i = e.showReplies),
                (R = e.useEmoji),
                (H = e.linksInNewWindow),
                (j = e.showPermalinks),
                (q = e.dataOnly);
              var t = document.getElementsByTagName("head")[0];
              null !== n && t.removeChild(n),
                ((n = document.createElement("script")).type =
                  "text/javascript"),
                void 0 !== e.list
                  ? (n.src =
                      "https://syndication.twitter.com/timeline/list?callback=__twttrf.callback&dnt=false&list_slug=" +
                      e.list.listSlug +
                      "&screen_name=" +
                      e.list.screenName +
                      "&suppress_response_codes=true&lang=" +
                      (e.lang || a) +
                      "&rnd=" +
                      Math.random())
                  : void 0 !== e.profile
                  ? (n.src =
                      "https://syndication.twitter.com/timeline/profile?callback=__twttrf.callback&dnt=false&screen_name=" +
                      e.profile.screenName +
                      "&with_replies=" +
                      i +
                      "&suppress_response_codes=true&lang=" +
                      (e.lang || a) +
                      "&rnd=" +
                      Math.random())
                  : void 0 !== e.likes
                  ? (n.src =
                      "https://syndication.twitter.com/timeline/likes?callback=__twttrf.callback&dnt=false&screen_name=" +
                      e.likes.screenName +
                      "&suppress_response_codes=true&lang=" +
                      (e.lang || a) +
                      "&rnd=" +
                      Math.random())
                  : (n.src =
                      "https://cdn.syndication.twimg.com/widgets/timelines/" +
                      e.id +
                      "?&lang=" +
                      (e.lang || a) +
                      "&callback=__twttrf.callback&suppress_response_codes=true&rnd=" +
                      Math.random()),
                t.appendChild(n);
            }
          },
          callback: function (e) {
            if (void 0 === e || void 0 === e.body)
              return (
                (C = !1), void (0 < k.length && (O.fetch(k[0]), k.splice(0, 1)))
              );
            R ||
              (e.body = e.body.replace(
                /(<img[^c]*class="Emoji[^>]*>)|(<img[^c]*class="u-block[^>]*>)/g,
                ""
              )),
              M ||
                (e.body = e.body.replace(
                  /(<img[^c]*class="NaturalImage-image[^>]*>|(<img[^c]*class="CroppedImage-image[^>]*>))/g,
                  ""
                )),
              E ||
                (e.body = e.body.replace(
                  /(<img[^c]*class="Avatar"[^>]*>)/g,
                  ""
                ));
            var t = document.createElement("div");
            function i(e) {
              var t = e.getElementsByTagName("img")[0];
              return (
                t && t.length && (t.src = t.getAttribute("data-src-2x")), e
              );
            }
            (t.innerHTML = e.body),
              void 0 === t.getElementsByClassName && (A = !1);
            var a = [],
              n = [],
              s = [],
              l = [],
              r = [],
              o = [],
              c = [],
              d = 0;
            if (A)
              for (
                var m = t.getElementsByClassName("timeline-Tweet");
                d < m.length;

              )
                0 <
                m[d].getElementsByClassName("timeline-Tweet-retweetCredit")
                  .length
                  ? r.push(!0)
                  : r.push(!1),
                  (!r[d] || (r[d] && I)) &&
                    (a.push(
                      m[d].getElementsByClassName("timeline-Tweet-text")[0]
                    ),
                    o.push(m[d].getAttribute("data-tweet-id")),
                    E &&
                      n.push(
                        i(
                          m[d].getElementsByClassName(
                            "timeline-Tweet-author"
                          )[0]
                        )
                      ),
                    s.push(m[d].getElementsByClassName("dt-updated")[0]),
                    c.push(
                      m[d].getElementsByClassName("timeline-Tweet-timestamp")[0]
                    ),
                    void 0 !==
                    m[d].getElementsByClassName("timeline-Tweet-media")[0]
                      ? l.push(
                          m[d].getElementsByClassName("timeline-Tweet-media")[0]
                        )
                      : l.push(void 0)),
                  d++;
            else
              for (m = U(t, "timeline-Tweet"); d < m.length; )
                0 < U(m[d], "timeline-Tweet-retweetCredit").length
                  ? r.push(!0)
                  : r.push(!1),
                  (!r[d] || (r[d] && I)) &&
                    (a.push(U(m[d], "timeline-Tweet-text")[0]),
                    o.push(m[d].getAttribute("data-tweet-id")),
                    E && n.push(i(U(m[d], "timeline-Tweet-author")[0])),
                    s.push(U(m[d], "dt-updated")[0]),
                    c.push(U(m[d], "timeline-Tweet-timestamp")[0]),
                    void 0 !== U(m[d], "timeline-Tweet-media")[0]
                      ? l.push(U(m[d], "timeline-Tweet-media")[0])
                      : l.push(void 0)),
                  d++;
            a.length > y &&
              (a.splice(y, a.length - y),
              n.splice(y, n.length - y),
              s.splice(y, s.length - y),
              r.splice(y, r.length - y),
              l.splice(y, l.length - y),
              c.splice(y, c.length - y));
            var p = [],
              u = ((d = a.length), 0);
            if (q)
              for (; u < d; )
                p.push({
                  tweet: a[u].innerHTML,
                  author: n[u] ? n[u].innerHTML : "Unknown Author",
                  author_data: {
                    profile_url: n[u]
                      ? n[u].querySelector('[data-scribe="element:user_link"]')
                          .href
                      : null,
                    profile_image: n[u]
                      ? n[u]
                          .querySelector('[data-scribe="element:avatar"]')
                          .getAttribute("data-src-1x")
                      : null,
                    profile_image_2x: n[u]
                      ? n[u]
                          .querySelector('[data-scribe="element:avatar"]')
                          .getAttribute("data-src-2x")
                      : null,
                    screen_name: n[u]
                      ? n[u].querySelector(
                          '[data-scribe="element:screen_name"]'
                        ).title
                      : null,
                    name: n[u]
                      ? n[u].querySelector('[data-scribe="element:name"]').title
                      : null,
                  },
                  time: s[u].textContent,
                  timestamp: s[u]
                    .getAttribute("datetime")
                    .replace("+0000", "Z")
                    .replace(/([\+\-])(\d\d)(\d\d)/, "$1$2:$3"),
                  image: F(l[u]),
                  rt: r[u],
                  tid: o[u],
                  permalinkURL: void 0 === c[u] ? "" : c[u].href,
                }),
                  u++;
            else
              for (; u < d; ) {
                if ("string" != typeof N) {
                  var h = s[u].getAttribute("datetime"),
                    g = new Date(
                      s[u]
                        .getAttribute("datetime")
                        .replace(/-/g, "/")
                        .replace("T", " ")
                        .split("+")[0]
                    ),
                    w = N(g, h);
                  if ((s[u].setAttribute("aria-label", w), a[u].textContent))
                    if (A) s[u].textContent = w;
                    else {
                      var f = document.createElement("p"),
                        v = document.createTextNode(w);
                      f.appendChild(v),
                        f.setAttribute("aria-label", w),
                        (s[u] = f);
                    }
                  else s[u].textContent = w;
                }
                var b = "";
                T
                  ? (H && (S(a[u]), E && S(n[u])),
                    E &&
                      (b +=
                        '<div class="user">' + P(n[u].innerHTML) + "</div>"),
                    (b += '<p class="tweet">' + P(a[u].innerHTML) + "</p>"),
                    x &&
                      (b += j
                        ? '<p class="timePosted"><a href="' +
                          c[u] +
                          '">' +
                          s[u].getAttribute("aria-label") +
                          "</a></p>"
                        : '<p class="timePosted">' +
                          s[u].getAttribute("aria-label") +
                          "</p>"))
                  : (a[u].textContent,
                    E && (b += '<p class="user">' + n[u].textContent + "</p>"),
                    (b += '<p class="tweet">' + a[u].textContent + "</p>"),
                    x &&
                      (b +=
                        '<p class="timePosted">' + s[u].textContent + "</p>")),
                  L &&
                    (b +=
                      '<p class="interact"><a href="https://twitter.com/intent/tweet?in_reply_to=' +
                      o[u] +
                      '" class="twitter_reply_icon"' +
                      (H ? ' target="_blank">' : ">") +
                      'Reply</a><a href="https://twitter.com/intent/retweet?tweet_id=' +
                      o[u] +
                      '" class="twitter_retweet_icon"' +
                      (H ? ' target="_blank">' : ">") +
                      'Retweet</a><a href="https://twitter.com/intent/favorite?tweet_id=' +
                      o[u] +
                      '" class="twitter_fav_icon"' +
                      (H ? ' target="_blank">' : ">") +
                      "Favorite</a></p>"),
                  M &&
                    void 0 !== l[u] &&
                    void 0 !== F(l[u]) &&
                    (b +=
                      '<div class="media"><img src="' +
                      F(l[u]) +
                      '" alt="Image from tweet" /></div>'),
                  M ? p.push(b) : !M && a[u].textContent.length && p.push(b),
                  u++;
              }
            !(function (e) {
              if (null === B) {
                for (
                  var t = e.length,
                    i = 0,
                    a = document.getElementById(_),
                    n = "<ul>";
                  i < t;

                )
                  (n += "<li>" + e[i] + "</li>"), i++;
                (n += "</ul>"), (a.innerHTML = n);
              } else B(e);
            })(p),
              (C = !1),
              0 < k.length && (O.fetch(k[0]), k.splice(0, 1));
          },
        };
        return (window.__twttrf = O), (window.twitterFetcher = O);
      });

      /***/
    },
    /* 148 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(107);
      __webpack_require__(113);
      module.exports = __webpack_require__(11).Symbol;

      /***/
    },
    /* 149 */
    /***/ function (module, exports, __webpack_require__) {
      // all enumerable object keys, includes symbols
      var getKeys = __webpack_require__(30);
      var gOPS = __webpack_require__(62);
      var pIE = __webpack_require__(56);
      module.exports = function (it) {
        var result = getKeys(it);
        var getSymbols = gOPS.f;
        if (getSymbols) {
          var symbols = getSymbols(it);
          var isEnum = pIE.f;
          var i = 0;
          var key;
          while (symbols.length > i)
            if (isEnum.call(it, (key = symbols[i++]))) result.push(key);
        }
        return result;
      };

      /***/
    },
    /* 150 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(114);
      module.exports = __webpack_require__(11).Object.assign;

      /***/
    },
    /* 151 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(64);
      module.exports = __webpack_require__(11).Array.values;

      /***/
    },
    /* 152 */
    /***/ function (module, exports) {
      /*!
       * Trend 0.2.0
       *
       * Fail-safe TransitionEnd event for jQuery.
       *
       * Adds a new "trend" event that can be used in browsers that don't
       * support "transitionend".
       *
       * NOTE: Only supports being bound with "jQuery.one".
       *
       * Copyright 2014, Pixel Union - http://pixelunion.net
       * Released under the MIT license
       */
      (function ($) {
        // Prefixed transitionend event names
        var transitionEndEvents =
          "webkitTransitionEnd " +
          "otransitionend " +
          "oTransitionEnd " +
          "msTransitionEnd " +
          "transitionend";

        // Prefixed transition duration property names
        var transitionDurationProperties = [
          "transition-duration",
          "-moz-transition-duration",
          "-webkit-transition-duration",
          "-ms-transition-duration",
          "-o-transition-duration",
          "-khtml-transition-duration",
        ];

        // Prefixed transition delay property names
        var transitionDelayProperties = [
          "transition-delay",
          "-moz-transition-delay",
          "-webkit-transition-delay",
          "-ms-transition-delay",
          "-o-transition-delay",
          "-khtml-transition-delay",
        ];

        // Parses a CSS time value into milliseconds.
        var parseTime = function (s) {
          s = s.replace(/\s/, "");
          var v = window.parseFloat(s);

          return s.match(/[^m]s$/i) ? v * 1000 : v;
        };

        // Parses the longest time unit found in a series of CSS properties.
        // Returns a value in milliseconds.
        var parseProperties = function (el, properties) {
          var duration = 0;

          for (var i = 0; i < properties.length; i++) {
            // Get raw CSS value
            var value = el.css(properties[i]);
            if (!value) continue;

            // Multiple transitions--pick the longest
            if (value.indexOf(",") !== -1) {
              var values = value.split(",");
              var durations = (function () {
                var results = [];
                for (var i = 0; i < values.length; i++) {
                  var duration = parseTime(values[i]);
                  results.push(duration);
                }
                return results;
              })();

              duration = Math.max.apply(Math, durations);
            }

            // Single transition
            else {
              duration = parseTime(value);
            }

            // Accept first vaue
            break;
          }

          return duration;
        };

        $.event.special.trend = {
          // Triggers an event handler when an element is done transitioning.
          //
          // Handles browsers that don't support transitionend by adding a
          // timeout with the transition duration.
          add: function (handleObj) {
            var el = $(this);
            var fired = false;

            // Mark element as being in transition
            el.data("trend", true);

            // Calculate a fallback duration. + 20 because some browsers fire
            // timeouts faster than transitionend.
            var time =
              parseProperties(el, transitionDurationProperties) +
              parseProperties(el, transitionDelayProperties) +
              20;

            var cb = function (e) {
              // transitionend events can be sent for each property. Let's just
              // skip all but the first. Also handles the timeout callback.
              if (fired) return;

              // Child elements that also have transitions can be fired before we
              // complete. This will catch and ignore those. Unfortunately, we'll
              // have to rely on the timeout in these cases.
              if (e && e.srcElement !== el[0]) return;

              // Mark element has not being in transition
              el.data("trend", false);

              // Callback
              fired = true;
              if (handleObj.handler) handleObj.handler();
            };

            el.one(transitionEndEvents, cb);
            el.data("trend-timeout", window.setTimeout(cb, time));
          },

          remove: function (handleObj) {
            var el = $(this);
            el.off(transitionEndEvents);
            window.clearTimeout(el.data("trend-timeout"));
          },
        };
      })(jQuery);

      /***/
    },
    /* 153 */
    /***/ function (module, exports) {
      /*!
       * Revealer 2.0.0
       *
       * Copyright 2015, Pixel Union - http://pixelunion.net
       * Released under the MIT license
       */
      (function ($) {
        // check for trend event (make sure jquery.trend is included)
        if (typeof $.event.special.trend !== "object") {
          console.warn(
            "Please make sure jquery.trend is included! Otherwise revealer won't work."
          );
        }

        // Simple requestAnimationFrame polyfill
        var raf =
          window.requestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          function (fn) {
            window.setTimeout(fn, 1000 / 60);
          };

        // Public API
        var methods = {
          isVisible: function (el) {
            return !!el.data("revealer-visible");
          },

          show: function (el, force) {
            // Check state
            if (methods.isVisible(el)) {
              el.removeClass("animating animating-in");
              el.off("revealer-animating revealer-show");
              return;
            }

            // Remove previous event listeners
            el.data("revealer-visible", true);
            el.off("trend");

            if (force) {
              el.addClass("visible");
              raf(function () {
                el.trigger("revealer-animating");
                el.trigger("revealer-show");
              });
              return;
            }

            raf(function () {
              // Start animation state transition
              el.addClass("animating animating-in");
              el.trigger("revealer-animating");

              raf(function () {
                el.addClass("visible");

                el.one("trend", function () {
                  el.removeClass("animating animating-in");
                  el.trigger("revealer-show");
                });
              });
            });
          },

          hide: function (el, force) {
            // Check state
            if (!methods.isVisible(el)) {
              el.removeClass("animating animating-out visible");
              el.off("revealer-animating revealer-hide");
              return;
            }

            // Remove previous event listeners
            el.data("revealer-visible", false);
            el.off("trend");

            if (force) {
              el.removeClass("visible");
              raf(function () {
                el.trigger("revealer-animating");
                el.trigger("revealer-hide");
              });
              return;
            }

            raf(function () {
              el.addClass("animating animating-out");
              el.trigger("revealer-animating");

              raf(function () {
                el.removeClass("visible");

                el.one("trend", function () {
                  el.removeClass("animating animating-in animating-out");
                  el.trigger("revealer-hide");
                });
              });
            });
          },

          toggle: function (el, force) {
            if (methods.isVisible(el)) {
              methods.hide(el, force);
            } else {
              methods.show(el, force);
            }
          },
        };

        // jQuery plugin
        $.fn.revealer = function (method, force) {
          // Get action
          var action = methods[method || "toggle"];
          if (!action) return this;

          // Run action
          if (method === "isVisible") {
            return action(this);
          }

          return this.each(function () {
            action($(this), force);
          });
        };
      })(jQuery);

      /***/
    },
    /* 154 */
    /***/ function (module, exports) {
      // Global function called by Google on auth errors.
      // Show an auto error message on all map instances.
      function gm_authFailure() {
        // Editor check
        var isThemeEditor = window.Shopify && window.Shopify.designMode;
        if (!isThemeEditor) return;
        var maps = document.querySelectorAll("[data-map-container]");
        var javascriptApi =
          "https://developers.google.com/maps/documentation/javascript/get-api-key";
        var geocodingApi =
          "https://developers.google.com/maps/documentation/geocoding/get-api-key";
        var errorMessage =
          '\n    <p>\n      The API key you entered is invalid. To activate your map:\n      <ol>\n        <li>\n          Generate both <a href="'
            .concat(
              javascriptApi,
              '" target="_blank">JavaScript</a>\n          and <a href="'
            )
            .concat(
              geocodingApi,
              '" target="_blank">Geocoding</a> API keys.\n        </li>\n        <li>Copy and paste one of them into the theme editor.</li>\n        <li>Save your changes to verify the new API key.</li>\n      </ol>\n    </p>\n  '
            );
        maps.forEach(function (map) {
          map.innerHTML = '<div class="map-error-message">'.concat(
            errorMessage,
            "</div>"
          );
        });
      }

      window.gm_authFailure = gm_authFailure;

      /***/
    },
    /* 155 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
      /*!
       * Outlayer v2.1.1
       * the brains and guts of a layout library
       * MIT license
       */

      (function (window, factory) {
        "use strict";
        // universal module definition
        /* jshint strict: false */ /* globals define, module, require */
        if (true) {
          // AMD - RequireJS
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(57),
            __webpack_require__(58),
            __webpack_require__(32),
            __webpack_require__(157),
          ]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (
            EvEmitter,
            getSize,
            utils,
            Item
          ) {
            return factory(window, EvEmitter, getSize, utils, Item);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
            (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(window, function factory(window, EvEmitter, getSize, utils, Item) {
        "use strict";

        // ----- vars ----- //

        var console = window.console;
        var jQuery = window.jQuery;
        var noop = function () {};

        // -------------------------- Outlayer -------------------------- //

        // globally unique identifiers
        var GUID = 0;
        // internal store of all Outlayer intances
        var instances = {};

        /**
         * @param {Element, String} element
         * @param {Object} options
         * @constructor
         */
        function Outlayer(element, options) {
          var queryElement = utils.getQueryElement(element);
          if (!queryElement) {
            if (console) {
              console.error(
                "Bad element for " +
                  this.constructor.namespace +
                  ": " +
                  (queryElement || element)
              );
            }
            return;
          }
          this.element = queryElement;
          // add jQuery
          if (jQuery) {
            this.$element = jQuery(this.element);
          }

          // options
          this.options = utils.extend({}, this.constructor.defaults);
          this.option(options);

          // add id for Outlayer.getFromElement
          var id = ++GUID;
          this.element.outlayerGUID = id; // expando
          instances[id] = this; // associate via id

          // kick it off
          this._create();

          var isInitLayout = this._getOption("initLayout");
          if (isInitLayout) {
            this.layout();
          }
        }

        // settings are for internal use only
        Outlayer.namespace = "outlayer";
        Outlayer.Item = Item;

        // default options
        Outlayer.defaults = {
          containerStyle: {
            position: "relative",
          },
          initLayout: true,
          originLeft: true,
          originTop: true,
          resize: true,
          resizeContainer: true,
          // item options
          transitionDuration: "0.4s",
          hiddenStyle: {
            opacity: 0,
            transform: "scale(0.001)",
          },
          visibleStyle: {
            opacity: 1,
            transform: "scale(1)",
          },
        };

        var proto = Outlayer.prototype;
        // inherit EvEmitter
        utils.extend(proto, EvEmitter.prototype);

        /**
         * set options
         * @param {Object} opts
         */
        proto.option = function (opts) {
          utils.extend(this.options, opts);
        };

        /**
         * get backwards compatible option value, check old name
         */
        proto._getOption = function (option) {
          var oldOption = this.constructor.compatOptions[option];
          return oldOption && this.options[oldOption] !== undefined
            ? this.options[oldOption]
            : this.options[option];
        };

        Outlayer.compatOptions = {
          // currentName: oldName
          initLayout: "isInitLayout",
          horizontal: "isHorizontal",
          layoutInstant: "isLayoutInstant",
          originLeft: "isOriginLeft",
          originTop: "isOriginTop",
          resize: "isResizeBound",
          resizeContainer: "isResizingContainer",
        };

        proto._create = function () {
          // get items from children
          this.reloadItems();
          // elements that affect layout, but are not laid out
          this.stamps = [];
          this.stamp(this.options.stamp);
          // set container style
          utils.extend(this.element.style, this.options.containerStyle);

          // bind resize method
          var canBindResize = this._getOption("resize");
          if (canBindResize) {
            this.bindResize();
          }
        };

        // goes through all children again and gets bricks in proper order
        proto.reloadItems = function () {
          // collection of item elements
          this.items = this._itemize(this.element.children);
        };

        /**
         * turn elements into Outlayer.Items to be used in layout
         * @param {Array or NodeList or HTMLElement} elems
         * @returns {Array} items - collection of new Outlayer Items
         */
        proto._itemize = function (elems) {
          var itemElems = this._filterFindItemElements(elems);
          var Item = this.constructor.Item;

          // create new Outlayer Items for collection
          var items = [];
          for (var i = 0; i < itemElems.length; i++) {
            var elem = itemElems[i];
            var item = new Item(elem, this);
            items.push(item);
          }

          return items;
        };

        /**
         * get item elements to be used in layout
         * @param {Array or NodeList or HTMLElement} elems
         * @returns {Array} items - item elements
         */
        proto._filterFindItemElements = function (elems) {
          return utils.filterFindElements(elems, this.options.itemSelector);
        };

        /**
         * getter method for getting item elements
         * @returns {Array} elems - collection of item elements
         */
        proto.getItemElements = function () {
          return this.items.map(function (item) {
            return item.element;
          });
        };

        // ----- init & layout ----- //

        /**
         * lays out all items
         */
        proto.layout = function () {
          this._resetLayout();
          this._manageStamps();

          // don't animate first layout
          var layoutInstant = this._getOption("layoutInstant");
          var isInstant =
            layoutInstant !== undefined ? layoutInstant : !this._isLayoutInited;
          this.layoutItems(this.items, isInstant);

          // flag for initalized
          this._isLayoutInited = true;
        };

        // _init is alias for layout
        proto._init = proto.layout;

        /**
         * logic before any new layout
         */
        proto._resetLayout = function () {
          this.getSize();
        };

        proto.getSize = function () {
          this.size = getSize(this.element);
        };

        /**
         * get measurement from option, for columnWidth, rowHeight, gutter
         * if option is String -> get element from selector string, & get size of element
         * if option is Element -> get size of element
         * else use option as a number
         *
         * @param {String} measurement
         * @param {String} size - width or height
         * @private
         */
        proto._getMeasurement = function (measurement, size) {
          var option = this.options[measurement];
          var elem;
          if (!option) {
            // default to 0
            this[measurement] = 0;
          } else {
            // use option as an element
            if (typeof option == "string") {
              elem = this.element.querySelector(option);
            } else if (option instanceof HTMLElement) {
              elem = option;
            }
            // use size of element, if element
            this[measurement] = elem ? getSize(elem)[size] : option;
          }
        };

        /**
         * layout a collection of item elements
         * @api public
         */
        proto.layoutItems = function (items, isInstant) {
          items = this._getItemsForLayout(items);

          this._layoutItems(items, isInstant);

          this._postLayout();
        };

        /**
         * get the items to be laid out
         * you may want to skip over some items
         * @param {Array} items
         * @returns {Array} items
         */
        proto._getItemsForLayout = function (items) {
          return items.filter(function (item) {
            return !item.isIgnored;
          });
        };

        /**
         * layout items
         * @param {Array} items
         * @param {Boolean} isInstant
         */
        proto._layoutItems = function (items, isInstant) {
          this._emitCompleteOnItems("layout", items);

          if (!items || !items.length) {
            // no items, emit event with empty array
            return;
          }

          var queue = [];

          items.forEach(function (item) {
            // get x/y object from method
            var position = this._getItemLayoutPosition(item);
            // enqueue
            position.item = item;
            position.isInstant = isInstant || item.isLayoutInstant;
            queue.push(position);
          }, this);

          this._processLayoutQueue(queue);
        };

        /**
         * get item layout position
         * @param {Outlayer.Item} item
         * @returns {Object} x and y position
         */
        proto._getItemLayoutPosition = function (/* item */) {
          return {
            x: 0,
            y: 0,
          };
        };

        /**
         * iterate over array and position each item
         * Reason being - separating this logic prevents 'layout invalidation'
         * thx @paul_irish
         * @param {Array} queue
         */
        proto._processLayoutQueue = function (queue) {
          this.updateStagger();
          queue.forEach(function (obj, i) {
            this._positionItem(obj.item, obj.x, obj.y, obj.isInstant, i);
          }, this);
        };

        // set stagger from option in milliseconds number
        proto.updateStagger = function () {
          var stagger = this.options.stagger;
          if (stagger === null || stagger === undefined) {
            this.stagger = 0;
            return;
          }
          this.stagger = getMilliseconds(stagger);
          return this.stagger;
        };

        /**
         * Sets position of item in DOM
         * @param {Outlayer.Item} item
         * @param {Number} x - horizontal position
         * @param {Number} y - vertical position
         * @param {Boolean} isInstant - disables transitions
         */
        proto._positionItem = function (item, x, y, isInstant, i) {
          if (isInstant) {
            // if not transition, just set CSS
            item.goTo(x, y);
          } else {
            item.stagger(i * this.stagger);
            item.moveTo(x, y);
          }
        };

        /**
         * Any logic you want to do after each layout,
         * i.e. size the container
         */
        proto._postLayout = function () {
          this.resizeContainer();
        };

        proto.resizeContainer = function () {
          var isResizingContainer = this._getOption("resizeContainer");
          if (!isResizingContainer) {
            return;
          }
          var size = this._getContainerSize();
          if (size) {
            this._setContainerMeasure(size.width, true);
            this._setContainerMeasure(size.height, false);
          }
        };

        /**
         * Sets width or height of container if returned
         * @returns {Object} size
         *   @param {Number} width
         *   @param {Number} height
         */
        proto._getContainerSize = noop;

        /**
         * @param {Number} measure - size of width or height
         * @param {Boolean} isWidth
         */
        proto._setContainerMeasure = function (measure, isWidth) {
          if (measure === undefined) {
            return;
          }

          var elemSize = this.size;
          // add padding and border width if border box
          if (elemSize.isBorderBox) {
            measure += isWidth
              ? elemSize.paddingLeft +
                elemSize.paddingRight +
                elemSize.borderLeftWidth +
                elemSize.borderRightWidth
              : elemSize.paddingBottom +
                elemSize.paddingTop +
                elemSize.borderTopWidth +
                elemSize.borderBottomWidth;
          }

          measure = Math.max(measure, 0);
          this.element.style[isWidth ? "width" : "height"] = measure + "px";
        };

        /**
         * emit eventComplete on a collection of items events
         * @param {String} eventName
         * @param {Array} items - Outlayer.Items
         */
        proto._emitCompleteOnItems = function (eventName, items) {
          var _this = this;
          function onComplete() {
            _this.dispatchEvent(eventName + "Complete", null, [items]);
          }

          var count = items.length;
          if (!items || !count) {
            onComplete();
            return;
          }

          var doneCount = 0;
          function tick() {
            doneCount++;
            if (doneCount == count) {
              onComplete();
            }
          }

          // bind callback
          items.forEach(function (item) {
            item.once(eventName, tick);
          });
        };

        /**
         * emits events via EvEmitter and jQuery events
         * @param {String} type - name of event
         * @param {Event} event - original event
         * @param {Array} args - extra arguments
         */
        proto.dispatchEvent = function (type, event, args) {
          // add original event to arguments
          var emitArgs = event ? [event].concat(args) : args;
          this.emitEvent(type, emitArgs);

          if (jQuery) {
            // set this.$element
            this.$element = this.$element || jQuery(this.element);
            if (event) {
              // create jQuery event
              var $event = jQuery.Event(event);
              $event.type = type;
              this.$element.trigger($event, args);
            } else {
              // just trigger with type if no event available
              this.$element.trigger(type, args);
            }
          }
        };

        // -------------------------- ignore & stamps -------------------------- //

        /**
         * keep item in collection, but do not lay it out
         * ignored items do not get skipped in layout
         * @param {Element} elem
         */
        proto.ignore = function (elem) {
          var item = this.getItem(elem);
          if (item) {
            item.isIgnored = true;
          }
        };

        /**
         * return item to layout collection
         * @param {Element} elem
         */
        proto.unignore = function (elem) {
          var item = this.getItem(elem);
          if (item) {
            delete item.isIgnored;
          }
        };

        /**
         * adds elements to stamps
         * @param {NodeList, Array, Element, or String} elems
         */
        proto.stamp = function (elems) {
          elems = this._find(elems);
          if (!elems) {
            return;
          }

          this.stamps = this.stamps.concat(elems);
          // ignore
          elems.forEach(this.ignore, this);
        };

        /**
         * removes elements to stamps
         * @param {NodeList, Array, or Element} elems
         */
        proto.unstamp = function (elems) {
          elems = this._find(elems);
          if (!elems) {
            return;
          }

          elems.forEach(function (elem) {
            // filter out removed stamp elements
            utils.removeFrom(this.stamps, elem);
            this.unignore(elem);
          }, this);
        };

        /**
         * finds child elements
         * @param {NodeList, Array, Element, or String} elems
         * @returns {Array} elems
         */
        proto._find = function (elems) {
          if (!elems) {
            return;
          }
          // if string, use argument as selector string
          if (typeof elems == "string") {
            elems = this.element.querySelectorAll(elems);
          }
          elems = utils.makeArray(elems);
          return elems;
        };

        proto._manageStamps = function () {
          if (!this.stamps || !this.stamps.length) {
            return;
          }

          this._getBoundingRect();

          this.stamps.forEach(this._manageStamp, this);
        };

        // update boundingLeft / Top
        proto._getBoundingRect = function () {
          // get bounding rect for container element
          var boundingRect = this.element.getBoundingClientRect();
          var size = this.size;
          this._boundingRect = {
            left: boundingRect.left + size.paddingLeft + size.borderLeftWidth,
            top: boundingRect.top + size.paddingTop + size.borderTopWidth,
            right:
              boundingRect.right - (size.paddingRight + size.borderRightWidth),
            bottom:
              boundingRect.bottom -
              (size.paddingBottom + size.borderBottomWidth),
          };
        };

        /**
         * @param {Element} stamp
         **/
        proto._manageStamp = noop;

        /**
         * get x/y position of element relative to container element
         * @param {Element} elem
         * @returns {Object} offset - has left, top, right, bottom
         */
        proto._getElementOffset = function (elem) {
          var boundingRect = elem.getBoundingClientRect();
          var thisRect = this._boundingRect;
          var size = getSize(elem);
          var offset = {
            left: boundingRect.left - thisRect.left - size.marginLeft,
            top: boundingRect.top - thisRect.top - size.marginTop,
            right: thisRect.right - boundingRect.right - size.marginRight,
            bottom: thisRect.bottom - boundingRect.bottom - size.marginBottom,
          };
          return offset;
        };

        // -------------------------- resize -------------------------- //

        // enable event handlers for listeners
        // i.e. resize -> onresize
        proto.handleEvent = utils.handleEvent;

        /**
         * Bind layout to window resizing
         */
        proto.bindResize = function () {
          window.addEventListener("resize", this);
          this.isResizeBound = true;
        };

        /**
         * Unbind layout to window resizing
         */
        proto.unbindResize = function () {
          window.removeEventListener("resize", this);
          this.isResizeBound = false;
        };

        proto.onresize = function () {
          this.resize();
        };

        utils.debounceMethod(Outlayer, "onresize", 100);

        proto.resize = function () {
          // don't trigger if size did not change
          // or if resize was unbound. See #9
          if (!this.isResizeBound || !this.needsResizeLayout()) {
            return;
          }

          this.layout();
        };

        /**
         * check if layout is needed post layout
         * @returns Boolean
         */
        proto.needsResizeLayout = function () {
          var size = getSize(this.element);
          // check that this.size and size are there
          // IE8 triggers resize on body size change, so they might not be
          var hasSizes = this.size && size;
          return hasSizes && size.innerWidth !== this.size.innerWidth;
        };

        // -------------------------- methods -------------------------- //

        /**
         * add items to Outlayer instance
         * @param {Array or NodeList or Element} elems
         * @returns {Array} items - Outlayer.Items
         **/
        proto.addItems = function (elems) {
          var items = this._itemize(elems);
          // add items to collection
          if (items.length) {
            this.items = this.items.concat(items);
          }
          return items;
        };

        /**
         * Layout newly-appended item elements
         * @param {Array or NodeList or Element} elems
         */
        proto.appended = function (elems) {
          var items = this.addItems(elems);
          if (!items.length) {
            return;
          }
          // layout and reveal just the new items
          this.layoutItems(items, true);
          this.reveal(items);
        };

        /**
         * Layout prepended elements
         * @param {Array or NodeList or Element} elems
         */
        proto.prepended = function (elems) {
          var items = this._itemize(elems);
          if (!items.length) {
            return;
          }
          // add items to beginning of collection
          var previousItems = this.items.slice(0);
          this.items = items.concat(previousItems);
          // start new layout
          this._resetLayout();
          this._manageStamps();
          // layout new stuff without transition
          this.layoutItems(items, true);
          this.reveal(items);
          // layout previous items
          this.layoutItems(previousItems);
        };

        /**
         * reveal a collection of items
         * @param {Array of Outlayer.Items} items
         */
        proto.reveal = function (items) {
          this._emitCompleteOnItems("reveal", items);
          if (!items || !items.length) {
            return;
          }
          var stagger = this.updateStagger();
          items.forEach(function (item, i) {
            item.stagger(i * stagger);
            item.reveal();
          });
        };

        /**
         * hide a collection of items
         * @param {Array of Outlayer.Items} items
         */
        proto.hide = function (items) {
          this._emitCompleteOnItems("hide", items);
          if (!items || !items.length) {
            return;
          }
          var stagger = this.updateStagger();
          items.forEach(function (item, i) {
            item.stagger(i * stagger);
            item.hide();
          });
        };

        /**
         * reveal item elements
         * @param {Array}, {Element}, {NodeList} items
         */
        proto.revealItemElements = function (elems) {
          var items = this.getItems(elems);
          this.reveal(items);
        };

        /**
         * hide item elements
         * @param {Array}, {Element}, {NodeList} items
         */
        proto.hideItemElements = function (elems) {
          var items = this.getItems(elems);
          this.hide(items);
        };

        /**
         * get Outlayer.Item, given an Element
         * @param {Element} elem
         * @param {Function} callback
         * @returns {Outlayer.Item} item
         */
        proto.getItem = function (elem) {
          // loop through items to get the one that matches
          for (var i = 0; i < this.items.length; i++) {
            var item = this.items[i];
            if (item.element == elem) {
              // return item
              return item;
            }
          }
        };

        /**
         * get collection of Outlayer.Items, given Elements
         * @param {Array} elems
         * @returns {Array} items - Outlayer.Items
         */
        proto.getItems = function (elems) {
          elems = utils.makeArray(elems);
          var items = [];
          elems.forEach(function (elem) {
            var item = this.getItem(elem);
            if (item) {
              items.push(item);
            }
          }, this);

          return items;
        };

        /**
         * remove element(s) from instance and DOM
         * @param {Array or NodeList or Element} elems
         */
        proto.remove = function (elems) {
          var removeItems = this.getItems(elems);

          this._emitCompleteOnItems("remove", removeItems);

          // bail if no items to remove
          if (!removeItems || !removeItems.length) {
            return;
          }

          removeItems.forEach(function (item) {
            item.remove();
            // remove item from collection
            utils.removeFrom(this.items, item);
          }, this);
        };

        // ----- destroy ----- //

        // remove and disable Outlayer instance
        proto.destroy = function () {
          // clean up dynamic styles
          var style = this.element.style;
          style.height = "";
          style.position = "";
          style.width = "";
          // destroy items
          this.items.forEach(function (item) {
            item.destroy();
          });

          this.unbindResize();

          var id = this.element.outlayerGUID;
          delete instances[id]; // remove reference to instance by id
          delete this.element.outlayerGUID;
          // remove data for jQuery
          if (jQuery) {
            jQuery.removeData(this.element, this.constructor.namespace);
          }
        };

        // -------------------------- data -------------------------- //

        /**
         * get Outlayer instance from element
         * @param {Element} elem
         * @returns {Outlayer}
         */
        Outlayer.data = function (elem) {
          elem = utils.getQueryElement(elem);
          var id = elem && elem.outlayerGUID;
          return id && instances[id];
        };

        // -------------------------- create Outlayer class -------------------------- //

        /**
         * create a layout class
         * @param {String} namespace
         */
        Outlayer.create = function (namespace, options) {
          // sub-class Outlayer
          var Layout = subclass(Outlayer);
          // apply new options and compatOptions
          Layout.defaults = utils.extend({}, Outlayer.defaults);
          utils.extend(Layout.defaults, options);
          Layout.compatOptions = utils.extend({}, Outlayer.compatOptions);

          Layout.namespace = namespace;

          Layout.data = Outlayer.data;

          // sub-class Item
          Layout.Item = subclass(Item);

          // -------------------------- declarative -------------------------- //

          utils.htmlInit(Layout, namespace);

          // -------------------------- jQuery bridge -------------------------- //

          // make into jQuery plugin
          if (jQuery && jQuery.bridget) {
            jQuery.bridget(namespace, Layout);
          }

          return Layout;
        };

        function subclass(Parent) {
          function SubClass() {
            Parent.apply(this, arguments);
          }

          SubClass.prototype = Object.create(Parent.prototype);
          SubClass.prototype.constructor = SubClass;

          return SubClass;
        }

        // ----- helpers ----- //

        // how many milliseconds are in each unit
        var msUnits = {
          ms: 1,
          s: 1000,
        };

        // munge time-like parameter into millisecond number
        // '0.4s' -> 40
        function getMilliseconds(time) {
          if (typeof time == "number") {
            return time;
          }
          var matches = time.match(/(^\d*\.?\d*)(\w*)/);
          var num = matches && matches[1];
          var unit = matches && matches[2];
          if (!num.length) {
            return 0;
          }
          num = parseFloat(num);
          var mult = msUnits[unit] || 1;
          return num * mult;
        }

        // ----- fin ----- //

        // back in global
        Outlayer.Item = Item;

        return Outlayer;
      });

      /***/
    },
    /* 156 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;
      /**
       * matchesSelector v2.0.2
       * matchesSelector( element, '.selector' )
       * MIT license
       */

      /*jshint browser: true, strict: true, undef: true, unused: true */

      (function (window, factory) {
        /*global define: false, module: false */
        "use strict";
        // universal module definition
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
          (__WEBPACK_AMD_DEFINE_RESULT__ =
            typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
              ? __WEBPACK_AMD_DEFINE_FACTORY__.call(
                  exports,
                  __webpack_require__,
                  exports,
                  module
                )
              : __WEBPACK_AMD_DEFINE_FACTORY__),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
            (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(window, function factory() {
        "use strict";

        var matchesMethod = (function () {
          var ElemProto = window.Element.prototype;
          // check for the standard method name first
          if (ElemProto.matches) {
            return "matches";
          }
          // check un-prefixed
          if (ElemProto.matchesSelector) {
            return "matchesSelector";
          }
          // check vendor prefixes
          var prefixes = ["webkit", "moz", "ms", "o"];

          for (var i = 0; i < prefixes.length; i++) {
            var prefix = prefixes[i];
            var method = prefix + "MatchesSelector";
            if (ElemProto[method]) {
              return method;
            }
          }
        })();

        return function matchesSelector(elem, selector) {
          return elem[matchesMethod](selector);
        };
      });

      /***/
    },
    /* 157 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_FACTORY__,
        __WEBPACK_AMD_DEFINE_ARRAY__,
        __WEBPACK_AMD_DEFINE_RESULT__;
      /**
       * Outlayer Item
       */

      (function (window, factory) {
        // universal module definition
        /* jshint strict: false */ /* globals define, module, require */
        if (true) {
          // AMD - RequireJS
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(57),
            __webpack_require__(58),
          ]),
          (__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
          (__WEBPACK_AMD_DEFINE_RESULT__ =
            typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
              ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(
                  exports,
                  __WEBPACK_AMD_DEFINE_ARRAY__
                )
              : __WEBPACK_AMD_DEFINE_FACTORY__),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
            (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(window, function factory(EvEmitter, getSize) {
        "use strict";

        // ----- helpers ----- //

        function isEmptyObj(obj) {
          for (var prop in obj) {
            return false;
          }
          prop = null;
          return true;
        }

        // -------------------------- CSS3 support -------------------------- //

        var docElemStyle = document.documentElement.style;

        var transitionProperty =
          typeof docElemStyle.transition == "string"
            ? "transition"
            : "WebkitTransition";
        var transformProperty =
          typeof docElemStyle.transform == "string"
            ? "transform"
            : "WebkitTransform";

        var transitionEndEvent = {
          WebkitTransition: "webkitTransitionEnd",
          transition: "transitionend",
        }[transitionProperty];

        // cache all vendor properties that could have vendor prefix
        var vendorProperties = {
          transform: transformProperty,
          transition: transitionProperty,
          transitionDuration: transitionProperty + "Duration",
          transitionProperty: transitionProperty + "Property",
          transitionDelay: transitionProperty + "Delay",
        };

        // -------------------------- Item -------------------------- //

        function Item(element, layout) {
          if (!element) {
            return;
          }

          this.element = element;
          // parent layout class, i.e. Masonry, Isotope, or Packery
          this.layout = layout;
          this.position = {
            x: 0,
            y: 0,
          };

          this._create();
        }

        // inherit EvEmitter
        var proto = (Item.prototype = Object.create(EvEmitter.prototype));
        proto.constructor = Item;

        proto._create = function () {
          // transition objects
          this._transn = {
            ingProperties: {},
            clean: {},
            onEnd: {},
          };

          this.css({
            position: "absolute",
          });
        };

        // trigger specified handler for event type
        proto.handleEvent = function (event) {
          var method = "on" + event.type;
          if (this[method]) {
            this[method](event);
          }
        };

        proto.getSize = function () {
          this.size = getSize(this.element);
        };

        /**
         * apply CSS styles to element
         * @param {Object} style
         */
        proto.css = function (style) {
          var elemStyle = this.element.style;

          for (var prop in style) {
            // use vendor property if available
            var supportedProp = vendorProperties[prop] || prop;
            elemStyle[supportedProp] = style[prop];
          }
        };

        // measure position, and sets it
        proto.getPosition = function () {
          var style = getComputedStyle(this.element);
          var isOriginLeft = this.layout._getOption("originLeft");
          var isOriginTop = this.layout._getOption("originTop");
          var xValue = style[isOriginLeft ? "left" : "right"];
          var yValue = style[isOriginTop ? "top" : "bottom"];
          var x = parseFloat(xValue);
          var y = parseFloat(yValue);
          // convert percent to pixels
          var layoutSize = this.layout.size;
          if (xValue.indexOf("%") != -1) {
            x = (x / 100) * layoutSize.width;
          }
          if (yValue.indexOf("%") != -1) {
            y = (y / 100) * layoutSize.height;
          }
          // clean up 'auto' or other non-integer values
          x = isNaN(x) ? 0 : x;
          y = isNaN(y) ? 0 : y;
          // remove padding from measurement
          x -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;
          y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;

          this.position.x = x;
          this.position.y = y;
        };

        // set settled position, apply padding
        proto.layoutPosition = function () {
          var layoutSize = this.layout.size;
          var style = {};
          var isOriginLeft = this.layout._getOption("originLeft");
          var isOriginTop = this.layout._getOption("originTop");

          // x
          var xPadding = isOriginLeft ? "paddingLeft" : "paddingRight";
          var xProperty = isOriginLeft ? "left" : "right";
          var xResetProperty = isOriginLeft ? "right" : "left";

          var x = this.position.x + layoutSize[xPadding];
          // set in percentage or pixels
          style[xProperty] = this.getXValue(x);
          // reset other property
          style[xResetProperty] = "";

          // y
          var yPadding = isOriginTop ? "paddingTop" : "paddingBottom";
          var yProperty = isOriginTop ? "top" : "bottom";
          var yResetProperty = isOriginTop ? "bottom" : "top";

          var y = this.position.y + layoutSize[yPadding];
          // set in percentage or pixels
          style[yProperty] = this.getYValue(y);
          // reset other property
          style[yResetProperty] = "";

          this.css(style);
          this.emitEvent("layout", [this]);
        };

        proto.getXValue = function (x) {
          var isHorizontal = this.layout._getOption("horizontal");
          return this.layout.options.percentPosition && !isHorizontal
            ? (x / this.layout.size.width) * 100 + "%"
            : x + "px";
        };

        proto.getYValue = function (y) {
          var isHorizontal = this.layout._getOption("horizontal");
          return this.layout.options.percentPosition && isHorizontal
            ? (y / this.layout.size.height) * 100 + "%"
            : y + "px";
        };

        proto._transitionTo = function (x, y) {
          this.getPosition();
          // get current x & y from top/left
          var curX = this.position.x;
          var curY = this.position.y;

          var didNotMove = x == this.position.x && y == this.position.y;

          // save end position
          this.setPosition(x, y);

          // if did not move and not transitioning, just go to layout
          if (didNotMove && !this.isTransitioning) {
            this.layoutPosition();
            return;
          }

          var transX = x - curX;
          var transY = y - curY;
          var transitionStyle = {};
          transitionStyle.transform = this.getTranslate(transX, transY);

          this.transition({
            to: transitionStyle,
            onTransitionEnd: {
              transform: this.layoutPosition,
            },
            isCleaning: true,
          });
        };

        proto.getTranslate = function (x, y) {
          // flip cooridinates if origin on right or bottom
          var isOriginLeft = this.layout._getOption("originLeft");
          var isOriginTop = this.layout._getOption("originTop");
          x = isOriginLeft ? x : -x;
          y = isOriginTop ? y : -y;
          return "translate3d(" + x + "px, " + y + "px, 0)";
        };

        // non transition + transform support
        proto.goTo = function (x, y) {
          this.setPosition(x, y);
          this.layoutPosition();
        };

        proto.moveTo = proto._transitionTo;

        proto.setPosition = function (x, y) {
          this.position.x = parseFloat(x);
          this.position.y = parseFloat(y);
        };

        // ----- transition ----- //

        /**
         * @param {Object} style - CSS
         * @param {Function} onTransitionEnd
         */

        // non transition, just trigger callback
        proto._nonTransition = function (args) {
          this.css(args.to);
          if (args.isCleaning) {
            this._removeStyles(args.to);
          }
          for (var prop in args.onTransitionEnd) {
            args.onTransitionEnd[prop].call(this);
          }
        };

        /**
         * proper transition
         * @param {Object} args - arguments
         *   @param {Object} to - style to transition to
         *   @param {Object} from - style to start transition from
         *   @param {Boolean} isCleaning - removes transition styles after transition
         *   @param {Function} onTransitionEnd - callback
         */
        proto.transition = function (args) {
          // redirect to nonTransition if no transition duration
          if (!parseFloat(this.layout.options.transitionDuration)) {
            this._nonTransition(args);
            return;
          }

          var _transition = this._transn;
          // keep track of onTransitionEnd callback by css property
          for (var prop in args.onTransitionEnd) {
            _transition.onEnd[prop] = args.onTransitionEnd[prop];
          }
          // keep track of properties that are transitioning
          for (prop in args.to) {
            _transition.ingProperties[prop] = true;
            // keep track of properties to clean up when transition is done
            if (args.isCleaning) {
              _transition.clean[prop] = true;
            }
          }

          // set from styles
          if (args.from) {
            this.css(args.from);
            // force redraw. http://blog.alexmaccaw.com/css-transitions
            var h = this.element.offsetHeight;
            // hack for JSHint to hush about unused var
            h = null;
          }
          // enable transition
          this.enableTransition(args.to);
          // set styles that are transitioning
          this.css(args.to);

          this.isTransitioning = true;
        };

        // dash before all cap letters, including first for
        // WebkitTransform => -webkit-transform
        function toDashedAll(str) {
          return str.replace(/([A-Z])/g, function ($1) {
            return "-" + $1.toLowerCase();
          });
        }

        var transitionProps = "opacity," + toDashedAll(transformProperty);

        proto.enableTransition = function (/* style */) {
          // HACK changing transitionProperty during a transition
          // will cause transition to jump
          if (this.isTransitioning) {
            return;
          }

          // make `transition: foo, bar, baz` from style object
          // HACK un-comment this when enableTransition can work
          // while a transition is happening
          // var transitionValues = [];
          // for ( var prop in style ) {
          //   // dash-ify camelCased properties like WebkitTransition
          //   prop = vendorProperties[ prop ] || prop;
          //   transitionValues.push( toDashedAll( prop ) );
          // }
          // munge number to millisecond, to match stagger
          var duration = this.layout.options.transitionDuration;
          duration = typeof duration == "number" ? duration + "ms" : duration;
          // enable transition styles
          this.css({
            transitionProperty: transitionProps,
            transitionDuration: duration,
            transitionDelay: this.staggerDelay || 0,
          });
          // listen for transition end event
          this.element.addEventListener(transitionEndEvent, this, false);
        };

        // ----- events ----- //

        proto.onwebkitTransitionEnd = function (event) {
          this.ontransitionend(event);
        };

        proto.onotransitionend = function (event) {
          this.ontransitionend(event);
        };

        // properties that I munge to make my life easier
        var dashedVendorProperties = {
          "-webkit-transform": "transform",
        };

        proto.ontransitionend = function (event) {
          // disregard bubbled events from children
          if (event.target !== this.element) {
            return;
          }
          var _transition = this._transn;
          // get property name of transitioned property, convert to prefix-free
          var propertyName =
            dashedVendorProperties[event.propertyName] || event.propertyName;

          // remove property that has completed transitioning
          delete _transition.ingProperties[propertyName];
          // check if any properties are still transitioning
          if (isEmptyObj(_transition.ingProperties)) {
            // all properties have completed transitioning
            this.disableTransition();
          }
          // clean style
          if (propertyName in _transition.clean) {
            // clean up style
            this.element.style[event.propertyName] = "";
            delete _transition.clean[propertyName];
          }
          // trigger onTransitionEnd callback
          if (propertyName in _transition.onEnd) {
            var onTransitionEnd = _transition.onEnd[propertyName];
            onTransitionEnd.call(this);
            delete _transition.onEnd[propertyName];
          }

          this.emitEvent("transitionEnd", [this]);
        };

        proto.disableTransition = function () {
          this.removeTransitionStyles();
          this.element.removeEventListener(transitionEndEvent, this, false);
          this.isTransitioning = false;
        };

        /**
         * removes style property from element
         * @param {Object} style
         **/
        proto._removeStyles = function (style) {
          // clean up transition styles
          var cleanStyle = {};
          for (var prop in style) {
            cleanStyle[prop] = "";
          }
          this.css(cleanStyle);
        };

        var cleanTransitionStyle = {
          transitionProperty: "",
          transitionDuration: "",
          transitionDelay: "",
        };

        proto.removeTransitionStyles = function () {
          // remove transition
          this.css(cleanTransitionStyle);
        };

        // ----- stagger ----- //

        proto.stagger = function (delay) {
          delay = isNaN(delay) ? 0 : delay;
          this.staggerDelay = delay + "ms";
        };

        // ----- show/hide/remove ----- //

        // remove element from DOM
        proto.removeElem = function () {
          this.element.parentNode.removeChild(this.element);
          // remove display: none
          this.css({ display: "" });
          this.emitEvent("remove", [this]);
        };

        proto.remove = function () {
          // just remove element if no transition support or no transition
          if (
            !transitionProperty ||
            !parseFloat(this.layout.options.transitionDuration)
          ) {
            this.removeElem();
            return;
          }

          // start transition
          this.once("transitionEnd", function () {
            this.removeElem();
          });
          this.hide();
        };

        proto.reveal = function () {
          delete this.isHidden;
          // remove display: none
          this.css({ display: "" });

          var options = this.layout.options;

          var onTransitionEnd = {};
          var transitionEndProperty =
            this.getHideRevealTransitionEndProperty("visibleStyle");
          onTransitionEnd[transitionEndProperty] = this.onRevealTransitionEnd;

          this.transition({
            from: options.hiddenStyle,
            to: options.visibleStyle,
            isCleaning: true,
            onTransitionEnd: onTransitionEnd,
          });
        };

        proto.onRevealTransitionEnd = function () {
          // check if still visible
          // during transition, item may have been hidden
          if (!this.isHidden) {
            this.emitEvent("reveal");
          }
        };

        /**
         * get style property use for hide/reveal transition end
         * @param {String} styleProperty - hiddenStyle/visibleStyle
         * @returns {String}
         */
        proto.getHideRevealTransitionEndProperty = function (styleProperty) {
          var optionStyle = this.layout.options[styleProperty];
          // use opacity
          if (optionStyle.opacity) {
            return "opacity";
          }
          // get first property
          for (var prop in optionStyle) {
            return prop;
          }
        };

        proto.hide = function () {
          // set flag
          this.isHidden = true;
          // remove display: none
          this.css({ display: "" });

          var options = this.layout.options;

          var onTransitionEnd = {};
          var transitionEndProperty =
            this.getHideRevealTransitionEndProperty("hiddenStyle");
          onTransitionEnd[transitionEndProperty] = this.onHideTransitionEnd;

          this.transition({
            from: options.visibleStyle,
            to: options.hiddenStyle,
            // keep hidden stuff hidden
            isCleaning: true,
            onTransitionEnd: onTransitionEnd,
          });
        };

        proto.onHideTransitionEnd = function () {
          // check if still hidden
          // during transition, item may have been un-hidden
          if (this.isHidden) {
            this.css({ display: "none" });
            this.emitEvent("hide");
          }
        };

        proto.destroy = function () {
          this.css({
            position: "",
            left: "",
            right: "",
            top: "",
            bottom: "",
            transition: "",
            transform: "",
          });
        };

        return Item;
      });

      /***/
    },
    /* 158 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // Flickity.Cell
      (function (window, factory) {
        // universal module definition
        /* jshint strict: false */
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(58)]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (getSize) {
            return factory(window, getSize);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
            (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(window, function factory(window, getSize) {
        "use strict";

        function Cell(elem, parent) {
          this.element = elem;
          this.parent = parent;

          this.create();
        }

        var proto = Cell.prototype;

        proto.create = function () {
          this.element.style.position = "absolute";
          this.element.setAttribute("aria-hidden", "true");
          this.x = 0;
          this.shift = 0;
        };

        proto.destroy = function () {
          // reset style
          this.unselect();
          this.element.style.position = "";
          var side = this.parent.originSide;
          this.element.style[side] = "";
        };

        proto.getSize = function () {
          this.size = getSize(this.element);
        };

        proto.setPosition = function (x) {
          this.x = x;
          this.updateTarget();
          this.renderPosition(x);
        };

        // setDefaultTarget v1 method, backwards compatibility, remove in v3
        proto.updateTarget = proto.setDefaultTarget = function () {
          var marginProperty =
            this.parent.originSide == "left" ? "marginLeft" : "marginRight";
          this.target =
            this.x +
            this.size[marginProperty] +
            this.size.width * this.parent.cellAlign;
        };

        proto.renderPosition = function (x) {
          // render position of cell with in slider
          var side = this.parent.originSide;
          this.element.style[side] = this.parent.getPositionValue(x);
        };

        proto.select = function () {
          this.element.classList.add("is-selected");
          this.element.removeAttribute("aria-hidden");
        };

        proto.unselect = function () {
          this.element.classList.remove("is-selected");
          this.element.setAttribute("aria-hidden", "true");
        };

        /**
         * @param {Integer} factor - 0, 1, or -1
         **/
        proto.wrapShift = function (shift) {
          this.shift = shift;
          this.renderPosition(this.x + this.parent.slideableWidth * shift);
        };

        proto.remove = function () {
          this.element.parentNode.removeChild(this.element);
        };

        return Cell;
      });

      /***/
    },
    /* 159 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__; // slide
      (function (window, factory) {
        // universal module definition
        /* jshint strict: false */
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
          (__WEBPACK_AMD_DEFINE_RESULT__ =
            typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
              ? __WEBPACK_AMD_DEFINE_FACTORY__.call(
                  exports,
                  __webpack_require__,
                  exports,
                  module
                )
              : __WEBPACK_AMD_DEFINE_FACTORY__),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
            (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(window, function factory() {
        "use strict";

        function Slide(parent) {
          this.parent = parent;
          this.isOriginLeft = parent.originSide == "left";
          this.cells = [];
          this.outerWidth = 0;
          this.height = 0;
        }

        var proto = Slide.prototype;

        proto.addCell = function (cell) {
          this.cells.push(cell);
          this.outerWidth += cell.size.outerWidth;
          this.height = Math.max(cell.size.outerHeight, this.height);
          // first cell stuff
          if (this.cells.length == 1) {
            this.x = cell.x; // x comes from first cell
            var beginMargin = this.isOriginLeft ? "marginLeft" : "marginRight";
            this.firstMargin = cell.size[beginMargin];
          }
        };

        proto.updateTarget = function () {
          var endMargin = this.isOriginLeft ? "marginRight" : "marginLeft";
          var lastCell = this.getLastCell();
          var lastMargin = lastCell ? lastCell.size[endMargin] : 0;
          var slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
          this.target =
            this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
        };

        proto.getLastCell = function () {
          return this.cells[this.cells.length - 1];
        };

        proto.select = function () {
          this.cells.forEach(function (cell) {
            cell.select();
          });
        };

        proto.unselect = function () {
          this.cells.forEach(function (cell) {
            cell.unselect();
          });
        };

        proto.getCellElements = function () {
          return this.cells.map(function (cell) {
            return cell.element;
          });
        };

        return Slide;
      });

      /***/
    },
    /* 160 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // animate
      (function (window, factory) {
        // universal module definition
        /* jshint strict: false */
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(32)]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (utils) {
            return factory(window, utils);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
            (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(window, function factory(window, utils) {
        "use strict";

        // -------------------------- animate -------------------------- //

        var proto = {};

        proto.startAnimation = function () {
          if (this.isAnimating) {
            return;
          }

          this.isAnimating = true;
          this.restingFrames = 0;
          this.animate();
        };

        proto.animate = function () {
          this.applyDragForce();
          this.applySelectedAttraction();

          var previousX = this.x;

          this.integratePhysics();
          this.positionSlider();
          this.settle(previousX);
          // animate next frame
          if (this.isAnimating) {
            var _this = this;
            requestAnimationFrame(function animateFrame() {
              _this.animate();
            });
          }
        };

        proto.positionSlider = function () {
          var x = this.x;
          // wrap position around
          if (this.options.wrapAround && this.cells.length > 1) {
            x = utils.modulo(x, this.slideableWidth);
            x = x - this.slideableWidth;
            this.shiftWrapCells(x);
          }

          this.setTranslateX(x, this.isAnimating);
          this.dispatchScrollEvent();
        };

        proto.setTranslateX = function (x, is3d) {
          x += this.cursorPosition;
          // reverse if right-to-left and using transform
          x = this.options.rightToLeft ? -x : x;
          var translateX = this.getPositionValue(x);
          // use 3D tranforms for hardware acceleration on iOS
          // but use 2D when settled, for better font-rendering
          this.slider.style.transform = is3d
            ? "translate3d(" + translateX + ",0,0)"
            : "translateX(" + translateX + ")";
        };

        proto.dispatchScrollEvent = function () {
          var firstSlide = this.slides[0];
          if (!firstSlide) {
            return;
          }
          var positionX = -this.x - firstSlide.target;
          var progress = positionX / this.slidesWidth;
          this.dispatchEvent("scroll", null, [progress, positionX]);
        };

        proto.positionSliderAtSelected = function () {
          if (!this.cells.length) {
            return;
          }
          this.x = -this.selectedSlide.target;
          this.velocity = 0; // stop wobble
          this.positionSlider();
        };

        proto.getPositionValue = function (position) {
          if (this.options.percentPosition) {
            // percent position, round to 2 digits, like 12.34%
            return (
              Math.round((position / this.size.innerWidth) * 10000) * 0.01 + "%"
            );
          } else {
            // pixel positioning
            return Math.round(position) + "px";
          }
        };

        proto.settle = function (previousX) {
          // keep track of frames where x hasn't moved
          if (
            !this.isPointerDown &&
            Math.round(this.x * 100) == Math.round(previousX * 100)
          ) {
            this.restingFrames++;
          }
          // stop animating if resting for 3 or more frames
          if (this.restingFrames > 2) {
            this.isAnimating = false;
            delete this.isFreeScrolling;
            // render position with translateX when settled
            this.positionSlider();
            this.dispatchEvent("settle", null, [this.selectedIndex]);
          }
        };

        proto.shiftWrapCells = function (x) {
          // shift before cells
          var beforeGap = this.cursorPosition + x;
          this._shiftCells(this.beforeShiftCells, beforeGap, -1);
          // shift after cells
          var afterGap =
            this.size.innerWidth -
            (x + this.slideableWidth + this.cursorPosition);
          this._shiftCells(this.afterShiftCells, afterGap, 1);
        };

        proto._shiftCells = function (cells, gap, shift) {
          for (var i = 0; i < cells.length; i++) {
            var cell = cells[i];
            var cellShift = gap > 0 ? shift : 0;
            cell.wrapShift(cellShift);
            gap -= cell.size.outerWidth;
          }
        };

        proto._unshiftCells = function (cells) {
          if (!cells || !cells.length) {
            return;
          }
          for (var i = 0; i < cells.length; i++) {
            cells[i].wrapShift(0);
          }
        };

        // -------------------------- physics -------------------------- //

        proto.integratePhysics = function () {
          this.x += this.velocity;
          this.velocity *= this.getFrictionFactor();
        };

        proto.applyForce = function (force) {
          this.velocity += force;
        };

        proto.getFrictionFactor = function () {
          return (
            1 -
            this.options[
              this.isFreeScrolling ? "freeScrollFriction" : "friction"
            ]
          );
        };

        proto.getRestingPosition = function () {
          // my thanks to Steven Wittens, who simplified this math greatly
          return this.x + this.velocity / (1 - this.getFrictionFactor());
        };

        proto.applyDragForce = function () {
          if (!this.isDraggable || !this.isPointerDown) {
            return;
          }
          // change the position to drag position by applying force
          var dragVelocity = this.dragX - this.x;
          var dragForce = dragVelocity - this.velocity;
          this.applyForce(dragForce);
        };

        proto.applySelectedAttraction = function () {
          // do not attract if pointer down or no slides
          var dragDown = this.isDraggable && this.isPointerDown;
          if (dragDown || this.isFreeScrolling || !this.slides.length) {
            return;
          }
          var distance = this.selectedSlide.target * -1 - this.x;
          var force = distance * this.options.selectedAttraction;
          this.applyForce(force);
        };

        return proto;
      });

      /***/
    },
    /* 161 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // drag
      (function (window, factory) {
        // universal module definition
        /* jshint strict: false */
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(47),
            __webpack_require__(162),
            __webpack_require__(32),
          ]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (
            Flickity,
            Unidragger,
            utils
          ) {
            return factory(window, Flickity, Unidragger, utils);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
            (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(window, function factory(window, Flickity, Unidragger, utils) {
        "use strict";

        // ----- defaults ----- //

        utils.extend(Flickity.defaults, {
          draggable: ">1",
          dragThreshold: 3,
        });

        // ----- create ----- //

        Flickity.createMethods.push("_createDrag");

        // -------------------------- drag prototype -------------------------- //

        var proto = Flickity.prototype;
        utils.extend(proto, Unidragger.prototype);
        proto._touchActionValue = "pan-y";

        // --------------------------  -------------------------- //

        var isTouch = "createTouch" in document;
        var isTouchmoveScrollCanceled = false;

        proto._createDrag = function () {
          this.on("activate", this.onActivateDrag);
          this.on("uiChange", this._uiChangeDrag);
          this.on("deactivate", this.onDeactivateDrag);
          this.on("cellChange", this.updateDraggable);
          // TODO updateDraggable on resize? if groupCells & slides change
          // HACK - add seemingly innocuous handler to fix iOS 10 scroll behavior
          // #457, RubaXa/Sortable#973
          if (isTouch && !isTouchmoveScrollCanceled) {
            window.addEventListener("touchmove", function () {});
            isTouchmoveScrollCanceled = true;
          }
        };

        proto.onActivateDrag = function () {
          this.handles = [this.viewport];
          this.bindHandles();
          this.updateDraggable();
        };

        proto.onDeactivateDrag = function () {
          this.unbindHandles();
          this.element.classList.remove("is-draggable");
        };

        proto.updateDraggable = function () {
          // disable dragging if less than 2 slides. #278
          if (this.options.draggable == ">1") {
            this.isDraggable = this.slides.length > 1;
          } else {
            this.isDraggable = this.options.draggable;
          }
          if (this.isDraggable) {
            this.element.classList.add("is-draggable");
          } else {
            this.element.classList.remove("is-draggable");
          }
        };

        // backwards compatibility
        proto.bindDrag = function () {
          this.options.draggable = true;
          this.updateDraggable();
        };

        proto.unbindDrag = function () {
          this.options.draggable = false;
          this.updateDraggable();
        };

        proto._uiChangeDrag = function () {
          delete this.isFreeScrolling;
        };

        // -------------------------- pointer events -------------------------- //

        proto.pointerDown = function (event, pointer) {
          if (!this.isDraggable) {
            this._pointerDownDefault(event, pointer);
            return;
          }
          var isOkay = this.okayPointerDown(event);
          if (!isOkay) {
            return;
          }

          this._pointerDownPreventDefault(event);
          this.pointerDownFocus(event);
          // blur
          if (document.activeElement != this.element) {
            // do not blur if already focused
            this.pointerDownBlur();
          }

          // stop if it was moving
          this.dragX = this.x;
          this.viewport.classList.add("is-pointer-down");
          // track scrolling
          this.pointerDownScroll = getScrollPosition();
          window.addEventListener("scroll", this);

          this._pointerDownDefault(event, pointer);
        };

        // default pointerDown logic, used for staticClick
        proto._pointerDownDefault = function (event, pointer) {
          // track start event position
          // Safari 9 overrides pageX and pageY. These values needs to be copied. #779
          this.pointerDownPointer = {
            pageX: pointer.pageX,
            pageY: pointer.pageY,
          };
          // bind move and end events
          this._bindPostStartEvents(event);
          this.dispatchEvent("pointerDown", event, [pointer]);
        };

        var focusNodes = {
          INPUT: true,
          TEXTAREA: true,
          SELECT: true,
        };

        proto.pointerDownFocus = function (event) {
          var isFocusNode = focusNodes[event.target.nodeName];
          if (!isFocusNode) {
            this.focus();
          }
        };

        proto._pointerDownPreventDefault = function (event) {
          var isTouchStart = event.type == "touchstart";
          var isTouchPointer = event.pointerType == "touch";
          var isFocusNode = focusNodes[event.target.nodeName];
          if (!isTouchStart && !isTouchPointer && !isFocusNode) {
            event.preventDefault();
          }
        };

        // ----- move ----- //

        proto.hasDragStarted = function (moveVector) {
          return Math.abs(moveVector.x) > this.options.dragThreshold;
        };

        // ----- up ----- //

        proto.pointerUp = function (event, pointer) {
          delete this.isTouchScrolling;
          this.viewport.classList.remove("is-pointer-down");
          this.dispatchEvent("pointerUp", event, [pointer]);
          this._dragPointerUp(event, pointer);
        };

        proto.pointerDone = function () {
          window.removeEventListener("scroll", this);
          delete this.pointerDownScroll;
        };

        // -------------------------- dragging -------------------------- //

        proto.dragStart = function (event, pointer) {
          if (!this.isDraggable) {
            return;
          }
          this.dragStartPosition = this.x;
          this.startAnimation();
          window.removeEventListener("scroll", this);
          this.dispatchEvent("dragStart", event, [pointer]);
        };

        proto.pointerMove = function (event, pointer) {
          var moveVector = this._dragPointerMove(event, pointer);
          this.dispatchEvent("pointerMove", event, [pointer, moveVector]);
          this._dragMove(event, pointer, moveVector);
        };

        proto.dragMove = function (event, pointer, moveVector) {
          if (!this.isDraggable) {
            return;
          }
          event.preventDefault();

          this.previousDragX = this.dragX;
          // reverse if right-to-left
          var direction = this.options.rightToLeft ? -1 : 1;
          if (this.options.wrapAround) {
            // wrap around move. #589
            moveVector.x = moveVector.x % this.slideableWidth;
          }
          var dragX = this.dragStartPosition + moveVector.x * direction;

          if (!this.options.wrapAround && this.slides.length) {
            // slow drag
            var originBound = Math.max(
              -this.slides[0].target,
              this.dragStartPosition
            );
            dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
            var endBound = Math.min(
              -this.getLastSlide().target,
              this.dragStartPosition
            );
            dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
          }

          this.dragX = dragX;

          this.dragMoveTime = new Date();
          this.dispatchEvent("dragMove", event, [pointer, moveVector]);
        };

        proto.dragEnd = function (event, pointer) {
          if (!this.isDraggable) {
            return;
          }
          if (this.options.freeScroll) {
            this.isFreeScrolling = true;
          }
          // set selectedIndex based on where flick will end up
          var index = this.dragEndRestingSelect();

          if (this.options.freeScroll && !this.options.wrapAround) {
            // if free-scroll & not wrap around
            // do not free-scroll if going outside of bounding slides
            // so bounding slides can attract slider, and keep it in bounds
            var restingX = this.getRestingPosition();
            this.isFreeScrolling =
              -restingX > this.slides[0].target &&
              -restingX < this.getLastSlide().target;
          } else if (!this.options.freeScroll && index == this.selectedIndex) {
            // boost selection if selected index has not changed
            index += this.dragEndBoostSelect();
          }
          delete this.previousDragX;
          // apply selection
          // TODO refactor this, selecting here feels weird
          // HACK, set flag so dragging stays in correct direction
          this.isDragSelect = this.options.wrapAround;
          this.select(index);
          delete this.isDragSelect;
          this.dispatchEvent("dragEnd", event, [pointer]);
        };

        proto.dragEndRestingSelect = function () {
          var restingX = this.getRestingPosition();
          // how far away from selected slide
          var distance = Math.abs(
            this.getSlideDistance(-restingX, this.selectedIndex)
          );
          // get closet resting going up and going down
          var positiveResting = this._getClosestResting(restingX, distance, 1);
          var negativeResting = this._getClosestResting(restingX, distance, -1);
          // use closer resting for wrap-around
          var index =
            positiveResting.distance < negativeResting.distance
              ? positiveResting.index
              : negativeResting.index;
          return index;
        };

        /**
         * given resting X and distance to selected cell
         * get the distance and index of the closest cell
         * @param {Number} restingX - estimated post-flick resting position
         * @param {Number} distance - distance to selected cell
         * @param {Integer} increment - +1 or -1, going up or down
         * @returns {Object} - { distance: {Number}, index: {Integer} }
         */
        proto._getClosestResting = function (restingX, distance, increment) {
          var index = this.selectedIndex;
          var minDistance = Infinity;
          var condition =
            this.options.contain && !this.options.wrapAround
              ? // if contain, keep going if distance is equal to minDistance
                function (d, md) {
                  return d <= md;
                }
              : function (d, md) {
                  return d < md;
                };
          while (condition(distance, minDistance)) {
            // measure distance to next cell
            index += increment;
            minDistance = distance;
            distance = this.getSlideDistance(-restingX, index);
            if (distance === null) {
              break;
            }
            distance = Math.abs(distance);
          }
          return {
            distance: minDistance,
            // selected was previous index
            index: index - increment,
          };
        };

        /**
         * measure distance between x and a slide target
         * @param {Number} x
         * @param {Integer} index - slide index
         */
        proto.getSlideDistance = function (x, index) {
          var len = this.slides.length;
          // wrap around if at least 2 slides
          var isWrapAround = this.options.wrapAround && len > 1;
          var slideIndex = isWrapAround ? utils.modulo(index, len) : index;
          var slide = this.slides[slideIndex];
          if (!slide) {
            return null;
          }
          // add distance for wrap-around slides
          var wrap = isWrapAround
            ? this.slideableWidth * Math.floor(index / len)
            : 0;
          return x - (slide.target + wrap);
        };

        proto.dragEndBoostSelect = function () {
          // do not boost if no previousDragX or dragMoveTime
          if (
            this.previousDragX === undefined ||
            !this.dragMoveTime ||
            // or if drag was held for 100 ms
            new Date() - this.dragMoveTime > 100
          ) {
            return 0;
          }

          var distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
          var delta = this.previousDragX - this.dragX;
          if (distance > 0 && delta > 0) {
            // boost to next if moving towards the right, and positive velocity
            return 1;
          } else if (distance < 0 && delta < 0) {
            // boost to previous if moving towards the left, and negative velocity
            return -1;
          }
          return 0;
        };

        // ----- staticClick ----- //

        proto.staticClick = function (event, pointer) {
          // get clickedCell, if cell was clicked
          var clickedCell = this.getParentCell(event.target);
          var cellElem = clickedCell && clickedCell.element;
          var cellIndex = clickedCell && this.cells.indexOf(clickedCell);
          this.dispatchEvent("staticClick", event, [
            pointer,
            cellElem,
            cellIndex,
          ]);
        };

        // ----- scroll ----- //

        proto.onscroll = function () {
          var scroll = getScrollPosition();
          var scrollMoveX = this.pointerDownScroll.x - scroll.x;
          var scrollMoveY = this.pointerDownScroll.y - scroll.y;
          // cancel click/tap if scroll is too much
          if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) {
            this._pointerDone();
          }
        };

        // ----- utils ----- //

        function getScrollPosition() {
          return {
            x: window.pageXOffset,
            y: window.pageYOffset,
          };
        }

        // -----  ----- //

        return Flickity;
      });

      /***/
    },
    /* 162 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
      /*!
       * Unidragger v2.3.0
       * Draggable base class
       * MIT license
       */

      /*jshint browser: true, unused: true, undef: true, strict: true */

      (function (window, factory) {
        // universal module definition
        /*jshint strict: false */ /*globals define, module, require */

        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(85)]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (Unipointer) {
            return factory(window, Unipointer);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
            (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(window, function factory(window, Unipointer) {
        "use strict";

        // -------------------------- Unidragger -------------------------- //

        function Unidragger() {}

        // inherit Unipointer & EvEmitter
        var proto = (Unidragger.prototype = Object.create(
          Unipointer.prototype
        ));

        // ----- bind start ----- //

        proto.bindHandles = function () {
          this._bindHandles(true);
        };

        proto.unbindHandles = function () {
          this._bindHandles(false);
        };

        /**
         * Add or remove start event
         * @param {Boolean} isAdd
         */
        proto._bindHandles = function (isAdd) {
          // munge isAdd, default to true
          isAdd = isAdd === undefined ? true : isAdd;
          // bind each handle
          var bindMethod = isAdd ? "addEventListener" : "removeEventListener";
          var touchAction = isAdd ? this._touchActionValue : "";
          for (var i = 0; i < this.handles.length; i++) {
            var handle = this.handles[i];
            this._bindStartEvent(handle, isAdd);
            handle[bindMethod]("click", this);
            // touch-action: none to override browser touch gestures. metafizzy/flickity#540
            if (window.PointerEvent) {
              handle.style.touchAction = touchAction;
            }
          }
        };

        // prototype so it can be overwriteable by Flickity
        proto._touchActionValue = "none";

        // ----- start event ----- //

        /**
         * pointer start
         * @param {Event} event
         * @param {Event or Touch} pointer
         */
        proto.pointerDown = function (event, pointer) {
          var isOkay = this.okayPointerDown(event);
          if (!isOkay) {
            return;
          }
          // track start event position
          this.pointerDownPointer = pointer;

          event.preventDefault();
          this.pointerDownBlur();
          // bind move and end events
          this._bindPostStartEvents(event);
          this.emitEvent("pointerDown", [event, pointer]);
        };

        // nodes that have text fields
        var cursorNodes = {
          TEXTAREA: true,
          INPUT: true,
          SELECT: true,
          OPTION: true,
        };

        // input types that do not have text fields
        var clickTypes = {
          radio: true,
          checkbox: true,
          button: true,
          submit: true,
          image: true,
          file: true,
        };

        // dismiss inputs with text fields. flickity#403, flickity#404
        proto.okayPointerDown = function (event) {
          var isCursorNode = cursorNodes[event.target.nodeName];
          var isClickType = clickTypes[event.target.type];
          var isOkay = !isCursorNode || isClickType;
          if (!isOkay) {
            this._pointerReset();
          }
          return isOkay;
        };

        // kludge to blur previously focused input
        proto.pointerDownBlur = function () {
          var focused = document.activeElement;
          // do not blur body for IE10, metafizzy/flickity#117
          var canBlur = focused && focused.blur && focused != document.body;
          if (canBlur) {
            focused.blur();
          }
        };

        // ----- move event ----- //

        /**
         * drag move
         * @param {Event} event
         * @param {Event or Touch} pointer
         */
        proto.pointerMove = function (event, pointer) {
          var moveVector = this._dragPointerMove(event, pointer);
          this.emitEvent("pointerMove", [event, pointer, moveVector]);
          this._dragMove(event, pointer, moveVector);
        };

        // base pointer move logic
        proto._dragPointerMove = function (event, pointer) {
          var moveVector = {
            x: pointer.pageX - this.pointerDownPointer.pageX,
            y: pointer.pageY - this.pointerDownPointer.pageY,
          };
          // start drag if pointer has moved far enough to start drag
          if (!this.isDragging && this.hasDragStarted(moveVector)) {
            this._dragStart(event, pointer);
          }
          return moveVector;
        };

        // condition if pointer has moved far enough to start drag
        proto.hasDragStarted = function (moveVector) {
          return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
        };

        // ----- end event ----- //

        /**
         * pointer up
         * @param {Event} event
         * @param {Event or Touch} pointer
         */
        proto.pointerUp = function (event, pointer) {
          this.emitEvent("pointerUp", [event, pointer]);
          this._dragPointerUp(event, pointer);
        };

        proto._dragPointerUp = function (event, pointer) {
          if (this.isDragging) {
            this._dragEnd(event, pointer);
          } else {
            // pointer didn't move enough for drag to start
            this._staticClick(event, pointer);
          }
        };

        // -------------------------- drag -------------------------- //

        // dragStart
        proto._dragStart = function (event, pointer) {
          this.isDragging = true;
          // prevent clicks
          this.isPreventingClicks = true;
          this.dragStart(event, pointer);
        };

        proto.dragStart = function (event, pointer) {
          this.emitEvent("dragStart", [event, pointer]);
        };

        // dragMove
        proto._dragMove = function (event, pointer, moveVector) {
          // do not drag if not dragging yet
          if (!this.isDragging) {
            return;
          }

          this.dragMove(event, pointer, moveVector);
        };

        proto.dragMove = function (event, pointer, moveVector) {
          event.preventDefault();
          this.emitEvent("dragMove", [event, pointer, moveVector]);
        };

        // dragEnd
        proto._dragEnd = function (event, pointer) {
          // set flags
          this.isDragging = false;
          // re-enable clicking async
          setTimeout(
            function () {
              delete this.isPreventingClicks;
            }.bind(this)
          );

          this.dragEnd(event, pointer);
        };

        proto.dragEnd = function (event, pointer) {
          this.emitEvent("dragEnd", [event, pointer]);
        };

        // ----- onclick ----- //

        // handle all clicks and prevent clicks when dragging
        proto.onclick = function (event) {
          if (this.isPreventingClicks) {
            event.preventDefault();
          }
        };

        // ----- staticClick ----- //

        // triggered after pointer down & up with no/tiny movement
        proto._staticClick = function (event, pointer) {
          // ignore emulated mouse up clicks
          if (this.isIgnoringMouseUp && event.type == "mouseup") {
            return;
          }

          this.staticClick(event, pointer);

          // set flag for emulated clicks 300ms after touchend
          if (event.type != "mouseup") {
            this.isIgnoringMouseUp = true;
            // reset flag after 300ms
            setTimeout(
              function () {
                delete this.isIgnoringMouseUp;
              }.bind(this),
              400
            );
          }
        };

        proto.staticClick = function (event, pointer) {
          this.emitEvent("staticClick", [event, pointer]);
        };

        // ----- utils ----- //

        Unidragger.getPointerPoint = Unipointer.getPointerPoint;

        // -----  ----- //

        return Unidragger;
      });

      /***/
    },
    /* 163 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // prev/next buttons
      (function (window, factory) {
        // universal module definition
        /* jshint strict: false */
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(47),
            __webpack_require__(85),
            __webpack_require__(32),
          ]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (
            Flickity,
            Unipointer,
            utils
          ) {
            return factory(window, Flickity, Unipointer, utils);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
            (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(window, function factory(window, Flickity, Unipointer, utils) {
        "use strict";

        var svgURI = "http://www.w3.org/2000/svg";

        // -------------------------- PrevNextButton -------------------------- //

        function PrevNextButton(direction, parent) {
          this.direction = direction;
          this.parent = parent;
          this._create();
        }

        PrevNextButton.prototype = Object.create(Unipointer.prototype);

        PrevNextButton.prototype._create = function () {
          // properties
          this.isEnabled = true;
          this.isPrevious = this.direction == -1;
          var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
          this.isLeft = this.direction == leftDirection;

          var element = (this.element = document.createElement("button"));
          element.className = "flickity-button flickity-prev-next-button";
          element.className += this.isPrevious ? " previous" : " next";
          // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
          element.setAttribute("type", "button");
          // init as disabled
          this.disable();

          element.setAttribute(
            "aria-label",
            this.isPrevious ? "Previous" : "Next"
          );

          // create arrow
          var svg = this.createSVG();
          element.appendChild(svg);
          // events
          this.parent.on("select", this.update.bind(this));
          this.on(
            "pointerDown",
            this.parent.childUIPointerDown.bind(this.parent)
          );
        };

        PrevNextButton.prototype.activate = function () {
          this.bindStartEvent(this.element);
          this.element.addEventListener("click", this);
          // add to DOM
          this.parent.element.appendChild(this.element);
        };

        PrevNextButton.prototype.deactivate = function () {
          // remove from DOM
          this.parent.element.removeChild(this.element);
          // click events
          this.unbindStartEvent(this.element);
          this.element.removeEventListener("click", this);
        };

        PrevNextButton.prototype.createSVG = function () {
          var svg = document.createElementNS(svgURI, "svg");
          svg.setAttribute("class", "flickity-button-icon");
          svg.setAttribute("viewBox", "0 0 100 100");
          var path = document.createElementNS(svgURI, "path");
          var pathMovements = getArrowMovements(this.parent.options.arrowShape);
          path.setAttribute("d", pathMovements);
          path.setAttribute("class", "arrow");
          // rotate arrow
          if (!this.isLeft) {
            path.setAttribute("transform", "translate(100, 100) rotate(180) ");
          }
          svg.appendChild(path);
          return svg;
        };

        // get SVG path movmement
        function getArrowMovements(shape) {
          // use shape as movement if string
          if (typeof shape == "string") {
            return shape;
          }
          // create movement string
          return (
            "M " +
            shape.x0 +
            ",50" +
            " L " +
            shape.x1 +
            "," +
            (shape.y1 + 50) +
            " L " +
            shape.x2 +
            "," +
            (shape.y2 + 50) +
            " L " +
            shape.x3 +
            ",50 " +
            " L " +
            shape.x2 +
            "," +
            (50 - shape.y2) +
            " L " +
            shape.x1 +
            "," +
            (50 - shape.y1) +
            " Z"
          );
        }

        PrevNextButton.prototype.handleEvent = utils.handleEvent;

        PrevNextButton.prototype.onclick = function () {
          if (!this.isEnabled) {
            return;
          }
          this.parent.uiChange();
          var method = this.isPrevious ? "previous" : "next";
          this.parent[method]();
        };

        // -----  ----- //

        PrevNextButton.prototype.enable = function () {
          if (this.isEnabled) {
            return;
          }
          this.element.disabled = false;
          this.isEnabled = true;
        };

        PrevNextButton.prototype.disable = function () {
          if (!this.isEnabled) {
            return;
          }
          this.element.disabled = true;
          this.isEnabled = false;
        };

        PrevNextButton.prototype.update = function () {
          // index of first or last slide, if previous or next
          var slides = this.parent.slides;
          // enable is wrapAround and at least 2 slides
          if (this.parent.options.wrapAround && slides.length > 1) {
            this.enable();
            return;
          }
          var lastIndex = slides.length ? slides.length - 1 : 0;
          var boundIndex = this.isPrevious ? 0 : lastIndex;
          var method =
            this.parent.selectedIndex == boundIndex ? "disable" : "enable";
          this[method]();
        };

        PrevNextButton.prototype.destroy = function () {
          this.deactivate();
          this.allOff();
        };

        // -------------------------- Flickity prototype -------------------------- //

        utils.extend(Flickity.defaults, {
          prevNextButtons: true,
          arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30,
          },
        });

        Flickity.createMethods.push("_createPrevNextButtons");
        var proto = Flickity.prototype;

        proto._createPrevNextButtons = function () {
          if (!this.options.prevNextButtons) {
            return;
          }

          this.prevButton = new PrevNextButton(-1, this);
          this.nextButton = new PrevNextButton(1, this);

          this.on("activate", this.activatePrevNextButtons);
        };

        proto.activatePrevNextButtons = function () {
          this.prevButton.activate();
          this.nextButton.activate();
          this.on("deactivate", this.deactivatePrevNextButtons);
        };

        proto.deactivatePrevNextButtons = function () {
          this.prevButton.deactivate();
          this.nextButton.deactivate();
          this.off("deactivate", this.deactivatePrevNextButtons);
        };

        // --------------------------  -------------------------- //

        Flickity.PrevNextButton = PrevNextButton;

        return Flickity;
      });

      /***/
    },
    /* 164 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // page dots
      (function (window, factory) {
        // universal module definition
        /* jshint strict: false */
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(47),
            __webpack_require__(85),
            __webpack_require__(32),
          ]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (
            Flickity,
            Unipointer,
            utils
          ) {
            return factory(window, Flickity, Unipointer, utils);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
            (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(window, function factory(window, Flickity, Unipointer, utils) {
        // -------------------------- PageDots -------------------------- //

        "use strict";

        function PageDots(parent) {
          this.parent = parent;
          this._create();
        }

        PageDots.prototype = Object.create(Unipointer.prototype);

        PageDots.prototype._create = function () {
          // create holder element
          this.holder = document.createElement("ol");
          this.holder.className = "flickity-page-dots";
          // create dots, array of elements
          this.dots = [];
          // events
          this.handleClick = this.onClick.bind(this);
          this.on(
            "pointerDown",
            this.parent.childUIPointerDown.bind(this.parent)
          );
        };

        PageDots.prototype.activate = function () {
          this.setDots();
          this.holder.addEventListener("click", this.handleClick);
          this.bindStartEvent(this.holder);
          // add to DOM
          this.parent.element.appendChild(this.holder);
        };

        PageDots.prototype.deactivate = function () {
          this.holder.removeEventListener("click", this.handleClick);
          this.unbindStartEvent(this.holder);
          // remove from DOM
          this.parent.element.removeChild(this.holder);
        };

        PageDots.prototype.setDots = function () {
          // get difference between number of slides and number of dots
          var delta = this.parent.slides.length - this.dots.length;
          if (delta > 0) {
            this.addDots(delta);
          } else if (delta < 0) {
            this.removeDots(-delta);
          }
        };

        PageDots.prototype.addDots = function (count) {
          var fragment = document.createDocumentFragment();
          var newDots = [];
          var length = this.dots.length;
          var max = length + count;

          for (var i = length; i < max; i++) {
            var dot = document.createElement("li");
            dot.className = "dot";
            dot.setAttribute("aria-label", "Page dot " + (i + 1));
            fragment.appendChild(dot);
            newDots.push(dot);
          }

          this.holder.appendChild(fragment);
          this.dots = this.dots.concat(newDots);
        };

        PageDots.prototype.removeDots = function (count) {
          // remove from this.dots collection
          var removeDots = this.dots.splice(this.dots.length - count, count);
          // remove from DOM
          removeDots.forEach(function (dot) {
            this.holder.removeChild(dot);
          }, this);
        };

        PageDots.prototype.updateSelected = function () {
          // remove selected class on previous
          if (this.selectedDot) {
            this.selectedDot.className = "dot";
            this.selectedDot.removeAttribute("aria-current");
          }
          // don't proceed if no dots
          if (!this.dots.length) {
            return;
          }
          this.selectedDot = this.dots[this.parent.selectedIndex];
          this.selectedDot.className = "dot is-selected";
          this.selectedDot.setAttribute("aria-current", "step");
        };

        PageDots.prototype.onTap = // old method name, backwards-compatible
          PageDots.prototype.onClick = function (event) {
            var target = event.target;
            // only care about dot clicks
            if (target.nodeName != "LI") {
              return;
            }

            this.parent.uiChange();
            var index = this.dots.indexOf(target);
            this.parent.select(index);
          };

        PageDots.prototype.destroy = function () {
          this.deactivate();
          this.allOff();
        };

        Flickity.PageDots = PageDots;

        // -------------------------- Flickity -------------------------- //

        utils.extend(Flickity.defaults, {
          pageDots: true,
        });

        Flickity.createMethods.push("_createPageDots");

        var proto = Flickity.prototype;

        proto._createPageDots = function () {
          if (!this.options.pageDots) {
            return;
          }
          this.pageDots = new PageDots(this);
          // events
          this.on("activate", this.activatePageDots);
          this.on("select", this.updateSelectedPageDots);
          this.on("cellChange", this.updatePageDots);
          this.on("resize", this.updatePageDots);
          this.on("deactivate", this.deactivatePageDots);
        };

        proto.activatePageDots = function () {
          this.pageDots.activate();
        };

        proto.updateSelectedPageDots = function () {
          this.pageDots.updateSelected();
        };

        proto.updatePageDots = function () {
          this.pageDots.setDots();
        };

        proto.deactivatePageDots = function () {
          this.pageDots.deactivate();
        };

        // -----  ----- //

        Flickity.PageDots = PageDots;

        return Flickity;
      });

      /***/
    },
    /* 165 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // player & autoPlay
      (function (window, factory) {
        // universal module definition
        /* jshint strict: false */
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(57),
            __webpack_require__(32),
            __webpack_require__(47),
          ]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (
            EvEmitter,
            utils,
            Flickity
          ) {
            return factory(EvEmitter, utils, Flickity);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
            (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(window, function factory(EvEmitter, utils, Flickity) {
        "use strict";

        // -------------------------- Player -------------------------- //

        function Player(parent) {
          this.parent = parent;
          this.state = "stopped";
          // visibility change event handler
          this.onVisibilityChange = this.visibilityChange.bind(this);
          this.onVisibilityPlay = this.visibilityPlay.bind(this);
        }

        Player.prototype = Object.create(EvEmitter.prototype);

        // start play
        Player.prototype.play = function () {
          if (this.state == "playing") {
            return;
          }
          // do not play if page is hidden, start playing when page is visible
          var isPageHidden = document.hidden;
          if (isPageHidden) {
            document.addEventListener(
              "visibilitychange",
              this.onVisibilityPlay
            );
            return;
          }

          this.state = "playing";
          // listen to visibility change
          document.addEventListener(
            "visibilitychange",
            this.onVisibilityChange
          );
          // start ticking
          this.tick();
        };

        Player.prototype.tick = function () {
          // do not tick if not playing
          if (this.state != "playing") {
            return;
          }

          var time = this.parent.options.autoPlay;
          // default to 3 seconds
          time = typeof time == "number" ? time : 3000;
          var _this = this;
          // HACK: reset ticks if stopped and started within interval
          this.clear();
          this.timeout = setTimeout(function () {
            _this.parent.next(true);
            _this.tick();
          }, time);
        };

        Player.prototype.stop = function () {
          this.state = "stopped";
          this.clear();
          // remove visibility change event
          document.removeEventListener(
            "visibilitychange",
            this.onVisibilityChange
          );
        };

        Player.prototype.clear = function () {
          clearTimeout(this.timeout);
        };

        Player.prototype.pause = function () {
          if (this.state == "playing") {
            this.state = "paused";
            this.clear();
          }
        };

        Player.prototype.unpause = function () {
          // re-start play if paused
          if (this.state == "paused") {
            this.play();
          }
        };

        // pause if page visibility is hidden, unpause if visible
        Player.prototype.visibilityChange = function () {
          var isPageHidden = document.hidden;
          this[isPageHidden ? "pause" : "unpause"]();
        };

        Player.prototype.visibilityPlay = function () {
          this.play();
          document.removeEventListener(
            "visibilitychange",
            this.onVisibilityPlay
          );
        };

        // -------------------------- Flickity -------------------------- //

        utils.extend(Flickity.defaults, {
          pauseAutoPlayOnHover: true,
        });

        Flickity.createMethods.push("_createPlayer");
        var proto = Flickity.prototype;

        proto._createPlayer = function () {
          this.player = new Player(this);

          this.on("activate", this.activatePlayer);
          this.on("uiChange", this.stopPlayer);
          this.on("pointerDown", this.stopPlayer);
          this.on("deactivate", this.deactivatePlayer);
        };

        proto.activatePlayer = function () {
          if (!this.options.autoPlay) {
            return;
          }
          this.player.play();
          this.element.addEventListener("mouseenter", this);
        };

        // Player API, don't hate the ... thanks I know where the door is

        proto.playPlayer = function () {
          this.player.play();
        };

        proto.stopPlayer = function () {
          this.player.stop();
        };

        proto.pausePlayer = function () {
          this.player.pause();
        };

        proto.unpausePlayer = function () {
          this.player.unpause();
        };

        proto.deactivatePlayer = function () {
          this.player.stop();
          this.element.removeEventListener("mouseenter", this);
        };

        // ----- mouseenter/leave ----- //

        // pause auto-play on hover
        proto.onmouseenter = function () {
          if (!this.options.pauseAutoPlayOnHover) {
            return;
          }
          this.player.pause();
          this.element.addEventListener("mouseleave", this);
        };

        // resume auto-play on hover off
        proto.onmouseleave = function () {
          this.player.unpause();
          this.element.removeEventListener("mouseleave", this);
        };

        // -----  ----- //

        Flickity.Player = Player;

        return Flickity;
      });

      /***/
    },
    /* 166 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // add, remove cell
      (function (window, factory) {
        // universal module definition
        /* jshint strict: false */
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(47),
            __webpack_require__(32),
          ]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (Flickity, utils) {
            return factory(window, Flickity, utils);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
            (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(window, function factory(window, Flickity, utils) {
        "use strict";

        // append cells to a document fragment
        function getCellsFragment(cells) {
          var fragment = document.createDocumentFragment();
          cells.forEach(function (cell) {
            fragment.appendChild(cell.element);
          });
          return fragment;
        }

        // -------------------------- add/remove cell prototype -------------------------- //

        var proto = Flickity.prototype;

        /**
         * Insert, prepend, or append cells
         * @param {Element, Array, NodeList} elems
         * @param {Integer} index
         */
        proto.insert = function (elems, index) {
          var cells = this._makeCells(elems);
          if (!cells || !cells.length) {
            return;
          }
          var len = this.cells.length;
          // default to append
          index = index === undefined ? len : index;
          // add cells with document fragment
          var fragment = getCellsFragment(cells);
          // append to slider
          var isAppend = index == len;
          if (isAppend) {
            this.slider.appendChild(fragment);
          } else {
            var insertCellElement = this.cells[index].element;
            this.slider.insertBefore(fragment, insertCellElement);
          }
          // add to this.cells
          if (index === 0) {
            // prepend, add to start
            this.cells = cells.concat(this.cells);
          } else if (isAppend) {
            // append, add to end
            this.cells = this.cells.concat(cells);
          } else {
            // insert in this.cells
            var endCells = this.cells.splice(index, len - index);
            this.cells = this.cells.concat(cells).concat(endCells);
          }

          this._sizeCells(cells);
          this.cellChange(index, true);
        };

        proto.append = function (elems) {
          this.insert(elems, this.cells.length);
        };

        proto.prepend = function (elems) {
          this.insert(elems, 0);
        };

        /**
         * Remove cells
         * @param {Element, Array, NodeList} elems
         */
        proto.remove = function (elems) {
          var cells = this.getCells(elems);
          if (!cells || !cells.length) {
            return;
          }

          var minCellIndex = this.cells.length - 1;
          // remove cells from collection & DOM
          cells.forEach(function (cell) {
            cell.remove();
            var index = this.cells.indexOf(cell);
            minCellIndex = Math.min(index, minCellIndex);
            utils.removeFrom(this.cells, cell);
          }, this);

          this.cellChange(minCellIndex, true);
        };

        /**
         * logic to be run after a cell's size changes
         * @param {Element} elem - cell's element
         */
        proto.cellSizeChange = function (elem) {
          var cell = this.getCell(elem);
          if (!cell) {
            return;
          }
          cell.getSize();

          var index = this.cells.indexOf(cell);
          this.cellChange(index);
        };

        /**
         * logic any time a cell is changed: added, removed, or size changed
         * @param {Integer} changedCellIndex - index of the changed cell, optional
         */
        proto.cellChange = function (changedCellIndex, isPositioningSlider) {
          var prevSelectedElem = this.selectedElement;
          this._positionCells(changedCellIndex);
          this._getWrapShiftCells();
          this.setGallerySize();
          // update selectedIndex
          // try to maintain position & select previous selected element
          var cell = this.getCell(prevSelectedElem);
          if (cell) {
            this.selectedIndex = this.getCellSlideIndex(cell);
          }
          this.selectedIndex = Math.min(
            this.slides.length - 1,
            this.selectedIndex
          );

          this.emitEvent("cellChange", [changedCellIndex]);
          // position slider
          this.select(this.selectedIndex);
          // do not position slider after lazy load
          if (isPositioningSlider) {
            this.positionSliderAtSelected();
          }
        };

        // -----  ----- //

        return Flickity;
      });

      /***/
    },
    /* 167 */
    /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // lazyload
      (function (window, factory) {
        // universal module definition
        /* jshint strict: false */
        if (true) {
          // AMD
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(47),
            __webpack_require__(32),
          ]),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function (Flickity, utils) {
            return factory(window, Flickity, utils);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
            (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(window, function factory(window, Flickity, utils) {
        "use strict";

        Flickity.createMethods.push("_createLazyload");
        var proto = Flickity.prototype;

        proto._createLazyload = function () {
          this.on("select", this.lazyLoad);
        };

        proto.lazyLoad = function () {
          var lazyLoad = this.options.lazyLoad;
          if (!lazyLoad) {
            return;
          }
          // get adjacent cells, use lazyLoad option for adjacent count
          var adjCount = typeof lazyLoad == "number" ? lazyLoad : 0;
          var cellElems = this.getAdjacentCellElements(adjCount);
          // get lazy images in those cells
          var lazyImages = [];
          cellElems.forEach(function (cellElem) {
            var lazyCellImages = getCellLazyImages(cellElem);
            lazyImages = lazyImages.concat(lazyCellImages);
          });
          // load lazy images
          lazyImages.forEach(function (img) {
            new LazyLoader(img, this);
          }, this);
        };

        function getCellLazyImages(cellElem) {
          // check if cell element is lazy image
          if (cellElem.nodeName == "IMG") {
            var lazyloadAttr = cellElem.getAttribute("data-flickity-lazyload");
            var srcAttr = cellElem.getAttribute("data-flickity-lazyload-src");
            var srcsetAttr = cellElem.getAttribute(
              "data-flickity-lazyload-srcset"
            );
            if (lazyloadAttr || srcAttr || srcsetAttr) {
              return [cellElem];
            }
          }
          // select lazy images in cell
          var lazySelector =
            "img[data-flickity-lazyload], " +
            "img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]";
          var imgs = cellElem.querySelectorAll(lazySelector);
          return utils.makeArray(imgs);
        }

        // -------------------------- LazyLoader -------------------------- //

        /**
         * class to handle loading images
         */
        function LazyLoader(img, flickity) {
          this.img = img;
          this.flickity = flickity;
          this.load();
        }

        LazyLoader.prototype.handleEvent = utils.handleEvent;

        LazyLoader.prototype.load = function () {
          this.img.addEventListener("load", this);
          this.img.addEventListener("error", this);
          // get src & srcset
          var src =
            this.img.getAttribute("data-flickity-lazyload") ||
            this.img.getAttribute("data-flickity-lazyload-src");
          var srcset = this.img.getAttribute("data-flickity-lazyload-srcset");
          // set src & serset
          this.img.src = src;
          if (srcset) {
            this.img.setAttribute("srcset", srcset);
          }
          // remove attr
          this.img.removeAttribute("data-flickity-lazyload");
          this.img.removeAttribute("data-flickity-lazyload-src");
          this.img.removeAttribute("data-flickity-lazyload-srcset");
        };

        LazyLoader.prototype.onload = function (event) {
          this.complete(event, "flickity-lazyloaded");
        };

        LazyLoader.prototype.onerror = function (event) {
          this.complete(event, "flickity-lazyerror");
        };

        LazyLoader.prototype.complete = function (event, className) {
          // unbind events
          this.img.removeEventListener("load", this);
          this.img.removeEventListener("error", this);

          var cell = this.flickity.getParentCell(this.img);
          var cellElem = cell && cell.element;
          this.flickity.cellSizeChange(cellElem);

          this.img.classList.add(className);
          this.flickity.dispatchEvent("lazyLoad", event, cellElem);
        };

        // -----  ----- //

        Flickity.LazyLoader = LazyLoader;

        return Flickity;
      });

      /***/
    },
    /* 168 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(169);
      __webpack_require__(362);
      __webpack_require__(59);
      __webpack_require__(364);
      __webpack_require__(140);
      __webpack_require__(365);
      __webpack_require__(366);
      __webpack_require__(367);
      __webpack_require__(368);
      __webpack_require__(369);
      __webpack_require__(370);
      __webpack_require__(371);
      __webpack_require__(372);
      __webpack_require__(373);
      __webpack_require__(374);
      module.exports = __webpack_require__(11);

      /***/
    },
    /* 169 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(107);
      __webpack_require__(170);
      __webpack_require__(171);
      __webpack_require__(172);
      __webpack_require__(173);
      __webpack_require__(174);
      __webpack_require__(175);
      __webpack_require__(176);
      __webpack_require__(177);
      __webpack_require__(178);
      __webpack_require__(179);
      __webpack_require__(180);
      __webpack_require__(181);
      __webpack_require__(182);
      __webpack_require__(114);
      __webpack_require__(183);
      __webpack_require__(185);
      __webpack_require__(113);
      __webpack_require__(186);
      __webpack_require__(187);
      __webpack_require__(188);
      __webpack_require__(189);
      __webpack_require__(190);
      __webpack_require__(191);
      __webpack_require__(192);
      __webpack_require__(193);
      __webpack_require__(194);
      __webpack_require__(195);
      __webpack_require__(196);
      __webpack_require__(197);
      __webpack_require__(198);
      __webpack_require__(199);
      __webpack_require__(200);
      __webpack_require__(201);
      __webpack_require__(202);
      __webpack_require__(203);
      __webpack_require__(204);
      __webpack_require__(205);
      __webpack_require__(206);
      __webpack_require__(207);
      __webpack_require__(208);
      __webpack_require__(209);
      __webpack_require__(210);
      __webpack_require__(211);
      __webpack_require__(212);
      __webpack_require__(213);
      __webpack_require__(214);
      __webpack_require__(215);
      __webpack_require__(216);
      __webpack_require__(217);
      __webpack_require__(218);
      __webpack_require__(219);
      __webpack_require__(220);
      __webpack_require__(221);
      __webpack_require__(222);
      __webpack_require__(223);
      __webpack_require__(224);
      __webpack_require__(225);
      __webpack_require__(226);
      __webpack_require__(227);
      __webpack_require__(228);
      __webpack_require__(229);
      __webpack_require__(230);
      __webpack_require__(231);
      __webpack_require__(232);
      __webpack_require__(233);
      __webpack_require__(234);
      __webpack_require__(235);
      __webpack_require__(236);
      __webpack_require__(237);
      __webpack_require__(238);
      __webpack_require__(239);
      __webpack_require__(240);
      __webpack_require__(241);
      __webpack_require__(242);
      __webpack_require__(243);
      __webpack_require__(244);
      __webpack_require__(246);
      __webpack_require__(247);
      __webpack_require__(249);
      __webpack_require__(250);
      __webpack_require__(251);
      __webpack_require__(252);
      __webpack_require__(253);
      __webpack_require__(254);
      __webpack_require__(255);
      __webpack_require__(257);
      __webpack_require__(258);
      __webpack_require__(259);
      __webpack_require__(260);
      __webpack_require__(261);
      __webpack_require__(262);
      __webpack_require__(263);
      __webpack_require__(264);
      __webpack_require__(265);
      __webpack_require__(266);
      __webpack_require__(267);
      __webpack_require__(268);
      __webpack_require__(269);
      __webpack_require__(64);
      __webpack_require__(270);
      __webpack_require__(271);
      __webpack_require__(125);
      __webpack_require__(272);
      __webpack_require__(273);
      __webpack_require__(274);
      __webpack_require__(275);
      __webpack_require__(276);
      __webpack_require__(128);
      __webpack_require__(130);
      __webpack_require__(131);
      __webpack_require__(277);
      __webpack_require__(278);
      __webpack_require__(279);
      __webpack_require__(280);
      __webpack_require__(281);
      __webpack_require__(282);
      __webpack_require__(283);
      __webpack_require__(284);
      __webpack_require__(285);
      __webpack_require__(286);
      __webpack_require__(287);
      __webpack_require__(288);
      __webpack_require__(289);
      __webpack_require__(290);
      __webpack_require__(291);
      __webpack_require__(292);
      __webpack_require__(293);
      __webpack_require__(294);
      __webpack_require__(295);
      __webpack_require__(296);
      __webpack_require__(297);
      __webpack_require__(298);
      __webpack_require__(299);
      __webpack_require__(300);
      __webpack_require__(301);
      __webpack_require__(302);
      __webpack_require__(303);
      __webpack_require__(304);
      __webpack_require__(305);
      __webpack_require__(306);
      __webpack_require__(307);
      __webpack_require__(308);
      __webpack_require__(309);
      __webpack_require__(310);
      __webpack_require__(311);
      __webpack_require__(312);
      __webpack_require__(313);
      __webpack_require__(314);
      __webpack_require__(315);
      __webpack_require__(316);
      __webpack_require__(317);
      __webpack_require__(318);
      __webpack_require__(319);
      __webpack_require__(320);
      __webpack_require__(321);
      __webpack_require__(322);
      __webpack_require__(323);
      __webpack_require__(324);
      __webpack_require__(325);
      __webpack_require__(326);
      __webpack_require__(327);
      __webpack_require__(328);
      __webpack_require__(329);
      __webpack_require__(330);
      __webpack_require__(331);
      __webpack_require__(332);
      __webpack_require__(333);
      __webpack_require__(334);
      __webpack_require__(335);
      __webpack_require__(336);
      __webpack_require__(337);
      __webpack_require__(338);
      __webpack_require__(339);
      __webpack_require__(340);
      __webpack_require__(341);
      __webpack_require__(342);
      __webpack_require__(343);
      __webpack_require__(344);
      __webpack_require__(345);
      __webpack_require__(346);
      __webpack_require__(347);
      __webpack_require__(348);
      __webpack_require__(349);
      __webpack_require__(350);
      __webpack_require__(351);
      __webpack_require__(352);
      __webpack_require__(353);
      __webpack_require__(354);
      __webpack_require__(355);
      __webpack_require__(356);
      __webpack_require__(357);
      __webpack_require__(358);
      __webpack_require__(359);
      __webpack_require__(360);
      __webpack_require__(361);
      module.exports = __webpack_require__(11);

      /***/
    },
    /* 170 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(1);
      // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
      $export($export.S, "Object", { create: __webpack_require__(31) });

      /***/
    },
    /* 171 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(1);
      // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
      $export($export.S + $export.F * !__webpack_require__(9), "Object", {
        defineProperty: __webpack_require__(8).f,
      });

      /***/
    },
    /* 172 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(1);
      // 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
      $export($export.S + $export.F * !__webpack_require__(9), "Object", {
        defineProperties: __webpack_require__(111),
      });

      /***/
    },
    /* 173 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
      var toIObject = __webpack_require__(14);
      var $getOwnPropertyDescriptor = __webpack_require__(18).f;

      __webpack_require__(27)("getOwnPropertyDescriptor", function () {
        return function getOwnPropertyDescriptor(it, key) {
          return $getOwnPropertyDescriptor(toIObject(it), key);
        };
      });

      /***/
    },
    /* 174 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.9 Object.getPrototypeOf(O)
      var toObject = __webpack_require__(12);
      var $getPrototypeOf = __webpack_require__(19);

      __webpack_require__(27)("getPrototypeOf", function () {
        return function getPrototypeOf(it) {
          return $getPrototypeOf(toObject(it));
        };
      });

      /***/
    },
    /* 175 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.14 Object.keys(O)
      var toObject = __webpack_require__(12);
      var $keys = __webpack_require__(30);

      __webpack_require__(27)("keys", function () {
        return function keys(it) {
          return $keys(toObject(it));
        };
      });

      /***/
    },
    /* 176 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.7 Object.getOwnPropertyNames(O)
      __webpack_require__(27)("getOwnPropertyNames", function () {
        return __webpack_require__(112).f;
      });

      /***/
    },
    /* 177 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.5 Object.freeze(O)
      var isObject = __webpack_require__(4);
      var meta = __webpack_require__(37).onFreeze;

      __webpack_require__(27)("freeze", function ($freeze) {
        return function freeze(it) {
          return $freeze && isObject(it) ? $freeze(meta(it)) : it;
        };
      });

      /***/
    },
    /* 178 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.17 Object.seal(O)
      var isObject = __webpack_require__(4);
      var meta = __webpack_require__(37).onFreeze;

      __webpack_require__(27)("seal", function ($seal) {
        return function seal(it) {
          return $seal && isObject(it) ? $seal(meta(it)) : it;
        };
      });

      /***/
    },
    /* 179 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.15 Object.preventExtensions(O)
      var isObject = __webpack_require__(4);
      var meta = __webpack_require__(37).onFreeze;

      __webpack_require__(27)(
        "preventExtensions",
        function ($preventExtensions) {
          return function preventExtensions(it) {
            return $preventExtensions && isObject(it)
              ? $preventExtensions(meta(it))
              : it;
          };
        }
      );

      /***/
    },
    /* 180 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.12 Object.isFrozen(O)
      var isObject = __webpack_require__(4);

      __webpack_require__(27)("isFrozen", function ($isFrozen) {
        return function isFrozen(it) {
          return isObject(it) ? ($isFrozen ? $isFrozen(it) : false) : true;
        };
      });

      /***/
    },
    /* 181 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.13 Object.isSealed(O)
      var isObject = __webpack_require__(4);

      __webpack_require__(27)("isSealed", function ($isSealed) {
        return function isSealed(it) {
          return isObject(it) ? ($isSealed ? $isSealed(it) : false) : true;
        };
      });

      /***/
    },
    /* 182 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.2.11 Object.isExtensible(O)
      var isObject = __webpack_require__(4);

      __webpack_require__(27)("isExtensible", function ($isExtensible) {
        return function isExtensible(it) {
          return isObject(it)
            ? $isExtensible
              ? $isExtensible(it)
              : true
            : false;
        };
      });

      /***/
    },
    /* 183 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.3.10 Object.is(value1, value2)
      var $export = __webpack_require__(1);
      $export($export.S, "Object", { is: __webpack_require__(184) });

      /***/
    },
    /* 184 */
    /***/ function (module, exports) {
      // 7.2.9 SameValue(x, y)
      module.exports =
        Object.is ||
        function is(x, y) {
          // eslint-disable-next-line no-self-compare
          return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
        };

      /***/
    },
    /* 185 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.1.3.19 Object.setPrototypeOf(O, proto)
      var $export = __webpack_require__(1);
      $export($export.S, "Object", {
        setPrototypeOf: __webpack_require__(86).set,
      });

      /***/
    },
    /* 186 */
    /***/ function (module, exports, __webpack_require__) {
      // 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
      var $export = __webpack_require__(1);

      $export($export.P, "Function", { bind: __webpack_require__(115) });

      /***/
    },
    /* 187 */
    /***/ function (module, exports, __webpack_require__) {
      var dP = __webpack_require__(8).f;
      var FProto = Function.prototype;
      var nameRE = /^\s*function ([^ (]*)/;
      var NAME = "name";

      // 19.2.4.2 name
      NAME in FProto ||
        (__webpack_require__(9) &&
          dP(FProto, NAME, {
            configurable: true,
            get: function () {
              try {
                return ("" + this).match(nameRE)[1];
              } catch (e) {
                return "";
              }
            },
          }));

      /***/
    },
    /* 188 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var isObject = __webpack_require__(4);
      var getPrototypeOf = __webpack_require__(19);
      var HAS_INSTANCE = __webpack_require__(6)("hasInstance");
      var FunctionProto = Function.prototype;
      // 19.2.3.6 Function.prototype[@@hasInstance](V)
      if (!(HAS_INSTANCE in FunctionProto))
        __webpack_require__(8).f(FunctionProto, HAS_INSTANCE, {
          value: function (O) {
            if (typeof this != "function" || !isObject(O)) return false;
            if (!isObject(this.prototype)) return O instanceof this;
            // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
            while ((O = getPrototypeOf(O)))
              if (this.prototype === O) return true;
            return false;
          },
        });

      /***/
    },
    /* 189 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(1);
      var $parseInt = __webpack_require__(116);
      // 18.2.5 parseInt(string, radix)
      $export($export.G + $export.F * (parseInt != $parseInt), {
        parseInt: $parseInt,
      });

      /***/
    },
    /* 190 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(1);
      var $parseFloat = __webpack_require__(117);
      // 18.2.4 parseFloat(string)
      $export($export.G + $export.F * (parseFloat != $parseFloat), {
        parseFloat: $parseFloat,
      });

      /***/
    },
    /* 191 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var global = __webpack_require__(3);
      var has = __webpack_require__(15);
      var cof = __webpack_require__(22);
      var inheritIfRequired = __webpack_require__(89);
      var toPrimitive = __webpack_require__(24);
      var fails = __webpack_require__(5);
      var gOPN = __webpack_require__(44).f;
      var gOPD = __webpack_require__(18).f;
      var dP = __webpack_require__(8).f;
      var $trim = __webpack_require__(52).trim;
      var NUMBER = "Number";
      var $Number = global[NUMBER];
      var Base = $Number;
      var proto = $Number.prototype;
      // Opera ~12 has broken Object#toString
      var BROKEN_COF = cof(__webpack_require__(31)(proto)) == NUMBER;
      var TRIM = "trim" in String.prototype;

      // 7.1.3 ToNumber(argument)
      var toNumber = function (argument) {
        var it = toPrimitive(argument, false);
        if (typeof it == "string" && it.length > 2) {
          it = TRIM ? it.trim() : $trim(it, 3);
          var first = it.charCodeAt(0);
          var third, radix, maxCode;
          if (first === 43 || first === 45) {
            third = it.charCodeAt(2);
            if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
          } else if (first === 48) {
            switch (it.charCodeAt(1)) {
              case 66:
              case 98:
                radix = 2;
                maxCode = 49;
                break; // fast equal /^0b[01]+$/i
              case 79:
              case 111:
                radix = 8;
                maxCode = 55;
                break; // fast equal /^0o[0-7]+$/i
              default:
                return +it;
            }
            for (
              var digits = it.slice(2), i = 0, l = digits.length, code;
              i < l;
              i++
            ) {
              code = digits.charCodeAt(i);
              // parseInt parses a string to a first unavailable symbol
              // but ToNumber should return NaN if a string contains unavailable symbols
              if (code < 48 || code > maxCode) return NaN;
            }
            return parseInt(digits, radix);
          }
        }
        return +it;
      };

      if (!$Number(" 0o1") || !$Number("0b1") || $Number("+0x1")) {
        $Number = function Number(value) {
          var it = arguments.length < 1 ? 0 : value;
          var that = this;
          return that instanceof $Number &&
            // check on 1..constructor(foo) case
            (BROKEN_COF
              ? fails(function () {
                  proto.valueOf.call(that);
                })
              : cof(that) != NUMBER)
            ? inheritIfRequired(new Base(toNumber(it)), that, $Number)
            : toNumber(it);
        };
        for (
          var keys = __webpack_require__(9)
              ? gOPN(Base)
              : // ES3:
                (
                  "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY," +
                  // ES6 (in case, if modules with ES6 Number statics required before):
                  "EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER," +
                  "MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger"
                ).split(","),
            j = 0,
            key;
          keys.length > j;
          j++
        ) {
          if (has(Base, (key = keys[j])) && !has($Number, key)) {
            dP($Number, key, gOPD(Base, key));
          }
        }
        $Number.prototype = proto;
        proto.constructor = $Number;
        __webpack_require__(17)(global, NUMBER, $Number);
      }

      /***/
    },
    /* 192 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(1);
      var toInteger = __webpack_require__(26);
      var aNumberValue = __webpack_require__(118);
      var repeat = __webpack_require__(90);
      var $toFixed = (1.0).toFixed;
      var floor = Math.floor;
      var data = [0, 0, 0, 0, 0, 0];
      var ERROR = "Number.toFixed: incorrect invocation!";
      var ZERO = "0";

      var multiply = function (n, c) {
        var i = -1;
        var c2 = c;
        while (++i < 6) {
          c2 += n * data[i];
          data[i] = c2 % 1e7;
          c2 = floor(c2 / 1e7);
        }
      };
      var divide = function (n) {
        var i = 6;
        var c = 0;
        while (--i >= 0) {
          c += data[i];
          data[i] = floor(c / n);
          c = (c % n) * 1e7;
        }
      };
      var numToString = function () {
        var i = 6;
        var s = "";
        while (--i >= 0) {
          if (s !== "" || i === 0 || data[i] !== 0) {
            var t = String(data[i]);
            s = s === "" ? t : s + repeat.call(ZERO, 7 - t.length) + t;
          }
        }
        return s;
      };
      var pow = function (x, n, acc) {
        return n === 0
          ? acc
          : n % 2 === 1
          ? pow(x, n - 1, acc * x)
          : pow(x * x, n / 2, acc);
      };
      var log = function (x) {
        var n = 0;
        var x2 = x;
        while (x2 >= 4096) {
          n += 12;
          x2 /= 4096;
        }
        while (x2 >= 2) {
          n += 1;
          x2 /= 2;
        }
        return n;
      };

      $export(
        $export.P +
          $export.F *
            ((!!$toFixed &&
              ((0.00008).toFixed(3) !== "0.000" ||
                (0.9).toFixed(0) !== "1" ||
                (1.255).toFixed(2) !== "1.25" ||
                (1000000000000000128.0).toFixed(0) !==
                  "1000000000000000128")) ||
              !__webpack_require__(5)(function () {
                // V8 ~ Android 4.3-
                $toFixed.call({});
              })),
        "Number",
        {
          toFixed: function toFixed(fractionDigits) {
            var x = aNumberValue(this, ERROR);
            var f = toInteger(fractionDigits);
            var s = "";
            var m = ZERO;
            var e, z, j, k;
            if (f < 0 || f > 20) throw RangeError(ERROR);
            // eslint-disable-next-line no-self-compare
            if (x != x) return "NaN";
            if (x <= -1e21 || x >= 1e21) return String(x);
            if (x < 0) {
              s = "-";
              x = -x;
            }
            if (x > 1e-21) {
              e = log(x * pow(2, 69, 1)) - 69;
              z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
              z *= 0x10000000000000;
              e = 52 - e;
              if (e > 0) {
                multiply(0, z);
                j = f;
                while (j >= 7) {
                  multiply(1e7, 0);
                  j -= 7;
                }
                multiply(pow(10, j, 1), 0);
                j = e - 1;
                while (j >= 23) {
                  divide(1 << 23);
                  j -= 23;
                }
                divide(1 << j);
                multiply(1, 1);
                divide(2);
                m = numToString();
              } else {
                multiply(0, z);
                multiply(1 << -e, 0);
                m = numToString() + repeat.call(ZERO, f);
              }
            }
            if (f > 0) {
              k = m.length;
              m =
                s +
                (k <= f
                  ? "0." + repeat.call(ZERO, f - k) + m
                  : m.slice(0, k - f) + "." + m.slice(k - f));
            } else {
              m = s + m;
            }
            return m;
          },
        }
      );

      /***/
    },
    /* 193 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(1);
      var $fails = __webpack_require__(5);
      var aNumberValue = __webpack_require__(118);
      var $toPrecision = (1.0).toPrecision;

      $export(
        $export.P +
          $export.F *
            ($fails(function () {
              // IE7-
              return $toPrecision.call(1, undefined) !== "1";
            }) ||
              !$fails(function () {
                // V8 ~ Android 4.3-
                $toPrecision.call({});
              })),
        "Number",
        {
          toPrecision: function toPrecision(precision) {
            var that = aNumberValue(
              this,
              "Number#toPrecision: incorrect invocation!"
            );
            return precision === undefined
              ? $toPrecision.call(that)
              : $toPrecision.call(that, precision);
          },
        }
      );

      /***/
    },
    /* 194 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.1.2.1 Number.EPSILON
      var $export = __webpack_require__(1);

      $export($export.S, "Number", { EPSILON: Math.pow(2, -52) });

      /***/
    },
    /* 195 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.1.2.2 Number.isFinite(number)
      var $export = __webpack_require__(1);
      var _isFinite = __webpack_require__(3).isFinite;

      $export($export.S, "Number", {
        isFinite: function isFinite(it) {
          return typeof it == "number" && _isFinite(it);
        },
      });

      /***/
    },
    /* 196 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.1.2.3 Number.isInteger(number)
      var $export = __webpack_require__(1);

      $export($export.S, "Number", { isInteger: __webpack_require__(119) });

      /***/
    },
    /* 197 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.1.2.4 Number.isNaN(number)
      var $export = __webpack_require__(1);

      $export($export.S, "Number", {
        isNaN: function isNaN(number) {
          // eslint-disable-next-line no-self-compare
          return number != number;
        },
      });

      /***/
    },
    /* 198 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.1.2.5 Number.isSafeInteger(number)
      var $export = __webpack_require__(1);
      var isInteger = __webpack_require__(119);
      var abs = Math.abs;

      $export($export.S, "Number", {
        isSafeInteger: function isSafeInteger(number) {
          return isInteger(number) && abs(number) <= 0x1fffffffffffff;
        },
      });

      /***/
    },
    /* 199 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.1.2.6 Number.MAX_SAFE_INTEGER
      var $export = __webpack_require__(1);

      $export($export.S, "Number", { MAX_SAFE_INTEGER: 0x1fffffffffffff });

      /***/
    },
    /* 200 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.1.2.10 Number.MIN_SAFE_INTEGER
      var $export = __webpack_require__(1);

      $export($export.S, "Number", { MIN_SAFE_INTEGER: -0x1fffffffffffff });

      /***/
    },
    /* 201 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(1);
      var $parseFloat = __webpack_require__(117);
      // 20.1.2.12 Number.parseFloat(string)
      $export(
        $export.S + $export.F * (Number.parseFloat != $parseFloat),
        "Number",
        { parseFloat: $parseFloat }
      );

      /***/
    },
    /* 202 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(1);
      var $parseInt = __webpack_require__(116);
      // 20.1.2.13 Number.parseInt(string, radix)
      $export(
        $export.S + $export.F * (Number.parseInt != $parseInt),
        "Number",
        { parseInt: $parseInt }
      );

      /***/
    },
    /* 203 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.3 Math.acosh(x)
      var $export = __webpack_require__(1);
      var log1p = __webpack_require__(120);
      var sqrt = Math.sqrt;
      var $acosh = Math.acosh;

      $export(
        $export.S +
          $export.F *
            !(
              $acosh &&
              // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
              Math.floor($acosh(Number.MAX_VALUE)) == 710 &&
              // Tor Browser bug: Math.acosh(Infinity) -> NaN
              $acosh(Infinity) == Infinity
            ),
        "Math",
        {
          acosh: function acosh(x) {
            return (x = +x) < 1
              ? NaN
              : x > 94906265.62425156
              ? Math.log(x) + Math.LN2
              : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
          },
        }
      );

      /***/
    },
    /* 204 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.5 Math.asinh(x)
      var $export = __webpack_require__(1);
      var $asinh = Math.asinh;

      function asinh(x) {
        return !isFinite((x = +x)) || x == 0
          ? x
          : x < 0
          ? -asinh(-x)
          : Math.log(x + Math.sqrt(x * x + 1));
      }

      // Tor Browser bug: Math.asinh(0) -> -0
      $export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), "Math", {
        asinh: asinh,
      });

      /***/
    },
    /* 205 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.7 Math.atanh(x)
      var $export = __webpack_require__(1);
      var $atanh = Math.atanh;

      // Tor Browser bug: Math.atanh(-0) -> 0
      $export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), "Math", {
        atanh: function atanh(x) {
          return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
        },
      });

      /***/
    },
    /* 206 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.9 Math.cbrt(x)
      var $export = __webpack_require__(1);
      var sign = __webpack_require__(91);

      $export($export.S, "Math", {
        cbrt: function cbrt(x) {
          return sign((x = +x)) * Math.pow(Math.abs(x), 1 / 3);
        },
      });

      /***/
    },
    /* 207 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.11 Math.clz32(x)
      var $export = __webpack_require__(1);

      $export($export.S, "Math", {
        clz32: function clz32(x) {
          return (x >>>= 0)
            ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E)
            : 32;
        },
      });

      /***/
    },
    /* 208 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.12 Math.cosh(x)
      var $export = __webpack_require__(1);
      var exp = Math.exp;

      $export($export.S, "Math", {
        cosh: function cosh(x) {
          return (exp((x = +x)) + exp(-x)) / 2;
        },
      });

      /***/
    },
    /* 209 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.14 Math.expm1(x)
      var $export = __webpack_require__(1);
      var $expm1 = __webpack_require__(92);

      $export($export.S + $export.F * ($expm1 != Math.expm1), "Math", {
        expm1: $expm1,
      });

      /***/
    },
    /* 210 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.16 Math.fround(x)
      var $export = __webpack_require__(1);

      $export($export.S, "Math", { fround: __webpack_require__(121) });

      /***/
    },
    /* 211 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
      var $export = __webpack_require__(1);
      var abs = Math.abs;

      $export($export.S, "Math", {
        hypot: function hypot(value1, value2) {
          // eslint-disable-line no-unused-vars
          var sum = 0;
          var i = 0;
          var aLen = arguments.length;
          var larg = 0;
          var arg, div;
          while (i < aLen) {
            arg = abs(arguments[i++]);
            if (larg < arg) {
              div = larg / arg;
              sum = sum * div * div + 1;
              larg = arg;
            } else if (arg > 0) {
              div = arg / larg;
              sum += div * div;
            } else sum += arg;
          }
          return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
        },
      });

      /***/
    },
    /* 212 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.18 Math.imul(x, y)
      var $export = __webpack_require__(1);
      var $imul = Math.imul;

      // some WebKit versions fails with big numbers, some has wrong arity
      $export(
        $export.S +
          $export.F *
            __webpack_require__(5)(function () {
              return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
            }),
        "Math",
        {
          imul: function imul(x, y) {
            var UINT16 = 0xffff;
            var xn = +x;
            var yn = +y;
            var xl = UINT16 & xn;
            var yl = UINT16 & yn;
            return (
              0 |
              (xl * yl +
                ((((UINT16 & (xn >>> 16)) * yl + xl * (UINT16 & (yn >>> 16))) <<
                  16) >>>
                  0))
            );
          },
        }
      );

      /***/
    },
    /* 213 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.21 Math.log10(x)
      var $export = __webpack_require__(1);

      $export($export.S, "Math", {
        log10: function log10(x) {
          return Math.log(x) * Math.LOG10E;
        },
      });

      /***/
    },
    /* 214 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.20 Math.log1p(x)
      var $export = __webpack_require__(1);

      $export($export.S, "Math", { log1p: __webpack_require__(120) });

      /***/
    },
    /* 215 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.22 Math.log2(x)
      var $export = __webpack_require__(1);

      $export($export.S, "Math", {
        log2: function log2(x) {
          return Math.log(x) / Math.LN2;
        },
      });

      /***/
    },
    /* 216 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.28 Math.sign(x)
      var $export = __webpack_require__(1);

      $export($export.S, "Math", { sign: __webpack_require__(91) });

      /***/
    },
    /* 217 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.30 Math.sinh(x)
      var $export = __webpack_require__(1);
      var expm1 = __webpack_require__(92);
      var exp = Math.exp;

      // V8 near Chromium 38 has a problem with very small numbers
      $export(
        $export.S +
          $export.F *
            __webpack_require__(5)(function () {
              return !Math.sinh(-2e-17) != -2e-17;
            }),
        "Math",
        {
          sinh: function sinh(x) {
            return Math.abs((x = +x)) < 1
              ? (expm1(x) - expm1(-x)) / 2
              : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
          },
        }
      );

      /***/
    },
    /* 218 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.33 Math.tanh(x)
      var $export = __webpack_require__(1);
      var expm1 = __webpack_require__(92);
      var exp = Math.exp;

      $export($export.S, "Math", {
        tanh: function tanh(x) {
          var a = expm1((x = +x));
          var b = expm1(-x);
          return a == Infinity
            ? 1
            : b == Infinity
            ? -1
            : (a - b) / (exp(x) + exp(-x));
        },
      });

      /***/
    },
    /* 219 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.2.2.34 Math.trunc(x)
      var $export = __webpack_require__(1);

      $export($export.S, "Math", {
        trunc: function trunc(it) {
          return (it > 0 ? Math.floor : Math.ceil)(it);
        },
      });

      /***/
    },
    /* 220 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(1);
      var toAbsoluteIndex = __webpack_require__(43);
      var fromCharCode = String.fromCharCode;
      var $fromCodePoint = String.fromCodePoint;

      // length should be 1, old FF problem
      $export(
        $export.S +
          $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1),
        "String",
        {
          // 21.1.2.2 String.fromCodePoint(...codePoints)
          fromCodePoint: function fromCodePoint(x) {
            // eslint-disable-line no-unused-vars
            var res = [];
            var aLen = arguments.length;
            var i = 0;
            var code;
            while (aLen > i) {
              code = +arguments[i++];
              if (toAbsoluteIndex(code, 0x10ffff) !== code)
                throw RangeError(code + " is not a valid code point");
              res.push(
                code < 0x10000
                  ? fromCharCode(code)
                  : fromCharCode(
                      ((code -= 0x10000) >> 10) + 0xd800,
                      (code % 0x400) + 0xdc00
                    )
              );
            }
            return res.join("");
          },
        }
      );

      /***/
    },
    /* 221 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(1);
      var toIObject = __webpack_require__(14);
      var toLength = __webpack_require__(10);

      $export($export.S, "String", {
        // 21.1.2.4 String.raw(callSite, ...substitutions)
        raw: function raw(callSite) {
          var tpl = toIObject(callSite.raw);
          var len = toLength(tpl.length);
          var aLen = arguments.length;
          var res = [];
          var i = 0;
          while (len > i) {
            res.push(String(tpl[i++]));
            if (i < aLen) res.push(String(arguments[i]));
          }
          return res.join("");
        },
      });

      /***/
    },
    /* 222 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // 21.1.3.25 String.prototype.trim()
      __webpack_require__(52)("trim", function ($trim) {
        return function trim() {
          return $trim(this, 3);
        };
      });

      /***/
    },
    /* 223 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $at = __webpack_require__(93)(true);

      // 21.1.3.27 String.prototype[@@iterator]()
      __webpack_require__(65)(
        String,
        "String",
        function (iterated) {
          this._t = String(iterated); // target
          this._i = 0; // next index
          // 21.1.5.2.1 %StringIteratorPrototype%.next()
        },
        function () {
          var O = this._t;
          var index = this._i;
          var point;
          if (index >= O.length) return { value: undefined, done: true };
          point = $at(O, index);
          this._i += point.length;
          return { value: point, done: false };
        }
      );

      /***/
    },
    /* 224 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(1);
      var $at = __webpack_require__(93)(false);
      $export($export.P, "String", {
        // 21.1.3.3 String.prototype.codePointAt(pos)
        codePointAt: function codePointAt(pos) {
          return $at(this, pos);
        },
      });

      /***/
    },
    /* 225 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";
      // 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

      var $export = __webpack_require__(1);
      var toLength = __webpack_require__(10);
      var context = __webpack_require__(94);
      var ENDS_WITH = "endsWith";
      var $endsWith = ""[ENDS_WITH];

      $export(
        $export.P + $export.F * __webpack_require__(95)(ENDS_WITH),
        "String",
        {
          endsWith: function endsWith(
            searchString /* , endPosition = @length */
          ) {
            var that = context(this, searchString, ENDS_WITH);
            var endPosition = arguments.length > 1 ? arguments[1] : undefined;
            var len = toLength(that.length);
            var end =
              endPosition === undefined
                ? len
                : Math.min(toLength(endPosition), len);
            var search = String(searchString);
            return $endsWith
              ? $endsWith.call(that, search, end)
              : that.slice(end - search.length, end) === search;
          },
        }
      );

      /***/
    },
    /* 226 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";
      // 21.1.3.7 String.prototype.includes(searchString, position = 0)

      var $export = __webpack_require__(1);
      var context = __webpack_require__(94);
      var INCLUDES = "includes";

      $export(
        $export.P + $export.F * __webpack_require__(95)(INCLUDES),
        "String",
        {
          includes: function includes(searchString /* , position = 0 */) {
            return !!~context(this, searchString, INCLUDES).indexOf(
              searchString,
              arguments.length > 1 ? arguments[1] : undefined
            );
          },
        }
      );

      /***/
    },
    /* 227 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(1);

      $export($export.P, "String", {
        // 21.1.3.13 String.prototype.repeat(count)
        repeat: __webpack_require__(90),
      });

      /***/
    },
    /* 228 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";
      // 21.1.3.18 String.prototype.startsWith(searchString [, position ])

      var $export = __webpack_require__(1);
      var toLength = __webpack_require__(10);
      var context = __webpack_require__(94);
      var STARTS_WITH = "startsWith";
      var $startsWith = ""[STARTS_WITH];

      $export(
        $export.P + $export.F * __webpack_require__(95)(STARTS_WITH),
        "String",
        {
          startsWith: function startsWith(searchString /* , position = 0 */) {
            var that = context(this, searchString, STARTS_WITH);
            var index = toLength(
              Math.min(
                arguments.length > 1 ? arguments[1] : undefined,
                that.length
              )
            );
            var search = String(searchString);
            return $startsWith
              ? $startsWith.call(that, search, index)
              : that.slice(index, index + search.length) === search;
          },
        }
      );

      /***/
    },
    /* 229 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.2 String.prototype.anchor(name)
      __webpack_require__(20)("anchor", function (createHTML) {
        return function anchor(name) {
          return createHTML(this, "a", "name", name);
        };
      });

      /***/
    },
    /* 230 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.3 String.prototype.big()
      __webpack_require__(20)("big", function (createHTML) {
        return function big() {
          return createHTML(this, "big", "", "");
        };
      });

      /***/
    },
    /* 231 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.4 String.prototype.blink()
      __webpack_require__(20)("blink", function (createHTML) {
        return function blink() {
          return createHTML(this, "blink", "", "");
        };
      });

      /***/
    },
    /* 232 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.5 String.prototype.bold()
      __webpack_require__(20)("bold", function (createHTML) {
        return function bold() {
          return createHTML(this, "b", "", "");
        };
      });

      /***/
    },
    /* 233 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.6 String.prototype.fixed()
      __webpack_require__(20)("fixed", function (createHTML) {
        return function fixed() {
          return createHTML(this, "tt", "", "");
        };
      });

      /***/
    },
    /* 234 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.7 String.prototype.fontcolor(color)
      __webpack_require__(20)("fontcolor", function (createHTML) {
        return function fontcolor(color) {
          return createHTML(this, "font", "color", color);
        };
      });

      /***/
    },
    /* 235 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.8 String.prototype.fontsize(size)
      __webpack_require__(20)("fontsize", function (createHTML) {
        return function fontsize(size) {
          return createHTML(this, "font", "size", size);
        };
      });

      /***/
    },
    /* 236 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.9 String.prototype.italics()
      __webpack_require__(20)("italics", function (createHTML) {
        return function italics() {
          return createHTML(this, "i", "", "");
        };
      });

      /***/
    },
    /* 237 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.10 String.prototype.link(url)
      __webpack_require__(20)("link", function (createHTML) {
        return function link(url) {
          return createHTML(this, "a", "href", url);
        };
      });

      /***/
    },
    /* 238 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.11 String.prototype.small()
      __webpack_require__(20)("small", function (createHTML) {
        return function small() {
          return createHTML(this, "small", "", "");
        };
      });

      /***/
    },
    /* 239 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.12 String.prototype.strike()
      __webpack_require__(20)("strike", function (createHTML) {
        return function strike() {
          return createHTML(this, "strike", "", "");
        };
      });

      /***/
    },
    /* 240 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.13 String.prototype.sub()
      __webpack_require__(20)("sub", function (createHTML) {
        return function sub() {
          return createHTML(this, "sub", "", "");
        };
      });

      /***/
    },
    /* 241 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.14 String.prototype.sup()
      __webpack_require__(20)("sup", function (createHTML) {
        return function sup() {
          return createHTML(this, "sup", "", "");
        };
      });

      /***/
    },
    /* 242 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.3.3.1 / 15.9.4.4 Date.now()
      var $export = __webpack_require__(1);

      $export($export.S, "Date", {
        now: function () {
          return new Date().getTime();
        },
      });

      /***/
    },
    /* 243 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(1);
      var toObject = __webpack_require__(12);
      var toPrimitive = __webpack_require__(24);

      $export(
        $export.P +
          $export.F *
            __webpack_require__(5)(function () {
              return (
                new Date(NaN).toJSON() !== null ||
                Date.prototype.toJSON.call({
                  toISOString: function () {
                    return 1;
                  },
                }) !== 1
              );
            }),
        "Date",
        {
          // eslint-disable-next-line no-unused-vars
          toJSON: function toJSON(key) {
            var O = toObject(this);
            var pv = toPrimitive(O);
            return typeof pv == "number" && !isFinite(pv)
              ? null
              : O.toISOString();
          },
        }
      );

      /***/
    },
    /* 244 */
    /***/ function (module, exports, __webpack_require__) {
      // 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
      var $export = __webpack_require__(1);
      var toISOString = __webpack_require__(245);

      // PhantomJS / old WebKit has a broken implementations
      $export(
        $export.P + $export.F * (Date.prototype.toISOString !== toISOString),
        "Date",
        {
          toISOString: toISOString,
        }
      );

      /***/
    },
    /* 245 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
      var fails = __webpack_require__(5);
      var getTime = Date.prototype.getTime;
      var $toISOString = Date.prototype.toISOString;

      var lz = function (num) {
        return num > 9 ? num : "0" + num;
      };

      // PhantomJS / old WebKit has a broken implementations
      module.exports =
        fails(function () {
          return (
            $toISOString.call(new Date(-5e13 - 1)) != "0385-07-25T07:06:39.999Z"
          );
        }) ||
        !fails(function () {
          $toISOString.call(new Date(NaN));
        })
          ? function toISOString() {
              if (!isFinite(getTime.call(this)))
                throw RangeError("Invalid time value");
              var d = this;
              var y = d.getUTCFullYear();
              var m = d.getUTCMilliseconds();
              var s = y < 0 ? "-" : y > 9999 ? "+" : "";
              return (
                s +
                ("00000" + Math.abs(y)).slice(s ? -6 : -4) +
                "-" +
                lz(d.getUTCMonth() + 1) +
                "-" +
                lz(d.getUTCDate()) +
                "T" +
                lz(d.getUTCHours()) +
                ":" +
                lz(d.getUTCMinutes()) +
                ":" +
                lz(d.getUTCSeconds()) +
                "." +
                (m > 99 ? m : "0" + lz(m)) +
                "Z"
              );
            }
          : $toISOString;

      /***/
    },
    /* 246 */
    /***/ function (module, exports, __webpack_require__) {
      var DateProto = Date.prototype;
      var INVALID_DATE = "Invalid Date";
      var TO_STRING = "toString";
      var $toString = DateProto[TO_STRING];
      var getTime = DateProto.getTime;
      if (new Date(NaN) + "" != INVALID_DATE) {
        __webpack_require__(17)(DateProto, TO_STRING, function toString() {
          var value = getTime.call(this);
          // eslint-disable-next-line no-self-compare
          return value === value ? $toString.call(this) : INVALID_DATE;
        });
      }

      /***/
    },
    /* 247 */
    /***/ function (module, exports, __webpack_require__) {
      var TO_PRIMITIVE = __webpack_require__(6)("toPrimitive");
      var proto = Date.prototype;

      if (!(TO_PRIMITIVE in proto))
        __webpack_require__(16)(proto, TO_PRIMITIVE, __webpack_require__(248));

      /***/
    },
    /* 248 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var anObject = __webpack_require__(2);
      var toPrimitive = __webpack_require__(24);
      var NUMBER = "number";

      module.exports = function (hint) {
        if (hint !== "string" && hint !== NUMBER && hint !== "default")
          throw TypeError("Incorrect hint");
        return toPrimitive(anObject(this), hint != NUMBER);
      };

      /***/
    },
    /* 249 */
    /***/ function (module, exports, __webpack_require__) {
      // 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
      var $export = __webpack_require__(1);

      $export($export.S, "Array", { isArray: __webpack_require__(63) });

      /***/
    },
    /* 250 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var ctx = __webpack_require__(21);
      var $export = __webpack_require__(1);
      var toObject = __webpack_require__(12);
      var call = __webpack_require__(122);
      var isArrayIter = __webpack_require__(96);
      var toLength = __webpack_require__(10);
      var createProperty = __webpack_require__(97);
      var getIterFn = __webpack_require__(59);

      $export(
        $export.S +
          $export.F *
            !__webpack_require__(68)(function (iter) {
              Array.from(iter);
            }),
        "Array",
        {
          // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
          from: function from(
            arrayLike /* , mapfn = undefined, thisArg = undefined */
          ) {
            var O = toObject(arrayLike);
            var C = typeof this == "function" ? this : Array;
            var aLen = arguments.length;
            var mapfn = aLen > 1 ? arguments[1] : undefined;
            var mapping = mapfn !== undefined;
            var index = 0;
            var iterFn = getIterFn(O);
            var length, result, step, iterator;
            if (mapping)
              mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
            // if object isn't iterable or it's array with default iterator - use simple case
            if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
              for (
                iterator = iterFn.call(O), result = new C();
                !(step = iterator.next()).done;
                index++
              ) {
                createProperty(
                  result,
                  index,
                  mapping
                    ? call(iterator, mapfn, [step.value, index], true)
                    : step.value
                );
              }
            } else {
              length = toLength(O.length);
              for (result = new C(length); length > index; index++) {
                createProperty(
                  result,
                  index,
                  mapping ? mapfn(O[index], index) : O[index]
                );
              }
            }
            result.length = index;
            return result;
          },
        }
      );

      /***/
    },
    /* 251 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(1);
      var createProperty = __webpack_require__(97);

      // WebKit Array.of isn't generic
      $export(
        $export.S +
          $export.F *
            __webpack_require__(5)(function () {
              function F() {
                /* empty */
              }
              return !(Array.of.call(F) instanceof F);
            }),
        "Array",
        {
          // 22.1.2.3 Array.of( ...items)
          of: function of(/* ...args */) {
            var index = 0;
            var aLen = arguments.length;
            var result = new (typeof this == "function" ? this : Array)(aLen);
            while (aLen > index)
              createProperty(result, index, arguments[index++]);
            result.length = aLen;
            return result;
          },
        }
      );

      /***/
    },
    /* 252 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // 22.1.3.13 Array.prototype.join(separator)
      var $export = __webpack_require__(1);
      var toIObject = __webpack_require__(14);
      var arrayJoin = [].join;

      // fallback for not array-like strings
      $export(
        $export.P +
          $export.F *
            (__webpack_require__(55) != Object ||
              !__webpack_require__(23)(arrayJoin)),
        "Array",
        {
          join: function join(separator) {
            return arrayJoin.call(
              toIObject(this),
              separator === undefined ? "," : separator
            );
          },
        }
      );

      /***/
    },
    /* 253 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(1);
      var html = __webpack_require__(82);
      var cof = __webpack_require__(22);
      var toAbsoluteIndex = __webpack_require__(43);
      var toLength = __webpack_require__(10);
      var arraySlice = [].slice;

      // fallback for not array-like ES3 strings and DOM objects
      $export(
        $export.P +
          $export.F *
            __webpack_require__(5)(function () {
              if (html) arraySlice.call(html);
            }),
        "Array",
        {
          slice: function slice(begin, end) {
            var len = toLength(this.length);
            var klass = cof(this);
            end = end === undefined ? len : end;
            if (klass == "Array") return arraySlice.call(this, begin, end);
            var start = toAbsoluteIndex(begin, len);
            var upTo = toAbsoluteIndex(end, len);
            var size = toLength(upTo - start);
            var cloned = new Array(size);
            var i = 0;
            for (; i < size; i++)
              cloned[i] =
                klass == "String" ? this.charAt(start + i) : this[start + i];
            return cloned;
          },
        }
      );

      /***/
    },
    /* 254 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(1);
      var aFunction = __webpack_require__(13);
      var toObject = __webpack_require__(12);
      var fails = __webpack_require__(5);
      var $sort = [].sort;
      var test = [1, 2, 3];

      $export(
        $export.P +
          $export.F *
            (fails(function () {
              // IE8-
              test.sort(undefined);
            }) ||
              !fails(function () {
                // V8 bug
                test.sort(null);
                // Old WebKit
              }) ||
              !__webpack_require__(23)($sort)),
        "Array",
        {
          // 22.1.3.25 Array.prototype.sort(comparefn)
          sort: function sort(comparefn) {
            return comparefn === undefined
              ? $sort.call(toObject(this))
              : $sort.call(toObject(this), aFunction(comparefn));
          },
        }
      );

      /***/
    },
    /* 255 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(1);
      var $forEach = __webpack_require__(28)(0);
      var STRICT = __webpack_require__(23)([].forEach, true);

      $export($export.P + $export.F * !STRICT, "Array", {
        // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
        forEach: function forEach(callbackfn /* , thisArg */) {
          return $forEach(this, callbackfn, arguments[1]);
        },
      });

      /***/
    },
    /* 256 */
    /***/ function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(4);
      var isArray = __webpack_require__(63);
      var SPECIES = __webpack_require__(6)("species");

      module.exports = function (original) {
        var C;
        if (isArray(original)) {
          C = original.constructor;
          // cross-realm fallback
          if (typeof C == "function" && (C === Array || isArray(C.prototype)))
            C = undefined;
          if (isObject(C)) {
            C = C[SPECIES];
            if (C === null) C = undefined;
          }
        }
        return C === undefined ? Array : C;
      };

      /***/
    },
    /* 257 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(1);
      var $map = __webpack_require__(28)(1);

      $export(
        $export.P + $export.F * !__webpack_require__(23)([].map, true),
        "Array",
        {
          // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
          map: function map(callbackfn /* , thisArg */) {
            return $map(this, callbackfn, arguments[1]);
          },
        }
      );

      /***/
    },
    /* 258 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(1);
      var $filter = __webpack_require__(28)(2);

      $export(
        $export.P + $export.F * !__webpack_require__(23)([].filter, true),
        "Array",
        {
          // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
          filter: function filter(callbackfn /* , thisArg */) {
            return $filter(this, callbackfn, arguments[1]);
          },
        }
      );

      /***/
    },
    /* 259 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(1);
      var $some = __webpack_require__(28)(3);

      $export(
        $export.P + $export.F * !__webpack_require__(23)([].some, true),
        "Array",
        {
          // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
          some: function some(callbackfn /* , thisArg */) {
            return $some(this, callbackfn, arguments[1]);
          },
        }
      );

      /***/
    },
    /* 260 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(1);
      var $every = __webpack_require__(28)(4);

      $export(
        $export.P + $export.F * !__webpack_require__(23)([].every, true),
        "Array",
        {
          // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
          every: function every(callbackfn /* , thisArg */) {
            return $every(this, callbackfn, arguments[1]);
          },
        }
      );

      /***/
    },
    /* 261 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(1);
      var $reduce = __webpack_require__(123);

      $export(
        $export.P + $export.F * !__webpack_require__(23)([].reduce, true),
        "Array",
        {
          // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
          reduce: function reduce(callbackfn /* , initialValue */) {
            return $reduce(
              this,
              callbackfn,
              arguments.length,
              arguments[1],
              false
            );
          },
        }
      );

      /***/
    },
    /* 262 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(1);
      var $reduce = __webpack_require__(123);

      $export(
        $export.P + $export.F * !__webpack_require__(23)([].reduceRight, true),
        "Array",
        {
          // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
          reduceRight: function reduceRight(callbackfn /* , initialValue */) {
            return $reduce(
              this,
              callbackfn,
              arguments.length,
              arguments[1],
              true
            );
          },
        }
      );

      /***/
    },
    /* 263 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(1);
      var $indexOf = __webpack_require__(61)(false);
      var $native = [].indexOf;
      var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

      $export(
        $export.P +
          $export.F * (NEGATIVE_ZERO || !__webpack_require__(23)($native)),
        "Array",
        {
          // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
          indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
            return NEGATIVE_ZERO
              ? // convert -0 to +0
                $native.apply(this, arguments) || 0
              : $indexOf(this, searchElement, arguments[1]);
          },
        }
      );

      /***/
    },
    /* 264 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(1);
      var toIObject = __webpack_require__(14);
      var toInteger = __webpack_require__(26);
      var toLength = __webpack_require__(10);
      var $native = [].lastIndexOf;
      var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

      $export(
        $export.P +
          $export.F * (NEGATIVE_ZERO || !__webpack_require__(23)($native)),
        "Array",
        {
          // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
          lastIndexOf: function lastIndexOf(
            searchElement /* , fromIndex = @[*-1] */
          ) {
            // convert -0 to +0
            if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
            var O = toIObject(this);
            var length = toLength(O.length);
            var index = length - 1;
            if (arguments.length > 1)
              index = Math.min(index, toInteger(arguments[1]));
            if (index < 0) index = length + index;
            for (; index >= 0; index--)
              if (index in O) if (O[index] === searchElement) return index || 0;
            return -1;
          },
        }
      );

      /***/
    },
    /* 265 */
    /***/ function (module, exports, __webpack_require__) {
      // 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
      var $export = __webpack_require__(1);

      $export($export.P, "Array", { copyWithin: __webpack_require__(124) });

      __webpack_require__(39)("copyWithin");

      /***/
    },
    /* 266 */
    /***/ function (module, exports, __webpack_require__) {
      // 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
      var $export = __webpack_require__(1);

      $export($export.P, "Array", { fill: __webpack_require__(99) });

      __webpack_require__(39)("fill");

      /***/
    },
    /* 267 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
      var $export = __webpack_require__(1);
      var $find = __webpack_require__(28)(5);
      var KEY = "find";
      var forced = true;
      // Shouldn't skip holes
      if (KEY in [])
        Array(1)[KEY](function () {
          forced = false;
        });
      $export($export.P + $export.F * forced, "Array", {
        find: function find(callbackfn /* , that = undefined */) {
          return $find(
            this,
            callbackfn,
            arguments.length > 1 ? arguments[1] : undefined
          );
        },
      });
      __webpack_require__(39)(KEY);

      /***/
    },
    /* 268 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
      var $export = __webpack_require__(1);
      var $find = __webpack_require__(28)(6);
      var KEY = "findIndex";
      var forced = true;
      // Shouldn't skip holes
      if (KEY in [])
        Array(1)[KEY](function () {
          forced = false;
        });
      $export($export.P + $export.F * forced, "Array", {
        findIndex: function findIndex(callbackfn /* , that = undefined */) {
          return $find(
            this,
            callbackfn,
            arguments.length > 1 ? arguments[1] : undefined
          );
        },
      });
      __webpack_require__(39)(KEY);

      /***/
    },
    /* 269 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(48)("Array");

      /***/
    },
    /* 270 */
    /***/ function (module, exports, __webpack_require__) {
      var global = __webpack_require__(3);
      var inheritIfRequired = __webpack_require__(89);
      var dP = __webpack_require__(8).f;
      var gOPN = __webpack_require__(44).f;
      var isRegExp = __webpack_require__(67);
      var $flags = __webpack_require__(69);
      var $RegExp = global.RegExp;
      var Base = $RegExp;
      var proto = $RegExp.prototype;
      var re1 = /a/g;
      var re2 = /a/g;
      // "new" creates a new object, old webkit buggy here
      var CORRECT_NEW = new $RegExp(re1) !== re1;

      if (
        __webpack_require__(9) &&
        (!CORRECT_NEW ||
          __webpack_require__(5)(function () {
            re2[__webpack_require__(6)("match")] = false;
            // RegExp constructor can alter flags and IsRegExp works correct with @@match
            return (
              $RegExp(re1) != re1 ||
              $RegExp(re2) == re2 ||
              $RegExp(re1, "i") != "/a/i"
            );
          }))
      ) {
        $RegExp = function RegExp(p, f) {
          var tiRE = this instanceof $RegExp;
          var piRE = isRegExp(p);
          var fiU = f === undefined;
          return !tiRE && piRE && p.constructor === $RegExp && fiU
            ? p
            : inheritIfRequired(
                CORRECT_NEW
                  ? new Base(piRE && !fiU ? p.source : p, f)
                  : Base(
                      (piRE = p instanceof $RegExp) ? p.source : p,
                      piRE && fiU ? $flags.call(p) : f
                    ),
                tiRE ? this : proto,
                $RegExp
              );
        };
        var proxy = function (key) {
          key in $RegExp ||
            dP($RegExp, key, {
              configurable: true,
              get: function () {
                return Base[key];
              },
              set: function (it) {
                Base[key] = it;
              },
            });
        };
        for (var keys = gOPN(Base), i = 0; keys.length > i; ) proxy(keys[i++]);
        proto.constructor = $RegExp;
        $RegExp.prototype = proto;
        __webpack_require__(17)(global, "RegExp", $RegExp);
      }

      __webpack_require__(48)("RegExp");

      /***/
    },
    /* 271 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      __webpack_require__(125);
      var anObject = __webpack_require__(2);
      var $flags = __webpack_require__(69);
      var DESCRIPTORS = __webpack_require__(9);
      var TO_STRING = "toString";
      var $toString = /./[TO_STRING];

      var define = function (fn) {
        __webpack_require__(17)(RegExp.prototype, TO_STRING, fn, true);
      };

      // 21.2.5.14 RegExp.prototype.toString()
      if (
        __webpack_require__(5)(function () {
          return $toString.call({ source: "a", flags: "b" }) != "/a/b";
        })
      ) {
        define(function toString() {
          var R = anObject(this);
          return "/".concat(
            R.source,
            "/",
            "flags" in R
              ? R.flags
              : !DESCRIPTORS && R instanceof RegExp
              ? $flags.call(R)
              : undefined
          );
        });
        // FF44- RegExp#toString has a wrong name
      } else if ($toString.name != TO_STRING) {
        define(function toString() {
          return $toString.call(this);
        });
      }

      /***/
    },
    /* 272 */
    /***/ function (module, exports, __webpack_require__) {
      // @@match logic
      __webpack_require__(70)("match", 1, function (defined, MATCH, $match) {
        // 21.1.3.11 String.prototype.match(regexp)
        return [
          function match(regexp) {
            "use strict";
            var O = defined(this);
            var fn = regexp == undefined ? undefined : regexp[MATCH];
            return fn !== undefined
              ? fn.call(regexp, O)
              : new RegExp(regexp)[MATCH](String(O));
          },
          $match,
        ];
      });

      /***/
    },
    /* 273 */
    /***/ function (module, exports, __webpack_require__) {
      // @@replace logic
      __webpack_require__(70)(
        "replace",
        2,
        function (defined, REPLACE, $replace) {
          // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
          return [
            function replace(searchValue, replaceValue) {
              "use strict";
              var O = defined(this);
              var fn =
                searchValue == undefined ? undefined : searchValue[REPLACE];
              return fn !== undefined
                ? fn.call(searchValue, O, replaceValue)
                : $replace.call(String(O), searchValue, replaceValue);
            },
            $replace,
          ];
        }
      );

      /***/
    },
    /* 274 */
    /***/ function (module, exports, __webpack_require__) {
      // @@search logic
      __webpack_require__(70)("search", 1, function (defined, SEARCH, $search) {
        // 21.1.3.15 String.prototype.search(regexp)
        return [
          function search(regexp) {
            "use strict";
            var O = defined(this);
            var fn = regexp == undefined ? undefined : regexp[SEARCH];
            return fn !== undefined
              ? fn.call(regexp, O)
              : new RegExp(regexp)[SEARCH](String(O));
          },
          $search,
        ];
      });

      /***/
    },
    /* 275 */
    /***/ function (module, exports, __webpack_require__) {
      // @@split logic
      __webpack_require__(70)("split", 2, function (defined, SPLIT, $split) {
        "use strict";
        var isRegExp = __webpack_require__(67);
        var _split = $split;
        var $push = [].push;
        var $SPLIT = "split";
        var LENGTH = "length";
        var LAST_INDEX = "lastIndex";
        if (
          "abbc"[$SPLIT](/(b)*/)[1] == "c" ||
          "test"[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
          "ab"[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
          "."[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
          "."[$SPLIT](/()()/)[LENGTH] > 1 ||
          ""[$SPLIT](/.?/)[LENGTH]
        ) {
          var NPCG = /()??/.exec("")[1] === undefined; // nonparticipating capturing group
          // based on es5-shim implementation, need to rework it
          $split = function (separator, limit) {
            var string = String(this);
            if (separator === undefined && limit === 0) return [];
            // If `separator` is not a regex, use native split
            if (!isRegExp(separator))
              return _split.call(string, separator, limit);
            var output = [];
            var flags =
              (separator.ignoreCase ? "i" : "") +
              (separator.multiline ? "m" : "") +
              (separator.unicode ? "u" : "") +
              (separator.sticky ? "y" : "");
            var lastLastIndex = 0;
            var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
            // Make `global` and avoid `lastIndex` issues by working with a copy
            var separatorCopy = new RegExp(separator.source, flags + "g");
            var separator2, match, lastIndex, lastLength, i;
            // Doesn't need flags gy, but they don't hurt
            if (!NPCG)
              separator2 = new RegExp(
                "^" + separatorCopy.source + "$(?!\\s)",
                flags
              );
            while ((match = separatorCopy.exec(string))) {
              // `separatorCopy.lastIndex` is not reliable cross-browser
              lastIndex = match.index + match[0][LENGTH];
              if (lastIndex > lastLastIndex) {
                output.push(string.slice(lastLastIndex, match.index));
                // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
                // eslint-disable-next-line no-loop-func
                if (!NPCG && match[LENGTH] > 1)
                  match[0].replace(separator2, function () {
                    for (i = 1; i < arguments[LENGTH] - 2; i++)
                      if (arguments[i] === undefined) match[i] = undefined;
                  });
                if (match[LENGTH] > 1 && match.index < string[LENGTH])
                  $push.apply(output, match.slice(1));
                lastLength = match[0][LENGTH];
                lastLastIndex = lastIndex;
                if (output[LENGTH] >= splitLimit) break;
              }
              if (separatorCopy[LAST_INDEX] === match.index)
                separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
            }
            if (lastLastIndex === string[LENGTH]) {
              if (lastLength || !separatorCopy.test("")) output.push("");
            } else output.push(string.slice(lastLastIndex));
            return output[LENGTH] > splitLimit
              ? output.slice(0, splitLimit)
              : output;
          };
          // Chakra, V8
        } else if ("0"[$SPLIT](undefined, 0)[LENGTH]) {
          $split = function (separator, limit) {
            return separator === undefined && limit === 0
              ? []
              : _split.call(this, separator, limit);
          };
        }
        // 21.1.3.17 String.prototype.split(separator, limit)
        return [
          function split(separator, limit) {
            var O = defined(this);
            var fn = separator == undefined ? undefined : separator[SPLIT];
            return fn !== undefined
              ? fn.call(separator, O, limit)
              : $split.call(String(O), separator, limit);
          },
          $split,
        ];
      });

      /***/
    },
    /* 276 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var LIBRARY = __webpack_require__(38);
      var global = __webpack_require__(3);
      var ctx = __webpack_require__(21);
      var classof = __webpack_require__(45);
      var $export = __webpack_require__(1);
      var isObject = __webpack_require__(4);
      var aFunction = __webpack_require__(13);
      var anInstance = __webpack_require__(49);
      var forOf = __webpack_require__(40);
      var speciesConstructor = __webpack_require__(71);
      var task = __webpack_require__(100).set;
      var microtask = __webpack_require__(101)();
      var newPromiseCapabilityModule = __webpack_require__(102);
      var perform = __webpack_require__(126);
      var userAgent = __webpack_require__(72);
      var promiseResolve = __webpack_require__(127);
      var PROMISE = "Promise";
      var TypeError = global.TypeError;
      var process = global.process;
      var versions = process && process.versions;
      var v8 = (versions && versions.v8) || "";
      var $Promise = global[PROMISE];
      var isNode = classof(process) == "process";
      var empty = function () {
        /* empty */
      };
      var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
      var newPromiseCapability = (newGenericPromiseCapability =
        newPromiseCapabilityModule.f);

      var USE_NATIVE = !!(function () {
        try {
          // correct subclassing with @@species support
          var promise = $Promise.resolve(1);
          var FakePromise = ((promise.constructor = {})[
            __webpack_require__(6)("species")
          ] = function (exec) {
            exec(empty, empty);
          });
          // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
          return (
            (isNode || typeof PromiseRejectionEvent == "function") &&
            promise.then(empty) instanceof FakePromise &&
            // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
            // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
            // we can't detect it synchronously, so just check versions
            v8.indexOf("6.6") !== 0 &&
            userAgent.indexOf("Chrome/66") === -1
          );
        } catch (e) {
          /* empty */
        }
      })();

      // helpers
      var isThenable = function (it) {
        var then;
        return isObject(it) && typeof (then = it.then) == "function"
          ? then
          : false;
      };
      var notify = function (promise, isReject) {
        if (promise._n) return;
        promise._n = true;
        var chain = promise._c;
        microtask(function () {
          var value = promise._v;
          var ok = promise._s == 1;
          var i = 0;
          var run = function (reaction) {
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;
            try {
              if (handler) {
                if (!ok) {
                  if (promise._h == 2) onHandleUnhandled(promise);
                  promise._h = 1;
                }
                if (handler === true) result = value;
                else {
                  if (domain) domain.enter();
                  result = handler(value); // may throw
                  if (domain) {
                    domain.exit();
                    exited = true;
                  }
                }
                if (result === reaction.promise) {
                  reject(TypeError("Promise-chain cycle"));
                } else if ((then = isThenable(result))) {
                  then.call(result, resolve, reject);
                } else resolve(result);
              } else reject(value);
            } catch (e) {
              if (domain && !exited) domain.exit();
              reject(e);
            }
          };
          while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
          promise._c = [];
          promise._n = false;
          if (isReject && !promise._h) onUnhandled(promise);
        });
      };
      var onUnhandled = function (promise) {
        task.call(global, function () {
          var value = promise._v;
          var unhandled = isUnhandled(promise);
          var result, handler, console;
          if (unhandled) {
            result = perform(function () {
              if (isNode) {
                process.emit("unhandledRejection", value, promise);
              } else if ((handler = global.onunhandledrejection)) {
                handler({ promise: promise, reason: value });
              } else if ((console = global.console) && console.error) {
                console.error("Unhandled promise rejection", value);
              }
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            promise._h = isNode || isUnhandled(promise) ? 2 : 1;
          }
          promise._a = undefined;
          if (unhandled && result.e) throw result.v;
        });
      };
      var isUnhandled = function (promise) {
        return promise._h !== 1 && (promise._a || promise._c).length === 0;
      };
      var onHandleUnhandled = function (promise) {
        task.call(global, function () {
          var handler;
          if (isNode) {
            process.emit("rejectionHandled", promise);
          } else if ((handler = global.onrejectionhandled)) {
            handler({ promise: promise, reason: promise._v });
          }
        });
      };
      var $reject = function (value) {
        var promise = this;
        if (promise._d) return;
        promise._d = true;
        promise = promise._w || promise; // unwrap
        promise._v = value;
        promise._s = 2;
        if (!promise._a) promise._a = promise._c.slice();
        notify(promise, true);
      };
      var $resolve = function (value) {
        var promise = this;
        var then;
        if (promise._d) return;
        promise._d = true;
        promise = promise._w || promise; // unwrap
        try {
          if (promise === value)
            throw TypeError("Promise can't be resolved itself");
          if ((then = isThenable(value))) {
            microtask(function () {
              var wrapper = { _w: promise, _d: false }; // wrap
              try {
                then.call(
                  value,
                  ctx($resolve, wrapper, 1),
                  ctx($reject, wrapper, 1)
                );
              } catch (e) {
                $reject.call(wrapper, e);
              }
            });
          } else {
            promise._v = value;
            promise._s = 1;
            notify(promise, false);
          }
        } catch (e) {
          $reject.call({ _w: promise, _d: false }, e); // wrap
        }
      };

      // constructor polyfill
      if (!USE_NATIVE) {
        // 25.4.3.1 Promise(executor)
        $Promise = function Promise(executor) {
          anInstance(this, $Promise, PROMISE, "_h");
          aFunction(executor);
          Internal.call(this);
          try {
            executor(ctx($resolve, this, 1), ctx($reject, this, 1));
          } catch (err) {
            $reject.call(this, err);
          }
        };
        // eslint-disable-next-line no-unused-vars
        Internal = function Promise(executor) {
          this._c = []; // <- awaiting reactions
          this._a = undefined; // <- checked in isUnhandled reactions
          this._s = 0; // <- state
          this._d = false; // <- done
          this._v = undefined; // <- value
          this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
          this._n = false; // <- notify
        };
        Internal.prototype = __webpack_require__(50)($Promise.prototype, {
          // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
          then: function then(onFulfilled, onRejected) {
            var reaction = newPromiseCapability(
              speciesConstructor(this, $Promise)
            );
            reaction.ok = typeof onFulfilled == "function" ? onFulfilled : true;
            reaction.fail = typeof onRejected == "function" && onRejected;
            reaction.domain = isNode ? process.domain : undefined;
            this._c.push(reaction);
            if (this._a) this._a.push(reaction);
            if (this._s) notify(this, false);
            return reaction.promise;
          },
          // 25.4.5.1 Promise.prototype.catch(onRejected)
          catch: function (onRejected) {
            return this.then(undefined, onRejected);
          },
        });
        OwnPromiseCapability = function () {
          var promise = new Internal();
          this.promise = promise;
          this.resolve = ctx($resolve, promise, 1);
          this.reject = ctx($reject, promise, 1);
        };
        newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
          return C === $Promise || C === Wrapper
            ? new OwnPromiseCapability(C)
            : newGenericPromiseCapability(C);
        };
      }

      $export($export.G + $export.W + $export.F * !USE_NATIVE, {
        Promise: $Promise,
      });
      __webpack_require__(51)($Promise, PROMISE);
      __webpack_require__(48)(PROMISE);
      Wrapper = __webpack_require__(11)[PROMISE];

      // statics
      $export($export.S + $export.F * !USE_NATIVE, PROMISE, {
        // 25.4.4.5 Promise.reject(r)
        reject: function reject(r) {
          var capability = newPromiseCapability(this);
          var $$reject = capability.reject;
          $$reject(r);
          return capability.promise;
        },
      });
      $export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
        // 25.4.4.6 Promise.resolve(x)
        resolve: function resolve(x) {
          return promiseResolve(
            LIBRARY && this === Wrapper ? $Promise : this,
            x
          );
        },
      });
      $export(
        $export.S +
          $export.F *
            !(
              USE_NATIVE &&
              __webpack_require__(68)(function (iter) {
                $Promise.all(iter)["catch"](empty);
              })
            ),
        PROMISE,
        {
          // 25.4.4.1 Promise.all(iterable)
          all: function all(iterable) {
            var C = this;
            var capability = newPromiseCapability(C);
            var resolve = capability.resolve;
            var reject = capability.reject;
            var result = perform(function () {
              var values = [];
              var index = 0;
              var remaining = 1;
              forOf(iterable, false, function (promise) {
                var $index = index++;
                var alreadyCalled = false;
                values.push(undefined);
                remaining++;
                C.resolve(promise).then(function (value) {
                  if (alreadyCalled) return;
                  alreadyCalled = true;
                  values[$index] = value;
                  --remaining || resolve(values);
                }, reject);
              });
              --remaining || resolve(values);
            });
            if (result.e) reject(result.v);
            return capability.promise;
          },
          // 25.4.4.4 Promise.race(iterable)
          race: function race(iterable) {
            var C = this;
            var capability = newPromiseCapability(C);
            var reject = capability.reject;
            var result = perform(function () {
              forOf(iterable, false, function (promise) {
                C.resolve(promise).then(capability.resolve, reject);
              });
            });
            if (result.e) reject(result.v);
            return capability.promise;
          },
        }
      );

      /***/
    },
    /* 277 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var weak = __webpack_require__(132);
      var validate = __webpack_require__(53);
      var WEAK_SET = "WeakSet";

      // 23.4 WeakSet Objects
      __webpack_require__(73)(
        WEAK_SET,
        function (get) {
          return function WeakSet() {
            return get(this, arguments.length > 0 ? arguments[0] : undefined);
          };
        },
        {
          // 23.4.3.1 WeakSet.prototype.add(value)
          add: function add(value) {
            return weak.def(validate(this, WEAK_SET), value, true);
          },
        },
        weak,
        false,
        true
      );

      /***/
    },
    /* 278 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(1);
      var $typed = __webpack_require__(74);
      var buffer = __webpack_require__(103);
      var anObject = __webpack_require__(2);
      var toAbsoluteIndex = __webpack_require__(43);
      var toLength = __webpack_require__(10);
      var isObject = __webpack_require__(4);
      var ArrayBuffer = __webpack_require__(3).ArrayBuffer;
      var speciesConstructor = __webpack_require__(71);
      var $ArrayBuffer = buffer.ArrayBuffer;
      var $DataView = buffer.DataView;
      var $isView = $typed.ABV && ArrayBuffer.isView;
      var $slice = $ArrayBuffer.prototype.slice;
      var VIEW = $typed.VIEW;
      var ARRAY_BUFFER = "ArrayBuffer";

      $export(
        $export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer),
        { ArrayBuffer: $ArrayBuffer }
      );

      $export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
        // 24.1.3.1 ArrayBuffer.isView(arg)
        isView: function isView(it) {
          return ($isView && $isView(it)) || (isObject(it) && VIEW in it);
        },
      });

      $export(
        $export.P +
          $export.U +
          $export.F *
            __webpack_require__(5)(function () {
              return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
            }),
        ARRAY_BUFFER,
        {
          // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
          slice: function slice(start, end) {
            if ($slice !== undefined && end === undefined)
              return $slice.call(anObject(this), start); // FF fix
            var len = anObject(this).byteLength;
            var first = toAbsoluteIndex(start, len);
            var fin = toAbsoluteIndex(end === undefined ? len : end, len);
            var result = new (speciesConstructor(this, $ArrayBuffer))(
              toLength(fin - first)
            );
            var viewS = new $DataView(this);
            var viewT = new $DataView(result);
            var index = 0;
            while (first < fin) {
              viewT.setUint8(index++, viewS.getUint8(first++));
            }
            return result;
          },
        }
      );

      __webpack_require__(48)(ARRAY_BUFFER);

      /***/
    },
    /* 279 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(1);
      $export(
        $export.G + $export.W + $export.F * !__webpack_require__(74).ABV,
        {
          DataView: __webpack_require__(103).DataView,
        }
      );

      /***/
    },
    /* 280 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(33)("Int8", 1, function (init) {
        return function Int8Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });

      /***/
    },
    /* 281 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(33)("Uint8", 1, function (init) {
        return function Uint8Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });

      /***/
    },
    /* 282 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(33)(
        "Uint8",
        1,
        function (init) {
          return function Uint8ClampedArray(data, byteOffset, length) {
            return init(this, data, byteOffset, length);
          };
        },
        true
      );

      /***/
    },
    /* 283 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(33)("Int16", 2, function (init) {
        return function Int16Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });

      /***/
    },
    /* 284 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(33)("Uint16", 2, function (init) {
        return function Uint16Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });

      /***/
    },
    /* 285 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(33)("Int32", 4, function (init) {
        return function Int32Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });

      /***/
    },
    /* 286 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(33)("Uint32", 4, function (init) {
        return function Uint32Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });

      /***/
    },
    /* 287 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(33)("Float32", 4, function (init) {
        return function Float32Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });

      /***/
    },
    /* 288 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(33)("Float64", 8, function (init) {
        return function Float64Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });

      /***/
    },
    /* 289 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
      var $export = __webpack_require__(1);
      var aFunction = __webpack_require__(13);
      var anObject = __webpack_require__(2);
      var rApply = (__webpack_require__(3).Reflect || {}).apply;
      var fApply = Function.apply;
      // MS Edge argumentsList argument is optional
      $export(
        $export.S +
          $export.F *
            !__webpack_require__(5)(function () {
              rApply(function () {
                /* empty */
              });
            }),
        "Reflect",
        {
          apply: function apply(target, thisArgument, argumentsList) {
            var T = aFunction(target);
            var L = anObject(argumentsList);
            return rApply
              ? rApply(T, thisArgument, L)
              : fApply.call(T, thisArgument, L);
          },
        }
      );

      /***/
    },
    /* 290 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
      var $export = __webpack_require__(1);
      var create = __webpack_require__(31);
      var aFunction = __webpack_require__(13);
      var anObject = __webpack_require__(2);
      var isObject = __webpack_require__(4);
      var fails = __webpack_require__(5);
      var bind = __webpack_require__(115);
      var rConstruct = (__webpack_require__(3).Reflect || {}).construct;

      // MS Edge supports only 2 arguments and argumentsList argument is optional
      // FF Nightly sets third argument as `new.target`, but does not create `this` from it
      var NEW_TARGET_BUG = fails(function () {
        function F() {
          /* empty */
        }
        return !(
          rConstruct(
            function () {
              /* empty */
            },
            [],
            F
          ) instanceof F
        );
      });
      var ARGS_BUG = !fails(function () {
        rConstruct(function () {
          /* empty */
        });
      });

      $export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), "Reflect", {
        construct: function construct(Target, args /* , newTarget */) {
          aFunction(Target);
          anObject(args);
          var newTarget =
            arguments.length < 3 ? Target : aFunction(arguments[2]);
          if (ARGS_BUG && !NEW_TARGET_BUG)
            return rConstruct(Target, args, newTarget);
          if (Target == newTarget) {
            // w/o altered newTarget, optimization for 0-4 arguments
            switch (args.length) {
              case 0:
                return new Target();
              case 1:
                return new Target(args[0]);
              case 2:
                return new Target(args[0], args[1]);
              case 3:
                return new Target(args[0], args[1], args[2]);
              case 4:
                return new Target(args[0], args[1], args[2], args[3]);
            }
            // w/o altered newTarget, lot of arguments case
            var $args = [null];
            $args.push.apply($args, args);
            return new (bind.apply(Target, $args))();
          }
          // with altered newTarget, not support built-in constructors
          var proto = newTarget.prototype;
          var instance = create(isObject(proto) ? proto : Object.prototype);
          var result = Function.apply.call(Target, instance, args);
          return isObject(result) ? result : instance;
        },
      });

      /***/
    },
    /* 291 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
      var dP = __webpack_require__(8);
      var $export = __webpack_require__(1);
      var anObject = __webpack_require__(2);
      var toPrimitive = __webpack_require__(24);

      // MS Edge has broken Reflect.defineProperty - throwing instead of returning false
      $export(
        $export.S +
          $export.F *
            __webpack_require__(5)(function () {
              // eslint-disable-next-line no-undef
              Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, {
                value: 2,
              });
            }),
        "Reflect",
        {
          defineProperty: function defineProperty(
            target,
            propertyKey,
            attributes
          ) {
            anObject(target);
            propertyKey = toPrimitive(propertyKey, true);
            anObject(attributes);
            try {
              dP.f(target, propertyKey, attributes);
              return true;
            } catch (e) {
              return false;
            }
          },
        }
      );

      /***/
    },
    /* 292 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.4 Reflect.deleteProperty(target, propertyKey)
      var $export = __webpack_require__(1);
      var gOPD = __webpack_require__(18).f;
      var anObject = __webpack_require__(2);

      $export($export.S, "Reflect", {
        deleteProperty: function deleteProperty(target, propertyKey) {
          var desc = gOPD(anObject(target), propertyKey);
          return desc && !desc.configurable
            ? false
            : delete target[propertyKey];
        },
      });

      /***/
    },
    /* 293 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // 26.1.5 Reflect.enumerate(target)
      var $export = __webpack_require__(1);
      var anObject = __webpack_require__(2);
      var Enumerate = function (iterated) {
        this._t = anObject(iterated); // target
        this._i = 0; // next index
        var keys = (this._k = []); // keys
        var key;
        for (key in iterated) keys.push(key);
      };
      __webpack_require__(66)(Enumerate, "Object", function () {
        var that = this;
        var keys = that._k;
        var key;
        do {
          if (that._i >= keys.length) return { value: undefined, done: true };
        } while (!((key = keys[that._i++]) in that._t));
        return { value: key, done: false };
      });

      $export($export.S, "Reflect", {
        enumerate: function enumerate(target) {
          return new Enumerate(target);
        },
      });

      /***/
    },
    /* 294 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.6 Reflect.get(target, propertyKey [, receiver])
      var gOPD = __webpack_require__(18);
      var getPrototypeOf = __webpack_require__(19);
      var has = __webpack_require__(15);
      var $export = __webpack_require__(1);
      var isObject = __webpack_require__(4);
      var anObject = __webpack_require__(2);

      function get(target, propertyKey /* , receiver */) {
        var receiver = arguments.length < 3 ? target : arguments[2];
        var desc, proto;
        if (anObject(target) === receiver) return target[propertyKey];
        if ((desc = gOPD.f(target, propertyKey)))
          return has(desc, "value")
            ? desc.value
            : desc.get !== undefined
            ? desc.get.call(receiver)
            : undefined;
        if (isObject((proto = getPrototypeOf(target))))
          return get(proto, propertyKey, receiver);
      }

      $export($export.S, "Reflect", { get: get });

      /***/
    },
    /* 295 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
      var gOPD = __webpack_require__(18);
      var $export = __webpack_require__(1);
      var anObject = __webpack_require__(2);

      $export($export.S, "Reflect", {
        getOwnPropertyDescriptor: function getOwnPropertyDescriptor(
          target,
          propertyKey
        ) {
          return gOPD.f(anObject(target), propertyKey);
        },
      });

      /***/
    },
    /* 296 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.8 Reflect.getPrototypeOf(target)
      var $export = __webpack_require__(1);
      var getProto = __webpack_require__(19);
      var anObject = __webpack_require__(2);

      $export($export.S, "Reflect", {
        getPrototypeOf: function getPrototypeOf(target) {
          return getProto(anObject(target));
        },
      });

      /***/
    },
    /* 297 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.9 Reflect.has(target, propertyKey)
      var $export = __webpack_require__(1);

      $export($export.S, "Reflect", {
        has: function has(target, propertyKey) {
          return propertyKey in target;
        },
      });

      /***/
    },
    /* 298 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.10 Reflect.isExtensible(target)
      var $export = __webpack_require__(1);
      var anObject = __webpack_require__(2);
      var $isExtensible = Object.isExtensible;

      $export($export.S, "Reflect", {
        isExtensible: function isExtensible(target) {
          anObject(target);
          return $isExtensible ? $isExtensible(target) : true;
        },
      });

      /***/
    },
    /* 299 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.11 Reflect.ownKeys(target)
      var $export = __webpack_require__(1);

      $export($export.S, "Reflect", { ownKeys: __webpack_require__(104) });

      /***/
    },
    /* 300 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.12 Reflect.preventExtensions(target)
      var $export = __webpack_require__(1);
      var anObject = __webpack_require__(2);
      var $preventExtensions = Object.preventExtensions;

      $export($export.S, "Reflect", {
        preventExtensions: function preventExtensions(target) {
          anObject(target);
          try {
            if ($preventExtensions) $preventExtensions(target);
            return true;
          } catch (e) {
            return false;
          }
        },
      });

      /***/
    },
    /* 301 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
      var dP = __webpack_require__(8);
      var gOPD = __webpack_require__(18);
      var getPrototypeOf = __webpack_require__(19);
      var has = __webpack_require__(15);
      var $export = __webpack_require__(1);
      var createDesc = __webpack_require__(36);
      var anObject = __webpack_require__(2);
      var isObject = __webpack_require__(4);

      function set(target, propertyKey, V /* , receiver */) {
        var receiver = arguments.length < 4 ? target : arguments[3];
        var ownDesc = gOPD.f(anObject(target), propertyKey);
        var existingDescriptor, proto;
        if (!ownDesc) {
          if (isObject((proto = getPrototypeOf(target)))) {
            return set(proto, propertyKey, V, receiver);
          }
          ownDesc = createDesc(0);
        }
        if (has(ownDesc, "value")) {
          if (ownDesc.writable === false || !isObject(receiver)) return false;
          if ((existingDescriptor = gOPD.f(receiver, propertyKey))) {
            if (
              existingDescriptor.get ||
              existingDescriptor.set ||
              existingDescriptor.writable === false
            )
              return false;
            existingDescriptor.value = V;
            dP.f(receiver, propertyKey, existingDescriptor);
          } else dP.f(receiver, propertyKey, createDesc(0, V));
          return true;
        }
        return ownDesc.set === undefined
          ? false
          : (ownDesc.set.call(receiver, V), true);
      }

      $export($export.S, "Reflect", { set: set });

      /***/
    },
    /* 302 */
    /***/ function (module, exports, __webpack_require__) {
      // 26.1.14 Reflect.setPrototypeOf(target, proto)
      var $export = __webpack_require__(1);
      var setProto = __webpack_require__(86);

      if (setProto)
        $export($export.S, "Reflect", {
          setPrototypeOf: function setPrototypeOf(target, proto) {
            setProto.check(target, proto);
            try {
              setProto.set(target, proto);
              return true;
            } catch (e) {
              return false;
            }
          },
        });

      /***/
    },
    /* 303 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // https://github.com/tc39/Array.prototype.includes
      var $export = __webpack_require__(1);
      var $includes = __webpack_require__(61)(true);

      $export($export.P, "Array", {
        includes: function includes(el /* , fromIndex = 0 */) {
          return $includes(
            this,
            el,
            arguments.length > 1 ? arguments[1] : undefined
          );
        },
      });

      __webpack_require__(39)("includes");

      /***/
    },
    /* 304 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
      var $export = __webpack_require__(1);
      var flattenIntoArray = __webpack_require__(134);
      var toObject = __webpack_require__(12);
      var toLength = __webpack_require__(10);
      var aFunction = __webpack_require__(13);
      var arraySpeciesCreate = __webpack_require__(98);

      $export($export.P, "Array", {
        flatMap: function flatMap(callbackfn /* , thisArg */) {
          var O = toObject(this);
          var sourceLen, A;
          aFunction(callbackfn);
          sourceLen = toLength(O.length);
          A = arraySpeciesCreate(O, 0);
          flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
          return A;
        },
      });

      __webpack_require__(39)("flatMap");

      /***/
    },
    /* 305 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
      var $export = __webpack_require__(1);
      var flattenIntoArray = __webpack_require__(134);
      var toObject = __webpack_require__(12);
      var toLength = __webpack_require__(10);
      var toInteger = __webpack_require__(26);
      var arraySpeciesCreate = __webpack_require__(98);

      $export($export.P, "Array", {
        flatten: function flatten(/* depthArg = 1 */) {
          var depthArg = arguments[0];
          var O = toObject(this);
          var sourceLen = toLength(O.length);
          var A = arraySpeciesCreate(O, 0);
          flattenIntoArray(
            A,
            O,
            O,
            sourceLen,
            0,
            depthArg === undefined ? 1 : toInteger(depthArg)
          );
          return A;
        },
      });

      __webpack_require__(39)("flatten");

      /***/
    },
    /* 306 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // https://github.com/mathiasbynens/String.prototype.at
      var $export = __webpack_require__(1);
      var $at = __webpack_require__(93)(true);

      $export($export.P, "String", {
        at: function at(pos) {
          return $at(this, pos);
        },
      });

      /***/
    },
    /* 307 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // https://github.com/tc39/proposal-string-pad-start-end
      var $export = __webpack_require__(1);
      var $pad = __webpack_require__(135);
      var userAgent = __webpack_require__(72);

      // https://github.com/zloirock/core-js/issues/280
      $export(
        $export.P +
          $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent),
        "String",
        {
          padStart: function padStart(maxLength /* , fillString = ' ' */) {
            return $pad(
              this,
              maxLength,
              arguments.length > 1 ? arguments[1] : undefined,
              true
            );
          },
        }
      );

      /***/
    },
    /* 308 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // https://github.com/tc39/proposal-string-pad-start-end
      var $export = __webpack_require__(1);
      var $pad = __webpack_require__(135);
      var userAgent = __webpack_require__(72);

      // https://github.com/zloirock/core-js/issues/280
      $export(
        $export.P +
          $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent),
        "String",
        {
          padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
            return $pad(
              this,
              maxLength,
              arguments.length > 1 ? arguments[1] : undefined,
              false
            );
          },
        }
      );

      /***/
    },
    /* 309 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // https://github.com/sebmarkbage/ecmascript-string-left-right-trim
      __webpack_require__(52)(
        "trimLeft",
        function ($trim) {
          return function trimLeft() {
            return $trim(this, 1);
          };
        },
        "trimStart"
      );

      /***/
    },
    /* 310 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // https://github.com/sebmarkbage/ecmascript-string-left-right-trim
      __webpack_require__(52)(
        "trimRight",
        function ($trim) {
          return function trimRight() {
            return $trim(this, 2);
          };
        },
        "trimEnd"
      );

      /***/
    },
    /* 311 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // https://tc39.github.io/String.prototype.matchAll/
      var $export = __webpack_require__(1);
      var defined = __webpack_require__(25);
      var toLength = __webpack_require__(10);
      var isRegExp = __webpack_require__(67);
      var getFlags = __webpack_require__(69);
      var RegExpProto = RegExp.prototype;

      var $RegExpStringIterator = function (regexp, string) {
        this._r = regexp;
        this._s = string;
      };

      __webpack_require__(66)(
        $RegExpStringIterator,
        "RegExp String",
        function next() {
          var match = this._r.exec(this._s);
          return { value: match, done: match === null };
        }
      );

      $export($export.P, "String", {
        matchAll: function matchAll(regexp) {
          defined(this);
          if (!isRegExp(regexp)) throw TypeError(regexp + " is not a regexp!");
          var S = String(this);
          var flags =
            "flags" in RegExpProto
              ? String(regexp.flags)
              : getFlags.call(regexp);
          var rx = new RegExp(
            regexp.source,
            ~flags.indexOf("g") ? flags : "g" + flags
          );
          rx.lastIndex = toLength(regexp.lastIndex);
          return new $RegExpStringIterator(rx, S);
        },
      });

      /***/
    },
    /* 312 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(79)("asyncIterator");

      /***/
    },
    /* 313 */
    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(79)("observable");

      /***/
    },
    /* 314 */
    /***/ function (module, exports, __webpack_require__) {
      // https://github.com/tc39/proposal-object-getownpropertydescriptors
      var $export = __webpack_require__(1);
      var ownKeys = __webpack_require__(104);
      var toIObject = __webpack_require__(14);
      var gOPD = __webpack_require__(18);
      var createProperty = __webpack_require__(97);

      $export($export.S, "Object", {
        getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
          var O = toIObject(object);
          var getDesc = gOPD.f;
          var keys = ownKeys(O);
          var result = {};
          var i = 0;
          var key, desc;
          while (keys.length > i) {
            desc = getDesc(O, (key = keys[i++]));
            if (desc !== undefined) createProperty(result, key, desc);
          }
          return result;
        },
      });

      /***/
    },
    /* 315 */
    /***/ function (module, exports, __webpack_require__) {
      // https://github.com/tc39/proposal-object-values-entries
      var $export = __webpack_require__(1);
      var $values = __webpack_require__(136)(false);

      $export($export.S, "Object", {
        values: function values(it) {
          return $values(it);
        },
      });

      /***/
    },
    /* 316 */
    /***/ function (module, exports, __webpack_require__) {
      // https://github.com/tc39/proposal-object-values-entries
      var $export = __webpack_require__(1);
      var $entries = __webpack_require__(136)(true);

      $export($export.S, "Object", {
        entries: function entries(it) {
          return $entries(it);
        },
      });

      /***/
    },
    /* 317 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(1);
      var toObject = __webpack_require__(12);
      var aFunction = __webpack_require__(13);
      var $defineProperty = __webpack_require__(8);

      // B.2.2.2 Object.prototype.__defineGetter__(P, getter)
      __webpack_require__(9) &&
        $export($export.P + __webpack_require__(75), "Object", {
          __defineGetter__: function __defineGetter__(P, getter) {
            $defineProperty.f(toObject(this), P, {
              get: aFunction(getter),
              enumerable: true,
              configurable: true,
            });
          },
        });

      /***/
    },
    /* 318 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(1);
      var toObject = __webpack_require__(12);
      var aFunction = __webpack_require__(13);
      var $defineProperty = __webpack_require__(8);

      // B.2.2.3 Object.prototype.__defineSetter__(P, setter)
      __webpack_require__(9) &&
        $export($export.P + __webpack_require__(75), "Object", {
          __defineSetter__: function __defineSetter__(P, setter) {
            $defineProperty.f(toObject(this), P, {
              set: aFunction(setter),
              enumerable: true,
              configurable: true,
            });
          },
        });

      /***/
    },
    /* 319 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(1);
      var toObject = __webpack_require__(12);
      var toPrimitive = __webpack_require__(24);
      var getPrototypeOf = __webpack_require__(19);
      var getOwnPropertyDescriptor = __webpack_require__(18).f;

      // B.2.2.4 Object.prototype.__lookupGetter__(P)
      __webpack_require__(9) &&
        $export($export.P + __webpack_require__(75), "Object", {
          __lookupGetter__: function __lookupGetter__(P) {
            var O = toObject(this);
            var K = toPrimitive(P, true);
            var D;
            do {
              if ((D = getOwnPropertyDescriptor(O, K))) return D.get;
            } while ((O = getPrototypeOf(O)));
          },
        });

      /***/
    },
    /* 320 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(1);
      var toObject = __webpack_require__(12);
      var toPrimitive = __webpack_require__(24);
      var getPrototypeOf = __webpack_require__(19);
      var getOwnPropertyDescriptor = __webpack_require__(18).f;

      // B.2.2.5 Object.prototype.__lookupSetter__(P)
      __webpack_require__(9) &&
        $export($export.P + __webpack_require__(75), "Object", {
          __lookupSetter__: function __lookupSetter__(P) {
            var O = toObject(this);
            var K = toPrimitive(P, true);
            var D;
            do {
              if ((D = getOwnPropertyDescriptor(O, K))) return D.set;
            } while ((O = getPrototypeOf(O)));
          },
        });

      /***/
    },
    /* 321 */
    /***/ function (module, exports, __webpack_require__) {
      // https://github.com/DavidBruant/Map-Set.prototype.toJSON
      var $export = __webpack_require__(1);

      $export($export.P + $export.R, "Map", {
        toJSON: __webpack_require__(137)("Map"),
      });

      /***/
    },
    /* 322 */
    /***/ function (module, exports, __webpack_require__) {
      // https://github.com/DavidBruant/Map-Set.prototype.toJSON
      var $export = __webpack_require__(1);

      $export($export.P + $export.R, "Set", {
        toJSON: __webpack_require__(137)("Set"),
      });

      /***/
    },
    /* 323 */
    /***/ function (module, exports, __webpack_require__) {
      // https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
      __webpack_require__(76)("Map");

      /***/
    },
    /* 324 */
    /***/ function (module, exports, __webpack_require__) {
      // https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
      __webpack_require__(76)("Set");

      /***/
    },
    /* 325 */
    /***/ function (module, exports, __webpack_require__) {
      // https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
      __webpack_require__(76)("WeakMap");

      /***/
    },
    /* 326 */
    /***/ function (module, exports, __webpack_require__) {
      // https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
      __webpack_require__(76)("WeakSet");

      /***/
    },
    /* 327 */
    /***/ function (module, exports, __webpack_require__) {
      // https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
      __webpack_require__(77)("Map");

      /***/
    },
    /* 328 */
    /***/ function (module, exports, __webpack_require__) {
      // https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
      __webpack_require__(77)("Set");

      /***/
    },
    /* 329 */
    /***/ function (module, exports, __webpack_require__) {
      // https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
      __webpack_require__(77)("WeakMap");

      /***/
    },
    /* 330 */
    /***/ function (module, exports, __webpack_require__) {
      // https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
      __webpack_require__(77)("WeakSet");

      /***/
    },
    /* 331 */
    /***/ function (module, exports, __webpack_require__) {
      // https://github.com/tc39/proposal-global
      var $export = __webpack_require__(1);

      $export($export.G, { global: __webpack_require__(3) });

      /***/
    },
    /* 332 */
    /***/ function (module, exports, __webpack_require__) {
      // https://github.com/tc39/proposal-global
      var $export = __webpack_require__(1);

      $export($export.S, "System", { global: __webpack_require__(3) });

      /***/
    },
    /* 333 */
    /***/ function (module, exports, __webpack_require__) {
      // https://github.com/ljharb/proposal-is-error
      var $export = __webpack_require__(1);
      var cof = __webpack_require__(22);

      $export($export.S, "Error", {
        isError: function isError(it) {
          return cof(it) === "Error";
        },
      });

      /***/
    },
    /* 334 */
    /***/ function (module, exports, __webpack_require__) {
      // https://rwaldron.github.io/proposal-math-extensions/
      var $export = __webpack_require__(1);

      $export($export.S, "Math", {
        clamp: function clamp(x, lower, upper) {
          return Math.min(upper, Math.max(lower, x));
        },
      });

      /***/
    },
    /* 335 */
    /***/ function (module, exports, __webpack_require__) {
      // https://rwaldron.github.io/proposal-math-extensions/
      var $export = __webpack_require__(1);

      $export($export.S, "Math", { DEG_PER_RAD: Math.PI / 180 });

      /***/
    },
    /* 336 */
    /***/ function (module, exports, __webpack_require__) {
      // https://rwaldron.github.io/proposal-math-extensions/
      var $export = __webpack_require__(1);
      var RAD_PER_DEG = 180 / Math.PI;

      $export($export.S, "Math", {
        degrees: function degrees(radians) {
          return radians * RAD_PER_DEG;
        },
      });

      /***/
    },
    /* 337 */
    /***/ function (module, exports, __webpack_require__) {
      // https://rwaldron.github.io/proposal-math-extensions/
      var $export = __webpack_require__(1);
      var scale = __webpack_require__(139);
      var fround = __webpack_require__(121);

      $export($export.S, "Math", {
        fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
          return fround(scale(x, inLow, inHigh, outLow, outHigh));
        },
      });

      /***/
    },
    /* 338 */
    /***/ function (module, exports, __webpack_require__) {
      // https://gist.github.com/BrendanEich/4294d5c212a6d2254703
      var $export = __webpack_require__(1);

      $export($export.S, "Math", {
        iaddh: function iaddh(x0, x1, y0, y1) {
          var $x0 = x0 >>> 0;
          var $x1 = x1 >>> 0;
          var $y0 = y0 >>> 0;
          return (
            ($x1 +
              (y1 >>> 0) +
              ((($x0 & $y0) | (($x0 | $y0) & ~(($x0 + $y0) >>> 0))) >>> 31)) |
            0
          );
        },
      });

      /***/
    },
    /* 339 */
    /***/ function (module, exports, __webpack_require__) {
      // https://gist.github.com/BrendanEich/4294d5c212a6d2254703
      var $export = __webpack_require__(1);

      $export($export.S, "Math", {
        isubh: function isubh(x0, x1, y0, y1) {
          var $x0 = x0 >>> 0;
          var $x1 = x1 >>> 0;
          var $y0 = y0 >>> 0;
          return (
            ($x1 -
              (y1 >>> 0) -
              (((~$x0 & $y0) | (~($x0 ^ $y0) & (($x0 - $y0) >>> 0))) >>> 31)) |
            0
          );
        },
      });

      /***/
    },
    /* 340 */
    /***/ function (module, exports, __webpack_require__) {
      // https://gist.github.com/BrendanEich/4294d5c212a6d2254703
      var $export = __webpack_require__(1);

      $export($export.S, "Math", {
        imulh: function imulh(u, v) {
          var UINT16 = 0xffff;
          var $u = +u;
          var $v = +v;
          var u0 = $u & UINT16;
          var v0 = $v & UINT16;
          var u1 = $u >> 16;
          var v1 = $v >> 16;
          var t = ((u1 * v0) >>> 0) + ((u0 * v0) >>> 16);
          return (
            u1 * v1 + (t >> 16) + ((((u0 * v1) >>> 0) + (t & UINT16)) >> 16)
          );
        },
      });

      /***/
    },
    /* 341 */
    /***/ function (module, exports, __webpack_require__) {
      // https://rwaldron.github.io/proposal-math-extensions/
      var $export = __webpack_require__(1);

      $export($export.S, "Math", { RAD_PER_DEG: 180 / Math.PI });

      /***/
    },
    /* 342 */
    /***/ function (module, exports, __webpack_require__) {
      // https://rwaldron.github.io/proposal-math-extensions/
      var $export = __webpack_require__(1);
      var DEG_PER_RAD = Math.PI / 180;

      $export($export.S, "Math", {
        radians: function radians(degrees) {
          return degrees * DEG_PER_RAD;
        },
      });

      /***/
    },
    /* 343 */
    /***/ function (module, exports, __webpack_require__) {
      // https://rwaldron.github.io/proposal-math-extensions/
      var $export = __webpack_require__(1);

      $export($export.S, "Math", { scale: __webpack_require__(139) });

      /***/
    },
    /* 344 */
    /***/ function (module, exports, __webpack_require__) {
      // https://gist.github.com/BrendanEich/4294d5c212a6d2254703
      var $export = __webpack_require__(1);

      $export($export.S, "Math", {
        umulh: function umulh(u, v) {
          var UINT16 = 0xffff;
          var $u = +u;
          var $v = +v;
          var u0 = $u & UINT16;
          var v0 = $v & UINT16;
          var u1 = $u >>> 16;
          var v1 = $v >>> 16;
          var t = ((u1 * v0) >>> 0) + ((u0 * v0) >>> 16);
          return (
            u1 * v1 + (t >>> 16) + ((((u0 * v1) >>> 0) + (t & UINT16)) >>> 16)
          );
        },
      });

      /***/
    },
    /* 345 */
    /***/ function (module, exports, __webpack_require__) {
      // http://jfbastien.github.io/papers/Math.signbit.html
      var $export = __webpack_require__(1);

      $export($export.S, "Math", {
        signbit: function signbit(x) {
          // eslint-disable-next-line no-self-compare
          return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
        },
      });

      /***/
    },
    /* 346 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";
      // https://github.com/tc39/proposal-promise-finally

      var $export = __webpack_require__(1);
      var core = __webpack_require__(11);
      var global = __webpack_require__(3);
      var speciesConstructor = __webpack_require__(71);
      var promiseResolve = __webpack_require__(127);

      $export($export.P + $export.R, "Promise", {
        finally: function (onFinally) {
          var C = speciesConstructor(this, core.Promise || global.Promise);
          var isFunction = typeof onFinally == "function";
          return this.then(
            isFunction
              ? function (x) {
                  return promiseResolve(C, onFinally()).then(function () {
                    return x;
                  });
                }
              : onFinally,
            isFunction
              ? function (e) {
                  return promiseResolve(C, onFinally()).then(function () {
                    throw e;
                  });
                }
              : onFinally
          );
        },
      });

      /***/
    },
    /* 347 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // https://github.com/tc39/proposal-promise-try
      var $export = __webpack_require__(1);
      var newPromiseCapability = __webpack_require__(102);
      var perform = __webpack_require__(126);

      $export($export.S, "Promise", {
        try: function (callbackfn) {
          var promiseCapability = newPromiseCapability.f(this);
          var result = perform(callbackfn);
          (result.e ? promiseCapability.reject : promiseCapability.resolve)(
            result.v
          );
          return promiseCapability.promise;
        },
      });

      /***/
    },
    /* 348 */
    /***/ function (module, exports, __webpack_require__) {
      var metadata = __webpack_require__(34);
      var anObject = __webpack_require__(2);
      var toMetaKey = metadata.key;
      var ordinaryDefineOwnMetadata = metadata.set;

      metadata.exp({
        defineMetadata: function defineMetadata(
          metadataKey,
          metadataValue,
          target,
          targetKey
        ) {
          ordinaryDefineOwnMetadata(
            metadataKey,
            metadataValue,
            anObject(target),
            toMetaKey(targetKey)
          );
        },
      });

      /***/
    },
    /* 349 */
    /***/ function (module, exports, __webpack_require__) {
      var metadata = __webpack_require__(34);
      var anObject = __webpack_require__(2);
      var toMetaKey = metadata.key;
      var getOrCreateMetadataMap = metadata.map;
      var store = metadata.store;

      metadata.exp({
        deleteMetadata: function deleteMetadata(
          metadataKey,
          target /* , targetKey */
        ) {
          var targetKey =
            arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
          var metadataMap = getOrCreateMetadataMap(
            anObject(target),
            targetKey,
            false
          );
          if (metadataMap === undefined || !metadataMap["delete"](metadataKey))
            return false;
          if (metadataMap.size) return true;
          var targetMetadata = store.get(target);
          targetMetadata["delete"](targetKey);
          return !!targetMetadata.size || store["delete"](target);
        },
      });

      /***/
    },
    /* 350 */
    /***/ function (module, exports, __webpack_require__) {
      var metadata = __webpack_require__(34);
      var anObject = __webpack_require__(2);
      var getPrototypeOf = __webpack_require__(19);
      var ordinaryHasOwnMetadata = metadata.has;
      var ordinaryGetOwnMetadata = metadata.get;
      var toMetaKey = metadata.key;

      var ordinaryGetMetadata = function (MetadataKey, O, P) {
        var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
        if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
        var parent = getPrototypeOf(O);
        return parent !== null
          ? ordinaryGetMetadata(MetadataKey, parent, P)
          : undefined;
      };

      metadata.exp({
        getMetadata: function getMetadata(
          metadataKey,
          target /* , targetKey */
        ) {
          return ordinaryGetMetadata(
            metadataKey,
            anObject(target),
            arguments.length < 3 ? undefined : toMetaKey(arguments[2])
          );
        },
      });

      /***/
    },
    /* 351 */
    /***/ function (module, exports, __webpack_require__) {
      var Set = __webpack_require__(130);
      var from = __webpack_require__(138);
      var metadata = __webpack_require__(34);
      var anObject = __webpack_require__(2);
      var getPrototypeOf = __webpack_require__(19);
      var ordinaryOwnMetadataKeys = metadata.keys;
      var toMetaKey = metadata.key;

      var ordinaryMetadataKeys = function (O, P) {
        var oKeys = ordinaryOwnMetadataKeys(O, P);
        var parent = getPrototypeOf(O);
        if (parent === null) return oKeys;
        var pKeys = ordinaryMetadataKeys(parent, P);
        return pKeys.length
          ? oKeys.length
            ? from(new Set(oKeys.concat(pKeys)))
            : pKeys
          : oKeys;
      };

      metadata.exp({
        getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
          return ordinaryMetadataKeys(
            anObject(target),
            arguments.length < 2 ? undefined : toMetaKey(arguments[1])
          );
        },
      });

      /***/
    },
    /* 352 */
    /***/ function (module, exports, __webpack_require__) {
      var metadata = __webpack_require__(34);
      var anObject = __webpack_require__(2);
      var ordinaryGetOwnMetadata = metadata.get;
      var toMetaKey = metadata.key;

      metadata.exp({
        getOwnMetadata: function getOwnMetadata(
          metadataKey,
          target /* , targetKey */
        ) {
          return ordinaryGetOwnMetadata(
            metadataKey,
            anObject(target),
            arguments.length < 3 ? undefined : toMetaKey(arguments[2])
          );
        },
      });

      /***/
    },
    /* 353 */
    /***/ function (module, exports, __webpack_require__) {
      var metadata = __webpack_require__(34);
      var anObject = __webpack_require__(2);
      var ordinaryOwnMetadataKeys = metadata.keys;
      var toMetaKey = metadata.key;

      metadata.exp({
        getOwnMetadataKeys: function getOwnMetadataKeys(
          target /* , targetKey */
        ) {
          return ordinaryOwnMetadataKeys(
            anObject(target),
            arguments.length < 2 ? undefined : toMetaKey(arguments[1])
          );
        },
      });

      /***/
    },
    /* 354 */
    /***/ function (module, exports, __webpack_require__) {
      var metadata = __webpack_require__(34);
      var anObject = __webpack_require__(2);
      var getPrototypeOf = __webpack_require__(19);
      var ordinaryHasOwnMetadata = metadata.has;
      var toMetaKey = metadata.key;

      var ordinaryHasMetadata = function (MetadataKey, O, P) {
        var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
        if (hasOwn) return true;
        var parent = getPrototypeOf(O);
        return parent !== null
          ? ordinaryHasMetadata(MetadataKey, parent, P)
          : false;
      };

      metadata.exp({
        hasMetadata: function hasMetadata(
          metadataKey,
          target /* , targetKey */
        ) {
          return ordinaryHasMetadata(
            metadataKey,
            anObject(target),
            arguments.length < 3 ? undefined : toMetaKey(arguments[2])
          );
        },
      });

      /***/
    },
    /* 355 */
    /***/ function (module, exports, __webpack_require__) {
      var metadata = __webpack_require__(34);
      var anObject = __webpack_require__(2);
      var ordinaryHasOwnMetadata = metadata.has;
      var toMetaKey = metadata.key;

      metadata.exp({
        hasOwnMetadata: function hasOwnMetadata(
          metadataKey,
          target /* , targetKey */
        ) {
          return ordinaryHasOwnMetadata(
            metadataKey,
            anObject(target),
            arguments.length < 3 ? undefined : toMetaKey(arguments[2])
          );
        },
      });

      /***/
    },
    /* 356 */
    /***/ function (module, exports, __webpack_require__) {
      var $metadata = __webpack_require__(34);
      var anObject = __webpack_require__(2);
      var aFunction = __webpack_require__(13);
      var toMetaKey = $metadata.key;
      var ordinaryDefineOwnMetadata = $metadata.set;

      $metadata.exp({
        metadata: function metadata(metadataKey, metadataValue) {
          return function decorator(target, targetKey) {
            ordinaryDefineOwnMetadata(
              metadataKey,
              metadataValue,
              (targetKey !== undefined ? anObject : aFunction)(target),
              toMetaKey(targetKey)
            );
          };
        },
      });

      /***/
    },
    /* 357 */
    /***/ function (module, exports, __webpack_require__) {
      // https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
      var $export = __webpack_require__(1);
      var microtask = __webpack_require__(101)();
      var process = __webpack_require__(3).process;
      var isNode = __webpack_require__(22)(process) == "process";

      $export($export.G, {
        asap: function asap(fn) {
          var domain = isNode && process.domain;
          microtask(domain ? domain.bind(fn) : fn);
        },
      });

      /***/
    },
    /* 358 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      // https://github.com/zenparsing/es-observable
      var $export = __webpack_require__(1);
      var global = __webpack_require__(3);
      var core = __webpack_require__(11);
      var microtask = __webpack_require__(101)();
      var OBSERVABLE = __webpack_require__(6)("observable");
      var aFunction = __webpack_require__(13);
      var anObject = __webpack_require__(2);
      var anInstance = __webpack_require__(49);
      var redefineAll = __webpack_require__(50);
      var hide = __webpack_require__(16);
      var forOf = __webpack_require__(40);
      var RETURN = forOf.RETURN;

      var getMethod = function (fn) {
        return fn == null ? undefined : aFunction(fn);
      };

      var cleanupSubscription = function (subscription) {
        var cleanup = subscription._c;
        if (cleanup) {
          subscription._c = undefined;
          cleanup();
        }
      };

      var subscriptionClosed = function (subscription) {
        return subscription._o === undefined;
      };

      var closeSubscription = function (subscription) {
        if (!subscriptionClosed(subscription)) {
          subscription._o = undefined;
          cleanupSubscription(subscription);
        }
      };

      var Subscription = function (observer, subscriber) {
        anObject(observer);
        this._c = undefined;
        this._o = observer;
        observer = new SubscriptionObserver(this);
        try {
          var cleanup = subscriber(observer);
          var subscription = cleanup;
          if (cleanup != null) {
            if (typeof cleanup.unsubscribe === "function")
              cleanup = function () {
                subscription.unsubscribe();
              };
            else aFunction(cleanup);
            this._c = cleanup;
          }
        } catch (e) {
          observer.error(e);
          return;
        }
        if (subscriptionClosed(this)) cleanupSubscription(this);
      };

      Subscription.prototype = redefineAll(
        {},
        {
          unsubscribe: function unsubscribe() {
            closeSubscription(this);
          },
        }
      );

      var SubscriptionObserver = function (subscription) {
        this._s = subscription;
      };

      SubscriptionObserver.prototype = redefineAll(
        {},
        {
          next: function next(value) {
            var subscription = this._s;
            if (!subscriptionClosed(subscription)) {
              var observer = subscription._o;
              try {
                var m = getMethod(observer.next);
                if (m) return m.call(observer, value);
              } catch (e) {
                try {
                  closeSubscription(subscription);
                } finally {
                  throw e;
                }
              }
            }
          },
          error: function error(value) {
            var subscription = this._s;
            if (subscriptionClosed(subscription)) throw value;
            var observer = subscription._o;
            subscription._o = undefined;
            try {
              var m = getMethod(observer.error);
              if (!m) throw value;
              value = m.call(observer, value);
            } catch (e) {
              try {
                cleanupSubscription(subscription);
              } finally {
                throw e;
              }
            }
            cleanupSubscription(subscription);
            return value;
          },
          complete: function complete(value) {
            var subscription = this._s;
            if (!subscriptionClosed(subscription)) {
              var observer = subscription._o;
              subscription._o = undefined;
              try {
                var m = getMethod(observer.complete);
                value = m ? m.call(observer, value) : undefined;
              } catch (e) {
                try {
                  cleanupSubscription(subscription);
                } finally {
                  throw e;
                }
              }
              cleanupSubscription(subscription);
              return value;
            }
          },
        }
      );

      var $Observable = function Observable(subscriber) {
        anInstance(this, $Observable, "Observable", "_f")._f =
          aFunction(subscriber);
      };

      redefineAll($Observable.prototype, {
        subscribe: function subscribe(observer) {
          return new Subscription(observer, this._f);
        },
        forEach: function forEach(fn) {
          var that = this;
          return new (core.Promise || global.Promise)(function (
            resolve,
            reject
          ) {
            aFunction(fn);
            var subscription = that.subscribe({
              next: function (value) {
                try {
                  return fn(value);
                } catch (e) {
                  reject(e);
                  subscription.unsubscribe();
                }
              },
              error: reject,
              complete: resolve,
            });
          });
        },
      });

      redefineAll($Observable, {
        from: function from(x) {
          var C = typeof this === "function" ? this : $Observable;
          var method = getMethod(anObject(x)[OBSERVABLE]);
          if (method) {
            var observable = anObject(method.call(x));
            return observable.constructor === C
              ? observable
              : new C(function (observer) {
                  return observable.subscribe(observer);
                });
          }
          return new C(function (observer) {
            var done = false;
            microtask(function () {
              if (!done) {
                try {
                  if (
                    forOf(x, false, function (it) {
                      observer.next(it);
                      if (done) return RETURN;
                    }) === RETURN
                  )
                    return;
                } catch (e) {
                  if (done) throw e;
                  observer.error(e);
                  return;
                }
                observer.complete();
              }
            });
            return function () {
              done = true;
            };
          });
        },
        of: function of() {
          for (var i = 0, l = arguments.length, items = new Array(l); i < l; )
            items[i] = arguments[i++];
          return new (typeof this === "function" ? this : $Observable)(
            function (observer) {
              var done = false;
              microtask(function () {
                if (!done) {
                  for (var j = 0; j < items.length; ++j) {
                    observer.next(items[j]);
                    if (done) return;
                  }
                  observer.complete();
                }
              });
              return function () {
                done = true;
              };
            }
          );
        },
      });

      hide($Observable.prototype, OBSERVABLE, function () {
        return this;
      });

      $export($export.G, { Observable: $Observable });

      __webpack_require__(48)("Observable");

      /***/
    },
    /* 359 */
    /***/ function (module, exports, __webpack_require__) {
      // ie9- setTimeout & setInterval additional parameters fix
      var global = __webpack_require__(3);
      var $export = __webpack_require__(1);
      var userAgent = __webpack_require__(72);
      var slice = [].slice;
      var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
      var wrap = function (set) {
        return function (fn, time /* , ...args */) {
          var boundArgs = arguments.length > 2;
          var args = boundArgs ? slice.call(arguments, 2) : false;
          return set(
            boundArgs
              ? function () {
                  // eslint-disable-next-line no-new-func
                  (typeof fn == "function" ? fn : Function(fn)).apply(
                    this,
                    args
                  );
                }
              : fn,
            time
          );
        };
      };
      $export($export.G + $export.B + $export.F * MSIE, {
        setTimeout: wrap(global.setTimeout),
        setInterval: wrap(global.setInterval),
      });

      /***/
    },
    /* 360 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(1);
      var $task = __webpack_require__(100);
      $export($export.G + $export.B, {
        setImmediate: $task.set,
        clearImmediate: $task.clear,
      });

      /***/
    },
    /* 361 */
    /***/ function (module, exports, __webpack_require__) {
      var $iterators = __webpack_require__(64);
      var getKeys = __webpack_require__(30);
      var redefine = __webpack_require__(17);
      var global = __webpack_require__(3);
      var hide = __webpack_require__(16);
      var Iterators = __webpack_require__(46);
      var wks = __webpack_require__(6);
      var ITERATOR = wks("iterator");
      var TO_STRING_TAG = wks("toStringTag");
      var ArrayValues = Iterators.Array;

      var DOMIterables = {
        CSSRuleList: true, // TODO: Not spec compliant, should be false.
        CSSStyleDeclaration: false,
        CSSValueList: false,
        ClientRectList: false,
        DOMRectList: false,
        DOMStringList: false,
        DOMTokenList: true,
        DataTransferItemList: false,
        FileList: false,
        HTMLAllCollection: false,
        HTMLCollection: false,
        HTMLFormElement: false,
        HTMLSelectElement: false,
        MediaList: true, // TODO: Not spec compliant, should be false.
        MimeTypeArray: false,
        NamedNodeMap: false,
        NodeList: true,
        PaintRequestList: false,
        Plugin: false,
        PluginArray: false,
        SVGLengthList: false,
        SVGNumberList: false,
        SVGPathSegList: false,
        SVGPointList: false,
        SVGStringList: false,
        SVGTransformList: false,
        SourceBufferList: false,
        StyleSheetList: true, // TODO: Not spec compliant, should be false.
        TextTrackCueList: false,
        TextTrackList: false,
        TouchList: false,
      };

      for (
        var collections = getKeys(DOMIterables), i = 0;
        i < collections.length;
        i++
      ) {
        var NAME = collections[i];
        var explicit = DOMIterables[NAME];
        var Collection = global[NAME];
        var proto = Collection && Collection.prototype;
        var key;
        if (proto) {
          if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
          if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
          Iterators[NAME] = ArrayValues;
          if (explicit)
            for (key in $iterators)
              if (!proto[key]) redefine(proto, key, $iterators[key], true);
        }
      }

      /***/
    },
    /* 362 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var ctx = __webpack_require__(21);
      var $export = __webpack_require__(1);
      var createDesc = __webpack_require__(36);
      var assign = __webpack_require__(83);
      var create = __webpack_require__(31);
      var getPrototypeOf = __webpack_require__(19);
      var getKeys = __webpack_require__(30);
      var dP = __webpack_require__(8);
      var keyOf = __webpack_require__(363);
      var aFunction = __webpack_require__(13);
      var forOf = __webpack_require__(40);
      var isIterable = __webpack_require__(140);
      var $iterCreate = __webpack_require__(66);
      var step = __webpack_require__(84);
      var isObject = __webpack_require__(4);
      var toIObject = __webpack_require__(14);
      var DESCRIPTORS = __webpack_require__(9);
      var has = __webpack_require__(15);

      // 0 -> Dict.forEach
      // 1 -> Dict.map
      // 2 -> Dict.filter
      // 3 -> Dict.some
      // 4 -> Dict.every
      // 5 -> Dict.find
      // 6 -> Dict.findKey
      // 7 -> Dict.mapPairs
      var createDictMethod = function (TYPE) {
        var IS_MAP = TYPE == 1;
        var IS_EVERY = TYPE == 4;
        return function (object, callbackfn, that /* = undefined */) {
          var f = ctx(callbackfn, that, 3);
          var O = toIObject(object);
          var result =
            IS_MAP || TYPE == 7 || TYPE == 2
              ? new (typeof this == "function" ? this : Dict)()
              : undefined;
          var key, val, res;
          for (key in O)
            if (has(O, key)) {
              val = O[key];
              res = f(val, key, object);
              if (TYPE) {
                if (IS_MAP) result[key] = res; // map
                else if (res)
                  switch (TYPE) {
                    case 2:
                      result[key] = val;
                      break; // filter
                    case 3:
                      return true; // some
                    case 5:
                      return val; // find
                    case 6:
                      return key; // findKey
                    case 7:
                      result[res[0]] = res[1]; // mapPairs
                  }
                else if (IS_EVERY) return false; // every
              }
            }
          return TYPE == 3 || IS_EVERY ? IS_EVERY : result;
        };
      };
      var findKey = createDictMethod(6);

      var createDictIter = function (kind) {
        return function (it) {
          return new DictIterator(it, kind);
        };
      };
      var DictIterator = function (iterated, kind) {
        this._t = toIObject(iterated); // target
        this._a = getKeys(iterated); // keys
        this._i = 0; // next index
        this._k = kind; // kind
      };
      $iterCreate(DictIterator, "Dict", function () {
        var that = this;
        var O = that._t;
        var keys = that._a;
        var kind = that._k;
        var key;
        do {
          if (that._i >= keys.length) {
            that._t = undefined;
            return step(1);
          }
        } while (!has(O, (key = keys[that._i++])));
        if (kind == "keys") return step(0, key);
        if (kind == "values") return step(0, O[key]);
        return step(0, [key, O[key]]);
      });

      function Dict(iterable) {
        var dict = create(null);
        if (iterable != undefined) {
          if (isIterable(iterable)) {
            forOf(iterable, true, function (key, value) {
              dict[key] = value;
            });
          } else assign(dict, iterable);
        }
        return dict;
      }
      Dict.prototype = null;

      function reduce(object, mapfn, init) {
        aFunction(mapfn);
        var O = toIObject(object);
        var keys = getKeys(O);
        var length = keys.length;
        var i = 0;
        var memo, key;
        if (arguments.length < 3) {
          if (!length)
            throw TypeError("Reduce of empty object with no initial value");
          memo = O[keys[i++]];
        } else memo = Object(init);
        while (length > i)
          if (has(O, (key = keys[i++]))) {
            memo = mapfn(memo, O[key], key, object);
          }
        return memo;
      }

      function includes(object, el) {
        // eslint-disable-next-line no-self-compare
        return (
          (el == el
            ? keyOf(object, el)
            : findKey(object, function (it) {
                // eslint-disable-next-line no-self-compare
                return it != it;
              })) !== undefined
        );
      }

      function get(object, key) {
        if (has(object, key)) return object[key];
      }
      function set(object, key, value) {
        if (DESCRIPTORS && key in Object)
          dP.f(object, key, createDesc(0, value));
        else object[key] = value;
        return object;
      }

      function isDict(it) {
        return isObject(it) && getPrototypeOf(it) === Dict.prototype;
      }

      $export($export.G + $export.F, { Dict: Dict });

      $export($export.S, "Dict", {
        keys: createDictIter("keys"),
        values: createDictIter("values"),
        entries: createDictIter("entries"),
        forEach: createDictMethod(0),
        map: createDictMethod(1),
        filter: createDictMethod(2),
        some: createDictMethod(3),
        every: createDictMethod(4),
        find: createDictMethod(5),
        findKey: findKey,
        mapPairs: createDictMethod(7),
        reduce: reduce,
        keyOf: keyOf,
        includes: includes,
        has: has,
        get: get,
        set: set,
        isDict: isDict,
      });

      /***/
    },
    /* 363 */
    /***/ function (module, exports, __webpack_require__) {
      var getKeys = __webpack_require__(30);
      var toIObject = __webpack_require__(14);
      module.exports = function (object, el) {
        var O = toIObject(object);
        var keys = getKeys(O);
        var length = keys.length;
        var index = 0;
        var key;
        while (length > index) if (O[(key = keys[index++])] === el) return key;
      };

      /***/
    },
    /* 364 */
    /***/ function (module, exports, __webpack_require__) {
      var anObject = __webpack_require__(2);
      var get = __webpack_require__(59);
      module.exports = __webpack_require__(11).getIterator = function (it) {
        var iterFn = get(it);
        if (typeof iterFn != "function")
          throw TypeError(it + " is not iterable!");
        return anObject(iterFn.call(it));
      };

      /***/
    },
    /* 365 */
    /***/ function (module, exports, __webpack_require__) {
      var global = __webpack_require__(3);
      var core = __webpack_require__(11);
      var $export = __webpack_require__(1);
      var partial = __webpack_require__(141);
      // https://esdiscuss.org/topic/promise-returning-delay-function
      $export($export.G + $export.F, {
        delay: function delay(time) {
          return new (core.Promise || global.Promise)(function (resolve) {
            setTimeout(partial.call(resolve, true), time);
          });
        },
      });

      /***/
    },
    /* 366 */
    /***/ function (module, exports, __webpack_require__) {
      var path = __webpack_require__(142);
      var $export = __webpack_require__(1);

      // Placeholder
      __webpack_require__(11)._ = path._ = path._ || {};

      $export($export.P + $export.F, "Function", {
        part: __webpack_require__(141),
      });

      /***/
    },
    /* 367 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(1);

      $export($export.S + $export.F, "Object", {
        isObject: __webpack_require__(4),
      });

      /***/
    },
    /* 368 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(1);

      $export($export.S + $export.F, "Object", {
        classof: __webpack_require__(45),
      });

      /***/
    },
    /* 369 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(1);
      var define = __webpack_require__(143);

      $export($export.S + $export.F, "Object", { define: define });

      /***/
    },
    /* 370 */
    /***/ function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(1);
      var define = __webpack_require__(143);
      var create = __webpack_require__(31);

      $export($export.S + $export.F, "Object", {
        make: function (proto, mixin) {
          return define(create(proto), mixin);
        },
      });

      /***/
    },
    /* 371 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      __webpack_require__(65)(
        Number,
        "Number",
        function (iterated) {
          this._l = +iterated;
          this._i = 0;
        },
        function () {
          var i = this._i++;
          var done = !(i < this._l);
          return { done: done, value: done ? undefined : i };
        }
      );

      /***/
    },
    /* 372 */
    /***/ function (module, exports, __webpack_require__) {
      // https://github.com/benjamingr/RexExp.escape
      var $export = __webpack_require__(1);
      var $re = __webpack_require__(105)(/[\\^$*+?.()|[\]{}]/g, "\\$&");

      $export($export.S, "RegExp", {
        escape: function escape(it) {
          return $re(it);
        },
      });

      /***/
    },
    /* 373 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(1);
      var $re = __webpack_require__(105)(/[&<>"']/g, {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&apos;",
      });

      $export($export.P + $export.F, "String", {
        escapeHTML: function escapeHTML() {
          return $re(this);
        },
      });

      /***/
    },
    /* 374 */
    /***/ function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(1);
      var $re = __webpack_require__(105)(/&(?:amp|lt|gt|quot|apos);/g, {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&apos;": "'",
      });

      $export($export.P + $export.F, "String", {
        unescapeHTML: function unescapeHTML() {
          return $re(this);
        },
      });

      /***/
    },
    /* 375 */
    /***/ function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      __webpack_require__.r(__webpack_exports__);

      // EXTERNAL MODULE: ./node_modules/intersection-observer/intersection-observer.js
      var intersection_observer = __webpack_require__(106);

      // EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
      var jquery = __webpack_require__(0);
      var jquery_default = /*#__PURE__*/ __webpack_require__.n(jquery);

      // EXTERNAL MODULE: ./node_modules/scriptjs/dist/script.js
      var script = __webpack_require__(29);
      var script_default = /*#__PURE__*/ __webpack_require__.n(script);

      // CONCATENATED MODULE: ./node_modules/pxs-map/dist/index.es.js

      /*!
       * pxs-map v2.0.3
       * (c) 2018 undefined
       */

      var classCallCheck = function (instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      };

      var toConsumableArray = function (arr) {
        if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++)
            arr2[i] = arr[i];

          return arr2;
        } else {
          return Array.from(arr);
        }
      };

      /*
       * Function to convert any given latitude and longitude format to decimal degrees
       */
      function getDecimalDegrees() {
        var firstComponent =
          arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var secondComponent =
          arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var thirdComponent =
          arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var fourthComponent =
          arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

        var directions = {
          N: 1,
          E: 1,
          S: -1,
          W: -1,
        };
        var decimalDegrees = 0.0;
        var components = [
          firstComponent,
          secondComponent,
          thirdComponent,
          fourthComponent,
        ];

        for (var i = 0; i < components.length; i++) {
          var component = components[i];

          if (component) {
            if (Number.isNaN(parseFloat(component))) {
              decimalDegrees *= directions[component];
            } else {
              decimalDegrees += parseFloat(component) / Math.pow(60, i);
            }
          }
        }

        return decimalDegrees;
      }

      /*
       * By providing the ability to use a place name, or latitude and longitude coordinates
       * we give merchants, and our demo stores the option to bypass the Geocoding API.
       * The Geocoding API (https://developers.google.com/maps/documentation/geocoding/usage-and-billing) allows us
       * to take a place name and convert it to latitude and longitude expressed in decimal degrees.
       */
      function getLatitudeLongitude(address) {
        var deferred = jquery_default.a.Deferred();
        // Degrees, Minutes and Seconds: DDD° MM' SS.S"
        var latLongDegreesMinutesSeconds =
          /^([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2})(?:'[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:"[ ]?| )?(N|E|S|W) ?([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2})(?:'[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:"[ ]?| )?(N|E|S|W)$/g;
        // Degrees and Decimal Minutes: DDD° MM.MMM'
        var latLongDegreesMinutes =
          /^([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:'[ ]?| )?(N|E|S|W) ?([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:'[ ]?| )?(N|E|S|W)$/g;
        // Decimal Degrees: DDD.DDDDD°
        var latLongDegrees =
          /^([-|+]?[0-9]{1,3}(?:\.[0-9]+)?)(?:°[ ]?| )?(N|E|S|W)?,? ?([-|+]?[0-9]{1,3}(?:\.[0-9]+)?)(?:°[ ]?| )?(N|E|S|W)?$/g;
        var latLongFormats = [
          latLongDegreesMinutesSeconds,
          latLongDegreesMinutes,
          latLongDegrees,
        ];
        var latLongMatches = latLongFormats.map(function (latLongFormat) {
          return address.match(latLongFormat);
        });

        /*
         * Select the first latitude and longitude format that is matched.
         * Ordering:
         *   1. Degrees, minutes, and seconds,
         *   2. Degrees, and decimal minutes,
         *   3. Decimal degrees.
         */
        var latLongMatch = latLongMatches.reduce(function (
          accumulator,
          value,
          index
        ) {
          if (!accumulator && value) {
            var latLongResult = latLongFormats[index].exec(address);
            var lat = latLongResult.slice(1, latLongResult.length / 2 + 1);
            var lng = latLongResult.slice(
              latLongResult.length / 2 + 1,
              latLongResult.length
            );

            return {
              lat: lat,
              lng: lng,
            };
          }

          return accumulator;
        },
        null);

        // If we've got a match on latitude and longitude, use that and avoid geocoding
        if (latLongMatch) {
          var latDecimalDegrees = getDecimalDegrees.apply(
            undefined,
            toConsumableArray(latLongMatch.lat)
          );
          var longDecimalDegrees = getDecimalDegrees.apply(
            undefined,
            toConsumableArray(latLongMatch.lng)
          );

          deferred.resolve({
            lat: latDecimalDegrees,
            lng: longDecimalDegrees,
          });
        } else {
          // Otherwise, geocode the assumed address
          var geocoder = new google.maps.Geocoder();

          geocoder.geocode({ address: address }, function (results, status) {
            if (status !== google.maps.GeocoderStatus.OK) {
              deferred.reject(status);
            }

            deferred.resolve(results[0].geometry.location);
          });
        }

        return deferred;
      }

      function getMapStyles(colors) {
        if (!colors) {
          return [];
        }

        return [
          { elementType: "geometry", stylers: [{ color: colors.e }] },
          { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
          { elementType: "labels.text.fill", stylers: [{ color: colors.a }] },
          { elementType: "labels.text.stroke", stylers: [{ color: colors.e }] },
          {
            featureType: "administrative",
            elementType: "geometry",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "administrative.country",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "administrative.land_parcel",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "administrative.neighborhood",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "administrative.locality",
            stylers: [{ visibility: "off" }],
          },
          { featureType: "poi", stylers: [{ visibility: "off" }] },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [{ color: colors.d }],
          },
          {
            featureType: "road",
            elementType: "labels.icon",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [{ color: colors.c }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: colors.b }],
          },
          {
            featureType: "road.highway.controlled_access",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [{ color: colors.b }],
          },
          {
            featureType: "road.local",
            elementType: "labels.text.stroke",
            stylers: [{ color: colors.e }],
          },
          { featureType: "transit", stylers: [{ visibility: "off" }] },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: colors.f }],
          },
        ];
      }

      function index_es_createMap(options) {
        var deferred = jquery_default.a.Deferred();
        var container = options.container,
          address = options.address,
          zoom = options.zoom,
          colors = options.colors;

        getLatitudeLongitude(address)
          .done(function (latLong) {
            var map = new google.maps.Map(container, {
              center: latLong,
              clickableIcons: false,
              disableDefaultUI: true,
              disableDoubleClickZoom: true,
              gestureHandling: "none",
              keyboardShortcuts: false,
              maxZoom: zoom,
              minZoom: zoom,
              scrollWheel: false,
              styles: getMapStyles(colors),
              zoom: zoom,
              zoomControl: false,
            });

            new google.maps.Marker({
              clickable: false,
              map: map,
              position: map.getCenter(),
            });

            map.panBy(0, 0);
            deferred.resolve(map);
          })
          .fail(function (status) {
            var usageLimits =
              "https://developers.google.com/maps/faq#usagelimits";
            var errorMessage = void 0;

            switch (status) {
              case "ZERO_RESULTS":
                errorMessage = "<p>Unable to find the address:</p> " + address;
                break;
              case "OVER_QUERY_LIMIT":
                errorMessage =
                  '\n            <p>Unable to load Google Maps, you have reached your usage limit.</p>\n            <p>\n              Please visit\n              <a href="' +
                  usageLimits +
                  '" target="_blank">' +
                  usageLimits +
                  "</a>\n              for more details.\n            </p>\n          ";
                break;
              default:
                errorMessage = "Unable to load Google Maps.";
                break;
            }

            deferred.reject(errorMessage);
          });

        return deferred;
      }

      function displayErrorInThemeEditor(container, errorMessage) {
        var isThemeEditor = window.Shopify && window.Shopify.designMode;

        if (!isThemeEditor) {
          return;
        }

        container.innerHTML =
          '<div class="map-error-message">' + errorMessage + "</div>";
      }

      var index_es_PxsMap = function PxsMap(section) {
        var _this = this;

        classCallCheck(this, PxsMap);

        this.map = null;

        var el = section.el.querySelector("[data-map]");
        var container = el.querySelector("[data-map-container]");
        var settings = section.data;
        var address = settings.address,
          colors = settings.colors;

        var apiKey = settings.api_key;
        // Scale so range is 12 ~ 17, rather than 1 to 6
        var zoom = Number.isNaN(settings.zoom)
          ? 13
          : 11 + parseInt(settings.zoom, 10);

        if (apiKey) {
          if (window.googleMaps === undefined) {
            script_default()(
              "https://maps.googleapis.com/maps/api/js?key=" + apiKey,
              function () {
                window.googleMaps = true;
                index_es_createMap({
                  container: container,
                  address: address,
                  zoom: zoom,
                  colors: colors,
                })
                  .done(function (map) {
                    _this.map = map;
                  })
                  .fail(function (error) {
                    return displayErrorInThemeEditor(container, error);
                  });
              }
            );
          } else {
            index_es_createMap({
              container: container,
              address: address,
              zoom: zoom,
              colors: colors,
            })
              .done(function (map) {
                _this.map = map;
              })
              .fail(function (error) {
                return displayErrorInThemeEditor(container, error);
              });
          }
        }
      };

      /* harmony default export */ var index_es = index_es_PxsMap;

      // CONCATENATED MODULE: ./node_modules/rimg/dist/index.es.js
      /*!
       * rimg v2.1.7
       * (c) 2018 Pixel Union
       */
      /**
       * The default template render function. Turns a template string into an image
       * URL.
       *
       * @param {String} template
       * @param {Size} size
       * @returns {String}
       */
      function defaultTemplateRender(template, size) {
        return template.replace("{size}", size.width + "x" + size.height);
      }

      /**
       * @type Settings
       */
      var defaults = {
        scale: 1,
        template: false,
        templateRender: defaultTemplateRender,
        max: { width: Infinity, height: Infinity },
        round: 32,
        placeholder: false,
        crop: null,
      };

      /**
       * Get a data attribute value from an element, with a default fallback and
       * sanitization step.
       *
       * @param {Element} el
       *
       * @param {String} name
       *        The data attribute name.
       *
       * @param {Object} options
       *        An object holding fallback values if the data attribute does not
       *        exist. If this object doesn't have the property, we further fallback
       *        to our defaults.
       *
       * @param {Function} [sanitize]
       *        A function to sanitize the data attribute value with.
       *
       * @returns {String|*}
       */
      function getData(el, name, options, sanitize) {
        var attr = "data-rimg-" + name;
        if (!el.hasAttribute(attr)) return options[name] || defaults[name];

        var value = el.getAttribute(attr);

        return sanitize ? sanitize(value) : value;
      }

      /**
       * Sanitize data attributes that represent a size (in the form of `10x10`).
       *
       * @param {String} value
       * @returns {Object} An object with `width` and `height` properties.
       */
      function parseSize(value) {
        value = value.split("x");
        return {
          width: parseInt(value[0], 10),
          height: parseInt(value[1], 10),
        };
      }

      /**
       * Loads information about an element.
       *
       * Options can be set on the element itself using data attributes, or through
       * the `options` parameter. Data attributes take priority.
       *
       * @param {HTMLElement} el
       * @param {Settings} options
       * @returns {Item}
       */
      function parseItem(el) {
        var options =
          arguments.length > 1 && arguments[1] !== undefined
            ? arguments[1]
            : {};

        var isImage = el.hasAttribute("data-rimg-template");

        /**
         * @typedef {Settings} Item
         */
        return {
          el: el,

          // Type of element
          isImage: isImage,
          isBackgroundImage: isImage && el.tagName !== "IMG",

          // Image scale
          scale: getData(el, "scale", options),

          // Device density
          density: window.devicePixelRatio || 1,

          // Image template URL
          template: getData(el, "template", options),
          templateRender: options.templateRender || defaults.templateRender,

          // Maximum image dimensions
          max: getData(el, "max", options, parseSize),

          // Round image dimensions to the nearest multiple
          round: getData(el, "round", options),

          // Placeholder image dimensions
          placeholder: getData(el, "placeholder", options, parseSize),

          // Crop value; null if image is uncropped, otherwise equal to the Shopify crop parameter ('center', 'top', etc.)
          crop: getData(el, "crop", options, function (value) {
            return value === "" ? null : value;
          }),
        };
      }

      /**
       * Round to the nearest multiple.
       *
       * This is so we don't tax the image server too much.
       *
       * @param {Number} size The size, in pixels.
       * @param {Number} [multiple] The multiple to round to the nearest.
       * @param {Number} [maxLimit] Maximum allowed value - value to return if rounded multiple is above this limit
       * @returns {Number}
       */
      function roundSize(size) {
        var multiple =
          arguments.length > 1 && arguments[1] !== undefined
            ? arguments[1]
            : 32;
        var maxLimit =
          arguments.length > 2 && arguments[2] !== undefined
            ? arguments[2]
            : Infinity;

        return size === 0
          ? multiple
          : Math.min(Math.ceil(size / multiple) * multiple, maxLimit);
      }

      /**
       * Get the size of an element.
       *
       * If it is too small, it's parent element is checked, and so on. This helps
       * avoid the situation where an element doesn't have a size yet or is positioned
       * out of the layout.
       *
       * @param {HTMLElement} el
       * @return {Object} size
       * @return {Number} size.width The width, in pixels.
       * @return {Number} size.height The height, in pixels.
       */
      function getElementSize(el) {
        var size = { width: 0, height: 0 };

        while (el) {
          size.width = el.offsetWidth;
          size.height = el.offsetHeight;
          if (size.width > 20 && size.height > 20) break;
          el = el.parentNode;
        }

        return size;
      }

      /**
       * Trigger a custom event.
       *
       * Note: this approach is deprecated, but still required to support older
       * browsers such as IE 10.
       *
       * @see https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events
       *
       * @param {HTMLElement} el
       *        The element to trigger the event on.
       *
       * @param {String} name
       *        The event name.
       *
       * @returns {Boolean}
       *          True if the event was canceled.
       */
      function index_es_trigger(el, name) {
        var event = document.createEvent("Event");
        event.initEvent(name, true, true);
        return !el.dispatchEvent(event);
      }

      /**
       * Return the maximum supported density of the image, given the container.
       *
       * @param {Item} item
       * @param {Size} size
       */
      function supportedDensity(item, size) {
        return Math.min(
          Math.min(Math.max(item.max.width / size.width, 1), item.density),
          Math.min(Math.max(item.max.height / size.height, 1), item.density)
        ).toFixed(2);
      }

      /**
       * Set the image URL on the element. Supports background images and `srcset`.
       *
       * @param {Item} item
       * @param {Size} size
       * @param {Boolean} isPlaceholder
       */
      function setImage(item, size, isPlaceholder, onLoad) {
        var render = item.templateRender;
        var density = isPlaceholder ? 1 : supportedDensity(item, size);
        var round = isPlaceholder ? 1 : item.round;

        // Calculate the final display size, taking into account the image's
        // maximum dimensions.
        var targetWidth = size.width * density;
        var targetHeight = size.height * density;

        var displaySize = void 0;

        if (item.crop) {
          displaySize = {
            width: roundSize(targetWidth, round, item.max.width),
            height: roundSize(targetHeight, round, item.max.height),
          };
        } else {
          // Shopify serves images clamped by the requested dimensions (fitted to the smallest dimension).
          // To get the desired and expected pixel density we need to request cover dimensions (fitted to largest dimension).
          // This isn't a problem with cropped images which are served at the exact dimension requested.
          var containerAspectRatio = size.width / size.height;
          var imageAspectRatio = item.max.width / item.max.height;

          if (containerAspectRatio > imageAspectRatio) {
            // fit width
            displaySize = {
              width: roundSize(targetWidth, round, item.max.width),
              height: roundSize(
                targetWidth / imageAspectRatio,
                round,
                item.max.height
              ),
            };
          } else {
            // fit height
            displaySize = {
              width: roundSize(
                targetHeight * imageAspectRatio,
                round,
                item.max.width
              ),
              height: roundSize(targetHeight, round, item.max.height),
            };
          }
        }

        var url = render(item.template, displaySize);

        // On load callback
        var image = new Image();
        image.onload = onLoad;
        image.src = url;

        // Set image
        if (item.isBackgroundImage) {
          item.el.style.backgroundImage = "url('" + url + "')";
        } else {
          item.el.setAttribute("srcset", url + " " + density + "x");
        }
      }

      /**
       * Load the image, set loaded status, and trigger the load event.
       *
       * @fires rimg:load
       * @fires rimg:error
       * @param {Item} item
       * @param {Size} size
       */
      function loadFullImage(item, size) {
        var el = item.el;

        setImage(item, size, false, function (event) {
          if (event.type === "load") {
            el.setAttribute("data-rimg", "loaded");
          } else {
            el.setAttribute("data-rimg", "error");
            index_es_trigger(el, "rimg:error");
          }

          index_es_trigger(el, "rimg:load");
        });
      }

      /**
       * Load in a responsive image.
       *
       * Sets the image's `srcset` attribute to the final image URLs, calculated based
       * on the actual size the image is being shown at.
       *
       * @fires rimg:loading
       *        The image URLs have been set and we are waiting for them to load.
       *
       * @fires rimg:loaded
       *        The final image has loaded.
       *
       * @fires rimg:error
       *        The final image failed loading.
       *
       * @param {Item} item
       */
      function loadImage(item) {
        var el = item.el;

        // Already loaded?
        var status = el.getAttribute("data-rimg");
        if (status === "loading" || status === "loaded") return;

        // Is the SVG loaded?
        if (!el.complete && !item.isBackgroundImage) {
          // Wait for the load event, then call load image
          el.addEventListener("load", function cb() {
            el.removeEventListener("load", cb);
            loadImage(item);
          });

          return;
        }

        // Trigger loading event, and stop if cancelled
        if (index_es_trigger(el, "rimg:loading")) return;

        // Mark as loading
        el.setAttribute("data-rimg", "loading");

        // Get element size. This is used as the ideal display size.
        var size = getElementSize(item.el);

        size.width *= item.scale;
        size.height *= item.scale;

        if (item.placeholder) {
          // Load a placeholder image first, followed by the full image. Force the
          // element to keep its dimensions while it loads. If the image is smaller
          // than the element size, use the image's size. Density is taken into account
          // for HiDPI devices to avoid blurry images.
          if (!item.isBackgroundImage) {
            el.setAttribute(
              "width",
              Math.min(Math.floor(item.max.width / item.density), size.width)
            );
            el.setAttribute(
              "height",
              Math.min(Math.floor(item.max.height / item.density), size.height)
            );
          }

          setImage(item, item.placeholder, true, function () {
            return loadFullImage(item, size);
          });
        } else {
          loadFullImage(item, size);
        }
      }

      /**
       * Prepare an element to be displayed on the screen.
       *
       * Images have special logic applied to them to swap out the different sources.
       *
       * @fires rimg:enter
       *        The element is entering the viewport.
       *
       * @param {HTMLElement} el
       * @param {Settings} options
       */
      function load(el, options) {
        if (!el) return;
        index_es_trigger(el, "rimg:enter");

        var item = parseItem(el, options);

        if (item.isImage) {
          if (!item.isBackgroundImage) {
            el.setAttribute(
              "data-rimg-template-svg",
              el.getAttribute("srcset")
            );
          }

          loadImage(item);
        }
      }

      /**
       * Reset an element's state so that its image can be recalculated.
       *
       * @fires rimg:update
       *        The element is being updated.
       *
       * @param {HTMLElement} el
       * @param {Settings} options
       */
      function index_es_update(el, options) {
        if (!el) return;
        index_es_trigger(el, "rimg:update");

        var item = parseItem(el, options);

        if (item.isImage) {
          if (!item.isBackgroundImage) {
            el.setAttribute("data-rimg", "lazy");
            el.setAttribute(
              "srcset",
              el.getAttribute("data-rimg-template-svg")
            );
          }

          loadImage(item);
        }
      }

      /**
       * Returns true if the element is within the viewport.
       * @param {HTMLElement} el
       * @returns {Boolean}
       */
      function inViewport(el) {
        if (
          !el.offsetWidth ||
          !el.offsetHeight ||
          !el.getClientRects().length
        ) {
          return false;
        }

        var root = document.documentElement;
        var width = Math.min(root.clientWidth, window.innerWidth);
        var height = Math.min(root.clientHeight, window.innerHeight);
        var rect = el.getBoundingClientRect();

        return (
          rect.bottom >= 0 &&
          rect.right >= 0 &&
          rect.top <= height &&
          rect.left <= width
        );
      }

      /**
       * @typedef {Object} Size
       * @property {Number} width
       * @property {Number} height
       */

      /**
       * A function to turn a template string into a URL.
       *
       * @callback TemplateRenderer
       * @param {String} template
       * @param {Size} size
       * @returns {String}
       */

      /**
       * @typedef {Object} Settings
       *
       * @property {String} [template]
       *           A template string used to generate URLs for an image. This allows us to
       *           dynamically load images with sizes to match the container's size.
       *
       * @property {TemplateRenderer} [templateRender]
       *           A function to turn a template string into a URL.
       *
       * @property {Size} [max]
       *           The maximum available size for the image. This ensures we don't
       *           try to load an image larger than is possible.
       *
       * @property {Number} [scale]
       *           A number to scale the final image dimensions by.
       *           Only applies to lazy-loaded images. Defaults to 1.
       *
       * @property {Number} [round]
       *           Round image dimensions to the nearest multiple. This is intended to
       *           tax the image server less by lowering the number of possible image
       *           sizes requested.
       *
       * @property {Size} [placeholder]
       *           The size of the lo-fi image to load before the full image.
       *
       * @property {String} [crop]
       *           Crop value; null if image is uncropped, otherwise equal
       *           to the Shopify crop parameter ('center', 'top', etc.).
       */

      /**
       * Initialize the responsive image handler.
       *
       * @param {String|HTMLElement|NodeList} selector
       *        The CSS selector, element, or elements to track for lazy-loading.
       *
       * @param {Settings} options
       *
       * @returns {PublicApi}
       */
      function rimg() {
        var selector =
          arguments.length > 0 && arguments[0] !== undefined
            ? arguments[0]
            : '[data-rimg="lazy"]';
        var options =
          arguments.length > 1 && arguments[1] !== undefined
            ? arguments[1]
            : {};

        // Intersections
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting || entry.intersectionRatio > 0) {
                io.unobserve(entry.target);
                load(entry.target, options);
              }
            });
          },
          {
            // Watch the viewport, with 20% vertical margins
            rootMargin: "20% 0px",
          }
        );

        /**
         * @typedef {Object} PublicApi
         */
        var api = {
          /**
           * Track a new selector, element, or nodelist for lazy-loading.
           * @type Function
           * @param {String|HTMLElement|NodeList} selector
           */
          track: function track() {
            var selector =
              arguments.length > 0 && arguments[0] !== undefined
                ? arguments[0]
                : '[data-rimg="lazy"]';

            var els = querySelector(selector);

            for (var i = 0; i < els.length; i++) {
              // If an element is already in the viewport, load it right away. This
              // fixes a race-condition with dynamically added elements.
              if (inViewport(els[i])) {
                load(els[i], options);
              } else {
                io.observe(els[i]);
              }
            }
          },

          /**
           * Update element(s) that have already been loaded to force their images
           * to be recalculated.
           * @type Function
           * @param {String|HTMLElement|NodeList} selector
           */
          update: function update$$1() {
            var selector =
              arguments.length > 0 && arguments[0] !== undefined
                ? arguments[0]
                : '[data-rimg="loaded"]';

            var els = querySelector(selector);
            for (var i = 0; i < els.length; i++) {
              index_es_update(els[i], options);
            }
          },

          /**
           * Stop tracking element(s) for lazy-loading.
           * @type Function
           * @param {String|HTMLElement|NodeList} selector
           */
          untrack: function untrack() {
            var selector =
              arguments.length > 0 && arguments[0] !== undefined
                ? arguments[0]
                : "[data-rimg]";

            var els = querySelector(selector);
            for (var i = 0; i < els.length; i++) {
              io.unobserve(els[i]);
            }
          },

          /**
           * Unload all event handlers and observers.
           * @type Function
           */
          unload: function unload() {
            io.disconnect();
          },
        };

        // Add initial elements
        api.track(selector);

        return api;
      }

      /**
       * Finds a group of elements on the page.
       *
       * @param {String|HTMLElement|NodeList} selector
       * @returns {Object} An array-like object.
       */
      function querySelector(selector) {
        if (typeof selector === "string") {
          return document.querySelectorAll(selector);
        }

        if (selector instanceof HTMLElement) {
          return [selector];
        }

        if (selector instanceof NodeList) {
          return selector;
        }

        return [];
      }

      /* harmony default export */ var dist_index_es = rimg;

      // CONCATENATED MODULE: ./node_modules/rimg-shopify/dist/index.es.js
      /*!
       * rimg-shopify v2.3.0
       * (c) 2018 Pixel Union
       */

      /**
       * Polyfill for Element.matches().
       *
       * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
       */
      if (!Element.prototype.matches) {
        Element.prototype.matches =
          Element.prototype.matchesSelector ||
          Element.prototype.mozMatchesSelector ||
          Element.prototype.msMatchesSelector ||
          Element.prototype.oMatchesSelector ||
          Element.prototype.webkitMatchesSelector ||
          function (s) {
            var matches = (
                this.document || this.ownerDocument
              ).querySelectorAll(s),
              i = matches.length;
            while (--i >= 0 && matches.item(i) !== this) {}
            return i > -1;
          };
      }

      var index_es_state = {
        init: init,
        watch: watch,
        unwatch: unwatch,
      };

      function init() {
        var selector =
          arguments.length > 0 && arguments[0] !== undefined
            ? arguments[0]
            : '[data-rimg="lazy"]';
        var options =
          arguments.length > 1 && arguments[1] !== undefined
            ? arguments[1]
            : {};

        index_es_state.selector = selector;
        index_es_state.instance = dist_index_es(selector, options);
        index_es_state.loadedWidth = Math.max(
          document.documentElement.clientWidth,
          window.innerWidth || 0
        );

        // Listen for Shopify theme editor events
        document.addEventListener("shopify:section:load", function (event) {
          return watch(event.target);
        });

        window.addEventListener("resize", function () {
          return _update();
        });

        document.addEventListener("shopify:section:unload", function (event) {
          return unwatch(event.target);
        });

        // Listen for custom events to allow themes to hook into rimg
        document.addEventListener("theme:rimg:watch", function (event) {
          return watch(event.target);
        });

        document.addEventListener("theme:rimg:unwatch", function (event) {
          return unwatch(event.target);
        });

        // Support custom events triggered through jQuery
        // See: https://github.com/jquery/jquery/issues/3347
        if (window.jQuery) {
          jQuery(document).on({
            "theme:rimg:watch": function themeRimgWatch(event) {
              return watch(event.target);
            },
            "theme:rimg:unwatch": function themeRimgUnwatch(event) {
              return unwatch(event.target);
            },
          });
        }
      }

      /**
       * Track an element, and its children.
       *
       * @param {HTMLElement} el
       */
      function watch(el) {
        // Track element
        if (
          typeof el.matches === "function" &&
          el.matches(index_es_state.selector)
        ) {
          index_es_state.instance.track(el);
        }

        // Track element's children
        index_es_state.instance.track(
          el.querySelectorAll(index_es_state.selector)
        );
      }

      /**
       * Untrack an element, and its children
       *
       * @param {HTMLElement} el
       * @private
       */
      function unwatch(el) {
        // Untrack element's children
        index_es_state.instance.untrack(
          el.querySelectorAll(index_es_state.selector)
        );

        // Untrack element
        if (
          typeof el.matches === "function" &&
          el.matches(index_es_state.selector)
        ) {
          index_es_state.instance.untrack(el);
        }
      }

      /**
       * Update an element, and its children.
       *
       * @param {HTMLElement} el
       */
      function _update() {
        var currentWidth = Math.max(
          document.documentElement.clientWidth,
          window.innerWidth || 0
        );

        // Return if we're not 2x smaller, or larger than the existing loading size
        if (
          currentWidth / index_es_state.loadedWidth > 0.5 &&
          currentWidth / index_es_state.loadedWidth < 2
        ) {
          return;
        }

        index_es_state.loadedWidth = currentWidth;
        index_es_state.instance.update();
      }

      /* harmony default export */ var rimg_shopify_dist_index_es =
        index_es_state;

      // EXTERNAL MODULE: ./node_modules/core-js/es6/symbol.js
      var symbol = __webpack_require__(148);

      // EXTERNAL MODULE: ./node_modules/core-js/fn/object/assign.js
      var object_assign = __webpack_require__(150);

      // EXTERNAL MODULE: ./node_modules/core-js/fn/array/iterator.js
      var iterator = __webpack_require__(151);

      // CONCATENATED MODULE: ./source/scripts/globals/jquery.js
      // jQuery plugins expect to find a global `jQuery` object, so we
      // need to attach it to the window.
      //
      // This is in its own file because we have to attach it before any
      // other imports happen, but with ES6 modules, all `import`s have
      // to be at the top.

      window.jQuery = jquery_default.a;
      window.$ = jquery_default.a;
      // EXTERNAL MODULE: ./node_modules/jquery-trend/jquery.trend.js
      var jquery_trend = __webpack_require__(152);

      // EXTERNAL MODULE: ./node_modules/jquery-revealer/jquery.revealer.js
      var jquery_revealer = __webpack_require__(153);

      // CONCATENATED MODULE: ./source/scripts/globals/FlickityTouchFix.js
      // This is a helper class to fix a touch issue that came up in flickity
      // on iOS devices as of version 13. It should smooth out some of the scroll
      // and swipe issues that flickity is having on that version of iOS.
      var flickityTouchFix = function flickityTouchFix() {
        var touchingSlider = false;
        var touchStartCoordsX = 0;

        var onTouchStart = function onTouchStart(e) {
          if (e.target.closest && e.target.closest(".flickity-slider")) {
            touchingSlider = true;
            touchStartCoordsX = e.touches[0].pageX;
          } else {
            touchingSlider = false;
          }
        };

        var onTouchMove = function onTouchMove(e) {
          if (!(touchingSlider && e.cancelable)) {
            return;
          }

          if (Math.abs(e.touches[0].pageX - touchStartCoordsX) > 10) {
            e.preventDefault();
          }
        };

        document.body.addEventListener("touchstart", onTouchStart);
        document.body.addEventListener("touchmove", onTouchMove, {
          passive: false,
        });
      };

      /* harmony default export */ var FlickityTouchFix = flickityTouchFix;
      // EXTERNAL MODULE: ./source/scripts/globals/google-maps.js
      var google_maps = __webpack_require__(154);

      // CONCATENATED MODULE: ./source/scripts/templates/accountTemplates.js

      function addressTemplate($customerAddresses) {
        var $addressEditLinks = jquery_default()("[data-edit-address]");

        if ($addressEditLinks.length) {
          $addressEditLinks.on("click", function (event) {
            var itemId = jquery_default()(event.target).attr(
              "data-edit-address"
            );
            jquery_default()("[data-address-id]").removeClass(
              "account-address-form-active"
            );
            jquery_default()(
              '[data-address-id="'.concat(itemId, '"]')
            ).addClass("account-address-form-active");
          });
        }

        var $addressDeleteLinks = jquery_default()("[data-delete-address]");

        if ($addressDeleteLinks.length) {
          $addressDeleteLinks.on("click", function (event) {
            var itemId = jquery_default()(event.target).attr(
              "data-delete-address"
            );
            Shopify.CustomerAddress.destroy(itemId);
          });
        }

        $customerAddresses.each(function provincePopulator() {
          var id = jquery_default()(this).attr("data-address-id"); // Initiate provinces for the New Address form

          new Shopify.CountryProvinceSelector(
            "customer-addr-".concat(id, "-country"),
            "customer-addr-".concat(id, "-province"),
            {
              hideElement: "address-province-container-".concat(id),
            }
          );
        });
      }

      function accountTemplates() {
        // Deal with showing / hiding elements on login page
        var $formWrapper = jquery_default()("[data-login-forms]");

        if ($formWrapper.length) {
          $formWrapper.on(
            "click",
            "[data-toggle-account-recovery]",
            function () {
              $formWrapper.toggleClass("show-account-recovery");
            }
          );

          if (
            jquery_default()(".account-recovery").find(".errors").length > 0
          ) {
            $formWrapper.toggleClass("show-account-recovery");
          }
        }

        var $customerAddresses = jquery_default()("[data-address-id]");

        if ($customerAddresses) {
          addressTemplate($customerAddresses);
        }
      }

      /* harmony default export */ var templates_accountTemplates =
        accountTemplates;
      // EXTERNAL MODULE: ./node_modules/grouped-content/dist/index.js
      var dist = __webpack_require__(144);
      var dist_default = /*#__PURE__*/ __webpack_require__.n(dist);

      // CONCATENATED MODULE: ./node_modules/reframe.js/dist/reframe.es.js
      function reframe(target, cName) {
        var frames =
          typeof target === "string"
            ? document.querySelectorAll(target)
            : target;
        var c = cName || "js-reframe";
        if (!("length" in frames)) frames = [frames];
        for (var i = 0; i < frames.length; i += 1) {
          var frame = frames[i];
          var hasClass = frame.className.split(" ").indexOf(c) !== -1;
          if (hasClass || frame.style.width.indexOf("%") > -1) continue;
          var h = frame.getAttribute("height") || frame.offsetHeight;
          var w = frame.getAttribute("width") || frame.offsetWidth;
          var padding = (h / w) * 100;
          var div = document.createElement("div");
          div.className = c;
          var divStyles = div.style;
          divStyles.position = "relative";
          divStyles.width = "100%";
          divStyles.paddingTop = padding + "%";
          var frameStyle = frame.style;
          frameStyle.position = "absolute";
          frameStyle.width = "100%";
          frameStyle.height = "100%";
          frameStyle.left = "0";
          frameStyle.top = "0";
          frame.parentNode.insertBefore(div, frame);
          frame.parentNode.removeChild(frame);
          div.appendChild(frame);
        }
      }

      /* harmony default export */ var reframe_es = reframe;

      // CONCATENATED MODULE: ./source/scripts/globals/RTE.js
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var RTE_RTE =
        /*#__PURE__*/
        (function () {
          function RTE(el) {
            _classCallCheck(this, RTE);

            this.el = el;
            this.groupedContent = new dist_default.a(el, {
              layout: "accordion",
              intelliparse: false,
            });
            this.frames = el.querySelectorAll("iframe");
            reframe_es(this.frames);
          }

          _createClass(RTE, [
            {
              key: "unload",
              value: function unload() {
                // Reframe doesnt offer an unload method, so we'll manually remove the elements added
                for (var i = 0; i < this.frames.length; i++) {
                  var frame = this.frames[i];
                  var wrapper = frame.parentNode;
                  var originalParent = wrapper.parentNode;
                  originalParent.appendChild(frame);
                  originalParent.removeChild(wrapper);
                }

                this.groupedContent.unload();
              },
            },
          ]);

          return RTE;
        })();

      // CONCATENATED MODULE: ./source/scripts/templates/pageTemplates.js

      function pageTemplates() {
        // Do nothing if we're not on a page template
        if (
          !document.body.classList.contains("page-template-page") &&
          !document.body.classList.contains("page-template-page.contact")
        ) {
          return;
        }

        var el = document.querySelector(".page");
        new RTE_RTE(el.querySelector(".rte"));
      }
      // CONCATENATED MODULE: ./source/scripts/Layout.js

      function getBreakpoint() {
        return window
          .getComputedStyle(document.documentElement, ":after")
          .getPropertyValue("content")
          .replace(/"/g, "");
      }

      var eventHandlers = [];
      var previousBreakpoint = getBreakpoint();

      function isBreakpoint() {
        for (var i = 0; i < arguments.length; i++) {
          if (
            getBreakpoint() ===
            (i < 0 || arguments.length <= i ? undefined : arguments[i])
          ) {
            return true;
          }
        }

        return false;
      }

      function Layout_onBreakpointChange(eventHandler) {
        if (eventHandlers.indexOf(eventHandler) === -1) {
          eventHandlers.push(eventHandler);
        }
      }

      function offBreakpointChange(eventHandler) {
        var index = eventHandlers.indexOf(eventHandler);

        if (index !== -1) {
          eventHandlers.splice(index, 1);
        }
      }

      jquery_default()(window).on("resize", function (event) {
        var currentBreakpoint = getBreakpoint();

        if (previousBreakpoint !== currentBreakpoint) {
          eventHandlers.forEach(function (eventHandler) {
            return eventHandler(event, {
              previous: previousBreakpoint,
              current: currentBreakpoint,
            });
          });
        }

        previousBreakpoint = currentBreakpoint;
      });
      /* harmony default export */ var Layout = {
        getBreakpoint: getBreakpoint,
        isBreakpoint: isBreakpoint,
        onBreakpointChange: Layout_onBreakpointChange,
        offBreakpointChange: offBreakpointChange,
      };
      // CONCATENATED MODULE: ./source/scripts/templates/enumerateSections.js

      function _enumerateSections() {
        var indexWrapper = document.getElementsByClassName("index-wrapper");

        if (!indexWrapper.length) {
          return;
        }

        indexWrapper = indexWrapper[0];
        var sections = indexWrapper.getElementsByClassName("shopify-section");
        var foundForward = false;
        var foundReverse = false;

        for (var i = 0; i < sections.length; i++) {
          var sectionForward = sections[i];
          var sectionReverse = sections[sections.length - 1 - i];
          sectionForward.classList.remove("shopify-section-first");
          sectionReverse.classList.remove("shopify-section-last");

          if (!foundForward && sectionForward.offsetHeight) {
            foundForward = true;
            sectionForward.className += " shopify-section-first";
          }

          if (!foundReverse && sectionReverse.offsetHeight) {
            foundReverse = true;
            sectionReverse.className += " shopify-section-last";
          }
        }
      }

      function enumerateSections() {
        Layout.onBreakpointChange(_enumerateSections);
        document.addEventListener(
          "shopify:section:reorder",
          _enumerateSections
        );
      }
      // CONCATENATED MODULE: ./source/scripts/Sections.js
      function Sections_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function Sections_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function Sections_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          Sections_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Sections_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var Sections =
        /*#__PURE__*/
        (function () {
          function Sections() {
            Sections_classCallCheck(this, Sections);

            this.handlers = {};
            this.instances = {};
            this._onSectionEvent = this._onSectionEvent.bind(this);
            document.addEventListener(
              "shopify:section:load",
              this._onSectionEvent
            );
            document.addEventListener(
              "shopify:section:unload",
              this._onSectionEvent
            );
            document.addEventListener(
              "shopify:section:select",
              this._onSectionEvent
            );
            document.addEventListener(
              "shopify:section:deselect",
              this._onSectionEvent
            );
            document.addEventListener(
              "shopify:block:select",
              this._onSectionEvent
            );
            document.addEventListener(
              "shopify:block:deselect",
              this._onSectionEvent
            );
          }
          /**
           * Stop listening for section events, and unbind all handlers.
           */

          Sections_createClass(Sections, [
            {
              key: "unbind",
              value: function unbind() {
                document.removeEventListener(
                  "shopify:section:load",
                  this._onSectionEvent
                );
                document.removeEventListener(
                  "shopify:section:unload",
                  this._onSectionEvent
                );
                document.removeEventListener(
                  "shopify:section:select",
                  this._onSectionEvent
                );
                document.removeEventListener(
                  "shopify:section:deselect",
                  this._onSectionEvent
                );
                document.removeEventListener(
                  "shopify:block:select",
                  this._onSectionEvent
                );
                document.removeEventListener(
                  "shopify:block:deselect",
                  this._onSectionEvent
                ); // Unload all instances

                for (var i = 0; i < this.instances.length; i++) {
                  this._triggerInstanceEvent(
                    this.instances[i],
                    "onSectionUnload"
                  );
                }

                this.handlers = {};
                this.instances = {};
              },
              /**
               * Register a section handler.
               *
               * @param {string} type
               *        The section type to handle. The handler will be called for all
               *        sections with this type.
               *
               * @param {function} handler
               *        The handler function is passed information about a specific section
               *        instance. The handler is expected to return an object that will be
               *        associated with the section instance.
               *
               *        Section handlers are passed an object with the following parameters:
               *          {string} id
               *          An ID that maps to a specific section instance. Typically the
               *          section's filename for static sections, or a generated ID for
               *          dynamic sections.
               *
               *          {string} type
               *          The section type, as supplied when registered.
               *
               *          {Element} el
               *          The root DOM element for the section instance.
               *
               *          {Object} data
               *          Data loaded from the section script element. Defaults to an
               *          empty object.
               *
               *          {Function} postMessage
               *          A function that can be called to pass messages between sections.
               *          The function should be called with a message "name", and
               *          optionally some data.
               */
            },
            {
              key: "register",
              value: function register(type, handler) {
                if (this.handlers[type]) {
                  console.warn(
                    "Sections: section handler already exists of type '".concat(
                      type,
                      "'."
                    )
                  );
                } // Store the section handler

                this.handlers[type] = handler; // Init sections for this type

                this._initSections(type);
              },
              /**
               * Initialize sections already on the page.
               */
            },
            {
              key: "_initSections",
              value: function _initSections(type) {
                // Fetch all existing sections of our type on the page
                var dataEls = document.querySelectorAll(
                  '[data-section-type="'.concat(type, '"]')
                );
                if (!dataEls) return; // Create an instance for each section

                for (var i = 0; i < dataEls.length; i++) {
                  var dataEl = dataEls[i];
                  var el = dataEl.parentNode; // Get instance ID

                  var idEl = el.querySelector("[data-section-id]");

                  if (!idEl) {
                    console.warn(
                      "Sections: unable to find section id for '".concat(
                        type,
                        "'."
                      ),
                      el
                    );
                    continue;
                  }

                  var sectionId = idEl.getAttribute("data-section-id");

                  if (!sectionId) {
                    console.warn(
                      "Sections: unable to find section id for '".concat(
                        type,
                        "'."
                      ),
                      el
                    );
                    continue;
                  }

                  this._createInstance(sectionId, el);
                }
              },
            },
            {
              key: "_onSectionEvent",
              value: function _onSectionEvent(event) {
                var el = event.target;
                var sectionId = event.detail.sectionId;
                var blockId = event.detail.blockId;
                var instance = this.instances[sectionId];

                switch (event.type) {
                  case "shopify:section:load":
                    this._createInstance(sectionId, el);

                    break;

                  case "shopify:section:unload":
                    this._triggerInstanceEvent(instance, "onSectionUnload", {
                      el: el,
                      id: sectionId,
                    });

                    delete this.instances[sectionId];
                    break;

                  case "shopify:section:select":
                    this._triggerInstanceEvent(instance, "onSectionSelect", {
                      el: el,
                      id: sectionId,
                    });

                    break;

                  case "shopify:section:deselect":
                    this._triggerInstanceEvent(instance, "onSectionDeselect", {
                      el: el,
                      id: sectionId,
                    });

                    break;

                  case "shopify:block:select":
                    this._triggerInstanceEvent(
                      instance,
                      "onSectionBlockSelect",
                      {
                        el: el,
                        id: blockId,
                      }
                    );

                    break;

                  case "shopify:block:deselect":
                    this._triggerInstanceEvent(
                      instance,
                      "onSectionBlockDeselect",
                      {
                        el: el,
                        id: blockId,
                      }
                    );

                    break;
                }
              },
            },
            {
              key: "_triggerInstanceEvent",
              value: function _triggerInstanceEvent(instance, eventName) {
                if (instance && instance[eventName]) {
                  for (
                    var _len = arguments.length,
                      args = new Array(_len > 2 ? _len - 2 : 0),
                      _key = 2;
                    _key < _len;
                    _key++
                  ) {
                    args[_key - 2] = arguments[_key];
                  }

                  instance[eventName].apply(instance, args);
                }
              },
            },
            {
              key: "_postMessage",
              value: function _postMessage(name, data) {
                for (var id in this.instances) {
                  this._triggerInstanceEvent(
                    this.instances[id],
                    "onSectionMessage",
                    name,
                    data
                  );
                }
              },
            },
            {
              key: "_createInstance",
              value: function _createInstance(id, el) {
                var typeEl = el.querySelector("[data-section-type]");
                if (!typeEl)
                  return console.warn(
                    "Sections: unable to find section type for id '".concat(
                      id,
                      "'."
                    )
                  );
                var type = typeEl.getAttribute("data-section-type");
                if (!type)
                  return console.warn(
                    "Sections: unable to find section type for id '".concat(
                      id,
                      "'."
                    )
                  );
                var handler = this.handlers[type];
                if (!handler)
                  return console.warn(
                    "Sections: unable to find section handler for type '".concat(
                      type,
                      "'."
                    )
                  );

                var data = this._loadData(el);

                var postMessage = this._postMessage.bind(this);

                this.instances[id] = handler({
                  id: id,
                  type: type,
                  el: el,
                  data: data,
                  postMessage: postMessage,
                });
              },
            },
            {
              key: "_loadData",
              value: function _loadData(el) {
                var dataEl = el.querySelector("[data-section-data]");
                if (!dataEl) return {}; // Load data from attribute, or innerHTML

                var data =
                  dataEl.getAttribute("data-section-data") || dataEl.innerHTML;

                try {
                  return JSON.parse(data);
                } catch (error) {
                  console.warn(
                    "Sections: invalid section data found. ".concat(
                      error.message
                    )
                  );
                  return {};
                }
              },
            },
          ]);

          return Sections;
        })();

      // CONCATENATED MODULE: ./source/scripts/snippets/NavTrigger.js
      function NavTrigger_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function NavTrigger_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function NavTrigger_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          NavTrigger_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) NavTrigger_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var NavTrigger_NavTrigger =
        /*#__PURE__*/
        (function () {
          function NavTrigger() {
            var _this = this;

            var options =
              arguments.length > 0 && arguments[0] !== undefined
                ? arguments[0]
                : {};

            NavTrigger_classCallCheck(this, NavTrigger);

            this.$el = jquery_default()(options.el); // Target element

            this.$document = jquery_default()(document);
            this.namespace = options.namespace;
            this.trigger = options.trigger;
            this.postMessage = options.postMessage;
            this.onShow = options.onShow;
            this.onHide = options.onHide;
            this.$overlay = jquery_default()(".site-navigation-overlay");
            this.isHovering = false;
            this.isTouching = false;
            this.isLocked = false;
            this.selector =
              ".site-navigation .navmenu-depth-1 > .navmenu-id-".concat(
                this.trigger
              );
            this.events = [
              // Show/hide target when touched
              this.$document.on(
                "touchend.".concat(this.namespace),
                this.selector,
                function (event) {
                  event.preventDefault();

                  _this.toggle();
                }
              ), // Show/hide target when hovering over the navigation trigger
              this.$document.on(
                "mouseenter.".concat(this.namespace),
                this.selector,
                function (event) {
                  return _this.show();
                }
              ),
              this.$document.on(
                "mouseleave.".concat(this.namespace),
                this.selector,
                function (event) {
                  return _this.hide();
                }
              ),
              this.$document.on(
                "focus.".concat(this.namespace),
                this.selector,
                function (event) {
                  _this.show();
                }
              ),
              this.$document.on(
                "blur.".concat(this.namespace),
                this.selector,
                function (event) {
                  _this.hide();
                }
              ), // Keep track of hovering state
              this.$el.on(
                "mouseenter.".concat(this.namespace),
                function (event) {
                  _this.isHovering = !_this.isTouching;
                  _this.isTouching = false;
                }
              ),
              this.$el.on(
                "touchstart.".concat(this.namespace),
                function (event) {
                  _this.isTouching = true;
                }
              ),
              this.$el.on(
                "mouseleave.".concat(this.namespace),
                function (event) {
                  _this.isHovering = false;

                  _this.hide();
                }
              ),
            ];
            this.addTrigger();
          }

          NavTrigger_createClass(NavTrigger, [
            {
              key: "unload",
              value: function unload() {
                var _this2 = this;

                // Reset state
                this.isHovering = false;
                this.isLocked = false;
                this.hide(); // Unbind events

                this.events.forEach(function (event) {
                  return event.off(".".concat(_this2.namespace));
                }); // Remove elements

                this.removeTriggers();
              },
            },
            {
              key: "lock",
              value: function lock() {
                this.isLocked = true;
                this.show(true);
              },
            },
            {
              key: "unlock",
              value: function unlock() {
                this.isLocked = false;
                this.hide();
              },
            },
            {
              key: "toggle",
              value: function toggle() {
                if (this.$el.revealer("isVisible")) {
                  this.hide();
                } else {
                  this.show();
                }
              },
              /**
               * Show the target.
               *
               * @param {boolean} force
               *        If true, skip animations.
               */
            },
            {
              key: "show",
              value: function show(force) {
                var _this3 = this;

                // close header minicart
                this.postMessage("header-minicart:toggle", "closed");
                jquery_default()(this.selector).attr("aria-expanded", true);
                this.$el
                  .revealer("show", force)
                  .one("revealer-animating", function () {
                    _this3.addShim();

                    if (_this3.onShow) _this3.onShow();
                  });
              },
              /**
               * Hide the target.
               *
               * Since the meganav element is not a child of the trigger element, we wait a
               * few milliseconds to allow time for the mouse to move between elements.
               */
            },
            {
              key: "hide",
              value: function hide() {
                var _this4 = this;

                if (this.isLocked) {
                  return;
                }

                this.hideOverlay();
                setTimeout(function () {
                  if (_this4.isHovering) return;

                  _this4.removeShim();

                  _this4.$el.revealer("hide").one("revealer-hide", function () {
                    if (_this4.onHide) _this4.onHide();
                  });
                }, 10);
              },
            },
            {
              key: "showOverlay",
              value: function showOverlay() {
                this.$overlay.show();
              },
            },
            {
              key: "hideOverlay",
              value: function hideOverlay() {
                this.$overlay.hide();
              },
              /**
               * Marks a specific navigation item as a trigger. Hovering over
               * that item should cause the target to show.
               */
            },
            {
              key: "addTrigger",
              value: function addTrigger() {
                var $trigger = jquery_default()(this.selector);
                if (!$trigger.length) return; // Mark element as a trigger

                $trigger.attr("data-navmenu-trigger", this.namespace); // Disable regular dropdowns

                $trigger.attr("data-navmenu-ignore", true);
              },
            },
            {
              key: "removeTriggers",
              value: function removeTriggers() {
                jquery_default()(
                  '[data-navmenu-trigger="'.concat(this.namespace, '"]')
                ).each(function (index, el) {
                  var $trigger = jquery_default()(el);
                  $trigger.removeAttr("data-navmenu-trigger");
                  $trigger.removeData("navmenu-ignore");
                });
              },
              /**
               * Add shim element.
               *
               * +---------+
               * | TRIGGER |
               * +---------+
               * | SHIM    |  <- Add shim to allow the mouse to travel between the trigger
               * +---------+     and target elements without hiding the target
               * | TARGET  |
               * +---------+
               */
            },
            {
              key: "addShim",
              value: function addShim() {
                var $trigger = jquery_default()(this.selector);
                if (!$trigger.length) return; // Calculate shim size

                var padding = 30;
                var height =
                  this.$el.offset().top -
                  ($trigger.offset().top + $trigger.outerHeight());
                var width = $trigger.outerWidth() + padding * 2; // Create shim element

                var $shim = jquery_default()("<div>", {
                  class: "navtrigger-shim",
                  css: {
                    position: "absolute",
                    top: "100%",
                    left: padding * -1,
                    width: width,
                    height: height,
                  },
                });
                $trigger.append($shim);
              },
              /**
               * Remove shim element.
               */
            },
            {
              key: "removeShim",
              value: function removeShim() {
                var $trigger = jquery_default()(this.selector);
                $trigger.attr("aria-expanded", false);
                $trigger.find(".navtrigger-shim").remove();
              },
            },
          ]);

          return NavTrigger;
        })();

      // EXTERNAL MODULE: ./node_modules/just-debounce/index.js
      var just_debounce = __webpack_require__(54);
      var just_debounce_default =
        /*#__PURE__*/ __webpack_require__.n(just_debounce);

      // CONCATENATED MODULE: ./source/scripts/snippets/Map.js
      function Map_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function Map_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function Map_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) Map_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Map_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var Map_Map =
        /*#__PURE__*/
        (function () {
          function Map(el) {
            Map_classCallCheck(this, Map);

            this.el = el;
            this.map = null;
            this.center = null;
            this.container = this.el.querySelector("[data-map-container]");
            this.container.innerHTML = "";
            var addressHtml = document.createElement("div");
            addressHtml.innerHTML = this.el.getAttribute("data-map-address");
            this.address = addressHtml.innerText; // Scale so range is 12 ~ 17, rather than 1 to 6

            this.zoom =
              11 + parseInt(this.el.getAttribute("data-map-zoom"), 10);
            if (isNaN(this.zoom)) this.zoom = 13;
            this.colors = {
              a: this.el.getAttribute("data-map-color-a"),
              b: this.el.getAttribute("data-map-color-b"),
              c: this.el.getAttribute("data-map-color-c"),
              d: this.el.getAttribute("data-map-color-d"),
              e: this.el.getAttribute("data-map-color-e"),
              f: this.el.getAttribute("data-map-color-f"),
            };
            this.resize = this.resize.bind(this);
          }

          Map_createClass(Map, [
            {
              key: "createMap",
              value: function createMap() {
                var _this = this;

                return this.geolocate()
                  .done(function (results) {
                    _this.map = new google.maps.Map(_this.container, {
                      center: results[0].geometry.location,
                      clickableIcons: false,
                      disableDefaultUI: true,
                      disableDoubleClickZoom: true,
                      gestureHandling: "none",
                      keyboardShortcuts: false,
                      maxZoom: _this.zoom,
                      minZoom: _this.zoom,
                      scrollWheel: false,
                      styles: _this.getMapStyles(),
                      zoom: _this.zoom,
                      zoomControl: false,
                    });
                    _this.center = _this.map.getCenter();
                    var marker = new google.maps.Marker({
                      clickable: false,
                      map: _this.map,
                      position: _this.center,
                    });
                    google.maps.event.addDomListener(
                      window,
                      "resize",
                      just_debounce_default()(_this.resize, 250, true, true)
                    );
                  })
                  .fail(function (status) {
                    var usageLimits =
                      "https://developers.google.com/maps/faq#usagelimits";
                    var errorMessage;

                    switch (status) {
                      case "ZERO_RESULTS":
                        errorMessage =
                          "<p>Unable to find the address:</p> ".concat(
                            _this.address
                          );
                        break;

                      case "OVER_QUERY_LIMIT":
                        errorMessage =
                          '\n              <p>Unable to load Google Maps, you have reached your usage limit.</p>\n              <p>\n                Please visit\n                <a href="'
                            .concat(usageLimits, '" target="_blank">')
                            .concat(
                              usageLimits,
                              "</a>\n                for more details.\n              </p>\n            "
                            );
                        break;

                      default:
                        errorMessage = "Unable to load Google Maps.";
                        break;
                    }

                    _this.displayErrorInThemeEditor(errorMessage, status);
                  });
              },
            },
            {
              key: "geolocate",
              value: function geolocate() {
                var deferred = jquery_default.a.Deferred();
                var geocoder = new google.maps.Geocoder();
                geocoder.geocode(
                  {
                    address: this.address,
                  },
                  function (results, status) {
                    if (status !== google.maps.GeocoderStatus.OK) {
                      deferred.reject(status);
                    }

                    deferred.resolve(results);
                  }
                );
                return deferred;
              },
            },
            {
              key: "resize",
              value: function resize() {
                if (this.map) {
                  google.maps.event.trigger(this.map, "resize");
                  this.map.setCenter(this.center);
                }
              },
            },
            {
              key: "unload",
              value: function unload() {
                if (this.map) {
                  google.maps.event.clearListeners(this.map, "resize");
                }
              },
            },
            {
              key: "getMapStyles",
              value: function getMapStyles() {
                return [
                  {
                    elementType: "geometry",
                    stylers: [
                      {
                        color: this.colors.e,
                      },
                    ],
                  },
                  {
                    elementType: "labels.icon",
                    stylers: [
                      {
                        visibility: "off",
                      },
                    ],
                  },
                  {
                    elementType: "labels.text.fill",
                    stylers: [
                      {
                        color: this.colors.a,
                      },
                    ],
                  },
                  {
                    elementType: "labels.text.stroke",
                    stylers: [
                      {
                        color: this.colors.e,
                      },
                    ],
                  },
                  {
                    featureType: "administrative",
                    elementType: "geometry",
                    stylers: [
                      {
                        visibility: "off",
                      },
                    ],
                  },
                  {
                    featureType: "administrative.country",
                    stylers: [
                      {
                        visibility: "off",
                      },
                    ],
                  },
                  {
                    featureType: "administrative.land_parcel",
                    stylers: [
                      {
                        visibility: "off",
                      },
                    ],
                  },
                  {
                    featureType: "administrative.neighborhood",
                    stylers: [
                      {
                        visibility: "off",
                      },
                    ],
                  },
                  {
                    featureType: "administrative.locality",
                    stylers: [
                      {
                        visibility: "off",
                      },
                    ],
                  },
                  {
                    featureType: "poi",
                    stylers: [
                      {
                        visibility: "off",
                      },
                    ],
                  },
                  {
                    featureType: "road",
                    elementType: "geometry.fill",
                    stylers: [
                      {
                        color: this.colors.d,
                      },
                    ],
                  },
                  {
                    featureType: "road",
                    elementType: "labels.icon",
                    stylers: [
                      {
                        visibility: "off",
                      },
                    ],
                  },
                  {
                    featureType: "road.arterial",
                    elementType: "geometry",
                    stylers: [
                      {
                        color: this.colors.c,
                      },
                    ],
                  },
                  {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                      {
                        color: this.colors.b,
                      },
                    ],
                  },
                  {
                    featureType: "road.highway.controlled_access",
                    stylers: [
                      {
                        visibility: "off",
                      },
                    ],
                  },
                  {
                    featureType: "road.local",
                    elementType: "labels.text.fill",
                    stylers: [
                      {
                        color: this.colors.b,
                      },
                    ],
                  },
                  {
                    featureType: "road.local",
                    elementType: "labels.text.stroke",
                    stylers: [
                      {
                        color: this.colors.e,
                      },
                    ],
                  },
                  {
                    featureType: "transit",
                    stylers: [
                      {
                        visibility: "off",
                      },
                    ],
                  },
                  {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [
                      {
                        color: this.colors.f,
                      },
                    ],
                  },
                ];
              },
            },
            {
              key: "displayErrorInThemeEditor",
              value: function displayErrorInThemeEditor(errorMessage) {
                var status =
                  arguments.length > 1 && arguments[1] !== undefined
                    ? arguments[1]
                    : "";
                // Editor check
                var isThemeEditor = window.Shopify && window.Shopify.designMode;

                if (!isThemeEditor) {
                  return;
                }

                this.container.innerHTML =
                  '<div class="map-error-message">'.concat(
                    errorMessage,
                    "</div>"
                  );
                console.warn(this.container.innerText, status);
              },
            },
          ]);

          return Map;
        })();

      // CONCATENATED MODULE: ./source/scripts/sections/ContactbarStaticSection.js
      function ContactbarStaticSection_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function ContactbarStaticSection_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function ContactbarStaticSection_createClass(
        Constructor,
        protoProps,
        staticProps
      ) {
        if (protoProps)
          ContactbarStaticSection_defineProperties(
            Constructor.prototype,
            protoProps
          );
        if (staticProps)
          ContactbarStaticSection_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var ContactbarStaticSection_ContactbarStaticSection =
        /*#__PURE__*/
        (function () {
          function ContactbarStaticSection(section) {
            var _this = this;

            ContactbarStaticSection_classCallCheck(
              this,
              ContactbarStaticSection
            );

            this.$el = jquery_default()(section.el);
            this.$map = jquery_default()("[data-map]", this.$el);
            this.hasMap = this.$map.length;
            this.apiKey = section.data.api_key;
            this.trigger = section.data.trigger;
            this.postMessage = section.postMessage;
            this.clones = [];
            this.maps = [];
            this.clone();

            if (this.hasMap) {
              this.maps.push(new Map_Map(this.$map[0]));

              if (this.apiKey) {
                if (window.google === undefined) {
                  jquery_default.a
                    .getScript(
                      "https://maps.googleapis.com/maps/api/js?key=".concat(
                        this.apiKey
                      )
                    )
                    .done(function () {
                      _this.maps.forEach(function (map) {
                        return map.createMap();
                      });
                    })
                    .fail(function (status) {
                      console.error(status);
                    });
                } else {
                  this.maps.forEach(function (map) {
                    return map.createMap();
                  });
                }
              } else {
                var javascriptApi =
                  "https://developers.google.com/maps/documentation/javascript/get-api-key";
                var geocodingApi =
                  "https://developers.google.com/maps/documentation/geocoding/get-api-key";
                var errorMessage =
                  '\n          <p>\n            To activate your map:\n            <ol>\n              <li>\n                Generate both <a href="'
                    .concat(
                      javascriptApi,
                      '" target="_blank">JavaScript</a>\n                and <a href="'
                    )
                    .concat(
                      geocodingApi,
                      '" target="_blank">Geocoding</a> API keys.\n              </li>\n              <li>Copy and paste one of them into the theme editor.</li>\n              <li>Save your changes to verify the new API key.</li>\n            </ol>\n          </p>\n        '
                    );
                this.maps.forEach(function (map) {
                  return map.displayErrorInThemeEditor(errorMessage);
                });
              }
            }

            this.navTrigger = new NavTrigger_NavTrigger({
              el: section.el,
              namespace: "contactbar",
              trigger: this.trigger,
              postMessage: this.postMessage,
              onShow: function onShow() {
                _this.maps.forEach(function (map) {
                  return map.resize();
                });

                _this.postMessage("nav:close-all", {});

                _this.postMessage("nav:close-triggers", {
                  source: _this.$el,
                });

                _this.postMessage("nav:show-overlay", {
                  source: _this.$el,
                });
              },
            });
            this.$mobile = jquery_default()(".mobilenav-contactbar");
            this.$info = this.$mobile.find(".contactbar-info");
            this.$infoTrigger = this.$mobile.find(
              "[data-contactbar-info-trigger]"
            );
            this.$infoClose = this.$mobile.find("[data-contactbar-info-close]");
            this.events = [
              // Show mobile info panel
              this.$infoTrigger.on("click.contactbar", function (event) {
                return _this.$info.revealer();
              }), // Hide mobile info panel
              this.$infoClose.on("click.contactbar", function (event) {
                return _this.$info.revealer("hide");
              }),
            ]; // Handle breakpoint changes while editing

            this.layoutHandler = this.onBreakpointChange.bind(this);
            Layout.onBreakpointChange(this.layoutHandler);
          }

          ContactbarStaticSection_createClass(ContactbarStaticSection, [
            {
              key: "onSectionUnload",
              value: function onSectionUnload() {
                this.events.forEach(function ($el) {
                  return $el.off(".contactbar");
                });
                this.clones.forEach(function (clone) {
                  return clone.$el.empty();
                });
                this.maps.forEach(function (map) {
                  return map.unload();
                });
                this.navTrigger.unload();
                Layout.offBreakpointChange(this.layoutHandler);
              },
            },
            {
              key: "onSectionSelect",
              value: function onSectionSelect() {
                this.isEditing = true;

                if (Layout.isBreakpoint("M") || Layout.isBreakpoint("L")) {
                  this.navTrigger.lock();
                } else {
                  this.postMessage("mobilenav:open");
                }
              },
            },
            {
              key: "onSectionDeselect",
              value: function onSectionDeselect() {
                this.isEditing = false;

                if (Layout.isBreakpoint("M") || Layout.isBreakpoint("L")) {
                  this.navTrigger.unlock();
                } else {
                  this.postMessage("mobilenav:close");
                }
              },
            },
            {
              key: "onSectionMessage",
              value: function onSectionMessage(name, data) {
                if (name === "nav:close-triggers" && data.source !== this.$el) {
                  this.navTrigger.hide();
                }

                if (name === "nav:show-overlay") {
                  this.navTrigger.showOverlay();
                }
              },
            },
            {
              key: "onBreakpointChange",
              value: function onBreakpointChange() {
                if (!this.isEditing) return;

                if (Layout.isBreakpoint("M") || Layout.isBreakpoint("L")) {
                  this.navTrigger.lock();
                  this.postMessage("mobilenav:close");
                } else {
                  this.navTrigger.unlock();
                  this.postMessage("mobilenav:open");
                }
              },
              /**
               * Copy the mega nav to other parts of the theme.
               */
            },
            {
              key: "clone",
              value: function clone() {
                var $source = this.$el
                  .find("[data-contactbar-clone-source]")
                  .first();
                if (!$source.length) return;
                var $clone = $source.children().clone(); // Add contactbar to mobilenav panel

                var $mobileTarget = jquery_default()(
                  "[data-contactbar-mobile-target]"
                );

                if ($mobileTarget.length) {
                  $mobileTarget.append($clone);
                  this.clones.push({
                    $el: $mobileTarget,
                  });
                } // Add contactbar to contact page

                var $pageTarget = jquery_default()(
                  "[data-contactbar-page-target]"
                );

                if ($pageTarget.length) {
                  $pageTarget.append($clone.clone());
                  this.clones.push({
                    $el: $pageTarget,
                  });

                  if (this.hasMap) {
                    this.maps.push(
                      new Map_Map(
                        jquery_default()("[data-map]", $pageTarget)[0]
                      )
                    );
                  }
                }
              },
            },
          ]);

          return ContactbarStaticSection;
        })();

      // EXTERNAL MODULE: ./node_modules/masonry-layout/masonry.js
      var masonry = __webpack_require__(145);
      var masonry_default = /*#__PURE__*/ __webpack_require__.n(masonry);

      // EXTERNAL MODULE: ./node_modules/flickity/js/index.js
      var js = __webpack_require__(41);
      var js_default = /*#__PURE__*/ __webpack_require__.n(js);

      // CONCATENATED MODULE: ./source/scripts/snippets/BlogLayout.js
      function BlogLayout_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function BlogLayout_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function BlogLayout_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          BlogLayout_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) BlogLayout_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var BlogLayout_BlogLayout =
        /*#__PURE__*/
        (function () {
          function BlogLayout(el) {
            var options =
              arguments.length > 1 && arguments[1] !== undefined
                ? arguments[1]
                : {};

            BlogLayout_classCallCheck(this, BlogLayout);

            this.$el = jquery_default()(el);
            this.options = options;
            this.update = this.update.bind(this);
            Layout.onBreakpointChange(this.update);
            this.update();
          }

          BlogLayout_createClass(BlogLayout, [
            {
              key: "unload",
              value: function unload() {
                this._destroyMasonry();

                this._destroyFlickity();

                Layout.offBreakpointChange(this.update);
              },
            },
            {
              key: "update",
              value: function update() {
                // Use flickity at S and M breakpoints if enabled, otherwise use masonry
                var flickity =
                  Layout.isBreakpoint("S") ||
                  (Layout.isBreakpoint("M") && this.options.flickity);

                if (flickity) {
                  this._destroyMasonry();

                  this._initFlickity();
                } else {
                  this._destroyFlickity();

                  this._initMasonry();
                }
              },
            },
            {
              key: "_initMasonry",
              value: function _initMasonry() {
                var _this = this;

                if (!this.$el.length) return; // Just re-layout items

                if (this.masonry) {
                  this._destroyMasonry();
                } // Create new masonry grid

                this.masonry = new masonry_default.a(this.$el[0], {
                  columnWidth: "[data-article-excerpt-masonry-item-sizer]",
                  gutter: "[data-article-excerpt-masonry-gutter-sizer]",
                  itemSelector: "[data-article-excerpt]",
                  percentPosition: true,
                });
                this.masonry.layout();
                jquery_default()(
                  ".article-excerpt-image [data-rimg]",
                  this.$el
                ).on("rimg:load", function () {
                  _this.masonry.layout();
                });
              },
            },
            {
              key: "_destroyMasonry",
              value: function _destroyMasonry() {
                if (this.masonry) {
                  this.masonry.destroy();
                  this.masonry = null;
                } // Clear styles

                jquery_default()("[data-article-excerpt]", this.$el).attr(
                  "style",
                  ""
                );
              },
            },
            {
              key: "_initFlickity",
              value: function _initFlickity() {
                if (!this.options.flickity) return;
                if (!this.$el.length) return;

                if (this.flickity) {
                  this._destroyFlickity();
                }

                this.flickity = new js_default.a(this.$el[0], {
                  cellAlign: "left",
                  cellSelector: "[data-article-excerpt]",
                  contain: true,
                  prevNextButtons: false,
                  pageDots: false,
                });
              },
            },
            {
              key: "_destroyFlickity",
              value: function _destroyFlickity() {
                if (this.flickity) {
                  this.flickity.destroy();
                  this.flickity = null;
                } // Clear styles

                jquery_default()("[data-article-excerpt]", this.$el).attr(
                  "style",
                  ""
                );
              },
            },
          ]);

          return BlogLayout;
        })();

      // CONCATENATED MODULE: ./source/scripts/sections/DynamicBlogPosts.js
      function DynamicBlogPosts_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function DynamicBlogPosts_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function DynamicBlogPosts_createClass(
        Constructor,
        protoProps,
        staticProps
      ) {
        if (protoProps)
          DynamicBlogPosts_defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
          DynamicBlogPosts_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var DynamicBlogPosts_DynamicBlogPosts =
        /*#__PURE__*/
        (function () {
          function DynamicBlogPosts(section) {
            DynamicBlogPosts_classCallCheck(this, DynamicBlogPosts);

            this.$el = jquery_default()(section.el); // Articles

            this.$articles = jquery_default()(
              "[data-article-excerpts]",
              section.el
            );
            this.blogLayout = new BlogLayout_BlogLayout(this.$articles, {
              flickity: true,
            });
          }

          DynamicBlogPosts_createClass(DynamicBlogPosts, [
            {
              key: "onSectionUnload",
              value: function onSectionUnload() {
                this.blogLayout.unload();
              },
            },
          ]);

          return DynamicBlogPosts;
        })();

      // EXTERNAL MODULE: ./node_modules/shopify-currency-converter/dist/index.js
      var shopify_currency_converter_dist = __webpack_require__(7);
      var shopify_currency_converter_dist_default =
        /*#__PURE__*/ __webpack_require__.n(shopify_currency_converter_dist);

      // CONCATENATED MODULE: ./source/scripts/ProductOptions.js
      function _toConsumableArray(arr) {
        return (
          _arrayWithoutHoles(arr) ||
          _iterableToArray(arr) ||
          _nonIterableSpread()
        );
      }

      function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }

      function _iterableToArray(iter) {
        if (
          Symbol.iterator in Object(iter) ||
          Object.prototype.toString.call(iter) === "[object Arguments]"
        )
          return Array.from(iter);
      }

      function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) {
          for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
          }
          return arr2;
        }
      }

      function ProductOptions_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function ProductOptions_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function ProductOptions_createClass(
        Constructor,
        protoProps,
        staticProps
      ) {
        if (protoProps)
          ProductOptions_defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
          ProductOptions_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var ProductOptions_Node =
        /*#__PURE__*/
        (function () {
          function Node(variant) {
            ProductOptions_classCallCheck(this, Node);

            this.variant = variant;
            this.optionsCount = this.variant.options.length;
            this.neighbors = [];

            for (var i = 0; i < this.optionsCount; i++) {
              this.neighbors.push([]);
            }
          }

          ProductOptions_createClass(Node, [
            {
              key: "addNeighbor",
              value: function addNeighbor(variant) {
                for (var i = 0; i < this.optionsCount; i++) {
                  if (this.variant.options[i] !== variant.options[i]) {
                    this.neighbors[i].push(variant);
                    break;
                  }
                }
              },
            },
            {
              key: "getValidOptions",
              value: function getValidOptions() {
                var _this = this;

                var options = [];

                var _loop = function _loop(i) {
                  var variants = [_this.variant].concat(
                    _toConsumableArray(_this.neighbors[i])
                  );
                  options[i] = {};
                  variants.forEach(function (item) {
                    var variant = item;
                    var option = variant.options[i];
                    options[i][option] = {
                      available:
                        (options[i][option] && options[i][option].available) ||
                        variant.available,
                    };
                  });
                };

                for (var i = 0; i < this.optionsCount; i++) {
                  _loop(i);
                }

                return options;
              },
            },
          ]);

          return Node;
        })();

      var ProductOptions =
        /*#__PURE__*/
        (function () {
          function ProductOptions(product) {
            ProductOptions_classCallCheck(this, ProductOptions);

            this.productHandle = product.handle;
            this.optionsCount = product.options.length;
            this.variants = product.variants;
            this.nodeMap = {};

            this._generateNodeMap(product);
          }

          ProductOptions_createClass(ProductOptions, [
            {
              key: "_generateNodeMap",
              value: function _generateNodeMap() {
                var _this2 = this;

                this.variants.forEach(function (variant) {
                  _this2.nodeMap[variant.id] = new ProductOptions_Node(variant);

                  _this2.variants.forEach(function (variant2) {
                    _this2.nodeMap[variant.id].addNeighbor(variant2);
                  });
                });
              },
            },
            {
              key: "getVariantFromOptions",
              value: function getVariantFromOptions(options) {
                var variant = null;
                this.variants.forEach(function (potentialVariant) {
                  var found = true;

                  for (var i = 0; i < potentialVariant.options.length; i++) {
                    if (options[i] !== potentialVariant.options[i]) {
                      found = false;
                    }
                  }

                  if (found) {
                    variant = potentialVariant;
                  }
                });
                return variant || false;
              },
            },
            {
              key: "getClosestVariantFromOptions",
              value: function getClosestVariantFromOptions(options) {
                var closestVariant = null;
                var matchingValues = 0;
                this.variants.forEach(function (variant) {
                  var tempMatchingValues = 0;

                  for (var i = 0; i < variant.options.length; i++) {
                    if (options[i] === variant.options[i]) {
                      tempMatchingValues++;
                    } else {
                      break;
                    }
                  }

                  if (tempMatchingValues >= matchingValues) {
                    closestVariant = variant;
                    matchingValues = tempMatchingValues;
                  }
                });
                return closestVariant ? closestVariant : false;
              },
            },
            {
              key: "getVariantOrClosestFromOptions",
              value: function getVariantOrClosestFromOptions(options) {
                return (
                  this.getVariantFromOptions(options) ||
                  this.getClosestVariantFromOptions(options)
                );
              },
            },
            {
              key: "getAvailableOptionsFromVariant",
              value: function getAvailableOptionsFromVariant(variant) {
                return this.nodeMap[variant.id].getValidOptions();
              },
            },
          ]);

          return ProductOptions;
        })();

      // CONCATENATED MODULE: ./source/scripts/VariantHelper.js
      function VariantHelper_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function VariantHelper_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function VariantHelper_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          VariantHelper_defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
          VariantHelper_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var VariantHelper_VariantHelper =
        /*#__PURE__*/
        (function () {
          function VariantHelper(product, $variants, $options) {
            VariantHelper_classCallCheck(this, VariantHelper);

            this.product = product;
            this.optionsCount = this.product.options.length;
            this.$variants = $variants;
            this.$options = $options;
            this.productOptions = new ProductOptions(this.product);
            this.optionsTypes = {
              select: "select",
              radio: 'input[type="radio"]',
            };

            this._bindEvents();

            if (this.$options.is(this.optionsTypes.select)) {
              this.optionsType = this.optionsTypes.select;
            } else if (this.$options.is(this.optionsTypes.radio)) {
              this.optionsType = this.optionsTypes.radio;
            } else {
              console.warn("Variant helper: Option set is not a valid type");

              this._unbindEvents();
            }

            this._switchVariant(true);
          }

          VariantHelper_createClass(VariantHelper, [
            {
              key: "_bindEvents",
              value: function _bindEvents() {
                var _this = this;

                this.$options.on("change.variant-helper", function () {
                  return _this._switchVariant();
                });
              },
            },
            {
              key: "_unbindEvents",
              value: function _unbindEvents() {
                this.$options.off("change.variant-helper");
              },
            },
            {
              key: "_switchVariant",
              value: function _switchVariant() {
                var firstLoad =
                  arguments.length > 0 && arguments[0] !== undefined
                    ? arguments[0]
                    : false;
                var options = [];
                var product = this.product;
                var variant = null;
                var availableOptions = null;

                if (this.optionsType === this.optionsTypes.select) {
                  this.$options.each(function (i, option) {
                    options.push(option.value);
                  });
                } else if (this.optionsType === this.optionsTypes.radio) {
                  this.$options.filter(":checked").each(function (i, option) {
                    options.push(option.value);
                  });
                } else {
                  return;
                }

                variant =
                  this.productOptions.getVariantOrClosestFromOptions(options);

                if (variant) {
                  availableOptions =
                    this.productOptions.getAvailableOptionsFromVariant(variant);
                } else {
                  return;
                }

                if (this.optionsType === this.optionsTypes.select) {
                  this._switchVariantSelect(variant, availableOptions);
                } else if (this.optionsType === this.optionsTypes.radio) {
                  this._switchVariantRadio(variant, availableOptions);
                } else {
                  return;
                }

                this.$variants.val(variant.id); // This function can be used by the event handler to determine if this
                // VariantHelper instance handles a specific product instance

                var isProduct = function isProduct(compareProduct) {
                  return compareProduct === product;
                };

                jquery_default()(window).trigger("product-variant-switch", {
                  product: product,
                  variant: variant,
                  firstLoad: firstLoad,
                  isProduct: isProduct,
                });
              },
            },
            {
              key: "_switchVariantSelect",
              value: function _switchVariantSelect(variant, availableOptions) {
                var _this2 = this;

                var _loop = function _loop(i) {
                  // Corresponding select dropdown
                  var $select = jquery_default()(_this2.$options[i]);
                  var $optionEls = $select.find("option"); // Iterate over each option on dropdown

                  $optionEls.each(function (index, option) {
                    var $option = jquery_default()(option);
                    var value = option.value; // Not an available option

                    $option
                      .prop(
                        "disabled",
                        !availableOptions[i][value] ||
                          !availableOptions[i][value].available
                      )
                      .prop("selected", false); // Dropdown option matches variant option

                    if (variant.options[i] === value) {
                      $option.prop("disabled", false).prop("selected", true);
                    }
                  });
                };

                // Iterate over each option type
                for (var i = 0; i < this.product.options.length; i++) {
                  _loop(i);
                }
              },
            },
            {
              key: "_switchVariantRadio",
              value: function _switchVariantRadio(variant, availableOptions) {
                var _this3 = this;

                this.$options
                  .attr("disabled", true)
                  .prop("checked", false)
                  .attr("data-soldout", false);

                var _loop2 = function _loop2(i) {
                  var selector = encodeURIComponent(_this3.product.options[i])
                    .replace(/%20/g, "+")
                    .replace(/[!'()*]/g, function (char) {
                      return (
                        "%" + char.charCodeAt(0).toString(16).toUpperCase()
                      );
                    });

                  var $options = _this3.$options.filter(
                    '[name="'.concat(selector, '"]')
                  );

                  $options.each(function (index, option) {
                    var $option = jquery_default()(option);

                    if (variant.options[i] === $option.val()) {
                      $option.prop("checked", true);
                    }

                    if (availableOptions[i][$option.val()]) {
                      $option.attr("disabled", false);

                      if (!availableOptions[i][$option.val()].available) {
                        $option.attr("disabled", true);
                        $option.attr("data-soldout", true);
                      }
                    }
                  });
                };

                for (var i = 0; i < this.product.options.length; i++) {
                  _loop2(i);
                }
              },
            },
            {
              key: "isDefault",
              value: function isDefault() {
                if (
                  this.product.variants[0].title === "Default Title" &&
                  this.product.variants[0].option1 === "Default Title"
                ) {
                  return true;
                }

                return false;
              },
            },
            {
              key: "hasSingleOption",
              value: function hasSingleOption() {
                return this.optionsCount === 1;
              },
            },
            {
              key: "getSelectedVariant",
              value: function getSelectedVariant() {
                if (this.isDefault()) {
                  return this.product.variants[0];
                }

                var options = [];

                if (this.optionsType === this.optionsTypes.select) {
                  this.$options.each(function (i, option) {
                    options.push(option.value);
                  });
                } else if (this.optionsType === this.optionsTypes.radio) {
                  this.$options.filter(":checked").each(function (i, option) {
                    options.push(option.value);
                  });
                } else {
                  return null;
                }

                return this.productOptions.getVariantFromOptions(options);
              },
            },
            {
              key: "unload",
              value: function unload() {
                this._unbindEvents();
              },
            },
          ]);

          return VariantHelper;
        })();

      // CONCATENATED MODULE: ./source/scripts/snippets/Quantity.js
      function Quantity_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function Quantity_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function Quantity_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          Quantity_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Quantity_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var Quantity_Quantity =
        /*#__PURE__*/
        (function () {
          function Quantity(el) {
            var _this = this;

            Quantity_classCallCheck(this, Quantity);

            this.$el = jquery_default()(el);
            this.$input = this.$el.find("[data-quantity-input]");
            this.$decrement = this.$el.find("[data-quantity-decrement]");
            this.$increment = this.$el.find("[data-quantity-increment]");
            this.events = [
              this.$input.on("change.quantity", function (event) {
                return _this.change(_this.value);
              }),
              this.$decrement.on("click.quantity", function (event) {
                var Uid = $(this).closest("article").attr("data-bundle-id");
                if (Uid) {
                  var $this = $(this)
                    .closest("[data-quantity]")
                    .find("[data-quantity-input]");
                  var finalQty;
                  jquery_default.a
                    .ajax({
                      type: "GET",
                      url: "/cart.js",
                      dataType: "json",
                    })
                    .done(function (response) {
                      let $total = response.item_count;
                      let ProductArray = [];
                      $(response.items).each(function (index, item) {
                        if (
                          item.properties != undefined &&
                          item.properties._bundle_id != undefined
                        ) {
                          var RadomNo = item.properties["_bundle_id"];
                          var itemKey = item.key;
                          if (Uid == RadomNo) {
                            finalQty = item.quantity - 1;
                            $total--;
                            ProductArray.push(finalQty);
                          } else {
                            ProductArray.push(item.quantity);
                          }
                        } else {
                          ProductArray.push(item.quantity);
                        }
                      });
                      jQuery.post("/cart/update.js", { updates: ProductArray });
                      // console.log(36380);
                      $this.val(finalQty);
                      setTimeout(function () {
                        $(".header-minicart-slideout-dismiss").trigger("click");
                      }, 200);
                    });
                  //   over
                } else {
                  return _this.change(_this.value - 1);
                }
              }),
              this.$increment.on("click.quantity", function (event) {
                var Uid = $(this).closest("article").attr("data-bundle-id");

                if (Uid) {
                  var $this = $(this)
                    .closest("[data-quantity]")
                    .find("[data-quantity-input]");
                  var finalQty;
                  jquery_default.a
                    .ajax({
                      type: "GET",
                      url: "/cart.js",
                      dataType: "json",
                    })
                    .done(function (response) {
                      let ProductArray = [];
                      $(response.items).each(function (index, item) {
                        if (
                          item.properties != undefined &&
                          item.properties._bundle_id != undefined
                        ) {
                          var RadomNo = item.properties["_bundle_id"];
                          var itemKey = item.key;
                          if (Uid == RadomNo) {
                            finalQty = item.quantity + 1;
                            ProductArray.push(finalQty);
                          } else {
                            ProductArray.push(item.quantity);
                          }
                        } else {
                          ProductArray.push(item.quantity);
                        }
                      });
                      jQuery.post("/cart/update.js", { updates: ProductArray });
                      // console.log(36425);
                      $this.val(finalQty);
                    });
                } else {
                  return _this.change(_this.value + 1);
                }
              }),
            ];

            this._updateButtonState();
          }

          Quantity_createClass(Quantity, [
            {
              key: "unload",
              value: function unload() {
                this.events.forEach(function ($el) {
                  return $el.off(".quantity");
                });
              },
            },
            {
              key: "change",
              value: function change(value) {
                var trigger =
                  arguments.length > 1 && arguments[1] !== undefined
                    ? arguments[1]
                    : true;
                var range = this.range;
                var currentValue = this.value;

                if (value > range.max) {
                  value = range.max;
                }

                if (value < range.min) {
                  value = range.min;
                }

                if (value !== currentValue) {
                  this.$input.val(value);
                }

                if (trigger && value !== currentValue) {
                  var event = document.createEvent("Event");
                  event.initEvent("change", true, true);
                  this.input.dispatchEvent(event);
                }

                this._updateButtonState();
              },
            },
            {
              key: "_updateButtonState",
              value: function _updateButtonState() {
                var value = this.value;
                var range = this.range;

                this.$decrement.prop("disabled", value <= range.min);
                this.$increment.prop("disabled", value >= range.max);
              },
            },
            {
              key: "input",
              get: function get() {
                return this.$input.get(0);
              },
            },
            {
              key: "value",
              get: function get() {
                return parseInt(this.$input.val(), 10) || 0;
              },
            },
            {
              key: "range",
              get: function get() {
                var min = parseInt(this.$input.attr("min"), 10) || 0;
                var max = parseInt(this.$input.attr("max"), 10) || Infinity;
                return {
                  min: min,
                  max: max,
                };
              },
            },
          ]);

          return Quantity;
        })();

      // CONCATENATED MODULE: ./source/scripts/snippets/ProductForm.js
      function ProductForm_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function ProductForm_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function ProductForm_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          ProductForm_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) ProductForm_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var ProductForm_ProductForm =
        /*#__PURE__*/
        (function () {
          /**
           *
           * @param {Element} el
           * @param {Object} options
           * @param {Object} options.container
           * @param {Object} options.product
           * @param {String} options.moneyFormat
           * @param {Function} options.onAddToCart
           * @param {Function} options.onSuccess
           * @param {Function} options.onError
           * @param {Function} options.onVariantChange
           * @param {Function} options.onQuantityChange
           * @param {Function} options.postMessage
           */
          function ProductForm(el) {
            var _this = this;

            var options =
              arguments.length > 1 && arguments[1] !== undefined
                ? arguments[1]
                : {};

            ProductForm_classCallCheck(this, ProductForm);

            this.$el = jquery_default()(options.container || el);
            this.$form = jquery_default()(options.form || el);
            this.options = options;
            this.product = options.product;
            this.postMessage = this.options.postMessage; // History

            this.isThemeEditor = window.Shopify && window.Shopify.designMode;
            this.useHistory =
              options.useHistory &&
              !this.isThemeEditor &&
              window.history &&
              history.replaceState; // Options

            this.$atc = this.$el.find("[data-product-atc]");
            this.$options = this.$el.find("[data-product-option]");
            this.$variants = this.$el.find("[data-variants]");
            this.variantHelper = new VariantHelper_VariantHelper(
              this.options.product,
              this.$variants,
              this.$options
            ); // Quantity

            this.quantity = new Quantity_Quantity(
              this.$el.find("[data-quantity]")
            ); // Events

            this.events = [
              // ATC
              this.$atc.on("click.product-form", function (event) {
                if (_this.options.enableCartRedirection) {
                  _this.$form.submit();

                  return;
                }

                event.preventDefault();

                _this._addToCart();
              }), // Switch variant
              jquery_default()(window).on(
                "product-variant-switch.product-form-".concat(this.product.id),
                function (event, data) {
                  _this._changeVariant(data);
                }
              ), // Change quantity
              jquery_default()(this.quantity.input).on(
                "change.product-form",
                function (event) {
                  if (_this.options.onQuantityChange) {
                    _this.options.onQuantityChange(
                      _this.variantHelper.getSelectedVariant(),
                      _this.quantity.value
                    );
                  }
                }
              ),
            ];
          }

          ProductForm_createClass(ProductForm, [
            {
              key: "unload",
              value: function unload() {
                var _this2 = this;

                this.events.forEach(function ($el) {
                  return $el.off(".product-form-".concat(_this2.product.id));
                });
                this.quantity.unload();
                this.variantHelper.unload();
              },
            },
            {
              key: "_changeVariant",
              value: function _changeVariant(data) {
                if (data.firstLoad || this.product !== data.product) {
                  return;
                }

                var variant = data.variant;
                var format = this.options.moneyFormat; // Update currency

                this._updateCurrency(variant, format); // Update URL
                this._changeUrl(variant); // Form-specific updates
                if (this.options.onVariantChange) {
                  this.options.onVariantChange(variant);
                }
              },
            },
            {
              key: "_changeUrl",
              value: function _changeUrl(variant) {
                if (!this.useHistory) {
                  return;
                }

                var params = jquery_default.a.param({
                  variant: variant.id,
                });
                var url = ""
                  .concat(this.options.product.handle, "?")
                  .concat(params);
                history.replaceState({}, "variant", url);
              },
            },
            {
              key: "_addToCart",
              value: function _addToCart() {
                var _this3 = this;

                if (this.options.onAddToCart) {
                  this.options.onAddToCart();
                }

                jquery_default.a
                  .ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: this.$form.serialize(),
                    dataType: "json",
                  }) // On success
                  .done(function (response) {
                    $("[data-product-atc]").removeClass("loading");
                  }) // On failure
                  .fail(function (response) {
                    if (_this3.options.onError) {
                      var responseText = {};

                      try {
                        responseText = JSON.parse(response.responseText);
                      } catch (error) {
                        responseText.description =
                          "We couldn't add that your cart but we're not sure why. Is your connection working?";
                      }

                      var error = responseText.description;

                      _this3.options.onError(response, error);
                    }
                  });
              },
            },
            {
              key: "_updateCart",
              value: function _updateCart() {
                var _this4 = this;

                jquery_default.a
                  .ajax({
                    type: "GET",
                    url: "/cart.js",
                    dataType: "json",
                  })
                  .done(function (response) {
                    _this4.postMessage("product:add-to-cart", {
                      response: response,
                    });
                  });
              },
            },
            {
              key: "_updateCurrency",
              value: function _updateCurrency(variant, format) {
                // Compare at price
                this.$el
                  .find("[data-variant-compare-at-price]")
                  .toggleClass(
                    "money-compare-at-hidden",
                    !variant.compare_at_price ||
                      variant.price === variant.compare_at_price
                  )
                  .text(Shopify.formatMoney(variant.compare_at_price, format))
                  .each(function (index, el) {
                    return shopify_currency_converter_dist_default.a.update(el);
                  }); // Price

                this.$el
                  .find("[data-variant-price]")
                  .text(Shopify.formatMoney(variant.price, format))
                  .each(function (index, el) {
                    return shopify_currency_converter_dist_default.a.update(el);
                  });
              },
            },
          ]);

          return ProductForm;
        })();

      // CONCATENATED MODULE: ./node_modules/shopify-asyncview/dist/index.es.js

      /*!
       * shopify-asyncview v1.0.2
       * (c) 2019 Pixel Union
       */

      var index_es_classCallCheck = function (instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      };

      var createClass = (function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      })();

      var index_es_deferred = {};

      var AsyncView = (function () {
        function AsyncView() {
          index_es_classCallCheck(this, AsyncView);
        }

        createClass(AsyncView, null, [
          {
            key: "load",

            /**
             * Load the template given by the provided URL into the provided
             * view
             *
             * @param {string} url - The url to load.
             * @param {string} view - The view to load into.
             * @param {object} options - Config options.
             * @param {string} options.hash - A hash of the current page content.
             */
            value: function load(url, view) {
              var options =
                arguments.length > 2 && arguments[2] !== undefined
                  ? arguments[2]
                  : {};

              var data = void 0;
              if (url in index_es_deferred) {
                return index_es_deferred[url];
              }

              var $deferred = $.Deferred();

              index_es_deferred[url] = $deferred;

              if (options.hash) {
                data = sessionStorage.getItem(url);

                if (data) {
                  var deserialized = JSON.parse(data);

                  if (options.hash === deserialized.options.hash) {
                    delete index_es_deferred[url];
                    return $deferred.resolve(deserialized).promise();
                  }
                }
              }

              // NOTE The $.ajax request has the cache option set to false.
              // This is to prevent certain browsers from returning cached
              // versions of the url we are requesting.
              // See this PR for more info: https://github.com/pixelunion/shopify-asyncview/pull/4
              $.ajax({
                url: url,
                cache: false,
                data: "view=" + view,
                dataType: "html",
                headers: {
                  "cache-control": "no-cache",
                },
                success: function success(response) {
                  var el = document.createElement("div");
                  el.innerHTML = response;

                  var responseOptions = {};
                  var optionsEl = el.querySelector("[data-options]");

                  if (optionsEl && optionsEl.innerHTML) {
                    responseOptions = JSON.parse(
                      el.querySelector("[data-options]").innerHTML
                    );
                  }

                  var htmls = el.querySelectorAll("[data-html]");

                  var html = {};

                  if (
                    htmls.length === 1 &&
                    htmls[0].getAttribute("data-html") === ""
                  ) {
                    html = htmls[0].innerHTML;
                  } else {
                    for (var i = 0; i < htmls.length; i++) {
                      html[htmls[i].getAttribute("data-html")] =
                        htmls[i].innerHTML;
                    }
                  }

                  if (options.hash) {
                    try {
                      sessionStorage.setItem(
                        url,
                        JSON.stringify({ options: responseOptions, html: html })
                      );
                    } catch (error) {
                      console.error(error);
                    }
                  }

                  delete index_es_deferred[url];
                  return $deferred.resolve({
                    options: responseOptions,
                    html: html,
                  });
                },
                error: function error() {
                  delete index_es_deferred[url];
                  return $deferred.reject();
                },
              });

              return $deferred.promise();
            },
          },
        ]);
        return AsyncView;
      })();

      /* harmony default export */ var shopify_asyncview_dist_index_es =
        AsyncView;

      // CONCATENATED MODULE: ./node_modules/morphdom/dist/morphdom-esm.js
      function morphAttrs(fromNode, toNode) {
        var attrs = toNode.attributes;
        var i;
        var attr;
        var attrName;
        var attrNamespaceURI;
        var attrValue;
        var fromValue;

        // update attributes on original DOM element
        for (i = attrs.length - 1; i >= 0; --i) {
          attr = attrs[i];
          attrName = attr.name;
          attrNamespaceURI = attr.namespaceURI;
          attrValue = attr.value;

          if (attrNamespaceURI) {
            attrName = attr.localName || attrName;
            fromValue = fromNode.getAttributeNS(attrNamespaceURI, attrName);

            if (fromValue !== attrValue) {
              fromNode.setAttributeNS(attrNamespaceURI, attrName, attrValue);
            }
          } else {
            fromValue = fromNode.getAttribute(attrName);

            if (fromValue !== attrValue) {
              fromNode.setAttribute(attrName, attrValue);
            }
          }
        }

        // Remove any extra attributes found on the original DOM element that
        // weren't found on the target element.
        attrs = fromNode.attributes;

        for (i = attrs.length - 1; i >= 0; --i) {
          attr = attrs[i];
          if (attr.specified !== false) {
            attrName = attr.name;
            attrNamespaceURI = attr.namespaceURI;

            if (attrNamespaceURI) {
              attrName = attr.localName || attrName;

              if (!toNode.hasAttributeNS(attrNamespaceURI, attrName)) {
                fromNode.removeAttributeNS(attrNamespaceURI, attrName);
              }
            } else {
              if (!toNode.hasAttribute(attrName)) {
                fromNode.removeAttribute(attrName);
              }
            }
          }
        }
      }

      var range; // Create a range object for efficently rendering strings to elements.
      var NS_XHTML = "http://www.w3.org/1999/xhtml";

      var doc = typeof document === "undefined" ? undefined : document;

      /**
       * This is about the same
       * var html = new DOMParser().parseFromString(str, 'text/html');
       * return html.body.firstChild;
       *
       * @method toElement
       * @param {String} str
       */
      function toElement(str) {
        if (!range && doc.createRange) {
          range = doc.createRange();
          range.selectNode(doc.body);
        }

        var fragment;
        if (range && range.createContextualFragment) {
          fragment = range.createContextualFragment(str);
        } else {
          fragment = doc.createElement("body");
          fragment.innerHTML = str;
        }
        return fragment.childNodes[0];
      }

      /**
       * Returns true if two node's names are the same.
       *
       * NOTE: We don't bother checking `namespaceURI` because you will never find two HTML elements with the same
       *       nodeName and different namespace URIs.
       *
       * @param {Element} a
       * @param {Element} b The target element
       * @return {boolean}
       */
      function compareNodeNames(fromEl, toEl) {
        var fromNodeName = fromEl.nodeName;
        var toNodeName = toEl.nodeName;

        if (fromNodeName === toNodeName) {
          return true;
        }

        if (
          toEl.actualize &&
          fromNodeName.charCodeAt(0) < 91 /* from tag name is upper case */ &&
          toNodeName.charCodeAt(0) > 90 /* target tag name is lower case */
        ) {
          // If the target element is a virtual DOM node then we may need to normalize the tag name
          // before comparing. Normal HTML elements that are in the "http://www.w3.org/1999/xhtml"
          // are converted to upper case
          return fromNodeName === toNodeName.toUpperCase();
        } else {
          return false;
        }
      }

      /**
       * Create an element, optionally with a known namespace URI.
       *
       * @param {string} name the element name, e.g. 'div' or 'svg'
       * @param {string} [namespaceURI] the element's namespace URI, i.e. the value of
       * its `xmlns` attribute or its inferred namespace.
       *
       * @return {Element}
       */
      function createElementNS(name, namespaceURI) {
        return !namespaceURI || namespaceURI === NS_XHTML
          ? doc.createElement(name)
          : doc.createElementNS(namespaceURI, name);
      }

      /**
       * Copies the children of one DOM element to another DOM element
       */
      function moveChildren(fromEl, toEl) {
        var curChild = fromEl.firstChild;
        while (curChild) {
          var nextChild = curChild.nextSibling;
          toEl.appendChild(curChild);
          curChild = nextChild;
        }
        return toEl;
      }

      function syncBooleanAttrProp(fromEl, toEl, name) {
        if (fromEl[name] !== toEl[name]) {
          fromEl[name] = toEl[name];
          if (fromEl[name]) {
            fromEl.setAttribute(name, "");
          } else {
            fromEl.removeAttribute(name);
          }
        }
      }

      var specialElHandlers = {
        OPTION: function (fromEl, toEl) {
          var parentNode = fromEl.parentNode;
          if (parentNode) {
            var parentName = parentNode.nodeName.toUpperCase();
            if (parentName === "OPTGROUP") {
              parentNode = parentNode.parentNode;
              parentName = parentNode && parentNode.nodeName.toUpperCase();
            }
            if (
              parentName === "SELECT" &&
              !parentNode.hasAttribute("multiple")
            ) {
              if (fromEl.hasAttribute("selected") && !toEl.selected) {
                // Workaround for MS Edge bug where the 'selected' attribute can only be
                // removed if set to a non-empty value:
                // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12087679/
                fromEl.setAttribute("selected", "selected");
                fromEl.removeAttribute("selected");
              }
              // We have to reset select element's selectedIndex to -1, otherwise setting
              // fromEl.selected using the syncBooleanAttrProp below has no effect.
              // The correct selectedIndex will be set in the SELECT special handler below.
              parentNode.selectedIndex = -1;
            }
          }
          syncBooleanAttrProp(fromEl, toEl, "selected");
        },
        /**
         * The "value" attribute is special for the <input> element since it sets
         * the initial value. Changing the "value" attribute without changing the
         * "value" property will have no effect since it is only used to the set the
         * initial value.  Similar for the "checked" attribute, and "disabled".
         */
        INPUT: function (fromEl, toEl) {
          syncBooleanAttrProp(fromEl, toEl, "checked");
          syncBooleanAttrProp(fromEl, toEl, "disabled");

          if (fromEl.value !== toEl.value) {
            fromEl.value = toEl.value;
          }

          if (!toEl.hasAttribute("value")) {
            fromEl.removeAttribute("value");
          }
        },

        TEXTAREA: function (fromEl, toEl) {
          var newValue = toEl.value;
          if (fromEl.value !== newValue) {
            fromEl.value = newValue;
          }

          var firstChild = fromEl.firstChild;
          if (firstChild) {
            // Needed for IE. Apparently IE sets the placeholder as the
            // node value and vise versa. This ignores an empty update.
            var oldValue = firstChild.nodeValue;

            if (
              oldValue == newValue ||
              (!newValue && oldValue == fromEl.placeholder)
            ) {
              return;
            }

            firstChild.nodeValue = newValue;
          }
        },
        SELECT: function (fromEl, toEl) {
          if (!toEl.hasAttribute("multiple")) {
            var selectedIndex = -1;
            var i = 0;
            // We have to loop through children of fromEl, not toEl since nodes can be moved
            // from toEl to fromEl directly when morphing.
            // At the time this special handler is invoked, all children have already been morphed
            // and appended to / removed from fromEl, so using fromEl here is safe and correct.
            var curChild = fromEl.firstChild;
            var optgroup;
            var nodeName;
            while (curChild) {
              nodeName = curChild.nodeName && curChild.nodeName.toUpperCase();
              if (nodeName === "OPTGROUP") {
                optgroup = curChild;
                curChild = optgroup.firstChild;
              } else {
                if (nodeName === "OPTION") {
                  if (curChild.hasAttribute("selected")) {
                    selectedIndex = i;
                    break;
                  }
                  i++;
                }
                curChild = curChild.nextSibling;
                if (!curChild && optgroup) {
                  curChild = optgroup.nextSibling;
                  optgroup = null;
                }
              }
            }

            fromEl.selectedIndex = selectedIndex;
          }
        },
      };

      var ELEMENT_NODE = 1;
      var DOCUMENT_FRAGMENT_NODE = 11;
      var TEXT_NODE = 3;
      var COMMENT_NODE = 8;

      function noop() {}

      function defaultGetNodeKey(node) {
        return node.id;
      }

      function morphdomFactory(morphAttrs) {
        return function morphdom(fromNode, toNode, options) {
          if (!options) {
            options = {};
          }

          if (typeof toNode === "string") {
            if (
              fromNode.nodeName === "#document" ||
              fromNode.nodeName === "HTML"
            ) {
              var toNodeHtml = toNode;
              toNode = doc.createElement("html");
              toNode.innerHTML = toNodeHtml;
            } else {
              toNode = toElement(toNode);
            }
          }

          var getNodeKey = options.getNodeKey || defaultGetNodeKey;
          var onBeforeNodeAdded = options.onBeforeNodeAdded || noop;
          var onNodeAdded = options.onNodeAdded || noop;
          var onBeforeElUpdated = options.onBeforeElUpdated || noop;
          var onElUpdated = options.onElUpdated || noop;
          var onBeforeNodeDiscarded = options.onBeforeNodeDiscarded || noop;
          var onNodeDiscarded = options.onNodeDiscarded || noop;
          var onBeforeElChildrenUpdated =
            options.onBeforeElChildrenUpdated || noop;
          var childrenOnly = options.childrenOnly === true;

          // This object is used as a lookup to quickly find all keyed elements in the original DOM tree.
          var fromNodesLookup = {};
          var keyedRemovalList;

          function addKeyedRemoval(key) {
            if (keyedRemovalList) {
              keyedRemovalList.push(key);
            } else {
              keyedRemovalList = [key];
            }
          }

          function walkDiscardedChildNodes(node, skipKeyedNodes) {
            if (node.nodeType === ELEMENT_NODE) {
              var curChild = node.firstChild;
              while (curChild) {
                var key = undefined;

                if (skipKeyedNodes && (key = getNodeKey(curChild))) {
                  // If we are skipping keyed nodes then we add the key
                  // to a list so that it can be handled at the very end.
                  addKeyedRemoval(key);
                } else {
                  // Only report the node as discarded if it is not keyed. We do this because
                  // at the end we loop through all keyed elements that were unmatched
                  // and then discard them in one final pass.
                  onNodeDiscarded(curChild);
                  if (curChild.firstChild) {
                    walkDiscardedChildNodes(curChild, skipKeyedNodes);
                  }
                }

                curChild = curChild.nextSibling;
              }
            }
          }

          /**
           * Removes a DOM node out of the original DOM
           *
           * @param  {Node} node The node to remove
           * @param  {Node} parentNode The nodes parent
           * @param  {Boolean} skipKeyedNodes If true then elements with keys will be skipped and not discarded.
           * @return {undefined}
           */
          function removeNode(node, parentNode, skipKeyedNodes) {
            if (onBeforeNodeDiscarded(node) === false) {
              return;
            }

            if (parentNode) {
              parentNode.removeChild(node);
            }

            onNodeDiscarded(node);
            walkDiscardedChildNodes(node, skipKeyedNodes);
          }

          // // TreeWalker implementation is no faster, but keeping this around in case this changes in the future
          // function indexTree(root) {
          //     var treeWalker = document.createTreeWalker(
          //         root,
          //         NodeFilter.SHOW_ELEMENT);
          //
          //     var el;
          //     while((el = treeWalker.nextNode())) {
          //         var key = getNodeKey(el);
          //         if (key) {
          //             fromNodesLookup[key] = el;
          //         }
          //     }
          // }

          // // NodeIterator implementation is no faster, but keeping this around in case this changes in the future
          //
          // function indexTree(node) {
          //     var nodeIterator = document.createNodeIterator(node, NodeFilter.SHOW_ELEMENT);
          //     var el;
          //     while((el = nodeIterator.nextNode())) {
          //         var key = getNodeKey(el);
          //         if (key) {
          //             fromNodesLookup[key] = el;
          //         }
          //     }
          // }

          function indexTree(node) {
            if (
              node.nodeType === ELEMENT_NODE ||
              node.nodeType === DOCUMENT_FRAGMENT_NODE
            ) {
              var curChild = node.firstChild;
              while (curChild) {
                var key = getNodeKey(curChild);
                if (key) {
                  fromNodesLookup[key] = curChild;
                }

                // Walk recursively
                indexTree(curChild);

                curChild = curChild.nextSibling;
              }
            }
          }

          indexTree(fromNode);

          function handleNodeAdded(el) {
            onNodeAdded(el);

            var curChild = el.firstChild;
            while (curChild) {
              var nextSibling = curChild.nextSibling;

              var key = getNodeKey(curChild);
              if (key) {
                var unmatchedFromEl = fromNodesLookup[key];
                if (
                  unmatchedFromEl &&
                  compareNodeNames(curChild, unmatchedFromEl)
                ) {
                  curChild.parentNode.replaceChild(unmatchedFromEl, curChild);
                  morphEl(unmatchedFromEl, curChild);
                }
              }

              handleNodeAdded(curChild);
              curChild = nextSibling;
            }
          }

          function cleanupFromEl(fromEl, curFromNodeChild, curFromNodeKey) {
            // We have processed all of the "to nodes". If curFromNodeChild is
            // non-null then we still have some from nodes left over that need
            // to be removed
            while (curFromNodeChild) {
              var fromNextSibling = curFromNodeChild.nextSibling;
              if ((curFromNodeKey = getNodeKey(curFromNodeChild))) {
                // Since the node is keyed it might be matched up later so we defer
                // the actual removal to later
                addKeyedRemoval(curFromNodeKey);
              } else {
                // NOTE: we skip nested keyed nodes from being removed since there is
                //       still a chance they will be matched up later
                removeNode(
                  curFromNodeChild,
                  fromEl,
                  true /* skip keyed nodes */
                );
              }
              curFromNodeChild = fromNextSibling;
            }
          }

          function morphEl(fromEl, toEl, childrenOnly) {
            var toElKey = getNodeKey(toEl);

            if (toElKey) {
              // If an element with an ID is being morphed then it will be in the final
              // DOM so clear it out of the saved elements collection
              delete fromNodesLookup[toElKey];
            }

            if (toNode.isSameNode && toNode.isSameNode(fromNode)) {
              return;
            }

            if (!childrenOnly) {
              // optional
              if (onBeforeElUpdated(fromEl, toEl) === false) {
                return;
              }

              // update attributes on original DOM element first
              morphAttrs(fromEl, toEl);
              // optional
              onElUpdated(fromEl);

              if (onBeforeElChildrenUpdated(fromEl, toEl) === false) {
                return;
              }
            }
            if (fromEl.nodeName !== "TEXTAREA") {
              morphChildren(fromEl, toEl);
            } else {
              specialElHandlers.TEXTAREA(fromEl, toEl);
            }
          }

          function morphChildren(fromEl, toEl) {
            var curToNodeChild = toEl.firstChild;
            var curFromNodeChild = fromEl.firstChild;
            var curToNodeKey;
            var curFromNodeKey;

            var fromNextSibling;
            var toNextSibling;
            var matchingFromEl;

            // walk the children
            outer: while (curToNodeChild) {
              toNextSibling = curToNodeChild.nextSibling;
              curToNodeKey = getNodeKey(curToNodeChild);

              // walk the fromNode children all the way through
              while (curFromNodeChild) {
                fromNextSibling = curFromNodeChild.nextSibling;

                if (
                  curToNodeChild.isSameNode &&
                  curToNodeChild.isSameNode(curFromNodeChild)
                ) {
                  curToNodeChild = toNextSibling;
                  curFromNodeChild = fromNextSibling;
                  continue outer;
                }

                curFromNodeKey = getNodeKey(curFromNodeChild);

                var curFromNodeType = curFromNodeChild.nodeType;

                // this means if the curFromNodeChild doesnt have a match with the curToNodeChild
                var isCompatible = undefined;

                if (curFromNodeType === curToNodeChild.nodeType) {
                  if (curFromNodeType === ELEMENT_NODE) {
                    // Both nodes being compared are Element nodes

                    if (curToNodeKey) {
                      // The target node has a key so we want to match it up with the correct element
                      // in the original DOM tree
                      if (curToNodeKey !== curFromNodeKey) {
                        // The current element in the original DOM tree does not have a matching key so
                        // let's check our lookup to see if there is a matching element in the original
                        // DOM tree
                        if ((matchingFromEl = fromNodesLookup[curToNodeKey])) {
                          if (fromNextSibling === matchingFromEl) {
                            // Special case for single element removals. To avoid removing the original
                            // DOM node out of the tree (since that can break CSS transitions, etc.),
                            // we will instead discard the current node and wait until the next
                            // iteration to properly match up the keyed target element with its matching
                            // element in the original tree
                            isCompatible = false;
                          } else {
                            // We found a matching keyed element somewhere in the original DOM tree.
                            // Let's move the original DOM node into the current position and morph
                            // it.

                            // NOTE: We use insertBefore instead of replaceChild because we want to go through
                            // the `removeNode()` function for the node that is being discarded so that
                            // all lifecycle hooks are correctly invoked
                            fromEl.insertBefore(
                              matchingFromEl,
                              curFromNodeChild
                            );

                            // fromNextSibling = curFromNodeChild.nextSibling;

                            if (curFromNodeKey) {
                              // Since the node is keyed it might be matched up later so we defer
                              // the actual removal to later
                              addKeyedRemoval(curFromNodeKey);
                            } else {
                              // NOTE: we skip nested keyed nodes from being removed since there is
                              //       still a chance they will be matched up later
                              removeNode(
                                curFromNodeChild,
                                fromEl,
                                true /* skip keyed nodes */
                              );
                            }

                            curFromNodeChild = matchingFromEl;
                          }
                        } else {
                          // The nodes are not compatible since the "to" node has a key and there
                          // is no matching keyed node in the source tree
                          isCompatible = false;
                        }
                      }
                    } else if (curFromNodeKey) {
                      // The original has a key
                      isCompatible = false;
                    }

                    isCompatible =
                      isCompatible !== false &&
                      compareNodeNames(curFromNodeChild, curToNodeChild);
                    if (isCompatible) {
                      // We found compatible DOM elements so transform
                      // the current "from" node to match the current
                      // target DOM node.
                      // MORPH
                      morphEl(curFromNodeChild, curToNodeChild);
                    }
                  } else if (
                    curFromNodeType === TEXT_NODE ||
                    curFromNodeType == COMMENT_NODE
                  ) {
                    // Both nodes being compared are Text or Comment nodes
                    isCompatible = true;
                    // Simply update nodeValue on the original node to
                    // change the text value
                    if (
                      curFromNodeChild.nodeValue !== curToNodeChild.nodeValue
                    ) {
                      curFromNodeChild.nodeValue = curToNodeChild.nodeValue;
                    }
                  }
                }

                if (isCompatible) {
                  // Advance both the "to" child and the "from" child since we found a match
                  // Nothing else to do as we already recursively called morphChildren above
                  curToNodeChild = toNextSibling;
                  curFromNodeChild = fromNextSibling;
                  continue outer;
                }

                // No compatible match so remove the old node from the DOM and continue trying to find a
                // match in the original DOM. However, we only do this if the from node is not keyed
                // since it is possible that a keyed node might match up with a node somewhere else in the
                // target tree and we don't want to discard it just yet since it still might find a
                // home in the final DOM tree. After everything is done we will remove any keyed nodes
                // that didn't find a home
                if (curFromNodeKey) {
                  // Since the node is keyed it might be matched up later so we defer
                  // the actual removal to later
                  addKeyedRemoval(curFromNodeKey);
                } else {
                  // NOTE: we skip nested keyed nodes from being removed since there is
                  //       still a chance they will be matched up later
                  removeNode(
                    curFromNodeChild,
                    fromEl,
                    true /* skip keyed nodes */
                  );
                }

                curFromNodeChild = fromNextSibling;
              } // END: while(curFromNodeChild) {}

              // If we got this far then we did not find a candidate match for
              // our "to node" and we exhausted all of the children "from"
              // nodes. Therefore, we will just append the current "to" node
              // to the end
              if (
                curToNodeKey &&
                (matchingFromEl = fromNodesLookup[curToNodeKey]) &&
                compareNodeNames(matchingFromEl, curToNodeChild)
              ) {
                fromEl.appendChild(matchingFromEl);
                // MORPH
                morphEl(matchingFromEl, curToNodeChild);
              } else {
                var onBeforeNodeAddedResult = onBeforeNodeAdded(curToNodeChild);
                if (onBeforeNodeAddedResult !== false) {
                  if (onBeforeNodeAddedResult) {
                    curToNodeChild = onBeforeNodeAddedResult;
                  }

                  if (curToNodeChild.actualize) {
                    curToNodeChild = curToNodeChild.actualize(
                      fromEl.ownerDocument || doc
                    );
                  }
                  fromEl.appendChild(curToNodeChild);
                  handleNodeAdded(curToNodeChild);
                }
              }

              curToNodeChild = toNextSibling;
              curFromNodeChild = fromNextSibling;
            }

            cleanupFromEl(fromEl, curFromNodeChild, curFromNodeKey);

            var specialElHandler = specialElHandlers[fromEl.nodeName];
            if (specialElHandler) {
              specialElHandler(fromEl, toEl);
            }
          } // END: morphChildren(...)

          var morphedNode = fromNode;
          var morphedNodeType = morphedNode.nodeType;
          var toNodeType = toNode.nodeType;

          if (!childrenOnly) {
            // Handle the case where we are given two DOM nodes that are not
            // compatible (e.g. <div> --> <span> or <div> --> TEXT)
            if (morphedNodeType === ELEMENT_NODE) {
              if (toNodeType === ELEMENT_NODE) {
                if (!compareNodeNames(fromNode, toNode)) {
                  onNodeDiscarded(fromNode);
                  morphedNode = moveChildren(
                    fromNode,
                    createElementNS(toNode.nodeName, toNode.namespaceURI)
                  );
                }
              } else {
                // Going from an element node to a text node
                morphedNode = toNode;
              }
            } else if (
              morphedNodeType === TEXT_NODE ||
              morphedNodeType === COMMENT_NODE
            ) {
              // Text or comment node
              if (toNodeType === morphedNodeType) {
                if (morphedNode.nodeValue !== toNode.nodeValue) {
                  morphedNode.nodeValue = toNode.nodeValue;
                }

                return morphedNode;
              } else {
                // Text node to something else
                morphedNode = toNode;
              }
            }
          }

          if (morphedNode === toNode) {
            // The "to node" was not compatible with the "from node" so we had to
            // toss out the "from node" and use the "to node"
            onNodeDiscarded(fromNode);
          } else {
            morphEl(morphedNode, toNode, childrenOnly);

            // We now need to loop over any keyed nodes that might need to be
            // removed. We only do the removal if we know that the keyed node
            // never found a match. When a keyed node is matched up we remove
            // it out of fromNodesLookup and we use fromNodesLookup to determine
            // if a keyed node has been matched up or not
            if (keyedRemovalList) {
              for (var i = 0, len = keyedRemovalList.length; i < len; i++) {
                var elToRemove = fromNodesLookup[keyedRemovalList[i]];
                if (elToRemove) {
                  removeNode(elToRemove, elToRemove.parentNode, false);
                }
              }
            }
          }

          if (
            !childrenOnly &&
            morphedNode !== fromNode &&
            fromNode.parentNode
          ) {
            if (morphedNode.actualize) {
              morphedNode = morphedNode.actualize(
                fromNode.ownerDocument || doc
              );
            }
            // If we had to swap out the from node with a new node because the old
            // node was not compatible with the target node then we need to
            // replace the old DOM node in the original DOM tree. This is only
            // possible if the original DOM node was part of a DOM tree which
            // we know is the case if it has a parent node.
            fromNode.parentNode.replaceChild(morphedNode, fromNode);
          }

          return morphedNode;
        };
      }

      var morphdom = morphdomFactory(morphAttrs);

      /* harmony default export */ var morphdom_esm = morphdom;

      // CONCATENATED MODULE: ./source/scripts/components/CartItem.js
      function CartItem_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function CartItem_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function CartItem_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          CartItem_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) CartItem_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var CartItem_CartItem =
        /*#__PURE__*/
        (function () {
          function CartItem(el, onUpdateCallback) {
            var _this = this;

            CartItem_classCallCheck(this, CartItem);

            this.el = el;
            this.onUpdateCallback = onUpdateCallback;
            this.id = el.dataset.cartItem;

            this.onQuantityInputChange = function () {
              return _this._onQuantityInputChange();
            };

            this.onRemoveButtonClick = function () {
              return _this._removeFromCart();
            };

            this.removeEl = el.querySelector("[data-cart-item-remove]");
            this.quantity = new Quantity_Quantity(
              el.querySelector("[data-quantity]")
            );
            this.removeEl.addEventListener("click", this.onRemoveButtonClick);
            this.quantity.input.addEventListener(
              "change",
              this.onQuantityInputChange
            );
          }

          CartItem_createClass(CartItem, [
            {
              key: "unload",
              value: function unload() {
                this.removeEl.removeEventListener(
                  "click",
                  this.onRemoveButtonClick
                );
                this.quantity.input.removeEventListener(
                  "change",
                  this.onQuantityInputChange
                );

                this.quantity.unload();
              },
            },
            {
              key: "_onQuantityInputChange",
              value: function _onQuantityInputChange() {
                var value = this.quantity.value;

                if (value > 0) {
                  this._changeCartQuantity(value, this.onUpdateCallback);
                } else {
                  var Uid = $(this).closest("article").attr("data-bundle-id");
                  return false;
                  this._removeFromCart();
                }
              },
            },
            {
              key: "_removeFromCart",
              value: function _removeFromCart() {
                var _this2 = this;
                clear_cart(_this2);
               this._changeCartQuantity(0, function () {
                  // Add in animation here
                  _this2.onUpdateCallback();
                  setTimeout(function () {
                    var ids = [];

                    jquery_default.a
                      .ajax({
                        type: "GET",
                        url: "/cart.js",
                        dataType: "json",
                      })
                      .done(function (response) {
                        var $shipping_product = false;
                        for (var i = 0; i < response.items.length; i++) {
                          var variant_id = response.items[i].variant_id;
                          $(".cartupsell").each(
                            function () {
                              var flag = false;
                              var pro_id = $(this)
                                .find(".upsell-form button")
                                .data("variant-id");
                              if (variant_id == pro_id) {
                                ids.push(pro_id);
                              }
                            }
                          );

                          if (
                            response.items[i].handle ==
                            "route-shipping-protection"
                          ) {
                            $shipping_product = true;
                          }
                        }

                        if (
                          response.item_count == 1 &&
                          $shipping_product == true
                        ) {
                          $("[data-shipping-remove]").trigger("click");
                        }

                        $(".cartupsell").each(
                          function () {
                            var pro_id = $(this)
                              .find(".upsell-form button")
                              .data("variant-id");
                            if (!ids.includes(pro_id)) {
                              $(this).show();
                            }
                          }
                        );
                      });
                  }, 1000);
                });
              },
            },
            {
              key: "_changeCartQuantity",
              value: function _changeCartQuantity(quantity, callback) {
                window.Shopify.changeItem(this.id, quantity, callback);
              },
            },
          ]);

          return CartItem;
        })();

      // CONCATENATED MODULE: ./source/scripts/components/Cart.js
      function Cart_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function Cart_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function Cart_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          Cart_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Cart_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var Cart_MonoCart =
        /*#__PURE__*/
        (function () {
          function MonoCart() {
            Cart_classCallCheck(this, MonoCart);

            this.carts = [];
          }

          Cart_createClass(MonoCart, [
            {
              key: "addCart",
              value: function addCart(el, postMessage) {
                var _this = this;

                var cartItemEls = el.querySelectorAll("[data-cart-item]");
                var cartItems = [];
                this.postMessage = postMessage;
                cartItemEls.forEach(function (cartItemEl) {
                  return cartItems.push(
                    new CartItem_CartItem(cartItemEl, _this.update.bind(_this))
                  );
                });
                this.carts.push({
                  el: el,
                  cartItems: cartItems,
                });
              },
            },
            {
              key: "update",
              value: function update() {
                var _this2 = this;

                return shopify_asyncview_dist_index_es
                  .load("/cart", "ajax")
                  .done(function (data) {
                    var $total_price = data.options.total_price;
                    $.ajax({
                      type: "GET",
                      url: "/cart.js",
                      dataType: "json",
                      async: false,
                    }).done(function (data) {
                      // console.log("news");
                      $total_price = data.total_price;
                      for (var i = 0; i < data.items.length; i++) {
                        if (
                          data.items[i].handle == "route-shipping-protection"
                        ) {
                          $total_price = data.total_price - data.items[i].price;
                        }
                      }
                    });
                    if ($("#togBtn").prop("checked") == true) {
                      if ($total_price > 0 && $total_price <= 9900) {
                        var update_data =
                          "updates[35786404495526]=1&updates[35786404528294]=0&updates[35786404561062]=0";
                        $("[shipping-product-money]").html(
                          Shopify.formatMoney(95)
                        );
                        shopify_currency_converter_dist_default.a.update(
                          $("[shipping-product-money]")[0]
                        );
                      } else if (
                        $total_price >= 10000 &&
                        $total_price <= 19900
                      ) {
                        var update_data =
                          "updates[35786404495526]=0&updates[35786404528294]=1&updates[35786404561062]=0";
                        $("[shipping-product-money]").html(
                          Shopify.formatMoney(150)
                        );
                        shopify_currency_converter_dist_default.a.update(
                          $("[shipping-product-money]")[0]
                        );
                      } else if ($total_price >= 20000) {
                        var update_data =
                          "updates[35786404495526]=0&updates[35786404528294]=0&updates[35786404561062]=1";
                        $("[shipping-product-money]").html(
                          Shopify.formatMoney(250)
                        );
                        shopify_currency_converter_dist_default.a.update(
                          $("[shipping-product-money]")[0]
                        );
                      } else if ($total_price == 0) {
                        var update_data =
                          "updates[35786404495526]=0&updates[35786404528294]=0&updates[35786404561062]=0";
                      }
                    } else {
                      if ($total_price > 0 && $total_price <= 9900) {
                        $("[shipping-product-money]").html(
                          Shopify.formatMoney(95)
                        );
                        shopify_currency_converter_dist_default.a.update(
                          $("[shipping-product-money]")[0]
                        );
                      } else if (
                        $total_price >= 10000 &&
                        $total_price <= 19900
                      ) {
                        $("[shipping-product-money]").html(
                          Shopify.formatMoney(150)
                        );
                        shopify_currency_converter_dist_default.a.update(
                          $("[shipping-product-money]")[0]
                        );
                      } else if ($total_price >= 20000) {
                        $("[shipping-product-money]").html(
                          Shopify.formatMoney(250)
                        );
                        shopify_currency_converter_dist_default.a.update(
                          $("[shipping-product-money]")[0]
                        );
                      }
                      var update_data =
                        "updates[35786404495526]=0&updates[35786404528294]=0&updates[35786404561062]=0";
                    }

                    //  var $total_price = data.options.total_price;
                    jquery_default.a
                      .ajax({
                        type: "POST",
                        url: "/cart/update.js",
                        data: update_data,
                        dataType: "json",
                        async: false,
                      })
                      .done(function (response) {console.log(38054); console.log("Updated"); });

                    if (
                      $("[data-shipping-bar]").length &&
                      !$("[data-shipping-bar]").hasClass("hide_shipping_bar")
                    ) {
                      //var $total_price = data.options.total_price;
                      var threshold =
                        $("[data-shipping-bar]").attr("data-threshold") * 100;
                      var percentage = 100;
                      var text_message = "";
                      var remaining_price = "";
                      if ($total_price >= threshold) {
                        percentage = 100;
                        text_message =
                          "Your order qualifies for free shipping!";
                        $("[data-icon-smallheart]").removeClass("hidden-icon");
                        $("[data-shipping-text]").html(text_message);
                        $("[data-progress-bar]").css("width", percentage + "%");
                      } else {
                        percentage = ($total_price * 100) / threshold;
                        remaining_price = threshold - $total_price;
                        text_message =
                          'Add <span class="money free-shipping-threshold" data-shipping-remaining>' +
                          Shopify.formatMoney(remaining_price) +
                          "</span> to your bag to receive free shipping";
                        $("[data-icon-smallheart]").addClass("hidden-icon");
                        $("[data-shipping-text]").html(text_message);
                        shopify_currency_converter_dist_default.a.update(
                          $("[data-shipping-remaining]")[0]
                        );
                        $("[data-progress-bar]").css("width", percentage + "%");
                      }
                    }

                    _this2.postMessage("cart:update", {
                      data: data,
                    });

                    _this2.carts.forEach(function (cart) {
                      cart.cartItems.forEach(function (cartItem) {
                        // return cartItem.unload();
                      });
                      cart.cartItems = [];
                      var cartElements = [
                        {
                          containers:
                            cart.el.querySelectorAll("[data-cart-items]"),
                          html: data.html.cart_items,
                        },
                        {
                          containers: cart.el.querySelectorAll(
                            "[data-cart-discounts]"
                          ),
                          html: data.html.cart_discounts,
                        },
                        {
                          containers: cart.el.querySelectorAll(
                            "[data-cart-discounts-simplified]"
                          ),
                          html: data.html.cart_discounts_simplified,
                        },
                        {
                          containers: cart.el.querySelectorAll(
                            "[data-cart-subtotal]"
                          ),
                          html:
                            '<span class="money">' +
                            Shopify.formatMoney($total_price) +
                            "</span>",
                        },
                      ];
                      cartElements.forEach(function (_ref) {
                        var containers = _ref.containers,
                          html = _ref.html;

                        for (var i = 0; i < containers.length; i++) {
                          var container = containers[i];
                          var virtualContainer = document.createElement("div");
                          virtualContainer.innerHTML = html;
                          morphdom_esm(container, virtualContainer, {
                            childrenOnly: true,
                            onBeforeElUpdated: function onBeforeElUpdated(
                              fromEl,
                              toEl
                            ) {
                              // Skip images if src matches
                              // - we don't want to reload lazy loaded images
                              if (
                                fromEl.tagName === "IMG" &&
                                fromEl.src === toEl.src
                              ) {
                                return false;
                              }

                              return true;
                            },
                          });
                          var cartMoneyEls =
                            container.querySelectorAll(".money");
                          cartMoneyEls.forEach(function (cartMoneyEl) {
                            return shopify_currency_converter_dist_default.a.update(
                              cartMoneyEl
                            );
                          });

                          if (container.classList.contains("money")) {
                            shopify_currency_converter_dist_default.a.update(
                              container
                            );
                          }

                          var cartItemEls =
                            container.querySelectorAll("[data-cart-item]");
                          cartItemEls.forEach(function (cartItemEl) {
                            return cart.cartItems.push(
                              new CartItem_CartItem(
                                cartItemEl,
                                _this2.update.bind(_this2)
                              )
                            );
                          });
                          rimg_shopify_dist_index_es.watch(container);
                        }
                      });
                      return data;
                    });

                    !(function (i) {
                      "use strict";
                      "function" == typeof define && define.amd
                        ? define(["jquery"], i)
                        : "undefined" != typeof exports
                        ? (module.exports = i(require("jquery")))
                        : i(jQuery);
                    })(function (i) {
                      "use strict";
                      var e = window.Slick || {};
                      ((e = (function () {
                        var e = 0;
                        return function (t, o) {
                          var s,
                            n = this;
                          (n.defaults = {
                            accessibility: !0,
                            adaptiveHeight: !1,
                            appendArrows: i(t),
                            appendDots: i(t),
                            arrows: !0,
                            asNavFor: null,
                            prevArrow:
                              '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                            nextArrow:
                              '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                            autoplay: !1,
                            autoplaySpeed: 3e3,
                            centerMode: !1,
                            centerPadding: "50px",
                            cssEase: "ease",
                            customPaging: function (e, t) {
                              return i('<button type="button" />').text(t + 1);
                            },
                            dots: !1,
                            dotsClass: "slick-dots",
                            draggable: !0,
                            easing: "linear",
                            edgeFriction: 0.35,
                            fade: !1,
                            focusOnSelect: !1,
                            focusOnChange: !1,
                            infinite: !0,
                            initialSlide: 0,
                            lazyLoad: "ondemand",
                            mobileFirst: !1,
                            pauseOnHover: !0,
                            pauseOnFocus: !0,
                            pauseOnDotsHover: !1,
                            respondTo: "window",
                            responsive: null,
                            rows: 1,
                            rtl: !1,
                            slide: "",
                            slidesPerRow: 1,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            speed: 500,
                            swipe: !0,
                            swipeToSlide: !1,
                            touchMove: !0,
                            touchThreshold: 5,
                            useCSS: !0,
                            useTransform: !0,
                            variableWidth: !1,
                            vertical: !1,
                            verticalSwiping: !1,
                            waitForAnimate: !0,
                            zIndex: 1e3,
                          }),
                            (n.initials = {
                              animating: !1,
                              dragging: !1,
                              autoPlayTimer: null,
                              currentDirection: 0,
                              currentLeft: null,
                              currentSlide: 0,
                              direction: 1,
                              $dots: null,
                              listWidth: null,
                              listHeight: null,
                              loadIndex: 0,
                              $nextArrow: null,
                              $prevArrow: null,
                              scrolling: !1,
                              slideCount: null,
                              slideWidth: null,
                              $slideTrack: null,
                              $slides: null,
                              sliding: !1,
                              slideOffset: 0,
                              swipeLeft: null,
                              swiping: !1,
                              $list: null,
                              touchObject: {},
                              transformsEnabled: !1,
                              unslicked: !1,
                            }),
                            i.extend(n, n.initials),
                            (n.activeBreakpoint = null),
                            (n.animType = null),
                            (n.animProp = null),
                            (n.breakpoints = []),
                            (n.breakpointSettings = []),
                            (n.cssTransitions = !1),
                            (n.focussed = !1),
                            (n.interrupted = !1),
                            (n.hidden = "hidden"),
                            (n.paused = !0),
                            (n.positionProp = null),
                            (n.respondTo = null),
                            (n.rowCount = 1),
                            (n.shouldClick = !0),
                            (n.$slider = i(t)),
                            (n.$slidesCache = null),
                            (n.transformType = null),
                            (n.transitionType = null),
                            (n.visibilityChange = "visibilitychange"),
                            (n.windowWidth = 0),
                            (n.windowTimer = null),
                            (s = i(t).data("slick") || {}),
                            (n.options = i.extend({}, n.defaults, o, s)),
                            (n.currentSlide = n.options.initialSlide),
                            (n.originalSettings = n.options),
                            void 0 !== document.mozHidden
                              ? ((n.hidden = "mozHidden"),
                                (n.visibilityChange = "mozvisibilitychange"))
                              : void 0 !== document.webkitHidden &&
                                ((n.hidden = "webkitHidden"),
                                (n.visibilityChange =
                                  "webkitvisibilitychange")),
                            (n.autoPlay = i.proxy(n.autoPlay, n)),
                            (n.autoPlayClear = i.proxy(n.autoPlayClear, n)),
                            (n.autoPlayIterator = i.proxy(
                              n.autoPlayIterator,
                              n
                            )),
                            (n.changeSlide = i.proxy(n.changeSlide, n)),
                            (n.clickHandler = i.proxy(n.clickHandler, n)),
                            (n.selectHandler = i.proxy(n.selectHandler, n)),
                            (n.setPosition = i.proxy(n.setPosition, n)),
                            (n.swipeHandler = i.proxy(n.swipeHandler, n)),
                            (n.dragHandler = i.proxy(n.dragHandler, n)),
                            (n.keyHandler = i.proxy(n.keyHandler, n)),
                            (n.instanceUid = e++),
                            (n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
                            n.registerBreakpoints(),
                            n.init(!0);
                        };
                      })()).prototype.activateADA = function () {
                        this.$slideTrack
                          .find(".slick-active")
                          .attr({ "aria-hidden": "false" })
                          .find("a, input, button, select")
                          .attr({ tabindex: "0" });
                      }),
                        (e.prototype.addSlide = e.prototype.slickAdd =
                          function (e, t, o) {
                            var s = this;
                            if ("boolean" == typeof t) (o = t), (t = null);
                            else if (t < 0 || t >= s.slideCount) return !1;
                            s.unload(),
                              "number" == typeof t
                                ? 0 === t && 0 === s.$slides.length
                                  ? i(e).appendTo(s.$slideTrack)
                                  : o
                                  ? i(e).insertBefore(s.$slides.eq(t))
                                  : i(e).insertAfter(s.$slides.eq(t))
                                : !0 === o
                                ? i(e).prependTo(s.$slideTrack)
                                : i(e).appendTo(s.$slideTrack),
                              (s.$slides = s.$slideTrack.children(
                                this.options.slide
                              )),
                              s.$slideTrack
                                .children(this.options.slide)
                                .detach(),
                              s.$slideTrack.append(s.$slides),
                              s.$slides.each(function (e, t) {
                                i(t).attr("data-slick-index", e);
                              }),
                              (s.$slidesCache = s.$slides),
                              s.reinit();
                          }),
                        (e.prototype.animateHeight = function () {
                          var i = this;
                          if (
                            1 === i.options.slidesToShow &&
                            !0 === i.options.adaptiveHeight &&
                            !1 === i.options.vertical
                          ) {
                            var e = i.$slides
                              .eq(i.currentSlide)
                              .outerHeight(!0);
                            i.$list.animate({ height: e }, i.options.speed);
                          }
                        }),
                        (e.prototype.animateSlide = function (e, t) {
                          var o = {},
                            s = this;
                          s.animateHeight(),
                            !0 === s.options.rtl &&
                              !1 === s.options.vertical &&
                              (e = -e),
                            !1 === s.transformsEnabled
                              ? !1 === s.options.vertical
                                ? s.$slideTrack.animate(
                                    { left: e },
                                    s.options.speed,
                                    s.options.easing,
                                    t
                                  )
                                : s.$slideTrack.animate(
                                    { top: e },
                                    s.options.speed,
                                    s.options.easing,
                                    t
                                  )
                              : !1 === s.cssTransitions
                              ? (!0 === s.options.rtl &&
                                  (s.currentLeft = -s.currentLeft),
                                i({ animStart: s.currentLeft }).animate(
                                  { animStart: e },
                                  {
                                    duration: s.options.speed,
                                    easing: s.options.easing,
                                    step: function (i) {
                                      (i = Math.ceil(i)),
                                        !1 === s.options.vertical
                                          ? ((o[s.animType] =
                                              "translate(" + i + "px, 0px)"),
                                            s.$slideTrack.css(o))
                                          : ((o[s.animType] =
                                              "translate(0px," + i + "px)"),
                                            s.$slideTrack.css(o));
                                    },
                                    complete: function () {
                                      t && t.call();
                                    },
                                  }
                                ))
                              : (s.applyTransition(),
                                (e = Math.ceil(e)),
                                !1 === s.options.vertical
                                  ? (o[s.animType] =
                                      "translate3d(" + e + "px, 0px, 0px)")
                                  : (o[s.animType] =
                                      "translate3d(0px," + e + "px, 0px)"),
                                s.$slideTrack.css(o),
                                t &&
                                  setTimeout(function () {
                                    s.disableTransition(), t.call();
                                  }, s.options.speed));
                        }),
                        (e.prototype.getNavTarget = function () {
                          var e = this,
                            t = e.options.asNavFor;
                          return (
                            t && null !== t && (t = i(t).not(e.$slider)), t
                          );
                        }),
                        (e.prototype.asNavFor = function (e) {
                          var t = this.getNavTarget();
                          null !== t &&
                            "object" == typeof t &&
                            t.each(function () {
                              var t = i(this).slick("getSlick");
                              t.unslicked || t.slideHandler(e, !0);
                            });
                        }),
                        (e.prototype.applyTransition = function (i) {
                          var e = this,
                            t = {};
                          !1 === e.options.fade
                            ? (t[e.transitionType] =
                                e.transformType +
                                " " +
                                e.options.speed +
                                "ms " +
                                e.options.cssEase)
                            : (t[e.transitionType] =
                                "opacity " +
                                e.options.speed +
                                "ms " +
                                e.options.cssEase),
                            !1 === e.options.fade
                              ? e.$slideTrack.css(t)
                              : e.$slides.eq(i).css(t);
                        }),
                        (e.prototype.autoPlay = function () {
                          var i = this;
                          i.autoPlayClear(),
                            i.slideCount > i.options.slidesToShow &&
                              (i.autoPlayTimer = setInterval(
                                i.autoPlayIterator,
                                i.options.autoplaySpeed
                              ));
                        }),
                        (e.prototype.autoPlayClear = function () {
                          var i = this;
                          i.autoPlayTimer && clearInterval(i.autoPlayTimer);
                        }),
                        (e.prototype.autoPlayIterator = function () {
                          var i = this,
                            e = i.currentSlide + i.options.slidesToScroll;
                          i.paused ||
                            i.interrupted ||
                            i.focussed ||
                            (!1 === i.options.infinite &&
                              (1 === i.direction &&
                              i.currentSlide + 1 === i.slideCount - 1
                                ? (i.direction = 0)
                                : 0 === i.direction &&
                                  ((e =
                                    i.currentSlide - i.options.slidesToScroll),
                                  i.currentSlide - 1 == 0 &&
                                    (i.direction = 1))),
                            i.slideHandler(e));
                        }),
                        (e.prototype.buildArrows = function () {
                          var e = this;
                          !0 === e.options.arrows &&
                            ((e.$prevArrow = i(e.options.prevArrow).addClass(
                              "slick-arrow"
                            )),
                            (e.$nextArrow = i(e.options.nextArrow).addClass(
                              "slick-arrow"
                            )),
                            e.slideCount > e.options.slidesToShow
                              ? (e.$prevArrow
                                  .removeClass("slick-hidden")
                                  .removeAttr("aria-hidden tabindex"),
                                e.$nextArrow
                                  .removeClass("slick-hidden")
                                  .removeAttr("aria-hidden tabindex"),
                                e.htmlExpr.test(e.options.prevArrow) &&
                                  e.$prevArrow.prependTo(
                                    e.options.appendArrows
                                  ),
                                e.htmlExpr.test(e.options.nextArrow) &&
                                  e.$nextArrow.appendTo(e.options.appendArrows),
                                !0 !== e.options.infinite &&
                                  e.$prevArrow
                                    .addClass("slick-disabled")
                                    .attr("aria-disabled", "true"))
                              : e.$prevArrow
                                  .add(e.$nextArrow)
                                  .addClass("slick-hidden")
                                  .attr({
                                    "aria-disabled": "true",
                                    tabindex: "-1",
                                  }));
                        }),
                        (e.prototype.buildDots = function () {
                          var e,
                            t,
                            o = this;
                          if (!0 === o.options.dots) {
                            for (
                              o.$slider.addClass("slick-dotted"),
                                t = i("<ul />").addClass(o.options.dotsClass),
                                e = 0;
                              e <= o.getDotCount();
                              e += 1
                            )
                              t.append(
                                i("<li />").append(
                                  o.options.customPaging.call(this, o, e)
                                )
                              );
                            (o.$dots = t.appendTo(o.options.appendDots)),
                              o.$dots
                                .find("li")
                                .first()
                                .addClass("slick-active");
                          }
                        }),
                        (e.prototype.buildOut = function () {
                          var e = this;
                          (e.$slides = e.$slider
                            .children(e.options.slide + ":not(.slick-cloned)")
                            .addClass("slick-slide")),
                            (e.slideCount = e.$slides.length),
                            e.$slides.each(function (e, t) {
                              i(t)
                                .attr("data-slick-index", e)
                                .data(
                                  "originalStyling",
                                  i(t).attr("style") || ""
                                );
                            }),
                            e.$slider.addClass("slick-slider"),
                            (e.$slideTrack =
                              0 === e.slideCount
                                ? i('<div class="slick-track"/>').appendTo(
                                    e.$slider
                                  )
                                : e.$slides
                                    .wrapAll('<div class="slick-track"/>')
                                    .parent()),
                            (e.$list = e.$slideTrack
                              .wrap('<div class="slick-list"/>')
                              .parent()),
                            e.$slideTrack.css("opacity", 0),
                            (!0 !== e.options.centerMode &&
                              !0 !== e.options.swipeToSlide) ||
                              (e.options.slidesToScroll = 1),
                            i("img[data-lazy]", e.$slider)
                              .not("[src]")
                              .addClass("slick-loading"),
                            e.setupInfinite(),
                            e.buildArrows(),
                            e.buildDots(),
                            e.updateDots(),
                            e.setSlideClasses(
                              "number" == typeof e.currentSlide
                                ? e.currentSlide
                                : 0
                            ),
                            !0 === e.options.draggable &&
                              e.$list.addClass("draggable");
                        }),
                        (e.prototype.buildRows = function () {
                          var i,
                            e,
                            t,
                            o,
                            s,
                            n,
                            r,
                            l = this;
                          if (
                            ((o = document.createDocumentFragment()),
                            (n = l.$slider.children()),
                            l.options.rows > 1)
                          ) {
                            for (
                              r = l.options.slidesPerRow * l.options.rows,
                                s = Math.ceil(n.length / r),
                                i = 0;
                              i < s;
                              i++
                            ) {
                              var d = document.createElement("div");
                              for (e = 0; e < l.options.rows; e++) {
                                var a = document.createElement("div");
                                for (t = 0; t < l.options.slidesPerRow; t++) {
                                  var c =
                                    i * r + (e * l.options.slidesPerRow + t);
                                  n.get(c) && a.appendChild(n.get(c));
                                }
                                d.appendChild(a);
                              }
                              o.appendChild(d);
                            }
                            l.$slider.empty().append(o),
                              l.$slider
                                .children()
                                .children()
                                .children()
                                .css({
                                  width: 100 / l.options.slidesPerRow + "%",
                                  display: "inline-block",
                                });
                          }
                        }),
                        (e.prototype.checkResponsive = function (e, t) {
                          var o,
                            s,
                            n,
                            r = this,
                            l = !1,
                            d = r.$slider.width(),
                            a = window.innerWidth || i(window).width();
                          if (
                            ("window" === r.respondTo
                              ? (n = a)
                              : "slider" === r.respondTo
                              ? (n = d)
                              : "min" === r.respondTo && (n = Math.min(a, d)),
                            r.options.responsive &&
                              r.options.responsive.length &&
                              null !== r.options.responsive)
                          ) {
                            s = null;
                            for (o in r.breakpoints)
                              r.breakpoints.hasOwnProperty(o) &&
                                (!1 === r.originalSettings.mobileFirst
                                  ? n < r.breakpoints[o] &&
                                    (s = r.breakpoints[o])
                                  : n > r.breakpoints[o] &&
                                    (s = r.breakpoints[o]));
                            null !== s
                              ? null !== r.activeBreakpoint
                                ? (s !== r.activeBreakpoint || t) &&
                                  ((r.activeBreakpoint = s),
                                  "unslick" === r.breakpointSettings[s]
                                    ? r.unslick(s)
                                    : ((r.options = i.extend(
                                        {},
                                        r.originalSettings,
                                        r.breakpointSettings[s]
                                      )),
                                      !0 === e &&
                                        (r.currentSlide =
                                          r.options.initialSlide),
                                      r.refresh(e)),
                                  (l = s))
                                : ((r.activeBreakpoint = s),
                                  "unslick" === r.breakpointSettings[s]
                                    ? r.unslick(s)
                                    : ((r.options = i.extend(
                                        {},
                                        r.originalSettings,
                                        r.breakpointSettings[s]
                                      )),
                                      !0 === e &&
                                        (r.currentSlide =
                                          r.options.initialSlide),
                                      r.refresh(e)),
                                  (l = s))
                              : null !== r.activeBreakpoint &&
                                ((r.activeBreakpoint = null),
                                (r.options = r.originalSettings),
                                !0 === e &&
                                  (r.currentSlide = r.options.initialSlide),
                                r.refresh(e),
                                (l = s)),
                              e ||
                                !1 === l ||
                                r.$slider.trigger("breakpoint", [r, l]);
                          }
                        }),
                        (e.prototype.changeSlide = function (e, t) {
                          var o,
                            s,
                            n,
                            r = this,
                            l = i(e.currentTarget);
                          switch (
                            (l.is("a") && e.preventDefault(),
                            l.is("li") || (l = l.closest("li")),
                            (n = r.slideCount % r.options.slidesToScroll != 0),
                            (o = n
                              ? 0
                              : (r.slideCount - r.currentSlide) %
                                r.options.slidesToScroll),
                            e.data.message)
                          ) {
                            case "previous":
                              (s =
                                0 === o
                                  ? r.options.slidesToScroll
                                  : r.options.slidesToShow - o),
                                r.slideCount > r.options.slidesToShow &&
                                  r.slideHandler(r.currentSlide - s, !1, t);
                              break;
                            case "next":
                              (s = 0 === o ? r.options.slidesToScroll : o),
                                r.slideCount > r.options.slidesToShow &&
                                  r.slideHandler(r.currentSlide + s, !1, t);
                              break;
                            case "index":
                              var d =
                                0 === e.data.index
                                  ? 0
                                  : e.data.index ||
                                    l.index() * r.options.slidesToScroll;
                              r.slideHandler(r.checkNavigable(d), !1, t),
                                l.children().trigger("focus");
                              break;
                            default:
                              return;
                          }
                        }),
                        (e.prototype.checkNavigable = function (i) {
                          var e, t;
                          if (
                            ((e = this.getNavigableIndexes()),
                            (t = 0),
                            i > e[e.length - 1])
                          )
                            i = e[e.length - 1];
                          else
                            for (var o in e) {
                              if (i < e[o]) {
                                i = t;
                                break;
                              }
                              t = e[o];
                            }
                          return i;
                        }),
                        (e.prototype.cleanUpEvents = function () {
                          var e = this;
                          e.options.dots &&
                            null !== e.$dots &&
                            (i("li", e.$dots)
                              .off("click.slick", e.changeSlide)
                              .off(
                                "mouseenter.slick",
                                i.proxy(e.interrupt, e, !0)
                              )
                              .off(
                                "mouseleave.slick",
                                i.proxy(e.interrupt, e, !1)
                              ),
                            !0 === e.options.accessibility &&
                              e.$dots.off("keydown.slick", e.keyHandler)),
                            e.$slider.off("focus.slick blur.slick"),
                            !0 === e.options.arrows &&
                              e.slideCount > e.options.slidesToShow &&
                              (e.$prevArrow &&
                                e.$prevArrow.off("click.slick", e.changeSlide),
                              e.$nextArrow &&
                                e.$nextArrow.off("click.slick", e.changeSlide),
                              !0 === e.options.accessibility &&
                                (e.$prevArrow &&
                                  e.$prevArrow.off(
                                    "keydown.slick",
                                    e.keyHandler
                                  ),
                                e.$nextArrow &&
                                  e.$nextArrow.off(
                                    "keydown.slick",
                                    e.keyHandler
                                  ))),
                            e.$list.off(
                              "touchstart.slick mousedown.slick",
                              e.swipeHandler
                            ),
                            e.$list.off(
                              "touchmove.slick mousemove.slick",
                              e.swipeHandler
                            ),
                            e.$list.off(
                              "touchend.slick mouseup.slick",
                              e.swipeHandler
                            ),
                            e.$list.off(
                              "touchcancel.slick mouseleave.slick",
                              e.swipeHandler
                            ),
                            e.$list.off("click.slick", e.clickHandler),
                            i(document).off(e.visibilityChange, e.visibility),
                            e.cleanUpSlideEvents(),
                            !0 === e.options.accessibility &&
                              e.$list.off("keydown.slick", e.keyHandler),
                            !0 === e.options.focusOnSelect &&
                              i(e.$slideTrack)
                                .children()
                                .off("click.slick", e.selectHandler),
                            i(window).off(
                              "orientationchange.slick.slick-" + e.instanceUid,
                              e.orientationChange
                            ),
                            i(window).off(
                              "resize.slick.slick-" + e.instanceUid,
                              e.resize
                            ),
                            i("[draggable!=true]", e.$slideTrack).off(
                              "dragstart",
                              e.preventDefault
                            ),
                            i(window).off(
                              "load.slick.slick-" + e.instanceUid,
                              e.setPosition
                            );
                        }),
                        (e.prototype.cleanUpSlideEvents = function () {
                          var e = this;
                          e.$list.off(
                            "mouseenter.slick",
                            i.proxy(e.interrupt, e, !0)
                          ),
                            e.$list.off(
                              "mouseleave.slick",
                              i.proxy(e.interrupt, e, !1)
                            );
                        }),
                        (e.prototype.cleanUpRows = function () {
                          var i,
                            e = this;
                          e.options.rows > 1 &&
                            ((i = e.$slides.children().children()).removeAttr(
                              "style"
                            ),
                            e.$slider.empty().append(i));
                        }),
                        (e.prototype.clickHandler = function (i) {
                          !1 === this.shouldClick &&
                            (i.stopImmediatePropagation(),
                            i.stopPropagation(),
                            i.preventDefault());
                        }),
                        (e.prototype.destroy = function (e) {
                          var t = this;
                          t.autoPlayClear(),
                            (t.touchObject = {}),
                            t.cleanUpEvents(),
                            i(".slick-cloned", t.$slider).detach(),
                            t.$dots && t.$dots.remove(),
                            t.$prevArrow &&
                              t.$prevArrow.length &&
                              (t.$prevArrow
                                .removeClass(
                                  "slick-disabled slick-arrow slick-hidden"
                                )
                                .removeAttr(
                                  "aria-hidden aria-disabled tabindex"
                                )
                                .css("display", ""),
                              t.htmlExpr.test(t.options.prevArrow) &&
                                t.$prevArrow.remove()),
                            t.$nextArrow &&
                              t.$nextArrow.length &&
                              (t.$nextArrow
                                .removeClass(
                                  "slick-disabled slick-arrow slick-hidden"
                                )
                                .removeAttr(
                                  "aria-hidden aria-disabled tabindex"
                                )
                                .css("display", ""),
                              t.htmlExpr.test(t.options.nextArrow) &&
                                t.$nextArrow.remove()),
                            t.$slides &&
                              (t.$slides
                                .removeClass(
                                  "slick-slide slick-active slick-center slick-visible slick-current"
                                )
                                .removeAttr("aria-hidden")
                                .removeAttr("data-slick-index")
                                .each(function () {
                                  i(this).attr(
                                    "style",
                                    i(this).data("originalStyling")
                                  );
                                }),
                              t.$slideTrack
                                .children(this.options.slide)
                                .detach(),
                              t.$slideTrack.detach(),
                              t.$list.detach(),
                              t.$slider.append(t.$slides)),
                            t.cleanUpRows(),
                            t.$slider.removeClass("slick-slider"),
                            t.$slider.removeClass("slick-initialized"),
                            t.$slider.removeClass("slick-dotted"),
                            (t.unslicked = !0),
                            e || t.$slider.trigger("destroy", [t]);
                        }),
                        (e.prototype.disableTransition = function (i) {
                          var e = this,
                            t = {};
                          (t[e.transitionType] = ""),
                            !1 === e.options.fade
                              ? e.$slideTrack.css(t)
                              : e.$slides.eq(i).css(t);
                        }),
                        (e.prototype.fadeSlide = function (i, e) {
                          var t = this;
                          !1 === t.cssTransitions
                            ? (t.$slides
                                .eq(i)
                                .css({ zIndex: t.options.zIndex }),
                              t.$slides
                                .eq(i)
                                .animate(
                                  { opacity: 1 },
                                  t.options.speed,
                                  t.options.easing,
                                  e
                                ))
                            : (t.applyTransition(i),
                              t.$slides
                                .eq(i)
                                .css({ opacity: 1, zIndex: t.options.zIndex }),
                              e &&
                                setTimeout(function () {
                                  t.disableTransition(i), e.call();
                                }, t.options.speed));
                        }),
                        (e.prototype.fadeSlideOut = function (i) {
                          var e = this;
                          !1 === e.cssTransitions
                            ? e.$slides
                                .eq(i)
                                .animate(
                                  { opacity: 0, zIndex: e.options.zIndex - 2 },
                                  e.options.speed,
                                  e.options.easing
                                )
                            : (e.applyTransition(i),
                              e.$slides
                                .eq(i)
                                .css({
                                  opacity: 0,
                                  zIndex: e.options.zIndex - 2,
                                }));
                        }),
                        (e.prototype.filterSlides = e.prototype.slickFilter =
                          function (i) {
                            var e = this;
                            null !== i &&
                              ((e.$slidesCache = e.$slides),
                              e.unload(),
                              e.$slideTrack
                                .children(this.options.slide)
                                .detach(),
                              e.$slidesCache.filter(i).appendTo(e.$slideTrack),
                              e.reinit());
                          }),
                        (e.prototype.focusHandler = function () {
                          var e = this;
                          e.$slider
                            .off("focus.slick blur.slick")
                            .on("focus.slick blur.slick", "*", function (t) {
                              t.stopImmediatePropagation();
                              var o = i(this);
                              setTimeout(function () {
                                e.options.pauseOnFocus &&
                                  ((e.focussed = o.is(":focus")), e.autoPlay());
                              }, 0);
                            });
                        }),
                        (e.prototype.getCurrent =
                          e.prototype.slickCurrentSlide =
                            function () {
                              return this.currentSlide;
                            }),
                        (e.prototype.getDotCount = function () {
                          var i = this,
                            e = 0,
                            t = 0,
                            o = 0;
                          if (!0 === i.options.infinite)
                            if (i.slideCount <= i.options.slidesToShow) ++o;
                            else
                              for (; e < i.slideCount; )
                                ++o,
                                  (e = t + i.options.slidesToScroll),
                                  (t +=
                                    i.options.slidesToScroll <=
                                    i.options.slidesToShow
                                      ? i.options.slidesToScroll
                                      : i.options.slidesToShow);
                          else if (!0 === i.options.centerMode)
                            o = i.slideCount;
                          else if (i.options.asNavFor)
                            for (; e < i.slideCount; )
                              ++o,
                                (e = t + i.options.slidesToScroll),
                                (t +=
                                  i.options.slidesToScroll <=
                                  i.options.slidesToShow
                                    ? i.options.slidesToScroll
                                    : i.options.slidesToShow);
                          else
                            o =
                              1 +
                              Math.ceil(
                                (i.slideCount - i.options.slidesToShow) /
                                  i.options.slidesToScroll
                              );
                          return o - 1;
                        }),
                        (e.prototype.getLeft = function (i) {
                          var e,
                            t,
                            o,
                            s,
                            n = this,
                            r = 0;
                          return (
                            (n.slideOffset = 0),
                            (t = n.$slides.first().outerHeight(!0)),
                            !0 === n.options.infinite
                              ? (n.slideCount > n.options.slidesToShow &&
                                  ((n.slideOffset =
                                    n.slideWidth * n.options.slidesToShow * -1),
                                  (s = -1),
                                  !0 === n.options.vertical &&
                                    !0 === n.options.centerMode &&
                                    (2 === n.options.slidesToShow
                                      ? (s = -1.5)
                                      : 1 === n.options.slidesToShow &&
                                        (s = -2)),
                                  (r = t * n.options.slidesToShow * s)),
                                n.slideCount % n.options.slidesToScroll != 0 &&
                                  i + n.options.slidesToScroll > n.slideCount &&
                                  n.slideCount > n.options.slidesToShow &&
                                  (i > n.slideCount
                                    ? ((n.slideOffset =
                                        (n.options.slidesToShow -
                                          (i - n.slideCount)) *
                                        n.slideWidth *
                                        -1),
                                      (r =
                                        (n.options.slidesToShow -
                                          (i - n.slideCount)) *
                                        t *
                                        -1))
                                    : ((n.slideOffset =
                                        (n.slideCount %
                                          n.options.slidesToScroll) *
                                        n.slideWidth *
                                        -1),
                                      (r =
                                        (n.slideCount %
                                          n.options.slidesToScroll) *
                                        t *
                                        -1))))
                              : i + n.options.slidesToShow > n.slideCount &&
                                ((n.slideOffset =
                                  (i + n.options.slidesToShow - n.slideCount) *
                                  n.slideWidth),
                                (r =
                                  (i + n.options.slidesToShow - n.slideCount) *
                                  t)),
                            n.slideCount <= n.options.slidesToShow &&
                              ((n.slideOffset = 0), (r = 0)),
                            !0 === n.options.centerMode &&
                            n.slideCount <= n.options.slidesToShow
                              ? (n.slideOffset =
                                  (n.slideWidth *
                                    Math.floor(n.options.slidesToShow)) /
                                    2 -
                                  (n.slideWidth * n.slideCount) / 2)
                              : !0 === n.options.centerMode &&
                                !0 === n.options.infinite
                              ? (n.slideOffset +=
                                  n.slideWidth *
                                    Math.floor(n.options.slidesToShow / 2) -
                                  n.slideWidth)
                              : !0 === n.options.centerMode &&
                                ((n.slideOffset = 0),
                                (n.slideOffset +=
                                  n.slideWidth *
                                  Math.floor(n.options.slidesToShow / 2))),
                            (e =
                              !1 === n.options.vertical
                                ? i * n.slideWidth * -1 + n.slideOffset
                                : i * t * -1 + r),
                            !0 === n.options.variableWidth &&
                              ((o =
                                n.slideCount <= n.options.slidesToShow ||
                                !1 === n.options.infinite
                                  ? n.$slideTrack.children(".slick-slide").eq(i)
                                  : n.$slideTrack
                                      .children(".slick-slide")
                                      .eq(i + n.options.slidesToShow)),
                              (e =
                                !0 === n.options.rtl
                                  ? o[0]
                                    ? -1 *
                                      (n.$slideTrack.width() -
                                        o[0].offsetLeft -
                                        o.width())
                                    : 0
                                  : o[0]
                                  ? -1 * o[0].offsetLeft
                                  : 0),
                              !0 === n.options.centerMode &&
                                ((o =
                                  n.slideCount <= n.options.slidesToShow ||
                                  !1 === n.options.infinite
                                    ? n.$slideTrack
                                        .children(".slick-slide")
                                        .eq(i)
                                    : n.$slideTrack
                                        .children(".slick-slide")
                                        .eq(i + n.options.slidesToShow + 1)),
                                (e =
                                  !0 === n.options.rtl
                                    ? o[0]
                                      ? -1 *
                                        (n.$slideTrack.width() -
                                          o[0].offsetLeft -
                                          o.width())
                                      : 0
                                    : o[0]
                                    ? -1 * o[0].offsetLeft
                                    : 0),
                                (e += (n.$list.width() - o.outerWidth()) / 2))),
                            e
                          );
                        }),
                        (e.prototype.getOption = e.prototype.slickGetOption =
                          function (i) {
                            return this.options[i];
                          }),
                        (e.prototype.getNavigableIndexes = function () {
                          var i,
                            e = this,
                            t = 0,
                            o = 0,
                            s = [];
                          for (
                            !1 === e.options.infinite
                              ? (i = e.slideCount)
                              : ((t = -1 * e.options.slidesToScroll),
                                (o = -1 * e.options.slidesToScroll),
                                (i = 2 * e.slideCount));
                            t < i;

                          )
                            s.push(t),
                              (t = o + e.options.slidesToScroll),
                              (o +=
                                e.options.slidesToScroll <=
                                e.options.slidesToShow
                                  ? e.options.slidesToScroll
                                  : e.options.slidesToShow);
                          return s;
                        }),
                        (e.prototype.getSlick = function () {
                          return this;
                        }),
                        (e.prototype.getSlideCount = function () {
                          var e,
                            t,
                            o = this;
                          return (
                            (t =
                              !0 === o.options.centerMode
                                ? o.slideWidth *
                                  Math.floor(o.options.slidesToShow / 2)
                                : 0),
                            !0 === o.options.swipeToSlide
                              ? (o.$slideTrack
                                  .find(".slick-slide")
                                  .each(function (s, n) {
                                    if (
                                      n.offsetLeft - t + i(n).outerWidth() / 2 >
                                      -1 * o.swipeLeft
                                    )
                                      return (e = n), !1;
                                  }),
                                Math.abs(
                                  i(e).attr("data-slick-index") - o.currentSlide
                                ) || 1)
                              : o.options.slidesToScroll
                          );
                        }),
                        (e.prototype.goTo = e.prototype.slickGoTo =
                          function (i, e) {
                            this.changeSlide(
                              {
                                data: { message: "index", index: parseInt(i) },
                              },
                              e
                            );
                          }),
                        (e.prototype.init = function (e) {
                          var t = this;
                          i(t.$slider).hasClass("slick-initialized") ||
                            (i(t.$slider).addClass("slick-initialized"),
                            t.buildRows(),
                            t.buildOut(),
                            t.setProps(),
                            t.startLoad(),
                            t.loadSlider(),
                            t.initializeEvents(),
                            t.updateArrows(),
                            t.updateDots(),
                            t.checkResponsive(!0),
                            t.focusHandler()),
                            e && t.$slider.trigger("init", [t]),
                            !0 === t.options.accessibility && t.initADA(),
                            t.options.autoplay &&
                              ((t.paused = !1), t.autoPlay());
                        }),
                        (e.prototype.initADA = function () {
                          var e = this,
                            t = Math.ceil(
                              e.slideCount / e.options.slidesToShow
                            ),
                            o = e.getNavigableIndexes().filter(function (i) {
                              return i >= 0 && i < e.slideCount;
                            });
                          e.$slides
                            .add(e.$slideTrack.find(".slick-cloned"))
                            .attr({ "aria-hidden": "true", tabindex: "-1" })
                            .find("a, input, button, select")
                            .attr({ tabindex: "-1" }),
                            null !== e.$dots &&
                              (e.$slides
                                .not(e.$slideTrack.find(".slick-cloned"))
                                .each(function (t) {
                                  var s = o.indexOf(t);
                                  i(this).attr({
                                    role: "tabpanel",
                                    id: "slick-slide" + e.instanceUid + t,
                                    tabindex: -1,
                                  }),
                                    -1 !== s &&
                                      i(this).attr({
                                        "aria-describedby":
                                          "slick-slide-control" +
                                          e.instanceUid +
                                          s,
                                      });
                                }),
                              e.$dots
                                .attr("role", "tablist")
                                .find("li")
                                .each(function (s) {
                                  var n = o[s];
                                  i(this).attr({ role: "presentation" }),
                                    i(this)
                                      .find("button")
                                      .first()
                                      .attr({
                                        role: "tab",
                                        id:
                                          "slick-slide-control" +
                                          e.instanceUid +
                                          s,
                                        "aria-controls":
                                          "slick-slide" + e.instanceUid + n,
                                        "aria-label": s + 1 + " of " + t,
                                        "aria-selected": null,
                                        tabindex: "-1",
                                      });
                                })
                                .eq(e.currentSlide)
                                .find("button")
                                .attr({
                                  "aria-selected": "true",
                                  tabindex: "0",
                                })
                                .end());
                          for (
                            var s = e.currentSlide,
                              n = s + e.options.slidesToShow;
                            s < n;
                            s++
                          )
                            e.$slides.eq(s).attr("tabindex", 0);
                          e.activateADA();
                        }),
                        (e.prototype.initArrowEvents = function () {
                          var i = this;
                          !0 === i.options.arrows &&
                            i.slideCount > i.options.slidesToShow &&
                            (i.$prevArrow
                              .off("click.slick")
                              .on(
                                "click.slick",
                                { message: "previous" },
                                i.changeSlide
                              ),
                            i.$nextArrow
                              .off("click.slick")
                              .on(
                                "click.slick",
                                { message: "next" },
                                i.changeSlide
                              ),
                            !0 === i.options.accessibility &&
                              (i.$prevArrow.on("keydown.slick", i.keyHandler),
                              i.$nextArrow.on("keydown.slick", i.keyHandler)));
                        }),
                        (e.prototype.initDotEvents = function () {
                          var e = this;
                          !0 === e.options.dots &&
                            (i("li", e.$dots).on(
                              "click.slick",
                              { message: "index" },
                              e.changeSlide
                            ),
                            !0 === e.options.accessibility &&
                              e.$dots.on("keydown.slick", e.keyHandler)),
                            !0 === e.options.dots &&
                              !0 === e.options.pauseOnDotsHover &&
                              i("li", e.$dots)
                                .on(
                                  "mouseenter.slick",
                                  i.proxy(e.interrupt, e, !0)
                                )
                                .on(
                                  "mouseleave.slick",
                                  i.proxy(e.interrupt, e, !1)
                                );
                        }),
                        (e.prototype.initSlideEvents = function () {
                          var e = this;
                          e.options.pauseOnHover &&
                            (e.$list.on(
                              "mouseenter.slick",
                              i.proxy(e.interrupt, e, !0)
                            ),
                            e.$list.on(
                              "mouseleave.slick",
                              i.proxy(e.interrupt, e, !1)
                            ));
                        }),
                        (e.prototype.initializeEvents = function () {
                          var e = this;
                          e.initArrowEvents(),
                            e.initDotEvents(),
                            e.initSlideEvents(),
                            e.$list.on(
                              "touchstart.slick mousedown.slick",
                              { action: "start" },
                              e.swipeHandler
                            ),
                            e.$list.on(
                              "touchmove.slick mousemove.slick",
                              { action: "move" },
                              e.swipeHandler
                            ),
                            e.$list.on(
                              "touchend.slick mouseup.slick",
                              { action: "end" },
                              e.swipeHandler
                            ),
                            e.$list.on(
                              "touchcancel.slick mouseleave.slick",
                              { action: "end" },
                              e.swipeHandler
                            ),
                            e.$list.on("click.slick", e.clickHandler),
                            i(document).on(
                              e.visibilityChange,
                              i.proxy(e.visibility, e)
                            ),
                            !0 === e.options.accessibility &&
                              e.$list.on("keydown.slick", e.keyHandler),
                            !0 === e.options.focusOnSelect &&
                              i(e.$slideTrack)
                                .children()
                                .on("click.slick", e.selectHandler),
                            i(window).on(
                              "orientationchange.slick.slick-" + e.instanceUid,
                              i.proxy(e.orientationChange, e)
                            ),
                            i(window).on(
                              "resize.slick.slick-" + e.instanceUid,
                              i.proxy(e.resize, e)
                            ),
                            i("[draggable!=true]", e.$slideTrack).on(
                              "dragstart",
                              e.preventDefault
                            ),
                            i(window).on(
                              "load.slick.slick-" + e.instanceUid,
                              e.setPosition
                            ),
                            i(e.setPosition);
                        }),
                        (e.prototype.initUI = function () {
                          var i = this;
                          !0 === i.options.arrows &&
                            i.slideCount > i.options.slidesToShow &&
                            (i.$prevArrow.show(), i.$nextArrow.show()),
                            !0 === i.options.dots &&
                              i.slideCount > i.options.slidesToShow &&
                              i.$dots.show();
                        }),
                        (e.prototype.keyHandler = function (i) {
                          var e = this;
                          i.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
                            (37 === i.keyCode && !0 === e.options.accessibility
                              ? e.changeSlide({
                                  data: {
                                    message:
                                      !0 === e.options.rtl
                                        ? "next"
                                        : "previous",
                                  },
                                })
                              : 39 === i.keyCode &&
                                !0 === e.options.accessibility &&
                                e.changeSlide({
                                  data: {
                                    message:
                                      !0 === e.options.rtl
                                        ? "previous"
                                        : "next",
                                  },
                                }));
                        }),
                        (e.prototype.lazyLoad = function () {
                          function e(e) {
                            i("img[data-lazy]", e).each(function () {
                              var e = i(this),
                                t = i(this).attr("data-lazy"),
                                o = i(this).attr("data-srcset"),
                                s =
                                  i(this).attr("data-sizes") ||
                                  n.$slider.attr("data-sizes"),
                                r = document.createElement("img");
                              (r.onload = function () {
                                e.animate({ opacity: 0 }, 100, function () {
                                  o &&
                                    (e.attr("srcset", o),
                                    s && e.attr("sizes", s)),
                                    e
                                      .attr("src", t)
                                      .animate(
                                        { opacity: 1 },
                                        200,
                                        function () {
                                          e.removeAttr(
                                            "data-lazy data-srcset data-sizes"
                                          ).removeClass("slick-loading");
                                        }
                                      ),
                                    n.$slider.trigger("lazyLoaded", [n, e, t]);
                                });
                              }),
                                (r.onerror = function () {
                                  e
                                    .removeAttr("data-lazy")
                                    .removeClass("slick-loading")
                                    .addClass("slick-lazyload-error"),
                                    n.$slider.trigger("lazyLoadError", [
                                      n,
                                      e,
                                      t,
                                    ]);
                                }),
                                (r.src = t);
                            });
                          }
                          var t,
                            o,
                            s,
                            n = this;
                          if (
                            (!0 === n.options.centerMode
                              ? !0 === n.options.infinite
                                ? (s =
                                    (o =
                                      n.currentSlide +
                                      (n.options.slidesToShow / 2 + 1)) +
                                    n.options.slidesToShow +
                                    2)
                                : ((o = Math.max(
                                    0,
                                    n.currentSlide -
                                      (n.options.slidesToShow / 2 + 1)
                                  )),
                                  (s =
                                    n.options.slidesToShow / 2 +
                                    1 +
                                    2 +
                                    n.currentSlide))
                              : ((o = n.options.infinite
                                  ? n.options.slidesToShow + n.currentSlide
                                  : n.currentSlide),
                                (s = Math.ceil(o + n.options.slidesToShow)),
                                !0 === n.options.fade &&
                                  (o > 0 && o--, s <= n.slideCount && s++)),
                            (t = n.$slider.find(".slick-slide").slice(o, s)),
                            "anticipated" === n.options.lazyLoad)
                          )
                            for (
                              var r = o - 1,
                                l = s,
                                d = n.$slider.find(".slick-slide"),
                                a = 0;
                              a < n.options.slidesToScroll;
                              a++
                            )
                              r < 0 && (r = n.slideCount - 1),
                                (t = (t = t.add(d.eq(r))).add(d.eq(l))),
                                r--,
                                l++;
                          e(t),
                            n.slideCount <= n.options.slidesToShow
                              ? e(n.$slider.find(".slick-slide"))
                              : n.currentSlide >=
                                n.slideCount - n.options.slidesToShow
                              ? e(
                                  n.$slider
                                    .find(".slick-cloned")
                                    .slice(0, n.options.slidesToShow)
                                )
                              : 0 === n.currentSlide &&
                                e(
                                  n.$slider
                                    .find(".slick-cloned")
                                    .slice(-1 * n.options.slidesToShow)
                                );
                        }),
                        (e.prototype.loadSlider = function () {
                          var i = this;
                          i.setPosition(),
                            i.$slideTrack.css({ opacity: 1 }),
                            i.$slider.removeClass("slick-loading"),
                            i.initUI(),
                            "progressive" === i.options.lazyLoad &&
                              i.progressiveLazyLoad();
                        }),
                        (e.prototype.next = e.prototype.slickNext =
                          function () {
                            this.changeSlide({ data: { message: "next" } });
                          }),
                        (e.prototype.orientationChange = function () {
                          var i = this;
                          i.checkResponsive(), i.setPosition();
                        }),
                        (e.prototype.pause = e.prototype.slickPause =
                          function () {
                            var i = this;
                            i.autoPlayClear(), (i.paused = !0);
                          }),
                        (e.prototype.play = e.prototype.slickPlay =
                          function () {
                            var i = this;
                            i.autoPlay(),
                              (i.options.autoplay = !0),
                              (i.paused = !1),
                              (i.focussed = !1),
                              (i.interrupted = !1);
                          }),
                        (e.prototype.postSlide = function (e) {
                          var t = this;
                          t.unslicked ||
                            (t.$slider.trigger("afterChange", [t, e]),
                            (t.animating = !1),
                            t.slideCount > t.options.slidesToShow &&
                              t.setPosition(),
                            (t.swipeLeft = null),
                            t.options.autoplay && t.autoPlay(),
                            !0 === t.options.accessibility &&
                              (t.initADA(),
                              t.options.focusOnChange &&
                                i(t.$slides.get(t.currentSlide))
                                  .attr("tabindex", 0)
                                  .focus()));
                        }),
                        (e.prototype.prev = e.prototype.slickPrev =
                          function () {
                            this.changeSlide({ data: { message: "previous" } });
                          }),
                        (e.prototype.preventDefault = function (i) {
                          i.preventDefault();
                        }),
                        (e.prototype.progressiveLazyLoad = function (e) {
                          e = e || 1;
                          var t,
                            o,
                            s,
                            n,
                            r,
                            l = this,
                            d = i("img[data-lazy]", l.$slider);
                          d.length
                            ? ((t = d.first()),
                              (o = t.attr("data-lazy")),
                              (s = t.attr("data-srcset")),
                              (n =
                                t.attr("data-sizes") ||
                                l.$slider.attr("data-sizes")),
                              ((r = document.createElement("img")).onload =
                                function () {
                                  s &&
                                    (t.attr("srcset", s),
                                    n && t.attr("sizes", n)),
                                    t
                                      .attr("src", o)
                                      .removeAttr(
                                        "data-lazy data-srcset data-sizes"
                                      )
                                      .removeClass("slick-loading"),
                                    !0 === l.options.adaptiveHeight &&
                                      l.setPosition(),
                                    l.$slider.trigger("lazyLoaded", [l, t, o]),
                                    l.progressiveLazyLoad();
                                }),
                              (r.onerror = function () {
                                e < 3
                                  ? setTimeout(function () {
                                      l.progressiveLazyLoad(e + 1);
                                    }, 500)
                                  : (t
                                      .removeAttr("data-lazy")
                                      .removeClass("slick-loading")
                                      .addClass("slick-lazyload-error"),
                                    l.$slider.trigger("lazyLoadError", [
                                      l,
                                      t,
                                      o,
                                    ]),
                                    l.progressiveLazyLoad());
                              }),
                              (r.src = o))
                            : l.$slider.trigger("allImagesLoaded", [l]);
                        }),
                        (e.prototype.refresh = function (e) {
                          var t,
                            o,
                            s = this;
                          (o = s.slideCount - s.options.slidesToShow),
                            !s.options.infinite &&
                              s.currentSlide > o &&
                              (s.currentSlide = o),
                            s.slideCount <= s.options.slidesToShow &&
                              (s.currentSlide = 0),
                            (t = s.currentSlide),
                            s.destroy(!0),
                            i.extend(s, s.initials, { currentSlide: t }),
                            s.init(),
                            e ||
                              s.changeSlide(
                                { data: { message: "index", index: t } },
                                !1
                              );
                        }),
                        (e.prototype.registerBreakpoints = function () {
                          var e,
                            t,
                            o,
                            s = this,
                            n = s.options.responsive || null;
                          if ("array" === i.type(n) && n.length) {
                            s.respondTo = s.options.respondTo || "window";
                            for (e in n)
                              if (
                                ((o = s.breakpoints.length - 1),
                                n.hasOwnProperty(e))
                              ) {
                                for (t = n[e].breakpoint; o >= 0; )
                                  s.breakpoints[o] &&
                                    s.breakpoints[o] === t &&
                                    s.breakpoints.splice(o, 1),
                                    o--;
                                s.breakpoints.push(t),
                                  (s.breakpointSettings[t] = n[e].settings);
                              }
                            s.breakpoints.sort(function (i, e) {
                              return s.options.mobileFirst ? i - e : e - i;
                            });
                          }
                        }),
                        (e.prototype.reinit = function () {
                          var e = this;
                          (e.$slides = e.$slideTrack
                            .children(e.options.slide)
                            .addClass("slick-slide")),
                            (e.slideCount = e.$slides.length),
                            e.currentSlide >= e.slideCount &&
                              0 !== e.currentSlide &&
                              (e.currentSlide =
                                e.currentSlide - e.options.slidesToScroll),
                            e.slideCount <= e.options.slidesToShow &&
                              (e.currentSlide = 0),
                            e.registerBreakpoints(),
                            e.setProps(),
                            e.setupInfinite(),
                            e.buildArrows(),
                            e.updateArrows(),
                            e.initArrowEvents(),
                            e.buildDots(),
                            e.updateDots(),
                            e.initDotEvents(),
                            e.cleanUpSlideEvents(),
                            e.initSlideEvents(),
                            e.checkResponsive(!1, !0),
                            !0 === e.options.focusOnSelect &&
                              i(e.$slideTrack)
                                .children()
                                .on("click.slick", e.selectHandler),
                            e.setSlideClasses(
                              "number" == typeof e.currentSlide
                                ? e.currentSlide
                                : 0
                            ),
                            e.setPosition(),
                            e.focusHandler(),
                            (e.paused = !e.options.autoplay),
                            e.autoPlay(),
                            e.$slider.trigger("reInit", [e]);
                        }),
                        (e.prototype.resize = function () {
                          var e = this;
                          i(window).width() !== e.windowWidth &&
                            (clearTimeout(e.windowDelay),
                            (e.windowDelay = window.setTimeout(function () {
                              (e.windowWidth = i(window).width()),
                                e.checkResponsive(),
                                e.unslicked || e.setPosition();
                            }, 50)));
                        }),
                        (e.prototype.removeSlide = e.prototype.slickRemove =
                          function (i, e, t) {
                            var o = this;
                            if (
                              ((i =
                                "boolean" == typeof i
                                  ? !0 === (e = i)
                                    ? 0
                                    : o.slideCount - 1
                                  : !0 === e
                                  ? --i
                                  : i),
                              o.slideCount < 1 || i < 0 || i > o.slideCount - 1)
                            )
                              return !1;
                            o.unload(),
                              !0 === t
                                ? o.$slideTrack.children().remove()
                                : o.$slideTrack
                                    .children(this.options.slide)
                                    .eq(i)
                                    .remove(),
                              (o.$slides = o.$slideTrack.children(
                                this.options.slide
                              )),
                              o.$slideTrack
                                .children(this.options.slide)
                                .detach(),
                              o.$slideTrack.append(o.$slides),
                              (o.$slidesCache = o.$slides),
                              o.reinit();
                          }),
                        (e.prototype.setCSS = function (i) {
                          var e,
                            t,
                            o = this,
                            s = {};
                          !0 === o.options.rtl && (i = -i),
                            (e =
                              "left" == o.positionProp
                                ? Math.ceil(i) + "px"
                                : "0px"),
                            (t =
                              "top" == o.positionProp
                                ? Math.ceil(i) + "px"
                                : "0px"),
                            (s[o.positionProp] = i),
                            !1 === o.transformsEnabled
                              ? o.$slideTrack.css(s)
                              : ((s = {}),
                                !1 === o.cssTransitions
                                  ? ((s[o.animType] =
                                      "translate(" + e + ", " + t + ")"),
                                    o.$slideTrack.css(s))
                                  : ((s[o.animType] =
                                      "translate3d(" + e + ", " + t + ", 0px)"),
                                    o.$slideTrack.css(s)));
                        }),
                        (e.prototype.setDimensions = function () {
                          var i = this;
                          !1 === i.options.vertical
                            ? !0 === i.options.centerMode &&
                              i.$list.css({
                                padding: "0px " + i.options.centerPadding,
                              })
                            : (i.$list.height(
                                i.$slides.first().outerHeight(!0) *
                                  i.options.slidesToShow
                              ),
                              !0 === i.options.centerMode &&
                                i.$list.css({
                                  padding: i.options.centerPadding + " 0px",
                                })),
                            (i.listWidth = i.$list.width()),
                            (i.listHeight = i.$list.height()),
                            !1 === i.options.vertical &&
                            !1 === i.options.variableWidth
                              ? ((i.slideWidth = Math.ceil(
                                  i.listWidth / i.options.slidesToShow
                                )),
                                i.$slideTrack.width(
                                  Math.ceil(
                                    i.slideWidth *
                                      i.$slideTrack.children(".slick-slide")
                                        .length
                                  )
                                ))
                              : !0 === i.options.variableWidth
                              ? i.$slideTrack.width(5e3 * i.slideCount)
                              : ((i.slideWidth = Math.ceil(i.listWidth)),
                                i.$slideTrack.height(
                                  Math.ceil(
                                    i.$slides.first().outerHeight(!0) *
                                      i.$slideTrack.children(".slick-slide")
                                        .length
                                  )
                                ));
                          var e =
                            i.$slides.first().outerWidth(!0) -
                            i.$slides.first().width();
                          !1 === i.options.variableWidth &&
                            i.$slideTrack
                              .children(".slick-slide")
                              .width(i.slideWidth - e);
                        }),
                        (e.prototype.setFade = function () {
                          var e,
                            t = this;
                          t.$slides.each(function (o, s) {
                            (e = t.slideWidth * o * -1),
                              !0 === t.options.rtl
                                ? i(s).css({
                                    position: "relative",
                                    right: e,
                                    top: 0,
                                    zIndex: t.options.zIndex - 2,
                                    opacity: 0,
                                  })
                                : i(s).css({
                                    position: "relative",
                                    left: e,
                                    top: 0,
                                    zIndex: t.options.zIndex - 2,
                                    opacity: 0,
                                  });
                          }),
                            t.$slides
                              .eq(t.currentSlide)
                              .css({
                                zIndex: t.options.zIndex - 1,
                                opacity: 1,
                              });
                        }),
                        (e.prototype.setHeight = function () {
                          var i = this;
                          if (
                            1 === i.options.slidesToShow &&
                            !0 === i.options.adaptiveHeight &&
                            !1 === i.options.vertical
                          ) {
                            var e = i.$slides
                              .eq(i.currentSlide)
                              .outerHeight(!0);
                            i.$list.css("height", e);
                          }
                        }),
                        (e.prototype.setOption = e.prototype.slickSetOption =
                          function () {
                            var e,
                              t,
                              o,
                              s,
                              n,
                              r = this,
                              l = !1;
                            if (
                              ("object" === i.type(arguments[0])
                                ? ((o = arguments[0]),
                                  (l = arguments[1]),
                                  (n = "multiple"))
                                : "string" === i.type(arguments[0]) &&
                                  ((o = arguments[0]),
                                  (s = arguments[1]),
                                  (l = arguments[2]),
                                  "responsive" === arguments[0] &&
                                  "array" === i.type(arguments[1])
                                    ? (n = "responsive")
                                    : void 0 !== arguments[1] &&
                                      (n = "single")),
                              "single" === n)
                            )
                              r.options[o] = s;
                            else if ("multiple" === n)
                              i.each(o, function (i, e) {
                                r.options[i] = e;
                              });
                            else if ("responsive" === n)
                              for (t in s)
                                if ("array" !== i.type(r.options.responsive))
                                  r.options.responsive = [s[t]];
                                else {
                                  for (
                                    e = r.options.responsive.length - 1;
                                    e >= 0;

                                  )
                                    r.options.responsive[e].breakpoint ===
                                      s[t].breakpoint &&
                                      r.options.responsive.splice(e, 1),
                                      e--;
                                  r.options.responsive.push(s[t]);
                                }
                            l && (r.unload(), r.reinit());
                          }),
                        (e.prototype.setPosition = function () {
                          var i = this;
                          i.setDimensions(),
                            i.setHeight(),
                            !1 === i.options.fade
                              ? i.setCSS(i.getLeft(i.currentSlide))
                              : i.setFade(),
                            i.$slider.trigger("setPosition", [i]);
                        }),
                        (e.prototype.setProps = function () {
                          var i = this,
                            e = document.body.style;
                          (i.positionProp =
                            !0 === i.options.vertical ? "top" : "left"),
                            "top" === i.positionProp
                              ? i.$slider.addClass("slick-vertical")
                              : i.$slider.removeClass("slick-vertical"),
                            (void 0 === e.WebkitTransition &&
                              void 0 === e.MozTransition &&
                              void 0 === e.msTransition) ||
                              (!0 === i.options.useCSS &&
                                (i.cssTransitions = !0)),
                            i.options.fade &&
                              ("number" == typeof i.options.zIndex
                                ? i.options.zIndex < 3 && (i.options.zIndex = 3)
                                : (i.options.zIndex = i.defaults.zIndex)),
                            void 0 !== e.OTransform &&
                              ((i.animType = "OTransform"),
                              (i.transformType = "-o-transform"),
                              (i.transitionType = "OTransition"),
                              void 0 === e.perspectiveProperty &&
                                void 0 === e.webkitPerspective &&
                                (i.animType = !1)),
                            void 0 !== e.MozTransform &&
                              ((i.animType = "MozTransform"),
                              (i.transformType = "-moz-transform"),
                              (i.transitionType = "MozTransition"),
                              void 0 === e.perspectiveProperty &&
                                void 0 === e.MozPerspective &&
                                (i.animType = !1)),
                            void 0 !== e.webkitTransform &&
                              ((i.animType = "webkitTransform"),
                              (i.transformType = "-webkit-transform"),
                              (i.transitionType = "webkitTransition"),
                              void 0 === e.perspectiveProperty &&
                                void 0 === e.webkitPerspective &&
                                (i.animType = !1)),
                            void 0 !== e.msTransform &&
                              ((i.animType = "msTransform"),
                              (i.transformType = "-ms-transform"),
                              (i.transitionType = "msTransition"),
                              void 0 === e.msTransform && (i.animType = !1)),
                            void 0 !== e.transform &&
                              !1 !== i.animType &&
                              ((i.animType = "transform"),
                              (i.transformType = "transform"),
                              (i.transitionType = "transition")),
                            (i.transformsEnabled =
                              i.options.useTransform &&
                              null !== i.animType &&
                              !1 !== i.animType);
                        }),
                        (e.prototype.setSlideClasses = function (i) {
                          var e,
                            t,
                            o,
                            s,
                            n = this;
                          if (
                            ((t = n.$slider
                              .find(".slick-slide")
                              .removeClass(
                                "slick-active slick-center slick-current"
                              )
                              .attr("aria-hidden", "true")),
                            n.$slides.eq(i).addClass("slick-current"),
                            !0 === n.options.centerMode)
                          ) {
                            var r = n.options.slidesToShow % 2 == 0 ? 1 : 0;
                            (e = Math.floor(n.options.slidesToShow / 2)),
                              !0 === n.options.infinite &&
                                (i >= e && i <= n.slideCount - 1 - e
                                  ? n.$slides
                                      .slice(i - e + r, i + e + 1)
                                      .addClass("slick-active")
                                      .attr("aria-hidden", "false")
                                  : ((o = n.options.slidesToShow + i),
                                    t
                                      .slice(o - e + 1 + r, o + e + 2)
                                      .addClass("slick-active")
                                      .attr("aria-hidden", "false")),
                                0 === i
                                  ? t
                                      .eq(t.length - 1 - n.options.slidesToShow)
                                      .addClass("slick-center")
                                  : i === n.slideCount - 1 &&
                                    t
                                      .eq(n.options.slidesToShow)
                                      .addClass("slick-center")),
                              n.$slides.eq(i).addClass("slick-center");
                          } else
                            i >= 0 && i <= n.slideCount - n.options.slidesToShow
                              ? n.$slides
                                  .slice(i, i + n.options.slidesToShow)
                                  .addClass("slick-active")
                                  .attr("aria-hidden", "false")
                              : t.length <= n.options.slidesToShow
                              ? t
                                  .addClass("slick-active")
                                  .attr("aria-hidden", "false")
                              : ((s = n.slideCount % n.options.slidesToShow),
                                (o =
                                  !0 === n.options.infinite
                                    ? n.options.slidesToShow + i
                                    : i),
                                n.options.slidesToShow ==
                                  n.options.slidesToScroll &&
                                n.slideCount - i < n.options.slidesToShow
                                  ? t
                                      .slice(
                                        o - (n.options.slidesToShow - s),
                                        o + s
                                      )
                                      .addClass("slick-active")
                                      .attr("aria-hidden", "false")
                                  : t
                                      .slice(o, o + n.options.slidesToShow)
                                      .addClass("slick-active")
                                      .attr("aria-hidden", "false"));
                          ("ondemand" !== n.options.lazyLoad &&
                            "anticipated" !== n.options.lazyLoad) ||
                            n.lazyLoad();
                        }),
                        (e.prototype.setupInfinite = function () {
                          var e,
                            t,
                            o,
                            s = this;
                          if (
                            (!0 === s.options.fade &&
                              (s.options.centerMode = !1),
                            !0 === s.options.infinite &&
                              !1 === s.options.fade &&
                              ((t = null),
                              s.slideCount > s.options.slidesToShow))
                          ) {
                            for (
                              o =
                                !0 === s.options.centerMode
                                  ? s.options.slidesToShow + 1
                                  : s.options.slidesToShow,
                                e = s.slideCount;
                              e > s.slideCount - o;
                              e -= 1
                            )
                              (t = e - 1),
                                i(s.$slides[t])
                                  .clone(!0)
                                  .attr("id", "")
                                  .attr("data-slick-index", t - s.slideCount)
                                  .prependTo(s.$slideTrack)
                                  .addClass("slick-cloned");
                            for (e = 0; e < o + s.slideCount; e += 1)
                              (t = e),
                                i(s.$slides[t])
                                  .clone(!0)
                                  .attr("id", "")
                                  .attr("data-slick-index", t + s.slideCount)
                                  .appendTo(s.$slideTrack)
                                  .addClass("slick-cloned");
                            s.$slideTrack
                              .find(".slick-cloned")
                              .find("[id]")
                              .each(function () {
                                i(this).attr("id", "");
                              });
                          }
                        }),
                        (e.prototype.interrupt = function (i) {
                          var e = this;
                          i || e.autoPlay(), (e.interrupted = i);
                        }),
                        (e.prototype.selectHandler = function (e) {
                          var t = this,
                            o = i(e.target).is(".slick-slide")
                              ? i(e.target)
                              : i(e.target).parents(".slick-slide"),
                            s = parseInt(o.attr("data-slick-index"));
                          s || (s = 0),
                            t.slideCount <= t.options.slidesToShow
                              ? t.slideHandler(s, !1, !0)
                              : t.slideHandler(s);
                        }),
                        (e.prototype.slideHandler = function (i, e, t) {
                          var o,
                            s,
                            n,
                            r,
                            l,
                            d = null,
                            a = this;
                          if (
                            ((e = e || !1),
                            !(
                              (!0 === a.animating &&
                                !0 === a.options.waitForAnimate) ||
                              (!0 === a.options.fade && a.currentSlide === i)
                            ))
                          )
                            if (
                              (!1 === e && a.asNavFor(i),
                              (o = i),
                              (d = a.getLeft(o)),
                              (r = a.getLeft(a.currentSlide)),
                              (a.currentLeft =
                                null === a.swipeLeft ? r : a.swipeLeft),
                              !1 === a.options.infinite &&
                                !1 === a.options.centerMode &&
                                (i < 0 ||
                                  i >
                                    a.getDotCount() * a.options.slidesToScroll))
                            )
                              !1 === a.options.fade &&
                                ((o = a.currentSlide),
                                !0 !== t
                                  ? a.animateSlide(r, function () {
                                      a.postSlide(o);
                                    })
                                  : a.postSlide(o));
                            else if (
                              !1 === a.options.infinite &&
                              !0 === a.options.centerMode &&
                              (i < 0 ||
                                i > a.slideCount - a.options.slidesToScroll)
                            )
                              !1 === a.options.fade &&
                                ((o = a.currentSlide),
                                !0 !== t
                                  ? a.animateSlide(r, function () {
                                      a.postSlide(o);
                                    })
                                  : a.postSlide(o));
                            else {
                              if (
                                (a.options.autoplay &&
                                  clearInterval(a.autoPlayTimer),
                                (s =
                                  o < 0
                                    ? a.slideCount % a.options.slidesToScroll !=
                                      0
                                      ? a.slideCount -
                                        (a.slideCount %
                                          a.options.slidesToScroll)
                                      : a.slideCount + o
                                    : o >= a.slideCount
                                    ? a.slideCount % a.options.slidesToScroll !=
                                      0
                                      ? 0
                                      : o - a.slideCount
                                    : o),
                                (a.animating = !0),
                                a.$slider.trigger("beforeChange", [
                                  a,
                                  a.currentSlide,
                                  s,
                                ]),
                                (n = a.currentSlide),
                                (a.currentSlide = s),
                                a.setSlideClasses(a.currentSlide),
                                a.options.asNavFor &&
                                  (l = (l = a.getNavTarget()).slick("getSlick"))
                                    .slideCount <= l.options.slidesToShow &&
                                  l.setSlideClasses(a.currentSlide),
                                a.updateDots(),
                                a.updateArrows(),
                                !0 === a.options.fade)
                              )
                                return (
                                  !0 !== t
                                    ? (a.fadeSlideOut(n),
                                      a.fadeSlide(s, function () {
                                        a.postSlide(s);
                                      }))
                                    : a.postSlide(s),
                                  void a.animateHeight()
                                );
                              !0 !== t
                                ? a.animateSlide(d, function () {
                                    a.postSlide(s);
                                  })
                                : a.postSlide(s);
                            }
                        }),
                        (e.prototype.startLoad = function () {
                          var i = this;
                          !0 === i.options.arrows &&
                            i.slideCount > i.options.slidesToShow &&
                            (i.$prevArrow.hide(), i.$nextArrow.hide()),
                            !0 === i.options.dots &&
                              i.slideCount > i.options.slidesToShow &&
                              i.$dots.hide(),
                            i.$slider.addClass("slick-loading");
                        }),
                        (e.prototype.swipeDirection = function () {
                          var i,
                            e,
                            t,
                            o,
                            s = this;
                          return (
                            (i = s.touchObject.startX - s.touchObject.curX),
                            (e = s.touchObject.startY - s.touchObject.curY),
                            (t = Math.atan2(e, i)),
                            (o = Math.round((180 * t) / Math.PI)) < 0 &&
                              (o = 360 - Math.abs(o)),
                            o <= 45 && o >= 0
                              ? !1 === s.options.rtl
                                ? "left"
                                : "right"
                              : o <= 360 && o >= 315
                              ? !1 === s.options.rtl
                                ? "left"
                                : "right"
                              : o >= 135 && o <= 225
                              ? !1 === s.options.rtl
                                ? "right"
                                : "left"
                              : !0 === s.options.verticalSwiping
                              ? o >= 35 && o <= 135
                                ? "down"
                                : "up"
                              : "vertical"
                          );
                        }),
                        (e.prototype.swipeEnd = function (i) {
                          var e,
                            t,
                            o = this;
                          if (
                            ((o.dragging = !1), (o.swiping = !1), o.scrolling)
                          )
                            return (o.scrolling = !1), !1;
                          if (
                            ((o.interrupted = !1),
                            (o.shouldClick = !(o.touchObject.swipeLength > 10)),
                            void 0 === o.touchObject.curX)
                          )
                            return !1;
                          if (
                            (!0 === o.touchObject.edgeHit &&
                              o.$slider.trigger("edge", [
                                o,
                                o.swipeDirection(),
                              ]),
                            o.touchObject.swipeLength >= o.touchObject.minSwipe)
                          ) {
                            switch ((t = o.swipeDirection())) {
                              case "left":
                              case "down":
                                (e = o.options.swipeToSlide
                                  ? o.checkNavigable(
                                      o.currentSlide + o.getSlideCount()
                                    )
                                  : o.currentSlide + o.getSlideCount()),
                                  (o.currentDirection = 0);
                                break;
                              case "right":
                              case "up":
                                (e = o.options.swipeToSlide
                                  ? o.checkNavigable(
                                      o.currentSlide - o.getSlideCount()
                                    )
                                  : o.currentSlide - o.getSlideCount()),
                                  (o.currentDirection = 1);
                            }
                            "vertical" != t &&
                              (o.slideHandler(e),
                              (o.touchObject = {}),
                              o.$slider.trigger("swipe", [o, t]));
                          } else
                            o.touchObject.startX !== o.touchObject.curX &&
                              (o.slideHandler(o.currentSlide),
                              (o.touchObject = {}));
                        }),
                        (e.prototype.swipeHandler = function (i) {
                          var e = this;
                          if (
                            !(
                              !1 === e.options.swipe ||
                              ("ontouchend" in document &&
                                !1 === e.options.swipe) ||
                              (!1 === e.options.draggable &&
                                -1 !== i.type.indexOf("mouse"))
                            )
                          )
                            switch (
                              ((e.touchObject.fingerCount =
                                i.originalEvent &&
                                void 0 !== i.originalEvent.touches
                                  ? i.originalEvent.touches.length
                                  : 1),
                              (e.touchObject.minSwipe =
                                e.listWidth / e.options.touchThreshold),
                              !0 === e.options.verticalSwiping &&
                                (e.touchObject.minSwipe =
                                  e.listHeight / e.options.touchThreshold),
                              i.data.action)
                            ) {
                              case "start":
                                e.swipeStart(i);
                                break;
                              case "move":
                                e.swipeMove(i);
                                break;
                              case "end":
                                e.swipeEnd(i);
                            }
                        }),
                        (e.prototype.swipeMove = function (i) {
                          var e,
                            t,
                            o,
                            s,
                            n,
                            r,
                            l = this;
                          return (
                            (n =
                              void 0 !== i.originalEvent
                                ? i.originalEvent.touches
                                : null),
                            !(
                              !l.dragging ||
                              l.scrolling ||
                              (n && 1 !== n.length)
                            ) &&
                              ((e = l.getLeft(l.currentSlide)),
                              (l.touchObject.curX =
                                void 0 !== n ? n[0].pageX : i.clientX),
                              (l.touchObject.curY =
                                void 0 !== n ? n[0].pageY : i.clientY),
                              (l.touchObject.swipeLength = Math.round(
                                Math.sqrt(
                                  Math.pow(
                                    l.touchObject.curX - l.touchObject.startX,
                                    2
                                  )
                                )
                              )),
                              (r = Math.round(
                                Math.sqrt(
                                  Math.pow(
                                    l.touchObject.curY - l.touchObject.startY,
                                    2
                                  )
                                )
                              )),
                              !l.options.verticalSwiping && !l.swiping && r > 4
                                ? ((l.scrolling = !0), !1)
                                : (!0 === l.options.verticalSwiping &&
                                    (l.touchObject.swipeLength = r),
                                  (t = l.swipeDirection()),
                                  void 0 !== i.originalEvent &&
                                    l.touchObject.swipeLength > 4 &&
                                    ((l.swiping = !0), i.preventDefault()),
                                  (s =
                                    (!1 === l.options.rtl ? 1 : -1) *
                                    (l.touchObject.curX > l.touchObject.startX
                                      ? 1
                                      : -1)),
                                  !0 === l.options.verticalSwiping &&
                                    (s =
                                      l.touchObject.curY > l.touchObject.startY
                                        ? 1
                                        : -1),
                                  (o = l.touchObject.swipeLength),
                                  (l.touchObject.edgeHit = !1),
                                  !1 === l.options.infinite &&
                                    ((0 === l.currentSlide && "right" === t) ||
                                      (l.currentSlide >= l.getDotCount() &&
                                        "left" === t)) &&
                                    ((o =
                                      l.touchObject.swipeLength *
                                      l.options.edgeFriction),
                                    (l.touchObject.edgeHit = !0)),
                                  !1 === l.options.vertical
                                    ? (l.swipeLeft = e + o * s)
                                    : (l.swipeLeft =
                                        e +
                                        o *
                                          (l.$list.height() / l.listWidth) *
                                          s),
                                  !0 === l.options.verticalSwiping &&
                                    (l.swipeLeft = e + o * s),
                                  !0 !== l.options.fade &&
                                    !1 !== l.options.touchMove &&
                                    (!0 === l.animating
                                      ? ((l.swipeLeft = null), !1)
                                      : void l.setCSS(l.swipeLeft))))
                          );
                        }),
                        (e.prototype.swipeStart = function (i) {
                          var e,
                            t = this;
                          if (
                            ((t.interrupted = !0),
                            1 !== t.touchObject.fingerCount ||
                              t.slideCount <= t.options.slidesToShow)
                          )
                            return (t.touchObject = {}), !1;
                          void 0 !== i.originalEvent &&
                            void 0 !== i.originalEvent.touches &&
                            (e = i.originalEvent.touches[0]),
                            (t.touchObject.startX = t.touchObject.curX =
                              void 0 !== e ? e.pageX : i.clientX),
                            (t.touchObject.startY = t.touchObject.curY =
                              void 0 !== e ? e.pageY : i.clientY),
                            (t.dragging = !0);
                        }),
                        (e.prototype.unfilterSlides =
                          e.prototype.slickUnfilter =
                            function () {
                              var i = this;
                              null !== i.$slidesCache &&
                                (i.unload(),
                                i.$slideTrack
                                  .children(this.options.slide)
                                  .detach(),
                                i.$slidesCache.appendTo(i.$slideTrack),
                                i.reinit());
                            }),
                        (e.prototype.unload = function () {
                          var e = this;
                          i(".slick-cloned", e.$slider).remove(),
                            e.$dots && e.$dots.remove(),
                            e.$prevArrow &&
                              e.htmlExpr.test(e.options.prevArrow) &&
                              e.$prevArrow.remove(),
                            e.$nextArrow &&
                              e.htmlExpr.test(e.options.nextArrow) &&
                              e.$nextArrow.remove(),
                            e.$slides
                              .removeClass(
                                "slick-slide slick-active slick-visible slick-current"
                              )
                              .attr("aria-hidden", "true")
                              .css("width", "");
                        }),
                        (e.prototype.unslick = function (i) {
                          var e = this;
                          e.$slider.trigger("unslick", [e, i]), e.destroy();
                        }),
                        (e.prototype.updateArrows = function () {
                          var i = this;
                          Math.floor(i.options.slidesToShow / 2),
                            !0 === i.options.arrows &&
                              i.slideCount > i.options.slidesToShow &&
                              !i.options.infinite &&
                              (i.$prevArrow
                                .removeClass("slick-disabled")
                                .attr("aria-disabled", "false"),
                              i.$nextArrow
                                .removeClass("slick-disabled")
                                .attr("aria-disabled", "false"),
                              0 === i.currentSlide
                                ? (i.$prevArrow
                                    .addClass("slick-disabled")
                                    .attr("aria-disabled", "true"),
                                  i.$nextArrow
                                    .removeClass("slick-disabled")
                                    .attr("aria-disabled", "false"))
                                : i.currentSlide >=
                                    i.slideCount - i.options.slidesToShow &&
                                  !1 === i.options.centerMode
                                ? (i.$nextArrow
                                    .addClass("slick-disabled")
                                    .attr("aria-disabled", "true"),
                                  i.$prevArrow
                                    .removeClass("slick-disabled")
                                    .attr("aria-disabled", "false"))
                                : i.currentSlide >= i.slideCount - 1 &&
                                  !0 === i.options.centerMode &&
                                  (i.$nextArrow
                                    .addClass("slick-disabled")
                                    .attr("aria-disabled", "true"),
                                  i.$prevArrow
                                    .removeClass("slick-disabled")
                                    .attr("aria-disabled", "false")));
                        }),
                        (e.prototype.updateDots = function () {
                          var i = this;
                          null !== i.$dots &&
                            (i.$dots
                              .find("li")
                              .removeClass("slick-active")
                              .end(),
                            i.$dots
                              .find("li")
                              .eq(
                                Math.floor(
                                  i.currentSlide / i.options.slidesToScroll
                                )
                              )
                              .addClass("slick-active"));
                        }),
                        (e.prototype.visibility = function () {
                          var i = this;
                          i.options.autoplay &&
                            (document[i.hidden]
                              ? (i.interrupted = !0)
                              : (i.interrupted = !1));
                        }),
                        (i.fn.slick = function () {
                          var i,
                            t,
                            o = this,
                            s = arguments[0],
                            n = Array.prototype.slice.call(arguments, 1),
                            r = o.length;
                          for (i = 0; i < r; i++)
                            if (
                              ("object" == typeof s || void 0 === s
                                ? (o[i].slick = new e(o[i], s))
                                : (t = o[i].slick[s].apply(o[i].slick, n)),
                              void 0 !== t)
                            )
                              return t;
                          return o;
                        });
                    });

                 /* setTimeout(()=>{
                    $(".header-minicart-content .main-carousel").slick({
                      dots: false,
                      //infinite: true,
                      speed: 300,
                      slidesToShow: 2,
                      adaptiveHeight: true,
                      arrows: true,
                      loop: false,
                    });
                  }, 100)*/
                    

                    //         if($total_price == 0){
                    //           console.log('remove', $('[data-shipping-remove]'));
                    //           $('[data-shipping-remove]').trigger('click');
                    //         }

                    //         $(window).resize(function(e){
                    //            $('.header-minicart-content .main-carousel').slick.refresh();
                    //         });

                    //  this._refreshCart();

                    //         $('.header-minicart-content .upsell-form button').on('click',function(){
                    //             console.log('v-id', $(this).data('variant-id'));
                    //             var quantity = 1;
                    //             var product_id=$(this).data('variant-id');
                    //             jquery_default.a.ajax({
                    //               type: 'POST',
                    //               url: '/cart/add.js',
                    //               data: 'quantity=' + quantity + '&id=' + product_id,
                    //               dataType: 'json'
                    //             }) // On success
                    //             .done(function (response) {
                    //               _this2.update.bind(_this2);
                    //             })

                    //           });
                  });
              },
            },
            {
              key: "unload",
              value: function unload() {
                this.carts.forEach(function (cart) {
                  cart.cartItems.forEach(function (cartItem) {
                    return cartItem.unload();
                  });
                });
                this.carts = [];
              },
            },
          ]);

          return MonoCart;
        })();

      /* harmony default export */ var Cart = new Cart_MonoCart();
      // CONCATENATED MODULE: ./source/scripts/utils/ScrollLock.js
      function ScrollLock_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function ScrollLock_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function ScrollLock_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          ScrollLock_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) ScrollLock_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var _document = document,
        body = _document.body;
      var ScrollLock_html = document.querySelector("html");

      function _blockScroll(event) {
        event.preventDefault();
        event.stopPropagation();
      }

      var ScrollLock =
        /*#__PURE__*/
        (function () {
          function ScrollLock() {
            ScrollLock_classCallCheck(this, ScrollLock);
          }

          ScrollLock_createClass(ScrollLock, null, [
            {
              key: "lock",
              value: function lock() {
                ScrollLock_html.classList.add("scroll-locked");
                body.style.top = -1 * window.pageYOffset;
                body.addEventListener("scroll", _blockScroll, false);
                body.addEventListener("touchmove", _blockScroll, {
                  passive: false,
                });
              },
            },
            {
              key: "unlock",
              value: function unlock() {
                ScrollLock_html.classList.remove("scroll-locked");
                body.style.top = "";
                body.removeEventListener("scroll", _blockScroll, false);
                body.removeEventListener("touchmove", _blockScroll, {
                  passive: false,
                });
              },
            },
          ]);

          return ScrollLock;
        })();

      // CONCATENATED MODULE: ./source/scripts/snippets/ProductMenu.js
      function ProductMenu_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function ProductMenu_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function ProductMenu_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          ProductMenu_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) ProductMenu_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var ProductMenu_ProductMenu =
        /*#__PURE__*/
        (function () {
          function ProductMenu(el, data, postMessage, inQuickshop) {
            var _this = this;

            ProductMenu_classCallCheck(this, ProductMenu);

            this.el = el;
            this.$el = jquery_default()(el);
            this.data = data;
            this.postMessage = postMessage;
            this.minimized = false;
            this.states = {
              selectOptions: "selectoptions",
              addToCart: "addtocart",
              addToCartSuccess: "addtocart-success",
            };
            this.dismissButton = this.el.querySelector(
              "[data-product-menu-slideout-dismiss]"
            );
            this.selectOptionsButton = this.el.querySelector(
              '[data-product-menu-button="selectoptions"]'
            );
            this.addToCartButton = this.el.querySelector(
              '[data-product-menu-button="addtocart"]'
            );
            this.slideout = this.el.querySelector(
              "[data-product-menu-slideout]"
            );
            this.$slideout = jquery_default()(this.slideout);
            this.defaultDesktopState = this.el.getAttribute(
              "data-product-menu-desktop-default-state"
            );
            this.defaultMobileState = this.el.getAttribute(
              "data-product-menu-mobile-default-state"
            );
            this.currentState = Layout.isBreakpoint("L")
              ? this.defaultDesktopState
              : this.defaultMobileState; // Form

            this.form = new ProductForm_ProductForm(this.$el, {
              product: this.data.product,
              moneyFormat: this.data.money_format,
              postMessage: postMessage,
              useHistory: !inQuickshop,
              enableCartRedirection: this.data.enable_cart_redirection,
              onSuccess: function onSuccess(response, quantity) {
                return _this._onAtcSuccess(response, quantity);
              },
              onError: function onError(response, error) {
                return _this._onAtcError(response, error);
              },
              onVariantChange: function onVariantChange(variant) {
                return _this._onVariantChange(variant);
              },
              onQuantityChange: function onQuantityChange(variant, quantity) {
                return _this._onQuantityChange(variant, quantity);
              },
              onAddToCart: function onAddToCart() {
                console.log("ATC");
                return _this._onAddToCart();
              },
            }); // atc button

            this.$productMenuButtonAddToCartPrice = jquery_default()(
              "[data-product-menu-button-addtocart-price]",
              this.el
            ); // Checkout button

            this.$productMenuButtonCheckoutPrice = jquery_default()(
              "[data-product-menu-button-checkout-price]",
              this.$el
            ); // Minicart title

            this.$productMiniCartTitle = jquery_default()(
              '[data-product-menu-slideout-heading="minicart-title"]',
              this.$el
            );
            this.cartTitleText = this.$productMiniCartTitle.text(); // Success and failure elements
            this.$productAtcFailureMessage = jquery_default()(
              "[data-product-menu-addtocart-failure-message]",
              this.$el
            );

            this.revertToDefaultState = function () {
              return _this._revertToDefaultState();
            };

            this.changeToAddToCartState = function () {
              return _this._changeState(_this.states.addToCart);
            };

            this._setMaxHeight = this._setMaxHeight.bind(this);
            this._setScrollLock = this._setScrollLock.bind(this);

            this._allowTouchMove = function (event) {
              return event.stopPropagation();
            }; // Prime the variant data

            this._onVariantChange(this.form.variantHelper.getSelectedVariant());

            jquery_default()(window).trigger(
              "product-variant-switch.product-menu",
              {
                variant: this.form.variantHelper.getSelectedVariant(),
                product: this.data.product,
              }
            );

            this._changeState(this.currentState);

            Layout.onBreakpointChange(this.revertToDefaultState);
            this.dismissButton.addEventListener(
              "click",
              this.revertToDefaultState
            );
            this.selectOptionsButton.addEventListener(
              "click",
              this.changeToAddToCartState
            );
            this.el.addEventListener("touchmove", this._allowTouchMove);

            this._setMaxHeight();

            window.addEventListener("resize", this._setMaxHeight);
            Cart.addCart(el);
          }

          ProductMenu_createClass(ProductMenu, [
            {
              key: "_setScrollLock",
              value: function _setScrollLock() {
                // If cart drawer is smaller than full screen, allow scrolling.
                if (this.el.clientHeight >= window.innerHeight) {
                  ScrollLock.lock();
                } else {
                  ScrollLock.unlock();
                }
              },
            },
            {
              key: "_changeState",
              value: function _changeState(state) {
                var _this2 = this;

                var animate =
                  arguments.length > 1 && arguments[1] !== undefined
                    ? arguments[1]
                    : true;
                jquery_default()(window).off("touchstart.menu");
                jquery_default()(window).off("touchend.menu touchcancel.menu");
                this.$el.off("touchstart.menu");
                this.$el.off("touchend.menu");
                var isDesktop = Layout.isBreakpoint("L");

                if (animate) {
                  var slideoutContent = this.el.querySelector(
                    '[data-product-menu-slideout-state="'.concat(
                      this.currentState,
                      '"]'
                    )
                  );
                  var $slideoutContent = jquery_default()(slideoutContent);
                  var shouldSlideoutAnimate =
                    $slideoutContent.length &&
                    slideoutContent.hasAttribute(
                      "data-product-menu-slideout-no-animation"
                    );
                  this.$slideout.slideUp({
                    duration: shouldSlideoutAnimate ? 0 : "",
                    complete: function complete() {
                      _this2.$slideout.removeClass(
                        "product-menu-slideout-visible"
                      );

                      _this2.$slideout.css("display", "");

                      _this2.currentState = state;

                      _this2.el.setAttribute("data-product-menu-state", state);

                      slideoutContent = _this2.el.querySelector(
                        '[data-product-menu-slideout-state="'.concat(
                          state,
                          '"]'
                        )
                      );
                      $slideoutContent = jquery_default()(slideoutContent);

                      if (!$slideoutContent.length) {
                        _this2._setScrollLock();

                        return;
                      }

                      shouldSlideoutAnimate = slideoutContent.hasAttribute(
                        "data-product-menu-slideout-no-animation"
                      );
                      var shouldShowSlideout =
                        (!isDesktop &&
                          !slideoutContent.hasAttribute(
                            "data-product-menu-mobile-slideout-hidden"
                          )) ||
                        (isDesktop &&
                          !slideoutContent.hasAttribute(
                            "data-product-menu-desktop-slideout-hidden"
                          ));

                      if (shouldShowSlideout) {
                        _this2.$slideout.slideDown({
                          duration: shouldSlideoutAnimate ? 0 : "",
                          start: function start() {
                            _this2.$slideout.css("display", "");

                            _this2.$slideout.addClass(
                              "product-menu-slideout-visible"
                            );
                          },
                          complete: _this2._setScrollLock,
                        });
                      } else {
                        _this2._setScrollLock();
                      }
                    },
                  });
                } else {
                  this.currentState = state;
                  this.el.setAttribute("data-product-menu-state", state);
                  window.requestAnimationFrame(this._setScrollLock);
                }

                jquery_default()(window).on("touchstart.menu", function () {
                  return _this2._minimizeSlideout();
                });
                jquery_default()(window).on(
                  "touchend.menu touchcancel.menu",
                  function () {
                    return _this2._maximizeSlideout();
                  }
                );
                this.$el.on("touchstart.menu", function (event) {
                  return event.stopPropagation();
                });
                this.$el.on("touchend.menu, ", function (event) {
                  return event.stopPropagation();
                });
              },
            },
            {
              key: "_setMaxHeight",
              value: function _setMaxHeight() {
                // Set max height to handle changing showing/hiding address bar on mobile devices
                // const newMaxHeight = this.minimized ? 0 : window.innerHeight;
                this.el.style.maxHeight = "".concat(
                  this.minimized ? 0 : window.innerHeight,
                  "px"
                );
              },
            },
            {
              key: "_minimizeSlideout",
              value: function _minimizeSlideout() {
                if (
                  !jquery_default()(
                    '[data-product-menu-slideout-state="'.concat(
                      this.currentState,
                      '"]'
                    ),
                    this.el
                  ).length
                ) {
                  return;
                }

                var height = this.slideout.getBoundingClientRect().height;
                this.$slideout.animate(
                  {
                    height: height / 2,
                    opacity: 0.2,
                  },
                  {
                    queue: false,
                    duration: 500,
                  }
                );
              },
            },
            {
              key: "_maximizeSlideout",
              value: function _maximizeSlideout() {
                if (
                  !jquery_default()(
                    '[data-product-menu-slideout-state="'.concat(
                      this.currentState,
                      '"]'
                    ),
                    this.el
                  ).length
                ) {
                  return;
                }

                var oldHeight = this.slideout.getBoundingClientRect().height;
                this.$slideout.css("height", "");
                var height = this.slideout.getBoundingClientRect().height;
                this.$slideout.css("height", oldHeight);
                this.$slideout.animate(
                  {
                    height: height,
                    opacity: 1,
                  },
                  {
                    queue: false,
                    duration: 500,
                  }
                );
              },
            },
            {
              key: "_clearFailure",
              value: function _clearFailure() {
                clearTimeout(this.errorMessageTimeout);
                this.$productAtcFailureMessage.hide(0);
              },
            },
            {
              key: "_revertToDefaultState",
              value: function _revertToDefaultState() {
                this._changeState(
                  Layout.isBreakpoint("L")
                    ? this.defaultDesktopState
                    : this.defaultMobileState
                );
              },
            },
            {
              key: "closeATCSuccess",
              value: function closeATCSuccess() {
                if (this.currentState === "addtocart-success") {
                  this._revertToDefaultState();
                }
              },
            },
            {
              key: "minimizeMenu",
              value: function minimizeMenu() {
                this._revertToDefaultState();

                this.el.classList.add("menu-minimized");
                this.minimized = true;

                this._setMaxHeight();
              },
            },
            {
              key: "maximizeMenu",
              value: function maximizeMenu() {
                this.minimized = false;
                this.el.classList.remove("menu-minimized");

                this._setMaxHeight();
              },
            },
            {
              key: "_onVariantChange",
              value: function _onVariantChange(variant) {
                // ATC
                this.$el
                  .find("[data-product-menu-button-addtocart]")
                  .prop("disabled", !variant.available); // ATC text

                this.$el
                  .find("[data-product-menu-button-addtocart-text]")
                  .text(
                    variant.available
                      ? this.data.text.product_available
                      : this.data.text.product_unavailable
                  ); // Options

                this.form.variantHelper.$options
                  .parent()
                  .removeClass("option-soldout")
                  .removeClass("option-selected")
                  .addClass("option-disabled");
                this.form.variantHelper.$options
                  .filter(":not(:disabled)")
                  .parent()
                  .removeClass("option-disabled");
                this.form.variantHelper.$options
                  .filter('[data-soldout="true"]')
                  .parent()
                  .addClass("option-soldout");
                this.form.variantHelper.$options
                  .filter(":checked")
                  .parent()
                  .addClass("option-selected");

                this._onQuantityChange(variant, this.form.quantity.value);
              },
            },
            {
              key: "_onQuantityChange",
              value: function _onQuantityChange(variant, quantity) {
                ////RTX CHANGE
                var selectedOption = document.querySelector(
                  `#rtx_buy_box_${currentProductId} input[name="selling_plan_select"]:checked`
                );
                if (selectedOption.value === "subsave") {
                  var price = Shopify.formatMoney(
                    variant.selling_plan_allocations[0].price * quantity,
                    this.data.money_format
                  );
                } else {
                  var price = Shopify.formatMoney(
                    variant.price * quantity,
                    this.data.money_format
                  );
                }
                //   var price = Shopify.formatMoney(variant.price * quantity, this.data.money_format);
                ///RTX CHANGE END
                this.$productMenuButtonAddToCartPrice
                  .text(price)
                  .each(function (index, el) {
                    return shopify_currency_converter_dist_default.a.update(el);
                  });
              },
            },
            {
              key: "_onAddToCart",
              value: function _onAddToCart() {
                this.addToCartButton.classList.add("loading");
              },
            },
            {
              key: "_onAtcSuccess",
              value: function _onAtcSuccess() {
                var _this3 = this;
                Cart.update()
                  .done(function (data) {
                    _this3.$productAtcFailureMessage.hide(0);

                    _this3._changeState(_this3.states.addToCartSuccess);

                    _this3.postMessage("cart:update", {
                      data: data,
                    });
                  })
                  .always(function () {
                    return _this3.addToCartButton.classList.remove("loading");
                  });
              },
            },
            {
              key: "_onAtcError",
              value: function _onAtcError(response, error) {
                var _this4 = this;

                this.addToCartButton.classList.remove("loading");
                this.$productAtcFailureMessage.html(error);

                if (this.form.variantHelper.isDefault()) {
                  this.$productAtcFailureMessage.slideDown(0);
                  this.$slideout.slideDown();
                } else {
                  this.$productAtcFailureMessage.slideDown();
                }

                this.errorMessageTimeout = setTimeout(function () {
                  if (_this4.form.variantHelper.isDefault()) {
                    _this4.$slideout.slideUp({
                      start: function start() {
                        _this4.$slideout.addClass(
                          "product-menu-slideout-visible"
                        );

                        _this4.$slideout.css("display", "");
                      },
                      complete: function complete() {
                        return _this4.$productAtcFailureMessage.slideUp(0);
                      },
                    });
                  } else {
                    _this4.$productAtcFailureMessage.slideUp();
                  }
                }, 5000);
              },
            },
            {
              key: "_updateMiniCartTotals",
              value: function _updateMiniCartTotals(cartData) {
                if (cartData.options.item_count === 0) {
                  this._changeState("selectoptions");
                  return;
                }
                this.$productMenuButtonCheckoutPrice.text(
                  Shopify.formatMoney(
                    cartData.options.total_price,
                    this.data.money_format
                  )
                );

                if (shopify_currency_converter_dist_default.a.isInitialised) {
                  shopify_currency_converter_dist_default.a.update(
                    this.$productMenuButtonCheckoutPrice[0]
                  );
                }
                this.$productMiniCartTitle.text(
                  ""
                    .concat(this.cartTitleText, " (")
                    .concat(cartData.options.item_count, ")")
                );
              },
            },
            {
              key: "onSectionMessage",
              value: function onSectionMessage(name, data) {
                if (name === "cart:update") {
                  this._updateMiniCartTotals(data.data);
                }

                if (name === "header-minicart:open") {
                  var transitionEnded = jquery_default.a.Deferred();
                  data(transitionEnded);
                  this.$el.one("transitionend", function () {
                    return transitionEnded.resolve();
                  });
                  this.minimizeMenu();
                  $(".product-menu-buttons-addtocart.button-wrap").removeAttr(
                    "style"
                  );
                  $(".product-menu-buttons-addtocart.button-wrap form").css(
                    "min-height",
                    "20vh"
                  );
                }

                if (name === "header-minicart:close") {
                  this.maximizeMenu();
                }
              },
            },
            {
              key: "unload",
              value: function unload() {
                jquery_default()(window).off("touchstart.menu");
                jquery_default()(window).off("touchend.menu touchcancel.menu");
                this.$el.off("touchstart.menu");
                this.$el.off("touchend.menu");
                Layout.offBreakpointChange(this.revertToDefaultState);
                this.dismissButton.removeEventListener(
                  "click",
                  this.revertToDefaultState
                );
                this.selectOptionsButton.removeEventListener(
                  "click",
                  this.changeToAddToCartState
                );
                this.el.removeEventListener("touchmove", this._allowTouchMove);
                window.removeEventListener("resize", this._setMaxHeight);
                this.form.unload();
              },
            },
          ]);

          return ProductMenu;
        })();

      // EXTERNAL MODULE: ./node_modules/@pixelunion/breakpoint/dist/cjs/index.js
      var cjs = __webpack_require__(35);

      // EXTERNAL MODULE: ./node_modules/@pixelunion/events/dist/EventHandler.js
      var EventHandler = __webpack_require__(146);
      var EventHandler_default =
        /*#__PURE__*/ __webpack_require__.n(EventHandler);

      // CONCATENATED MODULE: ./source/scripts/utils/loadYoutubeApi.js
      var apiReadyResolve = null;
      var apiReady = null;
      function loadYoutubeApi_load() {
        if (apiReady) return apiReady;
        apiReady = new Promise(function (resolve) {
          apiReadyResolve = resolve;
        });

        if (window.onYouTubeIframeAPIReady) {
          // If onYouTubeIframeAPIReady is already defined, we need to call it
          var _window = window,
            onYouTubeIframeAPIReady = _window.onYouTubeIframeAPIReady;

          window.onYouTubeIframeAPIReady = function () {
            onYouTubeIframeAPIReady();
            apiReadyResolve();
          };
        } else {
          window.onYouTubeIframeAPIReady = apiReadyResolve;
        }

        if (!document.querySelector("#youtube-api-script")) {
          var script = document.createElement("script");
          script.setAttribute("id", "youtube-api-script");
          script.setAttribute("type", "text/javascript");
          script.setAttribute("src", "https://www.youtube.com/iframe_api");
          document.body.appendChild(script);
        }

        if (window.YT && YT.loaded) {
          apiReadyResolve();
        }

        return apiReady;
      }
      // CONCATENATED MODULE: ./source/scripts/snippets/ProductZoom.js
      function ProductZoom_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function ProductZoom_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function ProductZoom_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          ProductZoom_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) ProductZoom_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var ProductZoom_ProductZoom =
        /*#__PURE__*/
        (function () {
          function ProductZoom(el) {
            var _this = this;

            ProductZoom_classCallCheck(this, ProductZoom);

            this.el = el;
            this.$el = jquery_default()(el);
            this.$img = jquery_default()(this.$el.children("img"));
            this.scale =
              this.$img[0].naturalWidth /
              this.$el[0].getBoundingClientRect().width;
            this.zoomable = this.scale >= 1.25;
            this.framerate = 60;
            this.zoomed = false;
            this.layoutHandler = this._layoutHandler.bind(this);
            this.resetZoom = this._resetZoom.bind(this);
            this.$img.on("rimg:load", function () {
              _this.disableZoom();

              _this.scale =
                _this.$img[0].naturalWidth /
                _this.$el[0].getBoundingClientRect().width;
              _this.zoomable = _this.scale >= 1.25;

              if (Layout.isBreakpoint("L") && _this.zoomable) {
                _this.enableZoom();

                _this._bindLayoutEvent();
              }
            });
          }

          ProductZoom_createClass(ProductZoom, [
            {
              key: "enableZoom",
              value: function enableZoom() {
                this.$el.addClass("product-image-zoomable");

                this._bindEvents();
              },
            },
            {
              key: "disableZoom",
              value: function disableZoom() {
                this.$el.removeClass("product-image-zoomable");

                this._unbindEvents();

                this._resetZoom();
              },
            },
            {
              key: "unload",
              value: function unload() {
                this._unbindLayoutEvent();

                this._unbindEvents();

                this._resetZoom();
              },
            },
            {
              key: "_bindEvents",
              value: function _bindEvents() {
                var _this2 = this;

                this.$el.on("click.product-zoom", function (event) {
                  _this2._toggleZoom(event.clientX, event.clientY);
                });
                jquery_default()(window).on(
                  "resize.product-zoom",
                  this.resetZoom
                );
              },
            },
            {
              key: "_unbindEvents",
              value: function _unbindEvents() {
                this.$el.off("click.product-zoom");
                jquery_default()(window).off(
                  "resize.product-zoom",
                  this.resetZoom
                );
              },
            },
            {
              key: "_bindLayoutEvent",
              value: function _bindLayoutEvent() {
                Layout.onBreakpointChange(this.layoutHandler);
              },
            },
            {
              key: "_unbindLayoutEvent",
              value: function _unbindLayoutEvent() {
                Layout.offBreakpointChange(this.layoutHandler);
              },
            },
            {
              key: "_layoutHandler",
              value: function _layoutHandler() {
                if (Layout.isBreakpoint("L")) {
                  this.enableZoom();
                } else {
                  this.disableZoom();
                }
              },
            },
            {
              key: "_toggleZoom",
              value: function _toggleZoom(clientX, clientY) {
                var _this3 = this;

                if (!this.zoomed) {
                  this.$el.on(
                    "mousemove.product-zoom",
                    just_debounce_default()(
                      function (event) {
                        _this3._positionZoom(event.clientX, event.clientY);
                      },
                      1000 / this.framerate,
                      true,
                      true
                    )
                  );
                  this.$el.on("mouseout.product-zoom", function () {
                    return _this3._resetZoom();
                  });
                  this.$el.addClass("product-image-zoomed");
                  this.$img.css("transform", "scale(".concat(this.scale, ")"));

                  this._positionZoom(clientX, clientY);

                  this.zoomed = true;
                } else {
                  this._resetZoom();
                }
              },
            },
            {
              key: "_resetZoom",
              value: function _resetZoom() {
                this.$el.off("mousemove.product-zoom");
                this.$el.off("mouseout.product-zoom");
                this.$el.removeClass("product-image-zoomed");
                this.$img.css("transform", "");
                this.zoomed = false;
              },
            },
            {
              key: "_positionZoom",
              value: function _positionZoom(clientX, clientY) {
                var figRect = this.$el[0].getBoundingClientRect();
                var imgRect = this.$img[0].getBoundingClientRect();
                var figHalfWidth = figRect.width / 2;
                var figHalfHeight = figRect.height / 2;
                var centerX = figRect.left + figHalfWidth;
                var centerY = figRect.top + figHalfHeight;
                var widthDiff = imgRect.width / 2 - figHalfWidth;
                var heightDiff = imgRect.height / 2 - figHalfHeight;
                var translateX =
                  (((centerX - clientX) / figHalfWidth) * widthDiff) /
                  this.scale;
                var translateY =
                  (((centerY - clientY) / figHalfHeight) * heightDiff) /
                  this.scale;
                this.$img.css(
                  "transform",
                  "scale("
                    .concat(this.scale, ") translate(")
                    .concat(translateX, "px, ")
                    .concat(translateY, "px)")
                );
              },
            },
          ]);

          return ProductZoom;
        })();

      // CONCATENATED MODULE: ./source/scripts/snippets/ProductGallery.js
      function ProductGallery_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function ProductGallery_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function ProductGallery_createClass(
        Constructor,
        protoProps,
        staticProps
      ) {
        if (protoProps)
          ProductGallery_defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
          ProductGallery_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var ProductGallery_ProductGallery =
        /*#__PURE__*/
        (function () {
          function ProductGallery(el) {
            var _this = this;

            var settings =
              arguments.length > 1 && arguments[1] !== undefined
                ? arguments[1]
                : {};

            ProductGallery_classCallCheck(this, ProductGallery);

            this.el = el;
            this.settings = settings;
            this.layout = this.el.dataset.productGalleryLayout;
            this.viewport = this.el.querySelector(
              "[data-product-gallery-viewport]"
            );
            this.navigation = this.el.querySelector(
              "[data-product-gallery-navigation]"
            );
            this.figures = this.viewport.querySelectorAll(
              "[data-product-gallery-figure]"
            );
            this.selected = {
              figure: this.viewport.querySelector(
                '[data-product-gallery-selected="true"]'
              ),
              thumbnail: null,
            };
            this.media = {
              images: [],
              models: [],
              videos: [],
            };
            var imageEls = this.viewport.querySelectorAll(
              '[data-media-type="image"][data-product-gallery-image-zoom]'
            );

            for (var i = 0; i < imageEls.length; i++) {
              this.media.images.push(new ProductZoom_ProductZoom(imageEls[i]));
            }

            this.events = new EventHandler_default.a();

            if (this.navigation) {
              this.selected.thumbnail = this.navigation.querySelector(
                '[data-product-gallery-selected="true"]'
              );
              this.navigationLayout =
                this.navigation.dataset.productGalleryNavigationLayout;
              this.navigationScroller = this.navigation.querySelector(
                "[data-product-gallery-navigation-scroller]"
              );
              this.navigationScrollUpButton = this.navigation.querySelector(
                "[data-product-gallery-navigation-scroll-up]"
              );
              this.navigationScrollDownButton = this.navigation.querySelector(
                "[data-product-gallery-navigation-scroll-down]"
              );
              this.navigationPreviousButton = this.navigation.querySelector(
                "[data-product-gallery-navigation-previous]"
              );
              this.navigationNextButton = this.navigation.querySelector(
                "[data-product-gallery-navigation-next]"
              );
              this.thumbnails = this.el.querySelectorAll(
                "[data-product-gallery-thumbnail]"
              );

              this.onThumbnailClick = function (e) {
                _this._selectMediaByIndex(
                  e.currentTarget.dataset.productGalleryThumbnail,
                  true
                );
              };

              this.thumbnails.forEach(function (thumbnail) {
                return _this.events.register(
                  thumbnail,
                  "click",
                  _this.onThumbnailClick
                );
              });

              this._initScroller();

              this._initPagination();
            }

            var features = [];

            if (this.el.querySelector('[data-media-type="model"]')) {
              this.events.register(this.viewport, "click", function (e) {
                if ("shopifyXr" in e.target.dataset) {
                  _this._onViewInYourSpaceClick(e.target);
                }
              });
              features.push({
                name: "model-viewer-ui",
                version: "1.0",
                onLoad: this._onModelLibraryLoad.bind(this),
              });
              features.push({
                name: "shopify-xr",
                version: "1.0",
              });
            }

            if (this.el.querySelector('[data-media-type="video"]')) {
              Promise.all([
                new Promise(function (resolve) {
                  if (!document.querySelector("#plyr-stylesheet")) {
                    var link = document.createElement("link");
                    link.setAttribute("id", "plyr-stylesheet");
                    link.setAttribute("rel", "stylesheet");
                    link.setAttribute(
                      "href",
                      "https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css"
                    );
                    link.onload = resolve;
                    document.body.appendChild(link);
                  } else {
                    resolve();
                  }
                }),
                new Promise(function (resolve) {
                  features.push({
                    name: "video-ui",
                    version: "1.0",
                    onLoad: resolve,
                  });
                }),
              ]).then(this._onVideoLibraryLoad.bind(this));
            }

            if (this.el.querySelector('[data-media-type="external_video"]')) {
              loadYoutubeApi_load().then(
                this._onExternalVideoLibraryLoad.bind(this)
              );
            }

            if (features.length) {
              Shopify.loadFeatures(features);
            }

            this._onBreakpointChange = this._onBreakpointChange.bind(this);
            cjs["onChange"](this._onBreakpointChange);

            this._onBreakpointChange();

            this.events.register(this.el, "rimg:load", function () {
              if (_this.flickity) {
                _this.flickity.resize();
              }

              _this._updateNavigationHeight();
            });
          }

          ProductGallery_createClass(ProductGallery, [
            {
              key: "selectMediaByVariant",
              value: function selectMediaByVariant(variant) {
                if (!variant.featured_media) return;
                var figure = this.viewport.querySelector(
                  '[data-media="'.concat(variant.featured_media.id, '"]')
                );

                this._selectMediaByIndex(figure.dataset.productGalleryFigure);
              },
            },
            {
              key: "pauseVideos",
              value: function pauseVideos() {
                var excludeVideo =
                  arguments.length > 0 && arguments[0] !== undefined
                    ? arguments[0]
                    : null;
                this.media.videos.forEach(function (v) {
                  if (v !== excludeVideo) {
                    v.pause();
                  }
                });
              },
            },
            {
              key: "pauseModels",
              value: function pauseModels() {
                var excludeModel =
                  arguments.length > 0 && arguments[0] !== undefined
                    ? arguments[0]
                    : null;
                this.media.models.forEach(function (m) {
                  if (m !== excludeModel && m.ui.interacting) {
                    m.ui.pause();
                  }
                });
              },
            },
            {
              key: "unload",
              value: function unload() {
                this._destroyScroller();

                this._destroyPagination();

                this.events.unregisterAll();
                this.media.videos.forEach(function (v) {
                  return v.unload();
                });
                this.media.images.forEach(function (i) {
                  return i.unload();
                });

                if (this.flickity) {
                  this.flickity.destroy();
                }

                if (this.navigation) {
                  this.navigation.style.height = "";

                  if (this.navigationScroller) {
                    this.navigationScroller.style.maxHeight = "";
                  }
                }

                cjs["offChange"](this._onBreakpointChange);
              },
            },
            {
              key: "_onModelLibraryLoad",
              value: function _onModelLibraryLoad() {
                var _this2 = this;

                var onPlayListener = function onPlayListener() {
                  if (_this2.flickity) {
                    _this2.flickity.unbindDrag();
                  }
                };

                var onPauseListener = function onPauseListener() {
                  if (_this2.flickity) {
                    _this2.flickity.bindDrag();
                  }
                };

                var controls = ["zoom-in", "zoom-out"];
                if (document.fullscreenEnabled) controls.push("fullscreen");
                this.viewport
                  .querySelectorAll('[data-media-type="model"]')
                  .forEach(function (modelFigure) {
                    var modelEl = modelFigure.querySelector("model-viewer");

                    _this2.media.models.push({
                      ui: new Shopify.ModelViewerUI(modelEl, {
                        controls: controls,
                      }),
                      el: modelEl,
                      figure: modelFigure,
                    });

                    _this2.events.register(
                      modelEl,
                      "shopify_model_viewer_ui_toggle_play",
                      onPlayListener
                    );

                    _this2.events.register(
                      modelEl,
                      "shopify_model_viewer_ui_toggle_pause",
                      onPauseListener
                    );

                    if (_this2.selected.figure.contains(modelEl)) {
                      if (_this2.flickity) {
                        _this2.flickity.resize();
                      }

                      _this2._updateNavigationHeight();
                    }
                  });
              },
            },
            {
              key: "_onViewInYourSpaceClick",
              value: function _onViewInYourSpaceClick(target) {
                if (
                  target.dataset.shopifyModel3dId ===
                  this.selected.figure.dataset.media
                )
                  return;
                var figure = this.viewport.querySelector(
                  '[data-media="'.concat(target.dataset.shopifyModel3dId, '"]')
                );

                this._selectMediaByEl(figure);
              },
            },
            {
              key: "_selectMediaByEl",
              value: function _selectMediaByEl(el) {
                this._selectMediaByIndex(
                  parseInt(el.dataset.productGalleryFigure, 10)
                );
              },
            },
            {
              key: "_onVideoLibraryLoad",
              value: function _onVideoLibraryLoad() {
                var _this3 = this;

                var videoFigures = this.viewport.querySelectorAll(
                  '[data-media-type="video"]'
                );

                var _loop = function _loop(i) {
                  var videoFigure = videoFigures[i];
                  var videoEl = videoFigure.querySelector("video");
                  var player = new Shopify.Plyr(videoEl, {
                    loop: {
                      active: _this3.settings.enable_video_looping,
                    },
                  });
                  var video = {
                    figure: videoFigure,
                    el: videoEl,
                    player: player,
                    restart: function restart() {
                      player.restart();
                      player.play();
                    },
                    pause: function pause() {
                      return player.pause();
                    },
                    play: function play() {
                      return player.play();
                    },
                    unload: function unload() {
                      return player.destroy();
                    },
                  };

                  _this3.events.register(videoFigure, "play", function () {
                    return _this3.pauseVideos(video);
                  });

                  _this3.media.videos.push(video);

                  if (_this3.selected.figure.contains(videoFigure)) {
                    if (_this3.flickity) {
                      _this3.flickity.resize();
                    }

                    _this3._updateNavigationHeight();
                  }
                };

                for (var i = 0; i < videoFigures.length; i++) {
                  _loop(i);
                }
              },
            },
            {
              key: "_onExternalVideoLibraryLoad",
              value: function _onExternalVideoLibraryLoad() {
                var _this4 = this;

                var videoFigures = this.viewport.querySelectorAll(
                  '[data-media-type="external_video"]'
                );

                var _loop2 = function _loop2(i) {
                  var videoFigure = videoFigures[i];
                  var videoEl = videoFigure.querySelector("iframe");
                  var player = new YT.Player(videoEl);
                  var video = {
                    figure: videoFigure,
                    el: videoEl,
                    player: player,
                    restart: function restart() {
                      player.seekTo(0);
                      player.playVideo();
                    },
                    pause: function pause() {
                      return player.pauseVideo();
                    },
                    play: function play() {
                      return player.playVideo();
                    },
                    unload: function unload() {},
                  };

                  _this4.events.register(
                    player,
                    "onStateChange",
                    function (_ref) {
                      var data = _ref.data;

                      if (
                        data === YT.PlayerState.ENDED &&
                        _this4.settings.enable_video_looping
                      ) {
                        video.restart();
                      } else if (data === YT.PlayerState.PLAYING) {
                        _this4.pauseVideos(video);
                      }
                    }
                  );

                  _this4.media.videos.push(video);

                  if (_this4.flickity) {
                    _this4.flickity.resize();
                  }

                  _this4._updateNavigationHeight();
                };

                for (var i = 0; i < videoFigures.length; i++) {
                  _loop2(i);
                }
              },
            },
            {
              key: "_onBreakpointChange",
              value: function _onBreakpointChange() {
                // If the resize was trigger by a fullscreen, do not do anything
                if (document.fullscreenElement) {
                  return;
                }

                if (this.flickity && cjs["min"]("L")) {
                  this._destroyFlickity();
                } else if (!this.flickity && cjs["max"]("M")) {
                  this._initFlickity();
                }

                this._updateNavigationHeight();
              },
            },
            {
              key: "_initPagination",
              value: function _initPagination() {
                var _this5 = this;

                if (
                  !this.navigationPreviousButton ||
                  !this.navigationNextButton
                )
                  return;

                this.navigatePrevious = function () {
                  var index =
                    (((parseInt(
                      _this5.selected.figure.dataset.productGalleryFigure,
                      10
                    ) -
                      1) %
                      _this5.figures.length) +
                      _this5.figures.length) %
                    _this5.figures.length;

                  _this5._selectMediaByIndex(index);
                };

                this.navigateNext = function () {
                  var index =
                    (parseInt(
                      _this5.selected.figure.dataset.productGalleryFigure,
                      10
                    ) +
                      1) %
                    _this5.figures.length;

                  _this5._selectMediaByIndex(index);
                };

                this.navigationPreviousButton.addEventListener(
                  "click",
                  this.navigatePrevious
                );
                this.navigationNextButton.addEventListener(
                  "click",
                  this.navigateNext
                );
              },
            },
            {
              key: "_destroyPagination",
              value: function _destroyPagination() {
                if (
                  !this.navigationPreviousButton ||
                  !this.navigationNextButton
                )
                  return;
                this.navigationPreviousButton.addEventListener(
                  "click",
                  this.navigatePrevious
                );
                this.navigationNextButton.addEventListener(
                  "click",
                  this.navigateNext
                );
              },
            },
            {
              key: "_initScroller",
              value: function _initScroller() {
                var _this6 = this;

                if (!this.navigationScroller) return;

                this._scrollerScrollUp = function () {
                  return _this6._scrollerScroll("up");
                };

                this._scrollerScrollDown = function () {
                  return _this6._scrollerScroll("down");
                };

                this._scrollerScrollScroll = function () {
                  return _this6._updateScrollerButtons();
                };

                this.navigationScrollUpButton.addEventListener(
                  "click",
                  this._scrollerScrollUp
                );
                this.navigationScrollDownButton.addEventListener(
                  "click",
                  this._scrollerScrollDown
                );
                this.navigationScroller.addEventListener(
                  "scroll",
                  this._scrollerScrollScroll
                );

                this._updateNavigationHeight();

                this._updateScrollerButtons();
              },
            },
            {
              key: "_destroyScroller",
              value: function _destroyScroller() {
                if (!this.navigationScroller) return;
                this.navigationScrollUpButton.removeEventListener(
                  "click",
                  this._scrollerScrollUp
                );
                this.navigationScrollDownButton.removeEventListener(
                  "click",
                  this._scrollerScrollDown
                );
                this.navigationScroller.removeEventListener(
                  "scroll",
                  this._scrollerScrollScroll
                );
              },
            },
            {
              key: "_scrollerScroll",
              value: function _scrollerScroll(direction) {
                var scrollerOrientation =
                  this.layout === "gallery-below" || cjs["max"]("M")
                    ? "horizontal"
                    : "vertical";

                if (scrollerOrientation === "horizontal") {
                  if (direction === "up") {
                    this._scrollerScrollHorizontal("left");
                  } else {
                    this._scrollerScrollHorizontal("right");
                  }

                  this._updateScrollerButtons();
                } else {
                  this._scrollerScrollVertical(direction);

                  this._updateScrollerButtons();
                }
              },
            },
            {
              key: "_scrollerScrollVertical",
              value: function _scrollerScrollVertical(direction) {
                var navigationScrollerTop =
                  this.navigationScroller.getBoundingClientRect().top;
                var closestDistance = Infinity;
                var closestIndex = -1;

                for (var i = 0; i < this.thumbnails.length; i++) {
                  var thumbnail = this.thumbnails[i];

                  var _thumbnail$getBoundin = thumbnail.getBoundingClientRect(),
                    top = _thumbnail$getBoundin.top,
                    bottom = _thumbnail$getBoundin.bottom;

                  var distance = Math.floor(
                    Math.abs(
                      navigationScrollerTop -
                        (direction === "up" ? bottom : top)
                    )
                  );

                  if (distance < closestDistance) {
                    closestDistance = distance;
                    closestIndex = i;
                  }
                }

                var $navigationScroller = $(this.navigationScroller);
                var navigateToImage =
                  direction === "up"
                    ? this.thumbnails[Math.max(closestIndex - 1, 0)]
                    : this.thumbnails[
                        Math.min(closestIndex + 1, this.thumbnails.length - 1)
                      ];
                var navigateToImageDistance =
                  navigateToImage.getBoundingClientRect().top -
                  navigationScrollerTop;
                $navigationScroller.animate(
                  {
                    scrollTop:
                      this.navigationScroller.scrollTop +
                      navigateToImageDistance,
                  },
                  {
                    queue: false,
                    duration: 500,
                  }
                );
              },
            },
            {
              key: "_scrollerScrollHorizontal",
              value: function _scrollerScrollHorizontal(direction) {
                var navigationScrollerLeft =
                  this.navigationScroller.getBoundingClientRect().left;
                var closestDistance = Infinity;
                var closestIndex = -1;

                for (var i = 0; i < this.thumbnails.length; i++) {
                  var thumbnail = this.thumbnails[i];

                  var _thumbnail$getBoundin2 =
                      thumbnail.getBoundingClientRect(),
                    left = _thumbnail$getBoundin2.left,
                    right = _thumbnail$getBoundin2.right;

                  var distance = Math.floor(
                    Math.abs(
                      navigationScrollerLeft -
                        (direction === "left" ? right : left)
                    )
                  );

                  if (distance < closestDistance) {
                    closestDistance = distance;
                    closestIndex = i;
                  }
                }

                var $navigationScroller = $(this.navigationScroller);
                var navigateToImage =
                  direction === "left"
                    ? this.thumbnails[Math.max(closestIndex - 1, 0)]
                    : this.thumbnails[
                        Math.min(closestIndex + 1, this.thumbnails.length - 1)
                      ];
                var navigateToImageDistance =
                  navigateToImage.getBoundingClientRect().left -
                  navigationScrollerLeft;
                $navigationScroller.animate(
                  {
                    scrollLeft:
                      this.navigationScroller.scrollLeft +
                      navigateToImageDistance,
                  },
                  {
                    queue: false,
                    duration: 500,
                  }
                );
              },
            },
            {
              key: "_updateScrollerButtons",
              value: function _updateScrollerButtons() {
                var direction =
                  this.layout === "gallery-below" || cjs["max"]("M")
                    ? "horizontal"
                    : "vertical";
                var scrollPosition;
                var totalPixels;
                var visiblePixels;

                if (direction === "horizontal") {
                  var _this$navigationScrol = this.navigationScroller,
                    scrollLeft = _this$navigationScrol.scrollLeft,
                    scrollWidth = _this$navigationScrol.scrollWidth,
                    clientWidth = _this$navigationScrol.clientWidth;
                  scrollPosition = scrollLeft;
                  totalPixels = scrollWidth;
                  visiblePixels = clientWidth;
                } else {
                  var _this$navigationScrol2 = this.navigationScroller,
                    scrollTop = _this$navigationScrol2.scrollTop,
                    scrollHeight = _this$navigationScrol2.scrollHeight,
                    clientHeight = _this$navigationScrol2.clientHeight;
                  scrollPosition = scrollTop;
                  totalPixels = scrollHeight;
                  visiblePixels = clientHeight;
                }

                if (scrollPosition === 0) {
                  this.navigationScrollUpButton.setAttribute("disabled", true);
                  this.navigationScrollDownButton.removeAttribute("disabled");
                } else if (totalPixels - visiblePixels === scrollPosition) {
                  this.navigationScrollUpButton.removeAttribute("disabled");
                  this.navigationScrollDownButton.setAttribute(
                    "disabled",
                    true
                  );
                } else {
                  this.navigationScrollUpButton.removeAttribute("disabled");
                  this.navigationScrollDownButton.removeAttribute("disabled");
                }
              },
            },
            {
              key: "_initFlickity",
              value: function _initFlickity() {
                var _this7 = this;

                this.flickity = new js_default.a(this.viewport, {
                  accessibility: true,
                  adaptiveHeight: true,
                  cellSelector: "[data-product-gallery-figure]",
                  cellAlign: "left",
                  friction: 0.8,
                  pageDots: false,
                  prevNextButtons: false,
                  selectedAttraction: 0.2,
                  wrapAround: true,
                }); // Flickity controls the pointerdown event which prevents model-viewer-ui from
                // triggering .play() on mouseup. This returns this functionality.

                this.flickity.on(
                  "staticClick",
                  function (event, pointer, cellElement) {
                    // Ignore anything but mouse events, touch events currently are bugged due to model-viewer-ui
                    // touchEnd triggers the model to pause after we play here, returning the model to a paused state
                    if (event.pointerType !== "mouse") return;

                    _this7.media.models.forEach(function (model) {
                      if (
                        cellElement.contains(model.el) &&
                        !model.ui.interacting
                      ) {
                        model.ui.play();
                      }
                    });
                  }
                );
                this.flickity.on("change", function (index) {
                  return _this7._onMediaSelect(index);
                });
              },
            },
            {
              key: "_destroyFlickity",
              value: function _destroyFlickity() {
                this.flickity.destroy();
                this.flickity = null;
              },
            },
            {
              key: "_onVideoSelect",
              value: function _onVideoSelect(video) {
                if (
                  this.settings.enable_video_autoplay &&
                  cjs["min"]("L") &&
                  this.layout !== "list"
                ) {
                  video.play();
                }
              },
            },
            {
              key: "_onMediaSelect",
              value: function _onMediaSelect(index) {
                var _this8 = this;

                var focus =
                  arguments.length > 1 && arguments[1] !== undefined
                    ? arguments[1]
                    : false;
                var figure = this.figures[index];
                this.selected.figure.dataset.productGallerySelected = false;

                if (this.layout !== "list") {
                  this.selected.figure.setAttribute("aria-hidden", true);
                }

                this.selected.figure = figure;
                this.selected.figure.dataset.productGallerySelected = true;

                if (this.layout !== "list") {
                  this.selected.figure.setAttribute("aria-hidden", false);
                }

                if (this.navigation) {
                  var thumbnail = this.thumbnails[index];
                  this.selected.thumbnail.dataset.productGallerySelected = false;
                  this.selected.thumbnail = thumbnail;
                  this.selected.thumbnail.dataset.productGallerySelected = true;
                }

                var viewInYourSpaceEls =
                  this.el.querySelectorAll("[data-shopify-xr]");

                var setViewInYourSpaceID = function setViewInYourSpaceID(id) {
                  for (var i = 0; i < viewInYourSpaceEls.length; i++) {
                    viewInYourSpaceEls[i].dataset.shopifyModel3dId = id;
                  }
                };

                if (viewInYourSpaceEls.length) {
                  setViewInYourSpaceID(
                    viewInYourSpaceEls[0].dataset.defaultModelId
                  );
                }

                this.pauseVideos();
                this.pauseModels();

                if (focus) {
                  this.media.videos.forEach(function (v) {
                    if (v.figure === _this8.selected.figure) {
                      v.el.focus();
                    }
                  });
                  this.media.models.forEach(function (m) {
                    if (m.figure === _this8.selected.figure) {
                      m.ui.play();
                      m.el.focus();
                    }
                  });
                }

                switch (this.selected.figure.dataset.mediaType) {
                  case "video":
                  case "external_video":
                    this._onVideoSelect(
                      this.media.videos.filter(function (v) {
                        return v.figure === _this8.selected.figure;
                      })[0]
                    );

                    break;

                  case "model":
                    setViewInYourSpaceID(this.selected.figure.dataset.media);
                    break;

                  default:
                    break;
                }

                this._updateNavigationHeight();
              },
            },
            {
              key: "_selectMediaByIndex",
              value: function _selectMediaByIndex(index) {
                var focus =
                  arguments.length > 1 && arguments[1] !== undefined
                    ? arguments[1]
                    : false;

                if (this.flickity) {
                  this.flickity.select(index);
                }

                this._onMediaSelect(index, focus);
              },
            },
            {
              key: "_updateNavigationHeight",
              value: function _updateNavigationHeight() {
                if (!this.navigation) return;

                if (this.navigationLayout !== "thumbnails") {
                  this.navigation.style.height = "";

                  if (this.navigationScroller) {
                    this.navigationScroller.style.maxHeight = "";
                  }

                  return;
                }

                var direction =
                  this.layout === "gallery-below" || cjs["max"]("M")
                    ? "horizontal"
                    : "vertical";
                var size = direction === "vertical" ? "height" : "width";
                var sizeScroll =
                  direction === "vertical" ? "scrollHeight" : "scrollWidth";
                var available =
                  this.selected.figure.getBoundingClientRect()[size];
                var required = this.navigationScroller[sizeScroll];
                var minimum = 280;

                if (required < available) {
                  this.navigationScrollUpButton.setAttribute("hidden", true);
                  this.navigationScrollDownButton.setAttribute("hidden", true);
                } else {
                  this.navigationScrollUpButton.removeAttribute("hidden");
                  this.navigationScrollDownButton.removeAttribute("hidden");
                }

                if (direction === "vertical") {
                  this.navigation.style.height = "".concat(
                    available < minimum ? minimum : available,
                    "px"
                  );
                  this.navigationScroller.style.maxHeight = "5000px";
                } else {
                  this.navigation.style.height = "";
                  this.navigationScroller.style.maxHeight = "";
                }
              },
            },
          ]);

          return ProductGallery;
        })();

      // CONCATENATED MODULE: ./source/scripts/snippets/ProductDetails.js
      function ProductDetails_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function ProductDetails_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function ProductDetails_createClass(
        Constructor,
        protoProps,
        staticProps
      ) {
        if (protoProps)
          ProductDetails_defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
          ProductDetails_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var ProductDetails_ProductDetails =
        /*#__PURE__*/
        (function () {
          function ProductDetails($el, section, inQuickshop) {
            var _this = this;

            ProductDetails_classCallCheck(this, ProductDetails);

            this.el = $el[0];
            this.data = section.data;
            this.onboarding = this.data.onboarding;
            this.postMessage = section.postMessage;
            this.inQuickshop = inQuickshop;
            this.type = section.type;
            this.$el = $el;
            this.$window = jquery_default()(window);
            this.$productImageItems = jquery_default()(
              "[data-product-image]",
              $el
            );
            this.$productDetails = jquery_default()(
              "[data-product-details]",
              $el
            );
            this.$menu = jquery_default()("[data-product-menu-container]", $el);
            this.$atc = jquery_default()("[data-product-atc]", $el);
            this.positionDetails = this._positionDetails.bind(this);
            this._handleVariantChange = this._handleVariantChange.bind(this); // Alert

            this.$alert = jquery_default()(".product-alert", $el);
            this.productGallery = new ProductGallery_ProductGallery(
              this.el.querySelector("[data-product-gallery]"),
              {
                enable_video_autoplay: section.data.gallery_video_autoplay,
                enable_video_looping: section.data.gallery_video_looping,
              }
            );
            this.rte = new RTE_RTE(
              this.$productDetails[0].querySelector(".rte")
            );
            this.listeningForVariantChange = false;
            this.listenForVariantChange(); // Form

            if (!this.onboarding && this.data.form_is_inline) {
              this.form = new ProductForm_ProductForm(
                this.$el.find("[data-product-details]"),
                {
                  form: jquery_default()(
                    "[data-product-form-inline]",
                    this.$el
                  ),
                  product: this.data.product,
                  moneyFormat: this.data.money_format,
                  postMessage: section.postMessage,
                  useHistory: this.data.use_history,
                  enableCartRedirection: this.data.enable_cart_redirection,
                  onAddToCart: function onAddToCart() {
                    return _this._onATC();
                  },
                  onSuccess: function onSuccess(response, quantity) {
                    return _this._onAtcSuccess(response, quantity);
                  },
                  onError: function onError(response, error) {
                    return _this._onAtcError(response, error);
                  },
                }
              );

              if (this.type !== "dynamic-product" && !this.inQuickshop) {
                jquery_default()(window).trigger("product-variant-switch", {
                  variant: this.form.variantHelper.getSelectedVariant(),
                });
              }
            } // Handle layout changes

            this.onLayoutChange = function () {
              return _this._layout();
            };

            Layout.onBreakpointChange(this.onLayoutChange); // Initial positioning

            this._layout(); // Events

            this.events = [
              // Dismiss alert
              this.$alert
                .find(".product-alert-dismiss")
                .on("click.product", function () {
                  return _this._hideAlert();
                }),
            ];
          }

          ProductDetails_createClass(ProductDetails, [
            {
              key: "listenForVariantChange",
              value: function listenForVariantChange() {
                if (!this.listeningForVariantChange) {
                  jquery_default()(window).on(
                    "product-variant-switch",
                    this._handleVariantChange
                  );
                  this.listeningForVariantChange = true;
                }
              },
            },
            {
              key: "stopListeningForVariantChange",
              value: function stopListeningForVariantChange() {
                if (this.listeningForVariantChange) {
                  jquery_default()(window).off(
                    "product-variant-switch",
                    this._handleVariantChange
                  );
                  this.listeningForVariantChange = false;
                }
              },
            },
            {
              key: "unload",
              value: function unload() {
                this.$window.off(".product-details");
                Layout.offBreakpointChange(this.onLayoutChange);

                this._hideAlert();

                this.rte.unload();
                if (this.form) this.form.unload();
                this.stopListeningForVariantChange();
              },
            },
            {
              key: "_layout",
              value: function _layout() {
                if (Layout.isBreakpoint("L")) {
                  this.$window.on(
                    "resize.product-details",
                    this.positionDetails
                  );
                } else {
                  this.$window.off("resize.product-details");
                }

                this._positionDetails();
              },
            },
            {
              key: "_positionDetails",
              value: function _positionDetails() {
                var isSticky = false;

                if (Layout.isBreakpoint("L")) {
                  var imagesHeight = jquery_default()(
                    "[data-product-gallery]"
                  ).outerHeight();
                  var detailsHeight = this.$productDetails.outerHeight();
                  var windowHeight = window.innerHeight;
                  var menuHeight = this.$menu.outerHeight() || 0;
                  var availableHeight = windowHeight - menuHeight;
                  isSticky =
                    imagesHeight > availableHeight &&
                    detailsHeight < availableHeight;
                }

                this.$productDetails.toggleClass(
                  "product-details-sticky",
                  isSticky
                );
              },
            },
            {
              key: "_onATC",
              value: function _onATC() {
                this._hideAlert();

                this.$atc[0].classList.add("loading");
              },
            },
            {
              key: "_onAtcSuccess",
              value: function _onAtcSuccess() {
                this.$atc[0].classList.remove("loading");
                this.postMessage("header-minicart:set-open");
              },
            },
            {
              key: "_onAtcError",
              value: function _onAtcError(response, error) {
                this.$atc[0].classList.remove("loading");

                this._showAlert(error, "error");
              },
            },
            {
              key: "_handleVariantChange",
              value: function _handleVariantChange(event, data) {
                this._onVariantChange(data);
              },
            },
            {
              key: "_onVariantChange",
              value: function _onVariantChange(_ref) {
                var variant = _ref.variant,
                  firstLoad = _ref.firstLoad,
                  isProduct = _ref.isProduct;

                if (isProduct && !isProduct(this.data.product)) {
                  return;
                }

                if (firstLoad) {
                  if (this.type !== "dynamic-product") {
                    this._positionDetails();
                  }
                }

                this.productGallery.selectMediaByVariant(variant);
                this.$el
                  .find(".product-form-inline-atc-button")
                  .prop("disabled", !variant.available)
                  .find("[data-product-inline-atc-text]")
                  .text(
                    variant.available
                      ? this.data.text.product_available
                      : this.data.text.product_unavailable
                  );
                this.$productDetails
                  .find("[data-variant-price]")
                  .text(
                    Shopify.formatMoney(variant.price, this.data.money_format)
                  )
                  .each(function (index, el) {
                    return shopify_currency_converter_dist_default.a.update(el);
                  });
              },
            },
            {
              key: "_showAlert",
              value: function _showAlert(message) {
                var _this2 = this;

                var type =
                  arguments.length > 1 && arguments[1] !== undefined
                    ? arguments[1]
                    : null;

                this._hideAlert(); // Add class name

                if (type) {
                  this.alertClassName = "product-alert-".concat(type);
                  this.$alert.addClass(this.alertClassName);
                } // Set text

                var $message = this.$alert.find(".product-alert-message");
                $message.html(message);
                this.$alert.one("revealer-hide", function (event) {
                  return $message.text("");
                }); // Show

                this.$alert.revealer("show"); // Positioning

                this._positionAlert();

                jquery_default()(window).on(
                  "scroll.product-alert",
                  function (event) {
                    return _this2._positionAlert();
                  }
                );
                this.alertTimeout = setTimeout(function () {
                  _this2._hideAlert();
                }, 3000);
              },
            },
            {
              key: "_hideAlert",
              value: function _hideAlert() {
                clearTimeout(this.alertTimeout); // Remove custom class names

                this.$alert.removeClass(this.alertClassName);
                this.alertClassName = null; // Stop positioning

                jquery_default()(window).off("scroll.product-alert"); // Hide

                this.$alert.revealer("hide");
              },
            },
            {
              key: "_positionAlert",
              value: function _positionAlert() {
                if (this.inQuickshop) {
                  return;
                }

                this.$alert[0].style.top = window.pageYOffset;
                this.$alert[0].classList.add("product-alert-fixed");
              },
            },
            {
              key: "gallery",
              get: function get() {
                return this.productGallery;
              },
            },
          ]);

          return ProductDetails;
        })();

      // CONCATENATED MODULE: ./source/scripts/snippets/ProductQuickshop.js
      function ProductQuickshop_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function ProductQuickshop_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function ProductQuickshop_createClass(
        Constructor,
        protoProps,
        staticProps
      ) {
        if (protoProps)
          ProductQuickshop_defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
          ProductQuickshop_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var ProductQuickshop_ProductQuickshop =
        /*#__PURE__*/
        (function () {
          function ProductQuickshop($parent, $el, postMessage) {
            ProductQuickshop_classCallCheck(this, ProductQuickshop);

            // Quickshop isn't a section, but we need this section-like object for ProductDetails functionality
            this.mockSection = {
              postMessage: postMessage,
              el: $el[0],
            };
            this.$parent = $parent;
            this.$el = $el;
            this.postMessage = postMessage;
            this.$details = jquery_default()(
              "[data-product-details]",
              this.$el
            );
            this.$description = this.$el.find("[data-product-description]");
            this.$featuredImage = jquery_default()(
              "[data-product-image-featured]",
              this.$el
            );
            this.$imageThumbs = jquery_default()(
              "[data-product-image-thumb]",
              this.$el
            );
            this.$imageThumbsSlide = jquery_default()(
              "[data-product-quickshop-image-thumbnails-slide]",
              this.$el
            );
            this.loaded = false;

            try {
              this.data = JSON.parse(
                jquery_default()("[data-quickshop-data]", this.$el).text()
              );
              this.mockSection.data = this.data;
              this.formIsInline = this.data.form_is_inline;
            } catch (error) {
              console.warn(
                "Quickshop: invalid quickshop data found. ".concat(
                  error.message
                )
              );
              return;
            }

            this._bindEvents();
          }

          ProductQuickshop_createClass(ProductQuickshop, [
            {
              key: "_init",
              value: function _init() {
                var $priceEl = jquery_default()(
                  "[data-variant-price]",
                  this.$details
                );
                var $compareAtPriceEl = jquery_default()(
                  "[data-variant-compare-at-price]",
                  this.$details
                );
                shopify_currency_converter_dist_default.a.update(
                  $priceEl.get(0)
                );
                shopify_currency_converter_dist_default.a.update(
                  $compareAtPriceEl.get(0)
                );
                this.$parent.append(this.$el);
                this.productDetails = new ProductDetails_ProductDetails(
                  this.$el,
                  this.mockSection,
                  true
                );

                if (!this.formIsInline) {
                  this.productMenu = new ProductMenu_ProductMenu(
                    this.$el[0].querySelector("[data-product-menu]"),
                    this.data,
                    this.postMessage,
                    true
                  );
                }

                if (window.Shopify.PaymentButton) {
                  window.Shopify.PaymentButton.init();
                }

                rimg_shopify_dist_index_es.watch(this.$el[0]);
                this.loaded = true;
              },
            },
            {
              key: "_bindEvents",
              value: function _bindEvents() {
                var _this = this;

                jquery_default()("[data-product-item-image]", this.$parent).on(
                  "click.product-quickshop",
                  function (event) {
                    // Minimum height is 500 pixels and must be desktop
                    if (!Layout.isBreakpoint("L") || window.innerHeight < 500) {
                      return;
                    }

                    event.preventDefault();
                    event.stopPropagation();

                    _this._open();
                  }
                );
                jquery_default()("[data-quickshop-container]", this.$el).on(
                  "click.product-quickshop",
                  function (event) {
                    event.stopPropagation();
                  }
                );
              },
            },
            {
              key: "_unbindEvents",
              value: function _unbindEvents() {
                jquery_default()("[data-product-item-image]", this.$parent).off(
                  "click.product-quickshop"
                );
                jquery_default()("[data-quickshop-container]", this.$el).off(
                  "click.product-quickshop"
                );
              },
            },
            {
              key: "_bindOnOpen",
              value: function _bindOnOpen() {
                var _this2 = this;

                jquery_default()(
                  "[data-product-quickshop-button-dismiss]",
                  this.$el
                ).on("click.product-quickshop", function () {
                  _this2._close();
                });
                this.$el.on("click.product-quickshop", function () {
                  _this2._close();
                });
                jquery_default()(document).on(
                  "keyup.product-quickshop",
                  function (event) {
                    if (event.keyCode == 27) {
                      _this2._close();
                    }
                  }
                );
                this.productDetails.listenForVariantChange();
                jquery_default()(window).on(
                  "resize.product-quickshop",
                  function () {
                    // If the resize was trigger by a fullscreen, do not do anything
                    if (document.fullscreenElement) {
                      return;
                    } // Minimum height is 500 pixels and must be desktop

                    if (Layout.isBreakpoint("L") && window.innerHeight >= 500) {
                      return;
                    }

                    _this2._close();
                  }
                );
              },
            },
            {
              key: "_unbindOnOpen",
              value: function _unbindOnOpen() {
                jquery_default()(
                  "[data-product-quickshop-button-dismiss]",
                  this.$el
                ).off("click.product-quickshop");
                this.$el.off("click.product-quickshop");
                jquery_default()(document).off("keyup.product-quickshop");
                this.productDetails.stopListeningForVariantChange();
              },
            },
            {
              key: "_open",
              value: function _open() {
                if (!this.loaded) {
                  this._init();
                }

                this._bindOnOpen();

                this.$el.revealer("show");
                ScrollLock.lock();
              },
            },
            {
              key: "_close",
              value: function _close() {
                this.productDetails.gallery.pauseModels();
                this.productDetails.gallery.pauseVideos();

                this._unbindOnOpen();

                this.$el.revealer("hide");

                if (this.productMenu) {
                  this.productMenu.closeATCSuccess();
                }

                ScrollLock.unlock();
              },
            },
            {
              key: "onSectionMessage",
              value: function onSectionMessage(name, data) {
                if (this.productMenu) {
                  this.productMenu.onSectionMessage(name, data);
                }

                if (name === "header-minicart:set-open" && this.loaded) {
                  this._close();
                }
              },
            },
            {
              key: "unload",
              value: function unload() {
                if (this.productMenu) {
                  this.productMenu.unload();
                }

                this._unbindOnOpen();

                this._unbindEvents();
              },
            },
          ]);

          return ProductQuickshop;
        })();

      // CONCATENATED MODULE: ./source/scripts/snippets/ProductItem.js
      function ProductItem_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function ProductItem_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function ProductItem_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          ProductItem_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) ProductItem_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var ProductItem_ProductItem =
        /*#__PURE__*/
        (function () {
          function ProductItem($el, postMessage) {
            ProductItem_classCallCheck(this, ProductItem);

            this.$el = $el;
            this.postMessage = postMessage;

            if (this.$el.is("[data-use-quickshop]")) {
              var productQuickshopMarkup = jquery_default()(
                "[data-quickshop-markup]",
                this.$el
              ).text();

              try {
                this.productQuickshop = new ProductQuickshop_ProductQuickshop(
                  this.$el,
                  jquery_default()(JSON.parse(productQuickshopMarkup)),
                  this.postMessage
                );
              } catch (error) {
                console.warn(
                  "Product item: invalid quickshop data found. ".concat(
                    error.message
                  )
                );
                return;
              }
            }

            this._objectFitPolyfill();
          }

          ProductItem_createClass(ProductItem, [
            {
              key: "onSectionMessage",
              value: function onSectionMessage(name, data) {
                if (this.productQuickshop) {
                  this.productQuickshop.onSectionMessage(name, data);
                }
              },
            },
            {
              key: "_isObjectFitAvailable",
              value: function _isObjectFitAvailable() {
                return "objectFit" in document.documentElement.style;
              },
            },
            {
              key: "_objectFitPolyfill",
              value: function _objectFitPolyfill() {
                if (this._isObjectFitAvailable()) {
                  return;
                }

                var $figure = jquery_default()(
                  "[data-product-item-image]",
                  this.$el
                );
                var featuredSrc = jquery_default()(
                  "img:not(.product-image-alternate)",
                  $figure
                ).attr("src");
                var alternateSrc = jquery_default()(
                  ".product-image-alternate",
                  $figure
                ).attr("src");
                $figure.addClass("product-item-image-no-objectfit");
                $figure.css(
                  "background-image",
                  'url("'.concat(featuredSrc, '")')
                );

                if (alternateSrc) {
                  this.$el.on("mouseover", function () {
                    $figure.css(
                      "background-image",
                      'url("'.concat(alternateSrc, '")')
                    );
                  });
                  this.$el.on("mouseleave", function () {
                    $figure.css(
                      "background-image",
                      'url("'.concat(featuredSrc, '")')
                    );
                  });
                }
              },
            },
            {
              key: "unload",
              value: function unload() {
                if (this.productQuickshop) {
                  this.productQuickshop.unload();
                }
              },
            },
          ]);

          return ProductItem;
        })();

      // CONCATENATED MODULE: ./source/scripts/snippets/ProductHighlights.js
      function ProductHighlights_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function ProductHighlights_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function ProductHighlights_createClass(
        Constructor,
        protoProps,
        staticProps
      ) {
        if (protoProps)
          ProductHighlights_defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
          ProductHighlights_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var ProductHighlights_ProductHighlights =
        /*#__PURE__*/
        (function () {
          function ProductHighlights(el, postMessage) {
            ProductHighlights_classCallCheck(this, ProductHighlights);

            this.el = el instanceof jquery_default.a ? el[0] : el;
            this.$el =
              el instanceof jquery_default.a ? el : jquery_default()(el);
            this.postMessage = postMessage;
            this.onBreakpointChange = this._onBreakpointChange.bind(this);
            this.productItems = [];

            this._load();
          }

          ProductHighlights_createClass(ProductHighlights, [
            {
              key: "onSectionMessage",
              value: function onSectionMessage(name, data) {
                // propogate through productItems, for use by quickshops
                this.productItems.forEach(function (productItem) {
                  return productItem.onSectionMessage(name, data);
                });
              },
            },
            {
              key: "reload",
              value: function reload() {
                this.unload();

                this._load();
              },
            },
            {
              key: "unload",
              value: function unload() {
                Layout.offBreakpointChange(this.onResize);
                this.productItems.forEach(function (productItem) {
                  return productItem.unload();
                });
              },
            },
            {
              key: "_unloadFlickity",
              value: function _unloadFlickity() {
                if (this.flickity) {
                  this.flickity.destroy();
                  this.flickity = null;
                  jquery_default()("[data-product-item]", this.$el).attr(
                    "style",
                    ""
                  );
                }
              },
            },
            {
              key: "_loadFlickity",
              value: function _loadFlickity() {
                var container = this.el.querySelector(
                  ".product-highlights-mobile-wrapper"
                );

                if (!container) {
                  return;
                }

                if (!this.flickity) {
                  this.flickity = new js_default.a(container, {
                    cellSelector: "[data-product-item]",
                    contain: true,
                    prevNextButtons: false,
                    pageDots: false,
                    selectedAttraction: 0.02,
                  });
                }
              },
            },
            {
              key: "_load",
              value: function _load() {
                var _this = this;

                jquery_default()("[data-product-item]", this.$el).each(
                  function (index, productItem) {
                    _this.productItems.push(
                      new ProductItem_ProductItem(
                        jquery_default()(productItem),
                        _this.postMessage
                      )
                    );
                  }
                );
                Layout.onBreakpointChange(this.onBreakpointChange);

                if (Layout.isBreakpoint("S", "M")) {
                  this._loadFlickity();
                }
              },
            },
            {
              key: "_onBreakpointChange",
              value: function _onBreakpointChange() {
                if (Layout.isBreakpoint("M") || Layout.isBreakpoint("S")) {
                  this._loadFlickity();
                } else {
                  this._unloadFlickity();
                }
              },
            },
          ]);

          return ProductHighlights;
        })();

      // CONCATENATED MODULE: ./source/scripts/sections/DynamicFeaturedProducts.js
      function DynamicFeaturedProducts_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function DynamicFeaturedProducts_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function DynamicFeaturedProducts_createClass(
        Constructor,
        protoProps,
        staticProps
      ) {
        if (protoProps)
          DynamicFeaturedProducts_defineProperties(
            Constructor.prototype,
            protoProps
          );
        if (staticProps)
          DynamicFeaturedProducts_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var DynamicFeaturedProducts_DynamicFeaturedProducts =
        /*#__PURE__*/
        (function () {
          function DynamicFeaturedProducts(section) {
            DynamicFeaturedProducts_classCallCheck(
              this,
              DynamicFeaturedProducts
            );

            this.section = section;
            this.$el = jquery_default()(section.el);
            this.productHighlights = new ProductHighlights_ProductHighlights(
              this.$el,
              this.section.postMessage
            );
          }

          DynamicFeaturedProducts_createClass(DynamicFeaturedProducts, [
            {
              key: "onSectionMessage",
              value: function onSectionMessage(name, data) {
                this.productHighlights.onSectionMessage(name, data);
              },
            },
            {
              key: "onSectionUnload",
              value: function onSectionUnload() {
                this.productHighlights.unload();
              },
            },
          ]);

          return DynamicFeaturedProducts;
        })();

      // CONCATENATED MODULE: ./source/scripts/sections/DynamicSlideshow.js
      function DynamicSlideshow_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function DynamicSlideshow_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function DynamicSlideshow_createClass(
        Constructor,
        protoProps,
        staticProps
      ) {
        if (protoProps)
          DynamicSlideshow_defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
          DynamicSlideshow_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var DynamicSlideshow_DynamicSlideshow =
        /*#__PURE__*/
        (function () {
          function DynamicSlideshow(section) {
            DynamicSlideshow_classCallCheck(this, DynamicSlideshow);
            this.el = section.el;
            this.$el = jquery_default()(section.el);
            this.data = section.data;
            this.events = new EventHandler_default.a();
            this.$slideshow = jquery_default()("[data-slideshow]", this.$el);
            this.$slides = jquery_default()("[data-slideshow-slide]", this.$el);
            this.autoplay =
              this.data.should_autoplay && this.data.autoplay
                ? this.data.autoplay * 1000
                : false;

            if (this.data.slide_count > 1) {
              this._initFlickity();

              this._bindEvents();
            }
          }

          DynamicSlideshow_createClass(DynamicSlideshow, [
            {
              key: "_initFlickity",
              value: function _initFlickity() {
                var _this = this;

                this.flickity = new js_default.a(this.$slideshow[0], {
                  accessibility: true,
                  adaptiveHeight: true,
                  autoPlay: this.autoplay,
                  cellAlign: "left",
                  cellSelector: "[data-slideshow-slide]",
                  friction: 0.8,
                  pageDots: false,
                  pauseAutoPlayOnHover: true,
                  prevNextButtons: true,
                  selectedAttraction: 0.2,
                  wrapAround: true,
                });
                this.events.register(this.el, "rimg:load", function () {
                  console.log("loading");
                  if (_this.flickity) {
                    _this.flickity.resize();
                  }
                });
              },
            },
            {
              key: "_bindEvents",
              value: function _bindEvents() {
                var _this = this;

                this.$slides.on("focusin.slideshow", function (event) {
                  event.preventDefault();
                  event.stopPropagation();

                  var slideIndex = _this.$slides.index(
                    jquery_default()(event.currentTarget)
                  );

                  _this.flickity.select(slideIndex, false, true);

                  _this.flickity.reloadCells();
                });
              },
            },
            {
              key: "_unbindEvents",
              value: function _unbindEvents() {
                this.$slides.off("focusin.slideshow");
              },
            },
            {
              key: "onSectionBlockSelect",
              value: function onSectionBlockSelect(block) {
                var $slides = jquery_default()(
                  "[data-slideshow-slide]",
                  this.$el
                );
                var slideIndex = $slides.index(jquery_default()(block.el));
                this.flickity.select(slideIndex, false, false);

                if (this.autoplay) {
                  this.flickity.stopPlayer();
                }
              },
            },
            {
              key: "onSectionBlockDeselect",
              value: function onSectionBlockDeselect() {
                if (this.autoplay) {
                  this.flickity.playPlayer();
                }
              },
            },
            {
              key: "onSectionUnload",
              value: function onSectionUnload() {
                this.flickity.destroy();

                this._unbindEvents();
              },
            },
          ]);

          return DynamicSlideshow;
        })();

      // EXTERNAL MODULE: ./node_modules/twitter-fetcher/js/twitterFetcher_min.js
      var twitterFetcher_min = __webpack_require__(147);
      var twitterFetcher_min_default =
        /*#__PURE__*/ __webpack_require__.n(twitterFetcher_min);

      // CONCATENATED MODULE: ./source/scripts/sections/DynamicTwitter.js
      function DynamicTwitter_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function DynamicTwitter_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function DynamicTwitter_createClass(
        Constructor,
        protoProps,
        staticProps
      ) {
        if (protoProps)
          DynamicTwitter_defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
          DynamicTwitter_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var DynamicTwitter_DynamicTwitter =
        /*#__PURE__*/
        (function () {
          function DynamicTwitter(section) {
            var _this = this;

            DynamicTwitter_classCallCheck(this, DynamicTwitter);

            this.$el = jquery_default()(section.el);
            this.$tweetContainer = jquery_default()(
              "[data-tweet-content]",
              this.$el
            );
            this.$tweetDate = jquery_default()("[data-tweet-date]", this.$el);
            this.$contentPlaceholder = jquery_default()(
              "[data-tweet-content-placeholder]",
              this.$el
            );
            this.settings = section.data;
            var onboarding = this.settings.onboarding;
            var username = this.settings.username;

            if (onboarding || !username) {
              return;
            }

            rimg_shopify_dist_index_es.watch(this.$tweetContainer[0]);
            this.$tweetContainer.one("rimg:enter", function () {
              twitterFetcher_min_default.a.fetch({
                profile: {
                  screenName: username,
                },
                maxTweets: 1,
                enableLinks: true,
                showUser: true,
                showTime: true,
                showRetweet: false,
                dataOnly: true,
                customCallback: function customCallback(tweets) {
                  return _this._renderTweet(tweets);
                },
                showInteraction: false,
                useEmoji: true,
              });
            });
          }

          DynamicTwitter_createClass(DynamicTwitter, [
            {
              key: "_renderTweet",
              value: function _renderTweet(tweets) {
                var _this2 = this;

                if (!tweets || !tweets.length) {
                  return;
                }

                var tweet = tweets[0];
                var time = tweet.time;
                var content = tweet.tweet;

                if (this.$tweetContainer.length) {
                  this.$contentPlaceholder.fadeOut(function () {
                    _this2.$tweetContainer.html(content);

                    _this2.$contentPlaceholder.remove();
                  });
                }

                if (this.$tweetDate.length) this.$tweetDate.html(time);
              },
            },
          ]);

          return DynamicTwitter;
        })();

      // CONCATENATED MODULE: ./source/scripts/components/Youtube.js
      function Youtube_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function Youtube_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function Youtube_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          Youtube_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Youtube_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var Youtube_Youtube =
        /*#__PURE__*/
        (function () {
          function Youtube(el) {
            Youtube_classCallCheck(this, Youtube);

            var url = el.getAttribute("data-video-url");
            var regex =
              /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i;
            this.el = el;
            this.id = url.match(regex)[1] || null;
            this.isReady = false;
            this.onReady = this._onReady.bind(this);
            this.onReadyCallback = null;
            this.onStateChange = this._onStateChange.bind(this);
            this.onPlayCallback = null;
            loadYoutubeApi_load().then(this._onApiLoaded.bind(this));
          }

          Youtube_createClass(Youtube, [
            {
              key: "play",
              value: function play() {
                var _this = this;

                return new Promise(function (resolve) {
                  _this.onPlayCallback = resolve;

                  if (_this.isReady) {
                    _this.player.playVideo();
                  } else {
                    _this.onReadyCallback = _this.player.playVideo;
                  }
                });
              },
            },
            {
              key: "unload",
              value: function unload() {
                // Reframe doesnt offer an unload method, so we'll manually remove the elements added
                if (this.frame) {
                  var wrapper = this.frame.parentNode;
                  var originalParent = wrapper.parentNode;
                  originalParent.appendChild(this.frame);
                  originalParent.removeChild(wrapper);
                }

                this.player.destroy();
              },
            },
            {
              key: "_onApiLoaded",
              value: function _onApiLoaded() {
                this.player = new YT.Player(this.el, {
                  videoId: this.id,
                  playerVars: {
                    modestbranding: true,
                    showinfo: false,
                    controls: false,
                  },
                  events: {
                    onReady: this.onReady,
                    onStateChange: this.onStateChange,
                  },
                });
              },
            },
            {
              key: "_onReady",
              value: function _onReady() {
                this.isReady = true;
                this.frame = this.player.getIframe();
                reframe_es(this.frame);

                if (this.onReadyCallback) {
                  this.onReadyCallback();
                }
              },
            },
            {
              key: "_onStateChange",
              value: function _onStateChange(event) {
                var state = event.data;

                if (
                  this.onPlayCallback &&
                  state === window.YT.PlayerState.PLAYING
                ) {
                  this.onPlayCallback();
                  this.onPlayCallback = null;
                }
              },
            },
          ]);

          return Youtube;
        })();

      // CONCATENATED MODULE: ./source/scripts/components/Vimeo.js
      function Vimeo_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function Vimeo_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function Vimeo_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          Vimeo_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Vimeo_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var api = "https://player.vimeo.com/api/player.js";
      var apiLoaded = false;

      var Vimeo_VimeoPlayer =
        /*#__PURE__*/
        (function () {
          function VimeoPlayer(el) {
            var _this = this;

            Vimeo_classCallCheck(this, VimeoPlayer);

            var url = el.getAttribute("data-video-url");
            var urlParts = url.split("/");
            this.el = el;
            this.id = urlParts[urlParts.length - 1];
            this.onProgress = this._onProgress.bind(this);
            this.onProgressCallback = null;

            if (apiLoaded) {
              this._loadPlayer();
            } else {
              script_default()(api, function () {
                apiLoaded = true;

                _this._loadPlayer();
              });
            }
          }

          Vimeo_createClass(VimeoPlayer, [
            {
              key: "play",
              value: function play() {
                var _this2 = this;

                return new Promise(function (resolve) {
                  _this2.onProgressCallback = resolve;

                  _this2.player.on("progress", _this2.onProgress);

                  _this2.player.play();
                });
              },
            },
            {
              key: "unload",
              value: function unload() {
                // Reframe doesnt offer an unload method, so we'll manually remove the elements added
                if (this.frame) {
                  var wrapper = this.frame.parentNode;
                  var originalParent = wrapper.parentNode;
                  originalParent.appendChild(this.frame);
                  originalParent.removeChild(wrapper);
                }

                this.player.unload().catch();
              },
            },
            {
              key: "_loadPlayer",
              value: function _loadPlayer() {
                var _this3 = this;

                this.player = new window.Vimeo.Player(this.el, {
                  id: this.id,
                });
                this.player.ready().then(function () {
                  _this3.frame = _this3.player.element;
                  reframe_es(_this3.frame);
                });
              },
            },
            {
              key: "_onProgress",
              value: function _onProgress() {
                this.player.off("progress", this.onProgress);

                if (this.onProgressCallback) {
                  this.onProgressCallback();
                  this.onProgressCallback = null;
                }
              },
            },
          ]);

          return VimeoPlayer;
        })();

      // CONCATENATED MODULE: ./source/scripts/components/Video.js
      function Video_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function Video_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function Video_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          Video_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Video_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var Video_Video =
        /*#__PURE__*/
        (function () {
          function Video(el) {
            Video_classCallCheck(this, Video);

            this.el = el;
            this.platform = el.getAttribute("data-video").trim();
            this.placeholder = el.querySelector("[data-video-placeholder]");
            this.playButton = el.querySelector("[data-video-play-button]");
            this.onPlayClick = this._onPlayClick.bind(this);
            this.video = null;

            switch (this.platform) {
              case "youtube":
                this.video = new Youtube_Youtube(
                  el.querySelector("[data-youtube]")
                );
                break;

              case "vimeo":
                this.video = new Vimeo_VimeoPlayer(
                  el.querySelector("[data-vimeo]")
                );
                break;

              default:
                this.video = null;
                break;
            }

            if (this.playButton) {
              this.playButton.addEventListener("click", this.onPlayClick);
            }
          }

          Video_createClass(Video, [
            {
              key: "_onPlayClick",
              value: function _onPlayClick() {
                var _this = this;

                this.el.classList.add("video-loading");
                this.video.play().then(function () {
                  _this.el.classList.add("video-transitioning");

                  setTimeout(function () {
                    _this.el.classList.remove("video-loading");

                    _this.el.classList.remove("video-transitioning");

                    _this.el.classList.add("video-playing");
                  }, 200);
                });
              },
            },
            {
              key: "unload",
              value: function unload() {
                if (this.playButton) {
                  this.playButton.removeEventListener(
                    "click",
                    this.onPlayClick
                  );
                }

                if (this.video) {
                  this.video.unload();
                }
              },
            },
          ]);

          return Video;
        })();

      // CONCATENATED MODULE: ./source/scripts/sections/DynamicVideo.js
      function DynamicVideo_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function DynamicVideo_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function DynamicVideo_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          DynamicVideo_defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
          DynamicVideo_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var DynamicVideo_DynamicVideo =
        /*#__PURE__*/
        (function () {
          function DynamicVideo(section) {
            DynamicVideo_classCallCheck(this, DynamicVideo);

            var videoEl = section.el.querySelector("[data-video]");

            if (videoEl) {
              this.video = new Video_Video(
                section.el.querySelector("[data-video]")
              );
            }
          }

          DynamicVideo_createClass(DynamicVideo, [
            {
              key: "onSectionUnload",
              value: function onSectionUnload() {
                if (this.video) {
                  this.video.unload();
                }
              },
            },
          ]);

          return DynamicVideo;
        })();

      // CONCATENATED MODULE: ./source/scripts/sections/GiftCardStaticSection.js
      function GiftCardStaticSection_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function GiftCardStaticSection_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function GiftCardStaticSection_createClass(
        Constructor,
        protoProps,
        staticProps
      ) {
        if (protoProps)
          GiftCardStaticSection_defineProperties(
            Constructor.prototype,
            protoProps
          );
        if (staticProps)
          GiftCardStaticSection_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var GiftCardStaticSection_GiftCardStaticSection =
        /*#__PURE__*/
        (function () {
          function GiftCardStaticSection(section) {
            GiftCardStaticSection_classCallCheck(this, GiftCardStaticSection);

            this.$el = jquery_default()(section.el);
            this.$qrcode = this.$el.find("[data-qrcode]");

            this._addQRCode();
          }

          GiftCardStaticSection_createClass(GiftCardStaticSection, [
            {
              key: "onSectionUnload",
              value: function onSectionUnload() {
                this.qrcode = null;
              },
            },
            {
              key: "_addQRCode",
              value: function _addQRCode() {
                if (!window.QRCode) return;
                this.qrcode = new QRCode(this.$qrcode[0], {
                  text: this.$qrcode.data("qrcode"),
                  width: 120,
                  height: 120,
                });
              },
            },
          ]);

          return GiftCardStaticSection;
        })();

      // CONCATENATED MODULE: ./source/scripts/components/HeaderMiniCart.js
      function HeaderMiniCart_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function HeaderMiniCart_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function HeaderMiniCart_createClass(
        Constructor,
        protoProps,
        staticProps
      ) {
        if (protoProps)
          HeaderMiniCart_defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
          HeaderMiniCart_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var HeaderMiniCart_HeaderMiniCart =
        /*#__PURE__ */
        (function () {
          function HeaderMiniCart(section) {
            var _this = this;

            HeaderMiniCart_classCallCheck(this, HeaderMiniCart);

            this.section = section;
            this.$el = jquery_default()(section.el);
            this.el = section.el;
            this.moneyFormat = section.data.moneyFormat; // Mini-cart

            this.$drawer = jquery_default()(
              "[data-header-minicart-drawer]",
              this.$el
            );
            this._toggleDrawer = this._toggleDrawer.bind(this);
            this.$title = jquery_default()(
              "[data-header-minicart-title]",
              this.$el
            );
            this.titleText = this.$title.data("header-minicart-title");
            this.open = false; // Event handlers

            this.events = [
              jquery_default()(
                "[data-site-header-minicart-dismiss]",
                this.$el
              ).on("click.minicart", this._toggleDrawer),
              this.$drawer.on("touchmove.minicart", function (event) {
                // this allows scrolling within the minicart while page is scroll-locked.

                event.stopPropagation();
              }),
              jquery_default()(window).on("resize.minicart", function () {
                return _this._setMaxDrawerHeight();
              }),
            ];
            Layout.onBreakpointChange(function () {
              return _this._toggleDrawer("closed");
            });
            Cart.addCart(section.el, section.postMessage); // Check if position: sticky is supported, and add alternative styling and event handlers if not

            if (
              window
                .getComputedStyle(
                  this.el.querySelector(".header-minicart-header")
                )
                .position.indexOf("sticky") === -1
            ) {
              this._makeItWorkWithoutSticky();
            }
          }

          HeaderMiniCart_createClass(HeaderMiniCart, [
            {
              key: "_calculateMaxDrawerHeight",
              value: function _calculateMaxDrawerHeight() {
                var _document$querySelect = document
                    .querySelector("#shopify-section-static-header")
                    .getBoundingClientRect(),
                  headerTop = _document$querySelect.top,
                  headerHeight = _document$querySelect.height;

                var drawerOffset = Math.max(headerHeight + headerTop, 0);

                if (this.workingWithoutSticky) {
                  // IE11 doesn't transition maxHeight properly for vh units
                  return "".concat(window.innerHeight - drawerOffset, "px");
                }

                return "calc(100vh - ".concat(drawerOffset, "px)");
              },
            },
            {
              key: "_makeItWorkWithoutSticky",
              value: function _makeItWorkWithoutSticky() {
                var _this2 = this;

                this.workingWithoutSticky = true;
                Layout.onBreakpointChange(function () {
                  if (!Layout.isBreakpoint("L")) {
                    _this2.el.style.top = "".concat(window.pageYOffset, "px");
                  }
                });
                var drawerStyle = this.$drawer[0].style;
                drawerStyle.width = "100%";
                drawerStyle.left = "50%";
                drawerStyle.transform = "translate(-50%)";
                this.el.style.position = "absolute";
                this.el.style.left = 0;
                this.el.style.right = 0;
                var header = document.querySelector(
                  "#shopify-section-static-header"
                );

                var setTop = function setTop() {
                  var headerBounds = header.getBoundingClientRect();

                  if (Layout.isBreakpoint("L")) {
                    _this2.el.style.top = "".concat(
                      Math.max(0, headerBounds.top + headerBounds.height) +
                        window.pageYOffset,
                      "px"
                    );
                  } else {
                    _this2.el.style.top = "".concat(window.pageYOffset, "px");
                  }
                };

                setTop();
                this.events.push(
                  jquery_default()(window).on("scroll.minicart", setTop)
                );
              },
            },
            {
              key: "_setScrollLock",
              value: function _setScrollLock() {
                if (!this.open) {
                  return;
                }

                if (this.workingWithoutSticky) {
                  ScrollLock.lock();
                  return;
                }

                if (!Layout.isBreakpoint("L")) {
                  ScrollLock.lock();
                  return;
                }

                var _this$$drawer$ = this.$drawer[0],
                  scrollHeight = _this$$drawer$.scrollHeight,
                  clientHeight = _this$$drawer$.clientHeight; // If cart drawer is smaller than full screen, allow scrolling.

                if (scrollHeight <= clientHeight) {
                  ScrollLock.unlock();
                } else {
                  ScrollLock.lock();
                }
              },
            },
            {
              key: "_setMaxDrawerHeight",
              value: function _setMaxDrawerHeight() {
                var force =
                  arguments.length > 0 && arguments[0] !== undefined
                    ? arguments[0]
                    : false;

                if (!this.open && !force) {
                  return;
                }

                if (!Layout.isBreakpoint("L")) {
                  // because Chrome on Android broke 100vh sizing, this needs to be set dynamically
                  this.$drawer[0].style.maxHeight = "".concat(
                    window.innerHeight,
                    "px"
                  );
                  return;
                }

                this.$drawer[0].style.maxHeight =
                  this._calculateMaxDrawerHeight();
              },
            },
            {
              key: "_unsetMaxDrawerHeight",
              value: function _unsetMaxDrawerHeight() {
                this.$drawer[0].style.maxHeight = null;
              },
            },
            {
              key: "_refreshCart",
              value: function _refreshCart() {
                //console.log('hi');
                var _this3 = this;

                this.$drawer[0].classList.add("loading");

                this._blankMiniCartTotals();

                Cart.update().done(function (data) {
                  _this3._onMiniCartUpdate(data);

                  _this3._setScrollLock();

                  _this3.section.postMessage("cart:update", {
                    data: data,
                  });
                  //  console.log($('.header-minicart-content .main-carousel').length);
                  //         if($('.header-minicart-content .main-carousel').length < 1){
                  //           setInterval(function(){
                  //             var elem = document.querySelector('.header-minicart-content .main-carousel');
                  //             var flkty = new Flickity( elem, {
                  //               fullscreen: true,
                  //               lazyLoad: 1,
                  //               groupCells: 1,
                  //               prevNextButtons: false,
                  //               on: {
                  //     ready: function() {
                  //       console.log('Flickity is ready');
                  //       clearInterval();
                  //     },
                  //     change: function( index ) {
                  //       console.log( 'Slide changed to' + index );
                  //     }
                  //               }
                  //             });

                  //             var flkty = new Flickity( '.header-minicart-content .main-carousel', {
                  //             });
                  //           },2000);
                  //         }
                });

                setTimeout(function () {
                  var ids = [];

                  jquery_default.a
                    .ajax({
                      type: "GET",
                      url: "/cart.js",
                      dataType: "json",
                    })
                    .done(function (response) {
                      for (var i = 0; i < response.items.length; i++) {
                        var variant_id = response.items[i].variant_id;
                        $(".cartupsell").each(
                          function () {
                            var flag = false;
                            var pro_id = $(this)
                              .find(".upsell-form button")
                              .data("variant-id");
                            if (variant_id == pro_id) {
                              ids.push(pro_id);
                            }
                          }
                        );
                      }

                      $(".cartupsell").each(
                        function () {
                          var pro_id = $(this)
                            .find(".upsell-form button")
                            .data("variant-id");
                          if (!ids.includes(pro_id)) {
                            $(this).show();
                          }
                        }
                      );

                      //             var elem = document.querySelector('.header-minicart-content .main-carousel');
                      //             var flkty = new Flickity( elem, {
                      //               fullscreen: true,
                      //               lazyLoad: 1,
                      //               groupCells: 1,
                      //               prevNextButtons: false,
                      //               on: {
                      //                 ready: function() {
                      //                   console.log('Flickity is ready');
                      //                   clearInterval();
                      //                 },
                      //                 change: function( index ) {
                      //                   console.log( 'Slide changed to' + index );
                      //                 }
                      //               }
                      //             });
                      $(".upsell-form button").on(
                        "click",
                        function () {
                          var $sel = $(this);
                          var quantity = 1;
                          var product_id = $(this).data("variant-id");
                          jquery_default.a
                            .ajax({
                              type: "POST",
                              url: "/cart/add.js",
                              data:
                                "quantity=" + quantity + "&id=" + product_id,
                              dataType: "json",
                            }) // On success
                            .done(function (response) {
                              console.log("vshgdgahs");
                              $sel.val("Added");
                              $sel.text("Added 😍");
                              $sel.addClass("addedtocart");
                              console.log(_this3);
                              _this3._refreshCart();
                            });
                        }
                      );
                    });
                }, 1000);
              },
            },
            {
              key: "_openDrawer",
              value: function _openDrawer() {
                var _this4 = this;

                this._setMaxDrawerHeight(true);

                this.$drawer.one("transitionend", function () {
                  return _this4._setScrollLock();
                });
                this.$drawer.parent()[0].classList.add("open");

                this._addClickToCloseEvents();

                this.open = true;
              },
            },
            {
              key: "_toggleDrawer",
              value: function _toggleDrawer(requestedState) {
                var _this5 = this;

                if (requestedState === "open" && this.open) {
                  this._refreshCart();

                  return;
                }

                if (requestedState === "closed" && !this.open) {
                  return;
                }

                if (this.open) {
                  this.$drawer.one("transitionend", function () {
                    // $('.drawer__close').removeClass('active');

                    _this5.section.postMessage("header-minicart:close");
                  });
                  ScrollLock.unlock();
                  this.$drawer.parent()[0].classList.remove("open");

                  this._unsetMaxDrawerHeight();

                  this._removeClickToCloseEvents();

                  this.open = false;
                } else {
                  var waitingOnTransition = false; // If there is a bottom menu initialized, it will use this callback to delay opening
                  // until the $.deferred transitionEnded has resolved.

                  this.section.postMessage(
                    "header-minicart:open",
                    function (transitionEnded) {
                      waitingOnTransition = true;

                      //   $('.drawer__close').addClass('active');

                      _this5._refreshCart();

                      transitionEnded.done(function () {
                        return _this5._openDrawer();
                      });
                    }
                  ); // otherwise, if the callback is never invoked, we can just open directly.
                  // Because postMessage is synchronous, we know that by this point
                  // anything that should will have invoked the callback.

                  if (!waitingOnTransition) {
                    this._refreshCart();

                    this._openDrawer();
                  }
                }
              },
            },
            {
              key: "_addClickToCloseEvents",
              value: function _addClickToCloseEvents() {
                var _this6 = this;

                jquery_default()(window).on("click.minicart", function () {
                  return _this6._toggleDrawer("closed");
                });
                this.$drawer.on("click.minicart", function (event) {
                  return event.stopPropagation();
                });
              },
            },
            {
              key: "_removeClickToCloseEvents",
              value: function _removeClickToCloseEvents() {
                jquery_default()(window).off("click.minicart");
                this.$drawer.off("click.minicart");
              },
            },
            {
              key: "_onMiniCartUpdate",
              value: function _onMiniCartUpdate(cartData) {
                this.$drawer[0].classList.remove("loading");
                rimg_shopify_dist_index_es.watch(this.$drawer[0]);
              },
            },
            {
              key: "_updateMiniCartTotals",
              value: function _updateMiniCartTotals(cartData) {
                if (cartData.options.item_count === 0) {
                  this.$drawer[0].classList.add("minicart-cart-empty");
                  return;
                }

                this.$drawer[0].classList.remove("minicart-cart-empty");
                this.$title.text(cartData.options.item_count);
              },
            },
            {
              key: "_blankMiniCartTotals",
              value: function _blankMiniCartTotals() {
                this.$title.text(0);
              },
            },
            {
              key: "onSectionUnload",
              value: function onSectionUnload() {
                Cart.unload();

                this._removeClickToCloseEvents();

                this.events.forEach(function ($el) {
                  return $el.off(".minicart");
                });
              },
            },
            {
              key: "onSectionMessage",
              value: function onSectionMessage(name, data) {
                if (name === "cart:update") {
                  this._updateMiniCartTotals(data.data);
                }

                if (name === "header-minicart:toggle") {
                  this._toggleDrawer(data);
                }

                if (name === "header-minicart:set-open") {
                  this._toggleDrawer("open");
                }
              },
            },
          ]);

          return HeaderMiniCart;
        })();

      // CONCATENATED MODULE: ./source/scripts/snippets/MeganavMenu.js
      function MeganavMenu_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function MeganavMenu_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function MeganavMenu_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          MeganavMenu_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) MeganavMenu_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var MeganavMenu_MeganavMenu =
        /*#__PURE__*/
        (function () {
          function MeganavMenu(el) {
            var _this = this;

            MeganavMenu_classCallCheck(this, MeganavMenu);

            this.$el = jquery_default()(el);
            this.$el.on(
              "click.meganav-menu",
              ".meganav-menu-header",
              function (event) {
                var $header = jquery_default()(event.currentTarget);

                if (
                  !$header.hasClass("meganav-menu-empty") &&
                  !$header.hasClass("navmenu-link-meganav")
                ) {
                  _this.toggleList($header);
                }
              }
            );
            this.$el.on(
              "click.meganav-menu",
              ".navmenu-arrow-toggle",
              function (event) {
                event.preventDefault();
                event.stopPropagation();
                var $header = jquery_default()(event.currentTarget);

                _this.arrowToggle($header);
              }
            );
          }

          MeganavMenu_createClass(MeganavMenu, [
            {
              key: "unload",
              value: function unload() {
                this.$el.off(".meganav-menu");
              },
            },
            {
              key: "toggleList",
              value: function toggleList($header, state) {
                var $group = $header.parents(".meganav-menu-group");

                if ($group.hasClass("meganav-menu-active")) {
                  return true;
                } else {
                  event.preventDefault();
                  var $list = $group.find(".meganav-menu-items");
                  $group.toggleClass("meganav-menu-active", state);
                  $list.slideToggle(state);
                }
              },
            },
            {
              key: "arrowToggle",
              value: function arrowToggle($header, state) {
                var $group = $header.parents(".meganav-menu-group");
                var $list = $group.find(".meganav-menu-items");
                $group.toggleClass("meganav-menu-active", state);
                $list.slideToggle(state);
              },
            },
          ]);

          return MeganavMenu;
        })();

      // CONCATENATED MODULE: ./source/scripts/snippets/NavMobile.js
      function NavMobile_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function NavMobile_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function NavMobile_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          NavMobile_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) NavMobile_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var NavMobile_MobileNav =
        /*#__PURE__*/
        (function () {
          function MobileNav(el) {
            var _this = this;

            NavMobile_classCallCheck(this, MobileNav);

            this.$html = jquery_default()("html"); // Component elements

            this.$el = jquery_default()(el);
            this.$panel = this.$el.find(".mobilenav-panel");
            this.$overlay = this.$el.find(".mobilenav-overlay");
            this.$content = this.$el.find(".mobilenav-panel-content");
            this.$animators = this.$el.find("[data-mobilenav-animator]"); // Search elements

            this.$searchInput = this.$el.find(".mobilenav-search-input");
            this.$searchCancel = this.$el.find(".mobilenav-search-cancel"); // Contact bar elements

            this.$contact = this.$el.find(".mobilenav-contactbar");
            this.$el.on(
              "click.navmenu",
              ".navmenu-link-parent:not(.navmenu-link-meganav)",
              function (event) {
                _this.toggleItem(event.currentTarget);
              }
            );
            this.$el.on(
              "click.navmenu",
              ".navmenu-arrow-toggle",
              function (event) {
                event.preventDefault();
                event.stopPropagation();

                _this.arrowToggle(event.currentTarget);
              }
            );
            this.$megaNavTriggers = this.$el.find("[data-meganav-trigger]");
            this.$megaNavs = this.$el.find("[data-meganav]");
            this.megaNavs = [];
            this.$megaNavTriggers.each(function (key, megaNavTrigger) {
              var $megaNavTrigger = jquery_default()(megaNavTrigger);
              var $megaNav = $megaNavTrigger.children(".meganav");

              _this.megaNavs.push(new MeganavMenu_MeganavMenu($megaNav.get(0)));
            });
            this.events = [];
          }

          NavMobile_createClass(MobileNav, [
            {
              key: "unload",
              value: function unload() {
                this.close();
                this.$el.off(".navmenu");
              },
            },
            {
              key: "open",
              value: function open() {
                var _this2 = this;

                this.$html.addClass("scroll-lock"); // Animate in elements

                this.$animators
                  .revealer("show")
                  .one("revealer-show", function () {
                    return _this2.$panel.css("display", "");
                  });
                this.$panel.css("display", "block");
                this.$searchInput.focus(); // Event handlers

                this.events = [
                  // Close menu when clicking on the overlay
                  this.$overlay.on("click.mobilenav", function (event) {
                    return _this2.close();
                  }), // Disable scrolling on overlay and contactbar
                  this.$overlay.on("touchmove.mobilenav", function (event) {
                    return event.preventDefault();
                  }),
                  this.$contact.on("touchmove.mobilenav", function (event) {
                    return event.preventDefault();
                  }), // Close keyboard when scrolling through the menu
                  this.$content.on("touchmove.mobilenav", function (event) {
                    return _this2.$searchInput.blur();
                  }), // Button to blur search input button
                  this.$searchCancel.on("click.mobilenav", function (event) {
                    return _this2.$searchInput.blur();
                  }),
                ];
              },
            },
            {
              key: "close",
              value: function close() {
                this.$html.removeClass("scroll-lock"); // Unbind events

                this.events.forEach(function ($el) {
                  return $el.off(".mobilenav");
                });
                this.events = []; // Animate out items

                this.$animators.revealer("hide");
              },
            },
            {
              key: "toggleItem",
              value: function toggleItem(el) {
                var $el = jquery_default()(el);

                if ($el.hasClass("navmenu-selected")) {
                  return true;
                } else {
                  event.preventDefault();
                  $el.toggleClass("navmenu-selected");
                  $el.parent().toggleClass("navmenu-active");
                  var $menu = $el.siblings(".navmenu");
                  $menu.slideToggle();
                }
              },
            },
            {
              key: "arrowToggle",
              value: function arrowToggle(el) {
                var $el = jquery_default()(el).parent();
                $el.toggleClass("navmenu-selected");
                $el.parent("").toggleClass("navmenu-active");
                var $menu = $el.siblings(".navmenu");
                $menu.slideToggle();
              },
            },
          ]);

          return MobileNav;
        })();

      // CONCATENATED MODULE: ./source/scripts/snippets/NavDesktop.js
      function NavDesktop_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function NavDesktop_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function NavDesktop_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          NavDesktop_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) NavDesktop_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var NavDesktop_NavDesktop =
        /*#__PURE__*/
        (function () {
          function NavDesktop(el, postMessage) {
            var _this = this;

            NavDesktop_classCallCheck(this, NavDesktop);

            this.$el = jquery_default()(el);
            this.el = this.$el[0];
            this.$overlay = jquery_default()(".site-navigation-overlay");
            this.postMessage = postMessage;
            this.events = [
              // Open item on hover
              this.$el.on(
                "mouseenter.navmenu",
                ".navmenu-item-parent:not([data-navmenu-ignore])",
                function (event) {
                  _this.openItem(event.currentTarget);
                }
              ), // Close item on hover
              this.$el.on(
                "mouseleave.navmenu",
                ".navmenu-item-parent:not([data-navmenu-ignore])",
                function (event) {
                  _this.closeItem(event.currentTarget);
                }
              ), // Toggle item on touch
              this.$el.on(
                "touchend.navmenu",
                ".navmenu-item-parent:not([data-navmenu-ignore]) > .navmenu-link-parent",
                function (event) {
                  event.preventDefault();
                  event.stopPropagation();

                  _this.toggleItem(event.currentTarget.parentNode);
                }
              ), // Keyboard navigation -- toggle submenus
              this.$el.on(
                "focus.navmenu",
                ".navmenu-item-parent:not([data-navmenu-ignore]) > .navmenu-link-parent",
                function (event) {
                  _this.toggleItem(event.currentTarget.parentNode);
                }
              ), // Keyboard navigation -- close submenus when moving to a new nav item
              this.$el.on(
                "focus.navmenu",
                ".navmenu-depth-1 > .navmenu-item:not([data-navmenu-ignore]) .navmenu-link",
                function (event) {
                  _this.closeAll(event.currentTarget);
                }
              ),
              jquery_default()(document.body).on(
                "focusin.navmenu",
                function (event) {
                  if (
                    event.currentTarget instanceof Node &&
                    _this.el.contains(event.target)
                  )
                    return;

                  _this.closeAll(_this.el);
                }
              ),
              this.$overlay.on("click.navmenu", function (event) {
                _this.postMessage("nav:close-triggers", {
                  source: el,
                });

                _this.closeAll();

                _this.hideOverlay();
              }),
            ];
          }

          NavDesktop_createClass(NavDesktop, [
            {
              key: "unload",
              value: function unload() {
                this.events.forEach(function ($el) {
                  return $el.off(".navmenu");
                });
              },
            },
            {
              key: "showOverlay",
              value: function showOverlay() {
                this.$overlay.show();
              },
            },
            {
              key: "hideOverlay",
              value: function hideOverlay() {
                this.$overlay.hide();
              },
            },
            {
              key: "openItem",
              value: function openItem(el) {
                // close header minicart
                this.postMessage("header-minicart:toggle", "closed");
                var $el = jquery_default()(el); // Check if menu is already open

                var $menu = $el.children(".navmenu");
                if ($menu.revealer("isVisible")) return;
                $el.attr("aria-expanded", true); // Close previously opened items

                this.closeAll(el);
                this.postMessage("nav:close-triggers", {
                  source: el,
                }); // Show menu

                $menu.revealer("show"); // Adjust menu position if it runs off the screen

                $el.toggleClass(
                  "navmenu-adjust-right",
                  el.getBoundingClientRect().right + el.clientWidth * 1.5 >
                    window.innerWidth
                ); // Show overlay

                this.showOverlay();
              },
            },
            {
              key: "closeAll",
              value: function closeAll(target) {
                var _this2 = this;

                this.$el
                  .find(".navmenu-depth-1 > .navmenu-item-parent")
                  .each(function (i, el) {
                    // Close any submenus in this tree
                    jquery_default()(el)
                      .find(".navmenu-item-parent")
                      .each(function (i, submenu) {
                        if (jquery_default.a.contains(submenu, target))
                          return true;

                        _this2.closeItem(submenu);
                      });
                    if (jquery_default.a.contains(el, target)) return true; // Close root-level menu item

                    _this2.closeItem(el);
                  });
                this.hideOverlay();
              },
            },
            {
              key: "closeItem",
              value: function closeItem(el) {
                var $menu = jquery_default()(el).children(".navmenu");
                if (!$menu.revealer("isVisible")) return;
                jquery_default()(el).attr("aria-expanded", false); // Hide menu

                $menu.revealer("hide"); // Hide overlay

                if (this.isFirstLevel(el)) {
                  this.hideOverlay();
                }
              },
            },
            {
              key: "toggleItem",
              value: function toggleItem(el) {
                var $el = jquery_default()(el);
                var $menu = $el.children(".navmenu");

                if ($menu.revealer("isVisible")) {
                  this.closeItem(el);
                } else {
                  this.openItem(el);
                }
              },
            },
            {
              key: "isFirstLevel",
              value: function isFirstLevel(el) {
                var $el = jquery_default()(el);
                return (
                  ($el.is(".navmenu-item") &&
                    $el.parent().is(".navmenu-depth-1")) ||
                  ($el.is(".navmenu-link") &&
                    $el.parent().parent().is(".navmenu-depth-1"))
                );
              },
            },
            {
              key: "isSingleLine",
              value: function isSingleLine() {
                var $menuItems = jquery_default()(
                  ".navmenu-depth-1 > .navmenu-item:not(.navmenu-mobile-account)",
                  this.$el
                );
                var isSingleLine = true;
                var prevTop = Infinity;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (
                    var _iterator = $menuItems[Symbol.iterator](), _step;
                    !(_iteratorNormalCompletion = (_step = _iterator.next())
                      .done);
                    _iteratorNormalCompletion = true
                  ) {
                    var menuItem = _step.value;
                    var top = menuItem.getBoundingClientRect().top;

                    if (prevTop == Infinity || prevTop == top) {
                      prevTop = top;
                    } else {
                      isSingleLine = false;
                      break;
                    }
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (
                      !_iteratorNormalCompletion &&
                      _iterator.return != null
                    ) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }

                return isSingleLine;
              },
            },
          ]);

          return NavDesktop;
        })();

      // CONCATENATED MODULE: ./source/scripts/snippets/FadePanel.js
      function FadePanel_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function FadePanel_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function FadePanel_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          FadePanel_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) FadePanel_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      /**
       * Add classes to an scrollable element to represent its scroll state.
       */
      var FadePanel =
        /*#__PURE__*/
        (function () {
          function FadePanel(el) {
            FadePanel_classCallCheck(this, FadePanel);

            this.el = el instanceof Element ? el : document.querySelector(el);
            this.container = this.el ? this.el.parentNode : null;
            this.classnames = {
              top: "fadepanel-top",
              bottom: "fadepanel-bottom",
              left: "fadepanel-left",
              right: "fadepanel-right",
            };
            this.onScroll = this.update.bind(this);

            if (this.container) {
              this.el.addEventListener("scroll", this.onScroll);
              this.onScroll();
            }
          }

          FadePanel_createClass(FadePanel, [
            {
              key: "unload",
              value: function unload() {
                this.el.removeEventListener("scroll", this.onScroll);
              },
            },
            {
              key: "update",
              value: function update() {
                var classes = this.container.className.split(" ");
                var isLeft = this.el.scrollLeft > 0;
                var leftIndex = classes.indexOf(this.classnames.left);
                if (isLeft && leftIndex === -1)
                  classes.push(this.classnames.left);
                if (!isLeft && leftIndex !== -1) classes.splice(leftIndex, 1);
                var isRight =
                  this.el.scrollLeft <
                  this.el.scrollWidth - this.el.clientWidth;
                var rightIndex = classes.indexOf(this.classnames.right);
                if (isRight && rightIndex === -1)
                  classes.push(this.classnames.right);
                if (!isRight && rightIndex !== -1)
                  classes.splice(rightIndex, 1);
                var isTop = this.el.scrollTop > 0;
                var topIndex = classes.indexOf(this.classnames.top);
                if (isTop && topIndex === -1) classes.push(this.classnames.top);
                if (!isTop && topIndex !== -1) classes.splice(topIndex, 1);
                var bottomIndex = classes.indexOf(this.classnames.bottom);
                var isBottom =
                  this.el.scrollTop <
                  this.el.scrollHeight - this.el.clientHeight;
                if (isBottom && bottomIndex === -1)
                  classes.push(this.classnames.bottom);
                if (!isBottom && bottomIndex !== -1)
                  classes.splice(bottomIndex, 1);
                this.container.className = classes.join(" ");
              },
            },
          ]);

          return FadePanel;
        })();

      // CONCATENATED MODULE: ./source/scripts/snippets/Meganav.js
      function Meganav_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function Meganav_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function Meganav_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          Meganav_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Meganav_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var Meganav_Meganav =
        /*#__PURE__*/
        (function () {
          function Meganav(el, postMessage, trigger) {
            var _this = this;

            Meganav_classCallCheck(this, Meganav);

            this.$el = jquery_default()(el);
            this.$window = jquery_default()(window);
            this.namespace = "mega-nav-".concat(trigger);
            this.trigger = trigger;
            this.postMessage = postMessage;
            this.navTrigger = new NavTrigger_NavTrigger({
              el: el,
              namespace: this.namespace,
              trigger: this.trigger,
              postMessage: postMessage,
              onShow: function onShow() {
                _this.update();

                _this.postMessage("nav:close-all", {});

                _this.postMessage("nav:close-triggers", {
                  source: _this.$el,
                });

                _this.postMessage("nav:show-overlay", {
                  source: _this.$el,
                });
              },
            }); // Ensure images have the same height

            this.$window.on("resize.".concat(this.namespace), function () {
              return _this.update();
            }); // Fade out edges when scrolling horizontally

            this.fadePanel = new FadePanel(
              '[data-meganav="' + trigger + '"] .meganav-menu-panel-contents'
            );
          }

          Meganav_createClass(Meganav, [
            {
              key: "onSectionUnload",
              value: function onSectionUnload() {
                this.$window.off(".".concat(this.namespace));
                this.navTrigger.unload();
                Layout.offBreakpointChange(this.layoutHandler);
              },
            },
            {
              key: "onSectionMessage",
              value: function onSectionMessage(name, data) {
                if (name === "nav:close-triggers" && data.source !== this.$el) {
                  this.navTrigger.hide();
                }

                if (name === "nav:show-overlay") {
                  this.navTrigger.showOverlay();
                }
              },
            },
            {
              key: "update",
              value: function update() {
                this.fadePanel.update();

                this._updateImageHeights();
              },
              /**
               * Set meganav collection image heights to match the tallest.
               *
               * This is purely visual, to make all the collection titles line up nicely.
               */
            },
            {
              key: "_updateImageHeights",
              value: function _updateImageHeights() {
                var $images = this.$el.find(".meganav-menu-image");
                if (!$images.length) return; // Find maximum image height

                var height = 0;
                $images.each(function (index, el) {
                  var $img = jquery_default()(el).find("img, svg").first();
                  if (!$img.length) return;
                  height = Math.max(height, $img[0].clientHeight);
                }); // Set all images height to maximum

                if (height) {
                  $images.each(function (index, el) {
                    return jquery_default()(el).height(height);
                  });
                }
              },
              /**
               * Remove all data attributes from an element.
               *
               * @param {Element} el
               */
            },
            {
              key: "_removeDataAttributes",
              value: function _removeDataAttributes(el) {
                if (!el || !el.attributes) return;
                var attributesToRemove = [];

                for (var i = el.attributes.length - 1; i >= 0; i--) {
                  var name = el.attributes[i].name;

                  if (name.substring(0, 5) === "data-") {
                    attributesToRemove.push(name);
                  }
                }

                attributesToRemove.forEach(function (name) {
                  return el.removeAttribute(name);
                });
              },
            },
          ]);

          return Meganav;
        })();

      // CONCATENATED MODULE: ./source/scripts/sections/HeaderStaticSection.js
      function HeaderStaticSection_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function HeaderStaticSection_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function HeaderStaticSection_createClass(
        Constructor,
        protoProps,
        staticProps
      ) {
        if (protoProps)
          HeaderStaticSection_defineProperties(
            Constructor.prototype,
            protoProps
          );
        if (staticProps)
          HeaderStaticSection_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var HeaderStaticSection_HeaderStaticSection =
        /*#__PURE__*/
        (function () {
          function HeaderStaticSection(section) {
            var _this = this;

            HeaderStaticSection_classCallCheck(this, HeaderStaticSection);

            this.section = section;
            this.$el = jquery_default()(section.el);
            this.$mobileNavToggle = this.$el.find("[data-mobilenav-toggle]");
            this.currency = section.data.currency;
            this.$switcher = jquery_default()("[data-currency-converter]");
            this.$cartButton = jquery_default()(
              "[data-header-site-actions-cart]",
              this.$el
            ); // Sub-components

            this.mobileNav = new NavMobile_MobileNav(
              this.$el.find(".mobilenav")
            );
            this.nav = new NavDesktop_NavDesktop(
              this.$el.find(".site-navigation"),
              section.postMessage
            );
            this.$megaNavTriggers = jquery_default()(
              this.$el.find(".site-navigation")
            ).find("[data-meganav-trigger]");
            this.$megaNavs = this.$el.find("[data-meganav]");
            this.megaNavs = [];
            this.$megaNavTriggers.each(function (key, megaNavTrigger) {
              var $megaNavTrigger = jquery_default()(megaNavTrigger);
              var trigger = $megaNavTrigger.data("meganav-trigger");

              var $megaNav = _this.$megaNavs.filter(
                '[data-meganav="'.concat(trigger, '"]')
              );

              _this.megaNavs.push(
                new Meganav_Meganav(
                  $megaNav.get(0),
                  _this.section.postMessage,
                  trigger
                )
              );
            }); // Event handlers

            this.events = [
              // Open mobile nav button
              // Mobile safari will only allow us to focus the actual search input
              // programaticaly if we trigger it from an input field.
              this.$mobileNavToggle.on("click.header", function (event) {
                event.preventDefault();

                _this.mobileNav.open();
              }),
              jquery_default()(window).on(
                "resize.header",
                just_debounce_default()(
                  function () {
                    return _this._repositionNav();
                  },
                  16,
                  true,
                  true
                )
              ),
              this.$cartButton.on("click.header", function (event) {
                event.preventDefault();
                event.stopPropagation();

                _this.section.postMessage("header-minicart:toggle");
              }),
            ];
            this.layoutHandler = this.onBreakpointChange.bind(this);
            Layout.onBreakpointChange(this.layoutHandler);

            if (this.currency.enable) {
              var $scripts = jquery_default()("[data-scripts]");
              script_default()(
                $scripts.data("shopify-currencies"),
                function () {
                  _this._converter();
                }
              );
            }

            setTimeout(function () {
              _this._repositionNav();
            }, 100);
          }

          HeaderStaticSection_createClass(HeaderStaticSection, [
            {
              key: "_repositionNav",
              value: function _repositionNav() {
                this.$el.removeClass("site-navigation-flex");

                if (Layout.isBreakpoint("S")) {
                  return;
                }

                this.$el.toggleClass(
                  "site-navigation-flex",
                  !this.nav.isSingleLine()
                );
                this.section.postMessage("header:repositionedNav");
              },
            },
            {
              key: "_converter",
              value: function _converter() {
                shopify_currency_converter_dist_default.a.init({
                  switcherSelector: "[data-currency-converter]",
                  priceSelector: ".money",
                  shopCurrency: this.currency.shopCurrency,
                  defaultCurrency: this.currency.defaultCurrency,
                  displayFormat: this.currency.displayFormat,
                  moneyFormat: this.currency.moneyFormat,
                  moneyFormatNoCurrency: this.currency.moneyFormatNoCurrency,
                  moneyFormatCurrency: this.currency.moneyFormatCurrency,
                });
                this.$switcher.on("change.converter", function (event) {
                  shopify_currency_converter_dist_default.a.setCurrency(
                    event.currentTarget.value
                  );
                });
              },
            },
            {
              key: "onSectionUnload",
              value: function onSectionUnload() {
                this.nav.unload();
                this.mobileNav.unload();
                this.events.forEach(function ($el) {
                  return $el.off(".header");
                });
                Layout.offBreakpointChange(this.layoutHandler);

                if (this.currency.enable) {
                  this.$switcher.off("change.converter");
                }

                this.megaNavs.forEach(function (megaNav) {
                  return megaNav.onSectionUnload();
                });
              },
            },
            {
              key: "onSectionMessage",
              value: function onSectionMessage(name, data) {
                if (name === "mobilenav:open") this.mobileNav.open();
                if (name === "mobilenav:close") this.mobileNav.close();

                if (name === "cart:update") {
                  jquery_default()("[data-cart-item-count]", this.$el).text(
                    data.data.options.item_count
                  ); // We need to do some additional styling of the cart label if the count has 3+ digits

                  // window.location.href="/cart";
                  var count = data.data.options.item_count;
                  // console.log(count);
                  jquery_default.a
                    .ajax({
                      type: "GET",
                      url: "/cart.js",
                      dataType: "json",
                    })
                    .done(function (data) {
                      // for(var i=0;i<data.items.length;i++){
                      // 	if(data.items[i].properties && data.items[i].properties['Product Type'] == 'Sub Product')
                      // 	{
                      // 		count = count - data.items[i].quantity;
                      // 	}
                      // }
                      // console.log(count);
                      // setTimeout(() => {
                      // 	$('[data-header-minicart-title]').text(count);
                      // 	$('[data-cart-item-count]').text(count);
                      // }, 1000);
                      freesamples()
                    });

                  if (data.data.item_count > 99) {
                    jquery_default()(
                      "[data-cart-item-count]",
                      this.$el
                    ).addClass("cart-label-format");
                  } else {
                    jquery_default()(
                      "[data-cart-item-count]",
                      this.$el
                    ).removeClass("cart-label-format");
                  }
                }

                if (name === "nav:close-all") this.nav.closeAll();
                this.megaNavs.forEach(function (megaNav) {
                  return megaNav.onSectionMessage(name, data);
                });
              },
            },
            {
              key: "onBreakpointChange",
              value: function onBreakpointChange() {
                if (Layout.isBreakpoint("M") || Layout.isBreakpoint("L")) {
                  this.mobileNav.close();
                }
              },
            },
          ]);

          return HeaderStaticSection;
        })();

      // CONCATENATED MODULE: ./source/scripts/sections/MobileCollectionsDynamicSection.js
      function MobileCollectionsDynamicSection_classCallCheck(
        instance,
        Constructor
      ) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function MobileCollectionsDynamicSection_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function MobileCollectionsDynamicSection_createClass(
        Constructor,
        protoProps,
        staticProps
      ) {
        if (protoProps)
          MobileCollectionsDynamicSection_defineProperties(
            Constructor.prototype,
            protoProps
          );
        if (staticProps)
          MobileCollectionsDynamicSection_defineProperties(
            Constructor,
            staticProps
          );
        return Constructor;
      }

      var MobileCollectionsDynamicSection_MobileCollectionsDynamicSection =
        /*#__PURE__*/
        (function () {
          function MobileCollectionsDynamicSection(section) {
            MobileCollectionsDynamicSection_classCallCheck(
              this,
              MobileCollectionsDynamicSection
            );

            this.$el = jquery_default()(section.el);
            this.menu = new MeganavMenu_MeganavMenu(this.$el);
          }

          MobileCollectionsDynamicSection_createClass(
            MobileCollectionsDynamicSection,
            [
              {
                key: "onSectionUnload",
                value: function onSectionUnload() {
                  this.menu.unload();
                },
              },
            ]
          );

          return MobileCollectionsDynamicSection;
        })();

      // CONCATENATED MODULE: ./source/scripts/sections/Product.js
      function Product_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function Product_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function Product_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          Product_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Product_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var Product_Product =
        /*#__PURE__*/
        (function () {
          function Product(section) {
            Product_classCallCheck(this, Product);

            this.section = section;
            this.$el = jquery_default()(section.el);
            var onboarding = section.data.onboarding; // Product details

            this.productDetails = new ProductDetails_ProductDetails(
              this.$el,
              section
            ); // Product menu

            if (!onboarding && !this.section.data.form_is_inline) {
              this.productMenu = new ProductMenu_ProductMenu(
                section.el.querySelector("[data-product-menu]"),
                this.section.data,
                this.section.postMessage
              );
            }
          }

          Product_createClass(Product, [
            {
              key: "onSectionMessage",
              value: function onSectionMessage(name, data) {
                if (this.productMenu) {
                  this.productMenu.onSectionMessage(name, data);
                }
              },
            },
            {
              key: "onSectionUnload",
              value: function onSectionUnload() {
                if (this.productMenu) this.productMenu.unload();
                this.productDetails.unload();
              },
            },
          ]);

          return Product;
        })();

      // CONCATENATED MODULE: ./source/scripts/sections/SearchStaticSection.js
      function SearchStaticSection_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function SearchStaticSection_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function SearchStaticSection_createClass(
        Constructor,
        protoProps,
        staticProps
      ) {
        if (protoProps)
          SearchStaticSection_defineProperties(
            Constructor.prototype,
            protoProps
          );
        if (staticProps)
          SearchStaticSection_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var SearchStaticSection_SearchStaticSection =
        /*#__PURE__*/
        (function () {
          function SearchStaticSection(section) {
            var _this = this;

            SearchStaticSection_classCallCheck(this, SearchStaticSection);

            this.$el = jquery_default()(section.el);
            this.section = section; // Tabs

            this.$tabs = jquery_default()(".search-results-tab", section.el);
            this.$groups = jquery_default()(
              ".search-results-group",
              section.el
            ); // Article results

            this.$articles = jquery_default()(
              "[data-article-excerpts]",
              section.el
            );
            this.blogLayout = new BlogLayout_BlogLayout(this.$articles); // Events

            this.events = [
              this.$tabs.on("click.search", function (event) {
                event.preventDefault();

                _this._selectTab(event.currentTarget);
              }),
            ]; // Product items

            this.productItems = [];
            var $productItems = jquery_default()(
              "[data-product-item]",
              this.$el
            );
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (
                var _iterator = $productItems[Symbol.iterator](), _step;
                !(_iteratorNormalCompletion = (_step = _iterator.next()).done);
                _iteratorNormalCompletion = true
              ) {
                var productItem = _step.value;
                this.productItems.push(
                  new ProductItem_ProductItem(
                    jquery_default()(productItem),
                    this.section.postMessage
                  )
                );
              } // Init state
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            this.$tabs.first().click();
          }

          SearchStaticSection_createClass(SearchStaticSection, [
            {
              key: "onSectionUnload",
              value: function onSectionUnload() {
                this.blogLayout.unload();
                this.events.forEach(function ($el) {
                  return $el.off(".search");
                });
              },
            },
            {
              key: "_selectTab",
              value: function _selectTab(el) {
                var $el = jquery_default()(el); // Select tab

                this.$tabs.removeClass("search-results-tab-selected");
                $el.addClass("search-results-tab-selected"); // Select group

                this.$groups.removeClass("search-results-group-selected");
                var selector = $el.attr("href");
                jquery_default()(selector).addClass(
                  "search-results-group-selected"
                ); // Re-layout blog posts

                this.blogLayout.update();
              },
            },
          ]);

          return SearchStaticSection;
        })();

      // EXTERNAL MODULE: ./node_modules/core-js/index.js
      var core_js = __webpack_require__(168);

      // CONCATENATED MODULE: ./source/scripts/sections/StaticArticle.js
      function StaticArticle_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function StaticArticle_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function StaticArticle_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          StaticArticle_defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
          StaticArticle_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var StaticArticle_StaticArticle =
        /*#__PURE__*/
        (function () {
          function StaticArticle(section) {
            var _this = this;

            StaticArticle_classCallCheck(this, StaticArticle);

            var el = section.el;
            this.$articleWrapper = jquery_default()(
              "[data-article-wrapper]",
              el
            );
            this.$articleImage = jquery_default()("[data-article-image]", el);
            this.rte = new RTE_RTE(el.querySelector(".rte"));

            this._positionImage();

            jquery_default()(window).on("resize.article", function () {
              return _this._positionImage();
            });
          }

          StaticArticle_createClass(StaticArticle, [
            {
              key: "onSectionMessage",
              value: function onSectionMessage(name) {
                if (name === "header:repositionedNav") {
                  this._positionImage();
                }
              },
            },
            {
              key: "_positionImage",
              value: function _positionImage() {
                this.$articleImage
                  .css("top", this.$articleWrapper.offset().top)
                  .addClass("article-image-positioned");
              },
            },
            {
              key: "onSectionUnload",
              value: function onSectionUnload() {
                jquery_default()(window).off("resize.article");
                this.rte.unload();
              },
            },
          ]);

          return StaticArticle;
        })();

      // CONCATENATED MODULE: ./source/scripts/sections/StaticBlog.js
      function StaticBlog_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function StaticBlog_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function StaticBlog_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          StaticBlog_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) StaticBlog_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var StaticBlog_StaticBlog =
        /*#__PURE__*/
        (function () {
          function StaticBlog(section) {
            StaticBlog_classCallCheck(this, StaticBlog);

            this.$articles = jquery_default()(
              "[data-article-excerpts]",
              section.el
            );
            this.blogLayout = new BlogLayout_BlogLayout(this.$articles);
          }

          StaticBlog_createClass(StaticBlog, [
            {
              key: "onSectionUnload",
              value: function onSectionUnload() {
                this.blogLayout.unload();
              },
            },
          ]);

          return StaticBlog;
        })();

      // CONCATENATED MODULE: ./source/scripts/components/Menu.js
      function Menu_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function Menu_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function Menu_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          Menu_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Menu_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var Menu_Menu =
        /*#__PURE__*/
        (function () {
          function Menu($el, states, initialState) {
            var _this = this;

            Menu_classCallCheck(this, Menu);

            this.$el = $el;
            this.el = $el[0];
            this.states = states;
            this.currentState = initialState;
            this.$currentStateSlideout = jquery_default()();
            this.$el.slideDown(function () {
              _this.changeState(_this.currentState);
            });
          }

          Menu_createClass(Menu, [
            {
              key: "changeState",
              value: function changeState(newState) {
                var _this2 = this;

                var $oldSlideout = jquery_default()(
                  this.currentState.slideoutSelector,
                  this.$el
                );
                var $oldButtons = jquery_default()(
                  this.currentState.buttonsSelector,
                  this.$el
                );
                var $newSlideout = jquery_default()(
                  newState.slideoutSelector,
                  this.$el
                );
                var $newButtons = jquery_default()(
                  newState.buttonsSelector,
                  this.$el
                );
                var callback = newState.callback;

                if (callback) {
                  callback(this.currentState);
                }

                this._unbindEvents();

                this._unbindSlideoutEvents();

                this.currentState = newState;
                this.$currentStateSlideout = $newSlideout;

                this._bindEvents();

                if ($oldButtons.length) {
                  $oldButtons.hide(0, function () {
                    return $newButtons.show(0);
                  });
                } else {
                  $newButtons.show(0);
                }

                if ($oldSlideout.length) {
                  $oldSlideout.slideUp(function () {
                    return $newSlideout.slideDown(function () {
                      _this2._bindSlideoutEvents();

                      $newSlideout.focus();
                    });
                  });
                } else {
                  $newSlideout.slideDown(function () {
                    _this2._bindSlideoutEvents();

                    $newSlideout.focus();
                  });
                }

                return true;
              },
            },
            {
              key: "_bindEvents",
              value: function _bindEvents() {
                var _this3 = this;

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  var _loop = function _loop() {
                    var button = _step.value;
                    jquery_default()(button.selector, _this3.$el).on(
                      "click.menu",
                      function () {
                        return button.callback();
                      }
                    );
                  };

                  for (
                    var _iterator =
                        this.currentState.buttons[Symbol.iterator](),
                      _step;
                    !(_iteratorNormalCompletion = (_step = _iterator.next())
                      .done);
                    _iteratorNormalCompletion = true
                  ) {
                    _loop();
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (
                      !_iteratorNormalCompletion &&
                      _iterator.return != null
                    ) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }
              },
            },
            {
              key: "_unbindEvents",
              value: function _unbindEvents() {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                  for (
                    var _iterator2 =
                        this.currentState.buttons[Symbol.iterator](),
                      _step2;
                    !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next())
                      .done);
                    _iteratorNormalCompletion2 = true
                  ) {
                    var button = _step2.value;
                    jquery_default()(button.selector, this.$el).off(
                      "click.menu"
                    );
                  }
                } catch (err) {
                  _didIteratorError2 = true;
                  _iteratorError2 = err;
                } finally {
                  try {
                    if (
                      !_iteratorNormalCompletion2 &&
                      _iterator2.return != null
                    ) {
                      _iterator2.return();
                    }
                  } finally {
                    if (_didIteratorError2) {
                      throw _iteratorError2;
                    }
                  }
                }
              },
            },
            {
              key: "_bindSlideoutEvents",
              value: function _bindSlideoutEvents() {
                var _this4 = this;

                if (!this.$currentStateSlideout.length) {
                  return;
                }

                jquery_default()(window).on("focusin.menu", function (event) {
                  var $target = jquery_default()(event.target);

                  if (!_this4.$currentStateSlideout.length) {
                    return;
                  }

                  if (
                    !jquery_default.a.contains(_this4.$el[0], $target[0]) &&
                    !jquery_default.a.contains(
                      _this4.$currentStateSlideout[0],
                      $target[0]
                    )
                  ) {
                    var dismiss = _this4.currentState.dismiss;

                    if (dismiss) {
                      dismiss(_this4.currentState);
                    }
                  }
                });
                jquery_default()(window).on("touchstart.menu", function () {
                  return _this4._minimizeSlideout();
                });
                jquery_default()(window).on(
                  "touchend.menu touchcancel.menu",
                  function () {
                    _this4._maximizeSlideout();
                  }
                );
                this.$el.on("touchstart.menu", function (event) {
                  event.stopPropagation();
                });
                this.$el.on("touchend.menu, ", function (event) {
                  event.stopPropagation();
                });
              },
            },
            {
              key: "_unbindSlideoutEvents",
              value: function _unbindSlideoutEvents() {
                if (!this.$currentStateSlideout.length) {
                  return;
                }

                jquery_default()(window).off("focusin.menu");
                jquery_default()(window).off("touchstart.menu");
                jquery_default()(window).off("touchend.menu touchcancel.menu");
                this.$el.off("touchstart.menu");
                this.$el.off("touchend.menu");
              },
            },
            {
              key: "_minimizeSlideout",
              value: function _minimizeSlideout() {
                if (!this.$currentStateSlideout.length) {
                  return;
                }

                var height =
                  this.$currentStateSlideout[0].getBoundingClientRect().height;
                this.$currentStateSlideout.animate(
                  {
                    height: height / 2,
                    opacity: 0.2,
                  },
                  {
                    queue: false,
                    duration: 500,
                  }
                );
              },
            },
            {
              key: "_maximizeSlideout",
              value: function _maximizeSlideout() {
                if (!this.$currentStateSlideout.length) {
                  return;
                }

                var oldHeight =
                  this.$currentStateSlideout[0].getBoundingClientRect().height;
                this.$currentStateSlideout.css("height", "");
                var height =
                  this.$currentStateSlideout[0].getBoundingClientRect().height;
                this.$currentStateSlideout.css("height", oldHeight);
                this.$currentStateSlideout.animate(
                  {
                    height: height,
                    opacity: 1,
                  },
                  {
                    queue: false,
                    duration: 500,
                  }
                );
              },
            },
            {
              key: "minimizeMenu",
              value: function minimizeMenu() {
                this.el.classList.add("menu-minimized");
              },
            },
            {
              key: "maximizeMenu",
              value: function maximizeMenu() {
                this.el.classList.remove("menu-minimized");
              },
            },
            {
              key: "unload",
              value: function unload() {
                this._unbindEvents();

                this._unbindSlideoutEvents();
              },
            },
          ]);

          return Menu;
        })();

      // CONCATENATED MODULE: ./source/scripts/sections/StaticCart.js
      function StaticCart_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function StaticCart_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function StaticCart_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          StaticCart_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) StaticCart_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var StaticCart_StaticCart =
        /*#__PURE__*/
        (function () {
          function StaticCart(section) {
            var _this = this;

            StaticCart_classCallCheck(this, StaticCart);

            this.$el = jquery_default()(section.el);
            this.data = section.data;
            this.events = []; // Shipping calculator

            this.$shippingToggle = this.$el.find(
              "[data-shipping-calculator-toggle]"
            );
            this.$shippingFieldsInline = this.$el.find(
              ".shipping-calculator-inline .shipping-calculator-fields"
            );
            Shopify.Cart.ShippingCalculator.show({
              submitButton: this.data.button_update_shipping_title,
              submitButtonDisabled:
                this.data.button_update_shipping_disabled_title,
              customerIsLoggedIn: this.data.customer_logged_in,
              moneyFormat: this.data.money_format,
            });
            this.events.push(
              this.$shippingToggle.on("click.cart", function (event) {
                event.preventDefault();

                _this._toggleInlineShippingCalculator();
              })
            ); // Menu system

            this.states = {
              default: {
                buttonsSelector: "[data-cart-menu-buttons-default]",
                buttons: [
                  {
                    selector: "[data-cart-menu-button-calculate-shipping]",
                    callback: function callback() {
                      _this.menu.changeState(_this.states.shippingCalculator);
                    },
                  },
                ],
              },
              shippingCalculator: {
                slideoutSelector: "[data-cart-menu-slideout]",
                buttonsSelector: "[data-cart-menu-buttons-shipping-calculator]",
                buttons: [
                  {
                    selector: "[data-cart-menu-slideout-button-dismiss]",
                    callback: function callback() {
                      _this.menu.changeState(_this.states.default);
                    },
                  },
                  {
                    selector: "[data-cart-menu-button-cancel-shipping]",
                    callback: function callback() {
                      _this.menu.changeState(_this.states.default);
                    },
                  },
                  {
                    selector: "[data-cart-menu-button-update-shipping]",
                    // None needed, Shopify.Cart.ShippingCalculator takes care of this
                    callback: function callback() {},
                  },
                ],
                dismiss: function dismiss() {
                  _this.menu.changeState(_this.states.default);
                },
              },
            };
            this.$cartMenuContainer = jquery_default()(
              "[data-cart-menu-container]",
              this.$el
            );
            this.menu = new Menu_Menu(
              this.$cartMenuContainer,
              this.states,
              this.states.default
            );
            Cart.addCart(section.el, section.postMessage);
          }

          StaticCart_createClass(StaticCart, [
            {
              key: "_toggleInlineShippingCalculator",
              value: function _toggleInlineShippingCalculator() {
                // Toggle form
                this.$shippingFieldsInline.toggle(); // Toggle button text

                var text = this.$shippingToggle.data("toggle-text");
                this.$shippingToggle.data(
                  "toggle-text",
                  this.$shippingToggle.text()
                );
                this.$shippingToggle.text(text);
              },
            },
            {
              key: "onSectionMessage",
              value: function onSectionMessage(name, data) {
                if (name === "header-minicart:open") {
                  var transitionEnded = jquery_default.a.Deferred();
                  data(transitionEnded);
                  this.$cartMenuContainer.one("transitionend", function () {
                    return transitionEnded.resolve();
                  });
                  this.menu.minimizeMenu();
                }

                if (name === "header-minicart:close") {
                  this.menu.maximizeMenu();
                }
              },
            },
            {
              key: "onSectionUnload",
              value: function onSectionUnload() {
                this.events.forEach(function ($el) {
                  return $el.off(".cart");
                });
              },
            },
          ]);

          return StaticCart;
        })();

      // CONCATENATED MODULE: ./source/scripts/components/Select.js
      function Select_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function Select_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function Select_createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          Select_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Select_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var Select =
        /*#__PURE__*/
        (function () {
          function Select(el) {
            var options =
              arguments.length > 1 && arguments[1] !== undefined
                ? arguments[1]
                : {};

            Select_classCallCheck(this, Select);

            this.callback = options.callback || false;
            this.label = el.querySelector("[data-select-label]");
            this.select = el.querySelector("[data-select]");
            this.onChange = this._onChange.bind(this);
            this.select.addEventListener("change", this.onChange);
          }

          Select_createClass(Select, [
            {
              key: "_onChange",
              value: function _onChange() {
                var text = this.select[this.select.selectedIndex].text;
                var value = this.select[this.select.selectedIndex].value;
                this.label.innerText = text;

                if (this.callback) {
                  this.callback(value);
                }
              },
            },
            {
              key: "unload",
              value: function unload() {
                this.select.removeEventListener("change", this.onChange);
              },
            },
          ]);

          return Select;
        })();

      // CONCATENATED MODULE: ./source/scripts/sections/StaticCollection.js
      function StaticCollection_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function StaticCollection_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function StaticCollection_createClass(
        Constructor,
        protoProps,
        staticProps
      ) {
        if (protoProps)
          StaticCollection_defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
          StaticCollection_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      var StaticCollection_StaticSection =
        /*#__PURE__*/
        (function () {
          function StaticSection(section) {
            var _this = this;

            StaticCollection_classCallCheck(this, StaticSection);

            this.section = section;
            this.$el = jquery_default()(section.el);
            this.el = section.el;
            this.data = section.data;
            this.$clearButton = jquery_default()("[data-clear-tags]", this.$el);
            this.onFilterChange = this._onFilterChange.bind(this);
            this.onSortByChange = this._onSortByChange.bind(this);
            this._infiniteScrollHandler =
              this._infiniteScrollHandler.bind(this);
            this.selectWrapperFilter = section.el.querySelector(
              "[data-select-wrapper-filter]"
            );
            this.selectWrapperSortBy = section.el.querySelector(
              "[data-select-wrapper-sortby]"
            );

            if (this.selectWrapperFilter && this.selectWrapperSortBy) {
              this.selectFilter = new Select(this.selectWrapperFilter, {
                callback: this.onFilterChange,
              });
              this.selectSortBy = new Select(this.selectWrapperSortBy, {
                callback: this.onSortByChange,
              });
            } // Menu system

            this.states = {
              default: {
                buttonsSelector: "[data-collection-menu-buttons-default]",
                buttons: [
                  {
                    selector: "[data-collection-menu-button-sortby]",
                    callback: function callback() {
                      _this.menu.changeState(_this.states.sortBy);
                    },
                  },
                  {
                    selector: "[data-collection-menu-button-refine]",
                    callback: function callback() {
                      _this.menu.changeState(_this.states.refine);
                    },
                  },
                ],
              },
              sortBy: {
                slideoutSelector: "[data-collection-slideout-sortby]",
                buttonsSelector: "[data-collection-menu-buttons-sortby]",
                buttons: [
                  {
                    selector: "[data-collection-menu-slideout-button-dismiss]",
                    callback: function callback() {
                      _this.menu.changeState(_this.states.default);
                    },
                  },
                  {
                    selector: "[data-collection-menu-button-cancel]",
                    callback: function callback() {
                      _this.menu.changeState(_this.states.default);
                    },
                  },
                  {
                    selector: "[data-collection-menu-button-apply]",
                    callback: function callback() {
                      _this._applySortByAndRefine();
                    },
                  },
                ],
                dismiss: function dismiss() {
                  _this.menu.changeState(_this.states.default);
                },
              },
              refine: {
                slideoutSelector: "[data-collection-slideout-refine]",
                buttonsSelector: "[data-collection-menu-buttons-refine]",
                buttons: [
                  {
                    selector: "[data-collection-menu-slideout-button-dismiss]",
                    callback: function callback() {
                      _this.menu.changeState(_this.states.default);
                    },
                  },
                  {
                    selector: "[data-collection-menu-button-cancel]",
                    callback: function callback() {
                      _this.menu.changeState(_this.states.default);
                    },
                  },
                  {
                    selector: "[data-collection-menu-button-apply]",
                    callback: function callback() {
                      _this._applySortByAndRefine();
                    },
                  },
                ],
                dismiss: function dismiss() {
                  _this.menu.changeState(_this.states.default);
                },
              },
            };
            this.$collectionMenuContainer = jquery_default()(
              "[data-collection-menu-container]",
              this.$el
            );

            if (this.$collectionMenuContainer.length) {
              this.menu = new Menu_Menu(
                this.$collectionMenuContainer,
                this.states,
                this.states.default
              );
            } // History

            this.isThemeEditor = window.Shopify && window.Shopify.designMode;
            this.useHistory = !this.isThemeEditor && history.pushState; // Filters

            this.$collectionTags = jquery_default()(
              "[data-collection-tag]",
              this.$el
            );
            this.$sortByOptions = jquery_default()(
              "[data-sortby-option]",
              this.$el
            );
            this.selectedCollectionTag = this.useHistory
              ? this.data.current_tags
              : ""; // Product items

            this.productItems = [];
            var $productItems = jquery_default()(
              "[data-product-item]",
              this.$el
            );
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (
                var _iterator = $productItems[Symbol.iterator](), _step;
                !(_iteratorNormalCompletion = (_step = _iterator.next()).done);
                _iteratorNormalCompletion = true
              ) {
                var productItem = _step.value;
                this.productItems.push(
                  new ProductItem_ProductItem(
                    jquery_default()(productItem),
                    this.section.postMessage
                  )
                );
              } // Infinite scroll
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            if (
              this.data.pagination_method.indexOf("infinite_scroll") > -1 &&
              this.data.products_per_page < this.data.total_products &&
              window.location.search.indexOf("page") === -1
            ) {
              this.loadMoreTarget = this.el.querySelector(
                "[data-infinite-scroll-target]"
              );
              this.showMoreButton = this.el.querySelector(
                "[data-infinite-scroll-show-more]"
              );
              this.showMoreButton.style.display = "block"; // If we're infinite scrolling, we want to hide pagination
              // while still keeping it accessible for screenreaders.

              var pagination = this.el.querySelector(".pagination");
              pagination.style.position = "absolute";
              pagination.style.left = "-9999px";
              this.currentPage = 1;
              this.fullCollectionLoaded = false;
              this.enableInfiniteScroll = true;

              if (this.data.pagination_method === "infinite_scroll") {
                var observer = new IntersectionObserver(function (entries) {
                  entries.forEach(function (entry) {
                    if (entry.intersectionRatio > 0) {
                      _this.scrollTargetVisible = true;

                      _this._infiniteScroll();
                    } else {
                      _this.scrollTargetVisible = false;
                    }
                  });
                });
                observer.observe(this.loadMoreTarget);
              }
            }

            this._setSortByQueryParameters();

            this._updateSortByButtons();

            this._bindEvents();

            this.$el[0].addEventListener("rimg-loaded", function () {
              var $collectionGrid = jquery_default()(
                "[data-collection-grid]",
                _this.$el
              );
              $collectionGrid.removeClass("collection-grid-uninit");

              _this._positionItems();
            });
          }

          StaticCollection_createClass(StaticSection, [
            {
              key: "_bindEvents",
              value: function _bindEvents() {
                var _this2 = this;

                jquery_default()(window).on("resize.collection", function () {
                  return _this2._positionItems();
                }); // Handles collection tag click event

                this.$collectionTags.on(
                  "click.collection-menu",
                  function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    var $selectedTag = jquery_default()(event.currentTarget);
                    var tag = $selectedTag.data("collection-tag");
                    jquery_default()(
                      "[data-collection-tag-selected]"
                    ).removeAttr("data-collection-tag-selected");
                    _this2.selectedCollectionTag = tag;
                    $selectedTag.attr("data-collection-tag-selected", "");

                    _this2.$clearButton.removeClass("hidden");
                  }
                );
                this.$clearButton.on("click", function (event) {
                  _this2.selectedCollectionTag = "";
                  jquery_default()("[data-collection-tag-selected]").removeAttr(
                    "data-collection-tag-selected"
                  );
                });
                this.$sortByOptions.on(
                  "click.collection-menu",
                  function (event) {
                    var $selectedSortByOption = jquery_default()(
                      event.currentTarget
                    );
                    Shopify.queryParams.sort_by = $selectedSortByOption.val();

                    _this2.$sortByOptions
                      .parent()
                      .removeClass("collection-sortby-option-selected");

                    $selectedSortByOption
                      .parent()
                      .addClass("collection-sortby-option-selected");
                  }
                );

                if (this.enableInfiniteScroll) {
                  this.showMoreButton.addEventListener(
                    "click",
                    this._infiniteScrollHandler
                  );
                }
              },
            },
            {
              key: "_unbindEvents",
              value: function _unbindEvents() {
                jquery_default()(window).off("resize.collection");
                this.$collectionTags.off("click.collection-menu");
                this.$sortByOptions.off("click.collection-menu");

                if (this.enableInfiniteScroll) {
                  this.showMoreButton.removeEventListener(
                    "click",
                    this._infiniteScrollHandler
                  );
                }
              },
            },
            {
              key: "_positionItems",
              value: function _positionItems() {
                var $header = jquery_default()(
                  "[data-collection-header]",
                  this.$el
                );
                var $gridItems = jquery_default()(
                  "[data-collection-grid-item]",
                  this.$el
                );
                var headerBottom = $header[0].getBoundingClientRect().bottom;
                var foundFirstClear = false;
                var lastGridItemTop = Infinity;
                var currentRowGridItems = [];
                var tallestRowGridItemHeight = -Infinity;
                $gridItems.css({
                  clear: "",
                  height: "",
                });
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                  for (
                    var _iterator2 = $gridItems[Symbol.iterator](), _step2;
                    !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next())
                      .done);
                    _iteratorNormalCompletion2 = true
                  ) {
                    var gridItem = _step2.value;
                    var $gridItem = jquery_default()(gridItem);
                    var gridItemRect = gridItem.getBoundingClientRect();
                    var gridItemPercentageExceeding =
                      gridItemRect.bottom < headerBottom
                        ? 0
                        : (gridItemRect.bottom - headerBottom) /
                          gridItemRect.height;

                    if (
                      lastGridItemTop != Infinity &&
                      gridItemRect.top != lastGridItemTop
                    ) {
                      currentRowGridItems.forEach(function ($el) {
                        return $el.css("height", tallestRowGridItemHeight);
                      });
                      tallestRowGridItemHeight = -Infinity;
                      currentRowGridItems = [];
                    }

                    tallestRowGridItemHeight = Math.max(
                      tallestRowGridItemHeight,
                      gridItemRect.height
                    );
                    currentRowGridItems.push($gridItem);

                    if (
                      !foundFirstClear &&
                      (gridItemPercentageExceeding > 0.6 ||
                        gridItemRect.top > headerBottom)
                    ) {
                      jquery_default()(currentRowGridItems[0]).css(
                        "clear",
                        "left"
                      );
                      foundFirstClear = true;
                    }

                    lastGridItemTop = gridItem.getBoundingClientRect().top;
                  }
                } catch (err) {
                  _didIteratorError2 = true;
                  _iteratorError2 = err;
                } finally {
                  try {
                    if (
                      !_iteratorNormalCompletion2 &&
                      _iterator2.return != null
                    ) {
                      _iterator2.return();
                    }
                  } finally {
                    if (_didIteratorError2) {
                      throw _iteratorError2;
                    }
                  }
                }
              },
            },
            {
              key: "_setSortByQueryParameters",
              value: function _setSortByQueryParameters() {
                Shopify.queryParams = {};

                if (location.search.length) {
                  for (
                    var aKeyValue,
                      i = 0,
                      aCouples = location.search.substr(1).split("&");
                    i < aCouples.length;
                    i++
                  ) {
                    aKeyValue = aCouples[i].split("="); // Reset the page number when we apply (i.e. don't add it to params)

                    if (aKeyValue.length > 1 && aKeyValue[0] != "page") {
                      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] =
                        decodeURIComponent(aKeyValue[1]);
                    } else if (aKeyValue[0] === "page") {
                      this.currentPage = parseInt(aKeyValue[1]);
                    }
                  }
                }
              },
            },
            {
              key: "_updateSortByButtons",
              value: function _updateSortByButtons() {
                this.$sortByOptions
                  .filter('[value="'.concat(this.data.sort_by, '"]'))
                  .prop("checked", true)
                  .parent()
                  .addClass("collection-sortby-option-selected");
              },
            },
            {
              key: "_applySortByAndRefine",
              value: function _applySortByAndRefine() {
                var isVendor = Shopify.queryParams.q;
                var url = ""
                  .concat(this.data.shop_url, "/collections/")
                  .concat(this.data.collection_handle, "/")
                  .concat(this.selectedCollectionTag, "?")
                  .concat(jquery_default.a.param(Shopify.queryParams));

                if (isVendor) {
                  url = ""
                    .concat(this.data.shop_url, "/collections/all/")
                    .concat(this.selectedCollectionTag, "?")
                    .concat(jquery_default.a.param(Shopify.queryParams));
                }

                window.location = url;
              },
            },
            {
              key: "_onFilterChange",
              value: function _onFilterChange(value) {
                this.selectedCollectionTag = value;

                this._applySortByAndRefine();
              },
            },
            {
              key: "_onSortByChange",
              value: function _onSortByChange(value) {
                Shopify.queryParams.sort_by = value;

                this._applySortByAndRefine();
              },
            },
            {
              key: "_infiniteScrollHandler",
              value: function _infiniteScrollHandler() {
                // Use handler so _infiniteScroll isn't called with event as argument
                this._infiniteScroll();
              },
            },
            {
              key: "_infiniteScroll",
              value: function _infiniteScroll() {
                var _this3 = this;

                var autoScrollCount =
                  arguments.length > 0 && arguments[0] !== undefined
                    ? arguments[0]
                    : 0;

                if (this.fullCollectionLoaded || autoScrollCount > 2) {
                  return;
                }

                var currentPage = "page=".concat(this.currentPage);
                this.currentPage++;
                var nextPage = "page=".concat(this.currentPage);
                var url = ""
                  .concat(window.location.pathname)
                  .concat(window.location.search);

                if (window.location.search.indexOf("page") > -1) {
                  url = url.replace(currentPage, nextPage);
                } else if (window.location.search.indexOf("?") > -1) {
                  url = "".concat(url, "&").concat(nextPage);
                } else {
                  url = "".concat(url, "?").concat(nextPage);
                }

                this.showMoreButton.classList.add("loading");
                this.showMoreButton.innerHTML =
                  this.showMoreButton.dataset.infiniteScrollLoading;
                jquery_default.a.ajax({
                  type: "GET",
                  url: url,
                  success: function success(data) {
                    var $products = jquery_default()(data).find(
                      "[data-collection-grid-item]"
                    );

                    for (var i = 0; i < $products.length; i++) {
                      // Grid items are what are ultimately appended to the DOM
                      var $productGridItem = $products.eq(i); // Our JS requires only the article portion of products.
                      // Promotion blocks don't have article tags, and should
                      // no be added to productItems, but should still be added to DOM

                      var $product = $productGridItem.find("article");

                      if ($product.length) {
                        _this3.productItems.push(
                          new ProductItem_ProductItem(
                            $product,
                            _this3.section.postMessage
                          )
                        );
                      }

                      if (
                        shopify_currency_converter_dist_default.a.isInitialised
                      ) {
                        $productGridItem
                          .find(".money")
                          .each(function (index, money) {
                            return shopify_currency_converter_dist_default.a.update(
                              money
                            );
                          });
                      } // Add grid item, either a new product or a promotion block

                      jquery_default()("[data-collection-grid]").append(
                        $productGridItem
                      );
                      rimg_shopify_dist_index_es.watch($productGridItem[0]);
                    }

                    if (
                      _this3.productItems.length === _this3.data.total_products
                    ) {
                      // we've loaded the full collection
                      _this3.fullCollectionLoaded = true;
                      _this3.showMoreButton.style.display = "none";
                    }

                    _this3.showMoreButton.classList.remove("loading");

                    _this3.showMoreButton.innerHTML =
                      _this3.showMoreButton.dataset.infiniteScrollShowMore; // If target is still in viewport, we want to load more items.
                    // But let's keep track of how many times we've done this, and
                    // take a bit of time to let IntersectionObserver catch up.

                    setTimeout(function () {
                      if (_this3.scrollTargetVisible) {
                        _this3._infiniteScroll(autoScrollCount + 1);
                      }
                    }, 200);
                  },
                  dataType: "html",
                });
              },
            },
            {
              key: "onSectionMessage",
              value: function onSectionMessage(name, data) {
                // propogate through productItems, for use by quickshops
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                  for (
                    var _iterator3 = this.productItems[Symbol.iterator](),
                      _step3;
                    !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next())
                      .done);
                    _iteratorNormalCompletion3 = true
                  ) {
                    var productItem = _step3.value;
                    productItem.onSectionMessage(name, data);
                  }
                } catch (err) {
                  _didIteratorError3 = true;
                  _iteratorError3 = err;
                } finally {
                  try {
                    if (
                      !_iteratorNormalCompletion3 &&
                      _iterator3.return != null
                    ) {
                      _iterator3.return();
                    }
                  } finally {
                    if (_didIteratorError3) {
                      throw _iteratorError3;
                    }
                  }
                }

                if (this.menu && name === "header-minicart:open") {
                  var transitionEnded = jquery_default.a.Deferred();
                  data(transitionEnded);
                  this.$collectionMenuContainer.one(
                    "transitionend",
                    function () {
                      return transitionEnded.resolve();
                    }
                  );
                  this.menu.minimizeMenu();
                }

                if (this.menu && name === "header-minicart:close") {
                  this.menu.maximizeMenu();
                }
              },
            },
            {
              key: "onSectionUnload",
              value: function onSectionUnload() {
                this._unbindEvents();

                if (this.menu) {
                  this.menu.unload();
                }

                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                  for (
                    var _iterator4 = this.productItems[Symbol.iterator](),
                      _step4;
                    !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next())
                      .done);
                    _iteratorNormalCompletion4 = true
                  ) {
                    var productItem = _step4.value;
                    productItem.unload();
                  }
                } catch (err) {
                  _didIteratorError4 = true;
                  _iteratorError4 = err;
                } finally {
                  try {
                    if (
                      !_iteratorNormalCompletion4 &&
                      _iterator4.return != null
                    ) {
                      _iterator4.return();
                    }
                  } finally {
                    if (_didIteratorError4) {
                      throw _iteratorError4;
                    }
                  }
                }

                if (this.selectFilter && this.selectSortBy) {
                  this.selectFilter.unload();
                  this.selectSortBy.unload();
                }
              },
            },
          ]);

          return StaticSection;
        })();

      // CONCATENATED MODULE: ./source/scripts/sections/StaticProductRecommendations.js
      function StaticProductRecommendations_classCallCheck(
        instance,
        Constructor
      ) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function StaticProductRecommendations_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function StaticProductRecommendations_createClass(
        Constructor,
        protoProps,
        staticProps
      ) {
        if (protoProps)
          StaticProductRecommendations_defineProperties(
            Constructor.prototype,
            protoProps
          );
        if (staticProps)
          StaticProductRecommendations_defineProperties(
            Constructor,
            staticProps
          );
        return Constructor;
      }

      var StaticProductRecommendations_StaticProductRecommendations =
        /*#__PURE__*/
        (function () {
          function StaticProductRecommendations(section) {
            StaticProductRecommendations_classCallCheck(
              this,
              StaticProductRecommendations
            );

            this.section = section;
            this.productHighlights = new ProductHighlights_ProductHighlights(
              section.el,
              section.postMessage
            );
            var productId = section.data.productId;
            var limit = section.data.settings.limit;
            var recommendationsEl = section.el.querySelector(
              "[data-product-recommendations]"
            );

            this._loadRecommendations(recommendationsEl, productId, limit);
          }

          StaticProductRecommendations_createClass(
            StaticProductRecommendations,
            [
              {
                key: "onSectionUnload",
                value: function onSectionUnload() {
                  this.productHighlights.unload();
                },
              },
              {
                key: "_loadRecommendations",
                value: function _loadRecommendations(
                  container,
                  productId,
                  limit
                ) {
                  var _this = this;

                  var url =
                    "/recommendations/products?section_id=static-product-recommendations&limit="
                      .concat(limit, "&product_id=")
                      .concat(productId);
                  shopify_asyncview_dist_index_es
                    .load(url)
                    .done(function (_ref) {
                      var html = _ref.html;
                      container.innerHTML = html;
                      rimg_shopify_dist_index_es.watch(container);

                      _this.productHighlights.reload();

                      var moneyItems = container.querySelectorAll(".money");

                      for (var i = 0; i < moneyItems.length; i++) {
                        shopify_currency_converter_dist_default.a.update(
                          moneyItems[i]
                        );
                      }

                      if (window.Shopify && Shopify.PaymentButton) {
                        Shopify.PaymentButton.init();
                      }
                    });
                },
              },
            ]
          );

          return StaticProductRecommendations;
        })();

      // CONCATENATED MODULE: ./source/scripts/Handy.js

      // Polyfills

      // jQuery plugins

      // Google maps

      // Template imports

      // Section imports

      var sections = new Sections();
      rimg_shopify_dist_index_es.init();
      sections.register("dynamic-blog-posts", function (section) {
        return new DynamicBlogPosts_DynamicBlogPosts(section);
      });
      sections.register("dynamic-mobile-collections", function (section) {
        return new MobileCollectionsDynamicSection_MobileCollectionsDynamicSection(
          section
        );
      });
      sections.register("dynamic-slideshow", function (section) {
        return new DynamicSlideshow_DynamicSlideshow(section);
      });
      sections.register("dynamic-twitter", function (section) {
        return new DynamicTwitter_DynamicTwitter(section);
      });
      sections.register("dynamic-video", function (section) {
        return new DynamicVideo_DynamicVideo(section);
      });
      sections.register("static-article", function (section) {
        return new StaticArticle_StaticArticle(section);
      });
      sections.register("static-blog", function (section) {
        return new StaticBlog_StaticBlog(section);
      });
      sections.register("static-collection", function (section) {
        return new StaticCollection_StaticSection(section);
      });
      sections.register("static-contactbar", function (section) {
        return new ContactbarStaticSection_ContactbarStaticSection(section);
      });
      sections.register("static-header", function (section) {
        return new HeaderStaticSection_HeaderStaticSection(section);
      });
      sections.register("static-product-recommendations", function (section) {
        return new StaticProductRecommendations_StaticProductRecommendations(
          section
        );
      });
      sections.register("static-search-results", function (section) {
        return new SearchStaticSection_SearchStaticSection(section);
      });
      sections.register("pxs-map", function (section) {
        return new index_es(section);
      }); // Load sections that require the Shopify API

      script_default()(
        jquery_default()("[data-scripts]").data("shopify-api-url"),
        function () {
          sections.register("dynamic-featured-products", function (section) {
            return new DynamicFeaturedProducts_DynamicFeaturedProducts(section);
          });
          sections.register("static-product", function (section) {
            return new Product_Product(section);
          });
          sections.register("dynamic-product", function (section) {
            return new Product_Product(section);
          }); // HeaderMiniCart isn't a real Shopify section, but uses the section postMessage functionality

          sections.register("header-minicart", function (section) {
            return new HeaderMiniCart_HeaderMiniCart(section);
          });
        }
      ); // Cart

      script_default()(
        jquery_default()("[data-scripts]").data("shopify-cart-url"),
        function () {
          sections.register("static-cart", function (section) {
            return new StaticCart_StaticCart(section);
          });
        }
      ); // Giftcard

      script_default()(
        jquery_default()("[data-scripts]").data("shopify-qrcode"),
        function () {
          sections.register("static-giftcard", function (section) {
            return new GiftCardStaticSection_GiftCardStaticSection(section);
          });
        }
      );
      templates_accountTemplates();
      pageTemplates();
      enumerateSections();
      FlickityTouchFix();

      /***/
    },
    /******/
  ]
);
//# sourceMappingURL=handy.js.map?1581544599060

/*---------cart page----------*/

const freesamples = ()=> {
  $total_price = 0;
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    async: false,
  }).done(function (data) {
  $total_price = data.total_price;
  for (var i = 0; i < data.items.length; i++) {
    if (data.items[i].handle == "route-shipping-protection") {
      $total_price = data.total_price - data.items[i].price;
    }
  }
     // console.log('newsdfsdff', $total_price);
  if($total_price >= 5500 && $total_price <= 6599){
    // console.log('news2');
    $('.free-sample-1').removeClass('free-samples')
    $('.free-sample-1').css('pointer-events', 'auto')
  }
  else if ($total_price >= 6600 && $total_price <= 7599) {
    // console.log('news3');
    $('.free-sample-1').removeClass('free-samples')
    $('.free-sample-1').css('pointer-events', 'auto')
    $('.free-sample-2').removeClass('free-samples')
    $('.free-sample-2').css('pointer-events', 'auto')
  }
  else if ($total_price >= 7600 ) {
    // console.log('news4');
    $('.free-sample-1').removeClass('free-samples')
    $('.free-sample-1').css('pointer-events', 'auto')
    $('.free-sample-2').removeClass('free-samples')
    $('.free-sample-2').css('pointer-events', 'auto')
    $('.free-sample-3').removeClass('free-samples')
    $('.free-sample-3').css('pointer-events', 'auto')
  }
    else{
      // console.log('news5');
       $('.free-sample-1').addClass('free-samples')
    $('.free-sample-1').css('pointer-events', 'none')
      $('.free-sample-2').addClass('free-samples')
    $('.free-sample-2').css('pointer-events', 'none')
      $('.free-sample-3').addClass('free-samples')
    $('.free-sample-3').css('pointer-events', 'none')
    }
});
}


$("[data-quantity-increment-cart]").click(function (e) {
  $(this).attr("disabled", "disabled");
  var $input = $(this).siblings("[data-quantity-input-cart]");
  var $value = Number($($input).val());
  var $variant = $($input).attr("data-variant-id");
  $value += 1;
  $($input).val($value);
  $($input).attr("value", $value);
  var Uid = $(this).closest("article").attr("data-bundle-id");
  if (Uid) {
    updateCartNew($value, Uid);
  } else {
    updateCartNew($value, $variant);
  }
});

$("[data-quantity-decrement-cart]").click(function (e) {
  $(this).attr("disabled", "disabled");
  var $input = $(this).siblings("[data-quantity-input-cart]");
  var $value = Number($($input).val());
  var $variant = $($input).attr("data-variant-id");
  if ($value > 1) {
    $value -= 1;
    $($input).val($value);
    $($input).attr("value", $value);
    var Uid = $(this).closest("article").attr("data-bundle-id");
    if (Uid) {
      updateCartNew($value, Uid);
    } else {
      updateCartNew($value, $variant);
    }
  }
});

function updateCartNew($qty, $id) {
  var Uid = $id;

  jQuery
    .ajax({
      type: "GET",
      url: "/cart.js",
      dataType: "json",
    })
    .done(function (response) {
      let ProductArray = [];
      $(response.items).each(function (index, item) {
        if (
          item.properties != undefined &&
          item.properties._bundle_id != undefined
        ) {
          var RadomNo = item.properties["_bundle_id"];
          var itemKey = item.key;
          if (Uid == RadomNo) {
            finalQty = $qty;
            ProductArray.push(finalQty);
          } else {
            ProductArray.push(item.quantity);
          }
        } else if (item.variant_id == Number($id)) {
          ProductArray.push($qty);
        } else {
          ProductArray.push(item.quantity);
        }
      });
      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        dataType: "json",
        data: { updates: ProductArray },
        success: function (data) {
          // console.log(47667);
          var $total_price = data.total_price;
          for (var i = 0; i < data.items.length; i++) {
            if (data.items[i].handle == "route-shipping-protection") {
              $total_price = data.total_price - data.items[i].price;
            }
          }
          if ($total_price > 0 && $total_price <= 9900) {
            var update_data =
              "updates[35786404495526]=1&updates[35786404528294]=0&updates[35786404561062]=0";
          } else if ($total_price >= 10000 && $total_price <= 19900) {
            var update_data =
              "updates[35786404495526]=0&updates[35786404528294]=1&updates[35786404561062]=0";
          } else if ($total_price >= 20000) {
            var update_data =
              "updates[35786404495526]=0&updates[35786404528294]=0&updates[35786404561062]=1";
          } else if ($total_price < 1) {
            var update_data =
              "updates[35786404495526]=0&updates[35786404528294]=0&updates[35786404561062]=0";
          }
          $.ajax({
            type: "POST",
            url: "/cart/update.js",
            data: update_data,
            dataType: "json",
            async: false,
          }).done(function (response) {
            location.reload();
          });
        },
        error: function (error) {
          //   console.log(error);
        },
      });
    });
}

$.get(
  "https://ipinfo.io?token=6617625a83f25b",
  function (response) {
    if (response.country == "US") {
      if (
        response.region != "U.S. Virgin Islands" &&
        response.region != "Armed Forces Americas" &&
        response.region != "Armed Forces Europe" &&
        response.region != "Armed Forces Pacific"
      ) {
        $(".free-shiping-bar").removeClass("hide_shipping_bar");
      } else {
        $(".free-shiping-bar").addClass("hide_shipping_bar");
      }
    } else {
      $(".free-shiping-bar").addClass("hide_shipping_bar");
    }
  },
  "jsonp"
);

if ($(".page-template-cart").length > 0) {
  setTimeout(function () {
    var ids = [];

    $.ajax({
      type: "GET",
      url: "/cart.js",
      dataType: "json",
    }).done(function (response) {
      for (var i = 0; i < response.items.length; i++) {
        var variant_id = response.items[i].variant_id;
        $(".upsell_product_box .cartupsell").each(function () {
          var flag = false;
          var pro_id = $(this).find(".upsell-form button").data("variant-id");
          if (variant_id == pro_id) {
            ids.push(pro_id);
          }
        });
      }

      $(".upsell_product_box .cartupsell").each(function () {
        var pro_id = $(this).find(".upsell-form button").data("variant-id");
        if (!ids.includes(pro_id)) {
          $(this).show();
        }
      });

      $(".upsell_product_box .upsell-form button").on("click", function () {
        var quantity = 1;
        var product_id = $(this).data("variant-id");
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: "quantity=" + quantity + "&id=" + product_id,
          dataType: "json",
        }) // On success
          .done(function (response) {
            location.reload();
          });
      });
    });
  }, 1000);
}

$("#togBtn").change(function (e) {
  var $this = $(this);
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    async: true,
  }).done(function (data) {
    var $total_price = data.total_price;
    for (var i = 0; i < data.items.length; i++) {
      if (data.items[i].handle == "route-shipping-protection") {
        $total_price = data.total_price - data.items[i].price;
      }
    }

    if ($($this).prop("checked") == true) {
      if ($total_price > 0 && $total_price <= 9900) {
        var update_data =
          "updates[35786404495526]=1&updates[35786404528294]=0&updates[35786404561062]=0";
      } else if ($total_price >= 10000 && $total_price <= 19900) {
        var update_data =
          "updates[35786404495526]=0&updates[35786404528294]=1&updates[35786404561062]=0";
      } else if ($total_price >= 20000) {
        var update_data =
          "updates[35786404495526]=0&updates[35786404528294]=0&updates[35786404561062]=1";
      } else if ($total_price == 0) {
        var update_data =
          "updates[35786404495526]=0&updates[35786404528294]=0&updates[35786404561062]=0";
      }
    } else {
      var update_data =
        "updates[35786404495526]=0&updates[35786404528294]=0&updates[35786404561062]=0";
    }
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: update_data,
      dataType: "json",
      async: true,
    }).done(function (response) {
      location.reload();
    });
  });
});

$(".custom-btn-design").on("click", function () {
  $(".product-menu-buttons-addtocart.button-wrap").css("height", "280px");
});
$(".product-menu-slideout-dismiss").on("click", function () {
  $(".product-menu-buttons-addtocart.button-wrap").removeAttr("style");
});
$(".header-minicart-slideout-dismiss").on("click", function () {
  $(".custom-menu").removeAttr("style");
});

$(".product-form").on("submit", function (event) {
  event.preventDefault();
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: $(this).serialize(),
    success: function () {
      // window.location.href = "/cart";
    },
  });
});

$("#video_svg").click(function () {
  var video = $("#image_video").get(0);
  video.play();

  $(this).css("visibility", "hidden");
  return false;
});

$("#image_video").bind("pause ended", function () {
  $("#video_svg").css("visibility", "visible");
});
$("[data-header-site-actions-cart]").on("click", function (event) {});
$total_price = 0;
$.ajax({
  type: "GET",
  url: "/cart.js",
  dataType: "json",
  async: false,
}).done(function (data) {
     // console.log('new');
  $total_price = data.total_price;
  for (var i = 0; i < data.items.length; i++) {
    if (data.items[i].handle == "route-shipping-protection") {
      $total_price = data.total_price - data.items[i].price;
    }
  }
  // console.log($total_price, 'price hai');
});
//  console.log($total_price+'--'+$('#togBtn').prop('checked'));
if ($("#togBtn").prop("checked") == true) {
  if ($total_price > 0 && $total_price <= 9900) {
    var update_data =
      "updates[35786404495526]=1&updates[35786404528294]=0&updates[35786404561062]=0";
    $("[shipping-product-money]").html(Shopify.formatMoney(95));
    //             shopify_currency_converter_dist_default.a.update($('[shipping-product-money]')[0]);
    // console.log($total_price + "-1-" + $("#togBtn").prop("checked"));
  } else if ($total_price >= 10000 && $total_price <= 19900) {
    var update_data =
      "updates[35786404495526]=0&updates[35786404528294]=1&updates[35786404561062]=0";
    $("[shipping-product-money]").html(Shopify.formatMoney(150));
    //             shopify_currency_converter_dist_default.a.update($('[shipping-product-money]')[0]);
    // console.log($total_price + "-2-" + $("#togBtn").prop("checked"));
  } else if ($total_price >= 20000) {
    var update_data =
      "updates[35786404495526]=0&updates[35786404528294]=0&updates[35786404561062]=1";
    $("[shipping-product-money]").html(Shopify.formatMoney(250));
    //             shopify_currency_converter_dist_default.a.update($('[shipping-product-money]')[0]);
    // console.log($total_price + "-3-" + $("#togBtn").prop("checked"));
  } else if ($total_price == 0) {
    var update_data =
      "updates[35786404495526]=0&updates[35786404528294]=0&updates[35786404561062]=0";
    // console.log($total_price + "-4-" + $("#togBtn").prop("checked"));
  }
} else {
  if ($total_price > 0 && $total_price <= 9900) {
    $("[shipping-product-money]").html(Shopify.formatMoney(95));
    //             shopify_currency_converter_dist_default.a.update($('[shipping-product-money]')[0]);
  } else if ($total_price >= 10000 && $total_price <= 19900) {
    $("[shipping-product-money]").html(Shopify.formatMoney(150));
    //             shopify_currency_converter_dist_default.a.update($('[shipping-product-money]')[0]);
  } else if ($total_price >= 20000) {
    $("[shipping-product-money]").html(Shopify.formatMoney(250));
    //             shopify_currency_converter_dist_default.a.update($('[shipping-product-money]')[0]);
  }
  var update_data =
    "updates[35786404495526]=0&updates[35786404528294]=0&updates[35786404561062]=0";
}

//  var $total_price = data.options.total_price;
$.ajax({
  type: "POST",
  url: "/cart/update.js",
  data: update_data,
  dataType: "json",
  async: false,
}).done(function (response) {
            console.log(47912);
  //           location.reload();
});

$('.header-minicart-drawer').on('click', freesamples)

/*! jQuery v3.7.1 | (c) OpenJS Foundation and other contributors | jquery.org/license */
!function(e,t){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return t(e)}:t(e)}("undefined"!=typeof window?window:this,function(ie,e){"use strict";var oe=[],r=Object.getPrototypeOf,ae=oe.slice,g=oe.flat?function(e){return oe.flat.call(e)}:function(e){return oe.concat.apply([],e)},s=oe.push,se=oe.indexOf,n={},i=n.toString,ue=n.hasOwnProperty,o=ue.toString,a=o.call(Object),le={},v=function(e){return"function"==typeof e&&"number"!=typeof e.nodeType&&"function"!=typeof e.item},y=function(e){return null!=e&&e===e.window},C=ie.document,u={type:!0,src:!0,nonce:!0,noModule:!0};function m(e,t,n){var r,i,o=(n=n||C).createElement("script");if(o.text=e,t)for(r in u)(i=t[r]||t.getAttribute&&t.getAttribute(r))&&o.setAttribute(r,i);n.head.appendChild(o).parentNode.removeChild(o)}function x(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?n[i.call(e)]||"object":typeof e}var t="3.7.1",l=/HTML$/i,ce=function(e,t){return new ce.fn.init(e,t)};function c(e){var t=!!e&&"length"in e&&e.length,n=x(e);return!v(e)&&!y(e)&&("array"===n||0===t||"number"==typeof t&&0<t&&t-1 in e)}function fe(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}ce.fn=ce.prototype={jquery:t,constructor:ce,length:0,toArray:function(){return ae.call(this)},get:function(e){return null==e?ae.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=ce.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return ce.each(this,e)},map:function(n){return this.pushStack(ce.map(this,function(e,t){return n.call(e,t,e)}))},slice:function(){return this.pushStack(ae.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},even:function(){return this.pushStack(ce.grep(this,function(e,t){return(t+1)%2}))},odd:function(){return this.pushStack(ce.grep(this,function(e,t){return t%2}))},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(0<=n&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:s,sort:oe.sort,splice:oe.splice},ce.extend=ce.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for("boolean"==typeof a&&(l=a,a=arguments[s]||{},s++),"object"==typeof a||v(a)||(a={}),s===u&&(a=this,s--);s<u;s++)if(null!=(e=arguments[s]))for(t in e)r=e[t],"__proto__"!==t&&a!==r&&(l&&r&&(ce.isPlainObject(r)||(i=Array.isArray(r)))?(n=a[t],o=i&&!Array.isArray(n)?[]:i||ce.isPlainObject(n)?n:{},i=!1,a[t]=ce.extend(l,o,r)):void 0!==r&&(a[t]=r));return a},ce.extend({expando:"jQuery"+(t+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==i.call(e))&&(!(t=r(e))||"function"==typeof(n=ue.call(t,"constructor")&&t.constructor)&&o.call(n)===a)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e,t,n){m(e,{nonce:t&&t.nonce},n)},each:function(e,t){var n,r=0;if(c(e)){for(n=e.length;r<n;r++)if(!1===t.call(e[r],r,e[r]))break}else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},text:function(e){var t,n="",r=0,i=e.nodeType;if(!i)while(t=e[r++])n+=ce.text(t);return 1===i||11===i?e.textContent:9===i?e.documentElement.textContent:3===i||4===i?e.nodeValue:n},makeArray:function(e,t){var n=t||[];return null!=e&&(c(Object(e))?ce.merge(n,"string"==typeof e?[e]:e):s.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:se.call(t,e,n)},isXMLDoc:function(e){var t=e&&e.namespaceURI,n=e&&(e.ownerDocument||e).documentElement;return!l.test(t||n&&n.nodeName||"HTML")},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r=[],i=0,o=e.length,a=!n;i<o;i++)!t(e[i],i)!==a&&r.push(e[i]);return r},map:function(e,t,n){var r,i,o=0,a=[];if(c(e))for(r=e.length;o<r;o++)null!=(i=t(e[o],o,n))&&a.push(i);else for(o in e)null!=(i=t(e[o],o,n))&&a.push(i);return g(a)},guid:1,support:le}),"function"==typeof Symbol&&(ce.fn[Symbol.iterator]=oe[Symbol.iterator]),ce.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){n["[object "+t+"]"]=t.toLowerCase()});var pe=oe.pop,de=oe.sort,he=oe.splice,ge="[\\x20\\t\\r\\n\\f]",ve=new RegExp("^"+ge+"+|((?:^|[^\\\\])(?:\\\\.)*)"+ge+"+$","g");ce.contains=function(e,t){var n=t&&t.parentNode;return e===n||!(!n||1!==n.nodeType||!(e.contains?e.contains(n):e.compareDocumentPosition&&16&e.compareDocumentPosition(n)))};var f=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;function p(e,t){return t?"\0"===e?"\ufffd":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e}ce.escapeSelector=function(e){return(e+"").replace(f,p)};var ye=C,me=s;!function(){var e,b,w,o,a,T,r,C,d,i,k=me,S=ce.expando,E=0,n=0,s=W(),c=W(),u=W(),h=W(),l=function(e,t){return e===t&&(a=!0),0},f="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",t="(?:\\\\[\\da-fA-F]{1,6}"+ge+"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",p="\\["+ge+"*("+t+")(?:"+ge+"*([*^$|!~]?=)"+ge+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+t+"))|)"+ge+"*\\]",g=":("+t+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+p+")*)|.*)\\)|)",v=new RegExp(ge+"+","g"),y=new RegExp("^"+ge+"*,"+ge+"*"),m=new RegExp("^"+ge+"*([>+~]|"+ge+")"+ge+"*"),x=new RegExp(ge+"|>"),j=new RegExp(g),A=new RegExp("^"+t+"$"),D={ID:new RegExp("^#("+t+")"),CLASS:new RegExp("^\\.("+t+")"),TAG:new RegExp("^("+t+"|[*])"),ATTR:new RegExp("^"+p),PSEUDO:new RegExp("^"+g),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+ge+"*(even|odd|(([+-]|)(\\d*)n|)"+ge+"*(?:([+-]|)"+ge+"*(\\d+)|))"+ge+"*\\)|)","i"),bool:new RegExp("^(?:"+f+")$","i"),needsContext:new RegExp("^"+ge+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+ge+"*((?:-\\d)?\\d*)"+ge+"*\\)|)(?=[^-]|$)","i")},N=/^(?:input|select|textarea|button)$/i,q=/^h\d$/i,L=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,H=/[+~]/,O=new RegExp("\\\\[\\da-fA-F]{1,6}"+ge+"?|\\\\([^\\r\\n\\f])","g"),P=function(e,t){var n="0x"+e.slice(1)-65536;return t||(n<0?String.fromCharCode(n+65536):String.fromCharCode(n>>10|55296,1023&n|56320))},M=function(){V()},R=J(function(e){return!0===e.disabled&&fe(e,"fieldset")},{dir:"parentNode",next:"legend"});try{k.apply(oe=ae.call(ye.childNodes),ye.childNodes),oe[ye.childNodes.length].nodeType}catch(e){k={apply:function(e,t){me.apply(e,ae.call(t))},call:function(e){me.apply(e,ae.call(arguments,1))}}}function I(t,e,n,r){var i,o,a,s,u,l,c,f=e&&e.ownerDocument,p=e?e.nodeType:9;if(n=n||[],"string"!=typeof t||!t||1!==p&&9!==p&&11!==p)return n;if(!r&&(V(e),e=e||T,C)){if(11!==p&&(u=L.exec(t)))if(i=u[1]){if(9===p){if(!(a=e.getElementById(i)))return n;if(a.id===i)return k.call(n,a),n}else if(f&&(a=f.getElementById(i))&&I.contains(e,a)&&a.id===i)return k.call(n,a),n}else{if(u[2])return k.apply(n,e.getElementsByTagName(t)),n;if((i=u[3])&&e.getElementsByClassName)return k.apply(n,e.getElementsByClassName(i)),n}if(!(h[t+" "]||d&&d.test(t))){if(c=t,f=e,1===p&&(x.test(t)||m.test(t))){(f=H.test(t)&&U(e.parentNode)||e)==e&&le.scope||((s=e.getAttribute("id"))?s=ce.escapeSelector(s):e.setAttribute("id",s=S)),o=(l=Y(t)).length;while(o--)l[o]=(s?"#"+s:":scope")+" "+Q(l[o]);c=l.join(",")}try{return k.apply(n,f.querySelectorAll(c)),n}catch(e){h(t,!0)}finally{s===S&&e.removeAttribute("id")}}}return re(t.replace(ve,"$1"),e,n,r)}function W(){var r=[];return function e(t,n){return r.push(t+" ")>b.cacheLength&&delete e[r.shift()],e[t+" "]=n}}function F(e){return e[S]=!0,e}function $(e){var t=T.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function B(t){return function(e){return fe(e,"input")&&e.type===t}}function _(t){return function(e){return(fe(e,"input")||fe(e,"button"))&&e.type===t}}function z(t){return function(e){return"form"in e?e.parentNode&&!1===e.disabled?"label"in e?"label"in e.parentNode?e.parentNode.disabled===t:e.disabled===t:e.isDisabled===t||e.isDisabled!==!t&&R(e)===t:e.disabled===t:"label"in e&&e.disabled===t}}function X(a){return F(function(o){return o=+o,F(function(e,t){var n,r=a([],e.length,o),i=r.length;while(i--)e[n=r[i]]&&(e[n]=!(t[n]=e[n]))})})}function U(e){return e&&"undefined"!=typeof e.getElementsByTagName&&e}function V(e){var t,n=e?e.ownerDocument||e:ye;return n!=T&&9===n.nodeType&&n.documentElement&&(r=(T=n).documentElement,C=!ce.isXMLDoc(T),i=r.matches||r.webkitMatchesSelector||r.msMatchesSelector,r.msMatchesSelector&&ye!=T&&(t=T.defaultView)&&t.top!==t&&t.addEventListener("unload",M),le.getById=$(function(e){return r.appendChild(e).id=ce.expando,!T.getElementsByName||!T.getElementsByName(ce.expando).length}),le.disconnectedMatch=$(function(e){return i.call(e,"*")}),le.scope=$(function(){return T.querySelectorAll(":scope")}),le.cssHas=$(function(){try{return T.querySelector(":has(*,:jqfake)"),!1}catch(e){return!0}}),le.getById?(b.filter.ID=function(e){var t=e.replace(O,P);return function(e){return e.getAttribute("id")===t}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&C){var n=t.getElementById(e);return n?[n]:[]}}):(b.filter.ID=function(e){var n=e.replace(O,P);return function(e){var t="undefined"!=typeof e.getAttributeNode&&e.getAttributeNode("id");return t&&t.value===n}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&C){var n,r,i,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];i=t.getElementsByName(e),r=0;while(o=i[r++])if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),b.find.TAG=function(e,t){return"undefined"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):t.querySelectorAll(e)},b.find.CLASS=function(e,t){if("undefined"!=typeof t.getElementsByClassName&&C)return t.getElementsByClassName(e)},d=[],$(function(e){var t;r.appendChild(e).innerHTML="<a id='"+S+"' href='' disabled='disabled'></a><select id='"+S+"-\r\\' disabled='disabled'><option selected=''></option></select>",e.querySelectorAll("[selected]").length||d.push("\\["+ge+"*(?:value|"+f+")"),e.querySelectorAll("[id~="+S+"-]").length||d.push("~="),e.querySelectorAll("a#"+S+"+*").length||d.push(".#.+[+~]"),e.querySelectorAll(":checked").length||d.push(":checked"),(t=T.createElement("input")).setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),r.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&d.push(":enabled",":disabled"),(t=T.createElement("input")).setAttribute("name",""),e.appendChild(t),e.querySelectorAll("[name='']").length||d.push("\\["+ge+"*name"+ge+"*="+ge+"*(?:''|\"\")")}),le.cssHas||d.push(":has"),d=d.length&&new RegExp(d.join("|")),l=function(e,t){if(e===t)return a=!0,0;var n=!e.compareDocumentPosition-!t.compareDocumentPosition;return n||(1&(n=(e.ownerDocument||e)==(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!le.sortDetached&&t.compareDocumentPosition(e)===n?e===T||e.ownerDocument==ye&&I.contains(ye,e)?-1:t===T||t.ownerDocument==ye&&I.contains(ye,t)?1:o?se.call(o,e)-se.call(o,t):0:4&n?-1:1)}),T}for(e in I.matches=function(e,t){return I(e,null,null,t)},I.matchesSelector=function(e,t){if(V(e),C&&!h[t+" "]&&(!d||!d.test(t)))try{var n=i.call(e,t);if(n||le.disconnectedMatch||e.document&&11!==e.document.nodeType)return n}catch(e){h(t,!0)}return 0<I(t,T,null,[e]).length},I.contains=function(e,t){return(e.ownerDocument||e)!=T&&V(e),ce.contains(e,t)},I.attr=function(e,t){(e.ownerDocument||e)!=T&&V(e);var n=b.attrHandle[t.toLowerCase()],r=n&&ue.call(b.attrHandle,t.toLowerCase())?n(e,t,!C):void 0;return void 0!==r?r:e.getAttribute(t)},I.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},ce.uniqueSort=function(e){var t,n=[],r=0,i=0;if(a=!le.sortStable,o=!le.sortStable&&ae.call(e,0),de.call(e,l),a){while(t=e[i++])t===e[i]&&(r=n.push(i));while(r--)he.call(e,n[r],1)}return o=null,e},ce.fn.uniqueSort=function(){return this.pushStack(ce.uniqueSort(ae.apply(this)))},(b=ce.expr={cacheLength:50,createPseudo:F,match:D,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(O,P),e[3]=(e[3]||e[4]||e[5]||"").replace(O,P),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||I.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&I.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return D.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&j.test(n)&&(t=Y(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(O,P).toLowerCase();return"*"===e?function(){return!0}:function(e){return fe(e,t)}},CLASS:function(e){var t=s[e+" "];return t||(t=new RegExp("(^|"+ge+")"+e+"("+ge+"|$)"))&&s(e,function(e){return t.test("string"==typeof e.className&&e.className||"undefined"!=typeof e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(n,r,i){return function(e){var t=I.attr(e,n);return null==t?"!="===r:!r||(t+="","="===r?t===i:"!="===r?t!==i:"^="===r?i&&0===t.indexOf(i):"*="===r?i&&-1<t.indexOf(i):"$="===r?i&&t.slice(-i.length)===i:"~="===r?-1<(" "+t.replace(v," ")+" ").indexOf(i):"|="===r&&(t===i||t.slice(0,i.length+1)===i+"-"))}},CHILD:function(d,e,t,h,g){var v="nth"!==d.slice(0,3),y="last"!==d.slice(-4),m="of-type"===e;return 1===h&&0===g?function(e){return!!e.parentNode}:function(e,t,n){var r,i,o,a,s,u=v!==y?"nextSibling":"previousSibling",l=e.parentNode,c=m&&e.nodeName.toLowerCase(),f=!n&&!m,p=!1;if(l){if(v){while(u){o=e;while(o=o[u])if(m?fe(o,c):1===o.nodeType)return!1;s=u="only"===d&&!s&&"nextSibling"}return!0}if(s=[y?l.firstChild:l.lastChild],y&&f){p=(a=(r=(i=l[S]||(l[S]={}))[d]||[])[0]===E&&r[1])&&r[2],o=a&&l.childNodes[a];while(o=++a&&o&&o[u]||(p=a=0)||s.pop())if(1===o.nodeType&&++p&&o===e){i[d]=[E,a,p];break}}else if(f&&(p=a=(r=(i=e[S]||(e[S]={}))[d]||[])[0]===E&&r[1]),!1===p)while(o=++a&&o&&o[u]||(p=a=0)||s.pop())if((m?fe(o,c):1===o.nodeType)&&++p&&(f&&((i=o[S]||(o[S]={}))[d]=[E,p]),o===e))break;return(p-=g)===h||p%h==0&&0<=p/h}}},PSEUDO:function(e,o){var t,a=b.pseudos[e]||b.setFilters[e.toLowerCase()]||I.error("unsupported pseudo: "+e);return a[S]?a(o):1<a.length?(t=[e,e,"",o],b.setFilters.hasOwnProperty(e.toLowerCase())?F(function(e,t){var n,r=a(e,o),i=r.length;while(i--)e[n=se.call(e,r[i])]=!(t[n]=r[i])}):function(e){return a(e,0,t)}):a}},pseudos:{not:F(function(e){var r=[],i=[],s=ne(e.replace(ve,"$1"));return s[S]?F(function(e,t,n,r){var i,o=s(e,null,r,[]),a=e.length;while(a--)(i=o[a])&&(e[a]=!(t[a]=i))}):function(e,t,n){return r[0]=e,s(r,null,n,i),r[0]=null,!i.pop()}}),has:F(function(t){return function(e){return 0<I(t,e).length}}),contains:F(function(t){return t=t.replace(O,P),function(e){return-1<(e.textContent||ce.text(e)).indexOf(t)}}),lang:F(function(n){return A.test(n||"")||I.error("unsupported lang: "+n),n=n.replace(O,P).toLowerCase(),function(e){var t;do{if(t=C?e.lang:e.getAttribute("xml:lang")||e.getAttribute("lang"))return(t=t.toLowerCase())===n||0===t.indexOf(n+"-")}while((e=e.parentNode)&&1===e.nodeType);return!1}}),target:function(e){var t=ie.location&&ie.location.hash;return t&&t.slice(1)===e.id},root:function(e){return e===r},focus:function(e){return e===function(){try{return T.activeElement}catch(e){}}()&&T.hasFocus()&&!!(e.type||e.href||~e.tabIndex)},enabled:z(!1),disabled:z(!0),checked:function(e){return fe(e,"input")&&!!e.checked||fe(e,"option")&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!b.pseudos.empty(e)},header:function(e){return q.test(e.nodeName)},input:function(e){return N.test(e.nodeName)},button:function(e){return fe(e,"input")&&"button"===e.type||fe(e,"button")},text:function(e){var t;return fe(e,"input")&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:X(function(){return[0]}),last:X(function(e,t){return[t-1]}),eq:X(function(e,t,n){return[n<0?n+t:n]}),even:X(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:X(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:X(function(e,t,n){var r;for(r=n<0?n+t:t<n?t:n;0<=--r;)e.push(r);return e}),gt:X(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}}).pseudos.nth=b.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})b.pseudos[e]=B(e);for(e in{submit:!0,reset:!0})b.pseudos[e]=_(e);function G(){}function Y(e,t){var n,r,i,o,a,s,u,l=c[e+" "];if(l)return t?0:l.slice(0);a=e,s=[],u=b.preFilter;while(a){for(o in n&&!(r=y.exec(a))||(r&&(a=a.slice(r[0].length)||a),s.push(i=[])),n=!1,(r=m.exec(a))&&(n=r.shift(),i.push({value:n,type:r[0].replace(ve," ")}),a=a.slice(n.length)),b.filter)!(r=D[o].exec(a))||u[o]&&!(r=u[o](r))||(n=r.shift(),i.push({value:n,type:o,matches:r}),a=a.slice(n.length));if(!n)break}return t?a.length:a?I.error(e):c(e,s).slice(0)}function Q(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function J(a,e,t){var s=e.dir,u=e.next,l=u||s,c=t&&"parentNode"===l,f=n++;return e.first?function(e,t,n){while(e=e[s])if(1===e.nodeType||c)return a(e,t,n);return!1}:function(e,t,n){var r,i,o=[E,f];if(n){while(e=e[s])if((1===e.nodeType||c)&&a(e,t,n))return!0}else while(e=e[s])if(1===e.nodeType||c)if(i=e[S]||(e[S]={}),u&&fe(e,u))e=e[s]||e;else{if((r=i[l])&&r[0]===E&&r[1]===f)return o[2]=r[2];if((i[l]=o)[2]=a(e,t,n))return!0}return!1}}function K(i){return 1<i.length?function(e,t,n){var r=i.length;while(r--)if(!i[r](e,t,n))return!1;return!0}:i[0]}function Z(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)(o=e[s])&&(n&&!n(o,r,i)||(a.push(o),l&&t.push(s)));return a}function ee(d,h,g,v,y,e){return v&&!v[S]&&(v=ee(v)),y&&!y[S]&&(y=ee(y,e)),F(function(e,t,n,r){var i,o,a,s,u=[],l=[],c=t.length,f=e||function(e,t,n){for(var r=0,i=t.length;r<i;r++)I(e,t[r],n);return n}(h||"*",n.nodeType?[n]:n,[]),p=!d||!e&&h?f:Z(f,u,d,n,r);if(g?g(p,s=y||(e?d:c||v)?[]:t,n,r):s=p,v){i=Z(s,l),v(i,[],n,r),o=i.length;while(o--)(a=i[o])&&(s[l[o]]=!(p[l[o]]=a))}if(e){if(y||d){if(y){i=[],o=s.length;while(o--)(a=s[o])&&i.push(p[o]=a);y(null,s=[],i,r)}o=s.length;while(o--)(a=s[o])&&-1<(i=y?se.call(e,a):u[o])&&(e[i]=!(t[i]=a))}}else s=Z(s===t?s.splice(c,s.length):s),y?y(null,t,s,r):k.apply(t,s)})}function te(e){for(var i,t,n,r=e.length,o=b.relative[e[0].type],a=o||b.relative[" "],s=o?1:0,u=J(function(e){return e===i},a,!0),l=J(function(e){return-1<se.call(i,e)},a,!0),c=[function(e,t,n){var r=!o&&(n||t!=w)||((i=t).nodeType?u(e,t,n):l(e,t,n));return i=null,r}];s<r;s++)if(t=b.relative[e[s].type])c=[J(K(c),t)];else{if((t=b.filter[e[s].type].apply(null,e[s].matches))[S]){for(n=++s;n<r;n++)if(b.relative[e[n].type])break;return ee(1<s&&K(c),1<s&&Q(e.slice(0,s-1).concat({value:" "===e[s-2].type?"*":""})).replace(ve,"$1"),t,s<n&&te(e.slice(s,n)),n<r&&te(e=e.slice(n)),n<r&&Q(e))}c.push(t)}return K(c)}function ne(e,t){var n,v,y,m,x,r,i=[],o=[],a=u[e+" "];if(!a){t||(t=Y(e)),n=t.length;while(n--)(a=te(t[n]))[S]?i.push(a):o.push(a);(a=u(e,(v=o,m=0<(y=i).length,x=0<v.length,r=function(e,t,n,r,i){var o,a,s,u=0,l="0",c=e&&[],f=[],p=w,d=e||x&&b.find.TAG("*",i),h=E+=null==p?1:Math.random()||.1,g=d.length;for(i&&(w=t==T||t||i);l!==g&&null!=(o=d[l]);l++){if(x&&o){a=0,t||o.ownerDocument==T||(V(o),n=!C);while(s=v[a++])if(s(o,t||T,n)){k.call(r,o);break}i&&(E=h)}m&&((o=!s&&o)&&u--,e&&c.push(o))}if(u+=l,m&&l!==u){a=0;while(s=y[a++])s(c,f,t,n);if(e){if(0<u)while(l--)c[l]||f[l]||(f[l]=pe.call(r));f=Z(f)}k.apply(r,f),i&&!e&&0<f.length&&1<u+y.length&&ce.uniqueSort(r)}return i&&(E=h,w=p),c},m?F(r):r))).selector=e}return a}function re(e,t,n,r){var i,o,a,s,u,l="function"==typeof e&&e,c=!r&&Y(e=l.selector||e);if(n=n||[],1===c.length){if(2<(o=c[0]=c[0].slice(0)).length&&"ID"===(a=o[0]).type&&9===t.nodeType&&C&&b.relative[o[1].type]){if(!(t=(b.find.ID(a.matches[0].replace(O,P),t)||[])[0]))return n;l&&(t=t.parentNode),e=e.slice(o.shift().value.length)}i=D.needsContext.test(e)?0:o.length;while(i--){if(a=o[i],b.relative[s=a.type])break;if((u=b.find[s])&&(r=u(a.matches[0].replace(O,P),H.test(o[0].type)&&U(t.parentNode)||t))){if(o.splice(i,1),!(e=r.length&&Q(o)))return k.apply(n,r),n;break}}}return(l||ne(e,c))(r,t,!C,n,!t||H.test(e)&&U(t.parentNode)||t),n}G.prototype=b.filters=b.pseudos,b.setFilters=new G,le.sortStable=S.split("").sort(l).join("")===S,V(),le.sortDetached=$(function(e){return 1&e.compareDocumentPosition(T.createElement("fieldset"))}),ce.find=I,ce.expr[":"]=ce.expr.pseudos,ce.unique=ce.uniqueSort,I.compile=ne,I.select=re,I.setDocument=V,I.tokenize=Y,I.escape=ce.escapeSelector,I.getText=ce.text,I.isXML=ce.isXMLDoc,I.selectors=ce.expr,I.support=ce.support,I.uniqueSort=ce.uniqueSort}();var d=function(e,t,n){var r=[],i=void 0!==n;while((e=e[t])&&9!==e.nodeType)if(1===e.nodeType){if(i&&ce(e).is(n))break;r.push(e)}return r},h=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},b=ce.expr.match.needsContext,w=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function T(e,n,r){return v(n)?ce.grep(e,function(e,t){return!!n.call(e,t,e)!==r}):n.nodeType?ce.grep(e,function(e){return e===n!==r}):"string"!=typeof n?ce.grep(e,function(e){return-1<se.call(n,e)!==r}):ce.filter(n,e,r)}ce.filter=function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?ce.find.matchesSelector(r,e)?[r]:[]:ce.find.matches(e,ce.grep(t,function(e){return 1===e.nodeType}))},ce.fn.extend({find:function(e){var t,n,r=this.length,i=this;if("string"!=typeof e)return this.pushStack(ce(e).filter(function(){for(t=0;t<r;t++)if(ce.contains(i[t],this))return!0}));for(n=this.pushStack([]),t=0;t<r;t++)ce.find(e,i[t],n);return 1<r?ce.uniqueSort(n):n},filter:function(e){return this.pushStack(T(this,e||[],!1))},not:function(e){return this.pushStack(T(this,e||[],!0))},is:function(e){return!!T(this,"string"==typeof e&&b.test(e)?ce(e):e||[],!1).length}});var k,S=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(ce.fn.init=function(e,t,n){var r,i;if(!e)return this;if(n=n||k,"string"==typeof e){if(!(r="<"===e[0]&&">"===e[e.length-1]&&3<=e.length?[null,e,null]:S.exec(e))||!r[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(r[1]){if(t=t instanceof ce?t[0]:t,ce.merge(this,ce.parseHTML(r[1],t&&t.nodeType?t.ownerDocument||t:C,!0)),w.test(r[1])&&ce.isPlainObject(t))for(r in t)v(this[r])?this[r](t[r]):this.attr(r,t[r]);return this}return(i=C.getElementById(r[2]))&&(this[0]=i,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):v(e)?void 0!==n.ready?n.ready(e):e(ce):ce.makeArray(e,this)}).prototype=ce.fn,k=ce(C);var E=/^(?:parents|prev(?:Until|All))/,j={children:!0,contents:!0,next:!0,prev:!0};function A(e,t){while((e=e[t])&&1!==e.nodeType);return e}ce.fn.extend({has:function(e){var t=ce(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(ce.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a="string"!=typeof e&&ce(e);if(!b.test(e))for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?-1<a.index(n):1===n.nodeType&&ce.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(1<o.length?ce.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?se.call(ce(e),this[0]):se.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(ce.uniqueSort(ce.merge(this.get(),ce(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),ce.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return d(e,"parentNode")},parentsUntil:function(e,t,n){return d(e,"parentNode",n)},next:function(e){return A(e,"nextSibling")},prev:function(e){return A(e,"previousSibling")},nextAll:function(e){return d(e,"nextSibling")},prevAll:function(e){return d(e,"previousSibling")},nextUntil:function(e,t,n){return d(e,"nextSibling",n)},prevUntil:function(e,t,n){return d(e,"previousSibling",n)},siblings:function(e){return h((e.parentNode||{}).firstChild,e)},children:function(e){return h(e.firstChild)},contents:function(e){return null!=e.contentDocument&&r(e.contentDocument)?e.contentDocument:(fe(e,"template")&&(e=e.content||e),ce.merge([],e.childNodes))}},function(r,i){ce.fn[r]=function(e,t){var n=ce.map(this,i,e);return"Until"!==r.slice(-5)&&(t=e),t&&"string"==typeof t&&(n=ce.filter(t,n)),1<this.length&&(j[r]||ce.uniqueSort(n),E.test(r)&&n.reverse()),this.pushStack(n)}});var D=/[^\x20\t\r\n\f]+/g;function N(e){return e}function q(e){throw e}function L(e,t,n,r){var i;try{e&&v(i=e.promise)?i.call(e).done(t).fail(n):e&&v(i=e.then)?i.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n.apply(void 0,[e])}}ce.Callbacks=function(r){var e,n;r="string"==typeof r?(e=r,n={},ce.each(e.match(D)||[],function(e,t){n[t]=!0}),n):ce.extend({},r);var i,t,o,a,s=[],u=[],l=-1,c=function(){for(a=a||r.once,o=i=!0;u.length;l=-1){t=u.shift();while(++l<s.length)!1===s[l].apply(t[0],t[1])&&r.stopOnFalse&&(l=s.length,t=!1)}r.memory||(t=!1),i=!1,a&&(s=t?[]:"")},f={add:function(){return s&&(t&&!i&&(l=s.length-1,u.push(t)),function n(e){ce.each(e,function(e,t){v(t)?r.unique&&f.has(t)||s.push(t):t&&t.length&&"string"!==x(t)&&n(t)})}(arguments),t&&!i&&c()),this},remove:function(){return ce.each(arguments,function(e,t){var n;while(-1<(n=ce.inArray(t,s,n)))s.splice(n,1),n<=l&&l--}),this},has:function(e){return e?-1<ce.inArray(e,s):0<s.length},empty:function(){return s&&(s=[]),this},disable:function(){return a=u=[],s=t="",this},disabled:function(){return!s},lock:function(){return a=u=[],t||i||(s=t=""),this},locked:function(){return!!a},fireWith:function(e,t){return a||(t=[e,(t=t||[]).slice?t.slice():t],u.push(t),i||c()),this},fire:function(){return f.fireWith(this,arguments),this},fired:function(){return!!o}};return f},ce.extend({Deferred:function(e){var o=[["notify","progress",ce.Callbacks("memory"),ce.Callbacks("memory"),2],["resolve","done",ce.Callbacks("once memory"),ce.Callbacks("once memory"),0,"resolved"],["reject","fail",ce.Callbacks("once memory"),ce.Callbacks("once memory"),1,"rejected"]],i="pending",a={state:function(){return i},always:function(){return s.done(arguments).fail(arguments),this},"catch":function(e){return a.then(null,e)},pipe:function(){var i=arguments;return ce.Deferred(function(r){ce.each(o,function(e,t){var n=v(i[t[4]])&&i[t[4]];s[t[1]](function(){var e=n&&n.apply(this,arguments);e&&v(e.promise)?e.promise().progress(r.notify).done(r.resolve).fail(r.reject):r[t[0]+"With"](this,n?[e]:arguments)})}),i=null}).promise()},then:function(t,n,r){var u=0;function l(i,o,a,s){return function(){var n=this,r=arguments,e=function(){var e,t;if(!(i<u)){if((e=a.apply(n,r))===o.promise())throw new TypeError("Thenable self-resolution");t=e&&("object"==typeof e||"function"==typeof e)&&e.then,v(t)?s?t.call(e,l(u,o,N,s),l(u,o,q,s)):(u++,t.call(e,l(u,o,N,s),l(u,o,q,s),l(u,o,N,o.notifyWith))):(a!==N&&(n=void 0,r=[e]),(s||o.resolveWith)(n,r))}},t=s?e:function(){try{e()}catch(e){ce.Deferred.exceptionHook&&ce.Deferred.exceptionHook(e,t.error),u<=i+1&&(a!==q&&(n=void 0,r=[e]),o.rejectWith(n,r))}};i?t():(ce.Deferred.getErrorHook?t.error=ce.Deferred.getErrorHook():ce.Deferred.getStackHook&&(t.error=ce.Deferred.getStackHook()),ie.setTimeout(t))}}return ce.Deferred(function(e){o[0][3].add(l(0,e,v(r)?r:N,e.notifyWith)),o[1][3].add(l(0,e,v(t)?t:N)),o[2][3].add(l(0,e,v(n)?n:q))}).promise()},promise:function(e){return null!=e?ce.extend(e,a):a}},s={};return ce.each(o,function(e,t){var n=t[2],r=t[5];a[t[1]]=n.add,r&&n.add(function(){i=r},o[3-e][2].disable,o[3-e][3].disable,o[0][2].lock,o[0][3].lock),n.add(t[3].fire),s[t[0]]=function(){return s[t[0]+"With"](this===s?void 0:this,arguments),this},s[t[0]+"With"]=n.fireWith}),a.promise(s),e&&e.call(s,s),s},when:function(e){var n=arguments.length,t=n,r=Array(t),i=ae.call(arguments),o=ce.Deferred(),a=function(t){return function(e){r[t]=this,i[t]=1<arguments.length?ae.call(arguments):e,--n||o.resolveWith(r,i)}};if(n<=1&&(L(e,o.done(a(t)).resolve,o.reject,!n),"pending"===o.state()||v(i[t]&&i[t].then)))return o.then();while(t--)L(i[t],a(t),o.reject);return o.promise()}});var H=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;ce.Deferred.exceptionHook=function(e,t){ie.console&&ie.console.warn&&e&&H.test(e.name)&&ie.console.warn("jQuery.Deferred exception: "+e.message,e.stack,t)},ce.readyException=function(e){ie.setTimeout(function(){throw e})};var O=ce.Deferred();function P(){C.removeEventListener("DOMContentLoaded",P),ie.removeEventListener("load",P),ce.ready()}ce.fn.ready=function(e){return O.then(e)["catch"](function(e){ce.readyException(e)}),this},ce.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--ce.readyWait:ce.isReady)||(ce.isReady=!0)!==e&&0<--ce.readyWait||O.resolveWith(C,[ce])}}),ce.ready.then=O.then,"complete"===C.readyState||"loading"!==C.readyState&&!C.documentElement.doScroll?ie.setTimeout(ce.ready):(C.addEventListener("DOMContentLoaded",P),ie.addEventListener("load",P));var M=function(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if("object"===x(n))for(s in i=!0,n)M(e,t,s,n[s],!0,o,a);else if(void 0!==r&&(i=!0,v(r)||(a=!0),l&&(a?(t.call(e,r),t=null):(l=t,t=function(e,t,n){return l.call(ce(e),n)})),t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o},R=/^-ms-/,I=/-([a-z])/g;function W(e,t){return t.toUpperCase()}function F(e){return e.replace(R,"ms-").replace(I,W)}var $=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function B(){this.expando=ce.expando+B.uid++}B.uid=1,B.prototype={cache:function(e){var t=e[this.expando];return t||(t={},$(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if("string"==typeof t)i[F(t)]=n;else for(r in t)i[F(r)]=t[r];return i},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][F(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(F):(t=F(t))in r?[t]:t.match(D)||[]).length;while(n--)delete r[t[n]]}(void 0===t||ce.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!ce.isEmptyObject(t)}};var _=new B,z=new B,X=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,U=/[A-Z]/g;function V(e,t,n){var r,i;if(void 0===n&&1===e.nodeType)if(r="data-"+t.replace(U,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{n="true"===(i=n)||"false"!==i&&("null"===i?null:i===+i+""?+i:X.test(i)?JSON.parse(i):i)}catch(e){}z.set(e,t,n)}else n=void 0;return n}ce.extend({hasData:function(e){return z.hasData(e)||_.hasData(e)},data:function(e,t,n){return z.access(e,t,n)},removeData:function(e,t){z.remove(e,t)},_data:function(e,t,n){return _.access(e,t,n)},_removeData:function(e,t){_.remove(e,t)}}),ce.fn.extend({data:function(n,e){var t,r,i,o=this[0],a=o&&o.attributes;if(void 0===n){if(this.length&&(i=z.get(o),1===o.nodeType&&!_.get(o,"hasDataAttrs"))){t=a.length;while(t--)a[t]&&0===(r=a[t].name).indexOf("data-")&&(r=F(r.slice(5)),V(o,r,i[r]));_.set(o,"hasDataAttrs",!0)}return i}return"object"==typeof n?this.each(function(){z.set(this,n)}):M(this,function(e){var t;if(o&&void 0===e)return void 0!==(t=z.get(o,n))?t:void 0!==(t=V(o,n))?t:void 0;this.each(function(){z.set(this,n,e)})},null,e,1<arguments.length,null,!0)},removeData:function(e){return this.each(function(){z.remove(this,e)})}}),ce.extend({queue:function(e,t,n){var r;if(e)return t=(t||"fx")+"queue",r=_.get(e,t),n&&(!r||Array.isArray(n)?r=_.access(e,t,ce.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=ce.queue(e,t),r=n.length,i=n.shift(),o=ce._queueHooks(e,t);"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,function(){ce.dequeue(e,t)},o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return _.get(e,n)||_.access(e,n,{empty:ce.Callbacks("once memory").add(function(){_.remove(e,[t+"queue",n])})})}}),ce.fn.extend({queue:function(t,n){var e=2;return"string"!=typeof t&&(n=t,t="fx",e--),arguments.length<e?ce.queue(this[0],t):void 0===n?this:this.each(function(){var e=ce.queue(this,t,n);ce._queueHooks(this,t),"fx"===t&&"inprogress"!==e[0]&&ce.dequeue(this,t)})},dequeue:function(e){return this.each(function(){ce.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,i=ce.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};"string"!=typeof e&&(t=e,e=void 0),e=e||"fx";while(a--)(n=_.get(o[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var G=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,Y=new RegExp("^(?:([+-])=|)("+G+")([a-z%]*)$","i"),Q=["Top","Right","Bottom","Left"],J=C.documentElement,K=function(e){return ce.contains(e.ownerDocument,e)},Z={composed:!0};J.getRootNode&&(K=function(e){return ce.contains(e.ownerDocument,e)||e.getRootNode(Z)===e.ownerDocument});var ee=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&K(e)&&"none"===ce.css(e,"display")};function te(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return ce.css(e,t,"")},u=s(),l=n&&n[3]||(ce.cssNumber[t]?"":"px"),c=e.nodeType&&(ce.cssNumber[t]||"px"!==l&&+u)&&Y.exec(ce.css(e,t));if(c&&c[3]!==l){u/=2,l=l||c[3],c=+u||1;while(a--)ce.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;c*=2,ce.style(e,t,c+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i}var ne={};function re(e,t){for(var n,r,i,o,a,s,u,l=[],c=0,f=e.length;c<f;c++)(r=e[c]).style&&(n=r.style.display,t?("none"===n&&(l[c]=_.get(r,"display")||null,l[c]||(r.style.display="")),""===r.style.display&&ee(r)&&(l[c]=(u=a=o=void 0,a=(i=r).ownerDocument,s=i.nodeName,(u=ne[s])||(o=a.body.appendChild(a.createElement(s)),u=ce.css(o,"display"),o.parentNode.removeChild(o),"none"===u&&(u="block"),ne[s]=u)))):"none"!==n&&(l[c]="none",_.set(r,"display",n)));for(c=0;c<f;c++)null!=l[c]&&(e[c].style.display=l[c]);return e}ce.fn.extend({show:function(){return re(this,!0)},hide:function(){return re(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){ee(this)?ce(this).show():ce(this).hide()})}});var xe,be,we=/^(?:checkbox|radio)$/i,Te=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,Ce=/^$|^module$|\/(?:java|ecma)script/i;xe=C.createDocumentFragment().appendChild(C.createElement("div")),(be=C.createElement("input")).setAttribute("type","radio"),be.setAttribute("checked","checked"),be.setAttribute("name","t"),xe.appendChild(be),le.checkClone=xe.cloneNode(!0).cloneNode(!0).lastChild.checked,xe.innerHTML="<textarea>x</textarea>",le.noCloneChecked=!!xe.cloneNode(!0).lastChild.defaultValue,xe.innerHTML="<option></option>",le.option=!!xe.lastChild;var ke={thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};function Se(e,t){var n;return n="undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||"*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&fe(e,t)?ce.merge([e],n):n}function Ee(e,t){for(var n=0,r=e.length;n<r;n++)_.set(e[n],"globalEval",!t||_.get(t[n],"globalEval"))}ke.tbody=ke.tfoot=ke.colgroup=ke.caption=ke.thead,ke.th=ke.td,le.option||(ke.optgroup=ke.option=[1,"<select multiple='multiple'>","</select>"]);var je=/<|&#?\w+;/;function Ae(e,t,n,r,i){for(var o,a,s,u,l,c,f=t.createDocumentFragment(),p=[],d=0,h=e.length;d<h;d++)if((o=e[d])||0===o)if("object"===x(o))ce.merge(p,o.nodeType?[o]:o);else if(je.test(o)){a=a||f.appendChild(t.createElement("div")),s=(Te.exec(o)||["",""])[1].toLowerCase(),u=ke[s]||ke._default,a.innerHTML=u[1]+ce.htmlPrefilter(o)+u[2],c=u[0];while(c--)a=a.lastChild;ce.merge(p,a.childNodes),(a=f.firstChild).textContent=""}else p.push(t.createTextNode(o));f.textContent="",d=0;while(o=p[d++])if(r&&-1<ce.inArray(o,r))i&&i.push(o);else if(l=K(o),a=Se(f.appendChild(o),"script"),l&&Ee(a),n){c=0;while(o=a[c++])Ce.test(o.type||"")&&n.push(o)}return f}var De=/^([^.]*)(?:\.(.+)|)/;function Ne(){return!0}function qe(){return!1}function Le(e,t,n,r,i,o){var a,s;if("object"==typeof t){for(s in"string"!=typeof n&&(r=r||n,n=void 0),t)Le(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&("string"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=qe;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return ce().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=ce.guid++)),e.each(function(){ce.event.add(this,t,i,r,n)})}function He(e,r,t){t?(_.set(e,r,!1),ce.event.add(e,r,{namespace:!1,handler:function(e){var t,n=_.get(this,r);if(1&e.isTrigger&&this[r]){if(n)(ce.event.special[r]||{}).delegateType&&e.stopPropagation();else if(n=ae.call(arguments),_.set(this,r,n),this[r](),t=_.get(this,r),_.set(this,r,!1),n!==t)return e.stopImmediatePropagation(),e.preventDefault(),t}else n&&(_.set(this,r,ce.event.trigger(n[0],n.slice(1),this)),e.stopPropagation(),e.isImmediatePropagationStopped=Ne)}})):void 0===_.get(e,r)&&ce.event.add(e,r,Ne)}ce.event={global:{},add:function(t,e,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=_.get(t);if($(t)){n.handler&&(n=(o=n).handler,i=o.selector),i&&ce.find.matchesSelector(J,i),n.guid||(n.guid=ce.guid++),(u=v.events)||(u=v.events=Object.create(null)),(a=v.handle)||(a=v.handle=function(e){return"undefined"!=typeof ce&&ce.event.triggered!==e.type?ce.event.dispatch.apply(t,arguments):void 0}),l=(e=(e||"").match(D)||[""]).length;while(l--)d=g=(s=De.exec(e[l])||[])[1],h=(s[2]||"").split(".").sort(),d&&(f=ce.event.special[d]||{},d=(i?f.delegateType:f.bindType)||d,f=ce.event.special[d]||{},c=ce.extend({type:d,origType:g,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&ce.expr.match.needsContext.test(i),namespace:h.join(".")},o),(p=u[d])||((p=u[d]=[]).delegateCount=0,f.setup&&!1!==f.setup.call(t,r,h,a)||t.addEventListener&&t.addEventListener(d,a)),f.add&&(f.add.call(t,c),c.handler.guid||(c.handler.guid=n.guid)),i?p.splice(p.delegateCount++,0,c):p.push(c),ce.event.global[d]=!0)}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=_.hasData(e)&&_.get(e);if(v&&(u=v.events)){l=(t=(t||"").match(D)||[""]).length;while(l--)if(d=g=(s=De.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),d){f=ce.event.special[d]||{},p=u[d=(r?f.delegateType:f.bindType)||d]||[],s=s[2]&&new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=p.length;while(o--)c=p[o],!i&&g!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(p.splice(o,1),c.selector&&p.delegateCount--,f.remove&&f.remove.call(e,c));a&&!p.length&&(f.teardown&&!1!==f.teardown.call(e,h,v.handle)||ce.removeEvent(e,d,v.handle),delete u[d])}else for(d in u)ce.event.remove(e,d+t[l],n,r,!0);ce.isEmptyObject(u)&&_.remove(e,"handle events")}},dispatch:function(e){var t,n,r,i,o,a,s=new Array(arguments.length),u=ce.event.fix(e),l=(_.get(this,"events")||Object.create(null))[u.type]||[],c=ce.event.special[u.type]||{};for(s[0]=u,t=1;t<arguments.length;t++)s[t]=arguments[t];if(u.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,u)){a=ce.event.handlers.call(this,u,l),t=0;while((i=a[t++])&&!u.isPropagationStopped()){u.currentTarget=i.elem,n=0;while((o=i.handlers[n++])&&!u.isImmediatePropagationStopped())u.rnamespace&&!1!==o.namespace&&!u.rnamespace.test(o.namespace)||(u.handleObj=o,u.data=o.data,void 0!==(r=((ce.event.special[o.origType]||{}).handle||o.handler).apply(i.elem,s))&&!1===(u.result=r)&&(u.preventDefault(),u.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,u),u.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&l.nodeType&&!("click"===e.type&&1<=e.button))for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&("click"!==e.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++)void 0===a[i=(r=t[n]).selector+" "]&&(a[i]=r.needsContext?-1<ce(i,this).index(l):ce.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(t,e){Object.defineProperty(ce.Event.prototype,t,{enumerable:!0,configurable:!0,get:v(e)?function(){if(this.originalEvent)return e(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[t]},set:function(e){Object.defineProperty(this,t,{enumerable:!0,configurable:!0,writable:!0,value:e})}})},fix:function(e){return e[ce.expando]?e:new ce.Event(e)},special:{load:{noBubble:!0},click:{setup:function(e){var t=this||e;return we.test(t.type)&&t.click&&fe(t,"input")&&He(t,"click",!0),!1},trigger:function(e){var t=this||e;return we.test(t.type)&&t.click&&fe(t,"input")&&He(t,"click"),!0},_default:function(e){var t=e.target;return we.test(t.type)&&t.click&&fe(t,"input")&&_.get(t,"click")||fe(t,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},ce.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},ce.Event=function(e,t){if(!(this instanceof ce.Event))return new ce.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?Ne:qe,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&ce.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[ce.expando]=!0},ce.Event.prototype={constructor:ce.Event,isDefaultPrevented:qe,isPropagationStopped:qe,isImmediatePropagationStopped:qe,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=Ne,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=Ne,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=Ne,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},ce.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:!0},ce.event.addProp),ce.each({focus:"focusin",blur:"focusout"},function(r,i){function o(e){if(C.documentMode){var t=_.get(this,"handle"),n=ce.event.fix(e);n.type="focusin"===e.type?"focus":"blur",n.isSimulated=!0,t(e),n.target===n.currentTarget&&t(n)}else ce.event.simulate(i,e.target,ce.event.fix(e))}ce.event.special[r]={setup:function(){var e;if(He(this,r,!0),!C.documentMode)return!1;(e=_.get(this,i))||this.addEventListener(i,o),_.set(this,i,(e||0)+1)},trigger:function(){return He(this,r),!0},teardown:function(){var e;if(!C.documentMode)return!1;(e=_.get(this,i)-1)?_.set(this,i,e):(this.removeEventListener(i,o),_.remove(this,i))},_default:function(e){return _.get(e.target,r)},delegateType:i},ce.event.special[i]={setup:function(){var e=this.ownerDocument||this.document||this,t=C.documentMode?this:e,n=_.get(t,i);n||(C.documentMode?this.addEventListener(i,o):e.addEventListener(r,o,!0)),_.set(t,i,(n||0)+1)},teardown:function(){var e=this.ownerDocument||this.document||this,t=C.documentMode?this:e,n=_.get(t,i)-1;n?_.set(t,i,n):(C.documentMode?this.removeEventListener(i,o):e.removeEventListener(r,o,!0),_.remove(t,i))}}}),ce.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,i){ce.event.special[e]={delegateType:i,bindType:i,handle:function(e){var t,n=e.relatedTarget,r=e.handleObj;return n&&(n===this||ce.contains(this,n))||(e.type=r.origType,t=r.handler.apply(this,arguments),e.type=i),t}}}),ce.fn.extend({on:function(e,t,n,r){return Le(this,e,t,n,r)},one:function(e,t,n,r){return Le(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,ce(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=qe),this.each(function(){ce.event.remove(this,e,n,t)})}});var Oe=/<script|<style|<link/i,Pe=/checked\s*(?:[^=]|=\s*.checked.)/i,Me=/^\s*<!\[CDATA\[|\]\]>\s*$/g;function Re(e,t){return fe(e,"table")&&fe(11!==t.nodeType?t:t.firstChild,"tr")&&ce(e).children("tbody")[0]||e}function Ie(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function We(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Fe(e,t){var n,r,i,o,a,s;if(1===t.nodeType){if(_.hasData(e)&&(s=_.get(e).events))for(i in _.remove(t,"handle events"),s)for(n=0,r=s[i].length;n<r;n++)ce.event.add(t,i,s[i][n]);z.hasData(e)&&(o=z.access(e),a=ce.extend({},o),z.set(t,a))}}function $e(n,r,i,o){r=g(r);var e,t,a,s,u,l,c=0,f=n.length,p=f-1,d=r[0],h=v(d);if(h||1<f&&"string"==typeof d&&!le.checkClone&&Pe.test(d))return n.each(function(e){var t=n.eq(e);h&&(r[0]=d.call(this,e,t.html())),$e(t,r,i,o)});if(f&&(t=(e=Ae(r,n[0].ownerDocument,!1,n,o)).firstChild,1===e.childNodes.length&&(e=t),t||o)){for(s=(a=ce.map(Se(e,"script"),Ie)).length;c<f;c++)u=e,c!==p&&(u=ce.clone(u,!0,!0),s&&ce.merge(a,Se(u,"script"))),i.call(n[c],u,c);if(s)for(l=a[a.length-1].ownerDocument,ce.map(a,We),c=0;c<s;c++)u=a[c],Ce.test(u.type||"")&&!_.access(u,"globalEval")&&ce.contains(l,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?ce._evalUrl&&!u.noModule&&ce._evalUrl(u.src,{nonce:u.nonce||u.getAttribute("nonce")},l):m(u.textContent.replace(Me,""),u,l))}return n}function Be(e,t,n){for(var r,i=t?ce.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||ce.cleanData(Se(r)),r.parentNode&&(n&&K(r)&&Ee(Se(r,"script")),r.parentNode.removeChild(r));return e}ce.extend({htmlPrefilter:function(e){return e},clone:function(e,t,n){var r,i,o,a,s,u,l,c=e.cloneNode(!0),f=K(e);if(!(le.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||ce.isXMLDoc(e)))for(a=Se(c),r=0,i=(o=Se(e)).length;r<i;r++)s=o[r],u=a[r],void 0,"input"===(l=u.nodeName.toLowerCase())&&we.test(s.type)?u.checked=s.checked:"input"!==l&&"textarea"!==l||(u.defaultValue=s.defaultValue);if(t)if(n)for(o=o||Se(e),a=a||Se(c),r=0,i=o.length;r<i;r++)Fe(o[r],a[r]);else Fe(e,c);return 0<(a=Se(c,"script")).length&&Ee(a,!f&&Se(e,"script")),c},cleanData:function(e){for(var t,n,r,i=ce.event.special,o=0;void 0!==(n=e[o]);o++)if($(n)){if(t=n[_.expando]){if(t.events)for(r in t.events)i[r]?ce.event.remove(n,r):ce.removeEvent(n,r,t.handle);n[_.expando]=void 0}n[z.expando]&&(n[z.expando]=void 0)}}}),ce.fn.extend({detach:function(e){return Be(this,e,!0)},remove:function(e){return Be(this,e)},text:function(e){return M(this,function(e){return void 0===e?ce.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return $e(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||Re(this,e).appendChild(e)})},prepend:function(){return $e(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=Re(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return $e(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return $e(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(ce.cleanData(Se(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return ce.clone(this,e,t)})},html:function(e){return M(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!Oe.test(e)&&!ke[(Te.exec(e)||["",""])[1].toLowerCase()]){e=ce.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(ce.cleanData(Se(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var n=[];return $e(this,arguments,function(e){var t=this.parentNode;ce.inArray(this,n)<0&&(ce.cleanData(Se(this)),t&&t.replaceChild(e,this))},n)}}),ce.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,a){ce.fn[e]=function(e){for(var t,n=[],r=ce(e),i=r.length-1,o=0;o<=i;o++)t=o===i?this:this.clone(!0),ce(r[o])[a](t),s.apply(n,t.get());return this.pushStack(n)}});var _e=new RegExp("^("+G+")(?!px)[a-z%]+$","i"),ze=/^--/,Xe=function(e){var t=e.ownerDocument.defaultView;return t&&t.opener||(t=ie),t.getComputedStyle(e)},Ue=function(e,t,n){var r,i,o={};for(i in t)o[i]=e.style[i],e.style[i]=t[i];for(i in r=n.call(e),t)e.style[i]=o[i];return r},Ve=new RegExp(Q.join("|"),"i");function Ge(e,t,n){var r,i,o,a,s=ze.test(t),u=e.style;return(n=n||Xe(e))&&(a=n.getPropertyValue(t)||n[t],s&&a&&(a=a.replace(ve,"$1")||void 0),""!==a||K(e)||(a=ce.style(e,t)),!le.pixelBoxStyles()&&_e.test(a)&&Ve.test(t)&&(r=u.width,i=u.minWidth,o=u.maxWidth,u.minWidth=u.maxWidth=u.width=a,a=n.width,u.width=r,u.minWidth=i,u.maxWidth=o)),void 0!==a?a+"":a}function Ye(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}!function(){function e(){if(l){u.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",l.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",J.appendChild(u).appendChild(l);var e=ie.getComputedStyle(l);n="1%"!==e.top,s=12===t(e.marginLeft),l.style.right="60%",o=36===t(e.right),r=36===t(e.width),l.style.position="absolute",i=12===t(l.offsetWidth/3),J.removeChild(u),l=null}}function t(e){return Math.round(parseFloat(e))}var n,r,i,o,a,s,u=C.createElement("div"),l=C.createElement("div");l.style&&(l.style.backgroundClip="content-box",l.cloneNode(!0).style.backgroundClip="",le.clearCloneStyle="content-box"===l.style.backgroundClip,ce.extend(le,{boxSizingReliable:function(){return e(),r},pixelBoxStyles:function(){return e(),o},pixelPosition:function(){return e(),n},reliableMarginLeft:function(){return e(),s},scrollboxSize:function(){return e(),i},reliableTrDimensions:function(){var e,t,n,r;return null==a&&(e=C.createElement("table"),t=C.createElement("tr"),n=C.createElement("div"),e.style.cssText="position:absolute;left:-11111px;border-collapse:separate",t.style.cssText="box-sizing:content-box;border:1px solid",t.style.height="1px",n.style.height="9px",n.style.display="block",J.appendChild(e).appendChild(t).appendChild(n),r=ie.getComputedStyle(t),a=parseInt(r.height,10)+parseInt(r.borderTopWidth,10)+parseInt(r.borderBottomWidth,10)===t.offsetHeight,J.removeChild(e)),a}}))}();var Qe=["Webkit","Moz","ms"],Je=C.createElement("div").style,Ke={};function Ze(e){var t=ce.cssProps[e]||Ke[e];return t||(e in Je?e:Ke[e]=function(e){var t=e[0].toUpperCase()+e.slice(1),n=Qe.length;while(n--)if((e=Qe[n]+t)in Je)return e}(e)||e)}var et=/^(none|table(?!-c[ea]).+)/,tt={position:"absolute",visibility:"hidden",display:"block"},nt={letterSpacing:"0",fontWeight:"400"};function rt(e,t,n){var r=Y.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function it(e,t,n,r,i,o){var a="width"===t?1:0,s=0,u=0,l=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(l+=ce.css(e,n+Q[a],!0,i)),r?("content"===n&&(u-=ce.css(e,"padding"+Q[a],!0,i)),"margin"!==n&&(u-=ce.css(e,"border"+Q[a]+"Width",!0,i))):(u+=ce.css(e,"padding"+Q[a],!0,i),"padding"!==n?u+=ce.css(e,"border"+Q[a]+"Width",!0,i):s+=ce.css(e,"border"+Q[a]+"Width",!0,i));return!r&&0<=o&&(u+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))||0),u+l}function ot(e,t,n){var r=Xe(e),i=(!le.boxSizingReliable()||n)&&"border-box"===ce.css(e,"boxSizing",!1,r),o=i,a=Ge(e,t,r),s="offset"+t[0].toUpperCase()+t.slice(1);if(_e.test(a)){if(!n)return a;a="auto"}return(!le.boxSizingReliable()&&i||!le.reliableTrDimensions()&&fe(e,"tr")||"auto"===a||!parseFloat(a)&&"inline"===ce.css(e,"display",!1,r))&&e.getClientRects().length&&(i="border-box"===ce.css(e,"boxSizing",!1,r),(o=s in e)&&(a=e[s])),(a=parseFloat(a)||0)+it(e,t,n||(i?"border":"content"),o,r,a)+"px"}function at(e,t,n,r,i){return new at.prototype.init(e,t,n,r,i)}ce.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Ge(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,aspectRatio:!0,borderImageSlice:!0,columnCount:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,scale:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeMiterlimit:!0,strokeOpacity:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=F(t),u=ze.test(t),l=e.style;if(u||(t=Ze(s)),a=ce.cssHooks[t]||ce.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];"string"===(o=typeof n)&&(i=Y.exec(n))&&i[1]&&(n=te(e,t,i),o="number"),null!=n&&n==n&&("number"!==o||u||(n+=i&&i[3]||(ce.cssNumber[s]?"":"px")),le.clearCloneStyle||""!==n||0!==t.indexOf("background")||(l[t]="inherit"),a&&"set"in a&&void 0===(n=a.set(e,n,r))||(u?l.setProperty(t,n):l[t]=n))}},css:function(e,t,n,r){var i,o,a,s=F(t);return ze.test(t)||(t=Ze(s)),(a=ce.cssHooks[t]||ce.cssHooks[s])&&"get"in a&&(i=a.get(e,!0,n)),void 0===i&&(i=Ge(e,t,r)),"normal"===i&&t in nt&&(i=nt[t]),""===n||n?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i}}),ce.each(["height","width"],function(e,u){ce.cssHooks[u]={get:function(e,t,n){if(t)return!et.test(ce.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?ot(e,u,n):Ue(e,tt,function(){return ot(e,u,n)})},set:function(e,t,n){var r,i=Xe(e),o=!le.scrollboxSize()&&"absolute"===i.position,a=(o||n)&&"border-box"===ce.css(e,"boxSizing",!1,i),s=n?it(e,u,n,a,i):0;return a&&o&&(s-=Math.ceil(e["offset"+u[0].toUpperCase()+u.slice(1)]-parseFloat(i[u])-it(e,u,"border",!1,i)-.5)),s&&(r=Y.exec(t))&&"px"!==(r[3]||"px")&&(e.style[u]=t,t=ce.css(e,u)),rt(0,t,s)}}}),ce.cssHooks.marginLeft=Ye(le.reliableMarginLeft,function(e,t){if(t)return(parseFloat(Ge(e,"marginLeft"))||e.getBoundingClientRect().left-Ue(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+"px"}),ce.each({margin:"",padding:"",border:"Width"},function(i,o){ce.cssHooks[i+o]={expand:function(e){for(var t=0,n={},r="string"==typeof e?e.split(" "):[e];t<4;t++)n[i+Q[t]+o]=r[t]||r[t-2]||r[0];return n}},"margin"!==i&&(ce.cssHooks[i+o].set=rt)}),ce.fn.extend({css:function(e,t){return M(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=Xe(e),i=t.length;a<i;a++)o[t[a]]=ce.css(e,t[a],!1,r);return o}return void 0!==n?ce.style(e,t,n):ce.css(e,t)},e,t,1<arguments.length)}}),((ce.Tween=at).prototype={constructor:at,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||ce.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(ce.cssNumber[n]?"":"px")},cur:function(){var e=at.propHooks[this.prop];return e&&e.get?e.get(this):at.propHooks._default.get(this)},run:function(e){var t,n=at.propHooks[this.prop];return this.options.duration?this.pos=t=ce.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):at.propHooks._default.set(this),this}}).init.prototype=at.prototype,(at.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=ce.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){ce.fx.step[e.prop]?ce.fx.step[e.prop](e):1!==e.elem.nodeType||!ce.cssHooks[e.prop]&&null==e.elem.style[Ze(e.prop)]?e.elem[e.prop]=e.now:ce.style(e.elem,e.prop,e.now+e.unit)}}}).scrollTop=at.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},ce.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},ce.fx=at.prototype.init,ce.fx.step={};var st,ut,lt,ct,ft=/^(?:toggle|show|hide)$/,pt=/queueHooks$/;function dt(){ut&&(!1===C.hidden&&ie.requestAnimationFrame?ie.requestAnimationFrame(dt):ie.setTimeout(dt,ce.fx.interval),ce.fx.tick())}function ht(){return ie.setTimeout(function(){st=void 0}),st=Date.now()}function gt(e,t){var n,r=0,i={height:e};for(t=t?1:0;r<4;r+=2-t)i["margin"+(n=Q[r])]=i["padding"+n]=e;return t&&(i.opacity=i.width=e),i}function vt(e,t,n){for(var r,i=(yt.tweeners[t]||[]).concat(yt.tweeners["*"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function yt(o,e,t){var n,a,r=0,i=yt.prefilters.length,s=ce.Deferred().always(function(){delete u.elem}),u=function(){if(a)return!1;for(var e=st||ht(),t=Math.max(0,l.startTime+l.duration-e),n=1-(t/l.duration||0),r=0,i=l.tweens.length;r<i;r++)l.tweens[r].run(n);return s.notifyWith(o,[l,n,t]),n<1&&i?t:(i||s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l]),!1)},l=s.promise({elem:o,props:ce.extend({},e),opts:ce.extend(!0,{specialEasing:{},easing:ce.easing._default},t),originalProperties:e,originalOptions:t,startTime:st||ht(),duration:t.duration,tweens:[],createTween:function(e,t){var n=ce.Tween(o,l.opts,e,t,l.opts.specialEasing[e]||l.opts.easing);return l.tweens.push(n),n},stop:function(e){var t=0,n=e?l.tweens.length:0;if(a)return this;for(a=!0;t<n;t++)l.tweens[t].run(1);return e?(s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l,e])):s.rejectWith(o,[l,e]),this}}),c=l.props;for(!function(e,t){var n,r,i,o,a;for(n in e)if(i=t[r=F(n)],o=e[n],Array.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=ce.cssHooks[r])&&"expand"in a)for(n in o=a.expand(o),delete e[r],o)n in e||(e[n]=o[n],t[n]=i);else t[r]=i}(c,l.opts.specialEasing);r<i;r++)if(n=yt.prefilters[r].call(l,o,c,l.opts))return v(n.stop)&&(ce._queueHooks(l.elem,l.opts.queue).stop=n.stop.bind(n)),n;return ce.map(c,vt,l),v(l.opts.start)&&l.opts.start.call(o,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),ce.fx.timer(ce.extend(u,{elem:o,anim:l,queue:l.opts.queue})),l}ce.Animation=ce.extend(yt,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return te(n.elem,e,Y.exec(t),n),n}]},tweener:function(e,t){v(e)?(t=e,e=["*"]):e=e.match(D);for(var n,r=0,i=e.length;r<i;r++)n=e[r],yt.tweeners[n]=yt.tweeners[n]||[],yt.tweeners[n].unshift(t)},prefilters:[function(e,t,n){var r,i,o,a,s,u,l,c,f="width"in t||"height"in t,p=this,d={},h=e.style,g=e.nodeType&&ee(e),v=_.get(e,"fxshow");for(r in n.queue||(null==(a=ce._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,p.always(function(){p.always(function(){a.unqueued--,ce.queue(e,"fx").length||a.empty.fire()})})),t)if(i=t[r],ft.test(i)){if(delete t[r],o=o||"toggle"===i,i===(g?"hide":"show")){if("show"!==i||!v||void 0===v[r])continue;g=!0}d[r]=v&&v[r]||ce.style(e,r)}if((u=!ce.isEmptyObject(t))||!ce.isEmptyObject(d))for(r in f&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(l=v&&v.display)&&(l=_.get(e,"display")),"none"===(c=ce.css(e,"display"))&&(l?c=l:(re([e],!0),l=e.style.display||l,c=ce.css(e,"display"),re([e]))),("inline"===c||"inline-block"===c&&null!=l)&&"none"===ce.css(e,"float")&&(u||(p.done(function(){h.display=l}),null==l&&(c=h.display,l="none"===c?"":c)),h.display="inline-block")),n.overflow&&(h.overflow="hidden",p.always(function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]})),u=!1,d)u||(v?"hidden"in v&&(g=v.hidden):v=_.access(e,"fxshow",{display:l}),o&&(v.hidden=!g),g&&re([e],!0),p.done(function(){for(r in g||re([e]),_.remove(e,"fxshow"),d)ce.style(e,r,d[r])})),u=vt(g?v[r]:0,r,p),r in v||(v[r]=u.start,g&&(u.end=u.start,u.start=0))}],prefilter:function(e,t){t?yt.prefilters.unshift(e):yt.prefilters.push(e)}}),ce.speed=function(e,t,n){var r=e&&"object"==typeof e?ce.extend({},e):{complete:n||!n&&t||v(e)&&e,duration:e,easing:n&&t||t&&!v(t)&&t};return ce.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in ce.fx.speeds?r.duration=ce.fx.speeds[r.duration]:r.duration=ce.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){v(r.old)&&r.old.call(this),r.queue&&ce.dequeue(this,r.queue)},r},ce.fn.extend({fadeTo:function(e,t,n,r){return this.filter(ee).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(t,e,n,r){var i=ce.isEmptyObject(t),o=ce.speed(e,n,r),a=function(){var e=yt(this,ce.extend({},t),o);(i||_.get(this,"finish"))&&e.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(i,e,o){var a=function(e){var t=e.stop;delete e.stop,t(o)};return"string"!=typeof i&&(o=e,e=i,i=void 0),e&&this.queue(i||"fx",[]),this.each(function(){var e=!0,t=null!=i&&i+"queueHooks",n=ce.timers,r=_.get(this);if(t)r[t]&&r[t].stop&&a(r[t]);else for(t in r)r[t]&&r[t].stop&&pt.test(t)&&a(r[t]);for(t=n.length;t--;)n[t].elem!==this||null!=i&&n[t].queue!==i||(n[t].anim.stop(o),e=!1,n.splice(t,1));!e&&o||ce.dequeue(this,i)})},finish:function(a){return!1!==a&&(a=a||"fx"),this.each(function(){var e,t=_.get(this),n=t[a+"queue"],r=t[a+"queueHooks"],i=ce.timers,o=n?n.length:0;for(t.finish=!0,ce.queue(this,a,[]),r&&r.stop&&r.stop.call(this,!0),e=i.length;e--;)i[e].elem===this&&i[e].queue===a&&(i[e].anim.stop(!0),i.splice(e,1));for(e=0;e<o;e++)n[e]&&n[e].finish&&n[e].finish.call(this);delete t.finish})}}),ce.each(["toggle","show","hide"],function(e,r){var i=ce.fn[r];ce.fn[r]=function(e,t,n){return null==e||"boolean"==typeof e?i.apply(this,arguments):this.animate(gt(r,!0),e,t,n)}}),ce.each({slideDown:gt("show"),slideUp:gt("hide"),slideToggle:gt("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,r){ce.fn[e]=function(e,t,n){return this.animate(r,e,t,n)}}),ce.timers=[],ce.fx.tick=function(){var e,t=0,n=ce.timers;for(st=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||ce.fx.stop(),st=void 0},ce.fx.timer=function(e){ce.timers.push(e),ce.fx.start()},ce.fx.interval=13,ce.fx.start=function(){ut||(ut=!0,dt())},ce.fx.stop=function(){ut=null},ce.fx.speeds={slow:600,fast:200,_default:400},ce.fn.delay=function(r,e){return r=ce.fx&&ce.fx.speeds[r]||r,e=e||"fx",this.queue(e,function(e,t){var n=ie.setTimeout(e,r);t.stop=function(){ie.clearTimeout(n)}})},lt=C.createElement("input"),ct=C.createElement("select").appendChild(C.createElement("option")),lt.type="checkbox",le.checkOn=""!==lt.value,le.optSelected=ct.selected,(lt=C.createElement("input")).value="t",lt.type="radio",le.radioValue="t"===lt.value;var mt,xt=ce.expr.attrHandle;ce.fn.extend({attr:function(e,t){return M(this,ce.attr,e,t,1<arguments.length)},removeAttr:function(e){return this.each(function(){ce.removeAttr(this,e)})}}),ce.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return"undefined"==typeof e.getAttribute?ce.prop(e,t,n):(1===o&&ce.isXMLDoc(e)||(i=ce.attrHooks[t.toLowerCase()]||(ce.expr.match.bool.test(t)?mt:void 0)),void 0!==n?null===n?void ce.removeAttr(e,t):i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:(e.setAttribute(t,n+""),n):i&&"get"in i&&null!==(r=i.get(e,t))?r:null==(r=ce.find.attr(e,t))?void 0:r)},attrHooks:{type:{set:function(e,t){if(!le.radioValue&&"radio"===t&&fe(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,r=0,i=t&&t.match(D);if(i&&1===e.nodeType)while(n=i[r++])e.removeAttribute(n)}}),mt={set:function(e,t,n){return!1===t?ce.removeAttr(e,n):e.setAttribute(n,n),n}},ce.each(ce.expr.match.bool.source.match(/\w+/g),function(e,t){var a=xt[t]||ce.find.attr;xt[t]=function(e,t,n){var r,i,o=t.toLowerCase();return n||(i=xt[o],xt[o]=r,r=null!=a(e,t,n)?o:null,xt[o]=i),r}});var bt=/^(?:input|select|textarea|button)$/i,wt=/^(?:a|area)$/i;function Tt(e){return(e.match(D)||[]).join(" ")}function Ct(e){return e.getAttribute&&e.getAttribute("class")||""}function kt(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(D)||[]}ce.fn.extend({prop:function(e,t){return M(this,ce.prop,e,t,1<arguments.length)},removeProp:function(e){return this.each(function(){delete this[ce.propFix[e]||e]})}}),ce.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&ce.isXMLDoc(e)||(t=ce.propFix[t]||t,i=ce.propHooks[t]),void 0!==n?i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&"get"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=ce.find.attr(e,"tabindex");return t?parseInt(t,10):bt.test(e.nodeName)||wt.test(e.nodeName)&&e.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),le.optSelected||(ce.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),ce.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){ce.propFix[this.toLowerCase()]=this}),ce.fn.extend({addClass:function(t){var e,n,r,i,o,a;return v(t)?this.each(function(e){ce(this).addClass(t.call(this,e,Ct(this)))}):(e=kt(t)).length?this.each(function(){if(r=Ct(this),n=1===this.nodeType&&" "+Tt(r)+" "){for(o=0;o<e.length;o++)i=e[o],n.indexOf(" "+i+" ")<0&&(n+=i+" ");a=Tt(n),r!==a&&this.setAttribute("class",a)}}):this},removeClass:function(t){var e,n,r,i,o,a;return v(t)?this.each(function(e){ce(this).removeClass(t.call(this,e,Ct(this)))}):arguments.length?(e=kt(t)).length?this.each(function(){if(r=Ct(this),n=1===this.nodeType&&" "+Tt(r)+" "){for(o=0;o<e.length;o++){i=e[o];while(-1<n.indexOf(" "+i+" "))n=n.replace(" "+i+" "," ")}a=Tt(n),r!==a&&this.setAttribute("class",a)}}):this:this.attr("class","")},toggleClass:function(t,n){var e,r,i,o,a=typeof t,s="string"===a||Array.isArray(t);return v(t)?this.each(function(e){ce(this).toggleClass(t.call(this,e,Ct(this),n),n)}):"boolean"==typeof n&&s?n?this.addClass(t):this.removeClass(t):(e=kt(t),this.each(function(){if(s)for(o=ce(this),i=0;i<e.length;i++)r=e[i],o.hasClass(r)?o.removeClass(r):o.addClass(r);else void 0!==t&&"boolean"!==a||((r=Ct(this))&&_.set(this,"__className__",r),this.setAttribute&&this.setAttribute("class",r||!1===t?"":_.get(this,"__className__")||""))}))},hasClass:function(e){var t,n,r=0;t=" "+e+" ";while(n=this[r++])if(1===n.nodeType&&-1<(" "+Tt(Ct(n))+" ").indexOf(t))return!0;return!1}});var St=/\r/g;ce.fn.extend({val:function(n){var r,e,i,t=this[0];return arguments.length?(i=v(n),this.each(function(e){var t;1===this.nodeType&&(null==(t=i?n.call(this,e,ce(this).val()):n)?t="":"number"==typeof t?t+="":Array.isArray(t)&&(t=ce.map(t,function(e){return null==e?"":e+""})),(r=ce.valHooks[this.type]||ce.valHooks[this.nodeName.toLowerCase()])&&"set"in r&&void 0!==r.set(this,t,"value")||(this.value=t))})):t?(r=ce.valHooks[t.type]||ce.valHooks[t.nodeName.toLowerCase()])&&"get"in r&&void 0!==(e=r.get(t,"value"))?e:"string"==typeof(e=t.value)?e.replace(St,""):null==e?"":e:void 0}}),ce.extend({valHooks:{option:{get:function(e){var t=ce.find.attr(e,"value");return null!=t?t:Tt(ce.text(e))}},select:{get:function(e){var t,n,r,i=e.options,o=e.selectedIndex,a="select-one"===e.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++)if(((n=i[r]).selected||r===o)&&!n.disabled&&(!n.parentNode.disabled||!fe(n.parentNode,"optgroup"))){if(t=ce(n).val(),a)return t;s.push(t)}return s},set:function(e,t){var n,r,i=e.options,o=ce.makeArray(t),a=i.length;while(a--)((r=i[a]).selected=-1<ce.inArray(ce.valHooks.option.get(r),o))&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),ce.each(["radio","checkbox"],function(){ce.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=-1<ce.inArray(ce(e).val(),t)}},le.checkOn||(ce.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})});var Et=ie.location,jt={guid:Date.now()},At=/\?/;ce.parseXML=function(e){var t,n;if(!e||"string"!=typeof e)return null;try{t=(new ie.DOMParser).parseFromString(e,"text/xml")}catch(e){}return n=t&&t.getElementsByTagName("parsererror")[0],t&&!n||ce.error("Invalid XML: "+(n?ce.map(n.childNodes,function(e){return e.textContent}).join("\n"):e)),t};var Dt=/^(?:focusinfocus|focusoutblur)$/,Nt=function(e){e.stopPropagation()};ce.extend(ce.event,{trigger:function(e,t,n,r){var i,o,a,s,u,l,c,f,p=[n||C],d=ue.call(e,"type")?e.type:e,h=ue.call(e,"namespace")?e.namespace.split("."):[];if(o=f=a=n=n||C,3!==n.nodeType&&8!==n.nodeType&&!Dt.test(d+ce.event.triggered)&&(-1<d.indexOf(".")&&(d=(h=d.split(".")).shift(),h.sort()),u=d.indexOf(":")<0&&"on"+d,(e=e[ce.expando]?e:new ce.Event(d,"object"==typeof e&&e)).isTrigger=r?2:3,e.namespace=h.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,e.result=void 0,e.target||(e.target=n),t=null==t?[e]:ce.makeArray(t,[e]),c=ce.event.special[d]||{},r||!c.trigger||!1!==c.trigger.apply(n,t))){if(!r&&!c.noBubble&&!y(n)){for(s=c.delegateType||d,Dt.test(s+d)||(o=o.parentNode);o;o=o.parentNode)p.push(o),a=o;a===(n.ownerDocument||C)&&p.push(a.defaultView||a.parentWindow||ie)}i=0;while((o=p[i++])&&!e.isPropagationStopped())f=o,e.type=1<i?s:c.bindType||d,(l=(_.get(o,"events")||Object.create(null))[e.type]&&_.get(o,"handle"))&&l.apply(o,t),(l=u&&o[u])&&l.apply&&$(o)&&(e.result=l.apply(o,t),!1===e.result&&e.preventDefault());return e.type=d,r||e.isDefaultPrevented()||c._default&&!1!==c._default.apply(p.pop(),t)||!$(n)||u&&v(n[d])&&!y(n)&&((a=n[u])&&(n[u]=null),ce.event.triggered=d,e.isPropagationStopped()&&f.addEventListener(d,Nt),n[d](),e.isPropagationStopped()&&f.removeEventListener(d,Nt),ce.event.triggered=void 0,a&&(n[u]=a)),e.result}},simulate:function(e,t,n){var r=ce.extend(new ce.Event,n,{type:e,isSimulated:!0});ce.event.trigger(r,null,t)}}),ce.fn.extend({trigger:function(e,t){return this.each(function(){ce.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return ce.event.trigger(e,t,n,!0)}});var qt=/\[\]$/,Lt=/\r?\n/g,Ht=/^(?:submit|button|image|reset|file)$/i,Ot=/^(?:input|select|textarea|keygen)/i;function Pt(n,e,r,i){var t;if(Array.isArray(e))ce.each(e,function(e,t){r||qt.test(n)?i(n,t):Pt(n+"["+("object"==typeof t&&null!=t?e:"")+"]",t,r,i)});else if(r||"object"!==x(e))i(n,e);else for(t in e)Pt(n+"["+t+"]",e[t],r,i)}ce.param=function(e,t){var n,r=[],i=function(e,t){var n=v(t)?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!ce.isPlainObject(e))ce.each(e,function(){i(this.name,this.value)});else for(n in e)Pt(n,e[n],t,i);return r.join("&")},ce.fn.extend({serialize:function(){return ce.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=ce.prop(this,"elements");return e?ce.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!ce(this).is(":disabled")&&Ot.test(this.nodeName)&&!Ht.test(e)&&(this.checked||!we.test(e))}).map(function(e,t){var n=ce(this).val();return null==n?null:Array.isArray(n)?ce.map(n,function(e){return{name:t.name,value:e.replace(Lt,"\r\n")}}):{name:t.name,value:n.replace(Lt,"\r\n")}}).get()}});var Mt=/%20/g,Rt=/#.*$/,It=/([?&])_=[^&]*/,Wt=/^(.*?):[ \t]*([^\r\n]*)$/gm,Ft=/^(?:GET|HEAD)$/,$t=/^\/\//,Bt={},_t={},zt="*/".concat("*"),Xt=C.createElement("a");function Ut(o){return function(e,t){"string"!=typeof e&&(t=e,e="*");var n,r=0,i=e.toLowerCase().match(D)||[];if(v(t))while(n=i[r++])"+"===n[0]?(n=n.slice(1)||"*",(o[n]=o[n]||[]).unshift(t)):(o[n]=o[n]||[]).push(t)}}function Vt(t,i,o,a){var s={},u=t===_t;function l(e){var r;return s[e]=!0,ce.each(t[e]||[],function(e,t){var n=t(i,o,a);return"string"!=typeof n||u||s[n]?u?!(r=n):void 0:(i.dataTypes.unshift(n),l(n),!1)}),r}return l(i.dataTypes[0])||!s["*"]&&l("*")}function Gt(e,t){var n,r,i=ce.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((i[n]?e:r||(r={}))[n]=t[n]);return r&&ce.extend(!0,e,r),e}Xt.href=Et.href,ce.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Et.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Et.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":zt,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":ce.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?Gt(Gt(e,ce.ajaxSettings),t):Gt(ce.ajaxSettings,e)},ajaxPrefilter:Ut(Bt),ajaxTransport:Ut(_t),ajax:function(e,t){"object"==typeof e&&(t=e,e=void 0),t=t||{};var c,f,p,n,d,r,h,g,i,o,v=ce.ajaxSetup({},t),y=v.context||v,m=v.context&&(y.nodeType||y.jquery)?ce(y):ce.event,x=ce.Deferred(),b=ce.Callbacks("once memory"),w=v.statusCode||{},a={},s={},u="canceled",T={readyState:0,getResponseHeader:function(e){var t;if(h){if(!n){n={};while(t=Wt.exec(p))n[t[1].toLowerCase()+" "]=(n[t[1].toLowerCase()+" "]||[]).concat(t[2])}t=n[e.toLowerCase()+" "]}return null==t?null:t.join(", ")},getAllResponseHeaders:function(){return h?p:null},setRequestHeader:function(e,t){return null==h&&(e=s[e.toLowerCase()]=s[e.toLowerCase()]||e,a[e]=t),this},overrideMimeType:function(e){return null==h&&(v.mimeType=e),this},statusCode:function(e){var t;if(e)if(h)T.always(e[T.status]);else for(t in e)w[t]=[w[t],e[t]];return this},abort:function(e){var t=e||u;return c&&c.abort(t),l(0,t),this}};if(x.promise(T),v.url=((e||v.url||Et.href)+"").replace($t,Et.protocol+"//"),v.type=t.method||t.type||v.method||v.type,v.dataTypes=(v.dataType||"*").toLowerCase().match(D)||[""],null==v.crossDomain){r=C.createElement("a");try{r.href=v.url,r.href=r.href,v.crossDomain=Xt.protocol+"//"+Xt.host!=r.protocol+"//"+r.host}catch(e){v.crossDomain=!0}}if(v.data&&v.processData&&"string"!=typeof v.data&&(v.data=ce.param(v.data,v.traditional)),Vt(Bt,v,t,T),h)return T;for(i in(g=ce.event&&v.global)&&0==ce.active++&&ce.event.trigger("ajaxStart"),v.type=v.type.toUpperCase(),v.hasContent=!Ft.test(v.type),f=v.url.replace(Rt,""),v.hasContent?v.data&&v.processData&&0===(v.contentType||"").indexOf("application/x-www-form-urlencoded")&&(v.data=v.data.replace(Mt,"+")):(o=v.url.slice(f.length),v.data&&(v.processData||"string"==typeof v.data)&&(f+=(At.test(f)?"&":"?")+v.data,delete v.data),!1===v.cache&&(f=f.replace(It,"$1"),o=(At.test(f)?"&":"?")+"_="+jt.guid+++o),v.url=f+o),v.ifModified&&(ce.lastModified[f]&&T.setRequestHeader("If-Modified-Since",ce.lastModified[f]),ce.etag[f]&&T.setRequestHeader("If-None-Match",ce.etag[f])),(v.data&&v.hasContent&&!1!==v.contentType||t.contentType)&&T.setRequestHeader("Content-Type",v.contentType),T.setRequestHeader("Accept",v.dataTypes[0]&&v.accepts[v.dataTypes[0]]?v.accepts[v.dataTypes[0]]+("*"!==v.dataTypes[0]?", "+zt+"; q=0.01":""):v.accepts["*"]),v.headers)T.setRequestHeader(i,v.headers[i]);if(v.beforeSend&&(!1===v.beforeSend.call(y,T,v)||h))return T.abort();if(u="abort",b.add(v.complete),T.done(v.success),T.fail(v.error),c=Vt(_t,v,t,T)){if(T.readyState=1,g&&m.trigger("ajaxSend",[T,v]),h)return T;v.async&&0<v.timeout&&(d=ie.setTimeout(function(){T.abort("timeout")},v.timeout));try{h=!1,c.send(a,l)}catch(e){if(h)throw e;l(-1,e)}}else l(-1,"No Transport");function l(e,t,n,r){var i,o,a,s,u,l=t;h||(h=!0,d&&ie.clearTimeout(d),c=void 0,p=r||"",T.readyState=0<e?4:0,i=200<=e&&e<300||304===e,n&&(s=function(e,t,n){var r,i,o,a,s=e.contents,u=e.dataTypes;while("*"===u[0])u.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r)for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+" "+u[0]]){o=i;break}a||(a=i)}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}(v,T,n)),!i&&-1<ce.inArray("script",v.dataTypes)&&ce.inArray("json",v.dataTypes)<0&&(v.converters["text script"]=function(){}),s=function(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift())if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o]))for(i in l)if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e["throws"])t=a(t);else try{t=a(t)}catch(e){return{state:"parsererror",error:a?e:"No conversion from "+u+" to "+o}}}return{state:"success",data:t}}(v,s,T,i),i?(v.ifModified&&((u=T.getResponseHeader("Last-Modified"))&&(ce.lastModified[f]=u),(u=T.getResponseHeader("etag"))&&(ce.etag[f]=u)),204===e||"HEAD"===v.type?l="nocontent":304===e?l="notmodified":(l=s.state,o=s.data,i=!(a=s.error))):(a=l,!e&&l||(l="error",e<0&&(e=0))),T.status=e,T.statusText=(t||l)+"",i?x.resolveWith(y,[o,l,T]):x.rejectWith(y,[T,l,a]),T.statusCode(w),w=void 0,g&&m.trigger(i?"ajaxSuccess":"ajaxError",[T,v,i?o:a]),b.fireWith(y,[T,l]),g&&(m.trigger("ajaxComplete",[T,v]),--ce.active||ce.event.trigger("ajaxStop")))}return T},getJSON:function(e,t,n){return ce.get(e,t,n,"json")},getScript:function(e,t){return ce.get(e,void 0,t,"script")}}),ce.each(["get","post"],function(e,i){ce[i]=function(e,t,n,r){return v(t)&&(r=r||n,n=t,t=void 0),ce.ajax(ce.extend({url:e,type:i,dataType:r,data:t,success:n},ce.isPlainObject(e)&&e))}}),ce.ajaxPrefilter(function(e){var t;for(t in e.headers)"content-type"===t.toLowerCase()&&(e.contentType=e.headers[t]||"")}),ce._evalUrl=function(e,t,n){return ce.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(e){ce.globalEval(e,t,n)}})},ce.fn.extend({wrapAll:function(e){var t;return this[0]&&(v(e)&&(e=e.call(this[0])),t=ce(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstElementChild)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(n){return v(n)?this.each(function(e){ce(this).wrapInner(n.call(this,e))}):this.each(function(){var e=ce(this),t=e.contents();t.length?t.wrapAll(n):e.append(n)})},wrap:function(t){var n=v(t);return this.each(function(e){ce(this).wrapAll(n?t.call(this,e):t)})},unwrap:function(e){return this.parent(e).not("body").each(function(){ce(this).replaceWith(this.childNodes)}),this}}),ce.expr.pseudos.hidden=function(e){return!ce.expr.pseudos.visible(e)},ce.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},ce.ajaxSettings.xhr=function(){try{return new ie.XMLHttpRequest}catch(e){}};var Yt={0:200,1223:204},Qt=ce.ajaxSettings.xhr();le.cors=!!Qt&&"withCredentials"in Qt,le.ajax=Qt=!!Qt,ce.ajaxTransport(function(i){var o,a;if(le.cors||Qt&&!i.crossDomain)return{send:function(e,t){var n,r=i.xhr();if(r.open(i.type,i.url,i.async,i.username,i.password),i.xhrFields)for(n in i.xhrFields)r[n]=i.xhrFields[n];for(n in i.mimeType&&r.overrideMimeType&&r.overrideMimeType(i.mimeType),i.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest"),e)r.setRequestHeader(n,e[n]);o=function(e){return function(){o&&(o=a=r.onload=r.onerror=r.onabort=r.ontimeout=r.onreadystatechange=null,"abort"===e?r.abort():"error"===e?"number"!=typeof r.status?t(0,"error"):t(r.status,r.statusText):t(Yt[r.status]||r.status,r.statusText,"text"!==(r.responseType||"text")||"string"!=typeof r.responseText?{binary:r.response}:{text:r.responseText},r.getAllResponseHeaders()))}},r.onload=o(),a=r.onerror=r.ontimeout=o("error"),void 0!==r.onabort?r.onabort=a:r.onreadystatechange=function(){4===r.readyState&&ie.setTimeout(function(){o&&a()})},o=o("abort");try{r.send(i.hasContent&&i.data||null)}catch(e){if(o)throw e}},abort:function(){o&&o()}}}),ce.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),ce.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return ce.globalEval(e),e}}}),ce.ajaxPrefilter("script",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type="GET")}),ce.ajaxTransport("script",function(n){var r,i;if(n.crossDomain||n.scriptAttrs)return{send:function(e,t){r=ce("<script>").attr(n.scriptAttrs||{}).prop({charset:n.scriptCharset,src:n.url}).on("load error",i=function(e){r.remove(),i=null,e&&t("error"===e.type?404:200,e.type)}),C.head.appendChild(r[0])},abort:function(){i&&i()}}});var Jt,Kt=[],Zt=/(=)\?(?=&|$)|\?\?/;ce.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=Kt.pop()||ce.expando+"_"+jt.guid++;return this[e]=!0,e}}),ce.ajaxPrefilter("json jsonp",function(e,t,n){var r,i,o,a=!1!==e.jsonp&&(Zt.test(e.url)?"url":"string"==typeof e.data&&0===(e.contentType||"").indexOf("application/x-www-form-urlencoded")&&Zt.test(e.data)&&"data");if(a||"jsonp"===e.dataTypes[0])return r=e.jsonpCallback=v(e.jsonpCallback)?e.jsonpCallback():e.jsonpCallback,a?e[a]=e[a].replace(Zt,"$1"+r):!1!==e.jsonp&&(e.url+=(At.test(e.url)?"&":"?")+e.jsonp+"="+r),e.converters["script json"]=function(){return o||ce.error(r+" was not called"),o[0]},e.dataTypes[0]="json",i=ie[r],ie[r]=function(){o=arguments},n.always(function(){void 0===i?ce(ie).removeProp(r):ie[r]=i,e[r]&&(e.jsonpCallback=t.jsonpCallback,Kt.push(r)),o&&v(i)&&i(o[0]),o=i=void 0}),"script"}),le.createHTMLDocument=((Jt=C.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===Jt.childNodes.length),ce.parseHTML=function(e,t,n){return"string"!=typeof e?[]:("boolean"==typeof t&&(n=t,t=!1),t||(le.createHTMLDocument?((r=(t=C.implementation.createHTMLDocument("")).createElement("base")).href=C.location.href,t.head.appendChild(r)):t=C),o=!n&&[],(i=w.exec(e))?[t.createElement(i[1])]:(i=Ae([e],t,o),o&&o.length&&ce(o).remove(),ce.merge([],i.childNodes)));var r,i,o},ce.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(" ");return-1<s&&(r=Tt(e.slice(s)),e=e.slice(0,s)),v(t)?(n=t,t=void 0):t&&"object"==typeof t&&(i="POST"),0<a.length&&ce.ajax({url:e,type:i||"GET",dataType:"html",data:t}).done(function(e){o=arguments,a.html(r?ce("<div>").append(ce.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},ce.expr.pseudos.animated=function(t){return ce.grep(ce.timers,function(e){return t===e.elem}).length},ce.offset={setOffset:function(e,t,n){var r,i,o,a,s,u,l=ce.css(e,"position"),c=ce(e),f={};"static"===l&&(e.style.position="relative"),s=c.offset(),o=ce.css(e,"top"),u=ce.css(e,"left"),("absolute"===l||"fixed"===l)&&-1<(o+u).indexOf("auto")?(a=(r=c.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),v(t)&&(t=t.call(e,n,ce.extend({},s))),null!=t.top&&(f.top=t.top-s.top+a),null!=t.left&&(f.left=t.left-s.left+i),"using"in t?t.using.call(e,f):c.css(f)}},ce.fn.extend({offset:function(t){if(arguments.length)return void 0===t?this:this.each(function(e){ce.offset.setOffset(this,t,e)});var e,n,r=this[0];return r?r.getClientRects().length?(e=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:e.top+n.pageYOffset,left:e.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if("fixed"===ce.css(r,"position"))t=r.getBoundingClientRect();else{t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;while(e&&(e===n.body||e===n.documentElement)&&"static"===ce.css(e,"position"))e=e.parentNode;e&&e!==r&&1===e.nodeType&&((i=ce(e).offset()).top+=ce.css(e,"borderTopWidth",!0),i.left+=ce.css(e,"borderLeftWidth",!0))}return{top:t.top-i.top-ce.css(r,"marginTop",!0),left:t.left-i.left-ce.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent;while(e&&"static"===ce.css(e,"position"))e=e.offsetParent;return e||J})}}),ce.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(t,i){var o="pageYOffset"===i;ce.fn[t]=function(e){return M(this,function(e,t,n){var r;if(y(e)?r=e:9===e.nodeType&&(r=e.defaultView),void 0===n)return r?r[i]:e[t];r?r.scrollTo(o?r.pageXOffset:n,o?n:r.pageYOffset):e[t]=n},t,e,arguments.length)}}),ce.each(["top","left"],function(e,n){ce.cssHooks[n]=Ye(le.pixelPosition,function(e,t){if(t)return t=Ge(e,n),_e.test(t)?ce(e).position()[n]+"px":t})}),ce.each({Height:"height",Width:"width"},function(a,s){ce.each({padding:"inner"+a,content:s,"":"outer"+a},function(r,o){ce.fn[o]=function(e,t){var n=arguments.length&&(r||"boolean"!=typeof e),i=r||(!0===e||!0===t?"margin":"border");return M(this,function(e,t,n){var r;return y(e)?0===o.indexOf("outer")?e["inner"+a]:e.document.documentElement["client"+a]:9===e.nodeType?(r=e.documentElement,Math.max(e.body["scroll"+a],r["scroll"+a],e.body["offset"+a],r["offset"+a],r["client"+a])):void 0===n?ce.css(e,t,i):ce.style(e,t,n,i)},s,n?e:void 0,n)}})}),ce.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){ce.fn[t]=function(e){return this.on(t,e)}}),ce.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)},hover:function(e,t){return this.on("mouseenter",e).on("mouseleave",t||e)}}),ce.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,n){ce.fn[n]=function(e,t){return 0<arguments.length?this.on(n,null,e,t):this.trigger(n)}});var en=/^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;ce.proxy=function(e,t){var n,r,i;if("string"==typeof t&&(n=e[t],t=e,e=n),v(e))return r=ae.call(arguments,2),(i=function(){return e.apply(t||this,r.concat(ae.call(arguments)))}).guid=e.guid=e.guid||ce.guid++,i},ce.holdReady=function(e){e?ce.readyWait++:ce.ready(!0)},ce.isArray=Array.isArray,ce.parseJSON=JSON.parse,ce.nodeName=fe,ce.isFunction=v,ce.isWindow=y,ce.camelCase=F,ce.type=x,ce.now=Date.now,ce.isNumeric=function(e){var t=ce.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},ce.trim=function(e){return null==e?"":(e+"").replace(en,"$1")},"function"==typeof define&&define.amd&&define("jquery",[],function(){return ce});var tn=ie.jQuery,nn=ie.$;return ce.noConflict=function(e){return ie.$===ce&&(ie.$=nn),e&&ie.jQuery===ce&&(ie.jQuery=tn),ce},"undefined"==typeof e&&(ie.jQuery=ie.$=ce),ce});

!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});


// CD CODE
if($(".image-with-featured-collection .product_slider").length){ 
  $(".image-with-featured-collection .product_slider").each(function( index ){
    var el = $(this);
    el.slick({
      slidesToShow: 2.5,
      slidesToScroll: 1,
      infinite: false,
      prevArrow: el.parent().find(".arrow-prev"),
      nextArrow: el.parent().find(".arrow-next"),
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1.5
          }
        }
      ]
    });
  });
}

if($(".featured-collection-section .product_slider").length){ 
  $(".featured-collection-section .product_slider").each(function( index ){
    var el = $(this);
    el.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      prevArrow: el.parent().find(".arrow-prev"),
      nextArrow: el.parent().find(".arrow-next"),
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3
          }
        },
        {
        breakpoint: 767,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  });
}
if($(".blog-products .best-seller-items").length){ 
  $(".blog-products .best-seller-items").each(function( index ){
    var el = $(this);
    el.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      prevArrow: el.parent().find(".arrow-prev"),
      nextArrow: el.parent().find(".arrow-next"),
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3
          }
        },
        {
        breakpoint: 767,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  });
}

if($(".reward-page-section-3 .point-products .products-slide").length){ 
  $(".reward-page-section-3 .point-products .products-slide").each(function( index ){
    var el = $(this);
    el.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      prevArrow: el.parent().find(".arrow-prev"),
      nextArrow: el.parent().find(".arrow-next"),
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2
          }
        },
        {
        breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  });
}

if($(".slide_img_with_text .slider_content").length){ 
  $(".slide_img_with_text .slider_content").each(function( index ){
    var ele = $(this);
    ele.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  });
}

$(document).on('click', '.mobile_list_menu .custom_mobile_tab', function(e){
  e.preventDefault();
  if($(this).parent('li').hasClass('is_tab_open')){
    $(this).parent('li').removeClass('is_tab_open');
    $(this).parent('li').find('.mobile_mega_menu').slideUp();
    if($('.mobile_list_menu .mobile_mega_menu .child_mobile_tab').length){
      $('.mobile_list_menu .mobile_mega_menu .mob_menu_content').removeClass('is_child_tab_open');
      $('.mobile_list_menu .mobile_mega_menu .mob_menu_content ul').slideUp();
    }
  }else{
    $(this).parent('li').addClass('is_tab_open');
    $(this).parent('li').find('.mobile_mega_menu').slideDown();
  }
});

$(document).on('click', '.mobile_list_menu .mobile_mega_menu .child_mobile_tab', function(e){
  e.preventDefault();
  if($(this).parent('.mob_menu_content').hasClass('is_child_tab_open')){
    $(this).parent('.mob_menu_content').removeClass('is_child_tab_open');
    $(this).parent('.mob_menu_content').find('ul').slideUp();
  }else{
    $(this).parent('.mob_menu_content').addClass('is_child_tab_open');
    $(this).parent('.mob_menu_content').find('ul').slideDown();
  }
});

$(document).ready(function(){
  if($(window).width() < 1025){
    var header_height = $('#shopify-section-static-header').height();
    var announce_height = $('#shopify-section-announcement-slider').height();
    var total_height = header_height + announce_height;
    $('#site-mobilenav .mobilenav-panel').css('top', total_height + 'px');
  }
    if($(window).width() < 1025){
    var header_height = $('#shopify-section-static-header').height();
    var announce_height = $('#shopify-section-announcement-slider').height();
    var total_height = header_height + announce_height;
    var remaining_height = $(window).height() - total_height;

    $('#site-mobilenav .mobilenav-panel-content').css('height', remaining_height + 'px');
  }
});